module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 232);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return h; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return h; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneElement", function() { return cloneElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rerender", function() { return rerender; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "options", function() { return options; });
/** Virtual DOM Node */
function VNode() {}

/** Global options
 *	@public
 *	@namespace options {Object}
 */
var options = {

	/** If `true`, `prop` changes trigger synchronous component updates.
  *	@name syncComponentUpdates
  *	@type Boolean
  *	@default true
  */
	//syncComponentUpdates: true,

	/** Processes all created VNodes.
  *	@param {VNode} vnode	A newly-created VNode to normalize/process
  */
	//vnode(vnode) { }

	/** Hook invoked after a component is mounted. */
	// afterMount(component) { }

	/** Hook invoked after the DOM is updated with a component's latest render. */
	// afterUpdate(component) { }

	/** Hook invoked immediately before a component is unmounted. */
	// beforeUnmount(component) { }
};

var stack = [];

var EMPTY_CHILDREN = [];

/** JSX/hyperscript reviver
*	Benchmarks: https://esbench.com/bench/57ee8f8e330ab09900a1a1a0
 *	@see http://jasonformat.com/wtf-is-jsx
 *	@public
 */
function h(nodeName, attributes) {
	var children = EMPTY_CHILDREN,
	    lastSimple,
	    child,
	    simple,
	    i;
	for (i = arguments.length; i-- > 2;) {
		stack.push(arguments[i]);
	}
	if (attributes && attributes.children != null) {
		if (!stack.length) stack.push(attributes.children);
		delete attributes.children;
	}
	while (stack.length) {
		if ((child = stack.pop()) && child.pop !== undefined) {
			for (i = child.length; i--;) {
				stack.push(child[i]);
			}
		} else {
			if (typeof child === 'boolean') child = null;

			if (simple = typeof nodeName !== 'function') {
				if (child == null) child = '';else if (typeof child === 'number') child = String(child);else if (typeof child !== 'string') simple = false;
			}

			if (simple && lastSimple) {
				children[children.length - 1] += child;
			} else if (children === EMPTY_CHILDREN) {
				children = [child];
			} else {
				children.push(child);
			}

			lastSimple = simple;
		}
	}

	var p = new VNode();
	p.nodeName = nodeName;
	p.children = children;
	p.attributes = attributes == null ? undefined : attributes;
	p.key = attributes == null ? undefined : attributes.key;

	// if a "vnode hook" is defined, pass every created VNode to it
	if (options.vnode !== undefined) options.vnode(p);

	return p;
}

/** Copy own-properties from `props` onto `obj`.
 *	@returns obj
 *	@private
 */
function extend(obj, props) {
  for (var i in props) {
    obj[i] = props[i];
  }return obj;
}

/** Call a function asynchronously, as soon as possible.
 *	@param {Function} callback
 */
var defer = typeof Promise == 'function' ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout;

function cloneElement(vnode, props) {
	return h(vnode.nodeName, extend(extend({}, vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
}

// DOM properties that should NOT have "px" added when numeric
var IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;

/** Managed queue of dirty components to be re-rendered */

var items = [];

function enqueueRender(component) {
	if (!component._dirty && (component._dirty = true) && items.push(component) == 1) {
		(options.debounceRendering || defer)(rerender);
	}
}

function rerender() {
	var p,
	    list = items;
	items = [];
	while (p = list.pop()) {
		if (p._dirty) renderComponent(p);
	}
}

/** Check if two nodes are equivalent.
 *	@param {Element} node
 *	@param {VNode} vnode
 *	@private
 */
function isSameNodeType(node, vnode, hydrating) {
	if (typeof vnode === 'string' || typeof vnode === 'number') {
		return node.splitText !== undefined;
	}
	if (typeof vnode.nodeName === 'string') {
		return !node._componentConstructor && isNamedNode(node, vnode.nodeName);
	}
	return hydrating || node._componentConstructor === vnode.nodeName;
}

/** Check if an Element has a given normalized name.
*	@param {Element} node
*	@param {String} nodeName
 */
function isNamedNode(node, nodeName) {
	return node.normalizedNodeName === nodeName || node.nodeName.toLowerCase() === nodeName.toLowerCase();
}

/**
 * Reconstruct Component-style `props` from a VNode.
 * Ensures default/fallback values from `defaultProps`:
 * Own-properties of `defaultProps` not present in `vnode.attributes` are added.
 * @param {VNode} vnode
 * @returns {Object} props
 */
function getNodeProps(vnode) {
	var props = extend({}, vnode.attributes);
	props.children = vnode.children;

	var defaultProps = vnode.nodeName.defaultProps;
	if (defaultProps !== undefined) {
		for (var i in defaultProps) {
			if (props[i] === undefined) {
				props[i] = defaultProps[i];
			}
		}
	}

	return props;
}

/** Create an element with the given nodeName.
 *	@param {String} nodeName
 *	@param {Boolean} [isSvg=false]	If `true`, creates an element within the SVG namespace.
 *	@returns {Element} node
 */
function createNode(nodeName, isSvg) {
	var node = isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName);
	node.normalizedNodeName = nodeName;
	return node;
}

/** Remove a child node from its parent if attached.
 *	@param {Element} node		The node to remove
 */
function removeNode(node) {
	var parentNode = node.parentNode;
	if (parentNode) parentNode.removeChild(node);
}

/** Set a named attribute on the given Node, with special behavior for some names and event handlers.
 *	If `value` is `null`, the attribute/handler will be removed.
 *	@param {Element} node	An element to mutate
 *	@param {string} name	The name/key to set, such as an event or attribute name
 *	@param {any} old	The last value that was set for this name/node pair
 *	@param {any} value	An attribute value, such as a function to be used as an event handler
 *	@param {Boolean} isSvg	Are we currently diffing inside an svg?
 *	@private
 */
function setAccessor(node, name, old, value, isSvg) {
	if (name === 'className') name = 'class';

	if (name === 'key') {
		// ignore
	} else if (name === 'ref') {
		if (old) old(null);
		if (value) value(node);
	} else if (name === 'class' && !isSvg) {
		node.className = value || '';
	} else if (name === 'style') {
		if (!value || typeof value === 'string' || typeof old === 'string') {
			node.style.cssText = value || '';
		}
		if (value && typeof value === 'object') {
			if (typeof old !== 'string') {
				for (var i in old) {
					if (!(i in value)) node.style[i] = '';
				}
			}
			for (var i in value) {
				node.style[i] = typeof value[i] === 'number' && IS_NON_DIMENSIONAL.test(i) === false ? value[i] + 'px' : value[i];
			}
		}
	} else if (name === 'dangerouslySetInnerHTML') {
		if (value) node.innerHTML = value.__html || '';
	} else if (name[0] == 'o' && name[1] == 'n') {
		var useCapture = name !== (name = name.replace(/Capture$/, ''));
		name = name.toLowerCase().substring(2);
		if (value) {
			if (!old) node.addEventListener(name, eventProxy, useCapture);
		} else {
			node.removeEventListener(name, eventProxy, useCapture);
		}
		(node._listeners || (node._listeners = {}))[name] = value;
	} else if (name !== 'list' && name !== 'type' && !isSvg && name in node) {
		setProperty(node, name, value == null ? '' : value);
		if (value == null || value === false) node.removeAttribute(name);
	} else {
		var ns = isSvg && name !== (name = name.replace(/^xlink\:?/, ''));
		if (value == null || value === false) {
			if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase());else node.removeAttribute(name);
		} else if (typeof value !== 'function') {
			if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase(), value);else node.setAttribute(name, value);
		}
	}
}

/** Attempt to set a DOM property to the given value.
 *	IE & FF throw for certain property-value combinations.
 */
function setProperty(node, name, value) {
	try {
		node[name] = value;
	} catch (e) {}
}

/** Proxy an event to hooked event handlers
 *	@private
 */
function eventProxy(e) {
	return this._listeners[e.type](options.event && options.event(e) || e);
}

/** Queue of components that have been mounted and are awaiting componentDidMount */
var mounts = [];

/** Diff recursion count, used to track the end of the diff cycle. */
var diffLevel = 0;

/** Global flag indicating if the diff is currently within an SVG */
var isSvgMode = false;

/** Global flag indicating if the diff is performing hydration */
var hydrating = false;

/** Invoke queued componentDidMount lifecycle methods */
function flushMounts() {
	var c;
	while (c = mounts.pop()) {
		if (options.afterMount) options.afterMount(c);
		if (c.componentDidMount) c.componentDidMount();
	}
}

/** Apply differences in a given vnode (and it's deep children) to a real DOM Node.
 *	@param {Element} [dom=null]		A DOM node to mutate into the shape of the `vnode`
 *	@param {VNode} vnode			A VNode (with descendants forming a tree) representing the desired DOM structure
 *	@returns {Element} dom			The created/mutated element
 *	@private
 */
function diff(dom, vnode, context, mountAll, parent, componentRoot) {
	// diffLevel having been 0 here indicates initial entry into the diff (not a subdiff)
	if (!diffLevel++) {
		// when first starting the diff, check if we're diffing an SVG or within an SVG
		isSvgMode = parent != null && parent.ownerSVGElement !== undefined;

		// hydration is indicated by the existing element to be diffed not having a prop cache
		hydrating = dom != null && !('__preactattr_' in dom);
	}

	var ret = idiff(dom, vnode, context, mountAll, componentRoot);

	// append the element if its a new parent
	if (parent && ret.parentNode !== parent) parent.appendChild(ret);

	// diffLevel being reduced to 0 means we're exiting the diff
	if (! --diffLevel) {
		hydrating = false;
		// invoke queued componentDidMount lifecycle methods
		if (!componentRoot) flushMounts();
	}

	return ret;
}

/** Internals of `diff()`, separated to allow bypassing diffLevel / mount flushing. */
function idiff(dom, vnode, context, mountAll, componentRoot) {
	var out = dom,
	    prevSvgMode = isSvgMode;

	// empty values (null, undefined, booleans) render as empty Text nodes
	if (vnode == null || typeof vnode === 'boolean') vnode = '';

	// Fast case: Strings & Numbers create/update Text nodes.
	if (typeof vnode === 'string' || typeof vnode === 'number') {

		// update if it's already a Text node:
		if (dom && dom.splitText !== undefined && dom.parentNode && (!dom._component || componentRoot)) {
			/* istanbul ignore if */ /* Browser quirk that can't be covered: https://github.com/developit/preact/commit/fd4f21f5c45dfd75151bd27b4c217d8003aa5eb9 */
			if (dom.nodeValue != vnode) {
				dom.nodeValue = vnode;
			}
		} else {
			// it wasn't a Text node: replace it with one and recycle the old Element
			out = document.createTextNode(vnode);
			if (dom) {
				if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
				recollectNodeTree(dom, true);
			}
		}

		out['__preactattr_'] = true;

		return out;
	}

	// If the VNode represents a Component, perform a component diff:
	var vnodeName = vnode.nodeName;
	if (typeof vnodeName === 'function') {
		return buildComponentFromVNode(dom, vnode, context, mountAll);
	}

	// Tracks entering and exiting SVG namespace when descending through the tree.
	isSvgMode = vnodeName === 'svg' ? true : vnodeName === 'foreignObject' ? false : isSvgMode;

	// If there's no existing element or it's the wrong type, create a new one:
	vnodeName = String(vnodeName);
	if (!dom || !isNamedNode(dom, vnodeName)) {
		out = createNode(vnodeName, isSvgMode);

		if (dom) {
			// move children into the replacement node
			while (dom.firstChild) {
				out.appendChild(dom.firstChild);
			} // if the previous Element was mounted into the DOM, replace it inline
			if (dom.parentNode) dom.parentNode.replaceChild(out, dom);

			// recycle the old element (skips non-Element node types)
			recollectNodeTree(dom, true);
		}
	}

	var fc = out.firstChild,
	    props = out['__preactattr_'],
	    vchildren = vnode.children;

	if (props == null) {
		props = out['__preactattr_'] = {};
		for (var a = out.attributes, i = a.length; i--;) {
			props[a[i].name] = a[i].value;
		}
	}

	// Optimization: fast-path for elements containing a single TextNode:
	if (!hydrating && vchildren && vchildren.length === 1 && typeof vchildren[0] === 'string' && fc != null && fc.splitText !== undefined && fc.nextSibling == null) {
		if (fc.nodeValue != vchildren[0]) {
			fc.nodeValue = vchildren[0];
		}
	}
	// otherwise, if there are existing or new children, diff them:
	else if (vchildren && vchildren.length || fc != null) {
			innerDiffNode(out, vchildren, context, mountAll, hydrating || props.dangerouslySetInnerHTML != null);
		}

	// Apply attributes/props from VNode to the DOM Element:
	diffAttributes(out, vnode.attributes, props);

	// restore previous SVG mode: (in case we're exiting an SVG namespace)
	isSvgMode = prevSvgMode;

	return out;
}

/** Apply child and attribute changes between a VNode and a DOM Node to the DOM.
 *	@param {Element} dom			Element whose children should be compared & mutated
 *	@param {Array} vchildren		Array of VNodes to compare to `dom.childNodes`
 *	@param {Object} context			Implicitly descendant context object (from most recent `getChildContext()`)
 *	@param {Boolean} mountAll
 *	@param {Boolean} isHydrating	If `true`, consumes externally created elements similar to hydration
 */
function innerDiffNode(dom, vchildren, context, mountAll, isHydrating) {
	var originalChildren = dom.childNodes,
	    children = [],
	    keyed = {},
	    keyedLen = 0,
	    min = 0,
	    len = originalChildren.length,
	    childrenLen = 0,
	    vlen = vchildren ? vchildren.length : 0,
	    j,
	    c,
	    f,
	    vchild,
	    child;

	// Build up a map of keyed children and an Array of unkeyed children:
	if (len !== 0) {
		for (var i = 0; i < len; i++) {
			var _child = originalChildren[i],
			    props = _child['__preactattr_'],
			    key = vlen && props ? _child._component ? _child._component.__key : props.key : null;
			if (key != null) {
				keyedLen++;
				keyed[key] = _child;
			} else if (props || (_child.splitText !== undefined ? isHydrating ? _child.nodeValue.trim() : true : isHydrating)) {
				children[childrenLen++] = _child;
			}
		}
	}

	if (vlen !== 0) {
		for (var i = 0; i < vlen; i++) {
			vchild = vchildren[i];
			child = null;

			// attempt to find a node based on key matching
			var key = vchild.key;
			if (key != null) {
				if (keyedLen && keyed[key] !== undefined) {
					child = keyed[key];
					keyed[key] = undefined;
					keyedLen--;
				}
			}
			// attempt to pluck a node of the same type from the existing children
			else if (!child && min < childrenLen) {
					for (j = min; j < childrenLen; j++) {
						if (children[j] !== undefined && isSameNodeType(c = children[j], vchild, isHydrating)) {
							child = c;
							children[j] = undefined;
							if (j === childrenLen - 1) childrenLen--;
							if (j === min) min++;
							break;
						}
					}
				}

			// morph the matched/found/created DOM child to match vchild (deep)
			child = idiff(child, vchild, context, mountAll);

			f = originalChildren[i];
			if (child && child !== dom && child !== f) {
				if (f == null) {
					dom.appendChild(child);
				} else if (child === f.nextSibling) {
					removeNode(f);
				} else {
					dom.insertBefore(child, f);
				}
			}
		}
	}

	// remove unused keyed children:
	if (keyedLen) {
		for (var i in keyed) {
			if (keyed[i] !== undefined) recollectNodeTree(keyed[i], false);
		}
	}

	// remove orphaned unkeyed children:
	while (min <= childrenLen) {
		if ((child = children[childrenLen--]) !== undefined) recollectNodeTree(child, false);
	}
}

/** Recursively recycle (or just unmount) a node and its descendants.
 *	@param {Node} node						DOM node to start unmount/removal from
 *	@param {Boolean} [unmountOnly=false]	If `true`, only triggers unmount lifecycle, skips removal
 */
function recollectNodeTree(node, unmountOnly) {
	var component = node._component;
	if (component) {
		// if node is owned by a Component, unmount that component (ends up recursing back here)
		unmountComponent(component);
	} else {
		// If the node's VNode had a ref function, invoke it with null here.
		// (this is part of the React spec, and smart for unsetting references)
		if (node['__preactattr_'] != null && node['__preactattr_'].ref) node['__preactattr_'].ref(null);

		if (unmountOnly === false || node['__preactattr_'] == null) {
			removeNode(node);
		}

		removeChildren(node);
	}
}

/** Recollect/unmount all children.
 *	- we use .lastChild here because it causes less reflow than .firstChild
 *	- it's also cheaper than accessing the .childNodes Live NodeList
 */
function removeChildren(node) {
	node = node.lastChild;
	while (node) {
		var next = node.previousSibling;
		recollectNodeTree(node, true);
		node = next;
	}
}

/** Apply differences in attributes from a VNode to the given DOM Element.
 *	@param {Element} dom		Element with attributes to diff `attrs` against
 *	@param {Object} attrs		The desired end-state key-value attribute pairs
 *	@param {Object} old			Current/previous attributes (from previous VNode or element's prop cache)
 */
function diffAttributes(dom, attrs, old) {
	var name;

	// remove attributes no longer present on the vnode by setting them to undefined
	for (name in old) {
		if (!(attrs && attrs[name] != null) && old[name] != null) {
			setAccessor(dom, name, old[name], old[name] = undefined, isSvgMode);
		}
	}

	// add new & update changed attributes
	for (name in attrs) {
		if (name !== 'children' && name !== 'innerHTML' && (!(name in old) || attrs[name] !== (name === 'value' || name === 'checked' ? dom[name] : old[name]))) {
			setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
		}
	}
}

/** Retains a pool of Components for re-use, keyed on component name.
 *	Note: since component names are not unique or even necessarily available, these are primarily a form of sharding.
 *	@private
 */
var components = {};

/** Reclaim a component for later re-use by the recycler. */
function collectComponent(component) {
	var name = component.constructor.name;
	(components[name] || (components[name] = [])).push(component);
}

/** Create a component. Normalizes differences between PFC's and classful Components. */
function createComponent(Ctor, props, context) {
	var list = components[Ctor.name],
	    inst;

	if (Ctor.prototype && Ctor.prototype.render) {
		inst = new Ctor(props, context);
		Component.call(inst, props, context);
	} else {
		inst = new Component(props, context);
		inst.constructor = Ctor;
		inst.render = doRender;
	}

	if (list) {
		for (var i = list.length; i--;) {
			if (list[i].constructor === Ctor) {
				inst.nextBase = list[i].nextBase;
				list.splice(i, 1);
				break;
			}
		}
	}
	return inst;
}

/** The `.render()` method for a PFC backing instance. */
function doRender(props, state, context) {
	return this.constructor(props, context);
}

/** Set a component's `props` (generally derived from JSX attributes).
 *	@param {Object} props
 *	@param {Object} [opts]
 *	@param {boolean} [opts.renderSync=false]	If `true` and {@link options.syncComponentUpdates} is `true`, triggers synchronous rendering.
 *	@param {boolean} [opts.render=true]			If `false`, no render will be triggered.
 */
function setComponentProps(component, props, opts, context, mountAll) {
	if (component._disable) return;
	component._disable = true;

	if (component.__ref = props.ref) delete props.ref;
	if (component.__key = props.key) delete props.key;

	if (!component.base || mountAll) {
		if (component.componentWillMount) component.componentWillMount();
	} else if (component.componentWillReceiveProps) {
		component.componentWillReceiveProps(props, context);
	}

	if (context && context !== component.context) {
		if (!component.prevContext) component.prevContext = component.context;
		component.context = context;
	}

	if (!component.prevProps) component.prevProps = component.props;
	component.props = props;

	component._disable = false;

	if (opts !== 0) {
		if (opts === 1 || options.syncComponentUpdates !== false || !component.base) {
			renderComponent(component, 1, mountAll);
		} else {
			enqueueRender(component);
		}
	}

	if (component.__ref) component.__ref(component);
}

/** Render a Component, triggering necessary lifecycle events and taking High-Order Components into account.
 *	@param {Component} component
 *	@param {Object} [opts]
 *	@param {boolean} [opts.build=false]		If `true`, component will build and store a DOM node if not already associated with one.
 *	@private
 */
function renderComponent(component, opts, mountAll, isChild) {
	if (component._disable) return;

	var props = component.props,
	    state = component.state,
	    context = component.context,
	    previousProps = component.prevProps || props,
	    previousState = component.prevState || state,
	    previousContext = component.prevContext || context,
	    isUpdate = component.base,
	    nextBase = component.nextBase,
	    initialBase = isUpdate || nextBase,
	    initialChildComponent = component._component,
	    skip = false,
	    rendered,
	    inst,
	    cbase;

	// if updating
	if (isUpdate) {
		component.props = previousProps;
		component.state = previousState;
		component.context = previousContext;
		if (opts !== 2 && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === false) {
			skip = true;
		} else if (component.componentWillUpdate) {
			component.componentWillUpdate(props, state, context);
		}
		component.props = props;
		component.state = state;
		component.context = context;
	}

	component.prevProps = component.prevState = component.prevContext = component.nextBase = null;
	component._dirty = false;

	if (!skip) {
		rendered = component.render(props, state, context);

		// context to pass to the child, can be updated via (grand-)parent component
		if (component.getChildContext) {
			context = extend(extend({}, context), component.getChildContext());
		}

		var childComponent = rendered && rendered.nodeName,
		    toUnmount,
		    base;

		if (typeof childComponent === 'function') {
			// set up high order component link

			var childProps = getNodeProps(rendered);
			inst = initialChildComponent;

			if (inst && inst.constructor === childComponent && childProps.key == inst.__key) {
				setComponentProps(inst, childProps, 1, context, false);
			} else {
				toUnmount = inst;

				component._component = inst = createComponent(childComponent, childProps, context);
				inst.nextBase = inst.nextBase || nextBase;
				inst._parentComponent = component;
				setComponentProps(inst, childProps, 0, context, false);
				renderComponent(inst, 1, mountAll, true);
			}

			base = inst.base;
		} else {
			cbase = initialBase;

			// destroy high order component link
			toUnmount = initialChildComponent;
			if (toUnmount) {
				cbase = component._component = null;
			}

			if (initialBase || opts === 1) {
				if (cbase) cbase._component = null;
				base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, true);
			}
		}

		if (initialBase && base !== initialBase && inst !== initialChildComponent) {
			var baseParent = initialBase.parentNode;
			if (baseParent && base !== baseParent) {
				baseParent.replaceChild(base, initialBase);

				if (!toUnmount) {
					initialBase._component = null;
					recollectNodeTree(initialBase, false);
				}
			}
		}

		if (toUnmount) {
			unmountComponent(toUnmount);
		}

		component.base = base;
		if (base && !isChild) {
			var componentRef = component,
			    t = component;
			while (t = t._parentComponent) {
				(componentRef = t).base = base;
			}
			base._component = componentRef;
			base._componentConstructor = componentRef.constructor;
		}
	}

	if (!isUpdate || mountAll) {
		mounts.unshift(component);
	} else if (!skip) {
		// Ensure that pending componentDidMount() hooks of child components
		// are called before the componentDidUpdate() hook in the parent.
		// Note: disabled as it causes duplicate hooks, see https://github.com/developit/preact/issues/750
		// flushMounts();

		if (component.componentDidUpdate) {
			component.componentDidUpdate(previousProps, previousState, previousContext);
		}
		if (options.afterUpdate) options.afterUpdate(component);
	}

	if (component._renderCallbacks != null) {
		while (component._renderCallbacks.length) {
			component._renderCallbacks.pop().call(component);
		}
	}

	if (!diffLevel && !isChild) flushMounts();
}

/** Apply the Component referenced by a VNode to the DOM.
 *	@param {Element} dom	The DOM node to mutate
 *	@param {VNode} vnode	A Component-referencing VNode
 *	@returns {Element} dom	The created/mutated element
 *	@private
 */
function buildComponentFromVNode(dom, vnode, context, mountAll) {
	var c = dom && dom._component,
	    originalComponent = c,
	    oldDom = dom,
	    isDirectOwner = c && dom._componentConstructor === vnode.nodeName,
	    isOwner = isDirectOwner,
	    props = getNodeProps(vnode);
	while (c && !isOwner && (c = c._parentComponent)) {
		isOwner = c.constructor === vnode.nodeName;
	}

	if (c && isOwner && (!mountAll || c._component)) {
		setComponentProps(c, props, 3, context, mountAll);
		dom = c.base;
	} else {
		if (originalComponent && !isDirectOwner) {
			unmountComponent(originalComponent);
			dom = oldDom = null;
		}

		c = createComponent(vnode.nodeName, props, context);
		if (dom && !c.nextBase) {
			c.nextBase = dom;
			// passing dom/oldDom as nextBase will recycle it if unused, so bypass recycling on L229:
			oldDom = null;
		}
		setComponentProps(c, props, 1, context, mountAll);
		dom = c.base;

		if (oldDom && dom !== oldDom) {
			oldDom._component = null;
			recollectNodeTree(oldDom, false);
		}
	}

	return dom;
}

/** Remove a component from the DOM and recycle it.
 *	@param {Component} component	The Component instance to unmount
 *	@private
 */
function unmountComponent(component) {
	if (options.beforeUnmount) options.beforeUnmount(component);

	var base = component.base;

	component._disable = true;

	if (component.componentWillUnmount) component.componentWillUnmount();

	component.base = null;

	// recursively tear down & recollect high-order component children:
	var inner = component._component;
	if (inner) {
		unmountComponent(inner);
	} else if (base) {
		if (base['__preactattr_'] && base['__preactattr_'].ref) base['__preactattr_'].ref(null);

		component.nextBase = base;

		removeNode(base);
		collectComponent(component);

		removeChildren(base);
	}

	if (component.__ref) component.__ref(null);
}

/** Base Component class.
 *	Provides `setState()` and `forceUpdate()`, which trigger rendering.
 *	@public
 *
 *	@example
 *	class MyFoo extends Component {
 *		render(props, state) {
 *			return <div />;
 *		}
 *	}
 */
function Component(props, context) {
	this._dirty = true;

	/** @public
  *	@type {object}
  */
	this.context = context;

	/** @public
  *	@type {object}
  */
	this.props = props;

	/** @public
  *	@type {object}
  */
	this.state = this.state || {};
}

extend(Component.prototype, {

	/** Returns a `boolean` indicating if the component should re-render when receiving the given `props` and `state`.
  *	@param {object} nextProps
  *	@param {object} nextState
  *	@param {object} nextContext
  *	@returns {Boolean} should the component re-render
  *	@name shouldComponentUpdate
  *	@function
  */

	/** Update component state by copying properties from `state` to `this.state`.
  *	@param {object} state		A hash of state properties to update with new values
  *	@param {function} callback	A function to be called once component state is updated
  */
	setState: function setState(state, callback) {
		var s = this.state;
		if (!this.prevState) this.prevState = extend({}, s);
		extend(s, typeof state === 'function' ? state(s, this.props) : state);
		if (callback) (this._renderCallbacks = this._renderCallbacks || []).push(callback);
		enqueueRender(this);
	},


	/** Immediately perform a synchronous re-render of the component.
  *	@param {function} callback		A function to be called after component is re-rendered.
  *	@private
  */
	forceUpdate: function forceUpdate(callback) {
		if (callback) (this._renderCallbacks = this._renderCallbacks || []).push(callback);
		renderComponent(this, 2);
	},


	/** Accepts `props` and `state`, and returns a new Virtual DOM tree to build.
  *	Virtual DOM is generally constructed via [JSX](http://jasonformat.com/wtf-is-jsx).
  *	@param {object} props		Props (eg: JSX attributes) received from parent element/component
  *	@param {object} state		The component's current state
  *	@param {object} context		Context object (if a parent component has provided context)
  *	@returns VNode
  */
	render: function render() {}
});

/** Render JSX into a `parent` Element.
 *	@param {VNode} vnode		A (JSX) VNode to render
 *	@param {Element} parent		DOM element to render into
 *	@param {Element} [merge]	Attempt to re-use an existing DOM tree rooted at `merge`
 *	@public
 *
 *	@example
 *	// render a div into <body>:
 *	render(<div id="hello">hello!</div>, document.body);
 *
 *	@example
 *	// render a "Thing" component into #foo:
 *	const Thing = ({ name }) => <span>{ name }</span>;
 *	render(<Thing name="one" />, document.querySelector('#foo'));
 */
function render(vnode, parent, merge) {
  return diff(merge, vnode, {}, false, parent, false);
}

var preact = {
	h: h,
	createElement: h,
	cloneElement: cloneElement,
	Component: Component,
	render: render,
	rerender: rerender,
	options: options
};


/* harmony default export */ __webpack_exports__["default"] = (preact);
//# sourceMappingURL=preact.esm.js.map


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(253), __esModule: true };

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(255), __esModule: true };

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOM", function() { return DOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Children", function() { return Children; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createClass", function() { return createClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFactory", function() { return createFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return createElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneElement", function() { return cloneElement$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isValidElement", function() { return isValidElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findDOMNode", function() { return findDOMNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unmountComponentAtNode", function() { return unmountComponentAtNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PureComponent", function() { return PureComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_renderSubtreeIntoContainer", function() { return renderSubtreeIntoContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__(0);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PropTypes", function() { return __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a; });



var version = '15.1.0'; // trick libraries to think we are react

var ELEMENTS = 'a abbr address area article aside audio b base bdi bdo big blockquote body br button canvas caption cite code col colgroup data datalist dd del details dfn dialog div dl dt em embed fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe img input ins kbd keygen label legend li link main map mark menu menuitem meta meter nav noscript object ol optgroup option output p param picture pre progress q rp rt ruby s samp script section select small source span strong style sub summary sup table tbody td textarea tfoot th thead time title tr track u ul var video wbr circle clipPath defs ellipse g image line linearGradient mask path pattern polygon polyline radialGradient rect stop svg text tspan'.split(' ');

var REACT_ELEMENT_TYPE = (typeof Symbol!=='undefined' && Symbol.for && Symbol.for('react.element')) || 0xeac7;

var COMPONENT_WRAPPER_KEY = typeof Symbol!=='undefined' ? Symbol.for('__preactCompatWrapper') : '__preactCompatWrapper';

// don't autobind these methods since they already have guaranteed context.
var AUTOBIND_BLACKLIST = {
	constructor: 1,
	render: 1,
	shouldComponentUpdate: 1,
	componentWillReceiveProps: 1,
	componentWillUpdate: 1,
	componentDidUpdate: 1,
	componentWillMount: 1,
	componentDidMount: 1,
	componentWillUnmount: 1,
	componentDidUnmount: 1
};


var CAMEL_PROPS = /^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vert|word|writing|x)[A-Z]/;


var BYPASS_HOOK = {};

/*global process*/
var DEV = typeof process==='undefined' || !process.env || "production"!=='production';

// a component that renders nothing. Used to replace components for unmountComponentAtNode.
function EmptyComponent() { return null; }



// make react think we're react.
var VNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])('a', null).constructor;
VNode.prototype.$$typeof = REACT_ELEMENT_TYPE;
VNode.prototype.preactCompatUpgraded = false;
VNode.prototype.preactCompatNormalized = false;

Object.defineProperty(VNode.prototype, 'type', {
	get: function() { return this.nodeName; },
	set: function(v) { this.nodeName = v; },
	configurable:true
});

Object.defineProperty(VNode.prototype, 'props', {
	get: function() { return this.attributes; },
	set: function(v) { this.attributes = v; },
	configurable:true
});



var oldEventHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].event;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].event = function (e) {
	if (oldEventHook) { e = oldEventHook(e); }
	e.persist = Object;
	e.nativeEvent = e;
	return e;
};


var oldVnodeHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode = function (vnode) {
	if (!vnode.preactCompatUpgraded) {
		vnode.preactCompatUpgraded = true;

		var tag = vnode.nodeName,
			attrs = vnode.attributes = extend({}, vnode.attributes);

		if (typeof tag==='function') {
			if (tag[COMPONENT_WRAPPER_KEY]===true || (tag.prototype && 'isReactComponent' in tag.prototype)) {
				if (vnode.children && String(vnode.children)==='') { vnode.children = undefined; }
				if (vnode.children) { attrs.children = vnode.children; }

				if (!vnode.preactCompatNormalized) {
					normalizeVNode(vnode);
				}
				handleComponentVNode(vnode);
			}
		}
		else {
			if (vnode.children && String(vnode.children)==='') { vnode.children = undefined; }
			if (vnode.children) { attrs.children = vnode.children; }

			if (attrs.defaultValue) {
				if (!attrs.value && attrs.value!==0) {
					attrs.value = attrs.defaultValue;
				}
				delete attrs.defaultValue;
			}

			handleElementVNode(vnode, attrs);
		}
	}

	if (oldVnodeHook) { oldVnodeHook(vnode); }
};

function handleComponentVNode(vnode) {
	var tag = vnode.nodeName,
		a = vnode.attributes;

	vnode.attributes = {};
	if (tag.defaultProps) { extend(vnode.attributes, tag.defaultProps); }
	if (a) { extend(vnode.attributes, a); }
}

function handleElementVNode(vnode, a) {
	var shouldSanitize, attrs, i;
	if (a) {
		for (i in a) { if ((shouldSanitize = CAMEL_PROPS.test(i))) { break; } }
		if (shouldSanitize) {
			attrs = vnode.attributes = {};
			for (i in a) {
				if (a.hasOwnProperty(i)) {
					attrs[ CAMEL_PROPS.test(i) ? i.replace(/([A-Z0-9])/, '-$1').toLowerCase() : i ] = a[i];
				}
			}
		}
	}
}



// proxy render() since React returns a Component reference.
function render$1(vnode, parent, callback) {
	var prev = parent && parent._preactCompatRendered && parent._preactCompatRendered.base;

	// ignore impossible previous renders
	if (prev && prev.parentNode!==parent) { prev = null; }

	// default to first Element child
	if (!prev) { prev = parent.children[0]; }

	// remove unaffected siblings
	for (var i=parent.childNodes.length; i--; ) {
		if (parent.childNodes[i]!==prev) {
			parent.removeChild(parent.childNodes[i]);
		}
	}

	var out = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(vnode, parent, prev);
	if (parent) { parent._preactCompatRendered = out && (out._component || { base: out }); }
	if (typeof callback==='function') { callback(); }
	return out && out._component || out;
}


var ContextProvider = function () {};

ContextProvider.prototype.getChildContext = function () {
	return this.props.context;
};
ContextProvider.prototype.render = function (props) {
	return props.children[0];
};

function renderSubtreeIntoContainer(parentComponent, vnode, container, callback) {
	var wrap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(ContextProvider, { context: parentComponent.context }, vnode);
	var c = render$1(wrap, container);
	if (callback) { callback(c); }
	return c._component || c.base;
}


function unmountComponentAtNode(container) {
	var existing = container._preactCompatRendered && container._preactCompatRendered.base;
	if (existing && existing.parentNode===container) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(EmptyComponent), container, existing);
		return true;
	}
	return false;
}



var ARR = [];

// This API is completely unnecessary for Preact, so it's basically passthrough.
var Children = {
	map: function(children, fn, ctx) {
		if (children == null) { return null; }
		children = Children.toArray(children);
		if (ctx && ctx!==children) { fn = fn.bind(ctx); }
		return children.map(fn);
	},
	forEach: function(children, fn, ctx) {
		if (children == null) { return null; }
		children = Children.toArray(children);
		if (ctx && ctx!==children) { fn = fn.bind(ctx); }
		children.forEach(fn);
	},
	count: function(children) {
		return children && children.length || 0;
	},
	only: function(children) {
		children = Children.toArray(children);
		if (children.length!==1) { throw new Error('Children.only() expects only one child.'); }
		return children[0];
	},
	toArray: function(children) {
		if (children == null) { return []; }
		return Array.isArray && Array.isArray(children) ? children : ARR.concat(children);
	}
};


/** Track current render() component for ref assignment */
var currentComponent;


function createFactory(type) {
	return createElement.bind(null, type);
}


var DOM = {};
for (var i=ELEMENTS.length; i--; ) {
	DOM[ELEMENTS[i]] = createFactory(ELEMENTS[i]);
}

function upgradeToVNodes(arr, offset) {
	for (var i=offset || 0; i<arr.length; i++) {
		var obj = arr[i];
		if (Array.isArray(obj)) {
			upgradeToVNodes(obj);
		}
		else if (obj && typeof obj==='object' && !isValidElement(obj) && ((obj.props && obj.type) || (obj.attributes && obj.nodeName) || obj.children)) {
			arr[i] = createElement(obj.type || obj.nodeName, obj.props || obj.attributes, obj.children);
		}
	}
}

function isStatelessComponent(c) {
	return typeof c==='function' && !(c.prototype && c.prototype.render);
}


// wraps stateless functional components in a PropTypes validator
function wrapStatelessComponent(WrappedComponent) {
	return createClass({
		displayName: WrappedComponent.displayName || WrappedComponent.name,
		render: function() {
			return WrappedComponent(this.props, this.context);
		}
	});
}


function statelessComponentHook(Ctor) {
	var Wrapped = Ctor[COMPONENT_WRAPPER_KEY];
	if (Wrapped) { return Wrapped===true ? Ctor : Wrapped; }

	Wrapped = wrapStatelessComponent(Ctor);

	Object.defineProperty(Wrapped, COMPONENT_WRAPPER_KEY, { configurable:true, value:true });
	Wrapped.displayName = Ctor.displayName;
	Wrapped.propTypes = Ctor.propTypes;
	Wrapped.defaultProps = Ctor.defaultProps;

	Object.defineProperty(Ctor, COMPONENT_WRAPPER_KEY, { configurable:true, value:Wrapped });

	return Wrapped;
}


function createElement() {
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	upgradeToVNodes(args, 2);
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["h"].apply(void 0, args));
}


function normalizeVNode(vnode) {
	vnode.preactCompatNormalized = true;

	applyClassName(vnode);

	if (isStatelessComponent(vnode.nodeName)) {
		vnode.nodeName = statelessComponentHook(vnode.nodeName);
	}

	var ref = vnode.attributes.ref,
		type = ref && typeof ref;
	if (currentComponent && (type==='string' || type==='number')) {
		vnode.attributes.ref = createStringRefProxy(ref, currentComponent);
	}

	applyEventNormalization(vnode);

	return vnode;
}


function cloneElement$1(element, props) {
	var children = [], len = arguments.length - 2;
	while ( len-- > 0 ) children[ len ] = arguments[ len + 2 ];

	if (!isValidElement(element)) { return element; }
	var elementProps = element.attributes || element.props;
	var node = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(
		element.nodeName || element.type,
		elementProps,
		element.children || elementProps && elementProps.children
	);
	// Only provide the 3rd argument if needed.
	// Arguments 3+ overwrite element.children in preactCloneElement
	var cloneArgs = [node, props];
	if (children && children.length) {
		cloneArgs.push(children);
	}
	else if (props && props.children) {
		cloneArgs.push(props.children);
	}
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["cloneElement"].apply(void 0, cloneArgs));
}


function isValidElement(element) {
	return element && ((element instanceof VNode) || element.$$typeof===REACT_ELEMENT_TYPE);
}


function createStringRefProxy(name, component) {
	return component._refProxies[name] || (component._refProxies[name] = function (resolved) {
		if (component && component.refs) {
			component.refs[name] = resolved;
			if (resolved===null) {
				delete component._refProxies[name];
				component = null;
			}
		}
	});
}


function applyEventNormalization(ref) {
	var nodeName = ref.nodeName;
	var attributes = ref.attributes;

	if (!attributes || typeof nodeName!=='string') { return; }
	var props = {};
	for (var i in attributes) {
		props[i.toLowerCase()] = i;
	}
	if (props.ondoubleclick) {
		attributes.ondblclick = attributes[props.ondoubleclick];
		delete attributes[props.ondoubleclick];
	}
	// for *textual inputs* (incl textarea), normalize `onChange` -> `onInput`:
	if (props.onchange && (nodeName==='textarea' || (nodeName.toLowerCase()==='input' && !/^fil|che|rad/i.test(attributes.type)))) {
		var normalized = props.oninput || 'oninput';
		if (!attributes[normalized]) {
			attributes[normalized] = multihook([attributes[normalized], attributes[props.onchange]]);
			delete attributes[props.onchange];
		}
	}
}


function applyClassName(ref) {
	var attributes = ref.attributes;

	if (!attributes) { return; }
	var cl = attributes.className || attributes.class;
	if (cl) { attributes.className = cl; }
}


function extend(base, props) {
	for (var key in props) {
		if (props.hasOwnProperty(key)) {
			base[key] = props[key];
		}
	}
	return base;
}


function shallowDiffers(a, b) {
	for (var i in a) { if (!(i in b)) { return true; } }
	for (var i$1 in b) { if (a[i$1]!==b[i$1]) { return true; } }
	return false;
}


function findDOMNode(component) {
	return component && component.base || component;
}


function F(){}

function createClass(obj) {
	function cl(props, context) {
		bindAll(this);
		Component$1.call(this, props, context, BYPASS_HOOK);
		newComponentHook.call(this, props, context);
	}

	obj = extend({ constructor: cl }, obj);

	// We need to apply mixins here so that getDefaultProps is correctly mixed
	if (obj.mixins) {
		applyMixins(obj, collateMixins(obj.mixins));
	}
	if (obj.statics) {
		extend(cl, obj.statics);
	}
	if (obj.propTypes) {
		cl.propTypes = obj.propTypes;
	}
	if (obj.defaultProps) {
		cl.defaultProps = obj.defaultProps;
	}
	if (obj.getDefaultProps) {
		cl.defaultProps = obj.getDefaultProps();
	}

	F.prototype = Component$1.prototype;
	cl.prototype = extend(new F(), obj);

	cl.displayName = obj.displayName || 'Component';

	return cl;
}


// Flatten an Array of mixins to a map of method name to mixin implementations
function collateMixins(mixins) {
	var keyed = {};
	for (var i=0; i<mixins.length; i++) {
		var mixin = mixins[i];
		for (var key in mixin) {
			if (mixin.hasOwnProperty(key) && typeof mixin[key]==='function') {
				(keyed[key] || (keyed[key]=[])).push(mixin[key]);
			}
		}
	}
	return keyed;
}


// apply a mapping of Arrays of mixin methods to a component prototype
function applyMixins(proto, mixins) {
	for (var key in mixins) { if (mixins.hasOwnProperty(key)) {
		proto[key] = multihook(
			mixins[key].concat(proto[key] || ARR),
			key==='getDefaultProps' || key==='getInitialState' || key==='getChildContext'
		);
	} }
}


function bindAll(ctx) {
	for (var i in ctx) {
		var v = ctx[i];
		if (typeof v==='function' && !v.__bound && !AUTOBIND_BLACKLIST.hasOwnProperty(i)) {
			(ctx[i] = v.bind(ctx)).__bound = true;
		}
	}
}


function callMethod(ctx, m, args) {
	if (typeof m==='string') {
		m = ctx.constructor.prototype[m];
	}
	if (typeof m==='function') {
		return m.apply(ctx, args);
	}
}

function multihook(hooks, skipDuplicates) {
	return function() {
		var arguments$1 = arguments;
		var this$1 = this;

		var ret;
		for (var i=0; i<hooks.length; i++) {
			var r = callMethod(this$1, hooks[i], arguments$1);

			if (skipDuplicates && r!=null) {
				if (!ret) { ret = {}; }
				for (var key in r) { if (r.hasOwnProperty(key)) {
					ret[key] = r[key];
				} }
			}
			else if (typeof r!=='undefined') { ret = r; }
		}
		return ret;
	};
}


function newComponentHook(props, context) {
	propsHook.call(this, props, context);
	this.componentWillReceiveProps = multihook([propsHook, this.componentWillReceiveProps || 'componentWillReceiveProps']);
	this.render = multihook([propsHook, beforeRender, this.render || 'render', afterRender]);
}


function propsHook(props, context) {
	if (!props) { return; }

	// React annoyingly special-cases single children, and some react components are ridiculously strict about this.
	var c = props.children;
	if (c && Array.isArray(c) && c.length===1) {
		props.children = c[0];

		// but its totally still going to be an Array.
		if (props.children && typeof props.children==='object') {
			props.children.length = 1;
			props.children[0] = props.children;
		}
	}

	// add proptype checking
	if (DEV) {
		var ctor = typeof this==='function' ? this : this.constructor,
			propTypes = this.propTypes || ctor.propTypes;
		var displayName = this.displayName || ctor.name;

		if (propTypes) {
			__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.checkPropTypes(propTypes, props, 'prop', displayName);
		}
	}
}


function beforeRender(props) {
	currentComponent = this;
}

function afterRender() {
	if (currentComponent===this) {
		currentComponent = null;
	}
}



function Component$1(props, context, opts) {
	__WEBPACK_IMPORTED_MODULE_1_preact__["Component"].call(this, props, context);
	this.state = this.getInitialState ? this.getInitialState() : {};
	this.refs = {};
	this._refProxies = {};
	if (opts!==BYPASS_HOOK) {
		newComponentHook.call(this, props, context);
	}
}
extend(Component$1.prototype = new __WEBPACK_IMPORTED_MODULE_1_preact__["Component"](), {
	constructor: Component$1,

	isReactComponent: {},

	replaceState: function(state, callback) {
		var this$1 = this;

		this.setState(state, callback);
		for (var i in this$1.state) {
			if (!(i in state)) {
				delete this$1.state[i];
			}
		}
	},

	getDOMNode: function() {
		return this.base;
	},

	isMounted: function() {
		return !!this.base;
	}
});



function PureComponent(props, context) {
	Component$1.call(this, props, context);
}
F.prototype = Component$1.prototype;
PureComponent.prototype = new F();
PureComponent.prototype.isPureReactComponent = true;
PureComponent.prototype.shouldComponentUpdate = function(props, state) {
	return shallowDiffers(this.props, props) || shallowDiffers(this.state, state);
};



var index = {
	version: version,
	DOM: DOM,
	PropTypes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a,
	Children: Children,
	render: render$1,
	createClass: createClass,
	createFactory: createFactory,
	createElement: createElement,
	cloneElement: cloneElement$1,
	isValidElement: isValidElement,
	findDOMNode: findDOMNode,
	unmountComponentAtNode: unmountComponentAtNode,
	Component: Component$1,
	PureComponent: PureComponent,
	unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
};

/* harmony default export */ __webpack_exports__["default"] = (index);
//# sourceMappingURL=preact-compat.es.js.map


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(252), __esModule: true };

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(257), __esModule: true };

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(116), __webpack_require__(23), __webpack_require__(27), __webpack_require__(398), __webpack_require__(0), __webpack_require__(348)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/core-js/is-iterable'), require('babel-runtime/core-js/get-iterator'), require('babel-runtime/core-js/array/from'), require('parse-unit'), require('preact'), require('enumerate-devices'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.isIterable, global.getIterator, global.from, global.parseUnit, global.preact, global.enumerateDevices);
    global.index = mod.exports;
  }
})(this, function (exports, _isIterable2, _getIterator2, _from, _parseUnit3, _preact, _enumerateDevices) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.currentMilliseconds = exports.currentSeconds = exports.parseTags = exports.checkIfWebcamPermissionGranted = exports.checkIfHasWebcam = exports.isDesktop = exports.preventDefaultOnClick = exports.wrapWithClass = exports.getCSSMilisecsValue = exports.getCSSValue = exports.functionalSwitch = undefined;

  var _isIterable3 = _interopRequireDefault(_isIterable2);

  var _getIterator3 = _interopRequireDefault(_getIterator2);

  var _from2 = _interopRequireDefault(_from);

  var _parseUnit4 = _interopRequireDefault(_parseUnit3);

  var _enumerateDevices2 = _interopRequireDefault(_enumerateDevices);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _slicedToArray = function () {
    function sliceIterator(arr, i) {
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = undefined;

      try {
        for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);

          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }

      return _arr;
    }

    return function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if ((0, _isIterable3.default)(Object(arr))) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  }();

  var functionalSwitch = exports.functionalSwitch = function functionalSwitch(key, hash) {
    return (hash[key] || function () {
      return null;
    })();
  };

  var getCSSValue = exports.getCSSValue = function getCSSValue(expectedUnit, cssUnit) {
    var _parseUnit = (0, _parseUnit4.default)(cssUnit),
        _parseUnit2 = _slicedToArray(_parseUnit, 2),
        value = _parseUnit2[0],
        resUnit = _parseUnit2[1];

    if (resUnit !== expectedUnit) {
      console.warn('The css @value: ' + cssUnit + ' unit is ' + resUnit + ' but it should be ' + expectedUnit);
    }
    return value;
  };

  var getCSSMilisecsValue = exports.getCSSMilisecsValue = function getCSSMilisecsValue(cssUnit) {
    return getCSSValue("ms", cssUnit);
  };

  var wrapWithClass = exports.wrapWithClass = function wrapWithClass(className, children) {
    return (0, _preact.h)(
      'div',
      { className: className },
      children
    );
  };

  var preventDefaultOnClick = exports.preventDefaultOnClick = function preventDefaultOnClick(callback) {
    return function (event) {
      event.preventDefault();
      callback();
    };
  };

  // Copied from https://github.com/muaz-khan/DetectRTC/blob/master/DetectRTC.js
  var isDesktop = exports.isDesktop = !/Android|webOS|iPhone|iPad|iPod|BB10|BlackBerry|IEMobile|Opera Mini|Mobile|mobile/i.test(navigator.userAgent || '');

  var enumerateDevicesInternal = function enumerateDevicesInternal(onSuccess, onError) {
    try {
      (0, _enumerateDevices2.default)().then(onSuccess).catch(onError);
    } catch (exception) {
      onError(exception);
    }
  };

  var checkDevicesInfo = function checkDevicesInfo(checkFn) {
    return function (onResult) {
      return enumerateDevicesInternal(function (devices) {
        return onResult(checkFn(devices));
      }, function () {
        return onResult(false);
      });
    };
  };

  var isVideoDevice = function isVideoDevice(_ref) {
    var _ref$kind = _ref.kind,
        kind = _ref$kind === undefined ? '' : _ref$kind;
    return kind.includes('video');
  };

  var hasDevicePermission = function hasDevicePermission(_ref2) {
    var label = _ref2.label;
    return !!label;
  };

  var checkIfHasWebcam = exports.checkIfHasWebcam = checkDevicesInfo(function (devices) {
    return devices.some(isVideoDevice);
  });

  var checkIfWebcamPermissionGranted = exports.checkIfWebcamPermissionGranted = checkDevicesInfo(function (devices) {
    return devices.filter(isVideoDevice).some(hasDevicePermission);
  });

  var parseTags = exports.parseTags = function parseTags(str, handleTag) {
    var parser = new DOMParser();
    var stringToXml = parser.parseFromString('<l>' + str + '</l>', 'application/xml');
    var xmlToNodesArray = (0, _from2.default)(stringToXml.firstChild.childNodes);
    return xmlToNodesArray.map(function (node) {
      return node.nodeType === document.TEXT_NODE ? node.textContent : handleTag({ type: node.tagName, text: node.textContent });
    });
  };

  var currentSeconds = exports.currentSeconds = function currentSeconds() {
    return Math.floor(Date.now() / 1000);
  };

  var currentMilliseconds = exports.currentMilliseconds = function currentMilliseconds() {
    return new Date().getTime();
  };
});

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(3), __webpack_require__(10), __webpack_require__(27), __webpack_require__(7), __webpack_require__(6), __webpack_require__(72), __webpack_require__(71), __webpack_require__(4), __webpack_require__(57), __webpack_require__(0), __webpack_require__(405), __webpack_require__(75), __webpack_require__(397), __webpack_require__(430)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/object/define-property'), require('babel-runtime/core-js/object/assign'), require('babel-runtime/core-js/array/from'), require('babel-runtime/core-js/object/set-prototype-of'), require('babel-runtime/core-js/object/create'), require('babel-runtime/core-js/symbol/iterator'), require('babel-runtime/core-js/symbol'), require('babel-runtime/core-js/object/get-prototype-of'), require('babel-runtime/core-js/json/stringify'), require('preact'), require('raven-js'), require('../components/utils/array'), require('object-loops/map'), require('script-loader!../../node_modules/wpt/wpt.min.js'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.defineProperty, global.assign, global.from, global.setPrototypeOf, global.create, global.iterator, global.symbol, global.getPrototypeOf, global.stringify, global.preact, global.ravenJs, global.array, global.map, global.wptMin);
    global.index = mod.exports;
  }
})(this, function (module, exports, _defineProperty2, _assign, _from, _setPrototypeOf, _create, _iterator, _symbol, _getPrototypeOf, _stringify, _preact, _ravenJs, _array, _map) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _defineProperty3 = _interopRequireDefault(_defineProperty2);

  var _assign2 = _interopRequireDefault(_assign);

  var _from2 = _interopRequireDefault(_from);

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create2 = _interopRequireDefault(_create);

  var _iterator2 = _interopRequireDefault(_iterator);

  var _symbol2 = _interopRequireDefault(_symbol);

  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

  var _stringify2 = _interopRequireDefault(_stringify);

  var _ravenJs2 = _interopRequireDefault(_ravenJs);

  var _map2 = _interopRequireDefault(_map);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      (0, _defineProperty3.default)(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty3.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _extends = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    } else {
      return (0, _from2.default)(arr);
    }
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj;
  };

  var RavenTracker = _ravenJs2.default.config('https://6e3dc0335efc49889187ec90288a84fd@sentry.io/109946');

  //TODO change Woopra to export properly, commonjs style
  //This is necessary because of the horrible way that woopra loads its trackers to the global context
  //This is actuall a less horrible way,
  //because the original way expects the tracker names to be inside of a global list with name __woo

  //this is necessary because woopra will load a script
  //that updates a key in window which has the name which is passed to WoopraTracker
  var trackerName = "onfidojssdkwoopra";

  var woopra = new window.WoopraTracker(trackerName);

  var setUp = function setUp() {
    woopra.init();

    // configure tracker
    woopra.config({
      domain: "onfido-js-sdk.com",
      cookie_name: 'onfido-js-sdk-woopra',
      cookie_domain: location.hostname,
      referer: location.href
    });

    var client = window.location.hostname;
    var sdk_version = "2.8.0";
    // Do not overwrite the woopra client if we are in the cross device client.
    // This is so we can track the original page where the user opened the SDK.
    woopra.identify(client.match(/^(id|id-dev)\.onfido\.com$/) ? { sdk_version: sdk_version } : { sdk_version: sdk_version, client: client });

    _ravenJs2.default.TraceKit.collectWindowErrors = true; //TODO scope exceptions to sdk code only
  };

  var track = function track() {
    woopra.track();
    RavenTracker.install();
  };

  var formatProperties = function formatProperties(properties) {
    if (!properties) return null;
    return (0, _map2.default)(properties, function (value) {
      return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? (0, _stringify2.default)(value) : value;
    });
  };

  var sendEvent = function sendEvent(eventName, properties) {
    return woopra.track(eventName, formatProperties(properties));
  };

  var screeNameHierarchyFormat = function screeNameHierarchyFormat(screeNameHierarchy) {
    return 'screen_' + (0, _array.cleanFalsy)(screeNameHierarchy).join('_');
  };

  var sendScreen = function sendScreen(screeNameHierarchy, properties) {
    return sendEvent(screeNameHierarchyFormat(screeNameHierarchy), properties);
  };

  var appendToTracking = function appendToTracking(Acomponent, ancestorScreeNameHierarchy) {
    return function (_Component) {
      _inherits(_class2, _Component);

      function _class2() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, _class2);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class2.__proto__ || (0, _getPrototypeOf2.default)(_class2)).call.apply(_ref, [this].concat(args))), _this), _this.trackScreen = function (screenNameHierarchy) {
          var _this$props;

          for (var _len2 = arguments.length, others = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            others[_key2 - 1] = arguments[_key2];
          }

          return (_this$props = _this.props).trackScreen.apply(_this$props, [[].concat(_toConsumableArray((0, _array.wrapArray)(ancestorScreeNameHierarchy)), _toConsumableArray((0, _array.wrapArray)(screenNameHierarchy)))].concat(others));
        }, _this.render = function () {
          return (0, _preact.h)(Acomponent, _extends({}, _this.props, { trackScreen: _this.trackScreen }));
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      return _class2;
    }(_preact.Component);
  };

  var trackComponent = function trackComponent(Acomponent, screenName) {
    return function (_Component2) {
      _inherits(_class4, _Component2);

      function _class4() {
        var _ref2;

        var _temp2, _this2, _ret2;

        _classCallCheck(this, _class4);

        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = _class4.__proto__ || (0, _getPrototypeOf2.default)(_class4)).call.apply(_ref2, [this].concat(args))), _this2), _this2.render = function () {
          return (0, _preact.h)(Acomponent, _this2.props);
        }, _temp2), _possibleConstructorReturn(_this2, _ret2);
      }

      _createClass(_class4, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.props.trackScreen(screenName);
        }
      }]);

      return _class4;
    }(_preact.Component);
  };

  var trackComponentMode = function trackComponentMode(Acomponent, propKey) {
    return function (_Component3) {
      _inherits(_class6, _Component3);

      function _class6() {
        var _ref3;

        var _temp3, _this3, _ret3;

        _classCallCheck(this, _class6);

        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }

        return _ret3 = (_temp3 = (_this3 = _possibleConstructorReturn(this, (_ref3 = _class6.__proto__ || (0, _getPrototypeOf2.default)(_class6)).call.apply(_ref3, [this].concat(args))), _this3), _this3.render = function () {
          return (0, _preact.h)(Acomponent, _this3.props);
        }, _temp3), _possibleConstructorReturn(_this3, _ret3);
      }

      _createClass(_class6, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.trackScreen(this.props);
        }
      }, {
        key: 'trackScreen',
        value: function trackScreen(props) {
          var _props;

          var propValue = props[propKey];
          var params = propValue ? [propKey, _defineProperty({}, propKey, propValue)] : [];
          (_props = this.props).trackScreen.apply(_props, params);
        }
      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
          if (this.props[propKey] !== nextProps[propKey]) {
            this.trackScreen(nextProps);
          }
        }
      }]);

      return _class6;
    }(_preact.Component);
  };

  var trackComponentAndMode = function trackComponentAndMode(Acomponent, screenName, propKey) {
    return appendToTracking(trackComponentMode(Acomponent, propKey), screenName);
  };

  var sendError = function sendError(message, extra) {
    RavenTracker.captureException(new Error(message), {
      extra: extra
    });
  };

  var setWoopraCookie = function setWoopraCookie(cookie) {
    var cookie_name = woopra.config('cookie_name');
    var cookie_expire = woopra.config('cookie_expire');
    var cookie_path = woopra.config('cookie_path');
    var cookie_domain = woopra.config('cookie_domain');
    woopra.docCookies.setItem(cookie_name, cookie, cookie_expire, cookie_path, cookie_domain);
    woopra.cookie = cookie;
  };

  var getWoopraCookie = function getWoopraCookie() {
    return woopra.cookie;
  };

  exports.default = { setUp: setUp, track: track, sendError: sendError, sendEvent: sendEvent, sendScreen: sendScreen, trackComponent: trackComponent,
    trackComponentAndMode: trackComponentAndMode, appendToTracking: appendToTracking, setWoopraCookie: setWoopraCookie,
    getWoopraCookie: getWoopraCookie };
  module.exports = exports['default'];
});

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(251), __esModule: true };

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 12 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(337);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 14 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(3), __webpack_require__(0), __webpack_require__(453), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/object/define-property'), require('preact'), require('./style.css'), require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.defineProperty, global.preact, global.style, global.classnames);
    global.index = mod.exports;
  }
})(this, function (module, exports, _defineProperty2, _preact, _style, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _defineProperty3 = _interopRequireDefault(_defineProperty2);

  var _style2 = _interopRequireDefault(_style);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      (0, _defineProperty3.default)(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var Title = function Title(_ref) {
    var _classNames;

    var title = _ref.title,
        subTitle = _ref.subTitle,
        smaller = _ref.smaller,
        isFullScreen = _ref.isFullScreen,
        className = _ref.className;
    return (0, _preact.h)(
      'div',
      { className: (0, _classnames2.default)(_style2.default.titleWrapper, (_classNames = {}, _defineProperty(_classNames, _style2.default.smaller, smaller && !isFullScreen), _defineProperty(_classNames, _style2.default.fullScreen, isFullScreen), _classNames), className) },
      (0, _preact.h)(
        'div',
        { className: _style2.default.title },
        title
      ),
      subTitle && (0, _preact.h)(
        'div',
        null,
        subTitle
      )
    );
  };

  exports.default = Title;
  module.exports = exports['default'];
});

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(20);
var core = __webpack_require__(12);
var ctx = __webpack_require__(30);
var hide = __webpack_require__(26);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(92)('wks');
var uid = __webpack_require__(63);
var Symbol = __webpack_require__(20).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(24);
var IE8_DOM_DEFINE = __webpack_require__(124);
var toPrimitive = __webpack_require__(94);
var dP = Object.defineProperty;

exports.f = __webpack_require__(19) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(25)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 20 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(339);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(248), __esModule: true };

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(21);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(18);
var createDesc = __webpack_require__(49);
module.exports = __webpack_require__(19) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(246), __esModule: true };

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(3);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(120);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(86);
var defined = __webpack_require__(84);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.index = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var SET_DOCUMENT_TYPE = exports.SET_DOCUMENT_TYPE = 'SET_DOCUMENT_TYPE';
  var SET_ROOM_ID = exports.SET_ROOM_ID = 'SET_ROOM_ID';
  var SET_SOCKET = exports.SET_SOCKET = 'SET_SOCKET';
  var SET_MOBILE_NUMBER = exports.SET_MOBILE_NUMBER = 'SET_MOBILE_NUMBER';
  var SET_CLIENT_SUCCESS = exports.SET_CLIENT_SUCCESS = 'SET_CLIENT_SUCCESS';
  var MOBILE_CONNECTED = exports.MOBILE_CONNECTED = 'MOBILE_CONNECTED';
  var ACCEPT_TERMS = exports.ACCEPT_TERMS = 'ACCEPT_TERMS';

  var CAPTURE_CREATE = exports.CAPTURE_CREATE = 'CAPTURE_CREATE';
  var CAPTURE_VALIDATE = exports.CAPTURE_VALIDATE = 'CAPTURE_VALIDATE';
  var CAPTURE_DELETE = exports.CAPTURE_DELETE = 'CAPTURE_DELETE';

  var RESET_STORE = exports.RESET_STORE = 'RESET_STORE';
});

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(132);
var enumBugKeys = __webpack_require__(85);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(84);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Module dependencies.
 */

var keys = __webpack_require__(346);
var hasBinary = __webpack_require__(141);
var sliceBuffer = __webpack_require__(184);
var after = __webpack_require__(182);
var utf8 = __webpack_require__(347);

var base64encoder;
if (global && global.ArrayBuffer) {
  base64encoder = __webpack_require__(238);
}

/**
 * Check if we are running an android browser. That requires us to use
 * ArrayBuffer with polling transports...
 *
 * http://ghinda.net/jpeg-blob-ajax-android/
 */

var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);

/**
 * Check if we are running in PhantomJS.
 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
 * https://github.com/ariya/phantomjs/issues/11395
 * @type boolean
 */
var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);

/**
 * When true, avoids using Blobs to encode payloads.
 * @type boolean
 */
var dontSendBlobs = isAndroid || isPhantomJS;

/**
 * Current protocol version.
 */

exports.protocol = 3;

/**
 * Packet types.
 */

var packets = exports.packets = {
    open:     0    // non-ws
  , close:    1    // non-ws
  , ping:     2
  , pong:     3
  , message:  4
  , upgrade:  5
  , noop:     6
};

var packetslist = keys(packets);

/**
 * Premade error packet.
 */

var err = { type: 'error', data: 'parser error' };

/**
 * Create a blob api even for blob builder when vendor prefixes exist
 */

var Blob = __webpack_require__(240);

/**
 * Encodes a packet.
 *
 *     <packet type id> [ <data> ]
 *
 * Example:
 *
 *     5hello world
 *     3
 *     4
 *
 * Binary is encoded in an identical principle
 *
 * @api private
 */

exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
  if (typeof supportsBinary === 'function') {
    callback = supportsBinary;
    supportsBinary = false;
  }

  if (typeof utf8encode === 'function') {
    callback = utf8encode;
    utf8encode = null;
  }

  var data = (packet.data === undefined)
    ? undefined
    : packet.data.buffer || packet.data;

  if (global.ArrayBuffer && data instanceof ArrayBuffer) {
    return encodeArrayBuffer(packet, supportsBinary, callback);
  } else if (Blob && data instanceof global.Blob) {
    return encodeBlob(packet, supportsBinary, callback);
  }

  // might be an object with { base64: true, data: dataAsBase64String }
  if (data && data.base64) {
    return encodeBase64Object(packet, callback);
  }

  // Sending data as a utf-8 string
  var encoded = packets[packet.type];

  // data fragment is optional
  if (undefined !== packet.data) {
    encoded += utf8encode ? utf8.encode(String(packet.data), { strict: false }) : String(packet.data);
  }

  return callback('' + encoded);

};

function encodeBase64Object(packet, callback) {
  // packet data is an object { base64: true, data: dataAsBase64String }
  var message = 'b' + exports.packets[packet.type] + packet.data.data;
  return callback(message);
}

/**
 * Encode packet helpers for binary types
 */

function encodeArrayBuffer(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  var data = packet.data;
  var contentArray = new Uint8Array(data);
  var resultBuffer = new Uint8Array(1 + data.byteLength);

  resultBuffer[0] = packets[packet.type];
  for (var i = 0; i < contentArray.length; i++) {
    resultBuffer[i+1] = contentArray[i];
  }

  return callback(resultBuffer.buffer);
}

function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  var fr = new FileReader();
  fr.onload = function() {
    packet.data = fr.result;
    exports.encodePacket(packet, supportsBinary, true, callback);
  };
  return fr.readAsArrayBuffer(packet.data);
}

function encodeBlob(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  if (dontSendBlobs) {
    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
  }

  var length = new Uint8Array(1);
  length[0] = packets[packet.type];
  var blob = new Blob([length.buffer, packet.data]);

  return callback(blob);
}

/**
 * Encodes a packet with binary data in a base64 string
 *
 * @param {Object} packet, has `type` and `data`
 * @return {String} base64 encoded message
 */

exports.encodeBase64Packet = function(packet, callback) {
  var message = 'b' + exports.packets[packet.type];
  if (Blob && packet.data instanceof global.Blob) {
    var fr = new FileReader();
    fr.onload = function() {
      var b64 = fr.result.split(',')[1];
      callback(message + b64);
    };
    return fr.readAsDataURL(packet.data);
  }

  var b64data;
  try {
    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
  } catch (e) {
    // iPhone Safari doesn't let you apply with typed arrays
    var typed = new Uint8Array(packet.data);
    var basic = new Array(typed.length);
    for (var i = 0; i < typed.length; i++) {
      basic[i] = typed[i];
    }
    b64data = String.fromCharCode.apply(null, basic);
  }
  message += global.btoa(b64data);
  return callback(message);
};

/**
 * Decodes a packet. Changes format to Blob if requested.
 *
 * @return {Object} with `type` and `data` (if any)
 * @api private
 */

exports.decodePacket = function (data, binaryType, utf8decode) {
  if (data === undefined) {
    return err;
  }
  // String data
  if (typeof data === 'string') {
    if (data.charAt(0) === 'b') {
      return exports.decodeBase64Packet(data.substr(1), binaryType);
    }

    if (utf8decode) {
      data = tryDecode(data);
      if (data === false) {
        return err;
      }
    }
    var type = data.charAt(0);

    if (Number(type) != type || !packetslist[type]) {
      return err;
    }

    if (data.length > 1) {
      return { type: packetslist[type], data: data.substring(1) };
    } else {
      return { type: packetslist[type] };
    }
  }

  var asArray = new Uint8Array(data);
  var type = asArray[0];
  var rest = sliceBuffer(data, 1);
  if (Blob && binaryType === 'blob') {
    rest = new Blob([rest]);
  }
  return { type: packetslist[type], data: rest };
};

function tryDecode(data) {
  try {
    data = utf8.decode(data, { strict: false });
  } catch (e) {
    return false;
  }
  return data;
}

/**
 * Decodes a packet encoded in a base64 string
 *
 * @param {String} base64 encoded message
 * @return {Object} with `type` and `data` (if any)
 */

exports.decodeBase64Packet = function(msg, binaryType) {
  var type = packetslist[msg.charAt(0)];
  if (!base64encoder) {
    return { type: type, data: { base64: true, data: msg.substr(1) } };
  }

  var data = base64encoder.decode(msg.substr(1));

  if (binaryType === 'blob' && Blob) {
    data = new Blob([data]);
  }

  return { type: type, data: data };
};

/**
 * Encodes multiple messages (payload).
 *
 *     <length>:data
 *
 * Example:
 *
 *     11:hello world2:hi
 *
 * If any contents are binary, they will be encoded as base64 strings. Base64
 * encoded strings are marked with a b before the length specifier
 *
 * @param {Array} packets
 * @api private
 */

exports.encodePayload = function (packets, supportsBinary, callback) {
  if (typeof supportsBinary === 'function') {
    callback = supportsBinary;
    supportsBinary = null;
  }

  var isBinary = hasBinary(packets);

  if (supportsBinary && isBinary) {
    if (Blob && !dontSendBlobs) {
      return exports.encodePayloadAsBlob(packets, callback);
    }

    return exports.encodePayloadAsArrayBuffer(packets, callback);
  }

  if (!packets.length) {
    return callback('0:');
  }

  function setLengthHeader(message) {
    return message.length + ':' + message;
  }

  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, !isBinary ? false : supportsBinary, false, function(message) {
      doneCallback(null, setLengthHeader(message));
    });
  }

  map(packets, encodeOne, function(err, results) {
    return callback(results.join(''));
  });
};

/**
 * Async array map using after
 */

function map(ary, each, done) {
  var result = new Array(ary.length);
  var next = after(ary.length, done);

  var eachWithIndex = function(i, el, cb) {
    each(el, function(error, msg) {
      result[i] = msg;
      cb(error, result);
    });
  };

  for (var i = 0; i < ary.length; i++) {
    eachWithIndex(i, ary[i], next);
  }
}

/*
 * Decodes data when a payload is maybe expected. Possible binary contents are
 * decoded from their base64 representation
 *
 * @param {String} data, callback method
 * @api public
 */

exports.decodePayload = function (data, binaryType, callback) {
  if (typeof data !== 'string') {
    return exports.decodePayloadAsBinary(data, binaryType, callback);
  }

  if (typeof binaryType === 'function') {
    callback = binaryType;
    binaryType = null;
  }

  var packet;
  if (data === '') {
    // parser error - ignoring payload
    return callback(err, 0, 1);
  }

  var length = '', n, msg;

  for (var i = 0, l = data.length; i < l; i++) {
    var chr = data.charAt(i);

    if (chr !== ':') {
      length += chr;
      continue;
    }

    if (length === '' || (length != (n = Number(length)))) {
      // parser error - ignoring payload
      return callback(err, 0, 1);
    }

    msg = data.substr(i + 1, n);

    if (length != msg.length) {
      // parser error - ignoring payload
      return callback(err, 0, 1);
    }

    if (msg.length) {
      packet = exports.decodePacket(msg, binaryType, false);

      if (err.type === packet.type && err.data === packet.data) {
        // parser error in individual packet - ignoring payload
        return callback(err, 0, 1);
      }

      var ret = callback(packet, i + n, l);
      if (false === ret) return;
    }

    // advance cursor
    i += n;
    length = '';
  }

  if (length !== '') {
    // parser error - ignoring payload
    return callback(err, 0, 1);
  }

};

/**
 * Encodes multiple messages (payload) as binary.
 *
 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
 * 255><data>
 *
 * Example:
 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
 *
 * @param {Array} packets
 * @return {ArrayBuffer} encoded payload
 * @api private
 */

exports.encodePayloadAsArrayBuffer = function(packets, callback) {
  if (!packets.length) {
    return callback(new ArrayBuffer(0));
  }

  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, true, true, function(data) {
      return doneCallback(null, data);
    });
  }

  map(packets, encodeOne, function(err, encodedPackets) {
    var totalLength = encodedPackets.reduce(function(acc, p) {
      var len;
      if (typeof p === 'string'){
        len = p.length;
      } else {
        len = p.byteLength;
      }
      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
    }, 0);

    var resultArray = new Uint8Array(totalLength);

    var bufferIndex = 0;
    encodedPackets.forEach(function(p) {
      var isString = typeof p === 'string';
      var ab = p;
      if (isString) {
        var view = new Uint8Array(p.length);
        for (var i = 0; i < p.length; i++) {
          view[i] = p.charCodeAt(i);
        }
        ab = view.buffer;
      }

      if (isString) { // not true binary
        resultArray[bufferIndex++] = 0;
      } else { // true binary
        resultArray[bufferIndex++] = 1;
      }

      var lenStr = ab.byteLength.toString();
      for (var i = 0; i < lenStr.length; i++) {
        resultArray[bufferIndex++] = parseInt(lenStr[i]);
      }
      resultArray[bufferIndex++] = 255;

      var view = new Uint8Array(ab);
      for (var i = 0; i < view.length; i++) {
        resultArray[bufferIndex++] = view[i];
      }
    });

    return callback(resultArray.buffer);
  });
};

/**
 * Encode as Blob
 */

exports.encodePayloadAsBlob = function(packets, callback) {
  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, true, true, function(encoded) {
      var binaryIdentifier = new Uint8Array(1);
      binaryIdentifier[0] = 1;
      if (typeof encoded === 'string') {
        var view = new Uint8Array(encoded.length);
        for (var i = 0; i < encoded.length; i++) {
          view[i] = encoded.charCodeAt(i);
        }
        encoded = view.buffer;
        binaryIdentifier[0] = 0;
      }

      var len = (encoded instanceof ArrayBuffer)
        ? encoded.byteLength
        : encoded.size;

      var lenStr = len.toString();
      var lengthAry = new Uint8Array(lenStr.length + 1);
      for (var i = 0; i < lenStr.length; i++) {
        lengthAry[i] = parseInt(lenStr[i]);
      }
      lengthAry[lenStr.length] = 255;

      if (Blob) {
        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
        doneCallback(null, blob);
      }
    });
  }

  map(packets, encodeOne, function(err, results) {
    return callback(new Blob(results));
  });
};

/*
 * Decodes data when a payload is maybe expected. Strings are decoded by
 * interpreting each byte as a key code for entries marked to start with 0. See
 * description of encodePayloadAsBinary
 *
 * @param {ArrayBuffer} data, callback method
 * @api public
 */

exports.decodePayloadAsBinary = function (data, binaryType, callback) {
  if (typeof binaryType === 'function') {
    callback = binaryType;
    binaryType = null;
  }

  var bufferTail = data;
  var buffers = [];

  while (bufferTail.byteLength > 0) {
    var tailArray = new Uint8Array(bufferTail);
    var isString = tailArray[0] === 0;
    var msgLength = '';

    for (var i = 1; ; i++) {
      if (tailArray[i] === 255) break;

      // 310 = char length of Number.MAX_VALUE
      if (msgLength.length > 310) {
        return callback(err, 0, 1);
      }

      msgLength += tailArray[i];
    }

    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
    msgLength = parseInt(msgLength);

    var msg = sliceBuffer(bufferTail, 0, msgLength);
    if (isString) {
      try {
        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
      } catch (e) {
        // iPhone Safari doesn't let you apply to typed arrays
        var typed = new Uint8Array(msg);
        msg = '';
        for (var i = 0; i < typed.length; i++) {
          msg += String.fromCharCode(typed[i]);
        }
      }
    }

    buffers.push(msg);
    bufferTail = sliceBuffer(bufferTail, msgLength);
  }

  var total = buffers.length;
  buffers.forEach(function(buffer, i) {
    callback(exports.decodePacket(buffer, binaryType, true), i, total);
  });
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = get_phone_code;
/* harmony export (immutable) */ __webpack_exports__["k"] = get_national_number_pattern;
/* harmony export (immutable) */ __webpack_exports__["b"] = get_formats;
/* unused harmony export get_national_prefix */
/* unused harmony export get_national_prefix_formatting_rule */
/* harmony export (immutable) */ __webpack_exports__["l"] = get_national_prefix_for_parsing;
/* harmony export (immutable) */ __webpack_exports__["m"] = get_national_prefix_transform_rule;
/* unused harmony export get_national_prefix_is_optional_when_formatting */
/* harmony export (immutable) */ __webpack_exports__["n"] = get_leading_digits;
/* harmony export (immutable) */ __webpack_exports__["e"] = get_format_pattern;
/* harmony export (immutable) */ __webpack_exports__["i"] = get_format_format;
/* harmony export (immutable) */ __webpack_exports__["d"] = get_format_leading_digits_patterns;
/* harmony export (immutable) */ __webpack_exports__["h"] = get_format_national_prefix_formatting_rule;
/* harmony export (immutable) */ __webpack_exports__["o"] = get_format_national_prefix_is_optional_when_formatting;
/* harmony export (immutable) */ __webpack_exports__["g"] = get_format_national_prefix_is_mandatory_when_formatting;
/* harmony export (immutable) */ __webpack_exports__["j"] = get_format_uses_national_prefix;
/* harmony export (immutable) */ __webpack_exports__["c"] = get_format_international_format;
/* harmony export (immutable) */ __webpack_exports__["f"] = get_metadata_by_country_phone_code;
/* harmony export (immutable) */ __webpack_exports__["p"] = get_types;
/* harmony export (immutable) */ __webpack_exports__["y"] = get_type_fixed_line;
/* harmony export (immutable) */ __webpack_exports__["z"] = get_type_mobile;
/* harmony export (immutable) */ __webpack_exports__["r"] = get_type_toll_free;
/* harmony export (immutable) */ __webpack_exports__["q"] = get_type_premium_rate;
/* harmony export (immutable) */ __webpack_exports__["u"] = get_type_personal_number;
/* harmony export (immutable) */ __webpack_exports__["x"] = get_type_voice_mail;
/* harmony export (immutable) */ __webpack_exports__["w"] = get_type_uan;
/* harmony export (immutable) */ __webpack_exports__["v"] = get_type_pager;
/* harmony export (immutable) */ __webpack_exports__["t"] = get_type_voip;
/* harmony export (immutable) */ __webpack_exports__["s"] = get_type_shared_cost;
/* unused harmony export get_country_phone_code */
function get_phone_code(country_metadata) {
	return country_metadata[0];
}

function get_national_number_pattern(country_metadata) {
	return country_metadata[1];
}

function get_formats(country_metadata) {
	return country_metadata[2] || [];
}

function get_national_prefix(country_metadata) {
	return country_metadata[3];
}

function get_national_prefix_formatting_rule(country_metadata) {
	return country_metadata[4];
}

function get_national_prefix_for_parsing(country_metadata) {
	var national_prefix_for_parsing = country_metadata[5];

	// If `national_prefix_for_parsing` is not set explicitly,
	// then infer it from `national_prefix` (if any)
	if (!national_prefix_for_parsing) {
		national_prefix_for_parsing = get_national_prefix(country_metadata);
	}

	return national_prefix_for_parsing;
}

function get_national_prefix_transform_rule(country_metadata) {
	return country_metadata[6];
}

function get_national_prefix_is_optional_when_formatting(country_metadata) {
	return country_metadata[7];
}

function get_leading_digits(country_metadata) {
	return country_metadata[8];
}

function get_format_pattern(format_array) {
	return format_array[0];
}

function get_format_format(format_array) {
	return format_array[1];
}

function get_format_leading_digits_patterns(format_array) {
	return format_array[2] || [];
}

function get_format_national_prefix_formatting_rule(format_array, country_metadata) {
	return format_array[3] || get_national_prefix_formatting_rule(country_metadata);
}

function get_format_national_prefix_is_optional_when_formatting(format_array, country_metadata) {
	return format_array[4] || get_national_prefix_is_optional_when_formatting(country_metadata);
}

function get_format_national_prefix_is_mandatory_when_formatting(format_array, country_metadata) {
	var national_prefix_formatting_rule = get_format_national_prefix_formatting_rule(format_array, country_metadata);

	// National prefix is omitted if there's no national prefix formatting rule
	// set for this country, or when the national prefix formatting rule
	// contains no national prefix itself, or when this rule is set but
	// national prefix is optional for this phone number format
	// (and it is not enforced explicitly)
	return national_prefix_formatting_rule &&
	// Check that national prefix formatting rule is not a dummy one.
	// Check that national prefix formatting rule actually has national prefix digit(s).
	get_format_uses_national_prefix(national_prefix_formatting_rule) &&
	// Or maybe national prefix is optional for this format
	!get_format_national_prefix_is_optional_when_formatting(format_array, country_metadata);
}

// Checks whether national prefix formatting rule contains national prefix
function get_format_uses_national_prefix(national_prefix_formatting_rule) {
	// Check that national prefix formatting rule is not a dummy one
	return national_prefix_formatting_rule !== '$1' &&
	// Check that national prefix formatting rule actually has national prefix digit(s)
	/\d/.test(national_prefix_formatting_rule.replace('$1', ''));
}

function get_format_international_format(format_array) {
	return format_array[5] || get_format_format(format_array);
}

// Formatting information for regions which share
// a country calling code is contained by only one region
// for performance reasons. For example, for NANPA region
// ("North American Numbering Plan Administration",
//  which includes USA, Canada, Cayman Islands, Bahamas, etc)
// it will be contained in the metadata for `US`.
function get_metadata_by_country_phone_code(country_phone_code, metadata) {
	var country_code = metadata.country_phone_code_to_countries[country_phone_code][0];
	return metadata.countries[country_code];
}

function get_types(country_metadata) {
	return country_metadata[9];
}

function get_type(country_metadata, index) {
	return get_types(country_metadata) ? get_types(country_metadata)[index] : undefined;
}

function get_type_fixed_line(country_metadata) {
	return get_type(country_metadata, 0);
}

function get_type_mobile(country_metadata) {
	return get_type(country_metadata, 1);
}

function get_type_toll_free(country_metadata) {
	return get_type(country_metadata, 2);
}

function get_type_premium_rate(country_metadata) {
	return get_type(country_metadata, 3);
}

function get_type_personal_number(country_metadata) {
	return get_type(country_metadata, 4);
}

function get_type_voice_mail(country_metadata) {
	return get_type(country_metadata, 5);
}

function get_type_uan(country_metadata) {
	return get_type(country_metadata, 6);
}

function get_type_pager(country_metadata) {
	return get_type(country_metadata, 7);
}

function get_type_voip(country_metadata) {
	return get_type(country_metadata, 8);
}

function get_type_shared_cost(country_metadata) {
	return get_type(country_metadata, 9);
}

function get_country_phone_code(country, country_metadata) {
	return get_phone_code(country_metadata[country]);
}
//# sourceMappingURL=metadata.js.map

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PLUS_CHARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return VALID_DIGITS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VALID_PUNCTUATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DIGIT_MAPPINGS; });
/* harmony export (immutable) */ __webpack_exports__["a"] = parse;
/* unused harmony export normalize */
/* unused harmony export replace_characters */
/* harmony export (immutable) */ __webpack_exports__["j"] = is_viable_phone_number;
/* harmony export (immutable) */ __webpack_exports__["e"] = extract_formatted_phone_number;
/* harmony export (immutable) */ __webpack_exports__["f"] = parse_phone_number;
/* harmony export (immutable) */ __webpack_exports__["g"] = parse_phone_number_and_country_phone_code;
/* harmony export (immutable) */ __webpack_exports__["h"] = strip_national_prefix;
/* harmony export (immutable) */ __webpack_exports__["i"] = find_country_code;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__format__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__get_number_type__ = __webpack_require__(67);


// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of 17th November, 2016.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js









var PLUS_CHARS = '+\uFF0B';

// Digits accepted in phone numbers
// (ascii, fullwidth, arabic-indic, and eastern arabic digits).
var VALID_DIGITS = '0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9';

// `DASHES` will be right after the opening square bracket of the "character class"
var DASHES = '-\u2010-\u2015\u2212\u30FC\uFF0D';
var SLASHES = '\uFF0F/';
var DOTS = '\uFF0E.';
var WHITESPACE = ' \xA0\xAD\u200B\u2060\u3000';
var BRACKETS = '()\uFF08\uFF09\uFF3B\uFF3D\\[\\]';
var TILDES = '~\u2053\u223C\uFF5E';

// Regular expression of acceptable punctuation found in phone numbers. This
// excludes punctuation found as a leading character only. This consists of dash
// characters, white space characters, full stops, slashes, square brackets,
// parentheses and tildes. Full-width variants are also present.
var VALID_PUNCTUATION = '' + DASHES + SLASHES + DOTS + WHITESPACE + BRACKETS + TILDES;

//  Regular expression of viable phone numbers. This is location independent.
//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + VALID_DIGITS + ']{' + MIN_LENGTH_FOR_NSN + '}';
//
// And this is the second reg-exp:
// (see MIN_LENGTH_PHONE_NUMBER_PATTERN for a full description of this reg-exp)
//
var VALID_PHONE_NUMBER = '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){3,}' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*';

// The combined regular expression for valid phone numbers:
//
var VALID_PHONE_NUMBER_PATTERN = new RegExp(
// Either a short two-digit-only phone number
'^' + MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' +
// Or a longer fully parsed phone number (min 3 characters)
'^' + VALID_PHONE_NUMBER +
// screw phone number extensions
// '(?:' + EXTN_PATTERNS_FOR_PARSING + ')?' +
'$', 'i');

// This consists of the plus symbol, digits, and arabic-indic digits.
var PHONE_NUMBER_START_PATTERN = new RegExp('[' + PLUS_CHARS + VALID_DIGITS + ']');

// Regular expression of trailing characters that we want to remove.
var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + VALID_DIGITS + ']+$');

var LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+');

// These mappings map a character (key) to a specific digit that should
// replace it for normalization purposes. Non-European digits that
// may be used in phone numbers are mapped to a European equivalent.
//
// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
//
var DIGIT_MAPPINGS = {
	'0': '0',
	'1': '1',
	'2': '2',
	'3': '3',
	'4': '4',
	'5': '5',
	'6': '6',
	'7': '7',
	'8': '8',
	'9': '9',
	'\uFF10': '0', // Fullwidth digit 0
	'\uFF11': '1', // Fullwidth digit 1
	'\uFF12': '2', // Fullwidth digit 2
	'\uFF13': '3', // Fullwidth digit 3
	'\uFF14': '4', // Fullwidth digit 4
	'\uFF15': '5', // Fullwidth digit 5
	'\uFF16': '6', // Fullwidth digit 6
	'\uFF17': '7', // Fullwidth digit 7
	'\uFF18': '8', // Fullwidth digit 8
	'\uFF19': '9', // Fullwidth digit 9
	'\u0660': '0', // Arabic-indic digit 0
	'\u0661': '1', // Arabic-indic digit 1
	'\u0662': '2', // Arabic-indic digit 2
	'\u0663': '3', // Arabic-indic digit 3
	'\u0664': '4', // Arabic-indic digit 4
	'\u0665': '5', // Arabic-indic digit 5
	'\u0666': '6', // Arabic-indic digit 6
	'\u0667': '7', // Arabic-indic digit 7
	'\u0668': '8', // Arabic-indic digit 8
	'\u0669': '9', // Arabic-indic digit 9
	'\u06F0': '0', // Eastern-Arabic digit 0
	'\u06F1': '1', // Eastern-Arabic digit 1
	'\u06F2': '2', // Eastern-Arabic digit 2
	'\u06F3': '3', // Eastern-Arabic digit 3
	'\u06F4': '4', // Eastern-Arabic digit 4
	'\u06F5': '5', // Eastern-Arabic digit 5
	'\u06F6': '6', // Eastern-Arabic digit 6
	'\u06F7': '7', // Eastern-Arabic digit 7
	'\u06F8': '8', // Eastern-Arabic digit 8
	'\u06F9': '9' // Eastern-Arabic digit 9


	// The maximum length of the country calling code.
};var MAX_LENGTH_COUNTRY_CODE = 3;

// The minimum length of the national significant number.
var MIN_LENGTH_FOR_NSN = 2;

// The ITU says the maximum length should be 15,
// but one can find longer numbers in Germany.
var MAX_LENGTH_FOR_NSN = 17;

// We don't allow input strings for parsing to be longer than 250 chars.
// This prevents malicious input from consuming CPU.
var MAX_INPUT_STRING_LENGTH = 250;

var default_options = {
	country: {}

	// `options`:
	//  {
	//    country:
	//    {
	//      restrict - (a two-letter country code)
	//                 the phone number must be in this country
	//
	//      default - (a two-letter country code)
	//                default country to use for phone number parsing and validation
	//                (if no country code could be derived from the phone number)
	//    }
	//  }
	//
	// Returns `{ country, number }`
	//
	// Example use cases:
	//
	// ```js
	// parse('8 (800) 555-35-35', 'RU')
	// parse('8 (800) 555-35-35', 'RU', metadata)
	// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
	// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
	// parse('+7 800 555 35 35')
	// parse('+7 800 555 35 35', metadata)
	// ```
	//
};function parse(first_argument, second_argument, third_argument) {
	var _sort_out_arguments = sort_out_arguments(first_argument, second_argument, third_argument),
	    text = _sort_out_arguments.text,
	    options = _sort_out_arguments.options,
	    metadata = _sort_out_arguments.metadata;

	if (!options) {
		options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, default_options);
	}

	// Validate country codes

	// Validate `default` country
	if (options.country.default && !metadata.countries[options.country.default]) {
		throw new Error('Unknown country code: ' + options.country.default);
	}

	// Validate `restrict` country
	if (options.country.restrict && !metadata.countries[options.country.restrict]) {
		throw new Error('Unknown country code: ' + options.country.restrict);
	}

	// Parse the phone number

	var formatted_phone_number = extract_formatted_phone_number(text);

	// If the phone number is not viable, then abort.
	if (!is_viable_phone_number(formatted_phone_number)) {
		return {};
	}

	var _parse_phone_number_a = parse_phone_number_and_country_phone_code(formatted_phone_number, metadata),
	    country_phone_code = _parse_phone_number_a.country_phone_code,
	    number = _parse_phone_number_a.number;

	// Maybe invalid country phone code encountered


	if (!number) {
		return {};
	}

	var country = void 0;
	var country_metadata = void 0;

	// Whether the phone number is formatted as an international phone number
	var is_international = false;

	if (country_phone_code) {
		is_international = true;

		// Check country restriction
		if (options.country.restrict && country_phone_code !== __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* get_phone_code */])(metadata.countries[options.country.restrict])) {
			return {};
		}

		// Formatting information for regions which share
		// a country calling code is contained by only one region
		// for performance reasons. For example, for NANPA region
		// ("North American Numbering Plan Administration",
		//  which includes USA, Canada, Cayman Islands, Bahamas, etc)
		// it will be contained in the metadata for `US`.
		country_metadata = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["f" /* get_metadata_by_country_phone_code */])(country_phone_code, metadata);

		// `country` will be set later,
		// because, for example, for NANPA countries
		// there are several countries corresponding
		// to the same `1` country phone code.
		// Therefore, to reliably determine the exact country,
		// national (significant) number should be parsed first.
	} else if (options.country.restrict || options.country.default) {
		country = options.country.restrict || options.country.default;
		country_metadata = metadata.countries[country];

		number = normalize(text);
	}

	if (!country_metadata) {
		return {};
	}

	var national_number = strip_national_prefix(number, country_metadata);

	var did_have_national_prefix = national_number !== number;

	// https://github.com/catamphetamine/libphonenumber-js/issues/67
	// if (!is_international && !did_have_national_prefix &&
	// 		is_national_prefix_required(national_number, country_metadata))
	// {
	// 	return {}
	// }

	// Sometimes there are several countries
	// corresponding to the same country phone code
	// (e.g. NANPA countries all having `1` country phone code).
	// Therefore, to reliably determine the exact country,
	// national (significant) number should have been parsed first.
	//
	if (!country) {
		// When `metadata.json` is generated, all "ambiguous" country phone codes
		// get their countries populated with the full set of
		// "phone number type" regular expressions.
		country = find_country_code(country_phone_code, national_number, metadata);

		// Just in case there appears to be a bug in Google's metadata
		// and the exact country could not be extracted from the phone number.
		/* istanbul ignore if */
		if (!country) {
			return {};
		}

		// Update metadata to be for this specific country
		country_metadata = metadata.countries[country];
	}

	// Validate national (significant) number length.
	//
	// A sidenote:
	//
	// They say that sometimes national (significant) numbers
	// can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
	// https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
	// Such numbers will just be discarded.
	//
	if (national_number.length > MAX_LENGTH_FOR_NSN) {
		return {};
	}

	// National number pattern is different for each country,
	// even for those ones which are part of the "NANPA" group.
	var national_number_rule = new RegExp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["k" /* get_national_number_pattern */])(country_metadata));

	// Check if national phone number pattern matches the number
	if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common__["a" /* matches_entirely */])(national_number, national_number_rule)) {
		return {};
	}

	return { country: country, phone: national_number };
}

// Normalizes a string of characters representing a phone number.
// This converts wide-ascii and arabic-indic numerals to European numerals,
// and strips punctuation and alpha characters.
//
// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
//
function normalize(number) {
	return replace_characters(number, DIGIT_MAPPINGS);
}

// For any character not being part of `replacements`
// it is removed from the phone number.
function replace_characters(text, replacements) {
	var replaced = '';

	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(text), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var character = _step.value;

			var replacement = replacements[character.toUpperCase()];

			if (replacement !== undefined) {
				replaced += replacement;
			}
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	return replaced;
}

// Checks to see if the string of characters could possibly be a phone number at
// all. At the moment, checks to see that the string begins with at least 2
// digits, ignoring any punctuation commonly found in phone numbers. This method
// does not require the number to be normalized in advance - but does assume
// that leading non-number symbols have been removed, such as by the method
// `extract_possible_number`.
//
function is_viable_phone_number(number) {
	return number.length >= MIN_LENGTH_FOR_NSN && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common__["a" /* matches_entirely */])(number, VALID_PHONE_NUMBER_PATTERN);
}

function extract_formatted_phone_number(text) {
	if (!text || text.length > MAX_INPUT_STRING_LENGTH) {
		return '';
	}

	// Attempt to extract a possible number from the string passed in

	var starts_at = text.search(PHONE_NUMBER_START_PATTERN);

	if (starts_at < 0) {
		return '';
	}

	return text
	// Trim everything to the left of the phone number
	.slice(starts_at)
	// Remove trailing non-numerical characters
	.replace(AFTER_PHONE_NUMBER_END_PATTERN, '');
}

// Parses a formatted phone number.
function parse_phone_number(number) {
	if (!number) {
		return '';
	}

	var is_international = LEADING_PLUS_CHARS_PATTERN.test(number);

	// Remove non-digits
	// (and strip the possible leading '+')
	number = normalize(number);

	if (is_international) {
		return '+' + number;
	}

	return number;
}

// Parses a formatted phone number
// and returns `{ country_phone_code, number }`
// where `number` is the national (significant) phone number.
//
// (aka `maybeExtractCountryPhoneCode`)
//
function parse_phone_number_and_country_phone_code(number, metadata) {
	number = parse_phone_number(number);

	if (!number) {
		return {};
	}

	// If this is not an international phone number,
	// then don't extract country phone code.
	if (number[0] !== '+') {
		return { number: number };
	}

	// Strip the leading '+' sign
	number = number.slice(1);

	// Fast abortion: country codes do not begin with a '0'
	if (number[0] === '0') {
		return {};
	}

	// The thing with country phone codes
	// is that they are orthogonal to each other
	// i.e. there's no such country phone code A
	// for which country phone code B exists
	// where B starts with A.
	// Therefore, while scanning digits,
	// if a valid country code is found,
	// that means that it is the country code.
	//
	var i = 1;
	while (i <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
		var country_phone_code = number.slice(0, i);

		if (metadata.country_phone_code_to_countries[country_phone_code]) {
			return { country_phone_code: country_phone_code, number: number.slice(i) };
		}

		i++;
	}

	return {};
}

// Strips any national prefix (such as 0, 1) present in the number provided
function strip_national_prefix(number, country_metadata) {
	var national_prefix_for_parsing = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["l" /* get_national_prefix_for_parsing */])(country_metadata);

	if (!number || !national_prefix_for_parsing) {
		return number;
	}

	// Attempt to parse the first digits as a national prefix
	var national_prefix_pattern = new RegExp('^(?:' + national_prefix_for_parsing + ')');
	var national_prefix_matcher = national_prefix_pattern.exec(number);

	// If no national prefix is present in the phone number,
	// but if the national prefix is optional for this country,
	// then consider this phone number valid.
	//
	// Google's reference `libphonenumber` implementation
	// wouldn't recognize such phone numbers as valid,
	// but I think it would perfectly make sense
	// to consider such phone numbers as valid
	// because if a national phone number was originally
	// formatted without the national prefix
	// then it must be parseable back into the original national number.
	// In other words, `parse(format(number))`
	// must always be equal to `number`.
	//
	if (!national_prefix_matcher) {
		return number;
	}

	var national_significant_number = void 0;

	// `national_prefix_for_parsing` capturing groups
	// (used only for really messy cases: Argentina, Brazil, Mexico, Somalia)
	var any_groups_were_captured = national_prefix_matcher[national_prefix_matcher.length - 1];
	var national_prefix_transform_rule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["m" /* get_national_prefix_transform_rule */])(country_metadata);

	// If the national number tranformation is needed then do it
	if (national_prefix_transform_rule && any_groups_were_captured) {
		national_significant_number = number.replace(national_prefix_pattern, national_prefix_transform_rule);
	}
	// Else, no transformation is necessary,
	// and just strip the national prefix.
	else {
			national_significant_number = number.slice(national_prefix_matcher[0].length);
		}

	// Verify the parsed national (significant) number for this country
	var national_number_rule = new RegExp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["k" /* get_national_number_pattern */])(country_metadata));

	// If the original number (before stripping national prefix) was viable,
	// and the resultant number is not, then prefer the original phone number.
	// This is because for some countries (e.g. Russia) the same digit could be both
	// a national prefix and a leading digit of a valid national phone number,
	// like `8` is the national prefix for Russia and both
	// `8 800 555 35 35` and `800 555 35 35` are valid numbers.
	if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common__["a" /* matches_entirely */])(number, national_number_rule) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common__["a" /* matches_entirely */])(national_significant_number, national_number_rule)) {
		return number;
	}

	// Return the parsed national (significant) number
	return national_significant_number;
}

function find_country_code(country_phone_code, national_phone_number, metadata) {
	// Is always non-empty, because `country_phone_code` is always valid
	var possible_countries = metadata.country_phone_code_to_countries[country_phone_code];

	// If there's just one country corresponding to the country code,
	// then just return it, without further phone number digits validation.
	if (possible_countries.length === 1) {
		return possible_countries[0];
	}

	var _iteratorNormalCompletion2 = true;
	var _didIteratorError2 = false;
	var _iteratorError2 = undefined;

	try {
		for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(possible_countries), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
			var country_code = _step2.value;

			var country = metadata.countries[country_code];

			// Leading digits check would be the simplest one
			if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["n" /* get_leading_digits */])(country)) {
				if (national_phone_number && national_phone_number.search(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["n" /* get_leading_digits */])(country)) === 0) {
					return country_code;
				}
			}
			// Else perform full validation with all of those bulky
			// fixed-line/mobile/etc regular expressions.
			else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__get_number_type__["a" /* default */])({ phone: national_phone_number, country: country_code }, metadata)) {
					return country_code;
				}
		}
	} catch (err) {
		_didIteratorError2 = true;
		_iteratorError2 = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion2 && _iterator2.return) {
				_iterator2.return();
			}
		} finally {
			if (_didIteratorError2) {
				throw _iteratorError2;
			}
		}
	}
}

// export function is_national_prefix_required(national_number, country_metadata)
// {
// 	const format = choose_format_for_number(get_formats(country_metadata), national_number)
//
// 	if (format)
// 	{
// 		return get_format_national_prefix_is_mandatory_when_formatting(format, country_metadata)
// 	}
// }

// Sort out arguments
function sort_out_arguments(first_argument, second_argument, third_argument) {
	var text = void 0;
	var options = void 0;
	var metadata = void 0;

	// Normalize numerical `value`.
	// https://github.com/catamphetamine/libphonenumber-js/issues/142
	if (typeof first_argument === 'number') {
		first_argument = String(first_argument);
	}

	if (typeof first_argument === 'string') {
		text = first_argument;
	}

	// Covert `resrict` country to an `options` object
	if (typeof second_argument === 'string') {
		var restrict_to_country = second_argument;

		options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, default_options, {

			country: {
				restrict: restrict_to_country
			}
		});

		metadata = third_argument;
	} else {
		// Differentiate `metadata` from `options`
		if (second_argument && second_argument.countries) {
			metadata = second_argument;
		} else {
			options = second_argument;
			metadata = third_argument;
		}
	}

	// Sanity check
	if (!metadata) {
		throw new Error('Metadata not passed');
	}

	return { text: text, options: options, metadata: metadata };
}
//# sourceMappingURL=parse.js.map

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.connect = exports.Provider = undefined;

var _Provider = __webpack_require__(417);

var _Provider2 = _interopRequireDefault(_Provider);

var _connect = __webpack_require__(418);

var _connect2 = _interopRequireDefault(_connect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports.Provider = _Provider2["default"];
exports.connect = _connect2["default"];

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(43), __webpack_require__(235), __webpack_require__(394), __webpack_require__(380), __webpack_require__(381), __webpack_require__(382), __webpack_require__(383), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/core-js/object/keys'), require('babel-runtime/core-js/set'), require('node-polyglot'), require('./en.json'), require('./es.json'), require('./mobilePhrases/en.json'), require('./mobilePhrases/es.json'), require('../components/utils'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.keys, global.set, global.nodePolyglot, global.en, global.es, global.en, global.es, global.utils);
    global.index = mod.exports;
  }
})(this, function (exports, _keys, _set, _nodePolyglot, _en, _es, _en3, _es3, _utils) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.parseI18nWithXmlTags = exports.initializeI18n = undefined;

  var _keys2 = _interopRequireDefault(_keys);

  var _set2 = _interopRequireDefault(_set);

  var _nodePolyglot2 = _interopRequireDefault(_nodePolyglot);

  var _en2 = _interopRequireDefault(_en);

  var _es2 = _interopRequireDefault(_es);

  var _en4 = _interopRequireDefault(_en3);

  var _es4 = _interopRequireDefault(_es3);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var defaultLocaleTag = 'en';

  // Language tags should follow the IETF's BCP 47 guidelines, link below:
  //https://www.w3.org/International/questions/qa-lang-2or3
  // Generally it should be a two or three charaters tag (language) followed by a two/three characters subtag (region), if needed.
  var availableTransations = { en: _en2.default, es: _es2.default };

  var mobileTranslations = {
    en: _en4.default,
    es: _es4.default
  };

  var defaultLanguage = function defaultLanguage() {
    var polyglot = new _nodePolyglot2.default({ onMissingKey: function onMissingKey() {
        return null;
      } });
    return extendPolyglot(defaultLocaleTag, polyglot, availableTransations[defaultLocaleTag], mobileTranslations[defaultLocaleTag]);
  };

  var extendPolyglot = function extendPolyglot(locale, polyglot, phrases, mobilePhrases) {
    polyglot.locale(locale);
    polyglot.extend(phrases);
    if (!_utils.isDesktop) {
      polyglot.extend(mobilePhrases);
    }
    return polyglot;
  };

  var findMissingKeys = function findMissingKeys(defaultKeys, customKeys) {
    var newTranslationsSet = new _set2.default(customKeys);
    var missingKeys = defaultKeys.filter(function (element) {
      return !newTranslationsSet.has(element);
    });
    if (missingKeys.length) {
      console.warn('Missing keys:', missingKeys);
    }
  };

  var polyglotFormatKeys = function polyglotFormatKeys(phrases) {
    return (0, _keys2.default)(new _nodePolyglot2.default({ phrases: phrases }).phrases);
  };

  var verifyKeysPresence = function verifyKeysPresence(phrases, polyglot) {
    var defaultKeys = (0, _keys2.default)(polyglot.phrases);
    var customKeys = polyglotFormatKeys(phrases);
    findMissingKeys(defaultKeys, customKeys);
  };

  var trySupportedLanguage = function trySupportedLanguage(language, polyglot) {
    if (availableTransations[language]) {
      return extendPolyglot(language, polyglot, availableTransations[language], mobileTranslations[language]);
    }
    console.warn('Locale not supported');
  };

  var useCustomTranslations = function useCustomTranslations(language, polyglot) {
    verifyKeysPresence(language.phrases, polyglot);
    var newPolyglot = trySupportedLanguage(language.locale, polyglot) || polyglot;
    return extendPolyglot(language.locale, newPolyglot, language.phrases, language.mobilePhrases);
  };

  var overrideTranslations = function overrideTranslations(language, polyglot) {
    if (typeof language === 'string') {
      return trySupportedLanguage(language, polyglot);
    }
    return useCustomTranslations(language, polyglot);
  };

  var initializeI18n = exports.initializeI18n = function initializeI18n(language) {
    var polyglot = defaultLanguage();
    if (!language) return polyglot;
    return overrideTranslations(language, polyglot) || polyglot;
  };

  var parseI18nWithXmlTags = exports.parseI18nWithXmlTags = function parseI18nWithXmlTags(i18n, translationKey, handleTag) {
    return (0, _utils.parseTags)(i18n.t(translationKey), handleTag);
  };
});

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(256), __esModule: true };

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(7);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(6);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(79);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(79);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, URL, webkitURL, FileReader */

;(function ($) {
  'use strict'

  // Loads an image for a given File object.
  // Invokes the callback with an img or optional canvas
  // element (if supported by the browser) as parameter:
  function loadImage (file, callback, options) {
    var img = document.createElement('img')
    var url
    img.onerror = function (event) {
      return loadImage.onerror(img, event, file, callback, options)
    }
    img.onload = function (event) {
      return loadImage.onload(img, event, file, callback, options)
    }
    if (typeof file === 'string') {
      loadImage.fetchBlob(file, function (blob) {
        if (blob) {
          file = blob
          url = loadImage.createObjectURL(file)
        } else {
          url = file
          if (options && options.crossOrigin) {
            img.crossOrigin = options.crossOrigin
          }
        }
        img.src = url
      }, options)
      return img
    } else if (loadImage.isInstanceOf('Blob', file) ||
        // Files are also Blob instances, but some browsers
        // (Firefox 3.6) support the File API but not Blobs:
        loadImage.isInstanceOf('File', file)) {
      url = img._objectURL = loadImage.createObjectURL(file)
      if (url) {
        img.src = url
        return img
      }
      return loadImage.readFile(file, function (e) {
        var target = e.target
        if (target && target.result) {
          img.src = target.result
        } else if (callback) {
          callback(e)
        }
      })
    }
  }
  // The check for URL.revokeObjectURL fixes an issue with Opera 12,
  // which provides URL.createObjectURL but doesn't properly implement it:
  var urlAPI = (window.createObjectURL && window) ||
                (window.URL && URL.revokeObjectURL && URL) ||
                (window.webkitURL && webkitURL)

  function revokeHelper (img, options) {
    if (img._objectURL && !(options && options.noRevoke)) {
      loadImage.revokeObjectURL(img._objectURL)
      delete img._objectURL
    }
  }

  // If the callback given to this function returns a blob, it is used as image
  // source instead of the original url and overrides the file argument used in
  // the onload and onerror event callbacks:
  loadImage.fetchBlob = function (url, callback, options) {
    callback()
  }

  loadImage.isInstanceOf = function (type, obj) {
    // Cross-frame instanceof check
    return Object.prototype.toString.call(obj) === '[object ' + type + ']'
  }

  loadImage.transform = function (img, options, callback, file, data) {
    callback(img, data)
  }

  loadImage.onerror = function (img, event, file, callback, options) {
    revokeHelper(img, options)
    if (callback) {
      callback.call(img, event)
    }
  }

  loadImage.onload = function (img, event, file, callback, options) {
    revokeHelper(img, options)
    if (callback) {
      loadImage.transform(img, options, callback, file, {})
    }
  }

  loadImage.createObjectURL = function (file) {
    return urlAPI ? urlAPI.createObjectURL(file) : false
  }

  loadImage.revokeObjectURL = function (url) {
    return urlAPI ? urlAPI.revokeObjectURL(url) : false
  }

  // Loads a given File object via FileReader interface,
  // invokes the callback with the event object (load or error).
  // The result can be read via event.target.result:
  loadImage.readFile = function (file, callback, method) {
    if (window.FileReader) {
      var fileReader = new FileReader()
      fileReader.onload = fileReader.onerror = callback
      method = method || 'readAsDataURL'
      if (fileReader[method]) {
        fileReader[method](file)
        return fileReader
      }
    }
    return false
  }

  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return loadImage
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    module.exports = loadImage
  } else {
    $.loadImage = loadImage
  }
}(window))


/***/ }),
/* 48 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(281)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(87)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;

var _createStore = __webpack_require__(164);

var _createStore2 = _interopRequireDefault(_createStore);

var _combineReducers = __webpack_require__(426);

var _combineReducers2 = _interopRequireDefault(_combineReducers);

var _bindActionCreators = __webpack_require__(425);

var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);

var _applyMiddleware = __webpack_require__(424);

var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);

var _compose = __webpack_require__(163);

var _compose2 = _interopRequireDefault(_compose);

var _warning = __webpack_require__(165);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  (0, _warning2["default"])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}

exports.createStore = _createStore2["default"];
exports.combineReducers = _combineReducers2["default"];
exports.bindActionCreators = _bindActionCreators2["default"];
exports.applyMiddleware = _applyMiddleware2["default"];
exports.compose = _compose2["default"];

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(115), __webpack_require__(227), __webpack_require__(231)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./store/store'), require('./store/actions'), require('./store/selectors'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.store, global.actions, global.selectors);
    global.index = mod.exports;
  }
})(this, function (exports, _store, _actions, _selectors) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.selectors = exports.unboundActions = exports.actions = exports.store = undefined;

  var _store2 = _interopRequireDefault(_store);

  var selectors = _interopRequireWildcard(_selectors);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.store = _store2.default;
  exports.actions = _actions.actions;
  exports.unboundActions = _actions.unboundActions;
  exports.selectors = selectors;
});

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(56), __webpack_require__(3), __webpack_require__(7), __webpack_require__(6), __webpack_require__(4), __webpack_require__(5), __webpack_require__(0), __webpack_require__(423), __webpack_require__(199), __webpack_require__(15), __webpack_require__(74), __webpack_require__(185), __webpack_require__(189), __webpack_require__(198), __webpack_require__(187), __webpack_require__(188), __webpack_require__(107), __webpack_require__(8), __webpack_require__(11), __webpack_require__(104)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/core-js/array/includes'), require('babel-runtime/core-js/object/define-property'), require('babel-runtime/core-js/object/set-prototype-of'), require('babel-runtime/core-js/object/create'), require('babel-runtime/core-js/object/get-prototype-of'), require('react'), require('preact'), require('react-webcam-onfido'), require('../Overlay'), require('../Title'), require('../Error'), require('./AutoCapture'), require('./Photo'), require('../Liveness'), require('./Permissions/Primer'), require('./Permissions/Recover'), require('../CustomFileInput'), require('../utils'), require('classnames'), require('./style.css'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.includes, global.defineProperty, global.setPrototypeOf, global.create, global.getPrototypeOf, global.react, global.preact, global.reactWebcamOnfido, global.Overlay, global.Title, global.Error, global.AutoCapture, global.Photo, global.Liveness, global.Primer, global.Recover, global.CustomFileInput, global.utils, global.classnames, global.style);
    global.index = mod.exports;
  }
})(this, function (exports, _includes, _defineProperty2, _setPrototypeOf, _create, _getPrototypeOf, _react, _preact, _reactWebcamOnfido, _Overlay, _Title, _Error, _AutoCapture, _Photo, _Liveness, _Primer, _Recover, _CustomFileInput, _utils, _classnames, _style) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.CameraPure = exports.CameraActions = undefined;

  var _includes2 = _interopRequireDefault(_includes);

  var _defineProperty3 = _interopRequireDefault(_defineProperty2);

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create2 = _interopRequireDefault(_create);

  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

  var React = _interopRequireWildcard(_react);

  var _reactWebcamOnfido2 = _interopRequireDefault(_reactWebcamOnfido);

  var _Title2 = _interopRequireDefault(_Title);

  var _Error2 = _interopRequireDefault(_Error);

  var _AutoCapture2 = _interopRequireDefault(_AutoCapture);

  var _Photo2 = _interopRequireDefault(_Photo);

  var _Liveness2 = _interopRequireDefault(_Liveness);

  var _Primer2 = _interopRequireDefault(_Primer);

  var _Recover2 = _interopRequireDefault(_Recover);

  var _CustomFileInput2 = _interopRequireDefault(_CustomFileInput);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _style2 = _interopRequireDefault(_style);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      (0, _defineProperty3.default)(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty3.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var CameraActions = exports.CameraActions = function CameraActions(_ref) {
    var children = _ref.children;

    return (0, _preact.h)(
      'div',
      { className: _style2.default.captureActions },
      children
    );
  };

  var CameraError = function (_React$Component) {
    _inherits(CameraError, _React$Component);

    function CameraError() {
      var _ref2;

      var _temp, _this, _ret;

      _classCallCheck(this, CameraError);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = CameraError.__proto__ || (0, _getPrototypeOf2.default)(CameraError)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
        isDimissed: false
      }, _this.handleFileInputClick = function () {
        if (_this.props.cameraError.type === 'warning') {
          _this.props.trackScreen('fallback_triggered');
        }
      }, _this.basicCameraFallback = function (text) {
        return (0, _preact.h)(
          _CustomFileInput2.default,
          {
            className: _style2.default.fallbackLink,
            onChange: _this.props.onUploadFallback,
            onClick: _this.handleFileInputClick,
            accept: 'image/*',
            capture: _this.props.method === 'face' ? 'user' : true
          },
          text
        );
      }, _this.crossDeviceFallback = function (text) {
        return (0, _preact.h)(
          'span',
          { onClick: function onClick() {
              return _this.props.changeFlowTo('crossDeviceSteps');
            }, className: _style2.default.fallbackLink },
          text
        );
      }, _this.defaultFallback = _utils.isDesktop ? _this.crossDeviceFallback : _this.basicCameraFallback, _this.handleDismiss = function () {
        return _this.setState({ isDimissed: true });
      }, _this.render = function () {
        var _this$props = _this.props,
            cameraError = _this$props.cameraError,
            cameraErrorHasBackdrop = _this$props.cameraErrorHasBackdrop,
            i18n = _this$props.i18n,
            _this$props$cameraErr = _this$props.cameraErrorFallback,
            cameraErrorFallback = _this$props$cameraErr === undefined ? _this.defaultFallback : _this$props$cameraErr,
            cameraErrorIsDismissible = _this$props.cameraErrorIsDismissible;

        return !_this.state.isDimissed && (0, _preact.h)(
          'div',
          { className: (0, _classnames2.default)(_style2.default.errorContainer, _style2.default[cameraError.type + 'ContainerType'], _defineProperty({}, _style2.default.errorHasBackdrop, cameraErrorHasBackdrop)) },
          (0, _preact.h)(_Error2.default, {
            className: _style2.default.errorMessage,
            i18n: i18n,
            error: cameraError,
            isDismissible: cameraErrorIsDismissible,
            onDismiss: _this.handleDismiss,
            renderInstruction: function renderInstruction(str) {
              return (0, _utils.parseTags)(str, function (_ref3) {
                var text = _ref3.text;
                return cameraErrorFallback(text);
              });
            }
          })
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CameraError, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (nextProps.cameraError.name !== this.props.cameraError.name) {
          this.setState({ isDimissed: false });
        }
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.props.cameraError.type === 'error') {
          this.props.trackScreen('camera_error');
        }
      }
    }]);

    return CameraError;
  }(React.Component);

  // Specify just a camera height (no width) because on safari if you specify both
  // height and width you will hit an OverconstrainedError if the camera does not
  // support the precise resolution.

  var CameraPure = exports.CameraPure = function CameraPure(_ref4) {
    var _classNames2;

    var method = _ref4.method,
        title = _ref4.title,
        subTitle = _ref4.subTitle,
        onUploadFallback = _ref4.onUploadFallback,
        hasError = _ref4.hasError,
        onUserMedia = _ref4.onUserMedia,
        onFailure = _ref4.onFailure,
        webcamRef = _ref4.webcamRef,
        isFullScreen = _ref4.isFullScreen,
        i18n = _ref4.i18n,
        isWithoutHole = _ref4.isWithoutHole,
        className = _ref4.className,
        video = _ref4.video,
        changeFlowTo = _ref4.changeFlowTo,
        trackScreen = _ref4.trackScreen,
        cameraError = _ref4.cameraError,
        cameraErrorFallback = _ref4.cameraErrorFallback,
        cameraErrorHasBackdrop = _ref4.cameraErrorHasBackdrop,
        cameraErrorIsDismissible = _ref4.cameraErrorIsDismissible;
    return (0, _preact.h)(
      'div',
      { className: (0, _classnames2.default)(_style2.default.camera, className) },
      (0, _preact.h)(_Title2.default, _extends({ title: title, subTitle: subTitle, isFullScreen: isFullScreen }, { smaller: true })),
      (0, _preact.h)(
        'div',
        { className: (0, _classnames2.default)(_style2.default.container, (_classNames2 = {}, _defineProperty(_classNames2, _style2.default.fullScreenContainer, isFullScreen), _defineProperty(_classNames2, _style2.default.autoCaptureContainer, !isFullScreen), _classNames2)) },
        hasError ? (0, _preact.h)(CameraError, {
          cameraError: cameraError, cameraErrorHasBackdrop: cameraErrorHasBackdrop, cameraErrorFallback: cameraErrorFallback,
          onUploadFallback: onUploadFallback, i18n: i18n, trackScreen: trackScreen, changeFlowTo: changeFlowTo, method: method,
          cameraErrorIsDismissible: cameraErrorIsDismissible
        }) : null,
        (0, _preact.h)(
          'div',
          { className: _style2.default.webcamContainer },
          (0, _preact.h)(_reactWebcamOnfido2.default, _extends({
            className: _style2.default.video,
            audio: !!video,
            height: 720,
            facingMode: "user"
          }, { onUserMedia: onUserMedia, ref: webcamRef, onFailure: onFailure }))
        ),
        (0, _preact.h)(_Overlay.Overlay, { method: method, isFullScreen: isFullScreen, isWithoutHole: isWithoutHole })
      )
    );
  };

  var permissionErrors = ['PermissionDeniedError', 'NotAllowedError', 'NotFoundError'];

  var Camera = function (_React$Component2) {
    _inherits(Camera, _React$Component2);

    function Camera() {
      var _ref5;

      var _temp2, _this2, _ret2;

      _classCallCheck(this, Camera);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref5 = Camera.__proto__ || (0, _getPrototypeOf2.default)(Camera)).call.apply(_ref5, [this].concat(args))), _this2), _this2.webcam = null, _this2.state = {
        hasError: false,
        hasMediaStream: false,
        hasGrantedPermission: undefined,
        hasSeenPermissionsPrimer: false,
        cameraError: {}
      }, _this2.setPermissionsPrimerSeen = function () {
        _this2.setState({ hasSeenPermissionsPrimer: true });
      }, _this2.renderCamera = function () {
        var props = _extends({}, _this2.props, {
          onUserMedia: _this2.handleUserMedia,
          onFailure: _this2.handleWebcamFailure,
          hasError: _this2.state.hasError,
          hasMediaStream: _this2.state.hasMediaStream,
          cameraError: _this2.state.cameraError,
          hasGrantedPermission: _this2.state.hasGrantedPermission
        });

        if (_this2.props.autoCapture) return (0, _preact.h)(_AutoCapture2.default, props);
        return _this2.props.liveness ? (0, _preact.h)(_Liveness2.default, props) : (0, _preact.h)(_Photo2.default, props);
      }, _this2.handleUserMedia = function () {
        _this2.setState({ hasGrantedPermission: true, hasMediaStream: true });
      }, _this2.handleWebcamFailure = function (error) {
        // $FlowFixMe
        if ((0, _includes2.default)(permissionErrors, error.name)) {
          _this2.setState({ hasGrantedPermission: false });
        } else {
          _this2.setState({ hasError: true, cameraError: { name: 'CAMERA_NOT_WORKING', type: 'error' } });
        }
        _this2.props.onFailure();
      }, _this2.reload = function () {
        return window.location.reload();
      }, _this2.render = function () {
        var _this2$state = _this2.state,
            hasSeenPermissionsPrimer = _this2$state.hasSeenPermissionsPrimer,
            hasGrantedPermission = _this2$state.hasGrantedPermission;

        return hasGrantedPermission === false ? (0, _preact.h)(_Recover2.default, _extends({}, _this2.props, { onRefresh: _this2.reload })) : hasGrantedPermission || hasSeenPermissionsPrimer ? _this2.renderCamera() : (0, _preact.h)(_Primer2.default, _extends({}, _this2.props, {
          onNext: _this2.setPermissionsPrimerSeen
        }));
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    _createClass(Camera, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this3 = this;

        this.props.trackScreen('camera');
        (0, _utils.checkIfWebcamPermissionGranted)(function (hasGrantedPermission) {
          return _this3.setState({ hasGrantedPermission: hasGrantedPermission || undefined });
        });
        this.useFullScreenIfNeeded();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        if (prevState.hasGrantedPermission !== this.state.hasGrantedPermission || prevState.hasSeenPermissionsPrimer !== this.state.hasSeenPermissionsPrimer) {
          this.useFullScreenIfNeeded();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.props.useFullScreen(false);
      }
    }, {
      key: 'useFullScreenIfNeeded',
      value: function useFullScreenIfNeeded() {
        var method = this.props.method;
        var _state = this.state,
            hasSeenPermissionsPrimer = _state.hasSeenPermissionsPrimer,
            hasGrantedPermission = _state.hasGrantedPermission;

        var needsFullScreen = method === 'face' && hasGrantedPermission !== false && (hasGrantedPermission || hasSeenPermissionsPrimer);
        this.props.useFullScreen(needsFullScreen);
      }
    }]);

    return Camera;
  }(React.Component);

  Camera.defaultProps = {
    onFailure: function onFailure() {},
    useFullScreen: function useFullScreen() {}
  };
  exports.default = Camera;
});

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(0), __webpack_require__(452)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('preact'), require('./style.css'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.preact, global.style);
    global.index = mod.exports;
  }
})(this, function (module, exports, _preact, _style) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _style2 = _interopRequireDefault(_style);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Spinner = function Spinner() {
    return (0, _preact.h)(
      'div',
      { className: _style2.default.loader },
      (0, _preact.h)(
        'div',
        { className: _style2.default.inner },
        (0, _preact.h)('div', null),
        (0, _preact.h)('div', null),
        (0, _preact.h)('div', null)
      )
    );
  };

  exports.default = Spinner;
  module.exports = exports['default'];
});

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(27)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require("babel-runtime/core-js/array/from"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.from);
    global.func = mod.exports;
  }
})(this, function (exports, _from) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.compose = exports.identity = exports.tick = exports.asyncFunc = undefined;

  var _from2 = _interopRequireDefault(_from);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    } else {
      return (0, _from2.default)(arr);
    }
  }

  var asyncFunc = exports.asyncFunc = function asyncFunc(fn, args, callback) {
    return tick(function () {
      return callback(fn.apply(undefined, _toConsumableArray(args)));
    });
  };

  var tick = exports.tick = function tick(fn) {
    return requestAnimationFrame(fn);
  };

  var identity = exports.identity = function identity(val) {
    return val;
  };

  var compose = exports.compose = function compose() {
    for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
      fns[_key] = arguments[_key];
    }

    return fns.reduceRight(function (prev, next) {
      return function () {
        return next(prev.apply(undefined, arguments));
      };
    }, identity);
  };
});

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(247), __esModule: true };

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(250), __esModule: true };

/***/ }),
/* 58 */
/***/ (function(module, exports) {


module.exports = function(a, b){
  var fn = function(){};
  fn.prototype = b.prototype;
  a.prototype = new fn;
  a.prototype.constructor = a;
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(30);
var call = __webpack_require__(127);
var isArrayIter = __webpack_require__(125);
var anObject = __webpack_require__(24);
var toLength = __webpack_require__(62);
var getIterFn = __webpack_require__(97);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(24);
var dPs = __webpack_require__(273);
var enumBugKeys = __webpack_require__(85);
var IE_PROTO = __webpack_require__(91)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(123)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(269).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(18).f;
var has = __webpack_require__(31);
var TAG = __webpack_require__(17)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(93);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(288);
var global = __webpack_require__(20);
var hide = __webpack_require__(26);
var Iterators = __webpack_require__(35);
var TO_STRING_TAG = __webpack_require__(17)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matches_entirely;
// Checks whether the entire input sequence can be matched
// against the regular expression.
function matches_entirely() {
	var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	var regular_expression = arguments[1];

	if (typeof regular_expression === 'string') {
		regular_expression = '^(?:' + regular_expression + ')$';
	}

	var matched_groups = text.match(regular_expression);
	return matched_groups && matched_groups[0].length === text.length;
}
//# sourceMappingURL=common.js.map

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = format;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FIRST_GROUP_PATTERN; });
/* harmony export (immutable) */ __webpack_exports__["b"] = format_national_number_using_format;
/* unused harmony export format_national_number */
/* unused harmony export choose_format_for_number */
/* harmony export (immutable) */ __webpack_exports__["d"] = local_to_international_style;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parse__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(39);

// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of 17th November, 2016.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js







// Formats a phone number
//
// Example use cases:
//
// ```js
// format('8005553535', 'RU', 'International')
// format('8005553535', 'RU', 'International', metadata)
// format({ phone: '8005553535', country: 'RU' }, 'International')
// format({ phone: '8005553535', country: 'RU' }, 'International', metadata)
// format('+78005553535', 'National')
// format('+78005553535', 'National', metadata)
// ```
//
function format(first_argument, second_argument, third_argument, fourth_argument) {
	var _sort_out_arguments = sort_out_arguments(first_argument, second_argument, third_argument, fourth_argument),
	    input = _sort_out_arguments.input,
	    format_type = _sort_out_arguments.format_type,
	    metadata = _sort_out_arguments.metadata;

	var country_metadata = void 0;

	if (input.country) {
		country_metadata = metadata.countries[input.country];
	}

	var _parse_phone_number_a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__parse__["g" /* parse_phone_number_and_country_phone_code */])(input.phone, metadata),
	    country_phone_code = _parse_phone_number_a.country_phone_code,
	    number = _parse_phone_number_a.number;

	if (country_phone_code) {
		// Check country restriction
		if (input.country && country_metadata && country_phone_code !== __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* get_phone_code */])(country_metadata)) {
			return input.phone;
		}

		country_metadata = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["f" /* get_metadata_by_country_phone_code */])(country_phone_code, metadata);
	}

	if (!country_metadata) {
		return input.phone;
	}

	switch (format_type) {
		case 'International':
			if (!number) {
				return '+' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* get_phone_code */])(country_metadata);
			}
			var national_number = format_national_number(number, 'International', false, country_metadata);
			return '+' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* get_phone_code */])(country_metadata) + ' ' + national_number;

		case 'International_plaintext':
			return '+' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* get_phone_code */])(country_metadata) + input.phone;

		case 'National':
			if (!number) {
				return '';
			}
			return format_national_number(number, 'National', false, country_metadata);
	}
}

// This was originally set to $1 but there are some countries for which the
// first group is not used in the national pattern (e.g. Argentina) so the $1
// group does not match correctly.  Therefore, we use \d, so that the first
// group actually used in the pattern will be matched.
var FIRST_GROUP_PATTERN = /(\$\d)/;

function format_national_number_using_format(number, format, international, enforce_national_prefix, country_metadata) {
	var format_pattern_matcher = new RegExp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["e" /* get_format_pattern */])(format));

	var national_prefix_formatting_rule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["h" /* get_format_national_prefix_formatting_rule */])(format, country_metadata);

	// National prefix is omitted if there's no national prefix formatting rule
	// set for this country, or when this rule is set but
	// national prefix is optional for this phone number format
	// (and it is not enforced explicitly)
	var national_prefix_may_be_omitted = !national_prefix_formatting_rule || national_prefix_formatting_rule && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["o" /* get_format_national_prefix_is_optional_when_formatting */])(format, country_metadata) && !enforce_national_prefix;

	if (!international && !national_prefix_may_be_omitted) {
		return number.replace(format_pattern_matcher, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["i" /* get_format_format */])(format).replace(FIRST_GROUP_PATTERN, national_prefix_formatting_rule));
	}

	var formatted_number = number.replace(format_pattern_matcher, international ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* get_format_international_format */])(format) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["i" /* get_format_format */])(format));

	if (international) {
		return local_to_international_style(formatted_number);
	}

	return formatted_number;
}

function format_national_number(number, format_as, enforce_national_prefix, country_metadata) {
	var format = choose_format_for_number(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* get_formats */])(country_metadata), number);

	if (!format) {
		return number;
	}

	return format_national_number_using_format(number, format, format_as === 'International', enforce_national_prefix, country_metadata);
}

function choose_format_for_number(available_formats, national_number) {
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(available_formats), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var _format = _step.value;

			// Validate leading digits
			if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* get_format_leading_digits_patterns */])(_format).length > 0) {
				// The last leading_digits_pattern is used here, as it is the most detailed
				var last_leading_digits_pattern = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* get_format_leading_digits_patterns */])(_format)[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* get_format_leading_digits_patterns */])(_format).length - 1];

				// If leading digits don't match then move on to the next phone number format
				if (national_number.search(last_leading_digits_pattern) !== 0) {
					continue;
				}
			}

			// Check that the national number matches the phone number format regular expression
			if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* matches_entirely */])(national_number, new RegExp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["e" /* get_format_pattern */])(_format)))) {
				return _format;
			}
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}
}

// Removes brackets and replaces dashes with spaces.
//
// E.g. "(999) 111-22-33" -> "999 111 22 33"
//
function local_to_international_style(local) {
	return local.replace(new RegExp('[' + __WEBPACK_IMPORTED_MODULE_2__parse__["b" /* VALID_PUNCTUATION */] + ']+', 'g'), ' ').trim();
}

// Sort out arguments
function sort_out_arguments() {
	var first_argument = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	var second_argument = arguments[1];
	var third_argument = arguments[2];
	var fourth_argument = arguments[3];

	var input = void 0;
	var format_type = void 0;
	var metadata = void 0;

	// Sort out arguments
	if (typeof first_argument === 'string') {
		// If country code is supplied
		if (typeof third_argument === 'string') {
			// Will be `parse()`d later in code
			input = {
				phone: first_argument,
				country: second_argument
			};

			format_type = third_argument;
			metadata = fourth_argument;
		}
		// Just an international phone number is supplied
		else {
				// Will be `parse()`d later in code
				input = {
					phone: first_argument
				};

				if (typeof second_argument !== 'string') {
					throw new Error('Format type argument not passed for `format()`');
				}

				format_type = second_argument;
				metadata = third_argument;
			}
	} else {
		input = first_argument;
		format_type = second_argument;
		metadata = third_argument;
	}

	// Sanity check
	if (!metadata) {
		throw new Error('Metadata not passed');
	}

	switch (format_type) {
		case 'International':
		case 'International_plaintext':
		case 'National':
			break;
		default:
			throw new Error('Unknown format type argument passed to "format()": "' + format_type + '"');
	}

	return { input: input, format_type: format_type, metadata: metadata };
}
//# sourceMappingURL=format.js.map

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = get_number_type;
/* unused harmony export is_of_type */
/* harmony export (immutable) */ __webpack_exports__["b"] = sort_out_arguments;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parse__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__metadata__ = __webpack_require__(39);






// Finds out national phone number type (fixed line, mobile, etc)
function get_number_type(first_argument, second_argument, third_argument) {
	var _sort_out_arguments = sort_out_arguments(first_argument, second_argument, third_argument),
	    input = _sort_out_arguments.input,
	    metadata = _sort_out_arguments.metadata;

	// Sanity check


	if (!metadata) {
		throw new Error('Metadata not passed');
	}

	// When no input was passed
	if (!input) {
		return;
	}

	// When `parse()` returned `{}`
	// meaning that the phone number is not a valid one.
	if (!input.country) {
		return;
	}

	var national_number = input.phone;
	var country_metadata = metadata.countries[input.country];

	// The following is copy-pasted from the original function:
	// https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835

	// Is this national number even valid for this country
	if (!is_of_type(national_number, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__metadata__["k" /* get_national_number_pattern */])(country_metadata))) {
		return; // 'UNKNOWN'
	}

	if (is_of_type(national_number, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__metadata__["q" /* get_type_premium_rate */])(country_metadata))) {
		return 'PREMIUM_RATE';
	}

	if (is_of_type(national_number, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__metadata__["r" /* get_type_toll_free */])(country_metadata))) {
		return 'TOLL_FREE';
	}

	/* istanbul ignore if */
	if (is_of_type(national_number, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__metadata__["s" /* get_type_shared_cost */])(country_metadata))) {
		return 'SHARED_COST';
	}

	/* istanbul ignore if */
	if (is_of_type(national_number, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__metadata__["t" /* get_type_voip */])(country_metadata))) {
		return 'VOIP';
	}

	if (is_of_type(national_number, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__metadata__["u" /* get_type_personal_number */])(country_metadata))) {
		return 'PERSONAL_NUMBER';
	}

	/* istanbul ignore if */
	if (is_of_type(national_number, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__metadata__["v" /* get_type_pager */])(country_metadata))) {
		return 'PAGER';
	}

	/* istanbul ignore if */
	if (is_of_type(national_number, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__metadata__["w" /* get_type_uan */])(country_metadata))) {
		return 'UAN';
	}

	/* istanbul ignore if */
	if (is_of_type(national_number, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__metadata__["x" /* get_type_voice_mail */])(country_metadata))) {
		return 'VOICEMAIL';
	}

	// Is it fixed line number
	if (is_of_type(national_number, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__metadata__["y" /* get_type_fixed_line */])(country_metadata))) {
		// Because duplicate regular expressions are removed
		// to reduce metadata size, if there's no "mobile" pattern
		// then it means it was removed due to being a duplicate of some other pattern.
		//
		if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__metadata__["z" /* get_type_mobile */])(country_metadata)) {
			return 'FIXED_LINE_OR_MOBILE';
		}

		// Check if the number happens to qualify as both fixed line and mobile.
		// (no such country in the minimal metadata set)
		/* istanbul ignore if */
		if (is_of_type(national_number, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__metadata__["z" /* get_type_mobile */])(country_metadata))) {
			return 'FIXED_LINE_OR_MOBILE';
		}

		return 'FIXED_LINE';
	}

	if (is_of_type(national_number, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__metadata__["z" /* get_type_mobile */])(country_metadata))) {
		return 'MOBILE';
	}

	// return 'UNKNOWN'
}

function is_of_type(national_number, type) {
	// // Check if any possible number lengths are present;
	// // if so, we use them to avoid checking
	// // the validation pattern if they don't match.
	// // If they are absent, this means they match
	// // the general description, which we have
	// // already checked before a specific number type.
	// if (get_possible_lengths(type) &&
	// 	get_possible_lengths(type).indexOf(national_number.length) === -1)
	// {
	// 	return false
	// }

	// get_type_pattern(type) === type
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* matches_entirely */])(national_number, type);
}

// Sort out arguments
function sort_out_arguments(first_argument, second_argument, third_argument) {
	var input = void 0;
	var metadata = void 0;

	// Normalize numerical `value`.
	// https://github.com/catamphetamine/libphonenumber-js/issues/142
	if (typeof first_argument === 'number') {
		first_argument = String(first_argument);
	}

	if (typeof first_argument === 'string') {
		// If country code is supplied
		if (typeof second_argument === 'string' || second_argument === undefined) {
			metadata = third_argument;

			// `parse` extracts phone numbers from raw text,
			// therefore it will cut off all "garbage" characters,
			// while this `validate` function needs to verify
			// that the phone number contains no "garbage"
			// therefore the explicit `is_viable_phone_number` check.
			if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__parse__["j" /* is_viable_phone_number */])(first_argument)) {
				input = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__parse__["a" /* default */])(first_argument, second_argument, metadata);
			}
		}
		// Just an international phone number is supplied
		else {
				metadata = second_argument;

				// `parse` extracts phone numbers from raw text,
				// therefore it will cut off all "garbage" characters,
				// while this `validate` function needs to verify
				// that the phone number contains no "garbage"
				// therefore the explicit `is_viable_phone_number` check.
				if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__parse__["j" /* is_viable_phone_number */])(first_argument)) {
					input = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__parse__["a" /* default */])(first_argument, metadata);
				}
			}
	} else {
		// The `first_argument` must be a valid phone number
		// as a whole, not just a part of it which gets parsed here.
		if (first_argument && first_argument.phone && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__parse__["j" /* is_viable_phone_number */])(first_argument.phone)) {
			input = first_argument;
		}

		metadata = second_argument;
	}

	return { input: input, metadata: metadata };
}
//# sourceMappingURL=get number type.js.map

/***/ }),
/* 68 */
/***/ (function(module, exports) {

/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */

exports.encode = function (obj) {
  var str = '';

  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      if (str.length) str += '&';
      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
  }

  return str;
};

/**
 * Parses a simple querystring into an object
 *
 * @param {String} qs
 * @api private
 */

exports.decode = function(qs){
  var qry = {};
  var pairs = qs.split('&');
  for (var i = 0, l = pairs.length; i < l; i++) {
    var pair = pairs[i].split('=');
    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }
  return qry;
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(400)();
}


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(245), __esModule: true };

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(259), __esModule: true };

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(260), __esModule: true };

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(10), __webpack_require__(56), __webpack_require__(43), __webpack_require__(3), __webpack_require__(7), __webpack_require__(6), __webpack_require__(4), __webpack_require__(5), __webpack_require__(0), __webpack_require__(442), __webpack_require__(78), __webpack_require__(223), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/core-js/object/assign'), require('babel-runtime/core-js/array/includes'), require('babel-runtime/core-js/object/keys'), require('babel-runtime/core-js/object/define-property'), require('babel-runtime/core-js/object/set-prototype-of'), require('babel-runtime/core-js/object/create'), require('babel-runtime/core-js/object/get-prototype-of'), require('react'), require('preact'), require('./style.css'), require('../utils/string'), require('../utils/object'), require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.assign, global.includes, global.keys, global.defineProperty, global.setPrototypeOf, global.create, global.getPrototypeOf, global.react, global.preact, global.style, global.string, global.object, global.classnames);
    global.index = mod.exports;
  }
})(this, function (exports, _assign, _includes, _keys, _defineProperty, _setPrototypeOf, _create, _getPrototypeOf, _react, _preact, _style, _string, _object, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getDocumentTypeGroup = exports.PoADocumentSelector = exports.poaDocumentTypes = exports.IdentityDocumentSelector = exports.identityDocumentTypes = undefined;

  var _assign2 = _interopRequireDefault(_assign);

  var _includes2 = _interopRequireDefault(_includes);

  var _keys2 = _interopRequireDefault(_keys);

  var _defineProperty2 = _interopRequireDefault(_defineProperty);

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create2 = _interopRequireDefault(_create);

  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

  var React = _interopRequireWildcard(_react);

  var _style2 = _interopRequireDefault(_style);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty2.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var DocumentSelector = function (_Component) {
    _inherits(DocumentSelector, _Component);

    function DocumentSelector() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, DocumentSelector);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DocumentSelector.__proto__ || (0, _getPrototypeOf2.default)(DocumentSelector)).call.apply(_ref, [this].concat(args))), _this), _this.getOptions = function () {
        var _this$props = _this.props,
            i18n = _this$props.i18n,
            documentTypes = _this$props.documentTypes,
            defaultOptions = _this$props.defaultOptions;

        var defaultDocOptions = defaultOptions(i18n);

        var options = defaultDocOptions.filter(function (option) {
          return documentTypes && documentTypes[option.value];
        });
        // If no valid options passed, default to defaultDocOptions
        return options.length ? options : defaultDocOptions;
      }, _this.handleSelect = function (e, value) {
        e.stopPropagation();
        var _this$props2 = _this.props,
            setDocumentType = _this$props2.setDocumentType,
            nextStep = _this$props2.nextStep;

        setDocumentType(value);
        nextStep();
      }, _this.renderOption = function (option) {
        return (0, _preact.h)(
          'div',
          {
            'class': _style2.default.option,
            onClick: function onClick(e) {
              return _this.handleSelect(e, option.value);
            }
          },
          (0, _preact.h)('div', { className: _style2.default.icon + ' ' + _style2.default[option.icon] }),
          (0, _preact.h)(
            'div',
            { className: _style2.default.content },
            (0, _preact.h)(
              'div',
              { className: _style2.default.optionMain },
              (0, _preact.h)(
                'p',
                { className: _style2.default.label },
                option.label
              ),
              option.hint && (0, _preact.h)(
                'div',
                { className: _style2.default.hint },
                option.hint
              ),
              option.warning && (0, _preact.h)(
                'div',
                { className: _style2.default.warning },
                option.warning
              )
            ),
            option.eStatementAccepted && (0, _preact.h)(
              'div',
              { className: _style2.default.tag },
              _this.props.i18n.t('document_selector.proof_of_address.estatements_accepted')
            )
          )
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(DocumentSelector, [{
      key: 'render',
      value: function render() {
        var documentOptions = this.getOptions();
        var className = this.props.className;

        return (0, _preact.h)(
          'div',
          { className: (0, _classnames2.default)(_style2.default.wrapper, className) },
          documentOptions.map(this.renderOption)
        );
      }
    }]);

    return DocumentSelector;
  }(_preact.Component);

  var documentWithDefaultOptions = function documentWithDefaultOptions(types, group) {
    return function (props) {
      return (0, _preact.h)(DocumentSelector, _extends({}, props, {
        defaultOptions: function defaultOptions(i18n) {
          return (0, _keys2.default)(types).map(function (value) {
            var _types$value = types[value],
                _types$value$icon = _types$value.icon,
                icon = _types$value$icon === undefined ? 'icon-' + (0, _string.kebabCase)(value) : _types$value$icon,
                hint = _types$value.hint,
                warning = _types$value.warning,
                other = _objectWithoutProperties(_types$value, ['icon', 'hint', 'warning']);

            return _extends({}, other, {
              icon: icon,
              value: value,
              label: i18n.t(value),
              hint: hint ? i18n.t('document_selector.' + group + '.' + hint) : '',
              warning: warning ? i18n.t('document_selector.' + group + '.' + warning) : ''
            });
          });
        }
      }));
    };
  };

  var identityDocsOptions = {
    passport: {
      hint: 'passport_hint'
    },
    driving_licence: {
      hint: 'driving_licence_hint'
    },
    national_identity_card: {
      hint: 'national_identity_card_hint'
    }
  };

  var identityDocumentTypes = exports.identityDocumentTypes = (0, _keys2.default)(identityDocsOptions);

  var IdentityDocumentSelector = exports.IdentityDocumentSelector = documentWithDefaultOptions(identityDocsOptions, 'identity');

  var poaDocsOptions = {
    bank_building_society_statement: {
      eStatementAccepted: true
    },
    utility_bill: {
      hint: 'utility_bill_hint',
      warning: 'utility_bill_warning',
      eStatementAccepted: true
    },
    benefit_letters: {
      hint: 'benefits_letter_hint',
      icon: 'icon-letter'
    },
    council_tax: {
      icon: 'icon-letter'
    }
  };

  var poaDocumentTypes = exports.poaDocumentTypes = (0, _keys2.default)(poaDocsOptions);

  var PoADocumentSelector = exports.PoADocumentSelector = documentWithDefaultOptions(poaDocsOptions, 'proof_of_address');

  var getDocumentTypeGroup = exports.getDocumentTypeGroup = function getDocumentTypeGroup(documentType) {
    return (0, _object.find)({
      'proof_of_address': poaDocumentTypes,
      'identity': identityDocumentTypes
    }, function (types) {
      return (
        // $FlowFixMe
        (0, _includes2.default)(types, documentType)
      );
    });
  };
});

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(0), __webpack_require__(11), __webpack_require__(111), __webpack_require__(444), __webpack_require__(55)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('preact'), require('classnames'), require('../strings/errors'), require('./style.css'), require('components/utils/func'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.preact, global.classnames, global.errors, global.style, global.func);
    global.index = mod.exports;
  }
})(this, function (module, exports, _preact, _classnames, _errors, _style, _func) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _classnames2 = _interopRequireDefault(_classnames);

  var _style2 = _interopRequireDefault(_style);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var noop = function noop() {};

  var Error = function Error(_ref) {
    var className = _ref.className,
        error = _ref.error,
        i18n = _ref.i18n,
        withArrow = _ref.withArrow,
        _ref$renderMessage = _ref.renderMessage,
        renderMessage = _ref$renderMessage === undefined ? _func.identity : _ref$renderMessage,
        _ref$renderInstructio = _ref.renderInstruction,
        renderInstruction = _ref$renderInstructio === undefined ? _func.identity : _ref$renderInstructio,
        isDismissible = _ref.isDismissible,
        _ref$onDismiss = _ref.onDismiss,
        onDismiss = _ref$onDismiss === undefined ? noop : _ref$onDismiss;

    var errorList = (0, _errors.errors)(i18n);
    var errorText = errorList[error.name];
    var errorType = error.type === 'error' ? 'error' : 'warning';
    return (0, _preact.h)(
      'div',
      { className: (0, _classnames2.default)(_style2.default['container-' + errorType], className) },
      withArrow && (0, _preact.h)('div', { className: (0, _classnames2.default)(_style2.default.roundedTriangle, _style2.default[errorType + 'Triangle']) }),
      (0, _preact.h)(
        'div',
        { className: _style2.default.title },
        (0, _preact.h)('span', { className: _style2.default['title-icon-' + errorType] }),
        (0, _preact.h)(
          'span',
          { className: _style2.default['title-text'] },
          renderMessage(errorText.message)
        )
      ),
      (0, _preact.h)(
        'p',
        { className: _style2.default.instruction },
        renderInstruction(errorText.instruction)
      ),
      isDismissible && (0, _preact.h)('span', { className: _style2.default.dismiss, onClick: onDismiss })
    );
  };

  exports.default = Error;
  module.exports = exports['default'];
});

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(27), __webpack_require__(233)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require("babel-runtime/core-js/array/from"), require("babel-runtime/core-js/array/filter"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.from, global.filter);
    global.array = mod.exports;
  }
})(this, function (exports, _from, _filter) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.flatten = exports.wrapArray = exports.cleanFalsy = undefined;

  var _from2 = _interopRequireDefault(_from);

  var _filter2 = _interopRequireDefault(_filter);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    } else {
      return (0, _from2.default)(arr);
    }
  }

  var cleanFalsy = exports.cleanFalsy = function cleanFalsy(list) {
    return (0, _filter2.default)(list, function (n) {
      return n;
    });
  };

  var wrapArray = exports.wrapArray = function wrapArray(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [maybeArray];
  };

  var flatten = exports.flatten = function flatten() {
    for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
      values[_key] = arguments[_key];
    }

    return values.reduce(function (accum, arr) {
      return accum.concat.apply(accum, _toConsumableArray(wrapArray(arr)));
    }, []);
  };
});

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(466), __webpack_require__(55)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('supports-webp'), require('./func'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.supportsWebp, global.func);
    global.canvas = mod.exports;
  }
})(this, function (exports, _supportsWebp, _func) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.canvasToBase64Images = exports.toLossyImageDataUrl = exports.cloneCanvas = undefined;

  var _supportsWebp2 = _interopRequireDefault(_supportsWebp);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var cloneCanvas = exports.cloneCanvas = function cloneCanvas(oldCanvas) {
    var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    //create a new canvas
    var newCanvas = document.createElement('canvas');
    var context = newCanvas.getContext('2d');

    if (width === null) width = oldCanvas.width;
    if (height === null) height = oldCanvas.height;

    //set dimensions
    newCanvas.width = width;
    newCanvas.height = height;

    //apply the old canvas to the new one
    context.drawImage(oldCanvas, 0, 0, width, height);

    //return the new canvas
    return newCanvas;
  };

  var cloneLowResCanvas = function cloneLowResCanvas(canvas, maxHeight) {
    var width = canvas.width,
        height = canvas.height;

    var ratio = width / height;

    var lowHeight = Math.min(maxHeight, canvas.height);
    var lowWidth = lowHeight * ratio;

    return cloneCanvas(canvas, lowWidth, lowHeight);
  };

  var toDataUrl = function toDataUrl(type) {
    return function (canvas, callback) {
      return (0, _func.tick)(function () {
        return callback(canvas.toDataURL(type));
      });
    };
  };

  var browserSupportedLossyFormat = 'image/' + (_supportsWebp2.default ? 'webp' : 'jpeg');

  var toLossyImageDataUrl = exports.toLossyImageDataUrl = toDataUrl(browserSupportedLossyFormat);
  var toPngImageDataUrl = toDataUrl("image/png");

  var canvasToBase64Images = exports.canvasToBase64Images = function canvasToBase64Images(canvas, callback /*(imageLossy, imagePng)*/) {
    if (!canvas) return;

    var onPngImage = function onPngImage(imagePng) {
      return (0, _func.asyncFunc)(cloneLowResCanvas, [canvas, 200], function (lowResCanvas) {
        return onLowResCanvas(lowResCanvas, imagePng);
      });
    };

    var onLowResCanvas = function onLowResCanvas(lowResCanvas, imagePng) {
      return toLossyImageDataUrl(lowResCanvas, function (imageLossy) {
        return onLossyImage(imageLossy, imagePng);
      });
    };

    var onLossyImage = function onLossyImage(imageLossy, imagePng) {
      return callback(imageLossy, imagePng);
    };

    (0, _func.tick)(function () {
      return toPngImageDataUrl(canvas, onPngImage);
    });
  };
});

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.http = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var performHttpReq = exports.performHttpReq = function performHttpReq(_ref, onSuccess, onError) {
    var payload = _ref.payload,
        endpoint = _ref.endpoint,
        contentType = _ref.contentType,
        token = _ref.token;

    var request = new XMLHttpRequest();
    request.open('POST', endpoint);
    if (contentType) {
      request.setRequestHeader('Content-Type', contentType);
    }
    request.setRequestHeader('Authorization', token);

    request.onload = function () {
      if (request.status === 200 || request.status === 201) {
        onSuccess(JSON.parse(request.response));
      } else {
        onError(request);
      }
    };
    request.onerror = function () {
      return onError(request);
    };

    request.send(payload);
  };
});

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(55), __webpack_require__(75)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./func'), require('./array'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.func, global.array);
    global.string = mod.exports;
  }
})(this, function (exports, _func, _array) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.randomId = exports.humanCase = exports.startCase = exports.snakeCase = exports.kebabCase = exports.camelCase = undefined;


  var firstUpper = function firstUpper(str) {
    return str.substr(0, 1).toUpperCase() + str.substr(1);
  };

  var lower = function lower(str) {
    return str.toLowerCase();
  };

  var camelCaseRe = /([A-Z])/g;

  var unCamel = function unCamel(str) {
    return str.replace(camelCaseRe, ' $1').split(' ');
  };

  var compactFlat = (0, _func.compose)(_array.cleanFalsy, _array.flatten);

  var wordSplitRe = /[^\s_\-]+/g;

  var asWordsList = function asWordsList(str) {
    return compactFlat(((str || '').match(wordSplitRe) || []).map(unCamel)).map(lower);
  };

  var camelCase = exports.camelCase = function camelCase(str) {
    return asWordsList(str).reduce(function (accum, word, index) {
      return '' + accum + (index > 0 ? firstUpper : _func.identity)(word);
    }, '');
  };

  var kebabCase = exports.kebabCase = function kebabCase(str) {
    return asWordsList(str).join('-');
  };

  var snakeCase = exports.snakeCase = function snakeCase(str) {
    return asWordsList(str).join('_');
  };

  var startCase = exports.startCase = function startCase(str) {
    return asWordsList(str).map(firstUpper).join(' ');
  };

  var humanCase = exports.humanCase = function humanCase(str) {
    return firstUpper(asWordsList(str).join(' '));
  };

  var randomId = exports.randomId = function randomId() {
    return Math.random().toString(36).substring(7);
  };
});

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(72);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(71);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(30);
var IObject = __webpack_require__(86);
var toObject = __webpack_require__(37);
var toLength = __webpack_require__(62);
var asc = __webpack_require__(263);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(83);
var TAG = __webpack_require__(17)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 83 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 85 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(83);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(88);
var $export = __webpack_require__(16);
var redefine = __webpack_require__(135);
var hide = __webpack_require__(26);
var has = __webpack_require__(31);
var Iterators = __webpack_require__(35);
var $iterCreate = __webpack_require__(270);
var setToStringTag = __webpack_require__(61);
var getPrototypeOf = __webpack_require__(131);
var ITERATOR = __webpack_require__(17)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(63)('meta');
var isObject = __webpack_require__(21);
var has = __webpack_require__(31);
var setDesc = __webpack_require__(18).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(25)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 90 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(92)('keys');
var uid = __webpack_require__(63);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(20);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(21);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(20);
var core = __webpack_require__(12);
var LIBRARY = __webpack_require__(88);
var wksExt = __webpack_require__(96);
var defineProperty = __webpack_require__(18).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(17);


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(82);
var ITERATOR = __webpack_require__(17)('iterator');
var Iterators = __webpack_require__(35);
module.exports = __webpack_require__(12).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var parser = __webpack_require__(38);
var Emitter = __webpack_require__(34);

/**
 * Module exports.
 */

module.exports = Transport;

/**
 * Transport abstract constructor.
 *
 * @param {Object} options.
 * @api private
 */

function Transport (opts) {
  this.path = opts.path;
  this.hostname = opts.hostname;
  this.port = opts.port;
  this.secure = opts.secure;
  this.query = opts.query;
  this.timestampParam = opts.timestampParam;
  this.timestampRequests = opts.timestampRequests;
  this.readyState = '';
  this.agent = opts.agent || false;
  this.socket = opts.socket;
  this.enablesXDR = opts.enablesXDR;

  // SSL options for Node.js client
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;
  this.forceNode = opts.forceNode;

  // other options for Node.js client
  this.extraHeaders = opts.extraHeaders;
  this.localAddress = opts.localAddress;
}

/**
 * Mix in `Emitter`.
 */

Emitter(Transport.prototype);

/**
 * Emits an error.
 *
 * @param {String} str
 * @return {Transport} for chaining
 * @api public
 */

Transport.prototype.onError = function (msg, desc) {
  var err = new Error(msg);
  err.type = 'TransportError';
  err.description = desc;
  this.emit('error', err);
  return this;
};

/**
 * Opens the transport.
 *
 * @api public
 */

Transport.prototype.open = function () {
  if ('closed' === this.readyState || '' === this.readyState) {
    this.readyState = 'opening';
    this.doOpen();
  }

  return this;
};

/**
 * Closes the transport.
 *
 * @api private
 */

Transport.prototype.close = function () {
  if ('opening' === this.readyState || 'open' === this.readyState) {
    this.doClose();
    this.onClose();
  }

  return this;
};

/**
 * Sends multiple packets.
 *
 * @param {Array} packets
 * @api private
 */

Transport.prototype.send = function (packets) {
  if ('open' === this.readyState) {
    this.write(packets);
  } else {
    throw new Error('Transport not open');
  }
};

/**
 * Called upon open
 *
 * @api private
 */

Transport.prototype.onOpen = function () {
  this.readyState = 'open';
  this.writable = true;
  this.emit('open');
};

/**
 * Called with data.
 *
 * @param {String} data
 * @api private
 */

Transport.prototype.onData = function (data) {
  var packet = parser.decodePacket(data, this.socket.binaryType);
  this.onPacket(packet);
};

/**
 * Called with a decoded packet.
 */

Transport.prototype.onPacket = function (packet) {
  this.emit('packet', packet);
};

/**
 * Called upon close.
 *
 * @api private
 */

Transport.prototype.onClose = function () {
  this.readyState = 'closed';
  this.emit('close');
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// browser shim for xmlhttprequest module

var hasCORS = __webpack_require__(364);

module.exports = function (opts) {
  var xdomain = opts.xdomain;

  // scheme must be same when usign XDomainRequest
  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
  var xscheme = opts.xscheme;

  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
  // https://github.com/Automattic/engine.io-client/pull/217
  var enablesXDR = opts.enablesXDR;

  // XMLHttpRequest can be disabled on IE
  try {
    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
      return new XMLHttpRequest();
    }
  } catch (e) { }

  // Use XDomainRequest for IE8 if enablesXDR is true
  // because loading bar keeps flashing when using jsonp-polling
  // https://github.com/yujiosaka/socke.io-ie8-loading-example
  try {
    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
      return new XDomainRequest();
    }
  } catch (e) { }

  if (!xdomain) {
    try {
      return new global[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
    } catch (e) { }
  }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(363);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = count_occurences;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

// Counts all occurences of a symbol in a string
function count_occurences(symbol, string) {
	var count = 0;

	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(string), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var character = _step.value;

			if (character === symbol) {
				count++;
			}
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	return count;
}
//# sourceMappingURL=helpers.js.map

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(385),
    getPrototype = __webpack_require__(387),
    isObjectLike = __webpack_require__(392);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var debug = __webpack_require__(22)('socket.io-parser');
var Emitter = __webpack_require__(34);
var hasBin = __webpack_require__(141);
var binary = __webpack_require__(434);
var isBuf = __webpack_require__(170);

/**
 * Protocol version.
 *
 * @api public
 */

exports.protocol = 4;

/**
 * Packet types.
 *
 * @api public
 */

exports.types = [
  'CONNECT',
  'DISCONNECT',
  'EVENT',
  'ACK',
  'ERROR',
  'BINARY_EVENT',
  'BINARY_ACK'
];

/**
 * Packet type `connect`.
 *
 * @api public
 */

exports.CONNECT = 0;

/**
 * Packet type `disconnect`.
 *
 * @api public
 */

exports.DISCONNECT = 1;

/**
 * Packet type `event`.
 *
 * @api public
 */

exports.EVENT = 2;

/**
 * Packet type `ack`.
 *
 * @api public
 */

exports.ACK = 3;

/**
 * Packet type `error`.
 *
 * @api public
 */

exports.ERROR = 4;

/**
 * Packet type 'binary event'
 *
 * @api public
 */

exports.BINARY_EVENT = 5;

/**
 * Packet type `binary ack`. For acks with binary arguments.
 *
 * @api public
 */

exports.BINARY_ACK = 6;

/**
 * Encoder constructor.
 *
 * @api public
 */

exports.Encoder = Encoder;

/**
 * Decoder constructor.
 *
 * @api public
 */

exports.Decoder = Decoder;

/**
 * A socket.io Encoder instance
 *
 * @api public
 */

function Encoder() {}

/**
 * Encode a packet as a single string if non-binary, or as a
 * buffer sequence, depending on packet type.
 *
 * @param {Object} obj - packet object
 * @param {Function} callback - function to handle encodings (likely engine.write)
 * @return Calls callback with Array of encodings
 * @api public
 */

Encoder.prototype.encode = function(obj, callback){
  if ((obj.type === exports.EVENT || obj.type === exports.ACK) && hasBin(obj.data)) {
    obj.type = obj.type === exports.EVENT ? exports.BINARY_EVENT : exports.BINARY_ACK;
  }

  debug('encoding packet %j', obj);

  if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
    encodeAsBinary(obj, callback);
  }
  else {
    var encoding = encodeAsString(obj);
    callback([encoding]);
  }
};

/**
 * Encode packet as string.
 *
 * @param {Object} packet
 * @return {String} encoded
 * @api private
 */

function encodeAsString(obj) {

  // first is type
  var str = '' + obj.type;

  // attachments if we have them
  if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
    str += obj.attachments + '-';
  }

  // if we have a namespace other than `/`
  // we append it followed by a comma `,`
  if (obj.nsp && '/' !== obj.nsp) {
    str += obj.nsp + ',';
  }

  // immediately followed by the id
  if (null != obj.id) {
    str += obj.id;
  }

  // json data
  if (null != obj.data) {
    str += JSON.stringify(obj.data);
  }

  debug('encoded %j as %s', obj, str);
  return str;
}

/**
 * Encode packet as 'buffer sequence' by removing blobs, and
 * deconstructing packet into object with placeholders and
 * a list of buffers.
 *
 * @param {Object} packet
 * @return {Buffer} encoded
 * @api private
 */

function encodeAsBinary(obj, callback) {

  function writeEncoding(bloblessData) {
    var deconstruction = binary.deconstructPacket(bloblessData);
    var pack = encodeAsString(deconstruction.packet);
    var buffers = deconstruction.buffers;

    buffers.unshift(pack); // add packet info to beginning of data list
    callback(buffers); // write all the buffers
  }

  binary.removeBlobs(obj, writeEncoding);
}

/**
 * A socket.io Decoder instance
 *
 * @return {Object} decoder
 * @api public
 */

function Decoder() {
  this.reconstructor = null;
}

/**
 * Mix in `Emitter` with Decoder.
 */

Emitter(Decoder.prototype);

/**
 * Decodes an ecoded packet string into packet JSON.
 *
 * @param {String} obj - encoded packet
 * @return {Object} packet
 * @api public
 */

Decoder.prototype.add = function(obj) {
  var packet;
  if (typeof obj === 'string') {
    packet = decodeString(obj);
    if (exports.BINARY_EVENT === packet.type || exports.BINARY_ACK === packet.type) { // binary packet's json
      this.reconstructor = new BinaryReconstructor(packet);

      // no attachments, labeled binary but no binary data to follow
      if (this.reconstructor.reconPack.attachments === 0) {
        this.emit('decoded', packet);
      }
    } else { // non-binary full packet
      this.emit('decoded', packet);
    }
  }
  else if (isBuf(obj) || obj.base64) { // raw binary data
    if (!this.reconstructor) {
      throw new Error('got binary data when not reconstructing a packet');
    } else {
      packet = this.reconstructor.takeBinaryData(obj);
      if (packet) { // received final buffer
        this.reconstructor = null;
        this.emit('decoded', packet);
      }
    }
  }
  else {
    throw new Error('Unknown type: ' + obj);
  }
};

/**
 * Decode a packet String (JSON data)
 *
 * @param {String} str
 * @return {Object} packet
 * @api private
 */

function decodeString(str) {
  var i = 0;
  // look up type
  var p = {
    type: Number(str.charAt(0))
  };

  if (null == exports.types[p.type]) return error();

  // look up attachments if type binary
  if (exports.BINARY_EVENT === p.type || exports.BINARY_ACK === p.type) {
    var buf = '';
    while (str.charAt(++i) !== '-') {
      buf += str.charAt(i);
      if (i == str.length) break;
    }
    if (buf != Number(buf) || str.charAt(i) !== '-') {
      throw new Error('Illegal attachments');
    }
    p.attachments = Number(buf);
  }

  // look up namespace (if any)
  if ('/' === str.charAt(i + 1)) {
    p.nsp = '';
    while (++i) {
      var c = str.charAt(i);
      if (',' === c) break;
      p.nsp += c;
      if (i === str.length) break;
    }
  } else {
    p.nsp = '/';
  }

  // look up id
  var next = str.charAt(i + 1);
  if ('' !== next && Number(next) == next) {
    p.id = '';
    while (++i) {
      var c = str.charAt(i);
      if (null == c || Number(c) != c) {
        --i;
        break;
      }
      p.id += str.charAt(i);
      if (i === str.length) break;
    }
    p.id = Number(p.id);
  }

  // look up json data
  if (str.charAt(++i)) {
    p = tryParse(p, str.substr(i));
  }

  debug('decoded %s as %j', str, p);
  return p;
}

function tryParse(p, str) {
  try {
    p.data = JSON.parse(str);
  } catch(e){
    return error();
  }
  return p; 
}

/**
 * Deallocates a parser's resources
 *
 * @api public
 */

Decoder.prototype.destroy = function() {
  if (this.reconstructor) {
    this.reconstructor.finishedReconstruction();
  }
};

/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 * @api private
 */

function BinaryReconstructor(packet) {
  this.reconPack = packet;
  this.buffers = [];
}

/**
 * Method to be called when binary data received from connection
 * after a BINARY_EVENT packet.
 *
 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
 * @return {null | Object} returns null if more binary data is expected or
 *   a reconstructed packet object if all buffers have been received.
 * @api private
 */

BinaryReconstructor.prototype.takeBinaryData = function(binData) {
  this.buffers.push(binData);
  if (this.buffers.length === this.reconPack.attachments) { // done with buffer list
    var packet = binary.reconstructPacket(this.reconPack, this.buffers);
    this.finishedReconstruction();
    return packet;
  }
  return null;
};

/**
 * Cleans up binary packet reconstruction variables.
 *
 * @api private
 */

BinaryReconstructor.prototype.finishedReconstruction = function() {
  this.reconPack = null;
  this.buffers = [];
};

function error() {
  return {
    type: exports.ERROR,
    data: 'parser error'
  };
}


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(308);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(10), __webpack_require__(0), __webpack_require__(190), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/object/assign'), require('preact'), require('./capture.js'), require('../../Tracker'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.assign, global.preact, global.capture, global.Tracker);
    global.index = mod.exports;
  }
})(this, function (module, exports, _assign, _preact, _capture, _Tracker) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _assign2 = _interopRequireDefault(_assign);

  var _capture2 = _interopRequireDefault(_capture);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var webcamSupportChangeHandler = function webcamSupportChangeHandler(_ref) {
    var changeFlowTo = _ref.changeFlowTo,
        useWebcam = _ref.useWebcam,
        allowCrossDeviceFlow = _ref.allowCrossDeviceFlow;
    return useWebcam ? {
      onWebcamSupportChange: function onWebcamSupportChange(hasWebcam) {
        if (!hasWebcam && allowCrossDeviceFlow) {
          changeFlowTo('crossDeviceSteps', 0, true);
        }
      }
    } : {};
  };

  var DocumentCapture = function DocumentCapture(props) {
    return (0, _preact.h)(_capture2.default, _extends({ autoCapture: true }, props, webcamSupportChangeHandler(props)));
  };

  DocumentCapture.defaultProps = {
    useWebcam: false,
    method: 'document'
  };

  var FrontDocumentCapture = function FrontDocumentCapture(options) {
    return (0, _preact.h)(DocumentCapture, options);
  };
  FrontDocumentCapture.defaultProps = { side: 'front' };

  var BackDocumentCapture = function BackDocumentCapture(options) {
    return (0, _preact.h)(DocumentCapture, options);
  };

  BackDocumentCapture.defaultProps = { side: 'back' };

  var FaceCapture = function FaceCapture(props) {
    return (0, _preact.h)(_capture2.default, _extends({ autoCapture: false }, props, webcamSupportChangeHandler(props)));
  };

  FaceCapture.defaultProps = {
    useWebcam: true,
    method: 'face',
    requestedVariant: 'standard',
    side: null
  };

  var LivenessCapture = function LivenessCapture(props) {
    return (0, _preact.h)(FaceCapture, _extends({}, props, { liveness: true }));
  };

  exports.default = {
    FrontDocumentCapture: (0, _Tracker.appendToTracking)(FrontDocumentCapture, 'front_capture'),
    BackDocumentCapture: (0, _Tracker.appendToTracking)(BackDocumentCapture, 'back_capture'),
    FaceCapture: (0, _Tracker.appendToTracking)(FaceCapture, 'selfie_capture'),
    LivenessCapture: (0, _Tracker.appendToTracking)(LivenessCapture, 'video_capture')
  };
  module.exports = exports['default'];
});

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(10), __webpack_require__(7), __webpack_require__(6), __webpack_require__(4), __webpack_require__(5), __webpack_require__(0), __webpack_require__(11), __webpack_require__(441)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/object/assign'), require('babel-runtime/core-js/object/set-prototype-of'), require('babel-runtime/core-js/object/create'), require('babel-runtime/core-js/object/get-prototype-of'), require('react'), require('preact'), require('classnames'), require('./style.css'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.assign, global.setPrototypeOf, global.create, global.getPrototypeOf, global.react, global.preact, global.classnames, global.style);
    global.index = mod.exports;
  }
})(this, function (module, exports, _assign, _setPrototypeOf, _create, _getPrototypeOf, _react, _preact, _classnames, _style) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _assign2 = _interopRequireDefault(_assign);

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create2 = _interopRequireDefault(_create);

  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

  var React = _interopRequireWildcard(_react);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _style2 = _interopRequireDefault(_style);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var noop = function noop() {};

  var CustomFileInput = function (_React$Component) {
    _inherits(CustomFileInput, _React$Component);

    function CustomFileInput() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, CustomFileInput);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CustomFileInput.__proto__ || (0, _getPrototypeOf2.default)(CustomFileInput)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
        if (_this.input) {
          _this.input.click();
        }
        _this.props.onClick();
      }, _this.handleChange = function (event) {
        if (_this.input) {
          _this.props.onChange(_this.input.files[0]);
        }
        event.currentTarget.value = ''; // Allow re-uplading the same file
      }, _this.render = function () {
        var _this$props = _this.props,
            children = _this$props.children,
            className = _this$props.className,
            onClick = _this$props.onClick,
            onChange = _this$props.onChange,
            other = _objectWithoutProperties(_this$props, ['children', 'className', 'onClick', 'onChange']);

        // eslint-disable-line no-unused-vars
        return (0, _preact.h)(
          'div',
          { onClick: _this.handleClick, className: (0, _classnames2.default)(_style2.default.container, className) },
          children,
          (0, _preact.h)('input', _extends({
            type: 'file',
            className: _style2.default.input,
            ref: function ref(_ref2) {
              return _this.input = _ref2;
            },
            onChange: _this.handleChange
          }, other))
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return CustomFileInput;
  }(React.Component);

  CustomFileInput.defaultProps = {
    children: null,
    className: '',
    onClick: noop,
    onChange: noop
  };
  exports.default = CustomFileInput;
  module.exports = exports['default'];
});

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(3), __webpack_require__(0), __webpack_require__(11), __webpack_require__(446), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/object/define-property'), require('preact'), require('classnames'), require('./style.css'), require('../utils'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.defineProperty, global.preact, global.classnames, global.style, global.utils);
    global.index = mod.exports;
  }
})(this, function (module, exports, _defineProperty2, _preact, _classnames, _style, _utils) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _defineProperty3 = _interopRequireDefault(_defineProperty2);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _style2 = _interopRequireDefault(_style);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      (0, _defineProperty3.default)(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var NavigationBar = function NavigationBar(_ref) {
    var back = _ref.back,
        i18n = _ref.i18n,
        disabled = _ref.disabled,
        isFullScreen = _ref.isFullScreen,
        className = _ref.className;
    return (0, _preact.h)(
      'div',
      { className: (0, _classnames2.default)(className, _style2.default.navigation, _defineProperty({}, _style2.default.fullScreenNav, isFullScreen)) },
      (0, _preact.h)(
        'button',
        { href: '#', className: (0, _classnames2.default)(_style2.default.back, _defineProperty({}, _style2.default.disabled, disabled)),
          onClick: (0, _utils.preventDefaultOnClick)(back) },
        (0, _preact.h)('span', { className: _style2.default.iconBack }),
        (0, _preact.h)(
          'span',
          { className: _style2.default.label },
          i18n.t('back')
        )
      )
    );
  };

  exports.default = NavigationBar;
  module.exports = exports['default'];
});

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(27), __webpack_require__(56), __webpack_require__(70), __webpack_require__(0), __webpack_require__(212), __webpack_require__(209), __webpack_require__(106), __webpack_require__(194), __webpack_require__(192), __webpack_require__(219), __webpack_require__(214), __webpack_require__(213), __webpack_require__(217), __webpack_require__(197), __webpack_require__(207)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/core-js/array/from'), require('babel-runtime/core-js/array/includes'), require('babel-runtime/core-js/array/find'), require('preact'), require('../Welcome'), require('../Select'), require('../Capture'), require('../Confirm'), require('../Complete'), require('../crossDevice/MobileFlow'), require('../crossDevice/CrossDeviceLink'), require('../crossDevice/ClientSuccess'), require('../crossDevice/Intro'), require('../Liveness/Intro'), require('../ProofOfAddress'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.from, global.includes, global.find, global.preact, global.Welcome, global.Select, global.Capture, global.Confirm, global.Complete, global.MobileFlow, global.CrossDeviceLink, global.ClientSuccess, global.Intro, global.Intro, global.ProofOfAddress);
    global.StepComponentMap = mod.exports;
  }
})(this, function (exports, _from, _includes, _find, _preact, _Welcome, _Select, _Capture, _Confirm, _Complete, _MobileFlow, _CrossDeviceLink, _ClientSuccess, _Intro, _Intro3, _ProofOfAddress) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.componentsList = undefined;

  var _from2 = _interopRequireDefault(_from);

  var _includes2 = _interopRequireDefault(_includes);

  var _find2 = _interopRequireDefault(_find);

  var _Welcome2 = _interopRequireDefault(_Welcome);

  var _Complete2 = _interopRequireDefault(_Complete);

  var _MobileFlow2 = _interopRequireDefault(_MobileFlow);

  var _CrossDeviceLink2 = _interopRequireDefault(_CrossDeviceLink);

  var _ClientSuccess2 = _interopRequireDefault(_ClientSuccess);

  var _Intro2 = _interopRequireDefault(_Intro);

  var _Intro4 = _interopRequireDefault(_Intro3);

  var _ProofOfAddress2 = _interopRequireDefault(_ProofOfAddress);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    } else {
      return (0, _from2.default)(arr);
    }
  }

  var componentsList = exports.componentsList = function componentsList(_ref) {
    var flow = _ref.flow,
        documentType = _ref.documentType,
        steps = _ref.steps,
        mobileFlow = _ref.mobileFlow;

    var captureSteps = mobileFlow ? clientCaptureSteps(steps) : steps;
    return flow === 'captureSteps' ? createComponentList(captureStepsComponents(documentType, mobileFlow, steps), captureSteps) : createComponentList(crossDeviceComponents, crossDeviceSteps(steps));
  };

  var isComplete = function isComplete(step) {
    return step.type === 'complete';
  };

  var hasCompleteStep = function hasCompleteStep(steps) {
    return steps.some(isComplete);
  };

  var clientCaptureSteps = function clientCaptureSteps(steps) {
    return hasCompleteStep(steps) ? steps : [].concat(_toConsumableArray(steps), [{ type: 'complete' }]);
  };

  var shouldUseLiveness = function shouldUseLiveness(steps) {
    var _ref2 = (0, _find2.default)(steps, function (_ref3) {
      var type = _ref3.type;
      return type === 'face';
    }) || {},
        faceOptions = _ref2.options;

    return (faceOptions || {}).requestedVariant === 'video' && window.MediaRecorder;
  };

  var captureStepsComponents = function captureStepsComponents(documentType, mobileFlow, steps) {
    var _complete = mobileFlow ? [_ClientSuccess2.default] : [_Complete2.default];

    return {
      welcome: function welcome() {
        return [_Welcome2.default];
      },
      face: function face() {
        return shouldUseLiveness(steps) ? [_Intro4.default, _Capture.LivenessCapture, _Confirm.LivenessConfirm] : [_Capture.FaceCapture, _Confirm.FaceConfirm];
      },
      document: function document() {
        return createIdentityDocumentComponents(documentType);
      },
      poa: function poa() {
        return [_ProofOfAddress.PoAIntro, _Select.SelectPoADocument, _ProofOfAddress2.default, _Confirm.DocumentFrontConfirm];
      },
      complete: function complete() {
        return _complete;
      }
    };
  };

  var createIdentityDocumentComponents = function createIdentityDocumentComponents(documentType) {
    var double_sided_docs = ['driving_licence', 'national_identity_card'];
    var frontDocumentFlow = [_Select.SelectIdentityDocument, _Capture.FrontDocumentCapture, _Confirm.DocumentFrontConfirm];
    if ((0, _includes2.default)(double_sided_docs, documentType)) {
      return [].concat(frontDocumentFlow, [_Capture.BackDocumentCapture, _Confirm.DocumentBackConfirm]);
    }
    return frontDocumentFlow;
  };

  var crossDeviceSteps = function crossDeviceSteps(steps) {
    var baseSteps = [{ 'type': 'crossDevice' }];
    var completeStep = (0, _find2.default)(steps, isComplete);
    return hasCompleteStep(steps) ? [].concat(baseSteps, [completeStep]) : baseSteps;
  };

  var crossDeviceComponents = {
    crossDevice: function crossDevice() {
      return [_Intro2.default, _CrossDeviceLink2.default, _MobileFlow2.default];
    },
    complete: function complete() {
      return [_Complete2.default];
    }
  };

  var createComponentList = function createComponentList(components, steps) {
    var mapSteps = function mapSteps(step) {
      return createComponent(components, step);
    };
    return shallowFlatten(steps.map(mapSteps));
  };

  var createComponent = function createComponent(components, step) {
    var type = step.type;

    if (!(type in components)) {
      console.error('No such step: ' + type);
    }
    return components[type]().map(wrapComponent(step));
  };

  var wrapComponent = function wrapComponent(step) {
    return function (component) {
      return { component: component, step: step };
    };
  };

  var shallowFlatten = function shallowFlatten(list) {
    var _ref4;

    return (_ref4 = []).concat.apply(_ref4, _toConsumableArray(list));
  };
});

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(3), __webpack_require__(7), __webpack_require__(6), __webpack_require__(4), __webpack_require__(5), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/object/define-property'), require('babel-runtime/core-js/object/set-prototype-of'), require('babel-runtime/core-js/object/create'), require('babel-runtime/core-js/object/get-prototype-of'), require('react'), require('preact'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.defineProperty, global.setPrototypeOf, global.create, global.getPrototypeOf, global.react, global.preact);
    global.index = mod.exports;
  }
})(this, function (module, exports, _defineProperty, _setPrototypeOf, _create, _getPrototypeOf, _react, _preact) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _defineProperty2 = _interopRequireDefault(_defineProperty);

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create2 = _interopRequireDefault(_create);

  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

  var React = _interopRequireWildcard(_react);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty2.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Timeout = function (_Component) {
    _inherits(Timeout, _Component);

    function Timeout() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Timeout);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Timeout.__proto__ || (0, _getPrototypeOf2.default)(Timeout)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        hasTimedOut: false
      }, _this.clearInactivityTimeout = function () {
        return clearTimeout(_this.timeoutId);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Timeout, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        if (!this.timeoutId) {
          this.clearInactivityTimeout();
          this.timeoutId = setTimeout(function () {
            return _this2.setState({ hasTimedOut: true });
          }, this.props.seconds * 1000);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.clearInactivityTimeout();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        if (!prevState.hasTimedOut && this.state.hasTimedOut) {
          this.props.onTimeout();
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return Timeout;
  }(_preact.Component);

  Timeout.defaultProps = {
    seconds: 0,
    onTimeout: function onTimeout() {}
  };
  exports.default = Timeout;
  module.exports = exports['default'];
});

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.errors = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var errors = exports.errors = function errors(i18n) {
    return {
      'INVALID_CAPTURE': { message: i18n.t('errors.invalid_capture.message'), instruction: i18n.t('errors.invalid_capture.instruction') },
      'INVALID_TYPE': { message: i18n.t('errors.invalid_type.message'), instruction: i18n.t('errors.invalid_type.instruction') },
      'UNSUPPORTED_FILE': { message: i18n.t('errors.unsupported_file.message'), instruction: i18n.t('errors.unsupported_file.instruction') },
      'INVALID_SIZE': { message: i18n.t('errors.invalid_size.message'), instruction: i18n.t('errors.invalid_size.instruction') },
      'NO_FACE_ERROR': { message: i18n.t('errors.no_face.message'), instruction: i18n.t('errors.no_face.instruction') },
      'MULTIPLE_FACES_ERROR': { message: i18n.t('errors.multiple_faces.message'), instruction: i18n.t('errors.multiple_faces.instruction') },
      'SERVER_ERROR': { message: i18n.t('errors.server_error.message'), instruction: i18n.t('errors.server_error.instruction') },
      'GLARE_DETECTED': { message: i18n.t('errors.glare_detected.message'), instruction: i18n.t('errors.glare_detected.instruction') },
      'SMS_FAILED': { message: i18n.t('errors.sms_failed.message'), instruction: i18n.t('errors.sms_failed.instruction') },
      'SMS_OVERUSE': { message: i18n.t('errors.sms_overuse.message'), instruction: i18n.t('errors.sms_overuse.instruction') },
      'CAMERA_NOT_WORKING': { message: i18n.t('errors.camera_not_working.message'), instruction: i18n.t('errors.camera_not_working.instruction') },
      'CAMERA_INACTIVE': { message: i18n.t('errors.camera_inactive.message'), instruction: i18n.t('errors.camera_inactive.instruction') },
      'LIVENESS_TIMEOUT': { message: i18n.t('errors.liveness_timeout.message'), instruction: i18n.t('errors.liveness_timeout.instruction') }
    };
  };
});

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(55), __webpack_require__(76)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('../utils/func'), require('../utils/canvas.js'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.func, global.canvas);
    global.camera = mod.exports;
  }
})(this, function (exports, _func, _canvas) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.screenshot = undefined;
  var screenshot = exports.screenshot = function screenshot(webcam, callback) {
    var canvas = webcam && webcam.getCanvas();
    if (!canvas) {
      console.error('webcam canvas is null');
      return;
    }
    (0, _func.asyncFunc)(_canvas.cloneCanvas, [canvas], callback);
  };
});

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(47), __webpack_require__(76), __webpack_require__(242), __webpack_require__(241)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('blueimp-load-image/js/load-image'), require('./canvas.js'), require('blueimp-load-image/js/load-image-orientation'), require('blueimp-load-image/js/load-image-exif'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.loadImage, global.canvas, global.loadImageOrientation, global.loadImageExif);
    global.file = mod.exports;
  }
})(this, function (exports, _loadImage, _canvas) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.fileToLossyBase64Image = exports.isOfFileType = exports.fileType = exports.base64toBlob = exports.fileToBase64 = undefined;

  var _loadImage2 = _interopRequireDefault(_loadImage);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var fileToBase64 = exports.fileToBase64 = function fileToBase64(file, callback, errorCallback) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      callback(reader.result);
    };
    reader.onerror = function (error) {
      console.warn('File Reading Error: ', error);
      errorCallback(error);
    };
  };

  var decodeBase64 = function decodeBase64(image) {
    var byteString = atob(image.split(',')[1]);
    var mimeString = image.split(',')[0].split(':')[1].split(';')[0];
    var integerArray = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      integerArray[i] = byteString.charCodeAt(i);
    }
    return { integerArray: integerArray, mimeString: mimeString };
  };

  var base64toBlob = exports.base64toBlob = function base64toBlob(image) {
    var base64Data = decodeBase64(image);
    return new Blob([base64Data.integerArray], { type: base64Data.mimeString });
  };

  var fileType = exports.fileType = function fileType(file) {
    return file.type.split('/')[1];
  };

  var isOfFileType = exports.isOfFileType = function isOfFileType(fileTypeList, file) {
    return fileTypeList.some(function (acceptableFileType) {
      return acceptableFileType === fileType(file);
    });
  };

  var fileToCanvas = function fileToCanvas(file, callback, errorCallback) {
    return (0, _loadImage2.default)(file, function (canvasOrEventError) {
      if (canvasOrEventError.type === "error") {
        errorCallback(canvasOrEventError);
      } else {
        callback(canvasOrEventError);
      }
    }, { maxWidth: 960, maxHeight: 960, orientation: true });
  };

  var fileToLossyBase64Image = exports.fileToLossyBase64Image = function fileToLossyBase64Image(file, callback, errorCallback) {
    return fileToCanvas(file, function (canvas) {
      return (0, _canvas.toLossyImageDataUrl)(canvas, callback);
    }, errorCallback);
  };
});

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(10), __webpack_require__(57), __webpack_require__(77), __webpack_require__(157)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/core-js/object/assign'), require('babel-runtime/core-js/json/stringify'), require('../utils/http'), require('object-loops/for-each'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.assign, global.stringify, global.http, global.forEach);
    global.onfidoApi = mod.exports;
  }
})(this, function (exports, _assign, _stringify, _http, _forEach) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.requestChallenges = exports.uploadLiveVideo = exports.uploadLivePhoto = exports.uploadDocument = undefined;

  var _assign2 = _interopRequireDefault(_assign);

  var _stringify2 = _interopRequireDefault(_stringify);

  var _forEach2 = _interopRequireDefault(_forEach);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var formatError = function formatError(_ref, onError) {
    var response = _ref.response,
        status = _ref.status;
    return onError({ status: status, response: JSON.parse(response) });
  };

  var uploadDocument = function uploadDocument(data, token, onSuccess, onError) {
    var _data = data,
        validations = _data.validations,
        other = _objectWithoutProperties(_data, ['validations']);

    data = _extends({}, other, {
      sdk_validations: (0, _stringify2.default)(validations)
    });
    var endpoint = "https://api.onfido.com" + '/v2/documents';
    sendFile(endpoint, data, token, onSuccess, onError);
  };

  exports.uploadDocument = uploadDocument;
  var uploadLivePhoto = exports.uploadLivePhoto = function uploadLivePhoto(data, token, onSuccess, onError) {
    var endpoint = "https://api.onfido.com" + '/v2/live_photos';
    sendFile(endpoint, data, token, onSuccess, onError);
  };

  var uploadLiveVideo = exports.uploadLiveVideo = function uploadLiveVideo(_ref2, token, onSuccess, onError) {
    var challengeData = _ref2.challengeData,
        blob = _ref2.blob,
        language = _ref2.language;
    var challenge = challengeData.challenges,
        challenge_id = challengeData.id,
        challenge_switch_at = challengeData.switchSeconds;

    var payload = {
      file: blob,
      languages: (0, _stringify2.default)([{ source: 'sdk', language_code: language }]),
      challenge: (0, _stringify2.default)(challenge),
      challenge_id: challenge_id,
      challenge_switch_at: challenge_switch_at
    };
    var endpoint = "https://api.onfido.com" + '/v2/live_videos';
    sendFile(endpoint, payload, token, onSuccess, onError);
  };

  var requestChallenges = exports.requestChallenges = function requestChallenges(token, onSuccess, onError) {
    var options = {
      endpoint: "https://api.onfido.com" + '/v2/live_video_challenge',
      contentType: 'application/json',
      token: 'Bearer ' + token
    };
    (0, _http.performHttpReq)(options, onSuccess, onError);
  };

  var objectToFormData = function objectToFormData(object) {
    var formData = new FormData();
    (0, _forEach2.default)(object, function (value, key) {
      return formData.append(key, value);
    });
    return formData;
  };

  var sendFile = function sendFile(endpoint, data, token, onSuccess, onError) {
    data = _extends({}, data, {
      sdk_source: 'onfido_web_sdk',
      sdk_version: "2.8.0"
    });

    var requestParams = {
      payload: objectToFormData(data),
      endpoint: endpoint,
      token: 'Bearer ' + token
    };
    (0, _http.performHttpReq)(requestParams, onSuccess, function (request) {
      return formatError(request, onError);
    });
  };
});

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(51), __webpack_require__(230)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('redux'), require('./reducers'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.redux, global.reducers);
    global.store = mod.exports;
  }
})(this, function (module, exports, _redux, _reducers) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reducers2 = _interopRequireDefault(_reducers);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var store = (0, _redux.createStore)(_reducers2.default, window.devToolsExtension ? window.devToolsExtension() : undefined);

  exports.default = store;
  module.exports = exports['default'];
});

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(249), __esModule: true };

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image Meta
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * https://blueimp.net
 *
 * Image meta data handling implementation
 * based on the help and contribution of
 * Achim Stöhr.
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, Blob */

;(function (factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(47)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
}(function (loadImage) {
  'use strict'

  var hasblobSlice = window.Blob && (Blob.prototype.slice ||
  Blob.prototype.webkitSlice || Blob.prototype.mozSlice)

  loadImage.blobSlice = hasblobSlice && function () {
    var slice = this.slice || this.webkitSlice || this.mozSlice
    return slice.apply(this, arguments)
  }

  loadImage.metaDataParsers = {
    jpeg: {
      0xffe1: [] // APP1 marker
    }
  }

  // Parses image meta data and calls the callback with an object argument
  // with the following properties:
  // * imageHead: The complete image head as ArrayBuffer (Uint8Array for IE10)
  // The options arguments accepts an object and supports the following properties:
  // * maxMetaDataSize: Defines the maximum number of bytes to parse.
  // * disableImageHead: Disables creating the imageHead property.
  loadImage.parseMetaData = function (file, callback, options, data) {
    options = options || {}
    data = data || {}
    var that = this
    // 256 KiB should contain all EXIF/ICC/IPTC segments:
    var maxMetaDataSize = options.maxMetaDataSize || 262144
    var noMetaData = !(window.DataView && file && file.size >= 12 &&
                      file.type === 'image/jpeg' && loadImage.blobSlice)
    if (noMetaData || !loadImage.readFile(
        loadImage.blobSlice.call(file, 0, maxMetaDataSize),
        function (e) {
          if (e.target.error) {
            // FileReader error
            console.log(e.target.error)
            callback(data)
            return
          }
          // Note on endianness:
          // Since the marker and length bytes in JPEG files are always
          // stored in big endian order, we can leave the endian parameter
          // of the DataView methods undefined, defaulting to big endian.
          var buffer = e.target.result
          var dataView = new DataView(buffer)
          var offset = 2
          var maxOffset = dataView.byteLength - 4
          var headLength = offset
          var markerBytes
          var markerLength
          var parsers
          var i
          // Check for the JPEG marker (0xffd8):
          if (dataView.getUint16(0) === 0xffd8) {
            while (offset < maxOffset) {
              markerBytes = dataView.getUint16(offset)
              // Search for APPn (0xffeN) and COM (0xfffe) markers,
              // which contain application-specific meta-data like
              // Exif, ICC and IPTC data and text comments:
              if ((markerBytes >= 0xffe0 && markerBytes <= 0xffef) ||
                markerBytes === 0xfffe) {
                // The marker bytes (2) are always followed by
                // the length bytes (2), indicating the length of the
                // marker segment, which includes the length bytes,
                // but not the marker bytes, so we add 2:
                markerLength = dataView.getUint16(offset + 2) + 2
                if (offset + markerLength > dataView.byteLength) {
                  console.log('Invalid meta data: Invalid segment size.')
                  break
                }
                parsers = loadImage.metaDataParsers.jpeg[markerBytes]
                if (parsers) {
                  for (i = 0; i < parsers.length; i += 1) {
                    parsers[i].call(
                      that,
                      dataView,
                      offset,
                      markerLength,
                      data,
                      options
                    )
                  }
                }
                offset += markerLength
                headLength = offset
              } else {
                // Not an APPn or COM marker, probably safe to
                // assume that this is the end of the meta data
                break
              }
            }
            // Meta length must be longer than JPEG marker (2)
            // plus APPn marker (2), followed by length bytes (2):
            if (!options.disableImageHead && headLength > 6) {
              if (buffer.slice) {
                data.imageHead = buffer.slice(0, headLength)
              } else {
                // Workaround for IE10, which does not yet
                // support ArrayBuffer.slice:
                data.imageHead = new Uint8Array(buffer)
                  .subarray(0, headLength)
              }
            }
          } else {
            console.log('Invalid JPEG file: Missing JPEG marker.')
          }
          callback(data)
        },
        'readAsArrayBuffer'
      )) {
      callback(data)
    }
  }

  // Determines if meta data should be loaded automatically:
  loadImage.hasMetaOption = function (options) {
    return options && options.meta
  }

  var originalTransform = loadImage.transform
  loadImage.transform = function (img, options, callback, file, data) {
    if (loadImage.hasMetaOption(options)) {
      loadImage.parseMetaData(file, function (data) {
        originalTransform.call(loadImage, img, options, callback, file, data)
      }, options, data)
    } else {
      originalTransform.apply(loadImage, arguments)
    }
  }
}))


/***/ }),
/* 119 */
/***/ (function(module, exports) {

/**
 * Slice reference.
 */

var slice = [].slice;

/**
 * Bind `obj` to `fn`.
 *
 * @param {Object} obj
 * @param {Function|String} fn or string
 * @return {Function}
 * @api public
 */

module.exports = function(obj, fn){
  if ('string' == typeof fn) fn = obj[fn];
  if ('function' != typeof fn) throw new Error('bind() requires a function');
  var args = slice.call(arguments, 2);
  return function(){
    return fn.apply(obj, args.concat(slice.call(arguments)));
  }
};


/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(32);
var toLength = __webpack_require__(62);
var toAbsoluteIndex = __webpack_require__(282);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(21);
var document = __webpack_require__(20).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(19) && !__webpack_require__(25)(function () {
  return Object.defineProperty(__webpack_require__(123)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(35);
var ITERATOR = __webpack_require__(17)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(83);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(24);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(48);
var createDesc = __webpack_require__(49);
var toIObject = __webpack_require__(32);
var toPrimitive = __webpack_require__(94);
var has = __webpack_require__(31);
var IE8_DOM_DEFINE = __webpack_require__(124);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(19) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(132);
var hiddenKeys = __webpack_require__(85).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(31);
var toObject = __webpack_require__(37);
var IE_PROTO = __webpack_require__(91)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(31);
var toIObject = __webpack_require__(32);
var arrayIndexOf = __webpack_require__(122)(false);
var IE_PROTO = __webpack_require__(91)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(16);
var core = __webpack_require__(12);
var fails = __webpack_require__(25);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(26);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(26);


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(21);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 137 */
/***/ (function(module, exports) {



/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(395);
var foreach = __webpack_require__(362);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';

var toStr = Object.prototype.toString;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		Object.defineProperty(obj, 'x', { enumerable: false, value: obj });
        /* eslint-disable no-unused-vars, no-restricted-syntax */
        for (var _ in obj) { return false; }
        /* eslint-enable no-unused-vars, no-restricted-syntax */
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = Object.defineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		Object.defineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = props.concat(Object.getOwnPropertySymbols(map));
	}
	foreach(props, function (name) {
		defineProperty(object, name, map[name], predicates[name]);
	});
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Module dependencies
 */

var XMLHttpRequest = __webpack_require__(99);
var XHR = __webpack_require__(344);
var JSONP = __webpack_require__(343);
var websocket = __webpack_require__(345);

/**
 * Export transports.
 */

exports.polling = polling;
exports.websocket = websocket;

/**
 * Polling transport polymorphic constructor.
 * Decides on xhr vs jsonp based on feature detection.
 *
 * @api private
 */

function polling (opts) {
  var xhr;
  var xd = false;
  var xs = false;
  var jsonp = false !== opts.jsonp;

  if (global.location) {
    var isSSL = 'https:' === location.protocol;
    var port = location.port;

    // some user agents have empty `location.port`
    if (!port) {
      port = isSSL ? 443 : 80;
    }

    xd = opts.hostname !== location.hostname || port !== opts.port;
    xs = opts.secure !== isSSL;
  }

  opts.xdomain = xd;
  opts.xscheme = xs;
  xhr = new XMLHttpRequest(opts);

  if ('open' in xhr && !opts.forceJSONP) {
    return new XHR(opts);
  } else {
    if (!jsonp) throw new Error('JSONP disabled');
    return new JSONP(opts);
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var Transport = __webpack_require__(98);
var parseqs = __webpack_require__(68);
var parser = __webpack_require__(38);
var inherit = __webpack_require__(58);
var yeast = __webpack_require__(178);
var debug = __webpack_require__(22)('engine.io-client:polling');

/**
 * Module exports.
 */

module.exports = Polling;

/**
 * Is XHR2 supported?
 */

var hasXHR2 = (function () {
  var XMLHttpRequest = __webpack_require__(99);
  var xhr = new XMLHttpRequest({ xdomain: false });
  return null != xhr.responseType;
})();

/**
 * Polling interface.
 *
 * @param {Object} opts
 * @api private
 */

function Polling (opts) {
  var forceBase64 = (opts && opts.forceBase64);
  if (!hasXHR2 || forceBase64) {
    this.supportsBinary = false;
  }
  Transport.call(this, opts);
}

/**
 * Inherits from Transport.
 */

inherit(Polling, Transport);

/**
 * Transport name.
 */

Polling.prototype.name = 'polling';

/**
 * Opens the socket (triggers polling). We write a PING message to determine
 * when the transport is open.
 *
 * @api private
 */

Polling.prototype.doOpen = function () {
  this.poll();
};

/**
 * Pauses polling.
 *
 * @param {Function} callback upon buffers are flushed and transport is paused
 * @api private
 */

Polling.prototype.pause = function (onPause) {
  var self = this;

  this.readyState = 'pausing';

  function pause () {
    debug('paused');
    self.readyState = 'paused';
    onPause();
  }

  if (this.polling || !this.writable) {
    var total = 0;

    if (this.polling) {
      debug('we are currently polling - waiting to pause');
      total++;
      this.once('pollComplete', function () {
        debug('pre-pause polling complete');
        --total || pause();
      });
    }

    if (!this.writable) {
      debug('we are currently writing - waiting to pause');
      total++;
      this.once('drain', function () {
        debug('pre-pause writing complete');
        --total || pause();
      });
    }
  } else {
    pause();
  }
};

/**
 * Starts polling cycle.
 *
 * @api public
 */

Polling.prototype.poll = function () {
  debug('polling');
  this.polling = true;
  this.doPoll();
  this.emit('poll');
};

/**
 * Overloads onData to detect payloads.
 *
 * @api private
 */

Polling.prototype.onData = function (data) {
  var self = this;
  debug('polling got data %s', data);
  var callback = function (packet, index, total) {
    // if its the first message we consider the transport open
    if ('opening' === self.readyState) {
      self.onOpen();
    }

    // if its a close packet, we close the ongoing requests
    if ('close' === packet.type) {
      self.onClose();
      return false;
    }

    // otherwise bypass onData and handle the message
    self.onPacket(packet);
  };

  // decode payload
  parser.decodePayload(data, this.socket.binaryType, callback);

  // if an event did not trigger closing
  if ('closed' !== this.readyState) {
    // if we got data we're not polling
    this.polling = false;
    this.emit('pollComplete');

    if ('open' === this.readyState) {
      this.poll();
    } else {
      debug('ignoring poll - transport state "%s"', this.readyState);
    }
  }
};

/**
 * For polling, send a close packet.
 *
 * @api private
 */

Polling.prototype.doClose = function () {
  var self = this;

  function close () {
    debug('writing close packet');
    self.write([{ type: 'close' }]);
  }

  if ('open' === this.readyState) {
    debug('transport open - closing');
    close();
  } else {
    // in case we're trying to close while
    // handshaking is in progress (GH-164)
    debug('transport not open - deferring close');
    this.once('open', close);
  }
};

/**
 * Writes a packets payload.
 *
 * @param {Array} data packets
 * @param {Function} drain callback
 * @api private
 */

Polling.prototype.write = function (packets) {
  var self = this;
  this.writable = false;
  var callbackfn = function () {
    self.writable = true;
    self.emit('drain');
  };

  parser.encodePayload(packets, this.supportsBinary, function (data) {
    self.doWrite(data, callbackfn);
  });
};

/**
 * Generates uri for connection.
 *
 * @api private
 */

Polling.prototype.uri = function () {
  var query = this.query || {};
  var schema = this.secure ? 'https' : 'http';
  var port = '';

  // cache busting is forced
  if (false !== this.timestampRequests) {
    query[this.timestampParam] = yeast();
  }

  if (!this.supportsBinary && !query.sid) {
    query.b64 = 1;
  }

  query = parseqs.encode(query);

  // avoid port if default for schema
  if (this.port && (('https' === schema && Number(this.port) !== 443) ||
     ('http' === schema && Number(this.port) !== 80))) {
    port = ':' + this.port;
  }

  // prepend ? to query
  if (query.length) {
    query = '?' + query;
  }

  var ipv6 = this.hostname.indexOf(':') !== -1;
  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/* global Blob File */

/*
 * Module requirements.
 */

var isArray = __webpack_require__(151);

var toString = Object.prototype.toString;
var withNativeBlob = typeof global.Blob === 'function' || toString.call(global.Blob) === '[object BlobConstructor]';
var withNativeFile = typeof global.File === 'function' || toString.call(global.File) === '[object FileConstructor]';

/**
 * Module exports.
 */

module.exports = hasBinary;

/**
 * Checks for binary data.
 *
 * Supports Buffer, ArrayBuffer, Blob and File.
 *
 * @param {Object} anything
 * @api public
 */

function hasBinary (obj) {
  if (!obj || typeof obj !== 'object') {
    return false;
  }

  if (isArray(obj)) {
    for (var i = 0, l = obj.length; i < l; i++) {
      if (hasBinary(obj[i])) {
        return true;
      }
    }
    return false;
  }

  if ((typeof global.Buffer === 'function' && global.Buffer.isBuffer && global.Buffer.isBuffer(obj)) ||
     (typeof global.ArrayBuffer === 'function' && obj instanceof ArrayBuffer) ||
     (withNativeBlob && obj instanceof Blob) ||
     (withNativeFile && obj instanceof File)
    ) {
    return true;
  }

  // see: https://github.com/Automattic/has-binary/pull/4
  if (obj.toJSON && typeof obj.toJSON === 'function' && arguments.length === 1) {
    return hasBinary(obj.toJSON(), true);
  }

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key) && hasBinary(obj[key])) {
      return true;
    }
  }

  return false;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__(100);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var stripPrefix = exports.stripPrefix = function stripPrefix(path, prefix) {
  return path.indexOf(prefix) === 0 ? path.substr(prefix.length) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 144 */
/***/ (function(module, exports) {


var indexOf = [].indexOf;

module.exports = function(arr, obj){
  if (indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = format;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_formatter__ = __webpack_require__(148);


// Formats `value` value preserving `caret` at the same character.
//
// `{ value, caret }` attribute is the result of `parse()` function call.
//
// Returns `{ text, caret }` where the new `caret` is the caret position
// inside `text` text corresponding to the original `caret` position inside `value`.
//
// `formatter(value)` is a function returning `{ text, template }`.
//
// `text` is the `value` value formatted using `template`.
// It may either cut off the non-filled right part of the `template`
// or it may fill the non-filled character placeholders
// in the right part of the `template` with `spacer`
// which is a space (' ') character by default.
//
// `template` is the template used to format the `value`.
// It can be either a full-length template or a partial template.
//
// `formatter` can also be a string — a `template`
// where character placeholders are denoted by 'x'es.
// In this case `formatter` function is automatically created.
//
// Example:
//
// `value` is '880',
// `caret` is `2` (before the first `0`)
//
// `formatter` is `'880' =>
//   { text: '8 (80 )', template: 'x (xxx) xxx-xx-xx' }`
//
// The result is `{ text: '8 (80 )', caret: 4 }`.
//
function format(value, caret, formatter) {
	if (typeof formatter === 'string') {
		formatter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__template_formatter__["a" /* default */])(formatter);
	}

	var _ref = formatter(value) || {},
	    text = _ref.text,
	    template = _ref.template;

	if (text === undefined) {
		text = value;
	}

	if (template) {
		if (caret === undefined) {
			caret = text.length;
		} else {
			var index = 0;
			var found = false;

			var possibly_last_input_character_index = -1;

			while (index < text.length && index < template.length) {
				// Character placeholder found
				if (text[index] !== template[index]) {
					if (caret === 0) {
						found = true;
						caret = index;
						break;
					}

					possibly_last_input_character_index = index;

					caret--;
				}

				index++;
			}

			// If the caret was positioned after last input character,
			// then the text caret index is just after the last input character.
			if (!found) {
				caret = possibly_last_input_character_index + 1;
			}
		}
	}

	return { text: text, caret: caret };
}
//# sourceMappingURL=format.js.map

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__edit__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parse__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__format__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dom__ = __webpack_require__(372);








var Input_controller = function () {
	function Input_controller(get_input_element, parse, format, on_change) {
		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Input_controller);

		_initialiseProps.call(this);

		if (typeof get_input_element !== 'function') {
			(function () {
				var element = get_input_element;
				get_input_element = function get_input_element() {
					return element;
				};
			})();
		}

		this.get_input_element = get_input_element;
		this.parse = parse;
		this.format = format;
		this.on_change = on_change;
	}

	// Special handling for "Cut" event because
	// it wouldn't copy to clipboard otherwise.


	// Intercepts "Delete" and "Backspace" keys
	// (hitting "Delete" or "Backspace"
	//  at any caret position should always result in
	//  erasing a digit)


	__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Input_controller, [{
		key: 'erase_selection',


		// Erases the selected text inside an `<input/>`
		value: function erase_selection(input, selection) {
			var text = input.value;
			text = text.slice(0, selection.start) + text.slice(selection.end);

			input.value = text;
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dom__["a" /* setCaretPosition */])(input, selection.start);

			return this.format_input_text();
		}

		// Formats <input/> textual value as a phone number

	}, {
		key: 'getParsedValue',


		// Parses `<input/>` text
		value: function getParsedValue() {
			// <input/> DOM element
			var input = this.get_input_element();

			return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__parse__["a" /* default */])(input.value, undefined, this.parse);
		}
	}]);

	return Input_controller;
}();

var _initialiseProps = function _initialiseProps() {
	var _this = this;

	this.onCut = function (event) {
		setTimeout(_this.format_input_text, 0);
	};

	this.onPaste = function (event) {
		var input = _this.get_input_element();

		var selection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dom__["b" /* getSelection */])(input);

		// If selection is made,
		// just erase the selected text
		// prior to pasting
		if (selection) {
			_this.erase_selection(input, selection);
		}

		_this.format_input_text();
	};

	this.onChange = function (event) {
		_this.format_input_text();
	};

	this.onKeyDown = function (event) {
		var operation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dom__["c" /* getOperation */])(event);

		switch (operation) {
			case 'Delete':
			case 'Backspace':
				// Intercept this operation and perform it manually.
				event.preventDefault();

				var input = _this.get_input_element();

				var selection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dom__["b" /* getSelection */])(input);

				// If selection is made,
				// just erase the selected text,
				// and don't apply any more operations to it.
				if (selection) {
					_this.erase_selection(input, selection);
					return _this.format_input_text();
				}

				// Else, perform the (character erasing) operation manually
				return _this.format_input_text(operation);
		}
	};

	this.format_input_text = function (operation) {
		// <input/> DOM element
		var input = _this.get_input_element();

		var _parse = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__parse__["a" /* default */])(input.value, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dom__["d" /* getCaretPosition */])(input), _this.parse),
		    value = _parse.value,
		    caret = _parse.caret;

		// Apply the pending operation to the <input/> textual value (if any)


		if (operation) {
			var edit_result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__edit__["a" /* default */])(value, caret, operation);

			value = edit_result.value;
			caret = edit_result.caret;
		}

		// Format the <input/> textual value as a phone number
		// (and reposition the caret accordingly)

		var format_result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__format__["a" /* default */])(value, caret, _this.format);

		var text = format_result.text;
		caret = format_result.caret;

		// Set <input/> textual value manually to also set caret position
		// and prevent React from resetting the caret position later
		// inside subsequent `render()`.
		// Doesn't work for custom `inputComponent`s for some reason.
		input.value = text;
		// Set caret position (with the neccessary adjustments)
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dom__["a" /* setCaretPosition */])(input, caret);

		// <input/> textual value may have been changed,
		// so `value` may have been changed too.
		_this.on_change(value);
	};
};

/* harmony default export */ __webpack_exports__["a"] = (Input_controller);
//# sourceMappingURL=input controller.js.map

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parse;
// Parses the `text`.
//
// Returns `{ value, caret }` where `caret` is
// the caret position inside `value`
// corresponding to the `caret_position` inside `text`.
//
// The `text` is parsed by feeding each character sequentially to
// `parse_character(character, value)` function
// and appending the result (if it's not `undefined`) to `value`.
//
// Example:
//
// `text` is `8 (800) 555-35-35`,
// `caret_position` is `4` (before the first `0`).
// `parse_character` is `(character, value) =>
//   if (character >= '0' && character <= '9') { return character }`.
//
// then `parse()` outputs `{ value: '88005553535', caret: 2 }`.
//
function parse(text, caret_position, parse_character) {
	var value = '';

	var focused_input_character_index = 0;

	var index = 0;
	while (index < text.length) {
		var character = parse_character(text[index], value);

		if (character !== undefined) {
			value += character;

			if (caret_position !== undefined) {
				if (caret_position === index) {
					focused_input_character_index = value.length - 1;
				} else if (caret_position > index) {
					focused_input_character_index = value.length;
				}
			}
		}

		index++;
	}

	// If caret position wasn't specified
	if (caret_position === undefined) {
		// Then set caret position to "after the last input character"
		focused_input_character_index = value.length;
	}

	var result = {
		value: value,
		caret: focused_input_character_index
	};

	return result;
}
//# sourceMappingURL=parse.js.map

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = template_formatter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__close_braces__ = __webpack_require__(371);




// Takes a `template` where character placeholders
// are denoted by 'x'es (e.g. 'x (xxx) xxx-xx-xx').
//
// Returns a function which takes `value` characters
// and returns the `template` filled with those characters.
// If the `template` can only be partially filled
// then it is cut off.
//
// If `should_close_braces` is `true`,
// then it will also make sure all dangling braces are closed,
// e.g. "8 (8" -> "8 (8  )" (iPhone style phone number input).
//
function template_formatter(template) {
	var placeholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'x';
	var should_close_braces = arguments[2];

	if (!template) {
		return function (value) {
			return { text: value };
		};
	}

	var characters_in_template = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* count_occurences */])(placeholder, template);

	return function (value) {
		if (!value) {
			return { text: '', template: template };
		}

		var value_character_index = 0;
		var filled_in_template = '';

		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(template), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var character = _step.value;

				if (character !== placeholder) {
					filled_in_template += character;
					continue;
				}

				filled_in_template += value[value_character_index];
				value_character_index++;

				// If the last available value character has been filled in,
				// then return the filled in template
				// (either trim the right part or retain it,
				//  if no more character placeholders in there)
				if (value_character_index === value.length) {
					// If there are more character placeholders
					// in the right part of the template
					// then simply trim it.
					if (value.length < characters_in_template) {
						break;
					}
				}
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}

		if (should_close_braces) {
			filled_in_template = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__close_braces__["a" /* default */])(filled_in_template, template);
		}

		return { text: filled_in_template, template: template };
	};
}
//# sourceMappingURL=template formatter.js.map

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fnToStr = Function.prototype.toString;

var constructorRegex = /^\s*class /;
var isES6ClassFn = function isES6ClassFn(value) {
	try {
		var fnStr = fnToStr.call(value);
		var singleStripped = fnStr.replace(/\/\/.*\n/g, '');
		var multiStripped = singleStripped.replace(/\/\*[.\s\S]*\*\//g, '');
		var spaceStripped = multiStripped.replace(/\n/mg, ' ').replace(/ {2}/g, ' ');
		return constructorRegex.test(spaceStripped);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionObject(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isCallable(value) {
	if (!value) { return false; }
	if (typeof value !== 'function' && typeof value !== 'object') { return false; }
	if (hasToStringTag) { return tryFunctionObject(value); }
	if (isES6ClassFn(value)) { return false; }
	var strClass = toStr.call(value);
	return strClass === fnClass || strClass === genClass;
};


/***/ }),
/* 151 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports = {"country_phone_code_to_countries":{"1":["US","AG","AI","AS","BB","BM","BS","CA","DM","DO","GD","GU","JM","KN","KY","LC","MP","MS","PR","SX","TC","TT","VC","VG","VI"],"7":["RU","KZ"],"20":["EG"],"27":["ZA"],"30":["GR"],"31":["NL"],"32":["BE"],"33":["FR"],"34":["ES"],"36":["HU"],"39":["IT","VA"],"40":["RO"],"41":["CH"],"43":["AT"],"44":["GB","GG","IM","JE"],"45":["DK"],"46":["SE"],"47":["NO","SJ"],"48":["PL"],"49":["DE"],"51":["PE"],"52":["MX"],"53":["CU"],"54":["AR"],"55":["BR"],"56":["CL"],"57":["CO"],"58":["VE"],"60":["MY"],"61":["AU","CC","CX"],"62":["ID"],"63":["PH"],"64":["NZ"],"65":["SG"],"66":["TH"],"81":["JP"],"82":["KR"],"84":["VN"],"86":["CN"],"90":["TR"],"91":["IN"],"92":["PK"],"93":["AF"],"94":["LK"],"95":["MM"],"98":["IR"],"211":["SS"],"212":["MA","EH"],"213":["DZ"],"216":["TN"],"218":["LY"],"220":["GM"],"221":["SN"],"222":["MR"],"223":["ML"],"224":["GN"],"225":["CI"],"226":["BF"],"227":["NE"],"228":["TG"],"229":["BJ"],"230":["MU"],"231":["LR"],"232":["SL"],"233":["GH"],"234":["NG"],"235":["TD"],"236":["CF"],"237":["CM"],"238":["CV"],"239":["ST"],"240":["GQ"],"241":["GA"],"242":["CG"],"243":["CD"],"244":["AO"],"245":["GW"],"246":["IO"],"247":["AC"],"248":["SC"],"249":["SD"],"250":["RW"],"251":["ET"],"252":["SO"],"253":["DJ"],"254":["KE"],"255":["TZ"],"256":["UG"],"257":["BI"],"258":["MZ"],"260":["ZM"],"261":["MG"],"262":["RE","YT"],"263":["ZW"],"264":["NA"],"265":["MW"],"266":["LS"],"267":["BW"],"268":["SZ"],"269":["KM"],"290":["SH","TA"],"291":["ER"],"297":["AW"],"298":["FO"],"299":["GL"],"350":["GI"],"351":["PT"],"352":["LU"],"353":["IE"],"354":["IS"],"355":["AL"],"356":["MT"],"357":["CY"],"358":["FI","AX"],"359":["BG"],"370":["LT"],"371":["LV"],"372":["EE"],"373":["MD"],"374":["AM"],"375":["BY"],"376":["AD"],"377":["MC"],"378":["SM"],"380":["UA"],"381":["RS"],"382":["ME"],"385":["HR"],"386":["SI"],"387":["BA"],"389":["MK"],"420":["CZ"],"421":["SK"],"423":["LI"],"500":["FK"],"501":["BZ"],"502":["GT"],"503":["SV"],"504":["HN"],"505":["NI"],"506":["CR"],"507":["PA"],"508":["PM"],"509":["HT"],"590":["GP","BL","MF"],"591":["BO"],"592":["GY"],"593":["EC"],"594":["GF"],"595":["PY"],"596":["MQ"],"597":["SR"],"598":["UY"],"599":["CW","BQ"],"670":["TL"],"672":["NF"],"673":["BN"],"674":["NR"],"675":["PG"],"676":["TO"],"677":["SB"],"678":["VU"],"679":["FJ"],"680":["PW"],"681":["WF"],"682":["CK"],"683":["NU"],"685":["WS"],"686":["KI"],"687":["NC"],"688":["TV"],"689":["PF"],"690":["TK"],"691":["FM"],"692":["MH"],"800":["001"],"808":["001"],"850":["KP"],"852":["HK"],"853":["MO"],"855":["KH"],"856":["LA"],"870":["001"],"878":["001"],"880":["BD"],"881":["001"],"882":["001"],"883":["001"],"886":["TW"],"888":["001"],"960":["MV"],"961":["LB"],"962":["JO"],"963":["SY"],"964":["IQ"],"965":["KW"],"966":["SA"],"967":["YE"],"968":["OM"],"970":["PS"],"971":["AE"],"972":["IL"],"973":["BH"],"974":["QA"],"975":["BT"],"976":["MN"],"977":["NP"],"979":["001"],"992":["TJ"],"993":["TM"],"994":["AZ"],"995":["GE"],"996":["KG"],"998":["UZ"]},"countries":{"AC":["247","[46]\\d{4}|[01589]\\d{5}"],"AD":["376","[16]\\d{5,8}|[37-9]\\d{5}",[["(\\d{3})(\\d{3})","$1 $2",["[137-9]|6[0-8]"]],["(\\d{4})(\\d{4})","$1 $2",["180","180[02]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["690"]]]],"AE":["971","[2-79]\\d{7,8}|800\\d{2,9}",[["([2-4679])(\\d{3})(\\d{4})","$1 $2 $3",["[2-4679][2-8]"]],["(5\\d)(\\d{3})(\\d{4})","$1 $2 $3",["5"]],["([479]00)(\\d)(\\d{5})","$1 $2 $3",["[479]00"],"$1"],["([68]00)(\\d{2,9})","$1 $2",["[68]00"],"$1"]],"0","0$1"],"AF":["93","[2-7]\\d{8}",[["([2-7]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"]]],"0","0$1"],"AG":["1","[2589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"268"],"AI":["1","[2589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"264"],"AL":["355","[2-57]\\d{7}|6\\d{8}|8\\d{5,7}|9\\d{5}",[["(4)(\\d{3})(\\d{4})","$1 $2 $3",["4[0-6]"]],["(6\\d)(\\d{3})(\\d{4})","$1 $2 $3",["6"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4[7-9]"]],["(\\d{3})(\\d{3,5})","$1 $2",["[235][16-9]|[79]|8[016-9]"]]],"0","0$1"],"AM":["374","[1-9]\\d{7}",[["(\\d{2})(\\d{6})","$1 $2",["1|47"]],["(\\d{2})(\\d{6})","$1 $2",["4[1349]|[5-7]|88|9[1-9]"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["[23]"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["8|90"],"0 $1"]],"0","(0$1)"],"AO":["244","[29]\\d{8}",[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3"]]],"AR":["54","11\\d{8}|[2368]\\d{9}|9\\d{10}",[["([68]\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"]],["(9)(11)(\\d{4})(\\d{4})","$2 15-$3-$4",["911"],null,null,"$1 $2 $3-$4"],["(9)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9(?:2[2-4689]|3[3-8])","9(?:2(?:2[013]|3[067]|49|6[01346]|8|9[147-9])|3(?:36|4[1-358]|5[138]|6|7[069]|8[013578]))","9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[4-6]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))","9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1-39])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))"],null,null,"$1 $2 $3-$4"],["(9)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9[23]"],null,null,"$1 $2 $3-$4"],["(11)(\\d{4})(\\d{4})","$1 $2-$3",["11"],null,"true"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["2(?:2[013]|3[067]|49|6[01346]|8|9[147-9])|3(?:36|4[1-358]|5[138]|6|7[069]|8[013578])","2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[4-6]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))","2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1-39])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))"],null,"true"],["(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["[23]"],null,"true"]],"0","0$1","0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))?15)?","9$1"],"AS":["1","[5689]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"684"],"AT":["43","[1-9]\\d{3,12}",[["(116\\d{3})","$1",["116"],"$1"],["(1)(\\d{3,12})","$1 $2",["1"]],["(5\\d)(\\d{3,5})","$1 $2",["5[079]"]],["(5\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["5[079]"]],["(5\\d)(\\d{4})(\\d{4,7})","$1 $2 $3",["5[079]"]],["(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:[28]0|32)|[89]"]],["(\\d{4})(\\d{3,9})","$1 $2",["2|3(?:1[1-578]|[3-8])|4[2378]|5[2-6]|6(?:[12]|4[1-9]|5[468])|7(?:[24][1-8]|35|[5-79])"]]],"0","0$1"],"AU":["61","1\\d{4,9}|[2-578]\\d{8}",[["([2378])(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|[45]"],"0$1"],["(16)(\\d{3,4})","$1 $2",["16"],"0$1"],["(16)(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(1[389]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["1[389]0","1(?:[38]0|9)0"]],["(180)(2\\d{3})","$1 $2",["180","1802"]],["(19\\d)(\\d{3})","$1 $2",["19[13]"]],["(19\\d{2})(\\d{4})","$1 $2",["19[679]"]],["(13)(\\d{2})(\\d{2})","$1 $2 $3",["13[1-9]"]]],"0",null,null,null,null,null,["[237]\\d{8}|8(?:51(?:0(?:0[03-9]|[1247]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-6])|1(?:1[69]|[23]\\d|4[0-4]))|[6-8]\\d{4}|9(?:[02-9]\\d{3}|1(?:[0-57-9]\\d{2}|6[0135-9]\\d)))\\d{3}","14(?:5\\d|71)\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[12457-9]|9[017-9])\\d{6}","180(?:0\\d{3}|2)\\d{3}","19(?:0[0126]\\d|[679])\\d{5}","500\\d{6}",null,null,"16\\d{3,7}","550\\d{6}","13(?:00\\d{3}|45[0-4]|\\d)\\d{3}"]],"AW":["297","[25-9]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"AX":["358","[13]\\d{5,9}|2\\d{4,9}|4\\d{6,10}|5\\d{6,9}|[67]\\d{7,9}|8\\d{7,8}",[["(\\d{3})(\\d{3,7})","$1 $2",["(?:[1-3]0|[6-8])0"]],["(116\\d{3})","$1",["116"],"$1"],["(\\d{2})(\\d{3,9})","$1 $2",["1(?:0[1-9]|[3-9])|2(?:0[1-9]|9)|30[1-9]|4|50|7(?:[13]|5[03-9])"]],["(\\d)(\\d{4})","$1 $2",["9[1-8]"]],["(\\d)(\\d{5,9})","$1 $2",["[235689][1-8]"]],["(39\\d)(\\d{3})(\\d{3})","$1 $2 $3",["39"]]],"0",null,null,null,null,null,["18[1-8]\\d{4,6}","4(?:[0-8]\\d{5,8}|9\\d{9})|50\\d{6,8}","800\\d{5,6}","[67]00\\d{5,6}",null,null,"10(?:0\\d{4,6}|[1-37-9]\\d{5,7}|[46]\\d{3,7}|5\\d{4,7})|2(?:0(?:0\\d{4,6}|[1346-8]\\d{5,7}|2(?:[023]\\d{4,5}|[14-9]\\d{4,6})|5(?:\\d{3}|\\d{5,7})|9(?:[0-7]\\d{4,6}|[89]\\d{1,6}))|9\\d{5,8})|3(?:0(?:0\\d{3,7}|[1-57-9]\\d{5,7}|6(?:\\d{3}|\\d{5,7}))|44\\d{3}|93\\d{5,7})|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{5,6})"]],"AZ":["994","[1-9]\\d{8}",[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2(?:[0-36]|[45]2)|365"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[4-8]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"]],"0","(0$1)"],"BA":["387","[3-9]\\d{7,8}",[["(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-356]|[7-9]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6[047]"]]],"0","0$1"],"BB":["1","[2589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"246"],"BD":["880","[2-79]\\d{5,9}|1\\d{9}|8[0-7]\\d{4,8}",[["(2)(\\d{7,8})","$1-$2",["2"]],["(\\d{2})(\\d{4,6})","$1-$2",["[3-79]1"]],["(\\d{4})(\\d{3,6})","$1-$2",["1|3(?:0|[2-58]2)|4(?:0|[25]2|3[23]|[4689][25])|5(?:[02-578]2|6[25])|6(?:[0347-9]2|[26][25])|7[02-9]2|8(?:[023][23]|[4-7]2)|9(?:[02][23]|[458]2|6[016])"]],["(\\d{3})(\\d{3,7})","$1-$2",["[3-79][2-9]|8"]]],"0","0$1"],"BE":["32","[1-9]\\d{7,8}",[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4[6-9]"]],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[23]|4[23]|9[2-4]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[156]|7[018]|8(?:0[1-9]|[1-79])"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"]]],"0","0$1"],"BF":["226","[25-7]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"BG":["359","[23567]\\d{5,7}|[489]\\d{6,8}",[["(2)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"]],["(2)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"]],["(\\d{3})(\\d{4})","$1 $2",["43[124-7]|70[1-9]"]],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[124-7]|70[1-9]"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[78]00"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["99[69]"]],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"]],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["48|8[7-9]|9[08]"]]],"0","0$1"],"BH":["973","[136-9]\\d{7}",[["(\\d{4})(\\d{4})","$1 $2"]]],"BI":["257","[267]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"BJ":["229","[2689]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2689]"]]]],"BL":["590","[56]\\d{8}",[["([56]90)(\\d{2})(\\d{4})","$1 $2-$3",["[56]90"]]],"0",null,null,null,null,null,["590(?:2[7-9]|5[12]|87)\\d{4}","690(?:0[05-9]|[1-9]\\d)\\d{4}"]],"BM":["1","[4589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"441"],"BN":["673","[2-578]\\d{6}",[["([2-578]\\d{2})(\\d{4})","$1 $2",["[2-578]"]]]],"BO":["591","[23467]\\d{7}|8\\d{8}",[["([234])(\\d{7})","$1 $2",["[2-4]"]],["([67]\\d{7})","$1",["[67]"]],["(800)(\\d{2})(\\d{4})","$1 $2 $3",["800"]]],"0",null,"0(1\\d)?"],"BQ":["599","[347]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2",["[13-7]"]],["(9)(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],null,null,null,null,null,null,["(?:318[023]|41(?:6[023]|70)|7(?:1[578]|50)\\d)\\d{3}","(?:31(?:8[14-8]|9[14578])|416[145-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}"]],"BR":["55","[1-46-9]\\d{7,10}|5(?:[0-4]\\d{7,9}|5(?:[2-8]\\d{7}|9\\d{7,8}))",[["(\\d{4})(\\d{4})","$1-$2",["300|40[02]","300|40(?:0|20)"]],["([3589]00)(\\d{2,3})(\\d{4})","$1 $2 $3",["[3589]00"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["[1-9][1-9]"],"($1)"],["(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[1-9][1-9]9"],"($1)"]],"0",null,"0(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2"],"BS":["1","[2589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"242"],"BT":["975","[1-8]\\d{6,7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1|77"]],["([2-8])(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]]]],"BW":["267","[2-79]\\d{6,7}",[["(\\d{3})(\\d{4})","$1 $2",["[2-6]"]],["(7\\d)(\\d{3})(\\d{3})","$1 $2 $3",["7"]],["(90)(\\d{5})","$1 $2",["90"]]]],"BY":["375","[1-4]\\d{8}|8(?:0(?:0\\d{3,7}|[13]\\d{7})|(?:10|20\\d)\\d{7})|9\\d{9,10}",[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["17[0-3589]|2[4-9]|[34]","17(?:[02358]|1[0-2]|9[0189])|2[4-9]|[34]"],"8 0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:5[24]|6[235]|7[467])|2(?:1[246]|2[25]|3[26])","1(?:5[24]|6(?:2|3[04-9]|5[0346-9])|7(?:[46]|7[37-9]))|2(?:1[246]|2[25]|3[26])"],"8 0$1"],["(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],"8 0$1"],["([89]\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8[01]|9"],"8 $1"],["(82\\d)(\\d{4})(\\d{4})","$1 $2 $3",["82"],"8 $1"],["(800)(\\d{3})","$1 $2",["800"],"8 $1"],["(800)(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"]],"8",null,"8?0?"],"BZ":["501","[2-8]\\d{6}|0\\d{10}",[["(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],["(0)(800)(\\d{4})(\\d{3})","$1-$2-$3-$4",["080","0800"]]]],"CA":["1","[2-9]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,null,["(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:0[04]|13|22|39|47)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",null,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}","900[2-9]\\d{6}","5(?:00|22|33|44|66|77|88)[2-9]\\d{6}"]],"CC":["61","[1458]\\d{5,9}",[["([2378])(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|[45]"],"0$1"],["(16)(\\d{3,4})","$1 $2",["16"],"0$1"],["(16)(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(1[389]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["1[389]0","1(?:[38]0|9)0"]],["(180)(2\\d{3})","$1 $2",["180","1802"]],["(19\\d)(\\d{3})","$1 $2",["19[13]"]],["(19\\d{2})(\\d{4})","$1 $2",["19[679]"]],["(13)(\\d{2})(\\d{2})","$1 $2 $3",["13[1-9]"]]],"0",null,null,null,null,null,["89162\\d{4}","14(?:5\\d|71)\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[12547-9]|9[017-9])\\d{6}","180(?:0\\d{3}|2)\\d{3}","19(?:0[0126]\\d|[679])\\d{5}","500\\d{6}",null,null,null,"550\\d{6}","13(?:00\\d{2})?\\d{4}"]],"CD":["243","[2-6]\\d{6}|[18]\\d{6,8}|9\\d{8}",[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["12"]],["([89]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8[0-2459]|9"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"]],["(\\d{2})(\\d{5})","$1 $2",["[1-6]"]]],"0","0$1"],"CF":["236","[278]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"CG":["242","[028]\\d{8}",[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["801"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["800"]]]],"CH":["41","[2-9]\\d{8}|860\\d{9}",[["([2-9]\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]|[89]1"]],["([89]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"]],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["860"]]],"0","0$1"],"CI":["225","[02-8]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"CK":["682","[2-8]\\d{4}",[["(\\d{2})(\\d{3})","$1 $2"]]],"CL":["56","1230\\d{7}|[2-46-9]\\d{8,10}|5[1-3578]\\d{7}",[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[23]"],"($1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[357]|4[1-35]|6[13-57]"],"($1)"],["(9)(\\d{4})(\\d{4})","$1 $2 $3",["9"]],["(44)(\\d{3})(\\d{4})","$1 $2 $3",["44"]],["([68]00)(\\d{3})(\\d{3,4})","$1 $2 $3",["[68]00"],"$1"],["(600)(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["600"],"$1"],["(1230)(\\d{3})(\\d{4})","$1 $2 $3",["123","1230"],"$1"],["(\\d{5})(\\d{4})","$1 $2",["219"],"($1)"]],"0","0$1","0|(1(?:1[0-69]|2[0-57]|5[13-58]|69|7[0167]|8[018]))"],"CM":["237","[2368]\\d{7,8}",[["([26])(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[23]|88"]]]],"CN":["86","[1-7]\\d{6,11}|8[0-357-9]\\d{6,9}|9\\d{7,10}",[["(80\\d{2})(\\d{4})","$1 $2",["80[26-8]"],"0$1","true"],["([48]00)(\\d{3})(\\d{4})","$1 $2 $3",["[48]00"]],["(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2\\d)[19]","(?:10|2\\d)(?:10|9[56])","(?:10|2\\d)(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{5,6})","$1 $2",["[3-9]","[3-9]\\d\\d[19]","[3-9]\\d\\d(?:10|9[56])"],"0$1"],["(21)(\\d{4})(\\d{4,6})","$1 $2 $3",["21"],"0$1","true"],["([12]\\d)(\\d{4})(\\d{4})","$1 $2 $3",["10[1-9]|2[02-9]","10[1-9]|2[02-9]","10(?:[1-79]|8(?:0[1-9]|[1-9]))|2[02-9]"],"0$1","true"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:1[02-9]|35|49|5|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|[35][2-9]|6[47-9]|7|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[04-9]|4[3-6]|6[2368])|8(?:1[236-8]|2[5-7]|3|5[1-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])"],"0$1","true"],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["3(?:11|7[179])|4(?:[15]1|3[1-35])|5(?:1|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[457]|6[09])|8(?:[57]1|98)"],"0$1","true"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["807","8078"],"0$1","true"],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1(?:[3-57-9]|66)"]],["(10800)(\\d{3})(\\d{4})","$1 $2 $3",["108","1080","10800"]],["(\\d{3})(\\d{7,8})","$1 $2",["950"]]],"0",null,"(1(?:[129]\\d{3}|79\\d{2}))|0"],"CO":["57","(?:[13]\\d{0,3}|[24-8])\\d{7}",[["(\\d)(\\d{7})","$1 $2",["1(?:[2-7]|8[2-9]|9[0-3])|[24-8]","1(?:[2-7]|8[2-9]|9(?:09|[1-3]))|[24-8]"],"($1)"],["(\\d{3})(\\d{7})","$1 $2",["3"]],["(1)(\\d{3})(\\d{7})","$1-$2-$3",["1(?:80|9[04])","1(?:800|9(?:0[01]|4[78]))"],"0$1",null,"$1 $2 $3"]],"0",null,"0([3579]|4(?:44|56))?"],"CR":["506","[24-9]\\d{7,9}",[["(\\d{4})(\\d{4})","$1 $2",["[24-7]|8[3-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]0"]]],null,null,"(19(?:0[012468]|1[09]|20|66|77|99))"],"CU":["53","[2-57]\\d{5,7}",[["(\\d)(\\d{6,7})","$1 $2",["7"]],["(\\d{2})(\\d{4,6})","$1 $2",["[2-4]"]],["(\\d)(\\d{7})","$1 $2",["5"],"0$1"]],"0","(0$1)"],"CV":["238","[259]\\d{6}",[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3"]]],"CW":["599","[134679]\\d{6,7}",[["(\\d{3})(\\d{4})","$1 $2",["[13-7]"]],["(9)(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],null,null,null,null,null,null,["9(?:[48]\\d{2}|50\\d|7(?:2[0-24]|[34]\\d|6[35-7]|77|8[7-9]))\\d{4}","9(?:5(?:[12467]\\d|3[01])|6(?:[15-9]\\d|3[01]))\\d{4}",null,null,null,null,null,"955\\d{5}",null,"60[0-2]\\d{4}"]],"CX":["61","[1458]\\d{5,9}",[["([2378])(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|[45]"],"0$1"],["(16)(\\d{3,4})","$1 $2",["16"],"0$1"],["(16)(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(1[389]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["1[389]0","1(?:[38]0|9)0"]],["(180)(2\\d{3})","$1 $2",["180","1802"]],["(19\\d)(\\d{3})","$1 $2",["19[13]"]],["(19\\d{2})(\\d{4})","$1 $2",["19[679]"]],["(13)(\\d{2})(\\d{2})","$1 $2 $3",["13[1-9]"]]],"0",null,null,null,null,null,["89164\\d{4}","14(?:5\\d|71)\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[12547-9]|9[017-9])\\d{6}","180(?:0\\d{3}|2)\\d{3}","19(?:0[0126]\\d|[679])\\d{5}","500\\d{6}",null,null,null,"550\\d{6}","13(?:00\\d{2})?\\d{4}"]],"CY":["357","[257-9]\\d{7}",[["(\\d{2})(\\d{6})","$1 $2"]]],"CZ":["420","[2-8]\\d{8}|9\\d{8,11}",[["([2-9]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],["(96\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["96"]],["(9\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9[36]"]]]],"DE":["49","[1-35-9]\\d{3,14}|4(?:[0-8]\\d{3,12}|9(?:[0-37]\\d|4(?:[1-35-8]|4\\d?)|5\\d{1,2}|6[1-8]\\d?)\\d{2,8})",[["(1\\d{2})(\\d{7,8})","$1 $2",["1[67]"]],["(15\\d{3})(\\d{6})","$1 $2",["15[0568]"]],["(1\\d{3})(\\d{7})","$1 $2",["15"]],["(\\d{2})(\\d{3,11})","$1 $2",["3[02]|40|[68]9"]],["(\\d{3})(\\d{3,11})","$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14]|[4-9]1)|3(?:[35-9][15]|4[015])|[4-8][1-9]1|9(?:06|[1-9]1)"]],["(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|[7-9](?:0[1-9]|[1-9])","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|[46][1246]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|3[1357]|4[13578]|6[1246]|7[1356]|9[1346])|5(?:0[14]|2[1-3589]|3[1357]|[49][1246]|6[1-4]|7[1346]|8[13568])|6(?:0[356]|2[1-489]|3[124-6]|4[1347]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|3[1357]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|4[1347]|6[0135-9]|7[1467]|8[136])|9(?:0[12479]|2[1358]|3[1357]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|[7-9](?:0[1-9]|[1-9])"]],["(3\\d{4})(\\d{1,10})","$1 $2",["3"]],["(800)(\\d{7,12})","$1 $2",["800"]],["(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["1(?:37|80)|900","1(?:37|80)|900[1359]"]],["(1\\d{2})(\\d{5,11})","$1 $2",["181"]],["(18\\d{3})(\\d{6})","$1 $2",["185","1850","18500"]],["(18\\d{2})(\\d{7})","$1 $2",["18[68]"]],["(18\\d)(\\d{8})","$1 $2",["18[2-579]"]],["(700)(\\d{4})(\\d{4})","$1 $2 $3",["700"]],["(138)(\\d{4})","$1 $2",["138"]],["(15[013-68])(\\d{2})(\\d{8})","$1 $2 $3",["15[013-68]"]],["(15[279]\\d)(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"]],["(1[67]\\d)(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"]]],"0","0$1"],"DJ":["253","[27]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"DK":["45","[2-9]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"DM":["1","[57-9]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"767"],"DO":["1","[589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"8[024]9"],"DZ":["213","(?:[1-4]|[5-9]\\d)\\d{7}",[["([1-4]\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"]],["([5-8]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"]],["(9\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"]]],"0","0$1"],"EC":["593","1\\d{9,10}|[2-8]\\d{7}|9\\d{8}",[["(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[247]|[356][2-8]"],null,null,"$1-$2-$3"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],["(1800)(\\d{3})(\\d{3,4})","$1 $2 $3",["180","1800"],"$1"]],"0","(0$1)"],"EE":["372","[3-9]\\d{6,7}|800\\d{6,7}",[["([3-79]\\d{2})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]"]],["(70)(\\d{2})(\\d{4})","$1 $2 $3",["70"]],["(8000)(\\d{3})(\\d{3})","$1 $2 $3",["800","8000"]],["([458]\\d{3})(\\d{3,4})","$1 $2",["40|5|8(?:00|[1-5])","40|5|8(?:00[1-9]|[1-5])"]]]],"EG":["20","1\\d{4,9}|[24-6]\\d{8}|3\\d{7}|[89]\\d{8,9}",[["(\\d)(\\d{7,8})","$1 $2",["[23]"]],["(\\d{2})(\\d{6,7})","$1 $2",["1(?:3|5[239])|[4-6]|[89][2-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1[0-25]|[89]00"]]],"0","0$1"],"EH":["212","[5-9]\\d{8}",[["([5-7]\\d{2})(\\d{6})","$1-$2",["5(?:2[015-7]|3[0-4])|[67]"]],["([58]\\d{3})(\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9]|92)|892","5(?:2(?:[2-48]|9[0-7])|3(?:[5-79]|8[0-7])|924)|892"]],["(5\\d{4})(\\d{4})","$1-$2",["5(?:29|38)","5(?:29|38)[89]"]],["([5]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:4[067]|5[03])"]],["(8[09])(\\d{7})","$1-$2",["8(?:0|9[013-9])"]]],"0",null,null,null,null,"528[89]"],"ER":["291","[178]\\d{6}",[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3"]],"0","0$1"],"ES":["34","[5-9]\\d{8}",[["([89]00)(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],["([5-9]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[568]|[79][0-8]"]]]],"ET":["251","[1-59]\\d{8}",[["([1-59]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[1-59]"]]],"0","0$1"],"FI":["358","1\\d{5,9}|2\\d{4,9}|[35]\\d{5,9}|4\\d{5,10}|6\\d{6,9}|7\\d{7,9}|8\\d{6,8}|9\\d{4,8}",[["(\\d{3})(\\d{3,7})","$1 $2",["(?:[1-3]0|[6-8])0"]],["(116\\d{3})","$1",["116"],"$1"],["(\\d{2})(\\d{3,9})","$1 $2",["1(?:0[1-9]|[3-9])|2(?:0[1-9]|9)|30[1-9]|4|50|7(?:[13]|5[03-9])"]],["(\\d)(\\d{4})","$1 $2",["9[1-8]"]],["(\\d)(\\d{5,9})","$1 $2",["[235689][1-8]"]],["(39\\d)(\\d{3})(\\d{3})","$1 $2 $3",["39"]]],"0","0$1",null,null,null,null,["1[3-79][1-8]\\d{4,6}|[23568][1-8]\\d{5,7}|9[1-8]\\d{3,7}","4[0-8]\\d{5,8}|50\\d{4,8}","800\\d{5,6}","[67]00\\d{5,6}",null,null,"10(?:0\\d{4,6}|[1-37-9]\\d{5,7}|[46]\\d{3,7}|5\\d{4,7})|2(?:0(?:0\\d{4,6}|[1346-8]\\d{5,7}|2(?:[023]\\d{4,5}|[14-9]\\d{4,6})|5(?:\\d{3}|\\d{5,7})|9(?:[0-7]\\d{4,6}|[89]\\d{1,6}))|9\\d{5,8})|3(?:0(?:0\\d{3,7}|[1-57-9]\\d{5,7}|6(?:\\d{3}|\\d{5,7}))|44\\d{3}|93\\d{5,7})|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{5,6})"]],"FJ":["679","[2-9]\\d{6}|0\\d{10}",[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]]],"FK":["500","[2-7]\\d{4}"],"FM":["691","[39]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"FO":["298","[2-9]\\d{5}",[["(\\d{6})","$1"]],null,null,"(10(?:01|[12]0|88))"],"FR":["33","[1-9]\\d{8}",[["([1-79])(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"]],["(8\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"]],"0","0$1"],"GA":["241","0?\\d{7}",[["(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]]]],"GB":["44","\\d{7,10}",[["(7\\d{3})(\\d{6})","$1 $2",["7(?:[1-57-9]|62)","7(?:[1-57-9]|624)"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2|5[56]|7[06]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:[02-9]1|1)|3|9[018]"]],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"]],["(1\\d{3})(\\d{5,6})","$1 $2",["1"]],["(800)(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"]],["(845)(46)(4\\d)","$1 $2 $3",["845","8454","84546","845464"]],["(8\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8(?:4[2-5]|7[0-3])"]],["(80\\d)(\\d{3})(\\d{4})","$1 $2 $3",["80"]],["(800)(\\d{6})","$1 $2",["800"]]],"0","0$1",null,null,null,null,["2(?:0[01378]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{7}|1(?:1(?:3[0-48]|[46][0-4]|5[0-26-9]|[78][0-49])|21[0-7]|31[0-8]|[4-69]1\\d)\\d{6}|1(?:2(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)|3(?:0\\d|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[28][02-57-9]|[37]\\d|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|2[024-9]|3[015689]|4[02-9]|5[03-9]|6\\d|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0124578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|8\\d|9[2-57]))\\d{6}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[345])))|3(?:638[2-5]|647[23]|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[123]))|5(?:24(?:3[2-79]|6\\d)|276\\d|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[567]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|955[0-4])|7(?:26(?:6[13-9]|7[0-7])|442\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|84(?:3[2-58]))|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}|176888[2-46-8]\\d{2}|16977[23]\\d{3}","7(?:[1-3]\\d{3}|4(?:[0-46-9]\\d{2}|5(?:[0-689]\\d|7[0-57-9]))|5(?:0[0-8]|[13-9]\\d|2[0-35-9])\\d|7(?:0(?:0[01]|[1-9]\\d)|[1-7]\\d{2}|8[02-9]\\d|9[0-689]\\d)|8(?:[014-9]\\d|[23][0-8])\\d|9(?:[024-9]\\d{2}|1(?:[02-9]\\d|1[028])|3[0-689]\\d))\\d{5}","80(?:0(?:1111|\\d{6,7})|8\\d{7})","(?:87[123]|9(?:[01]\\d|8[2349]))\\d{7}","70\\d{8}",null,"(?:3[0347]|55)\\d{8}","76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}","56\\d{8}","8(?:4(?:5464\\d|[2-5]\\d{7})|70\\d{7})"]],"GD":["1","[4589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"473"],"GE":["995","[34578]\\d{8}",[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5"]]],"0"],"GF":["594","[56]\\d{8}",[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]],"0","0$1"],"GG":["44","[135789]\\d{6,9}",[["(7\\d{3})(\\d{6})","$1 $2",["7(?:[1-57-9]|62)","7(?:[1-57-9]|624)"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2|5[56]|7[06]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:[02-9]1|1)|3|9[018]"]],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"]],["(1\\d{3})(\\d{5,6})","$1 $2",["1"]],["(800)(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"]],["(845)(46)(4\\d)","$1 $2 $3",["845","8454","84546","845464"]],["(8\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8(?:4[2-5]|7[0-3])"]],["(80\\d)(\\d{3})(\\d{4})","$1 $2 $3",["80"]],["(800)(\\d{6})","$1 $2",["800"]]],"0",null,null,null,null,null,["1481[25-9]\\d{5}","7(?:781\\d|839\\d|911[17])\\d{5}","80(?:0(?:1111|\\d{6,7})|8\\d{7})","(?:87[123]|9(?:[01]\\d|8[0-3]))\\d{7}","70\\d{8}",null,"(?:3[0347]|55)\\d{8}","76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}","56\\d{8}","8(?:4(?:5464\\d|[2-5]\\d{7})|70\\d{7})"]],"GH":["233","[235]\\d{8}|8\\d{7}",[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{5})","$1 $2",["8"]]],"0","0$1"],"GI":["350","[256]\\d{7}",[["(\\d{3})(\\d{5})","$1 $2",["2"]]]],"GL":["299","[1-689]\\d{5}",[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3"]]],"GM":["220","[2-9]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"GN":["224","[367]\\d{7,8}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[67]"]]]],"GP":["590","[56]\\d{8}",[["([56]90)(\\d{2})(\\d{4})","$1 $2-$3",["[56]90"]]],"0","0$1",null,null,null,null,["590(?:0[13468]|1[012]|2[0-68]|3[28]|4[0-8]|5[579]|6[0189]|70|8[0-689]|9\\d)\\d{4}","690(?:0[05-9]|[1-9]\\d)\\d{4}"]],"GQ":["240","[23589]\\d{8}",[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{6})","$1 $2",["[89]"]]]],"GR":["30","[26-9]\\d{9}",[["([27]\\d)(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["2[2-9]1|[689]"]],["(2\\d{3})(\\d{6})","$1 $2",["2[2-9][02-9]"]]]],"GT":["502","[2-7]\\d{7}|1[89]\\d{9}",[["(\\d{4})(\\d{4})","$1 $2",["[2-7]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"GU":["1","[5689]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"671"],"GW":["245","(?:4(?:0\\d{5}|4\\d{7})|9\\d{8})",[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["44|9[5-7]"]],["(\\d{3})(\\d{4})","$1 $2",["40"]]]],"GY":["592","[2-46-9]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"HK":["852","[2-7]\\d{7}|8[0-3]\\d{6,7}|9\\d{4,10}",[["(\\d{4})(\\d{4})","$1 $2",["[2-7]|[89](?:0[1-9]|[1-9])"]],["(800)(\\d{3})(\\d{3})","$1 $2 $3",["800"]],["(900)(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["900"]],["(900)(\\d{2,5})","$1 $2",["900"]]]],"HN":["504","[237-9]\\d{7}",[["(\\d{4})(\\d{4})","$1-$2"]]],"HR":["385","[1-7]\\d{5,8}|[89]\\d{6,8}",[["(1)(\\d{4})(\\d{3})","$1 $2 $3",["1"]],["([2-5]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-5]"]],["(9\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["9"]],["(6[01])(\\d{2})(\\d{2,3})","$1 $2 $3",["6[01]"]],["([67]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[67]"]],["(80[01])(\\d{2})(\\d{2,3})","$1 $2 $3",["80[01]"]],["(80[01])(\\d{3})(\\d{3})","$1 $2 $3",["80[01]"]]],"0","0$1"],"HT":["509","[2-489]\\d{7}",[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3"]]],"HU":["36","[1-9]\\d{7,8}",[["(1)(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"]]],"06","($1)"],"ID":["62","(?:[1-79]\\d{6,10}|8\\d{7,11})",[["(\\d{2})(\\d{5,8})","$1 $2",["2[124]|[36]1"],"(0$1)"],["(\\d{3})(\\d{5,8})","$1 $2",["2[035-9]|[36][02-9]|[4579]"],"(0$1)"],["(8\\d{2})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"]],["(8\\d{2})(\\d{4})(\\d{4,5})","$1-$2-$3",["8[1-35-9]"]],["(1)(500)(\\d{3})","$1 $2 $3",["150","1500"],"$1"],["(177)(\\d{6,8})","$1 $2",["177"]],["(800)(\\d{5,7})","$1 $2",["800"]],["(804)(\\d{3})(\\d{4})","$1 $2 $3",["804"]],["(80\\d)(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80[79]"]]],"0","0$1"],"IE":["353","[124-9]\\d{6,9}",[["(1)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"]],["(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"]],["(\\d{3})(\\d{5})","$1 $2",["40[24]|50[45]"]],["(48)(\\d{4})(\\d{4})","$1 $2 $3",["48"]],["(818)(\\d{3})(\\d{3})","$1 $2 $3",["818"]],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[24-69]|7[14]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["76|8[35-9]"],"0$1"],["(8\\d)(\\d)(\\d{3})(\\d{4})","$1 $2 $3 $4",["8[35-9]5"],"0$1"],["(700)(\\d{3})(\\d{3})","$1 $2 $3",["700"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:5|8[059])","1(?:5|8[059]0)"],"$1"]],"0","(0$1)"],"IL":["972","1\\d{6,11}|[2-589]\\d{3}(?:\\d{3,6})?|6\\d{3}|7\\d{6,9}",[["([2-489])(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],["([57]\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(153)(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["153"]],["(1)([7-9]\\d{2})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],["(1255)(\\d{3})","$1-$2",["125","1255"]],["(1200)(\\d{3})(\\d{3})","$1-$2-$3",["120","1200"]],["(1212)(\\d{2})(\\d{2})","$1-$2-$3",["121","1212"]],["(1599)(\\d{6})","$1-$2",["159","1599"]],["(151)(\\d{1,2})(\\d{3})(\\d{4})","$1-$2 $3-$4",["151"]],["(\\d{4})","*$1",["[2-689]"]]],"0"],"IM":["44","[135789]\\d{6,9}",[["(7\\d{3})(\\d{6})","$1 $2",["7(?:[1-57-9]|62)","7(?:[1-57-9]|624)"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2|5[56]|7[06]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:[02-9]1|1)|3|9[018]"]],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"]],["(1\\d{3})(\\d{5,6})","$1 $2",["1"]],["(800)(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"]],["(845)(46)(4\\d)","$1 $2 $3",["845","8454","84546","845464"]],["(8\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8(?:4[2-5]|7[0-3])"]],["(80\\d)(\\d{3})(\\d{4})","$1 $2 $3",["80"]],["(800)(\\d{6})","$1 $2",["800"]]],"0",null,null,null,null,null,["1624[5-8]\\d{5}","7(?:4576|[59]24\\d|624[0-4689])\\d{5}","808162\\d{4}","(?:872299|90[0167]624)\\d{4}","70\\d{8}",null,"3(?:08162\\d|3\\d{5}|4(?:40[49]06|5624\\d)|7(?:0624\\d|2299\\d))\\d{3}|55\\d{8}",null,"56\\d{8}","8(?:4(?:40[49]06|5624\\d)|70624\\d)\\d{3}"]],"IN":["91","008\\d{9}|1\\d{7,12}|[2-9]\\d{9,10}",[["(\\d{8})","$1",["561","5616","56161"],"$1"],["(\\d{5})(\\d{5})","$1 $2",["6(?:[09]0|28|3[589])|7(?:[02-8]|19|9[037-9])|8(?:0[015-9]|[1-9])|9","6(?:[09]0|28[0-2]|3(?:5[01]|[89]0))|7(?:[07]|19[0-5]|2(?:[0235-9]|[14][017-9])|3(?:[025-9]|[134][017-9])|4(?:[0-35689]|[47][017-9])|5(?:[02-46-9]|[15][017-9])|6(?:[02-9]|1[0-257-9])|8(?:[0-79]|8[0189])|9(?:[089]|31|7[02-9]))|8(?:0(?:[01589]|6[67]|7[02-9])|1(?:[0-57-9]|6[07-9])|2(?:[014][07-9]|[235-9])|3(?:[03-57-9]|[126][07-9])|[45]|6(?:[02457-9]|[136][07-9])|7(?:[078][07-9]|[1-69])|8(?:[0-25-9]|3[07-9]|4[047-9])|9(?:[02-9]|1[027-9]))|9","6(?:[09]0|28[0-2]|3(?:5(?:0[0-6]|1)|[89]0))|7(?:0|19[0-5]|2(?:[0235-79]|[14][017-9]|8(?:[0-69]|[78][089]))|3(?:[05-8]|1(?:[0189]|7[5-9])|2(?:[0-49][089]|[5-8])|3[017-9]|4(?:[07-9]|11)|9(?:[01689]|[2-5][089]|7[0189]))|4(?:[056]|1(?:[0135-9]|[24][089])|[29](?:[0-7][089]|[89])|3(?:[0-8][089]|9)|[47](?:[089]|11|7[02-8])|8(?:[0-24-7][089]|[389]))|5(?:[0346-9]|[15][017-9]|2(?:[03-9]|[12][089]))|6(?:[0346-9]|1[0-257-9]|2(?:[0-4]|[5-9][089])|5(?:[0-367][089]|[4589]))|7(?:0(?:[02-9]|1[089])|[1-9])|8(?:[0-79]|8(?:0[0189]|11|8[013-9]|9))|9(?:[089]|313|7(?:[02-8]|9[07-9])))|8(?:0(?:[01589]|6[67]|7(?:[02-8]|9[05-9]))|1(?:[02-57-9]|1(?:[0-35-9]|4[0-46-9])|6(?:[089]|7[02-8]))|2(?:0(?:[089]|7[02])|[14](?:[089]|7[02-8])|[235-9])|3(?:[03-57-9]|1(?:[089]|7[02-6])|2(?:[09]|77|8[0-689])|6(?:[089]|7[02-7]))|[45]|6(?:[02457-9]|[136](?:[089]|7[02-8]))|7(?:0[07-9]|[1-69]|[78](?:[089]|7[02-8]))|8(?:[0-25-9]|3(?:[089]|7[02-8])|4(?:[0489]|7[02-68]))|9(?:[02-9]|1(?:[0289]|7[2-6])))|9"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-9]|80[2-46]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[59][14]|[68][1-9]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1|9[15])|6(?:12|[2-4]1|5[17]|6[13]|7[14]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[23579]|[468][1-9])|[2-8]"]],["(\\d{2})(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3 $4",["008"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],"$1"],["(\\d{4})(\\d{2})(\\d{4})","$1 $2 $3",["160","1600"],"$1"],["(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],"$1"],["(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["180","1800"],"$1"],["(\\d{4})(\\d{3,4})(\\d{4})","$1 $2 $3",["186","1860"],"$1"],["(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18[06]"],"$1"]],"0","0$1",null,null,true],"IO":["246","3\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"IQ":["964","[1-7]\\d{7,9}",[["(1)(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["([2-6]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"]],["(7\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"]]],"0","0$1"],"IR":["98","[1-8]\\d{5,9}|9(?:[0-4]\\d{8}|9\\d{8})",[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"]],["(\\d{2})(\\d{4,5})","$1 $2",["[1-8]"]],["(\\d{4,5})","$1",["96"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"]]],"0","0$1"],"IS":["354","[4-9]\\d{6}|38\\d{7}",[["(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],["(3\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]]],"IT":["39","[01589]\\d{5,10}|3(?:[12457-9]\\d{8}|[36]\\d{7,9})",[["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|55"]],["(0[26])(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],["(0[26])(\\d{4,6})","$1 $2",["0[26]"]],["(0\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]"]],["(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[245])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]],["(0\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["0[13-57-9][2-46-8]"]],["(0\\d{3})(\\d{2,6})","$1 $2",["0[13-57-9][2-46-8]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13]|8(?:00|4[08]|9[59])","[13]|8(?:00|4[08]|9(?:5[5-9]|9))"]],["(\\d{4})(\\d{4})","$1 $2",["894","894[5-9]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["3"]]],null,null,null,null,null,null,["0(?:[26]\\d{4,9}|(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2346]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[34578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7})","3(?:[12457-9]\\d{8}|6\\d{7,8}|3\\d{7,9})","80(?:0\\d{6}|3\\d{3})","0878\\d{5}|1(?:44|6[346])\\d{6}|89(?:2\\d{3}|4(?:[0-4]\\d{2}|[5-9]\\d{4})|5(?:[0-4]\\d{2}|[5-9]\\d{6})|9\\d{6})","1(?:78\\d|99)\\d{6}",null,null,null,"55\\d{8}","84(?:[08]\\d{6}|[17]\\d{3})"]],"JE":["44","[135789]\\d{6,9}",[["(7\\d{3})(\\d{6})","$1 $2",["7(?:[1-57-9]|62)","7(?:[1-57-9]|624)"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2|5[56]|7[06]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:[02-9]1|1)|3|9[018]"]],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"]],["(1\\d{3})(\\d{5,6})","$1 $2",["1"]],["(800)(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"]],["(845)(46)(4\\d)","$1 $2 $3",["845","8454","84546","845464"]],["(8\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8(?:4[2-5]|7[0-3])"]],["(80\\d)(\\d{3})(\\d{4})","$1 $2 $3",["80"]],["(800)(\\d{6})","$1 $2",["800"]]],"0",null,null,null,null,null,["1534[0-24-8]\\d{5}","7(?:509\\d|7(?:00[378]|97[7-9])|829\\d|937\\d)\\d{5}","80(?:07(?:35|81)|8901)\\d{4}","(?:871206|90(?:066[59]|1810|71(?:07|55)))\\d{4}","701511\\d{4}",null,"3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))\\d{4}|55\\d{8}","76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}","56\\d{8}","8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|70002)\\d{4}"]],"JM":["1","[589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"876"],"JO":["962","[235-9]\\d{7,8}",[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],["(7)(\\d{4})(\\d{4})","$1 $2 $3",["7[457-9]"]],["(\\d{2})(\\d{7})","$1 $2",["70"]],["(\\d{3})(\\d{5,6})","$1 $2",["8[0158]|9"]]],"0","0$1"],"JP":["81","[1-9]\\d{8,9}|00(?:[36]\\d{7,14}|7\\d{5,7}|8\\d{7})",[["(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"]],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[2579]0|80[1-9]"]],["(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])","1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[78]|96)|477|51[24]|636)|9(?:496|802|9(?:1[23]|69))","1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[78]|96[2457-9])|477|51[24]|636[2-57-9])|9(?:496|802|9(?:1[23]|69))"]],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["1(?:2[3-6]|3[3-9]|4[2-6]|5[2-8]|[68][2-7]|7[2-689]|9[1-578])|2(?:2[03-689]|3[3-58]|4[0-468]|5[04-8]|6[013-8]|7[06-9]|8[02-57-9]|9[13])|4(?:2[28]|3[689]|6[035-7]|7[05689]|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9[4-9])|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9[014-9])|8(?:2[49]|3[3-8]|4[5-8]|5[2-9]|6[35-9]|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9[3-7])","1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9[2-8])|3(?:[3-6][2-9]|7[2-6]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5[4-7]|6[2-9]|8[2-8]|9[236-9])|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3[34]|4[2-69]|[5-7]))","1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:20|[3578]|4[04-9]|6[56]))|3(?:[3-6][2-9]|7(?:[2-5]|6[0-59])|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))","1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:20|[3578]|4[04-9]|6(?:5[25]|60)))|3(?:[3-6][2-9]|7(?:[2-5]|6[0-59])|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))"]],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1|2(?:2[37]|5[5-9]|64|78|8[39]|91)|4(?:2[2689]|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93)","1|2(?:2[37]|5(?:[57]|[68]0|9[19])|64|78|8[39]|917)|4(?:2(?:20|[68]|9[178])|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93[34])","1|2(?:2[37]|5(?:[57]|[68]0|9(?:17|99))|64|78|8[39]|917)|4(?:2(?:20|[68]|9[178])|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93(?:31|4))"]],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["2(?:[34]7|[56]9|74|9[14-79])|82|993"]],["(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["3|4(?:2[09]|7[01])|6[1-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[2479][1-9]"]]],"0","0$1"],"KE":["254","20\\d{6,7}|[4-9]\\d{6,9}",[["(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"]],["(\\d{3})(\\d{6})","$1 $2",["7"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"]]],"0","0$1","005|0"],"KG":["996","[235-8]\\d{8,9}",[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[25-7]|31[25]"]],["(\\d{4})(\\d{5})","$1 $2",["3(?:1[36]|[2-9])"]],["(\\d{3})(\\d{3})(\\d)(\\d{3})","$1 $2 $3 $4",["8"]]],"0","0$1"],"KH":["855","[1-9]\\d{7,9}",[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["1\\d[1-9]|[2-9]"],"0$1"],["(1[89]00)(\\d{3})(\\d{3})","$1 $2 $3",["1[89]0","1[89]00"]]],"0"],"KI":["686","[2458]\\d{4}|3\\d{4,7}|[67]\\d{7}",[],null,null,"0"],"KM":["269","[3478]\\d{6}",[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3"]]],"KN":["1","[589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"869"],"KP":["850","1\\d{9}|[28]\\d{7}",[["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]],"0","0$1"],"KR":["82","00(?:3\\d{8,9}|7\\d{9,11})|[1-7]\\d{4,9}|8\\d{8}",[["(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"]],["(\\d{4})(\\d{4})","$1-$2",["1(?:5[246-9]|6[046-8]|8[03579])","1(?:5(?:22|44|66|77|88|99)|6(?:[07]0|44|6[16]|88)|8(?:00|33|55|77|99))"],"$1"],["(\\d{5})","$1",["1[016-9]1","1[016-9]11","1[016-9]114"]],["(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2[1-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60[2-9]|80"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["1[0-25-9]|(?:3[1-3]|[46][1-4]|5[1-5])[1-9]"]],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]0"]]],"0","0$1","0(8[1-46-8]|85\\d{2})?"],"KW":["965","[12569]\\d{6,7}",[["(\\d{4})(\\d{3,4})","$1 $2",["[16]|2(?:[0-35-9]|4[0-35-9])|52[25]|9[024-9]"]],["(\\d{3})(\\d{5})","$1 $2",["244|5(?:[015]|6[56])"]]]],"KY":["1","[3589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"345"],"KZ":["7","(?:33\\d|7\\d{2}|80[089])\\d{7}",[["([3489]\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[3489]"]],["(7\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"]]],"8",null,null,null,null,null,["33622\\d{5}|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9])|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[234]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[234]\\d|5[139])|4(?:2\\d|3[1235-9]|59)|5(?:[23]\\d|4[01246-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59)))\\d{5}","7(?:0[012578]|47|6[02-4]|7[15-8]|85)\\d{7}","800\\d{7}","809\\d{7}","808\\d{7}",null,null,null,"751\\d{7}"]],"LA":["856","[2-8]\\d{7,9}",[["(20)(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["20"]],["([2-8]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"]],["(30)(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30"]]],"0","0$1"],"LB":["961","[13-9]\\d{6,7}",[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],"0$1"],["([7-9]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["7(?:[01]|6[013-9]|8[89]|9[1-3])|[89][01]"]]],"0"],"LC":["1","[5789]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"758"],"LI":["423","6\\d{8}|[23789]\\d{6}",[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[237-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[56]"]],["(69)(7\\d{2})(\\d{4})","$1 $2 $3",["697"]]],"0",null,"0|10(?:01|20|66)"],"LK":["94","[1-9]\\d{8}",[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-689]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"]]],"0","0$1"],"LR":["231","2\\d{7,8}|[378]\\d{8}|4\\d{6}|5\\d{6,8}",[["(2\\d)(\\d{3})(\\d{3})","$1 $2 $3",["2"]],["([4-5])(\\d{3})(\\d{3})","$1 $2 $3",["[45]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23578]"]]],"0","0$1"],"LS":["266","[2568]\\d{7}",[["(\\d{4})(\\d{4})","$1 $2"]]],"LT":["370","[3-9]\\d{7}",[["([34]\\d)(\\d{6})","$1 $2",["37|4(?:1|5[45]|6[2-4])"]],["([3-6]\\d{2})(\\d{5})","$1 $2",["3[148]|4(?:[24]|6[09])|528|6"]],["([7-9]\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"8 $1"],["(5)(2\\d{2})(\\d{4})","$1 $2 $3",["52[0-79]"]]],"8","(8-$1)","[08]",null,true],"LU":["352","[24-9]\\d{3,10}|3(?:[0-46-9]\\d{2,9}|5[013-9]\\d{1,8})",[["(\\d{2})(\\d{3})","$1 $2",["[2-5]|7[1-9]|[89](?:0[2-9]|[1-9])"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[2-5]|7[1-9]|[89](?:0[2-9]|[1-9])"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,4})","$1 $2 $3 $4",["2(?:[12589]|4[12])|[3-5]|7[1-9]|8(?:0[2-9]|[1-9])|9(?:0[2-46-9]|[1-9])"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["70|80[01]|90[015]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],null,null,"(15(?:0[06]|1[12]|35|4[04]|55|6[26]|77|88|99)\\d)"],"LV":["371","[2689]\\d{7}",[["([2689]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2689]"]]]],"LY":["218","[25679]\\d{8}",[["([25-79]\\d)(\\d{7})","$1-$2",["[25-79]"]]],"0","0$1"],"MA":["212","[5-9]\\d{8}",[["([5-7]\\d{2})(\\d{6})","$1-$2",["5(?:2[015-7]|3[0-4])|[67]"]],["([58]\\d{3})(\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9]|92)|892","5(?:2(?:[2-48]|9[0-7])|3(?:[5-79]|8[0-7])|924)|892"]],["(5\\d{4})(\\d{4})","$1-$2",["5(?:29|38)","5(?:29|38)[89]"]],["([5]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:4[067]|5[03])"]],["(8[09])(\\d{7})","$1-$2",["8(?:0|9[013-9])"]]],"0","0$1",null,null,null,null,["5(?:2(?:[015-79]\\d|2[02-9]|3[2-57]|4[2-8]|8[235-7])\\d|3(?:[0-48]\\d|[57][2-9]|6[2-8]|9[3-9])\\d|4[067]\\d{2}|5[03]\\d{2})\\d{4}","(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0[067]|6[1267]|7[07]))\\d{6}","80\\d{7}","89\\d{7}",null,null,null,null,"5924[01]\\d{4}"]],"MC":["377","[34689]\\d{7,8}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[39]"],"$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"]],["(6)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"]],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["8"],"$1"]],"0","0$1"],"MD":["373","[235-9]\\d{7}",[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"]],["([25-7]\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["2[13-9]|[5-7]"]],["([89]\\d{2})(\\d{5})","$1 $2",["[89]"]]],"0","0$1"],"ME":["382","[2-9]\\d{7,8}",[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]|6[036-9]"]]],"0","0$1"],"MF":["590","[56]\\d{8}",[["([56]90)(\\d{2})(\\d{4})","$1 $2-$3",["[56]90"]]],"0",null,null,null,null,null,["590(?:[02][79]|13|5[0-268]|[78]7)\\d{4}","690(?:0[05-9]|[1-9]\\d)\\d{4}"]],"MG":["261","[23]\\d{8}",[["([23]\\d)(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",["[23]"]]],"0","0$1"],"MH":["692","[2-6]\\d{6}",[["(\\d{3})(\\d{4})","$1-$2"]],"1"],"MK":["389","[2-578]\\d{7}",[["(2)(\\d{3})(\\d{4})","$1 $2 $3",["2"]],["([347]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[347]"]],["([58]\\d{2})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"]]],"0","0$1"],"ML":["223","[246-9]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[246-9]"]]]],"MM":["95","[178]\\d{5,7}|[24-6]\\d{5,8}|9(?:[279]\\d{0,2}|5|[34]\\d{1,2}|6(?:\\d{1,2})?|8(?:\\d{2})?)\\d{6}",[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["1|2[245]"]],["(2)(\\d{4})(\\d{4})","$1 $2 $3",["251"]],["(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"]],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["432|67|81"]],["(\\d{2})(\\d{2})(\\d{3,4})","$1 $2 $3",["[4-8]"]],["(9)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"]],["(9)([34]\\d{4})(\\d{4})","$1 $2 $3",["9(?:3[0-36]|4[0-57-9])"]],["(9)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92[56]"]],["(9)(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["93"]]],"0","0$1"],"MN":["976","[12]\\d{7,9}|[57-9]\\d{7}",[["([12]\\d)(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"]],["([12]2\\d)(\\d{5,6})","$1 $2",["[12]2[1-3]"]],["([12]\\d{3})(\\d{5})","$1 $2",["[12](?:27|[3-5])","[12](?:27|[3-5]\\d)2"]],["(\\d{4})(\\d{4})","$1 $2",["[57-9]"],"$1"],["([12]\\d{4})(\\d{4,5})","$1 $2",["[12](?:27|[3-5])","[12](?:27|[3-5]\\d)[4-9]"]]],"0","0$1"],"MO":["853","[268]\\d{7}",[["([268]\\d{3})(\\d{4})","$1 $2",["[268]"]]]],"MP":["1","[5689]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"670"],"MQ":["596","[56]\\d{8}",[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]],"0","0$1"],"MR":["222","[2-48]\\d{7}",[["([2-48]\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-48]"]]]],"MS":["1","[5689]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"664"],"MT":["356","[2357-9]\\d{7}",[["(\\d{4})(\\d{4})","$1 $2"]]],"MU":["230","[2-9]\\d{6,7}",[["([2-46-9]\\d{2})(\\d{4})","$1 $2",["[2-46-9]"]],["(5\\d{3})(\\d{4})","$1 $2",["5"]]]],"MV":["960","[346-8]\\d{6,9}|9(?:00\\d{7}|\\d{6})",[["(\\d{3})(\\d{4})","$1-$2",["[3467]|9(?:0[1-9]|[1-9])"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]00"]]]],"MW":["265","(?:1(?:\\d{2})?|[2789]\\d{2})\\d{6}",[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1"]],["(2\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[17-9]"]]],"0","0$1"],"MX":["52","[1-9]\\d{9,10}",[["([358]\\d)(\\d{4})(\\d{4})","$1 $2 $3",["33|55|81"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2467]|3[0-2457-9]|5[089]|8[02-9]|9[0-35-9]"]],["(1)([358]\\d)(\\d{4})(\\d{4})","044 $2 $3 $4",["1(?:33|55|81)"],"$1",null,"$1 $2 $3 $4"],["(1)(\\d{3})(\\d{3})(\\d{4})","044 $2 $3 $4",["1(?:[2467]|3[0-2457-9]|5[089]|8[2-9]|9[1-35-9])"],"$1",null,"$1 $2 $3 $4"]],"01","01 $1","0[12]|04[45](\\d{10})","1$1",true],"MY":["60","[13-9]\\d{7,9}",[["([4-79])(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],["(3)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],["([18]\\d)(\\d{3})(\\d{3,4})","$1-$2 $3",["1[02-46-9][1-9]|8"],"0$1"],["(1)([36-8]00)(\\d{2})(\\d{4})","$1-$2-$3-$4",["1[36-8]0","1[36-8]00"]],["(11)(\\d{4})(\\d{4})","$1-$2 $3",["11"],"0$1"],["(15[49])(\\d{3})(\\d{4})","$1-$2 $3",["15[49]"],"0$1"]],"0"],"MZ":["258","[28]\\d{7,8}",[["([28]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-7]"]],["(80\\d)(\\d{3})(\\d{3})","$1 $2 $3",["80"]]]],"NA":["264","[68]\\d{7,8}",[["(8\\d)(\\d{3})(\\d{4})","$1 $2 $3",["8[1-35]"]],["(6\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["6"]],["(88)(\\d{3})(\\d{3})","$1 $2 $3",["88"]],["(870)(\\d{3})(\\d{3})","$1 $2 $3",["870"]]],"0","0$1"],"NC":["687","[2-57-9]\\d{5}",[["(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[2-46-9]|5[0-4]"]]]],"NE":["227","[0289]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["09|[289]"]],["(08)(\\d{3})(\\d{3})","$1 $2 $3",["08"]]]],"NF":["672","[13]\\d{5}",[["(\\d{2})(\\d{4})","$1 $2",["1"]],["(\\d)(\\d{5})","$1 $2",["3"]]]],"NG":["234","[1-6]\\d{5,8}|9\\d{5,9}|[78]\\d{5,13}",[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|9(?:0[3-9]|[1-9])"]],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[3-6]|7(?:0[1-9]|[1-79])|8[2-9]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["70|8[01]|90[235-9]"]],["([78]00)(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]00"]],["([78]00)(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]00"]],["(78)(\\d{2})(\\d{3})","$1 $2 $3",["78"]]],"0","0$1"],"NI":["505","[125-8]\\d{7}",[["(\\d{4})(\\d{4})","$1 $2"]]],"NL":["31","1\\d{4,8}|[2-7]\\d{8}|[89]\\d{6,9}",[["([1-578]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1[035]|2[0346]|3[03568]|4[0356]|5[0358]|7|8[4578]"]],["([1-5]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"]],["(6)(\\d{8})","$1 $2",["6[0-57-9]"]],["(66)(\\d{7})","$1 $2",["66"]],["(14)(\\d{3,4})","$1 $2",["14"],"$1"],["([89]0\\d)(\\d{4,7})","$1 $2",["[89]0"]]],"0","0$1"],"NO":["47","0\\d{4}|[2-9]\\d{7}",[["([489]\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[489]"]],["([235-7]\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-7]"]]],null,null,null,null,null,null,["(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}","(?:4[015-8]|5[89]|87|9\\d)\\d{6}","80[01]\\d{5}","82[09]\\d{5}","880\\d{5}","81[23]\\d{5}","0\\d{4}|81(?:0(?:0[7-9]|1\\d)|5\\d{2})\\d{3}",null,"85[0-5]\\d{5}","810(?:0[0-6]|[2-8]\\d)\\d{3}"]],"NP":["977","[1-8]\\d{7}|9(?:[1-69]\\d{6,8}|7[2-6]\\d{5,7}|8\\d{8})",[["(1)(\\d{7})","$1-$2",["1[2-6]"]],["(\\d{2})(\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-69]|7[15-9])"]],["(9\\d{2})(\\d{7})","$1-$2",["9(?:6[013]|7[245]|8)"],"$1"]],"0","0$1"],"NR":["674","[458]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"NU":["683","[1-5]\\d{3}"],"NZ":["64","6[235-9]\\d{6}|[2-57-9]\\d{7,9}",[["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["240|[346]|7[2-57-9]|9[1-9]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["21"]],["(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:1[1-9]|[69]|7[0-35-9])|70|86"]],["(2\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["2[028]"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["90"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|5|[89]0"]]],"0","0$1"],"OM":["968","(?:5|[279]\\d)\\d{6}|800\\d{5,6}",[["(2\\d)(\\d{6})","$1 $2",["2"]],["([79]\\d{3})(\\d{4})","$1 $2",["[79]"]],["([58]00)(\\d{4,6})","$1 $2",["[58]00"]]]],"PA":["507","[1-9]\\d{6,7}",[["(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],["(\\d{4})(\\d{4})","$1-$2",["6"]]]],"PE":["51","[14-9]\\d{7,8}",[["(1)(\\d{7})","$1 $2",["1"]],["([4-8]\\d)(\\d{6})","$1 $2",["[4-7]|8[2-4]"]],["(\\d{3})(\\d{5})","$1 $2",["80"]],["(9\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"$1"]],"0","(0$1)"],"PF":["689","4\\d{5,7}|8\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4[09]|8[79]"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]]]],"PG":["675","[1-9]\\d{6,7}",[["(\\d{3})(\\d{4})","$1 $2",["[13-689]|27"]],["(\\d{4})(\\d{4})","$1 $2",["20|7"]]]],"PH":["63","1\\d{10,12}|2\\d{5,7}|[3-7]\\d{8}|8\\d{7,9}|9\\d{9}",[["(2)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(2)(\\d{5})","$1 $2",["2"],"(0$1)"],["(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|5(?:22|44)|642|8(?:62|8[245])","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)"],["(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],["([3-8]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[3-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["81|9"],"0$1"],["(1800)(\\d{3})(\\d{4})","$1 $2 $3",["180","1800"]],["(1800)(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["180","1800"]]],"0"],"PK":["92","1\\d{8}|[2-8]\\d{5,11}|9(?:[013-9]\\d{4,10}|2\\d(?:111\\d{6}|\\d{3,7}))",[["([89]00)(\\d{3})(\\d{2})","$1 $2 $3",["[89]00"],"0$1"],["(1\\d{3})(\\d{5})","$1 $2",["1"],"$1"],["(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"]],["(\\d{3})(\\d{6,7})","$1 $2",["2[349]|45|54|60|72|8[2-5]|9[2-469]","(?:2[349]|45|54|60|72|8[2-5]|9[2-469])\\d[2-9]"]],["(58\\d{3})(\\d{5})","$1 $2",["58[126]"]],["(3\\d{2})(\\d{7})","$1 $2",["3"],"0$1"],["(\\d{2})(111)(\\d{3})(\\d{3})","$1 $2 $3 $4",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)1","(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)11","(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)111"]],["(\\d{3})(111)(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[349]|45|54|60|72|8[2-5]|9[2-9]","(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d1","(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d11","(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d111"]]],"0","(0$1)"],"PL":["48","[1-57-9]\\d{6,8}|6\\d{5,8}",[["(\\d{3})(\\d{3})","$1 $2",["11[68]|64"]],["(\\d{5})","$1",["19"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145]"]],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["26|39|45|5[0137]|6[0469]|7[02389]|8[08]"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[14]|2[0-57-9]|3[2-4]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145]"]]]],"PM":["508","[45]\\d{5}",[["([45]\\d)(\\d{2})(\\d{2})","$1 $2 $3",["[45]"]]],"0","0$1"],"PR":["1","[5789]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"787|939"],"PS":["970","1\\d{9}|[24589]\\d{7,8}",[["([2489])(2\\d{2})(\\d{4})","$1 $2 $3",["[2489]2"]],["(5[69]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["5[69]"]],["(1[78]00)(\\d{3})(\\d{3})","$1 $2 $3",["1[78]0","1[78]00"],"$1"]],"0","0$1"],"PT":["351","[2-46-9]\\d{8}",[["(2\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],["([2-46-9]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[3-9]|[346-9]"]]]],"PW":["680","[2-8]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"PY":["595","5[0-5]\\d{4,7}|[2-46-9]\\d{5,8}",[["(\\d{2})(\\d{5})","$1 $2",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],["(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["9[1-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["870","8700"]],["(\\d{3})(\\d{4,5})","$1 $2",["[2-8][1-9]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8][1-9]"],"0$1"]],"0"],"QA":["974","[2-8]\\d{6,7}",[["([28]\\d{2})(\\d{4})","$1 $2",["[28]"]],["([3-7]\\d{3})(\\d{4})","$1 $2",["[3-7]"]]]],"RE":["262","[268]\\d{8}",[["([268]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[268]"]]],"0","0$1",null,null,null,"262|69|8"],"RO":["40","[23]\\d{5,8}|[7-9]\\d{8}",[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"]],["(\\d{2})(\\d{4})","$1 $2",["[23]1"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[23][3-7]|[7-9]"]],["(2\\d{2})(\\d{3})","$1 $2",["2[3-6]"]]],"0","0$1"],"RS":["381","[126-9]\\d{4,11}|3(?:[0-79]\\d{3,10}|8[2-9]\\d{2,9})",[["([23]\\d{2})(\\d{4,9})","$1 $2",["(?:2[389]|39)0"]],["([1-3]\\d)(\\d{5,10})","$1 $2",["1|2(?:[0-24-7]|[389][1-9])|3(?:[0-8]|9[1-9])"]],["(6\\d)(\\d{6,8})","$1 $2",["6"]],["([89]\\d{2})(\\d{3,9})","$1 $2",["[89]"]],["(7[26])(\\d{4,9})","$1 $2",["7[26]"]],["(7[08]\\d)(\\d{4,9})","$1 $2",["7[08]"]]],"0","0$1"],"RU":["7","[347-9]\\d{9}",[["([3489]\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[3489]"]],["(7\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"]]],"8","8 ($1)",null,null,true,null,["(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}","9\\d{9}","80[04]\\d{7}","80[39]\\d{7}","808\\d{7}"]],"RW":["250","[027-9]\\d{7,8}",[["(2\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"]],["([7-9]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"],["(0\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]]],"0"],"SA":["966","1\\d{7,8}|(?:[2-467]|92)\\d{7}|5\\d{8}|8\\d{9}",[["([1-467])(\\d{3})(\\d{4})","$1 $2 $3",["[1-467]"]],["(1\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1[1-467]"]],["(5\\d)(\\d{3})(\\d{4})","$1 $2 $3",["5"]],["(92\\d{2})(\\d{5})","$1 $2",["92"],"$1"],["(800)(\\d{3})(\\d{4})","$1 $2 $3",["800"],"$1"],["(811)(\\d{3})(\\d{3,4})","$1 $2 $3",["811"]]],"0","0$1"],"SB":["677","[1-9]\\d{4,6}",[["(\\d{2})(\\d{5})","$1 $2",["[7-9]"]]]],"SC":["248","[24689]\\d{5,6}",[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]"]]]],"SD":["249","[19]\\d{8}",[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3"]],"0","0$1"],"SE":["46","[1-35-9]\\d{5,11}|4\\d{6,8}",[["(8)(\\d{2,3})(\\d{2,3})(\\d{2})","$1-$2 $3 $4",["8"],null,null,"$1 $2 $3 $4"],["([1-69]\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[013689]|2[0136]|3[1356]|4[0246]|54|6[03]|90"],null,null,"$1 $2 $3 $4"],["([1-469]\\d)(\\d{3})(\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90"],null,null,"$1 $2 $3"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"],null,null,"$1 $2 $3 $4"],["(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"],null,null,"$1 $2 $3"],["(7\\d)(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["7"],null,null,"$1 $2 $3 $4"],["(77)(\\d{2})(\\d{2})","$1-$2$3",["77"],null,null,"$1 $2 $3"],["(20)(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],null,null,"$1 $2 $3"],["(9[034]\\d)(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9[034]"],null,null,"$1 $2 $3 $4"],["(9[034]\\d)(\\d{4})","$1-$2",["9[034]"],null,null,"$1 $2"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["25[245]|67[3-6]"],null,null,"$1 $2 $3 $4 $5"]],"0","0$1"],"SG":["65","[36]\\d{7}|[17-9]\\d{7,10}",[["([3689]\\d{3})(\\d{4})","$1 $2",["[369]|8[1-9]"]],["(1[89]00)(\\d{3})(\\d{4})","$1 $2 $3",["1[89]0","1[89]00"]],["(7000)(\\d{4})(\\d{3})","$1 $2 $3",["700","7000"]],["(800)(\\d{3})(\\d{4})","$1 $2 $3",["800"]]]],"SH":["290","[256]\\d{4}|8\\d{3}",[],null,null,null,null,null,null,["2(?:[0-57-9]\\d|6[4-9])\\d{2}","[56]\\d{4}",null,null,null,null,null,null,"262\\d{2}"]],"SI":["386","[1-7]\\d{6,7}|[89]\\d{4,7}",[["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[12]|[34][24-8]|5[2-8]|7[3-8]"],"(0$1)"],["([3-7]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"]],["([89][09])(\\d{3,6})","$1 $2",["[89][09]"]],["([58]\\d{2})(\\d{5})","$1 $2",["59|8[1-3]"]]],"0","0$1"],"SJ":["47","0\\d{4}|[45789]\\d{7}",[["([489]\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[489]"]],["([235-7]\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-7]"]]],null,null,null,null,null,null,["79\\d{6}","(?:4[015-8]|5[89]|9\\d)\\d{6}","80[01]\\d{5}","82[09]\\d{5}","880\\d{5}","81[23]\\d{5}","0\\d{4}|81(?:0(?:0[7-9]|1\\d)|5\\d{2})\\d{3}",null,"85[0-5]\\d{5}","810(?:0[0-6]|[2-8]\\d)\\d{3}"]],"SK":["421","(?:[2-68]\\d{5,8}|9\\d{6,8})",[["(2)(1[67])(\\d{3,4})","$1 $2 $3",["21[67]"]],["([3-5]\\d)(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5]"]],["(2)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"]],["([3-5]\\d)(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"]],["([689]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"]],["(9090)(\\d{3})","$1 $2",["909","9090"]]],"0","0$1"],"SL":["232","[2-9]\\d{7}",[["(\\d{2})(\\d{6})","$1 $2"]],"0","(0$1)"],"SM":["378","[05-7]\\d{7,9}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],["(0549)(\\d{6})","$1 $2",["054","0549"],null,null,"($1) $2"],["(\\d{6})","0549 $1",["[89]"],null,null,"(0549) $1"]],null,null,"([89]\\d{5})","0549$1"],"SN":["221","[3789]\\d{8}",[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"SO":["252","[1-9]\\d{5,8}",[["(\\d{6})","$1",["[134]"]],["(\\d)(\\d{6})","$1 $2",["[13-5]|2[0-79]"]],["(\\d)(\\d{7})","$1 $2",["24|[67]"]],["(\\d{2})(\\d{4})","$1 $2",["8[125]"]],["(\\d{2})(\\d{5,7})","$1 $2",["15|28|6[1-35-9]|799|9[2-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3[59]|4[89]|6[24-6]|79|8[08]|90"]]],"0"],"SR":["597","[2-8]\\d{5,6}",[["(\\d{3})(\\d{3})","$1-$2",["[2-4]|5[2-58]"]],["(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["56"]],["(\\d{3})(\\d{4})","$1-$2",["[6-8]"]]]],"SS":["211","[19]\\d{8}",[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",null,"0$1"]],"0"],"ST":["239","[29]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"SV":["503","[267]\\d{7}|[89]\\d{6}(?:\\d{4})?",[["(\\d{4})(\\d{4})","$1 $2",["[267]"]],["(\\d{3})(\\d{4})","$1 $2",["[89]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]]],"SX":["1","[5789]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"721"],"SY":["963","[1-59]\\d{7,8}",[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-5]"]],["(9\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],"0","0$1",null,null,true],"SZ":["268","[027]\\d{7}",[["(\\d{4})(\\d{4})","$1 $2",["[027]"]]]],"TA":["290","8\\d{3}",[],null,null,null,null,null,null,["8\\d{3}"]],"TC":["1","[5689]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"649"],"TD":["235","[2679]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"TG":["228","[29]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[29]"]]]],"TH":["66","1\\d{8,9}|[2-9]\\d{7,8}",[["(2)(\\d{3})(\\d{4})","$1 $2 $3",["2"]],["([13-9]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["14|[3-9]"]],["(1[89]00)(\\d{3})(\\d{3})","$1 $2 $3",["1[89]0","1[89]00"],"$1"]],"0","0$1"],"TJ":["992","[3-57-9]\\d{8}",[["([349]\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[34]7|91[78]"]],["([457-9]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[148]|[578]|9(?:[0235-9]|1[59])"]],["(331700)(\\d)(\\d{2})","$1 $2 $3",["331","3317","33170","331700"]],["(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3[1-5]","3(?:[1245]|3(?:[02-9]|1[0-589]))"]]],"8",null,null,null,true],"TK":["690","[2-47]\\d{3,6}"],"TL":["670","[2-489]\\d{6}|7\\d{6,7}",[["(\\d{3})(\\d{4})","$1 $2",["[2-489]|70"]],["(\\d{4})(\\d{4})","$1 $2",["7[3-8]"]]]],"TM":["993","[1-6]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"]],["(\\d{2})(\\d{6})","$1 $2",["6"],"8 $1"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["13|[2-5]"]]],"8","(8 $1)"],"TN":["216","[2-57-9]\\d{7}",[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3"]]],"TO":["676","[02-8]\\d{4,6}",[["(\\d{2})(\\d{3})","$1-$2",["[1-6]|7[0-4]|8[05]"]],["(\\d{3})(\\d{4})","$1 $2",["7[5-9]|8[47-9]"]],["(\\d{4})(\\d{3})","$1 $2",["0"]]]],"TR":["90","[2-589]\\d{9}|444\\d{4}",[["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[23]|4(?:[0-35-9]|4[0-35-9])"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5[02-69]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["51|[89]"],"0$1"],["(444)(\\d{1})(\\d{3})","$1 $2 $3",["444"]]],"0",null,null,null,true],"TT":["1","[589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"868"],"TV":["688","[279]\\d{4,6}"],"TW":["886","2\\d{6,8}|[3-689]\\d{7,8}|7\\d{7,9}",[["(20)(\\d)(\\d{4})","$1 $2 $3",["202"]],["([258]0)(\\d{3})(\\d{4})","$1 $2 $3",["20[013-9]|50[0-46-9]|80[0-79]"]],["([2-8])(\\d{3,4})(\\d{4})","$1 $2 $3",["[25][2-8]|[346]|[78][1-9]"]],["(9\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"]],["(70)(\\d{4})(\\d{4})","$1 $2 $3",["70"]]],"0","0$1"],"TZ":["255","\\d{9}",[["([24]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[24]"]],["([67]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"]],["([89]\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"]]],"0","0$1"],"UA":["380","[3-9]\\d{8}",[["([3-9]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[38]9|4(?:[45][0-5]|87)|5(?:0|[67][37])|6[36-8]|7|9[1-9]","[38]9|4(?:[45][0-5]|87)|5(?:0|6(?:3[14-7]|7)|7[37])|6[36-8]|7|9[1-9]"]],["([3-689]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["(?:3[1-8]|4[136-8])2|5(?:[12457]2|6[24])|6(?:[12][29]|[49]2|5[24])|8[0-8]|90","3(?:[1-46-8]2[013-9]|52)|4(?:[1378]2|62[013-9])|5(?:[12457]2|6[24])|6(?:[12][29]|[49]2|5[24])|8[0-8]|90"]],["([3-6]\\d{3})(\\d{5})","$1 $2",["3(?:[1-46-8]|5[013-9])|4(?:[137][013-9]|[45][6-9]|6|8[4-6])|5(?:[1245][013-9]|3|6[0135689]|7[4-6])|6(?:[12][13-8]|[49][013-9]|5[0135-9])","3(?:[1-46-8](?:[013-9]|22)|5[013-9])|4(?:[137][013-9]|[45][6-9]|6(?:[013-9]|22)|8[4-6])|5(?:[1245][013-9]|3|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][13-8]|[49][013-9]|5[0135-9])"]]],"0","0$1"],"UG":["256","\\d{9}",[["(\\d{3})(\\d{6})","$1 $2",["20[0-8]|4(?:6[45]|[7-9])|[7-9]","20(?:[013-8]|2[5-9])|4(?:6[45]|[7-9])|[7-9]"]],["(\\d{2})(\\d{7})","$1 $2",["3|4(?:[1-5]|6[0-36-9])"]],["(2024)(\\d{5})","$1 $2",["202","2024"]]],"0","0$1"],"US":["1","[2-9]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,true,null,["(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[026]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[0-24679]|4[67]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[16]|5[017]|6[0-279]|78|8[012])|7(?:0[1-46-8]|1[02-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|28|3[0-258]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[014678]|4[0179]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}",null,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}","900[2-9]\\d{6}","5(?:00|22|33|44|66|77|88)[2-9]\\d{6}"]],"UY":["598","[2489]\\d{6,7}",[["(\\d{4})(\\d{4})","$1 $2",["[24]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9[1-9]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["[89]0"],"0$1"]],"0"],"UZ":["998","[679]\\d{8}",[["([679]\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[679]"]]],"8","8 $1"],"VA":["39","(?:0(?:878\\d{5}|6698\\d{5})|[1589]\\d{5,10}|3(?:[12457-9]\\d{8}|[36]\\d{7,9}))",[["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|55"]],["(0[26])(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],["(0[26])(\\d{4,6})","$1 $2",["0[26]"]],["(0\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]"]],["(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[245])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]],["(0\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["0[13-57-9][2-46-8]"]],["(0\\d{3})(\\d{2,6})","$1 $2",["0[13-57-9][2-46-8]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13]|8(?:00|4[08]|9[59])","[13]|8(?:00|4[08]|9(?:5[5-9]|9))"]],["(\\d{4})(\\d{4})","$1 $2",["894","894[5-9]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["3"]]],null,null,null,null,null,null,["06698\\d{5}","3(?:[12457-9]\\d{8}|6\\d{7,8}|3\\d{7,9})","80(?:0\\d{6}|3\\d{3})","0878\\d{5}|1(?:44|6[346])\\d{6}|89(?:2\\d{3}|4(?:[0-4]\\d{2}|[5-9]\\d{4})|5(?:[0-4]\\d{2}|[5-9]\\d{6})|9\\d{6})","1(?:78\\d|99)\\d{6}",null,null,null,"55\\d{8}","84(?:[08]\\d{6}|[17]\\d{3})"]],"VC":["1","[5789]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"784"],"VE":["58","[24589]\\d{9}",[["(\\d{3})(\\d{7})","$1-$2"]],"0","0$1"],"VG":["1","[2589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"284"],"VI":["1","[3589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"340"],"VN":["84","1\\d{6,9}|2\\d{9}|6\\d{6,7}|7\\d{6}|8\\d{6,8}|9\\d{8}",[["([17]99)(\\d{4})","$1 $2",["[17]99"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2[48]"]],["(80)(\\d{5})","$1 $2",["80"]],["(69\\d)(\\d{4,5})","$1 $2",["69"]],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2[0-35-79]"]],["([89]\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8(?:8|9[89])|9"]],["(1[2689]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1(?:[26]|8[68]|99)"]],["(86[89])(\\d{3})(\\d{3})","$1 $2 $3",["86[89]"]],["(1[89]00)(\\d{4,6})","$1 $2",["1[89]0","1[89]00"],"$1"]],"0","0$1",null,null,true],"VU":["678","[2-57-9]\\d{4,6}",[["(\\d{3})(\\d{4})","$1 $2",["[579]"]]]],"WF":["681","[4-8]\\d{5}",[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3"]]],"WS":["685","[2-8]\\d{4,6}",[["(8\\d{2})(\\d{3,4})","$1 $2",["8"]],["(7\\d)(\\d{5})","$1 $2",["7"]],["(\\d{5})","$1",["[2-6]"]]]],"YE":["967","[1-7]\\d{6,8}",[["([1-7])(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7[24-68]"]],["(7\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["7[0137]"]]],"0","0$1"],"YT":["262","[268]\\d{8}",[["([268]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[268]"]]],"0",null,null,null,null,"269|63"],"ZA":["27","[1-79]\\d{8}|8\\d{4,8}",[["(860)(\\d{3})(\\d{3})","$1 $2 $3",["860"]],["(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"]],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-79]|8(?:[0-57]|6[1-9])"]]],"0","0$1"],"ZM":["260","[289]\\d{8}",[["([29]\\d)(\\d{7})","$1 $2",["[29]"]],["(800)(\\d{3})(\\d{3})","$1 $2 $3",["800"]]],"0","0$1"],"ZW":["263","2(?:[0-57-9]\\d{3,8}|6(?:[14]\\d{7}|\\d{4}))|[13-79]\\d{4,9}|8[06]\\d{5,8}",[["([49])(\\d{3})(\\d{2,4})","$1 $2 $3",["4|9[2-9]"]],["(7\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["7"]],["(86\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["86[24]"]],["([2356]\\d{2})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8|[78])|3(?:[09]8|17|3[78]|7[1569]|8[37])|5[15][78]|6(?:[29]8|37|[68][78]|75)"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|31|[56][14]|7[35]|84)|329"]],["([1-356]\\d)(\\d{3,5})","$1 $2",["1[3-9]|2[02569]|3[0-69]|5[05689]|6"]],["([235]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[23]9|54"]],["([25]\\d{3})(\\d{3,5})","$1 $2",["(?:25|54)8","258[23]|5483"]],["(8\\d{3})(\\d{6})","$1 $2",["86"]],["(80\\d)(\\d{4})","$1 $2",["80"]]],"0","0$1"],"001":["979","\\d{9}",[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3"]]]}}

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DIGIT_PLACEHOLDER */
/* unused harmony export close_dangling_braces */
/* unused harmony export count_occurences */
/* unused harmony export repeat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parse__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__format__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__(65);



// This is an enhanced port of Google Android `libphonenumber`'s
// `asyoutypeformatter.js` of 17th November, 2016.
//
// https://github.com/googlei18n/libphonenumber/blob/8d21a365061de2ba0675c878a710a7b24f74d2ae/javascript/i18n/phonenumbers/asyoutypeformatter.js









// Used in phone number format template creation.
// Could be any digit, I guess.
var DUMMY_DIGIT = '9';
var DUMMY_DIGIT_MATCHER = new RegExp(DUMMY_DIGIT, 'g');
// I don't know why is it exactly `15`
var LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15;
// Create a phone number consisting only of the digit 9 that matches the
// `number_pattern` by applying the pattern to the "longest phone number" string.
var LONGEST_DUMMY_PHONE_NUMBER = repeat(DUMMY_DIGIT, LONGEST_NATIONAL_PHONE_NUMBER_LENGTH);

// The digits that have not been entered yet will be represented by a \u2008,
// the punctuation space.
var DIGIT_PLACEHOLDER = 'x'; // '\u2008' (punctuation space)
var DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER);
var DIGIT_PLACEHOLDER_MATCHER_GLOBAL = new RegExp(DIGIT_PLACEHOLDER, 'g');

// A pattern that is used to match character classes in regular expressions.
// An example of a character class is "[1-4]".
var CHARACTER_CLASS_PATTERN = /\[([^\[\]])*\]/g;

// Any digit in a regular expression that actually denotes a digit. For
// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
// (8 and 0) are standalone digits, but the rest are not.
// Two look-aheads are needed because the number following \\d could be a
// two-digit number, since the phone number can be as long as 15 digits.
var STANDALONE_DIGIT_PATTERN = /\d(?=[^,}][^,}])/g;

// A pattern that is used to determine if a `format` is eligible
// to be used by the "as you type formatter".
// It is eligible when the `format` contains groups of the dollar sign
// followed by a single digit, separated by valid phone number punctuation.
// This prevents invalid punctuation (such as the star sign in Israeli star numbers)
// getting into the output of the "as you type formatter".
var ELIGIBLE_FORMAT_PATTERN = new RegExp('^' + '[' + __WEBPACK_IMPORTED_MODULE_4__parse__["b" /* VALID_PUNCTUATION */] + ']*' + '(\\$\\d[' + __WEBPACK_IMPORTED_MODULE_4__parse__["b" /* VALID_PUNCTUATION */] + ']*)+' + '$');

// This is the minimum length of the leading digits of a phone number
// to guarantee the first "leading digits pattern" for a phone number format
// to be preemptive.
var MIN_LEADING_DIGITS_LENGTH = 3;

var VALID_INCOMPLETE_PHONE_NUMBER = '[' + __WEBPACK_IMPORTED_MODULE_4__parse__["c" /* PLUS_CHARS */] + ']{0,1}' + '[' + __WEBPACK_IMPORTED_MODULE_4__parse__["b" /* VALID_PUNCTUATION */] + __WEBPACK_IMPORTED_MODULE_4__parse__["d" /* VALID_DIGITS */] + ']*';

var VALID_INCOMPLETE_PHONE_NUMBER_PATTERN = new RegExp('^' + VALID_INCOMPLETE_PHONE_NUMBER + '$', 'i');

var as_you_type = function () {
	function as_you_type(country_code, metadata) {
		__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, as_you_type);

		// Sanity check
		if (!metadata) {
			throw new Error('Metadata not passed');
		}

		if (country_code && metadata.countries[country_code]) {
			this.default_country = country_code;
		}

		this.metadata = metadata;

		this.reset();
	}

	__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(as_you_type, [{
		key: 'input',
		value: function input(text) {
			// Parse input

			var extracted_number = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parse__["e" /* extract_formatted_phone_number */])(text);

			// Special case for a lone '+' sign
			// since it's not considered a possible phone number.
			if (!extracted_number) {
				if (text && text.indexOf('+') >= 0) {
					extracted_number = '+';
				}
			}

			// Validate possible first part of a phone number
			if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common__["a" /* matches_entirely */])(extracted_number, VALID_INCOMPLETE_PHONE_NUMBER_PATTERN)) {
				return this.current_output;
			}

			return this.process_input(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parse__["f" /* parse_phone_number */])(extracted_number));
		}
	}, {
		key: 'process_input',
		value: function process_input(input) {
			// If an out of position '+' sign detected
			// (or a second '+' sign),
			// then just drop it from the input.
			if (input[0] === '+') {
				if (!this.parsed_input) {
					this.parsed_input += '+';

					// If a default country was set
					// then reset it because an explicitly international
					// phone number is being entered
					this.reset_countriness();
				}

				input = input.slice(1);
			}

			// Raw phone number
			this.parsed_input += input;

			// // Reset phone number validation state
			// this.valid = false

			// Add digits to the national number
			this.national_number += input;

			// Try to format the parsed input

			if (this.is_international()) {
				if (!this.country_phone_code) {
					// If one looks at country phone codes
					// then he can notice that no one country phone code
					// is ever a (leftmost) substring of another country phone code.
					// So if a valid country code is extracted so far
					// then it means that this is the country code.

					// If no country phone code could be extracted so far,
					// then just return the raw phone number,
					// because it has no way of knowing
					// how to format the phone number so far.
					if (!this.extract_country_phone_code()) {
						// Return raw phone number
						return this.parsed_input;
					}

					// Initialize country-specific data
					this.initialize_phone_number_formats_for_this_country_phone_code();
					this.reset_format();
					this.determine_the_country();
				}
				// `this.country` could be `undefined`,
				// for instance, when there is ambiguity
				// in a form of several different countries
				// each corresponding to the same country phone code
				// (e.g. NANPA: USA, Canada, etc),
				// and there's not enough digits entered
				// to reliably determine the country
				// the phone number belongs to.
				// Therefore, in cases of such ambiguity,
				// each time something is input,
				// try to determine the country
				// (if it's not determined yet).
				else if (!this.country) {
						this.determine_the_country();
					}
			} else {
				// Some national prefixes are substrings of other national prefixes
				// (for the same country), therefore try to extract national prefix each time
				// because a longer national prefix might be available at some point in time.

				var previous_national_prefix = this.national_prefix;
				this.national_number = this.national_prefix + this.national_number;

				// Possibly extract a national prefix
				this.extract_national_prefix();

				if (this.national_prefix !== previous_national_prefix) {
					// National number has changed
					// (due to another national prefix been extracted)
					// therefore national number has changed
					// therefore reset all previous formatting data.
					// (and leading digits matching state)
					this.matching_formats = this.available_formats;
					this.reset_format();
				}
			}

			if (!this.should_format()) {
				return this.format_as_non_formatted_number();
			}

			// Check the available phone number formats
			// based on the currently available leading digits.
			this.match_formats_by_leading_digits();

			// Format the phone number (given the next digits)
			var formatted_national_phone_number = this.format_national_phone_number(input);

			// If the phone number could be formatted,
			// then return it, possibly prepending with country phone code
			// (for international phone numbers only)
			if (formatted_national_phone_number) {
				return this.full_phone_number(formatted_national_phone_number);
			}

			// If the phone number couldn't be formatted,
			// then just fall back to the raw phone number.
			return this.parsed_input;
		}
	}, {
		key: 'format_as_non_formatted_number',
		value: function format_as_non_formatted_number() {
			if (this.is_international() && this.country_phone_code) {
				if (this.national_number) {
					// For convenience, the public `.template` property
					// contains the whole international number
					// if the phone number being input is international:
					// 'x' for the '+' sign, 'x'es for the country phone code,
					// a spacebar and then the template for the national number digits.
					this.template = DIGIT_PLACEHOLDER + repeat(DIGIT_PLACEHOLDER, this.country_phone_code.length) + ' ' + repeat(DIGIT_PLACEHOLDER, this.national_number.length);

					return '+' + this.country_phone_code + ' ' + this.national_number;
				}

				return '+' + this.country_phone_code;
			}

			return this.parsed_input;
		}
	}, {
		key: 'format_national_phone_number',
		value: function format_national_phone_number(next_digits) {
			// Format the next phone number digits
			// using the previously chosen phone number format.
			//
			// This is done here because if `attempt_to_format_complete_phone_number`
			// was placed before this call then the `template`
			// wouldn't reflect the situation correctly (and would therefore be inconsistent)
			//
			var national_number_formatted_with_previous_format = void 0;
			if (this.chosen_format) {
				national_number_formatted_with_previous_format = this.format_next_national_number_digits(next_digits);
			}

			// See if the input digits can be formatted properly already. If not,
			// use the results from format_next_national_number_digits(), which does formatting
			// based on the formatting pattern chosen.

			var formatted_number = this.attempt_to_format_complete_phone_number();

			// Just because a phone number doesn't have a suitable format
			// that doesn't mean that the phone is invalid
			// because phone number formats only format phone numbers,
			// they don't validate them and some (rare) phone numbers
			// are meant to stay non-formatted.
			if (formatted_number) {
				// if (this.country)
				// {
				// 	this.valid = true
				// }

				return formatted_number;
			}

			// For some phone number formats national prefix

			// If the previously chosen phone number format
			// didn't match the next (current) digit being input
			// (leading digits pattern didn't match).
			if (this.choose_another_format()) {
				// And a more appropriate phone number format
				// has been chosen for these `leading digits`,
				// then format the national phone number (so far)
				// using the newly selected phone number pattern.

				// Will return `undefined` if it couldn't format
				// the supplied national number
				// using the selected phone number pattern.

				return this.reformat_national_number();
			}

			// If could format the next (current) digit
			// using the previously chosen phone number format
			// then return the formatted number so far.

			// If no new phone number format could be chosen,
			// and couldn't format the supplied national number
			// using the selected phone number pattern,
			// then it will return `undefined`.

			return national_number_formatted_with_previous_format;
		}
	}, {
		key: 'reset',
		value: function reset() {
			// Input stripped of non-phone-number characters.
			// Can only contain a possible leading '+' sign and digits.
			this.parsed_input = '';

			this.current_output = '';

			// This contains the national prefix that has been extracted. It contains only
			// digits without formatting.
			this.national_prefix = '';

			this.national_number = '';

			this.reset_countriness();

			this.reset_format();

			// this.valid = false

			return this;
		}
	}, {
		key: 'reset_country',
		value: function reset_country() {
			if (this.default_country && !this.is_international()) {
				this.country = this.default_country;
			} else {
				this.country = undefined;
			}
		}
	}, {
		key: 'reset_countriness',
		value: function reset_countriness() {
			this.reset_country();

			if (this.default_country && !this.is_international()) {
				this.country_metadata = this.metadata.countries[this.default_country];
				this.country_phone_code = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* get_phone_code */])(this.country_metadata);

				this.initialize_phone_number_formats_for_this_country_phone_code();
			} else {
				this.country_metadata = undefined;
				this.country_phone_code = undefined;

				this.available_formats = [];
				this.matching_formats = this.available_formats;
			}
		}
	}, {
		key: 'reset_format',
		value: function reset_format() {
			this.chosen_format = undefined;
			this.template = undefined;
			this.partially_populated_template = undefined;
			this.last_match_position = -1;
		}

		// Format each digit of national phone number (so far)
		// using the newly selected phone number pattern.

	}, {
		key: 'reformat_national_number',
		value: function reformat_national_number() {
			// Format each digit of national phone number (so far)
			// using the selected phone number pattern.
			return this.format_next_national_number_digits(this.national_number);
		}
	}, {
		key: 'initialize_phone_number_formats_for_this_country_phone_code',
		value: function initialize_phone_number_formats_for_this_country_phone_code() {
			// Get all "eligible" phone number formats for this country
			this.available_formats = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* get_formats */])(this.country_metadata).filter(function (format) {
				return ELIGIBLE_FORMAT_PATTERN.test(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* get_format_international_format */])(format));
			});

			this.matching_formats = this.available_formats;
		}
	}, {
		key: 'match_formats_by_leading_digits',
		value: function match_formats_by_leading_digits() {
			var leading_digits = this.national_number;

			// "leading digits" patterns start with a maximum of 3 digits,
			// and then with each additional digit
			// a more precise "leading digits" pattern is specified.

			var index_of_leading_digits_pattern = leading_digits.length - MIN_LEADING_DIGITS_LENGTH;

			if (index_of_leading_digits_pattern < 0) {
				index_of_leading_digits_pattern = 0;
			}

			this.matching_formats = this.matching_formats.filter(function (format) {
				var leading_digits_pattern_count = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* get_format_leading_digits_patterns */])(format).length;

				// Keep everything that isn't restricted by leading digits.
				if (leading_digits_pattern_count === 0) {
					return true;
				}

				var leading_digits_pattern_index = Math.min(index_of_leading_digits_pattern, leading_digits_pattern_count - 1);
				var leading_digits_pattern = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* get_format_leading_digits_patterns */])(format)[leading_digits_pattern_index];

				// Brackets are required for `^` to be applied to
				// all or-ed (`|`) parts, not just the first one.
				return new RegExp('^(' + leading_digits_pattern + ')').test(leading_digits);
			});

			// If there was a phone number format chosen
			// and it no longer holds given the new leading digits then reset it
			if (this.chosen_format && this.matching_formats.indexOf(this.chosen_format) === -1) {
				this.reset_format();
			}
		}
	}, {
		key: 'should_format',
		value: function should_format() {
			// Start matching any formats at all when the national number
			// entered so far is at least 3 digits long,
			// otherwise format matching would give false negatives
			// like when the digits entered so far are `2`
			// and the leading digits pattern is `21` –
			// it's quite obvious in this case that the format could be the one
			// but due to the absence of further digits it would give false negative.
			//
			// Google could have provided leading digits patterns starting
			// with a single digit but they chose not to (for whatever reasons).
			//
			return this.national_number >= MIN_LEADING_DIGITS_LENGTH;
		}

		// Check to see if there is an exact pattern match for these digits. If so, we
		// should use this instead of any other formatting template whose
		// leadingDigitsPattern also matches the input.

	}, {
		key: 'attempt_to_format_complete_phone_number',
		value: function attempt_to_format_complete_phone_number() {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.matching_formats), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var format = _step.value;

					var matcher = new RegExp('^(?:' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["e" /* get_format_pattern */])(format) + ')$');

					if (!matcher.test(this.national_number)) {
						continue;
					}

					if (!this.validate_format(format)) {
						continue;
					}

					// To leave the formatter in a consistent state
					this.reset_format();
					this.chosen_format = format;

					var formatted_number = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__format__["b" /* format_national_number_using_format */])(this.national_number, format, this.is_international(), this.national_prefix.length > 0, this.country_metadata);

					// Set `this.template` and `this.partially_populated_template`.
					//
					// `else` case doesn't ever happen
					// with the current metadata,
					// but just in case.
					//
					/* istanbul ignore else */
					if (this.create_formatting_template(format)) {
						// Populate `this.partially_populated_template`
						this.reformat_national_number();
					} else {
						// Prepend `+CountryCode` in case of an international phone number
						var full_number = this.full_phone_number(formatted_number);
						this.template = full_number.replace(/[\d\+]/g, DIGIT_PLACEHOLDER);
						this.partially_populated_template = full_number;
					}

					return formatted_number;
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		}

		// Prepends `+CountryCode` in case of an international phone number

	}, {
		key: 'full_phone_number',
		value: function full_phone_number(formatted_national_number) {
			if (this.is_international()) {
				return '+' + this.country_phone_code + ' ' + formatted_national_number;
			}

			return formatted_national_number;
		}

		// Extracts the country calling code from the beginning
		// of the entered `national_number` (so far),
		// and places the remaining input into the `national_number`.

	}, {
		key: 'extract_country_phone_code',
		value: function extract_country_phone_code() {
			if (!this.national_number) {
				return;
			}

			var _parse_phone_number_a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parse__["g" /* parse_phone_number_and_country_phone_code */])(this.parsed_input, this.metadata),
			    country_phone_code = _parse_phone_number_a.country_phone_code,
			    number = _parse_phone_number_a.number;

			if (!country_phone_code) {
				return;
			}

			this.country_phone_code = country_phone_code;
			this.national_number = number;

			return this.country_metadata = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["f" /* get_metadata_by_country_phone_code */])(country_phone_code, this.metadata);
		}
	}, {
		key: 'extract_national_prefix',
		value: function extract_national_prefix() {
			this.national_prefix = '';

			if (!this.country_metadata) {
				return;
			}

			var national_number = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parse__["h" /* strip_national_prefix */])(this.national_number, this.country_metadata);

			if (national_number !== this.national_number) {
				this.national_prefix = this.national_number.slice(0, this.national_number.length - national_number.length);
				this.national_number = national_number;
			}

			return this.national_prefix;
		}
	}, {
		key: 'choose_another_format',
		value: function choose_another_format() {
			// When there are multiple available formats, the formatter uses the first
			// format where a formatting template could be created.
			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.matching_formats), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var format = _step2.value;

					// If this format is currently being used
					// and is still possible, then stick to it.
					if (this.chosen_format === format) {
						return;
					}

					// If this `format` is suitable for "as you type",
					// then extract the template from this format
					// and use it to format the phone number being input.

					if (!this.validate_format(format)) {
						continue;
					}

					if (!this.create_formatting_template(format)) {
						continue;
					}

					this.chosen_format = format;

					// With a new formatting template, the matched position
					// using the old template needs to be reset.
					this.last_match_position = -1;

					return true;
				}

				// No format matches the phone number,
				// therefore set `country` to `undefined`
				// (or to the default country).
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}

			this.reset_country();

			// No format matches the national phone number entered
			this.reset_format();
		}
	}, {
		key: 'validate_format',
		value: function validate_format(format) {
			// If national prefix is mandatory for this phone number format
			// and the user didn't input the national prefix,
			// then this phone number format isn't suitable.
			if (!this.is_international() && !this.national_prefix && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["g" /* get_format_national_prefix_is_mandatory_when_formatting */])(format, this.country_metadata)) {
				return;
			}

			return true;
		}
	}, {
		key: 'create_formatting_template',
		value: function create_formatting_template(format) {
			// The formatter doesn't format numbers when numberPattern contains '|', e.g.
			// (20|3)\d{4}. In those cases we quickly return.
			// (Though there's no such format in current metadata)
			/* istanbul ignore if */
			if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["e" /* get_format_pattern */])(format).indexOf('|') >= 0) {
				return;
			}

			// Get formatting template for this phone number format
			var template = this.get_template_for_phone_number_format_pattern(format);

			// If the national number entered is too long
			// for any phone number format, then abort.
			if (!template) {
				return;
			}

			// This one is for national number only
			this.partially_populated_template = template;

			// For convenience, the public `.template` property
			// contains the whole international number
			// if the phone number being input is international:
			// 'x' for the '+' sign, 'x'es for the country phone code,
			// a spacebar and then the template for the formatted national number.
			if (this.is_international()) {
				this.template = DIGIT_PLACEHOLDER + repeat(DIGIT_PLACEHOLDER, this.country_phone_code.length) + ' ' + template;
			}
			// For local numbers, replace national prefix
			// with a digit placeholder.
			else {
					this.template = template.replace(/\d/g, DIGIT_PLACEHOLDER);
				}

			// This one is for the full phone number
			return this.template;
		}

		// Generates formatting template for a phone number format

	}, {
		key: 'get_template_for_phone_number_format_pattern',
		value: function get_template_for_phone_number_format_pattern(format) {
			var national_prefix_formatting_rule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["h" /* get_format_national_prefix_formatting_rule */])(format, this.country_metadata);

			// A very smart trick by the guys at Google
			var number_pattern = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["e" /* get_format_pattern */])(format)
			// Replace anything in the form of [..] with \d
			.replace(CHARACTER_CLASS_PATTERN, '\\d')
			// Replace any standalone digit (not the one in `{}`) with \d
			.replace(STANDALONE_DIGIT_PATTERN, '\\d');

			// This match will always succeed,
			// because the "longest dummy phone number"
			// has enough length to accomodate any possible
			// national phone number format pattern.
			var dummy_phone_number_matching_format_pattern = LONGEST_DUMMY_PHONE_NUMBER.match(number_pattern)[0];

			// If the national number entered is too long
			// for any phone number format, then abort.
			if (this.national_number.length > dummy_phone_number_matching_format_pattern.length) {
				return;
			}

			// Prepare the phone number format
			var number_format = this.get_format_format(format, national_prefix_formatting_rule);

			// Get a formatting template which can be used to efficiently format
			// a partial number where digits are added one by one.

			// Below `strict_pattern` is used for the
			// regular expression (with `^` and `$`).
			// This wasn't originally in Google's `libphonenumber`
			// and I guess they don't really need it
			// because they're not using "templates" to format phone numbers
			// but I added `strict_pattern` after encountering
			// South Korean phone number formatting bug.
			//
			// Non-strict regular expression bug demonstration:
			//
			// this.national_number : `111111111` (9 digits)
			//
			// number_pattern : (\d{2})(\d{3,4})(\d{4})
			// number_format : `$1 $2 $3`
			// dummy_phone_number_matching_format_pattern : `9999999999` (10 digits)
			//
			// '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
			//
			// template : xx xxxx xxxx
			//
			// But the correct template in this case is `xx xxx xxxx`.
			// The template was generated incorrectly because of the
			// `{3,4}` variability in the `number_pattern`.
			//
			// The fix is, if `this.national_number` has already sufficient length
			// to satisfy the `number_pattern` completely then `this.national_number` is used
			// instead of `dummy_phone_number_matching_format_pattern`.

			var strict_pattern = new RegExp('^' + number_pattern + '$');
			var national_number_dummy_digits = this.national_number.replace(/\d/g, DUMMY_DIGIT);

			// If `this.national_number` has already sufficient length
			// to satisfy the `number_pattern` completely then use it
			// instead of `dummy_phone_number_matching_format_pattern`.
			if (strict_pattern.test(national_number_dummy_digits)) {
				dummy_phone_number_matching_format_pattern = national_number_dummy_digits;
			}

			// Generate formatting template for this phone number format
			return dummy_phone_number_matching_format_pattern
			// Format the dummy phone number according to the format
			.replace(new RegExp(number_pattern), number_format)
			// Replace each dummy digit with a DIGIT_PLACEHOLDER
			.replace(DUMMY_DIGIT_MATCHER, DIGIT_PLACEHOLDER);
		}
	}, {
		key: 'format_next_national_number_digits',
		value: function format_next_national_number_digits(digits) {
			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(digits), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var digit = _step3.value;

					// If there is room for more digits in current `template`,
					// then set the next digit in the `template`,
					// and return the formatted digits so far.

					// If more digits are entered than the current format could handle
					if (this.partially_populated_template.slice(this.last_match_position + 1).search(DIGIT_PLACEHOLDER_MATCHER) === -1) {
						// Reset the current format,
						// so that the new format will be chosen
						// in a subsequent `this.choose_another_format()` call
						// later in code.
						this.chosen_format = undefined;
						this.template = undefined;
						this.partially_populated_template = undefined;
						return;
					}

					this.last_match_position = this.partially_populated_template.search(DIGIT_PLACEHOLDER_MATCHER);
					this.partially_populated_template = this.partially_populated_template.replace(DIGIT_PLACEHOLDER_MATCHER, digit);
				}

				// Return the formatted phone number so far
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}

			return close_dangling_braces(this.partially_populated_template, this.last_match_position + 1).replace(DIGIT_PLACEHOLDER_MATCHER_GLOBAL, ' ');
		}
	}, {
		key: 'is_international',
		value: function is_international() {
			return this.parsed_input && this.parsed_input[0] === '+';
		}
	}, {
		key: 'get_format_format',
		value: function get_format_format(format, national_prefix_formatting_rule) {
			var number_format = this.is_international() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* get_format_international_format */])(format) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["i" /* get_format_format */])(format);

			// If national prefix formatting rule is set
			// for this phone number format
			if (national_prefix_formatting_rule) {
				// If the user did input the national prefix
				// (or if the national prefix formatting rule does not require national prefix)
				// then maybe make it part of the phone number template
				if (this.national_prefix || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__metadata__["j" /* get_format_uses_national_prefix */])(national_prefix_formatting_rule)) {
					// Make the national prefix part of the phone number template
					number_format = number_format.replace(__WEBPACK_IMPORTED_MODULE_5__format__["c" /* FIRST_GROUP_PATTERN */], national_prefix_formatting_rule);
				}
			}

			if (this.is_international()) {
				return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__format__["d" /* local_to_international_style */])(number_format);
			}

			return number_format;
		}

		// Determines the country of the phone number
		// entered so far based on the country phone code
		// and the national phone number.

	}, {
		key: 'determine_the_country',
		value: function determine_the_country() {
			this.country = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parse__["i" /* find_country_code */])(this.country_phone_code, this.national_number, this.metadata);
		}
	}]);

	return as_you_type;
}();

/* harmony default export */ __webpack_exports__["a"] = (as_you_type);


function close_dangling_braces(template, cut_before) {
	var retained_template = template.slice(0, cut_before);

	var opening_braces = count_occurences('(', retained_template);
	var closing_braces = count_occurences(')', retained_template);

	var dangling_braces = opening_braces - closing_braces;

	while (dangling_braces > 0 && cut_before < template.length) {
		if (template[cut_before] === ')') {
			dangling_braces--;
		}
		cut_before++;
	}

	return template.slice(0, cut_before);
}

// Counts all occurences of a symbol in a string
function count_occurences(symbol, string) {
	var count = 0;

	var _iteratorNormalCompletion4 = true;
	var _didIteratorError4 = false;
	var _iteratorError4 = undefined;

	try {
		for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(string), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
			var character = _step4.value;

			if (character === symbol) {
				count++;
			}
		}
	} catch (err) {
		_didIteratorError4 = true;
		_iteratorError4 = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion4 && _iterator4.return) {
				_iterator4.return();
			}
		} finally {
			if (_didIteratorError4) {
				throw _iteratorError4;
			}
		}
	}

	return count;
}

// Repeats a string (or a symbol) N times.
// http://stackoverflow.com/questions/202605/repeat-string-javascript
function repeat(string, times) {
	if (times < 1) {
		return '';
	}

	var result = '';

	while (times > 1) {
		if (times & 1) {
			result += string;
		}

		times >>= 1;
		string += string;
	}

	return result + string;
}
//# sourceMappingURL=as you type.js.map

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = is_valid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parse__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_number_type__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__metadata__ = __webpack_require__(39);





// Checks if a given phone number is valid
//
// Example use cases:
//
// ```js
// is_valid('8005553535', 'RU')
// is_valid('8005553535', 'RU', metadata)
// is_valid({ phone: '8005553535', country: 'RU' })
// is_valid({ phone: '8005553535', country: 'RU' }, metadata)
// is_valid('+78005553535')
// is_valid('+78005553535', metadata)
// ```
//
function is_valid(first_argument, second_argument, third_argument) {
	var _sort_out_arguments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__get_number_type__["b" /* sort_out_arguments */])(first_argument, second_argument, third_argument),
	    input = _sort_out_arguments.input,
	    metadata = _sort_out_arguments.metadata;

	// Sanity check


	if (!metadata) {
		throw new Error('Metadata not passed');
	}

	if (!input) {
		return false;
	}

	if (!input.country) {
		return false;
	}

	var country_metadata = metadata.countries[input.country];

	if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__metadata__["p" /* get_types */])(country_metadata)) {
		if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__get_number_type__["a" /* default */])(input, metadata)) {
			return false;
		}
	}

	return true;
}
//# sourceMappingURL=validate.js.map

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parse;
/* harmony export (immutable) */ __webpack_exports__["b"] = format;
/* unused harmony export get_number_type */
/* unused harmony export getNumberType */
/* harmony export (immutable) */ __webpack_exports__["c"] = is_valid_number;
/* unused harmony export isValidNumber */
/* harmony export (immutable) */ __webpack_exports__["f"] = as_you_type;
/* unused harmony export asYouType */
/* harmony export (immutable) */ __webpack_exports__["d"] = getPhoneCode;
/* unused harmony export getPhoneCodeCustom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata_min_json__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__metadata_min_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__es6_parse__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__es6_get_number_type__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__es6_format__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__es6_validate__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__es6_as_you_type__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__es6_metadata__ = __webpack_require__(39);
/* unused harmony reexport parseCustom */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__es6_parse__["k"]; });
/* unused harmony reexport formatCustom */
/* unused harmony reexport isValidNumberCustom */
/* unused harmony reexport getNumberTypeCustom */
/* unused harmony reexport asYouTypeCustom */
/* unused harmony reexport DIGIT_PLACEHOLDER */










function parse()
{
	var parameters = Array.prototype.slice.call(arguments)
	parameters.push(__WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
	return __WEBPACK_IMPORTED_MODULE_1__es6_parse__["a" /* default */].apply(this, parameters)
}

function format()
{
	var parameters = Array.prototype.slice.call(arguments)
	parameters.push(__WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
	return __WEBPACK_IMPORTED_MODULE_3__es6_format__["a" /* default */].apply(this, parameters)
}

function get_number_type()
{
	var parameters = Array.prototype.slice.call(arguments)
	parameters.push(__WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
	return __WEBPACK_IMPORTED_MODULE_2__es6_get_number_type__["a" /* default */].apply(this, parameters)
}

// camelCase alias
function getNumberType()
{
	return get_number_type.apply(this, arguments)
}

function is_valid_number()
{
	var parameters = Array.prototype.slice.call(arguments)
	parameters.push(__WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
	return __WEBPACK_IMPORTED_MODULE_4__es6_validate__["a" /* default */].apply(this, parameters)
}

// camelCase alias
function isValidNumber()
{
	return is_valid_number.apply(this, arguments)
}

function as_you_type(country)
{
	__WEBPACK_IMPORTED_MODULE_5__es6_as_you_type__["a" /* default */].call(this, country, __WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
}

as_you_type.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_5__es6_as_you_type__["a" /* default */].prototype, {})
as_you_type.prototype.constructor = as_you_type

// camelCase alias

function asYouType(country)
{
	__WEBPACK_IMPORTED_MODULE_5__es6_as_you_type__["a" /* default */].call(this, country, __WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
}

asYouType.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_5__es6_as_you_type__["a" /* default */].prototype, {})
asYouType.prototype.constructor = asYouType









function getPhoneCode(country)
{
	return getPhoneCodeCustom(country, __WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
}

function getPhoneCodeCustom(country, metadata)
{
	if (!metadata.countries[country])
	{
		throw new Error('Unknown country: "' + country + '"')
	}

	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__es6_metadata__["a" /* get_phone_code */])(metadata.countries[country])
}

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(391);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 157 */
/***/ (function(module, exports) {

/**
 * @module object-loops/for-each
 */

/**
 * Executes a provided function once per each object value.
 * @function module:object-loops/for-each
 * @param {object} [obj] - object to forEach, not accepted if being used directly on Object.prototype
 * @param {forEachCallback} callback - function that will be invoked once for each key-value pair
 * @param {*} [thisArg] - context to bind to callback
 */
module.exports = forEach

function forEach (obj, callback, thisArg) {
  if (Array.isArray(obj)) {
    return obj.forEach(callback, thisArg)
  }
  if (typeof obj !== 'object' && typeof obj !== 'function') {
    throw new TypeError(obj + ' must be an object')
  }
  if (typeof callback !== 'function') {
    throw new TypeError(callback + ' must be a function')
  }
  Object.keys(obj).forEach(function (key) {
    var val = obj[key]
    callback.call(thisArg, val, key, obj)
  })
}
/**
 * This callback type is called `forEachCallback` and is displayed as a global symbol.
 * @callback forEachCallback
 * @param {*} val - value for key
 * @param {string} key - object key (used in current iteration)
 * @param {object} obj - object which values are being iterated
 */


/***/ }),
/* 158 */
/***/ (function(module, exports) {

/**
 * Parses an URI
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */

var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;

var parts = [
    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
];

module.exports = function parseuri(str) {
    var src = str,
        b = str.indexOf('['),
        e = str.indexOf(']');

    if (b != -1 && e != -1) {
        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    }

    var m = re.exec(str || ''),
        uri = {},
        i = 14;

    while (i--) {
        uri[parts[i]] = m[i] || '';
    }

    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }

    return uri;
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  return (/input|select|textarea|button|object/.test(nodeName) ? !element.disabled : "a" === nodeName ? element.href || isTabIndexNotNaN : isTabIndexNotNaN) && visible(element);
}

function hidden(el) {
  return el.offsetWidth <= 0 && el.offsetHeight <= 0 || el.style.display === 'none';
}

function visible(element) {
  while (element) {
    if (element === document.body) break;
    if (hidden(element)) return false;
    element = element.parentNode;
  }
  return true;
}

function tabbable(element) {
  var tabIndex = element.getAttribute('tabindex');
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll('*'), 0).filter(function (el) {
    return tabbable(el);
  });
}

module.exports = findTabbableDescendants;

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_libphonenumber_js__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_input_format__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_classnames__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_responsive_ui_commonjs_Select__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_responsive_ui_commonjs_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_responsive_ui_commonjs_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__countries__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__countries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__InternationalIcon__ = __webpack_require__(416);

















// Could have been `import { Select } from 'react-responsive-ui'`
// but in that case Webpack bundles the whole `react-responsive-ui` package.





// A list of all country codes
var all_countries = [];

// Country code to country name map
var default_dictionary = {
	International: 'International'

	// Populate `all_countries` and `default_dictionary`
};var _iteratorNormalCompletion = true;
var _didIteratorError = false;
var _iteratorError = undefined;

try {
	for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_17__countries___default.a), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
		var item = _step.value;

		var _item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(item, 2),
		    code = _item[0],
		    name = _item[1];

		all_countries.push(code.toUpperCase());
		default_dictionary[code.toUpperCase()] = name;
	}

	// Default country flag icon
} catch (err) {
	_didIteratorError = true;
	_iteratorError = err;
} finally {
	try {
		if (!_iteratorNormalCompletion && _iterator.return) {
			_iterator.return();
		}
	} finally {
		if (_didIteratorError) {
			throw _iteratorError;
		}
	}
}

var FlagComponent = function FlagComponent(_ref) {
	var countryCode = _ref.countryCode,
	    flagsPath = _ref.flagsPath;
	return __WEBPACK_IMPORTED_MODULE_10_react__["default"].createElement('img', {
		alt: countryCode,
		className: 'react-phone-number-input__icon',
		src: '' + flagsPath + countryCode.toLowerCase() + '.svg' });
};

// Allows passing custom `libphonenumber-js` metadata
// to reduce the overall bundle size.

var Input = function (_Component) {
	__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default()(Input, _Component);

	function Input(props) {
		__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, Input);

		var _this = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Input.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(Input)).call(this, props));

		_initialiseProps.call(_this);

		var _this$props = _this.props,
		    countries = _this$props.countries,
		    value = _this$props.value,
		    dictionary = _this$props.dictionary,
		    international = _this$props.international,
		    internationalIcon = _this$props.internationalIcon,
		    flags = _this$props.flags;
		var country = _this.props.country;

		// Normalize `country` code

		country = normalize_country_code(country, dictionary);

		// Autodetect country if value is set
		// and is international (which it should be)
		if (value && value[0] === '+') {
			// `country` will be left `undefined` in case of non-detection
			country = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_libphonenumber_js__["a" /* parse */])(value).country;
		}

		// If there will be no "International" option
		// then a `country` must be selected.
		if (!should_add_international_option(_this.props) && !country) {
			country = countries[0];
		}

		// Set the currently selected country
		_this.state.country_code = country;

		// If a phone number `value` is passed then format it
		if (value) {
			// `this.state.value_property` is the `this.props.value`
			// which corresponding to `this.state.value`.
			// It is being compared in `componentWillReceiveProps()`
			// against `newProps.value` to find out if the new `value` property
			// needs `this.state.value` recalculation.
			_this.state.value_property = value;
			// Set the currently entered `value`.
			// State `value` is either in international plaintext or just plaintext format.
			// (e.g. `+78005553535`, `1234567`)
			_this.state.value = _this.get_input_value_depending_on_the_country_selected(value, country);
		}

		// `<Select/>` options
		_this.select_options = [];

		// Whether custom country names are supplied
		var using_custom_country_names = false;

		// Add a `<Select/>` option for each country
		var _iteratorNormalCompletion2 = true;
		var _didIteratorError2 = false;
		var _iteratorError2 = undefined;

		try {
			for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(countries), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
				var country_code = _step2.value;

				if (dictionary[country_code]) {
					using_custom_country_names = true;
				}

				_this.select_options.push({
					value: country_code,
					label: dictionary[country_code] || default_dictionary[country_code],
					icon: get_country_option_icon(country_code, _this.props)
				});
			}

			// Sort the list of countries alphabetically
			// (if `String.localeCompare` is available).
			// https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare
			// (Which means: IE >= 11, and does not work in Safari as of May 2017)
			//
			// This is only done when custom country names
			// are supplied via `dictionary` property
			// because by default all country names are already sorted.
			//
		} catch (err) {
			_didIteratorError2 = true;
			_iteratorError2 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion2 && _iterator2.return) {
					_iterator2.return();
				}
			} finally {
				if (_didIteratorError2) {
					throw _iteratorError2;
				}
			}
		}

		if (using_custom_country_names && String.prototype.localeCompare) {
			_this.select_options.sort(function (a, b) {
				return a.label.localeCompare(b.label);
			});
		}

		// Add the "International" option to the country list (if suitable)
		if (should_add_international_option(_this.props)) {
			_this.select_options.unshift({
				label: dictionary['International'] || default_dictionary['International'],
				icon: flags === false ? undefined : internationalIcon
			});
		}
		return _this;
	}

	// Determines the text `<input/>` `value`
	// depending on `this.props.value` and the country selected.
	//
	// E.g. when a country is selected and `this.props.value`
	// is in international format for this country
	// then it can be converted to national format
	// (if `convertToNational` is `true`).
	//


	__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(Input, [{
		key: 'get_input_value_depending_on_the_country_selected',
		value: function get_input_value_depending_on_the_country_selected(value, country_code) {
			var _props = this.props,
			    metadata = _props.metadata,
			    convertToNational = _props.convertToNational;


			if (!value) {
				return;
			}

			// If the country code is specified
			if (country_code) {
				// and the phone is in international format
				// and should convert to national phone number
				if (value[0] === '+' && convertToNational) {
					// If it's a fully-entered phone number
					// that converts into a valid national number for this country
					// then the value is set to be that national number.

					var parsed = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_libphonenumber_js__["a" /* parse */])(value, metadata);

					if (parsed.country === country_code) {
						var input_value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_libphonenumber_js__["b" /* format */])(parsed.phone, country_code, 'National', metadata);
						return this.format(input_value, country_code).text;
					}
				}
			}
			// The country is not set.
			// Must be an international phone number then.
			else if (value[0] !== '+') {
					// The following causes the caret to move the end of the input field
					// but it's unlikely any sane person would like to erase the `+` sign
					// while inputting an international phone number without any country selected.
					return '+' + value;
				}

			return value;
		}
	}, {
		key: 'set_country_code_value',
		value: function set_country_code_value(country_code) {
			var onCountryChange = this.props.onCountryChange;


			if (onCountryChange) {
				onCountryChange(country_code);
			}

			this.setState({ country_code: country_code });
		}

		// `<select/>` `onChange` handler


		// `input-format` `parse` character function
		// https://github.com/catamphetamine/input-format


		// `input-format` `format` function
		// https://github.com/catamphetamine/input-format


		// Returns `true` if the country is available in the list


		// Can be called externally


		// `<input/>` `onKeyDown` handler


		// `<input/>` `onChange` handler.
		// Updates `this.props.value` (in e.164 phone number format)
		// according to the new `this.state.value`.
		// (keeps them in sync)


		// This `onBlur` interceptor is a workaround for `redux-form`,
		// so that it gets the parsed `value` in its `onBlur` handler,
		// not the formatted one.
		// A developer is not supposed to pass this `onBlur` property manually.
		// Instead, `redux-form` passes `onBlur` to this component automatically
		// and this component passes this `onBlur` property further to
		// `input-format`'s `<ReactInput/>` which then modifies this `onBlur` handler
		// to return the correct parsed `value` so that it all works with `redux-form`.


		// When country `<select/>` is toggled


		// Focuses the `<input/>` field
		// on tab out of the country `<select/>`

	}, {
		key: 'can_change_country',


		// Can a user change the default country or not.
		value: function can_change_country() {
			var countries = this.props.countries;

			// If `countries` is empty,
			// then only "International" option is available,
			// so can't switch it.
			//
			// If `countries` is a single allowed country,
			// then cant's switch it.
			//

			return countries.length > 1;
		}

		// Listen for default country property:
		// if it is set after the page loads
		// and the user hasn't selected a country yet
		// then select the default country.

	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(new_props) {
			var _props2 = this.props,
			    countries = _props2.countries,
			    value = _props2.value,
			    dictionary = _props2.dictionary;

			// Normalize `country` codes

			var country = normalize_country_code(this.props.country, dictionary);
			var new_country = normalize_country_code(new_props.country, dictionary);

			// If the default country changed
			// (e.g. in case of IP detection)
			if (new_country !== country) {
				// If the phone number input field is currently empty
				// (e.g. not touched yet) then change the selected `country`
				// to the newly passed one (e.g. as a result of a GeoIP query)
				if (!value) {
					// If the passed `country` allowed then update it
					if (countries.indexOf(new_country) !== -1) {
						// Set the new `country`
						this.set_country(new_country, false);
					}
				}
			}

			// This code is executed:
			// * after `this.props.onChange(value)` is called
			// * if the `value` was externally set (e.g. cleared)
			if (new_props.value !== value) {
				// `this.state.value_property` is the `this.props.value`
				// which corresponding to `this.state.value`.
				// It is being compared in `componentWillReceiveProps()`
				// against `newProps.value` to find out if the new `value` property
				// needs `this.state.value` recalculation.
				// This is an optimization, it's like `shouldComponentUpdate()`.
				// This is supposed to save some CPU cycles, maybe not much, I didn't check.
				// Or maybe there was some other reason for this I don't remember now.
				if (new_props.value !== this.state.value_property) {
					// Update the `value` because it was externally set

					// Country code gets updated too
					var country_code = this.state.country_code;

					// Autodetect country if `value` is set
					// and is international (which it should be)
					if (new_props.value && new_props.value[0] === '+') {
						// `parse().country` will be `undefined` in case of non-detection
						country_code = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_libphonenumber_js__["a" /* parse */])(new_props.value).country || country_code;
					}

					this.setState({
						country_code: country_code,
						value: this.get_input_value_depending_on_the_country_selected(new_props.value, country_code),
						// `this.state.value_property` is the `this.props.value`
						// which corresponding to `this.state.value`.
						// It is being compared in `componentWillReceiveProps()`
						// against `newProps.value` to find out if the new `value` property
						// needs `this.state.value` recalculation.
						value_property: new_props.value
					});
				}
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props3 = this.props,
			    saveOnIcons = _props3.saveOnIcons,
			    showCountrySelect = _props3.showCountrySelect,
			    nativeExpanded = _props3.nativeExpanded,
			    disabled = _props3.disabled,
			    autoComplete = _props3.autoComplete,
			    selectTabIndex = _props3.selectTabIndex,
			    selectMaxItems = _props3.selectMaxItems,
			    selectAriaLabel = _props3.selectAriaLabel,
			    selectCloseAriaLabel = _props3.selectCloseAriaLabel,
			    inputTabIndex = _props3.inputTabIndex,
			    style = _props3.style,
			    selectStyle = _props3.selectStyle,
			    inputStyle = _props3.inputStyle,
			    className = _props3.className,
			    inputClassName = _props3.inputClassName,
			    error = _props3.error,
			    indicateInvalid = _props3.indicateInvalid,
			    SelectComponent = _props3.selectComponent,
			    InputComponent = _props3.inputComponent,
			    dictionary = _props3.dictionary,
			    countries = _props3.countries,
			    country = _props3.country,
			    onCountryChange = _props3.onCountryChange,
			    flags = _props3.flags,
			    flagComponent = _props3.flagComponent,
			    flagsPath = _props3.flagsPath,
			    international = _props3.international,
			    internationalIcon = _props3.internationalIcon,
			    convertToNational = _props3.convertToNational,
			    metadata = _props3.metadata,
			    input_props = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_objectWithoutProperties___default()(_props3, ['saveOnIcons', 'showCountrySelect', 'nativeExpanded', 'disabled', 'autoComplete', 'selectTabIndex', 'selectMaxItems', 'selectAriaLabel', 'selectCloseAriaLabel', 'inputTabIndex', 'style', 'selectStyle', 'inputStyle', 'className', 'inputClassName', 'error', 'indicateInvalid', 'selectComponent', 'inputComponent', 'dictionary', 'countries', 'country', 'onCountryChange', 'flags', 'flagComponent', 'flagsPath', 'international', 'internationalIcon', 'convertToNational', 'metadata']);

			// `inputTabIndex` is deprecated, use just `tabIndex` instead


			if (inputTabIndex) {
				input_props.tabIndex = inputTabIndex;
			}

			var _state = this.state,
			    value = _state.value,
			    country_code = _state.country_code,
			    country_select_is_shown = _state.country_select_is_shown;

			// `type="tel"` was reported to have issues with
			// Samsung keyboards caret position on Android OS.
			// https://github.com/catamphetamine/react-phone-number-input/issues/59
			// One may choose to pass `type="text"` in those cases
			// but this will result in a non-digital input keyboard.

			return __WEBPACK_IMPORTED_MODULE_10_react__["default"].createElement(
				'div',
				{
					style: style,
					className: __WEBPACK_IMPORTED_MODULE_15_classnames___default()('react-phone-number-input', {
						'react-phone-number-input--invalid': error && indicateInvalid
					}, className) },
				__WEBPACK_IMPORTED_MODULE_10_react__["default"].createElement(
					'div',
					{ className: 'react-phone-number-input__row' },
					showCountrySelect && this.can_change_country() && __WEBPACK_IMPORTED_MODULE_10_react__["default"].createElement(SelectComponent, {
						ref: this.store_select_instance,
						value: country_code,
						options: this.select_options,
						onChange: this.set_country,
						disabled: disabled,
						onToggle: this.country_select_toggled,
						onTabOut: this.on_country_select_tab_out,
						nativeExpanded: nativeExpanded,
						autocomplete: true,
						autocompleteShowAll: true,
						maxItems: selectMaxItems,
						concise: true,
						tabIndex: selectTabIndex,
						focusUponSelection: false,
						saveOnIcons: saveOnIcons,
						name: input_props.name ? input_props.name + '__country' : undefined,
						ariaLabel: selectAriaLabel,
						closeAriaLabel: selectCloseAriaLabel,
						style: selectStyle,
						className: __WEBPACK_IMPORTED_MODULE_15_classnames___default()('react-phone-number-input__country', {
							'react-phone-number-input__country--native-expanded': nativeExpanded
						}),
						inputClassName: inputClassName }),
					!country_select_is_shown && __WEBPACK_IMPORTED_MODULE_10_react__["default"].createElement(InputComponent, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
						type: 'tel'
					}, input_props, {
						ref: this.store_input_instance,
						value: value,
						onChange: this.on_change,
						onBlur: this.on_blur,
						disabled: disabled,
						autoComplete: autoComplete,
						parse: this.parse_character,
						format: this.format,
						onKeyDown: this.on_key_down,
						style: inputStyle,
						className: __WEBPACK_IMPORTED_MODULE_15_classnames___default()('rrui__input', 'rrui__input-element', 'rrui__input-field', {
							'rrui__input-field--invalid': error && indicateInvalid,
							'rrui__input-field--disabled': disabled
						}, 'react-phone-number-input__phone', inputClassName) }))
				),
				error && indicateInvalid && __WEBPACK_IMPORTED_MODULE_10_react__["default"].createElement(
					'div',
					{ className: __WEBPACK_IMPORTED_MODULE_15_classnames___default()('rrui__input-error', 'react-phone-number-input__error') },
					error
				)
			);
		}
	}]);

	return Input;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

// Parses a partially entered phone number
// and returns the national number so far.
// Not using `libphonenumber-js`'s `parse`
// function here because `parse` only works
// when the number is fully entered,
// and this one is for partially entered number.


Input.propTypes = {
	// Phone number `value`.
	// Is a plaintext international phone number
	// (e.g. "+12223333333" for USA)
	value: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string,

	// This handler is called each time
	// the phone number <input/> changes its textual value.
	onChange: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired,

	// This `onBlur` interceptor is a workaround for `redux-form`,
	// so that it gets the parsed `value` in its `onBlur` handler,
	// not the formatted one.
	// A developer is not supposed to pass this `onBlur` property manually.
	// Instead, `redux-form` passes `onBlur` to this component automatically
	// and this component passes this `onBlur` property further to
	// `input-format`'s `<ReactInput/>` which then modifies this `onBlur` handler
	// to return the correct parsed `value` so that it all works with `redux-form`.
	onBlur: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

	// Set `onKeyDown` handler.
	// Can be used in special cases to handle e.g. enter pressed
	onKeyDown: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

	// Disables both the <input/> and the <select/>
	// (is `false` by default)
	disabled: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool.isRequired,

	// An error message below the `<input/>`
	error: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool]),

	// If this flag is `true` then the `error` is shown.
	// If this flag is `false` then the `error` is not shown (even if passed).
	indicateInvalid: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

	// Remembers the input and also autofills it
	// with a previously remembered phone number.
	// Default value: "tel".
	//
	// https://developers.google.com/web/updates/2015/06/checkout-faster-with-autofill
	//
	// "So when should you use autocomplete="off"?
	//  One example is when you've implemented your own version
	//  of autocomplete for search. Another example is any form field
	//  where users will input and submit different kinds of information
	//  where it would not be useful to have the browser remember
	//  what was submitted previously".
	//
	autoComplete: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string.isRequired,

	// Two-letter country code
	// to be used as the default country
	// for local (non-international) phone numbers.
	country: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string,

	// Is called when the selected country changes
	// (either by a user manually, or by autoparsing
	//  an international phone number being input).
	// This handler does not need to update the `country` property.
	// It's simply a listener for those who might need that for whatever purpose.
	onCountryChange: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

	// Localization dictionary:
	// `{ International: 'Международный', RU: 'Россия', US: 'США', ... }`
	dictionary: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string).isRequired,

	// An optional list of allowed countries
	countries: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string).isRequired,

	// Custom national flag icons
	flags: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,
	// Legacy behaviour, will be removed
	// in some future major version upgrade.
	__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.element)]),

	// Flag icon component
	flagComponent: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired,

	// A base URL path for national flag SVG icons.
	// By default it uses the ones from `flag-icon-css` github repo.
	flagsPath: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string.isRequired,

	// Whether to use native `<select/>` when expanded
	nativeExpanded: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool.isRequired,

	// If set to `false`, then country flags will be shown
	// for all countries in the options list
	// (not just for selected country).
	saveOnIcons: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool.isRequired,

	// Whether to show country `<Select/>`
	// (is `true` by default)
	showCountrySelect: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool.isRequired,

	// Whether to add the "International" option
	// to the list of countries.
	international: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

	// Custom "International" phone number type icon.
	internationalIcon: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.element.isRequired,

	// Should the initially passed phone number `value`
	// be converted to a national phone number for its country.
	// (is `false` by default)
	convertToNational: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool.isRequired,

	// HTML `tabindex` attribute for the country select
	selectTabIndex: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.number,

	// Defines the height of the dropdown country select list
	selectMaxItems: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.number,

	// (deprecated, use just `tabIndex` instead)
	// HTML `tabindex` attribute for the phone number `<input/>`
	inputTabIndex: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.number,

	// `aria-label` for the `<Select/>`'s `<button/>`
	selectAriaLabel: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string,

	// `aria-label` for the `<Select/>`'s "Close" button
	// (which is an "x" visible in fullscreen mode).
	// (not yet implemented but is likely to be)
	selectCloseAriaLabel: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string,

	// CSS style object
	style: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.object,

	// Inline CSS styles for country `<select/>`
	selectStyle: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.object,

	// Inline CSS styles for phone number `<input/>`
	inputStyle: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.object,

	// Component CSS class
	className: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string,

	// `<input/>` CSS class
	// (both for the phone number `<input/>` and the autocomplete `<input/>`)
	inputClassName: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string,

	// `<Select/>` from `react-responsive-ui` is used by default
	selectComponent: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired,

	// `<ReactInput/>` from `input-format` is used by default
	inputComponent: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired,

	// `libphonenumber-js` metadata
	metadata: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.shape({
		country_phone_code_to_countries: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.object.isRequired,
		countries: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.object.isRequired
	}).isRequired
};
Input.defaultProps = {
	// Is enabled
	disabled: false,

	// Remember (and autofill) as a phone number
	autoComplete: 'tel',

	// Include all countries by default
	countries: all_countries,

	// Flag icon component
	flagComponent: FlagComponent,

	// By default use the ones from `flag-icon-css` github repo.
	flagsPath: 'https://lipis.github.io/flag-icon-css/flags/4x3/',

	// Default international icon (globe)
	internationalIcon: __WEBPACK_IMPORTED_MODULE_10_react__["default"].createElement(
		'div',
		{ className: __WEBPACK_IMPORTED_MODULE_15_classnames___default()('react-phone-number-input__icon', 'react-phone-number-input__icon--international') },
		__WEBPACK_IMPORTED_MODULE_10_react__["default"].createElement(__WEBPACK_IMPORTED_MODULE_18__InternationalIcon__["a" /* default */], null)
	),

	// Custom country names
	dictionary: {},

	// Whether to use native `<select/>` when expanded
	nativeExpanded: false,

	// Don't show flags for all countries in the options list
	// (show it just for selected country).
	// (to save user's traffic because all flags are about 3 MegaBytes)
	saveOnIcons: true,

	// Show country `<Select/>` by default
	showCountrySelect: true,

	// Don't convert the initially passed phone number `value`
	// to a national phone number for its country.
	// The reason is that the newer generation grows up when
	// there are no stationary phones and therefore everyone inputs
	// phone numbers with a `+` in their smartphones so local phone numbers
	// should now be considered obsolete.
	convertToNational: false,

	// `<Select/>` from `react-responsive-ui` is used by default
	selectComponent: __WEBPACK_IMPORTED_MODULE_16_react_responsive_ui_commonjs_Select___default.a,

	// `<ReactInput/>` from `input-format` is used by default
	inputComponent: __WEBPACK_IMPORTED_MODULE_14_input_format__["a" /* ReactInput */]
};

var _initialiseProps = function _initialiseProps() {
	var _this2 = this;

	this.state = {};

	this.set_country = function (country_code, focus) {
		var _props4 = _this2.props,
		    metadata = _props4.metadata,
		    convertToNational = _props4.convertToNational;

		// Previously selected country

		var previous_country_code = _this2.state.country_code;

		_this2.set_country_code_value(country_code);

		// Adjust the phone number (`value`)
		// according to the selected `country_code`

		var value = _this2.state.value;

		// If the `value` property holds any digits already

		if (value) {
			// If switching to a country from International or another country
			if (country_code) {
				// If the phone number was entered in international format.
				// The phone number may be incomplete.
				// The phone number entered not necessarily starts with
				// the previously selected country phone prefix.
				if (value[0] === '+') {
					// If the international phone number already contains
					// any country phone code then trim the country phone code part.
					// (that also could be the newly selected country phone code prefix)
					value = strip_country_phone_code(value, metadata);

					// Else just trim the + sign
					if (value[0] === '+') {
						value = value.slice('+'.length);
					}

					// Prepend country phone code part if `convertToNational` is not set
					if (!convertToNational) {
						value = '+' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_libphonenumber_js__["d" /* getPhoneCode */])(country_code) + value;
					}
				}
			}

			// If switching to International from a country
			if (previous_country_code && !country_code) {
				// If no leading `+` sign
				if (value[0] !== '+') {
					// Format the local phone number as an international one.
					// The phone number entered not necessarily even starts with
					// the previously selected country phone prefix.
					// Even if the phone number belongs to whole another country
					// it will still be parsed into some national phone number.
					var national_number = parse_partial_number(value, previous_country_code, metadata).national_number;
					value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_libphonenumber_js__["b" /* format */])(national_number, previous_country_code, 'International_plaintext', metadata);
				}
			}

			// Update the adjusted `<input/>` `value`
			// and update `this.props.value` (in e.164 phone number format)
			// according to the new `this.state.value`.
			// (keep them in sync)
			_this2.on_change(value, country_code, true);
		}
		// Disabling this feature because if a user selects a country
		// then it means he doesn't know how to input his phone number
		// in international format therefore not forcing it
		// by prepending `+${getPhoneCode(country_code)}`.
		//
		// else
		// {
		// 	// If the `value` property is `undefined`
		// 	// (which means the `<input/>` is either empty
		// 	//  or just the country phone code part is entered)
		// 	// and `convertToNational` wasn't set to `true`
		// 	// then populate `<input/>` with the selected country
		// 	// phone code prefix.
		// 	if (!convertToNational && country_code)
		// 	{
		// 		// Update the adjusted `<input/>` `value`
		// 		// and update `this.props.value` (in e.164 phone number format)
		// 		// according to the new `this.state.value`.
		// 		// (keep them in sync)
		// 		this.on_change(`+${getPhoneCode(country_code)}`, country_code, true)
		// 	}
		// }

		// Focus the phone number input upon country selection
		// (do it in a timeout because the `<input/>`
		//  is hidden while selecting a country)
		if (focus !== false) {
			setTimeout(_this2.focus, 0);
		}
	};

	this.parse_character = function (character, value) {
		var countries = _this2.props.countries;


		if (character === '+') {
			// Only allow a leading `+`
			if (!value) {
				// If the "International" option is available
				// then allow the leading `+` because it's meant to be this way.
				//
				// Otherwise, the leading `+` will either erase all subsequent digits
				// (if they're not appropriate for the selected country)
				// or the subsequent digits (if any) will join the `+`
				// forming an international phone number. Because a user
				// might be comfortable with entering an international phone number
				// (i.e. with country code) rather than the local one.
				// Therefore such possibility is given.
				//
				return character;
			}
		}
		// For digits.
		// Converts wide-ascii and arabic-indic numerals to European numerals.
		// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
		else if (__WEBPACK_IMPORTED_MODULE_13_libphonenumber_js__["e" /* DIGITS */][character]) {
				var metadata = _this2.props.metadata;
				var country_code = _this2.state.country_code;

				// If the "International" option is not available
				// and if the value has a leading `+`
				// then it means that the phone number being entered
				// is an international one, so only allow the country phone code
				// for the selected country to be entered.

				if (!should_add_international_option(_this2.props) && value && value[0] === '+') {
					if (!could_phone_number_belong_to_country(value + __WEBPACK_IMPORTED_MODULE_13_libphonenumber_js__["e" /* DIGITS */][character], country_code, metadata)) {
						return;
					}
				}

				return __WEBPACK_IMPORTED_MODULE_13_libphonenumber_js__["e" /* DIGITS */][character];
			}
	};

	this.format = function (input_text) {
		var country_code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this2.state.country_code;
		var metadata = _this2.props.metadata;

		// "As you type" formatter

		var formatter = new __WEBPACK_IMPORTED_MODULE_13_libphonenumber_js__["f" /* as_you_type */](country_code, metadata);

		// Is used to check if a country code can already be derived
		_this2.formatter = formatter;

		// Format phone number
		var text = formatter.input(input_text);

		return { text: text, template: formatter.template };
	};

	this.is_selectable_country = function (country_code) {
		var countries = _this2.props.countries;
		var _iteratorNormalCompletion3 = true;
		var _didIteratorError3 = false;
		var _iteratorError3 = undefined;

		try {

			for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(countries), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
				var available_country_code = _step3.value;

				if (available_country_code === country_code) {
					return true;
				}
			}
		} catch (err) {
			_didIteratorError3 = true;
			_iteratorError3 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion3 && _iterator3.return) {
					_iterator3.return();
				}
			} finally {
				if (_didIteratorError3) {
					throw _iteratorError3;
				}
			}
		}
	};

	this.focus = function () {
		__WEBPACK_IMPORTED_MODULE_12_react_dom__["default"].findDOMNode(_this2.input).focus();
	};

	this.on_key_down = function (event) {
		var onKeyDown = _this2.props.onKeyDown;

		// Expand country `<select/>`` on "Down arrow" key press

		if (event.keyCode === 40) {
			_this2.select.toggle();
		}

		if (onKeyDown) {
			onKeyDown(event);
		}
	};

	this.on_change = function (value) {
		var country_code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this2.state.country_code;
		var changed_country = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
		var _props5 = _this2.props,
		    metadata = _props5.metadata,
		    onChange = _props5.onChange;

		// If the `<input/>` is empty then just exit

		if (!value) {
			return _this2.setState({
				// State `value` is the parsed input value
				// (e.g. `+78005553535`, `1234567`).
				// This is not `this.props.value`
				// i.e. it's not neccessarily an international plaintext phone number,
				// it's just the `value` parsed by `input-format`.
				value: value,
				// `this.state.value_property` is the `this.props.value`
				// which corresponding to `this.state.value`.
				// It is being compared in `componentWillReceiveProps()`
				// against `newProps.value` to find out if the new `value` property
				// needs `this.state.value` recalculation.
				value_property: value
			},
			// Write the new `this.props.value`.
			function () {
				return onChange(value);
			});
		}

		// For international phone numbers
		if (value[0] === '+') {
			// If an international phone number is being erased up to the first `+` sign
			// or if an international phone number is just starting (with a `+` sign)
			// then unset the current country because it's clear that a user intends to change it.
			if (value.length === 1) {
				// If "International" country option has not been disabled
				// then reset the currently selected country.
				if (!changed_country && should_add_international_option(_this2.props)) {
					country_code = undefined;
					_this2.set_country_code_value(country_code);
				}
			} else {
				// If a phone number is being input as an international one
				// and the country code can already be derived,
				// then switch the country.
				// (`001` is a special "non-geograpical entity" code in `libphonenumber` library)
				if (!changed_country && _this2.formatter.country && _this2.formatter.country !== '001' && _this2.is_selectable_country(_this2.formatter.country)) {
					country_code = _this2.formatter.country;
					_this2.set_country_code_value(country_code);
				}
				// If "International" country option has not been disabled
				// and the international phone number entered doesn't correspond
				// to the currently selected country then reset the currently selected country.
				else if (!changed_country && should_add_international_option(_this2.props) && country_code && value.indexOf(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_libphonenumber_js__["d" /* getPhoneCode */])(country_code) !== '+'.length)) {
						country_code = undefined;
						_this2.set_country_code_value(country_code);
					}
			}
		}
		// If "International" mode is selected
		// and the `value` doesn't start with a + sign,
		// then prepend it to the `value`.
		else if (!country_code) {
				value = '+' + value;
			}

		// `this.state.value_property` is the `this.props.value`
		// which corresponding to `this.state.value`.
		// It is being compared in `componentWillReceiveProps()`
		// against `newProps.value` to find out if the new `value` property
		// needs `this.state.value` recalculation.
		var value_property = void 0;

		// `value` equal to `+` makes no sense
		if (value === '+') {
			value_property = undefined;
		}
		// If a phone number is in international format then check
		// that the phone number entered belongs to the selected country.
		else if (country_code && value[0] === '+' && !(value.indexOf('+' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_libphonenumber_js__["d" /* getPhoneCode */])(country_code)) === 0 && value.length > ('+' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_libphonenumber_js__["d" /* getPhoneCode */])(country_code)).length)) {
				value_property = undefined;
			}
			// Should be a most-probably-valid phone number
			else {
					// Convert `value` to E.164 phone number format
					value_property = e164(value, country_code, metadata);
				}

		_this2.setState({
			// State `value` is the parsed input value
			// (e.g. `+78005553535`, `1234567`).
			// This is not `this.props.value`
			// i.e. it's not neccessarily an international plaintext phone number,
			// it's just the `value` parsed by `input-format`.
			value: value,
			// `this.state.value_property` is the `this.props.value`
			// which corresponding to `this.state.value`.
			// It is being compared in `componentWillReceiveProps()`
			// against `newProps.value` to find out if the new `value` property
			// needs `this.state.value` recalculation.
			value_property: value_property
		},
		// Write the new `this.props.value`.
		function () {
			return onChange(value_property);
		});
	};

	this.on_blur = function (event) {
		var onBlur = _this2.props.onBlur;
		var value_property = _this2.state.value_property;


		if (!onBlur) {
			return;
		}

		var _event = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, event, {
			target: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, event.target, {
				value: value_property
			})

			// For `redux-form` event detection.
			// https://github.com/erikras/redux-form/blob/v5/src/events/isEvent.js
		});_event.stopPropagation = event.stopPropagation;
		_event.preventDefault = event.preventDefault;

		return onBlur(_event);
	};

	this.country_select_toggled = function (is_shown) {
		_this2.setState({ country_select_is_shown: is_shown });
	};

	this.on_country_select_tab_out = function (event) {
		event.preventDefault();

		// Focus the phone number input upon country selection
		// (do it in a timeout because the `<input/>`
		//  is hidden while selecting a country)
		setTimeout(_this2.focus, 0);
	};

	this.store_select_instance = function (instance) {
		_this2.select = instance;
	};

	this.store_input_instance = function (instance) {
		_this2.input = instance;
	};
};

/* harmony default export */ __webpack_exports__["a"] = (Input);
function parse_partial_number(value, country_code, metadata) {
	// "As you type" formatter
	var formatter = new __WEBPACK_IMPORTED_MODULE_13_libphonenumber_js__["f" /* as_you_type */](country_code, metadata);

	// Input partially entered phone number
	formatter.input(value);

	// Return the parsed partial phone number
	// (has `.national_number`, `.country`, etc)
	return formatter;
}

// Converts `value` to E.164 phone number format
function e164(value, country_code, metadata) {
	if (!value) {
		return undefined;
	}

	// If the phone number is being input in an international format
	if (value[0] === '+') {
		// If it's just the `+` sign
		if (value.length === 1) {
			return undefined;
		}

		// If there are some digits, the `value` is returned as is
		return value;
	}

	// For non-international phone number a country code is required
	if (!country_code) {
		return undefined;
	}

	// The phone number is being input in a country-specific format

	var partial_national_number = parse_partial_number(value, country_code).national_number;

	if (!partial_national_number) {
		return undefined;
	}

	// The value is converted to international plaintext
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_libphonenumber_js__["b" /* format */])(partial_national_number, country_code, 'International_plaintext', metadata);
}

// Gets country flag element by country code
function get_country_option_icon(countryCode, _ref2) {
	var flags = _ref2.flags,
	    flagsPath = _ref2.flagsPath,
	    flagComponent = _ref2.flagComponent;

	if (flags === false) {
		return undefined;
	}

	if (flags && flags[countryCode]) {
		return flags[countryCode];
	}

	return __WEBPACK_IMPORTED_MODULE_10_react__["default"].createElement(flagComponent, { countryCode: countryCode, flagsPath: flagsPath });
}

// Whether to add the "International" option to the list of countries
function should_add_international_option(properties) {
	var countries = properties.countries,
	    international = properties.international;

	// If this behaviour is explicitly set, then do as it says.

	if (international !== undefined) {
		return international;
	}

	// If `countries` is empty,
	// then only "International" option is available, so add it.
	if (countries.length === 0) {
		return true;
	}

	// If `countries` is a single allowed country,
	// then don't add the "International" option
	// because it would make no sense.
	if (countries.length === 1) {
		return false;
	}

	// Show the "International" option by default
	return true;
}

// Is it possible that the partially entered  phone number belongs to the given country
function could_phone_number_belong_to_country(phone_number, country_code, metadata) {
	// Strip the leading `+`
	var phone_number_digits = phone_number.slice('+'.length);

	var _iteratorNormalCompletion4 = true;
	var _didIteratorError4 = false;
	var _iteratorError4 = undefined;

	try {
		for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(metadata.country_phone_code_to_countries)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
			var country_phone_code = _step4.value;

			var possible_country_phone_code = phone_number_digits.substring(0, country_phone_code.length);
			if (country_phone_code.indexOf(possible_country_phone_code) === 0) {
				// This country phone code is possible.
				// Does the given country correspond to this country phone code.
				if (metadata.country_phone_code_to_countries[country_phone_code].indexOf(country_code) >= 0) {
					return true;
				}
			}
		}
	} catch (err) {
		_didIteratorError4 = true;
		_iteratorError4 = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion4 && _iterator4.return) {
				_iterator4.return();
			}
		} finally {
			if (_didIteratorError4) {
				throw _iteratorError4;
			}
		}
	}
}

// If a formatted phone number is an international one
// then it strips the `+${country_phone_code}` prefix from the formatted number.
function strip_country_phone_code(formatted_number, metadata) {
	if (!formatted_number || formatted_number[0] !== '+' || formatted_number === '+') {
		return formatted_number;
	}

	var _iteratorNormalCompletion5 = true;
	var _didIteratorError5 = false;
	var _iteratorError5 = undefined;

	try {
		for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(metadata.country_phone_code_to_countries)), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
			var country_phone_code = _step5.value;

			if (formatted_number.indexOf(country_phone_code) === '+'.length) {
				return formatted_number.slice('+'.length + country_phone_code.length).trim();
			}
		}
	} catch (err) {
		_didIteratorError5 = true;
		_iteratorError5 = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion5 && _iterator5.return) {
				_iterator5.return();
			}
		} finally {
			if (_didIteratorError5) {
				throw _iteratorError5;
			}
		}
	}

	return formatted_number;
}

// Validates country code
function normalize_country_code(country, dictionary) {
	// Normalize `country` if it's an empty string
	if (country === '') {
		country = undefined;
	}

	// No country is selected ("International")
	if (country === undefined || country === null) {
		return country;
	}

	// Check that `country` code exists
	if (dictionary[country] || default_dictionary[country]) {
		return country;
	}

	throw new Error('Unknown country: "' + country + '"');
}
//# sourceMappingURL=Input.js.map

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(5);

exports["default"] = _react.PropTypes.shape({
  subscribe: _react.PropTypes.func.isRequired,
  dispatch: _react.PropTypes.func.isRequired,
  getState: _react.PropTypes.func.isRequired
});

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  } else {
    var _ret = function () {
      var last = funcs[funcs.length - 1];
      var rest = funcs.slice(0, -1);
      return {
        v: function v() {
          return rest.reduceRight(function (composed, f) {
            return f(composed);
          }, last.apply(undefined, arguments));
        }
      };
    }();

    if (typeof _ret === "object") return _ret.v;
  }
}

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ActionTypes = undefined;
exports["default"] = createStore;

var _isPlainObject = __webpack_require__(102);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _symbolObservable = __webpack_require__(467);

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = exports.ActionTypes = {
  INIT: '@@redux/INIT'
};

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [initialState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} enhancer The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */
function createStore(reducer, initialState, enhancer) {
  var _ref2;

  if (typeof initialState === 'function' && typeof enhancer === 'undefined') {
    enhancer = initialState;
    initialState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, initialState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = initialState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!(0, _isPlainObject2["default"])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i]();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/zenparsing/es-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */

      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[_symbolObservable2["default"]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[_symbolObservable2["default"]] = observable, _ref2;
}

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var url = __webpack_require__(433);
var parser = __webpack_require__(103);
var Manager = __webpack_require__(167);
var debug = __webpack_require__(22)('socket.io-client');

/**
 * Module exports.
 */

module.exports = exports = lookup;

/**
 * Managers cache.
 */

var cache = exports.managers = {};

/**
 * Looks up an existing `Manager` for multiplexing.
 * If the user summons:
 *
 *   `io('http://localhost/a');`
 *   `io('http://localhost/b');`
 *
 * We reuse the existing instance based on same scheme/port/host,
 * and we initialize sockets for each namespace.
 *
 * @api public
 */

function lookup (uri, opts) {
  if (typeof uri === 'object') {
    opts = uri;
    uri = undefined;
  }

  opts = opts || {};

  var parsed = url(uri);
  var source = parsed.source;
  var id = parsed.id;
  var path = parsed.path;
  var sameNamespace = cache[id] && path in cache[id].nsps;
  var newConnection = opts.forceNew || opts['force new connection'] ||
                      false === opts.multiplex || sameNamespace;

  var io;

  if (newConnection) {
    debug('ignoring socket cache for %s', source);
    io = Manager(source, opts);
  } else {
    if (!cache[id]) {
      debug('new io instance for %s', source);
      cache[id] = Manager(source, opts);
    }
    io = cache[id];
  }
  if (parsed.query && !opts.query) {
    opts.query = parsed.query;
  }
  return io.socket(parsed.path, opts);
}

/**
 * Protocol version.
 *
 * @api public
 */

exports.protocol = parser.protocol;

/**
 * `connect`.
 *
 * @param {String} uri
 * @api public
 */

exports.connect = lookup;

/**
 * Expose constructors for standalone build.
 *
 * @api public
 */

exports.Manager = __webpack_require__(167);
exports.Socket = __webpack_require__(169);


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var eio = __webpack_require__(341);
var Socket = __webpack_require__(169);
var Emitter = __webpack_require__(34);
var parser = __webpack_require__(103);
var on = __webpack_require__(168);
var bind = __webpack_require__(119);
var debug = __webpack_require__(22)('socket.io-client:manager');
var indexOf = __webpack_require__(144);
var Backoff = __webpack_require__(237);

/**
 * IE6+ hasOwnProperty
 */

var has = Object.prototype.hasOwnProperty;

/**
 * Module exports
 */

module.exports = Manager;

/**
 * `Manager` constructor.
 *
 * @param {String} engine instance or engine uri/opts
 * @param {Object} options
 * @api public
 */

function Manager (uri, opts) {
  if (!(this instanceof Manager)) return new Manager(uri, opts);
  if (uri && ('object' === typeof uri)) {
    opts = uri;
    uri = undefined;
  }
  opts = opts || {};

  opts.path = opts.path || '/socket.io';
  this.nsps = {};
  this.subs = [];
  this.opts = opts;
  this.reconnection(opts.reconnection !== false);
  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
  this.reconnectionDelay(opts.reconnectionDelay || 1000);
  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
  this.randomizationFactor(opts.randomizationFactor || 0.5);
  this.backoff = new Backoff({
    min: this.reconnectionDelay(),
    max: this.reconnectionDelayMax(),
    jitter: this.randomizationFactor()
  });
  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
  this.readyState = 'closed';
  this.uri = uri;
  this.connecting = [];
  this.lastPing = null;
  this.encoding = false;
  this.packetBuffer = [];
  var _parser = opts.parser || parser;
  this.encoder = new _parser.Encoder();
  this.decoder = new _parser.Decoder();
  this.autoConnect = opts.autoConnect !== false;
  if (this.autoConnect) this.open();
}

/**
 * Propagate given event to sockets and emit on `this`
 *
 * @api private
 */

Manager.prototype.emitAll = function () {
  this.emit.apply(this, arguments);
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
    }
  }
};

/**
 * Update `socket.id` of all sockets
 *
 * @api private
 */

Manager.prototype.updateSocketIds = function () {
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].id = this.generateId(nsp);
    }
  }
};

/**
 * generate `socket.id` for the given `nsp`
 *
 * @param {String} nsp
 * @return {String}
 * @api private
 */

Manager.prototype.generateId = function (nsp) {
  return (nsp === '/' ? '' : (nsp + '#')) + this.engine.id;
};

/**
 * Mix in `Emitter`.
 */

Emitter(Manager.prototype);

/**
 * Sets the `reconnection` config.
 *
 * @param {Boolean} true/false if it should automatically reconnect
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnection = function (v) {
  if (!arguments.length) return this._reconnection;
  this._reconnection = !!v;
  return this;
};

/**
 * Sets the reconnection attempts config.
 *
 * @param {Number} max reconnection attempts before giving up
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionAttempts = function (v) {
  if (!arguments.length) return this._reconnectionAttempts;
  this._reconnectionAttempts = v;
  return this;
};

/**
 * Sets the delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionDelay = function (v) {
  if (!arguments.length) return this._reconnectionDelay;
  this._reconnectionDelay = v;
  this.backoff && this.backoff.setMin(v);
  return this;
};

Manager.prototype.randomizationFactor = function (v) {
  if (!arguments.length) return this._randomizationFactor;
  this._randomizationFactor = v;
  this.backoff && this.backoff.setJitter(v);
  return this;
};

/**
 * Sets the maximum delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionDelayMax = function (v) {
  if (!arguments.length) return this._reconnectionDelayMax;
  this._reconnectionDelayMax = v;
  this.backoff && this.backoff.setMax(v);
  return this;
};

/**
 * Sets the connection timeout. `false` to disable
 *
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.timeout = function (v) {
  if (!arguments.length) return this._timeout;
  this._timeout = v;
  return this;
};

/**
 * Starts trying to reconnect if reconnection is enabled and we have not
 * started reconnecting yet
 *
 * @api private
 */

Manager.prototype.maybeReconnectOnOpen = function () {
  // Only try to reconnect if it's the first time we're connecting
  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
    // keeps reconnection from firing twice for the same reconnection loop
    this.reconnect();
  }
};

/**
 * Sets the current transport `socket`.
 *
 * @param {Function} optional, callback
 * @return {Manager} self
 * @api public
 */

Manager.prototype.open =
Manager.prototype.connect = function (fn, opts) {
  debug('readyState %s', this.readyState);
  if (~this.readyState.indexOf('open')) return this;

  debug('opening %s', this.uri);
  this.engine = eio(this.uri, this.opts);
  var socket = this.engine;
  var self = this;
  this.readyState = 'opening';
  this.skipReconnect = false;

  // emit `open`
  var openSub = on(socket, 'open', function () {
    self.onopen();
    fn && fn();
  });

  // emit `connect_error`
  var errorSub = on(socket, 'error', function (data) {
    debug('connect_error');
    self.cleanup();
    self.readyState = 'closed';
    self.emitAll('connect_error', data);
    if (fn) {
      var err = new Error('Connection error');
      err.data = data;
      fn(err);
    } else {
      // Only do this if there is no fn to handle the error
      self.maybeReconnectOnOpen();
    }
  });

  // emit `connect_timeout`
  if (false !== this._timeout) {
    var timeout = this._timeout;
    debug('connect attempt will timeout after %d', timeout);

    // set timer
    var timer = setTimeout(function () {
      debug('connect attempt timed out after %d', timeout);
      openSub.destroy();
      socket.close();
      socket.emit('error', 'timeout');
      self.emitAll('connect_timeout', timeout);
    }, timeout);

    this.subs.push({
      destroy: function () {
        clearTimeout(timer);
      }
    });
  }

  this.subs.push(openSub);
  this.subs.push(errorSub);

  return this;
};

/**
 * Called upon transport open.
 *
 * @api private
 */

Manager.prototype.onopen = function () {
  debug('open');

  // clear old subs
  this.cleanup();

  // mark as open
  this.readyState = 'open';
  this.emit('open');

  // add new subs
  var socket = this.engine;
  this.subs.push(on(socket, 'data', bind(this, 'ondata')));
  this.subs.push(on(socket, 'ping', bind(this, 'onping')));
  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
  this.subs.push(on(socket, 'error', bind(this, 'onerror')));
  this.subs.push(on(socket, 'close', bind(this, 'onclose')));
  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
};

/**
 * Called upon a ping.
 *
 * @api private
 */

Manager.prototype.onping = function () {
  this.lastPing = new Date();
  this.emitAll('ping');
};

/**
 * Called upon a packet.
 *
 * @api private
 */

Manager.prototype.onpong = function () {
  this.emitAll('pong', new Date() - this.lastPing);
};

/**
 * Called with data.
 *
 * @api private
 */

Manager.prototype.ondata = function (data) {
  this.decoder.add(data);
};

/**
 * Called when parser fully decodes a packet.
 *
 * @api private
 */

Manager.prototype.ondecoded = function (packet) {
  this.emit('packet', packet);
};

/**
 * Called upon socket error.
 *
 * @api private
 */

Manager.prototype.onerror = function (err) {
  debug('error', err);
  this.emitAll('error', err);
};

/**
 * Creates a new socket for the given `nsp`.
 *
 * @return {Socket}
 * @api public
 */

Manager.prototype.socket = function (nsp, opts) {
  var socket = this.nsps[nsp];
  if (!socket) {
    socket = new Socket(this, nsp, opts);
    this.nsps[nsp] = socket;
    var self = this;
    socket.on('connecting', onConnecting);
    socket.on('connect', function () {
      socket.id = self.generateId(nsp);
    });

    if (this.autoConnect) {
      // manually call here since connecting event is fired before listening
      onConnecting();
    }
  }

  function onConnecting () {
    if (!~indexOf(self.connecting, socket)) {
      self.connecting.push(socket);
    }
  }

  return socket;
};

/**
 * Called upon a socket close.
 *
 * @param {Socket} socket
 */

Manager.prototype.destroy = function (socket) {
  var index = indexOf(this.connecting, socket);
  if (~index) this.connecting.splice(index, 1);
  if (this.connecting.length) return;

  this.close();
};

/**
 * Writes a packet.
 *
 * @param {Object} packet
 * @api private
 */

Manager.prototype.packet = function (packet) {
  debug('writing packet %j', packet);
  var self = this;
  if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;

  if (!self.encoding) {
    // encode, then write to engine with result
    self.encoding = true;
    this.encoder.encode(packet, function (encodedPackets) {
      for (var i = 0; i < encodedPackets.length; i++) {
        self.engine.write(encodedPackets[i], packet.options);
      }
      self.encoding = false;
      self.processPacketQueue();
    });
  } else { // add packet to the queue
    self.packetBuffer.push(packet);
  }
};

/**
 * If packet buffer is non-empty, begins encoding the
 * next packet in line.
 *
 * @api private
 */

Manager.prototype.processPacketQueue = function () {
  if (this.packetBuffer.length > 0 && !this.encoding) {
    var pack = this.packetBuffer.shift();
    this.packet(pack);
  }
};

/**
 * Clean up transport subscriptions and packet buffer.
 *
 * @api private
 */

Manager.prototype.cleanup = function () {
  debug('cleanup');

  var subsLength = this.subs.length;
  for (var i = 0; i < subsLength; i++) {
    var sub = this.subs.shift();
    sub.destroy();
  }

  this.packetBuffer = [];
  this.encoding = false;
  this.lastPing = null;

  this.decoder.destroy();
};

/**
 * Close the current socket.
 *
 * @api private
 */

Manager.prototype.close =
Manager.prototype.disconnect = function () {
  debug('disconnect');
  this.skipReconnect = true;
  this.reconnecting = false;
  if ('opening' === this.readyState) {
    // `onclose` will not fire because
    // an open event never happened
    this.cleanup();
  }
  this.backoff.reset();
  this.readyState = 'closed';
  if (this.engine) this.engine.close();
};

/**
 * Called upon engine close.
 *
 * @api private
 */

Manager.prototype.onclose = function (reason) {
  debug('onclose');

  this.cleanup();
  this.backoff.reset();
  this.readyState = 'closed';
  this.emit('close', reason);

  if (this._reconnection && !this.skipReconnect) {
    this.reconnect();
  }
};

/**
 * Attempt a reconnection.
 *
 * @api private
 */

Manager.prototype.reconnect = function () {
  if (this.reconnecting || this.skipReconnect) return this;

  var self = this;

  if (this.backoff.attempts >= this._reconnectionAttempts) {
    debug('reconnect failed');
    this.backoff.reset();
    this.emitAll('reconnect_failed');
    this.reconnecting = false;
  } else {
    var delay = this.backoff.duration();
    debug('will wait %dms before reconnect attempt', delay);

    this.reconnecting = true;
    var timer = setTimeout(function () {
      if (self.skipReconnect) return;

      debug('attempting reconnect');
      self.emitAll('reconnect_attempt', self.backoff.attempts);
      self.emitAll('reconnecting', self.backoff.attempts);

      // check again for the case socket closed in above events
      if (self.skipReconnect) return;

      self.open(function (err) {
        if (err) {
          debug('reconnect attempt error');
          self.reconnecting = false;
          self.reconnect();
          self.emitAll('reconnect_error', err.data);
        } else {
          debug('reconnect success');
          self.onreconnect();
        }
      });
    }, delay);

    this.subs.push({
      destroy: function () {
        clearTimeout(timer);
      }
    });
  }
};

/**
 * Called upon successful reconnect.
 *
 * @api private
 */

Manager.prototype.onreconnect = function () {
  var attempt = this.backoff.attempts;
  this.reconnecting = false;
  this.backoff.reset();
  this.updateSocketIds();
  this.emitAll('reconnect', attempt);
};


/***/ }),
/* 168 */
/***/ (function(module, exports) {


/**
 * Module exports.
 */

module.exports = on;

/**
 * Helper for subscriptions.
 *
 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
 * @param {String} event name
 * @param {Function} callback
 * @api public
 */

function on (obj, ev, fn) {
  obj.on(ev, fn);
  return {
    destroy: function () {
      obj.removeListener(ev, fn);
    }
  };
}


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var parser = __webpack_require__(103);
var Emitter = __webpack_require__(34);
var toArray = __webpack_require__(470);
var on = __webpack_require__(168);
var bind = __webpack_require__(119);
var debug = __webpack_require__(22)('socket.io-client:socket');
var parseqs = __webpack_require__(68);

/**
 * Module exports.
 */

module.exports = exports = Socket;

/**
 * Internal events (blacklisted).
 * These events can't be emitted by the user.
 *
 * @api private
 */

var events = {
  connect: 1,
  connect_error: 1,
  connect_timeout: 1,
  connecting: 1,
  disconnect: 1,
  error: 1,
  reconnect: 1,
  reconnect_attempt: 1,
  reconnect_failed: 1,
  reconnect_error: 1,
  reconnecting: 1,
  ping: 1,
  pong: 1
};

/**
 * Shortcut to `Emitter#emit`.
 */

var emit = Emitter.prototype.emit;

/**
 * `Socket` constructor.
 *
 * @api public
 */

function Socket (io, nsp, opts) {
  this.io = io;
  this.nsp = nsp;
  this.json = this; // compat
  this.ids = 0;
  this.acks = {};
  this.receiveBuffer = [];
  this.sendBuffer = [];
  this.connected = false;
  this.disconnected = true;
  if (opts && opts.query) {
    this.query = opts.query;
  }
  if (this.io.autoConnect) this.open();
}

/**
 * Mix in `Emitter`.
 */

Emitter(Socket.prototype);

/**
 * Subscribe to open, close and packet events
 *
 * @api private
 */

Socket.prototype.subEvents = function () {
  if (this.subs) return;

  var io = this.io;
  this.subs = [
    on(io, 'open', bind(this, 'onopen')),
    on(io, 'packet', bind(this, 'onpacket')),
    on(io, 'close', bind(this, 'onclose'))
  ];
};

/**
 * "Opens" the socket.
 *
 * @api public
 */

Socket.prototype.open =
Socket.prototype.connect = function () {
  if (this.connected) return this;

  this.subEvents();
  this.io.open(); // ensure open
  if ('open' === this.io.readyState) this.onopen();
  this.emit('connecting');
  return this;
};

/**
 * Sends a `message` event.
 *
 * @return {Socket} self
 * @api public
 */

Socket.prototype.send = function () {
  var args = toArray(arguments);
  args.unshift('message');
  this.emit.apply(this, args);
  return this;
};

/**
 * Override `emit`.
 * If the event is in `events`, it's emitted normally.
 *
 * @param {String} event name
 * @return {Socket} self
 * @api public
 */

Socket.prototype.emit = function (ev) {
  if (events.hasOwnProperty(ev)) {
    emit.apply(this, arguments);
    return this;
  }

  var args = toArray(arguments);
  var packet = { type: parser.EVENT, data: args };

  packet.options = {};
  packet.options.compress = !this.flags || false !== this.flags.compress;

  // event ack callback
  if ('function' === typeof args[args.length - 1]) {
    debug('emitting packet with ack id %d', this.ids);
    this.acks[this.ids] = args.pop();
    packet.id = this.ids++;
  }

  if (this.connected) {
    this.packet(packet);
  } else {
    this.sendBuffer.push(packet);
  }

  delete this.flags;

  return this;
};

/**
 * Sends a packet.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.packet = function (packet) {
  packet.nsp = this.nsp;
  this.io.packet(packet);
};

/**
 * Called upon engine `open`.
 *
 * @api private
 */

Socket.prototype.onopen = function () {
  debug('transport is open - connecting');

  // write connect packet if necessary
  if ('/' !== this.nsp) {
    if (this.query) {
      var query = typeof this.query === 'object' ? parseqs.encode(this.query) : this.query;
      debug('sending connect packet with query %s', query);
      this.packet({type: parser.CONNECT, query: query});
    } else {
      this.packet({type: parser.CONNECT});
    }
  }
};

/**
 * Called upon engine `close`.
 *
 * @param {String} reason
 * @api private
 */

Socket.prototype.onclose = function (reason) {
  debug('close (%s)', reason);
  this.connected = false;
  this.disconnected = true;
  delete this.id;
  this.emit('disconnect', reason);
};

/**
 * Called with socket packet.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onpacket = function (packet) {
  if (packet.nsp !== this.nsp) return;

  switch (packet.type) {
    case parser.CONNECT:
      this.onconnect();
      break;

    case parser.EVENT:
      this.onevent(packet);
      break;

    case parser.BINARY_EVENT:
      this.onevent(packet);
      break;

    case parser.ACK:
      this.onack(packet);
      break;

    case parser.BINARY_ACK:
      this.onack(packet);
      break;

    case parser.DISCONNECT:
      this.ondisconnect();
      break;

    case parser.ERROR:
      this.emit('error', packet.data);
      break;
  }
};

/**
 * Called upon a server event.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onevent = function (packet) {
  var args = packet.data || [];
  debug('emitting event %j', args);

  if (null != packet.id) {
    debug('attaching ack callback to event');
    args.push(this.ack(packet.id));
  }

  if (this.connected) {
    emit.apply(this, args);
  } else {
    this.receiveBuffer.push(args);
  }
};

/**
 * Produces an ack callback to emit with an event.
 *
 * @api private
 */

Socket.prototype.ack = function (id) {
  var self = this;
  var sent = false;
  return function () {
    // prevent double callbacks
    if (sent) return;
    sent = true;
    var args = toArray(arguments);
    debug('sending ack %j', args);

    self.packet({
      type: parser.ACK,
      id: id,
      data: args
    });
  };
};

/**
 * Called upon a server acknowlegement.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onack = function (packet) {
  var ack = this.acks[packet.id];
  if ('function' === typeof ack) {
    debug('calling ack %s with %j', packet.id, packet.data);
    ack.apply(this, packet.data);
    delete this.acks[packet.id];
  } else {
    debug('bad ack %s', packet.id);
  }
};

/**
 * Called upon server connect.
 *
 * @api private
 */

Socket.prototype.onconnect = function () {
  this.connected = true;
  this.disconnected = false;
  this.emit('connect');
  this.emitBuffered();
};

/**
 * Emit buffered events (received and emitted).
 *
 * @api private
 */

Socket.prototype.emitBuffered = function () {
  var i;
  for (i = 0; i < this.receiveBuffer.length; i++) {
    emit.apply(this, this.receiveBuffer[i]);
  }
  this.receiveBuffer = [];

  for (i = 0; i < this.sendBuffer.length; i++) {
    this.packet(this.sendBuffer[i]);
  }
  this.sendBuffer = [];
};

/**
 * Called upon server disconnect.
 *
 * @api private
 */

Socket.prototype.ondisconnect = function () {
  debug('server disconnect (%s)', this.nsp);
  this.destroy();
  this.onclose('io server disconnect');
};

/**
 * Called upon forced client/server side disconnections,
 * this method ensures the manager stops tracking us and
 * that reconnections don't get triggered for this.
 *
 * @api private.
 */

Socket.prototype.destroy = function () {
  if (this.subs) {
    // clean subscriptions to avoid reconnections
    for (var i = 0; i < this.subs.length; i++) {
      this.subs[i].destroy();
    }
    this.subs = null;
  }

  this.io.destroy(this);
};

/**
 * Disconnects the socket manually.
 *
 * @return {Socket} self
 * @api public
 */

Socket.prototype.close =
Socket.prototype.disconnect = function () {
  if (this.connected) {
    debug('performing disconnect (%s)', this.nsp);
    this.packet({ type: parser.DISCONNECT });
  }

  // remove socket from pool
  this.destroy();

  if (this.connected) {
    // fire events
    this.onclose('io client disconnect');
  }
  return this;
};

/**
 * Sets the compress flag.
 *
 * @param {Boolean} if `true`, compresses the sending data
 * @return {Socket} self
 * @api public
 */

Socket.prototype.compress = function (compress) {
  this.flags = this.flags || {};
  this.flags.compress = compress;
  return this;
};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
module.exports = isBuf;

/**
 * Returns true if obj is a buffer or an arraybuffer.
 *
 * @api private
 */

function isBuf(obj) {
  return (global.Buffer && global.Buffer.isBuffer(obj)) ||
         (global.ArrayBuffer && obj instanceof ArrayBuffer);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(100);
var ES = __webpack_require__(349);
var replace = bind.call(Function.call, String.prototype.replace);

var leftWhitespace = /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/;
var rightWhitespace = /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/;

module.exports = function trim() {
	var S = ES.ToString(ES.CheckObjectCoercible(this));
	return replace(replace(S, leftWhitespace, ''), rightWhitespace, '');
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(171);

var zeroWidthSpace = '\u200b';

module.exports = function getPolyfill() {
	if (String.prototype.trim && zeroWidthSpace.trim() === zeroWidthSpace) {
		return String.prototype.trim;
	}
	return implementation;
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(311);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(334);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(319);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(321);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
  , length = 64
  , map = {}
  , seed = 0
  , i = 0
  , prev;

/**
 * Return a string representing the specified number.
 *
 * @param {Number} num The number to convert.
 * @returns {String} The string representation of the number.
 * @api public
 */
function encode(num) {
  var encoded = '';

  do {
    encoded = alphabet[num % length] + encoded;
    num = Math.floor(num / length);
  } while (num > 0);

  return encoded;
}

/**
 * Return the integer value specified by the given string.
 *
 * @param {String} str The string to convert.
 * @returns {Number} The integer value represented by the string.
 * @api public
 */
function decode(str) {
  var decoded = 0;

  for (i = 0; i < str.length; i++) {
    decoded = decoded * length + map[str.charAt(i)];
  }

  return decoded;
}

/**
 * Yeast: A tiny growing id generator.
 *
 * @returns {String} A unique id.
 * @api public
 */
function yeast() {
  var now = encode(+new Date());

  if (now !== prev) return seed = 0, prev = now;
  return now +'.'+ encode(seed++);
}

//
// Map each character to its index.
//
for (; i < length; i++) map[alphabet[i]] = i;

//
// Expose the `yeast`, `encode` and `decode` functions.
//
yeast.encode = encode;
yeast.decode = decode;
module.exports = yeast;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(3), __webpack_require__(7), __webpack_require__(6), __webpack_require__(4), __webpack_require__(445), __webpack_require__(413), __webpack_require__(0), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/object/define-property'), require('babel-runtime/core-js/object/set-prototype-of'), require('babel-runtime/core-js/object/create'), require('babel-runtime/core-js/object/get-prototype-of'), require('./style.css'), require('react-modal'), require('preact'), require('../utils'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.defineProperty, global.setPrototypeOf, global.create, global.getPrototypeOf, global.style, global.reactModal, global.preact, global.utils);
    global.index = mod.exports;
  }
})(this, function (module, exports, _defineProperty, _setPrototypeOf, _create, _getPrototypeOf, _style, _reactModal, _preact, _utils) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _defineProperty2 = _interopRequireDefault(_defineProperty);

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create2 = _interopRequireDefault(_create);

  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

  var _style2 = _interopRequireDefault(_style);

  var _reactModal2 = _interopRequireDefault(_reactModal);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty2.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var MODAL_ANIMATION_DURATION = (0, _utils.getCSSMilisecsValue)(_style2.default.modal_animation_duration);

  var Wrapper = function Wrapper(_ref) {
    var children = _ref.children;
    return (0, _utils.wrapWithClass)(_style2.default.inner, children);
  };

  var ModalStrict = function (_Component) {
    _inherits(ModalStrict, _Component);

    function ModalStrict(props) {
      _classCallCheck(this, ModalStrict);

      var _this = _possibleConstructorReturn(this, (ModalStrict.__proto__ || (0, _getPrototypeOf2.default)(ModalStrict)).call(this, props));

      _this.openModal = function () {
        _this.setState({ isOpen: true });
      };

      _this.onRequestClose = function () {
        _this.setState({ isOpen: false });
      };

      _this.state = { isOpen: false };
      return _this;
    }

    _createClass(ModalStrict, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var buttonId = this.props.buttonId;

        console.log(buttonId);
        var button = document.getElementById(buttonId);
        if (!button) {
          console.warn('The button with id #' + buttonId + ' cannot be found');
          return;
        }
        button.addEventListener('click', this.openModal);
        button.disabled = false;
        this.setState({ button: button });
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var button = this.state.button;

        if (button) button.removeEventListener('click', this.openModal);
      }
    }, {
      key: 'render',
      value: function render() {
        return (0, _preact.h)(
          _reactModal2.default,
          {
            isOpen: this.state.isOpen || this.props.isOpen,
            onRequestClose: this.props.onRequestClose || this.onRequestClose,
            portalClassName: _style2.default.portal,
            overlayClassName: _style2.default.overlay,
            bodyClassName: _style2.default.modalBody,
            className: _style2.default.inner,
            shouldCloseOnOverlayClick: true,
            closeTimeoutMS: MODAL_ANIMATION_DURATION
          },
          this.props.children
        );
      }
    }]);

    return ModalStrict;
  }(_preact.Component);

  var ModalPure = function ModalPure(_ref2) {
    var useModal = _ref2.useModal,
        children = _ref2.children,
        otherProps = _objectWithoutProperties(_ref2, ['useModal', 'children']);

    return useModal ? (0, _preact.h)(
      ModalStrict,
      otherProps,
      children
    ) : (0, _preact.h)(
      Wrapper,
      null,
      children
    );
  };

  var Modal = function (_Component2) {
    _inherits(Modal, _Component2);

    function Modal() {
      var _ref3;

      var _temp, _this2, _ret;

      _classCallCheck(this, Modal);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref3 = Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).call.apply(_ref3, [this].concat(args))), _this2), _this2.render = function () {
        return (0, _preact.h)(ModalPure, _this2.props);
      }, _temp), _possibleConstructorReturn(_this2, _ret);
    }

    return Modal;
  }(_preact.Component);

  exports.default = Modal;
  module.exports = exports['default'];
});

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(10), __webpack_require__(3), __webpack_require__(7), __webpack_require__(6), __webpack_require__(4), __webpack_require__(0), __webpack_require__(51), __webpack_require__(41), __webpack_require__(166), __webpack_require__(368), __webpack_require__(471), __webpack_require__(109), __webpack_require__(208), __webpack_require__(210), __webpack_require__(54), __webpack_require__(216), __webpack_require__(52), __webpack_require__(8), __webpack_require__(222), __webpack_require__(42), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/object/assign'), require('babel-runtime/core-js/object/define-property'), require('babel-runtime/core-js/object/set-prototype-of'), require('babel-runtime/core-js/object/create'), require('babel-runtime/core-js/object/get-prototype-of'), require('preact'), require('redux'), require('react-redux'), require('socket.io-client'), require('history/createBrowserHistory'), require('url-search-params'), require('./StepComponentMap'), require('./StepsRouter'), require('../Theme'), require('../Spinner'), require('../crossDevice/GenericError'), require('../../core'), require('../utils'), require('../utils/jwt'), require('../../locales'), require('../../Tracker'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.assign, global.defineProperty, global.setPrototypeOf, global.create, global.getPrototypeOf, global.preact, global.redux, global.reactRedux, global.socket, global.createBrowserHistory, global.urlSearchParams, global.StepComponentMap, global.StepsRouter, global.Theme, global.Spinner, global.GenericError, global.core, global.utils, global.jwt, global.locales, global.Tracker);
    global.index = mod.exports;
  }
})(this, function (module, exports, _assign, _defineProperty, _setPrototypeOf, _create, _getPrototypeOf, _preact, _redux, _reactRedux, _socket, _createBrowserHistory, _urlSearchParams, _StepComponentMap, _StepsRouter, _Theme, _Spinner, _GenericError, _core, _utils, _jwt, _locales, _Tracker) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _assign2 = _interopRequireDefault(_assign);

  var _defineProperty2 = _interopRequireDefault(_defineProperty);

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create2 = _interopRequireDefault(_create);

  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

  var _socket2 = _interopRequireDefault(_socket);

  var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

  var _urlSearchParams2 = _interopRequireDefault(_urlSearchParams);

  var _StepsRouter2 = _interopRequireDefault(_StepsRouter);

  var _Spinner2 = _interopRequireDefault(_Spinner);

  var _GenericError2 = _interopRequireDefault(_GenericError);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty2.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var _extends = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var history = (0, _createBrowserHistory2.default)();

  var Router = function Router(props) {
    var RouterComponent = props.options.mobileFlow ? CrossDeviceMobileRouter : MainRouter;
    return (0, _preact.h)(RouterComponent, _extends({}, props, { allowCrossDeviceFlow: !props.options.mobileFlow && _utils.isDesktop }));
  };

  // Wrap components with theme that include navigation and footer
  var WrappedSpinner = (0, _Theme.themeWrap)(_Spinner2.default);
  var WrappedError = (0, _Theme.themeWrap)(_GenericError2.default);

  var CrossDeviceMobileRouter = function (_Component) {
    _inherits(CrossDeviceMobileRouter, _Component);

    function CrossDeviceMobileRouter(props) {
      _classCallCheck(this, CrossDeviceMobileRouter);

      var _this = _possibleConstructorReturn(this, (CrossDeviceMobileRouter.__proto__ || (0, _getPrototypeOf2.default)(CrossDeviceMobileRouter)).call(this, props));

      _initialiseProps.call(_this);

      // Some environments put the link ID in the query string so they can serve
      // the cross device flow without running nginx
      var searchParams = new _urlSearchParams2.default(window.location.search);
      var roomId = window.location.pathname.substring(3) || searchParams.get('link_id').substring(2);
      _this.state = {
        token: null,
        steps: null,
        step: null,
        i18n: (0, _locales.initializeI18n)(),
        socket: (0, _socket2.default)("https://sync.onfido.com", { autoConnect: false }),
        roomId: roomId,
        crossDeviceError: false,
        loading: true
      };
      _this.state.socket.on('config', _this.setConfig(props.actions));
      _this.state.socket.on('connect', function () {
        _this.state.socket.emit('join', { roomId: _this.state.roomId });
      });
      _this.state.socket.open();
      _this.requestConfig();
      return _this;
    }

    _createClass(CrossDeviceMobileRouter, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.state.socket.on('custom disconnect', this.onDisconnect);
        this.state.socket.on('disconnect pong', this.onDisconnectPong);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.clearConfigTimeout();
        this.clearPingTimeout();
        this.state.socket.close();
      }
    }]);

    return CrossDeviceMobileRouter;
  }(_preact.Component);

  var _initialiseProps = function _initialiseProps() {
    var _this4 = this;

    this.configTimeoutId = null;
    this.pingTimeoutId = null;

    this.sendMessage = function (event, payload) {
      var roomId = _this4.state.roomId;
      _this4.state.socket.emit('message', { roomId: roomId, event: event, payload: payload });
    };

    this.requestConfig = function () {
      _this4.sendMessage('get config');
      _this4.clearConfigTimeout();
      _this4.configTimeoutId = setTimeout(function () {
        if (_this4.state.loading) _this4.setError();
      }, 10000);
    };

    this.clearConfigTimeout = function () {
      return _this4.configTimeoutId && clearTimeout(_this4.configTimeoutId);
    };

    this.clearPingTimeout = function () {
      if (_this4.pingTimeoutId) {
        clearTimeout(_this4.pingTimeoutId);
        _this4.pingTimeoutId = null;
      }
    };

    this.setConfig = function (actions) {
      return function (data) {
        var token = data.token,
            steps = data.steps,
            language = data.language,
            documentType = data.documentType,
            step = data.step,
            woopraCookie = data.woopraCookie;

        (0, _Tracker.setWoopraCookie)(woopraCookie);
        if (!token) {
          console.error('Desktop did not send token');
          (0, _Tracker.sendError)('Desktop did not send token');
          return _this4.setError();
        }
        if ((0, _jwt.jwtExpired)(token)) {
          console.error('Desktop token has expired');
          (0, _Tracker.sendError)('Token has expired: ' + token);
          return _this4.setError();
        }
        _this4.setState({ token: token, steps: steps, step: step, loading: false, crossDeviceError: false, i18n: (0, _locales.initializeI18n)(language) });
        actions.setDocumentType(documentType);
        actions.acceptTerms();
      };
    };

    this.setError = function () {
      return _this4.setState({ crossDeviceError: true, loading: false });
    };

    this.onDisconnect = function () {
      _this4.pingTimeoutId = setTimeout(_this4.setError, 3000);
      _this4.sendMessage('disconnect ping');
    };

    this.onDisconnectPong = function () {
      return _this4.clearPingTimeout();
    };

    this.onStepChange = function (step) {
      _this4.setState({ step: step });
    };

    this.sendClientSuccess = function () {
      _this4.state.socket.off('custom disconnect', _this4.onDisconnect);
      var faceCapture = _this4.props.captures.face[0];
      var data = faceCapture ? { faceCapture: _extends({ blob: null }, faceCapture) } : {};
      _this4.sendMessage('client success', data);
    };

    this.render = function (props) {
      return _this4.state.loading ? (0, _preact.h)(WrappedSpinner, { i18n: _this4.state.i18n, disableNavigation: true }) : _this4.state.crossDeviceError ? (0, _preact.h)(WrappedError, { i18n: _this4.state.i18n, disableNavigation: true }) : (0, _preact.h)(HistoryRouter, _extends({}, props, _this4.state, {
        onStepChange: _this4.onStepChange,
        sendClientSuccess: _this4.sendClientSuccess,
        crossDeviceClientError: _this4.setError
      }));
    };
  };

  var MainRouter = function (_Component2) {
    _inherits(MainRouter, _Component2);

    function MainRouter(props) {
      _classCallCheck(this, MainRouter);

      var _this2 = _possibleConstructorReturn(this, (MainRouter.__proto__ || (0, _getPrototypeOf2.default)(MainRouter)).call(this, props));

      _initialiseProps2.call(_this2);

      _this2.state = {
        crossDeviceInitialStep: null,
        i18n: (0, _locales.initializeI18n)(_this2.props.options.language)
      };
      return _this2;
    }

    _createClass(MainRouter, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (nextProps.options.language !== this.props.options.language) {
          this.setState({ i18n: (0, _locales.initializeI18n)(nextProps.options.language) });
        }
      }
    }]);

    return MainRouter;
  }(_preact.Component);

  var _initialiseProps2 = function _initialiseProps2() {
    var _this5 = this;

    this.mobileConfig = function () {
      var _props = _this5.props,
          documentType = _props.documentType,
          options = _props.options;
      var steps = options.steps,
          token = options.token,
          language = options.language;

      var woopraCookie = (0, _Tracker.getWoopraCookie)();
      return { steps: steps, token: token, language: language, documentType: documentType, step: _this5.state.crossDeviceInitialStep, woopraCookie: woopraCookie };
    };

    this.onFlowChange = function (newFlow, newStep, previousFlow, previousStep) {
      if (newFlow === "crossDeviceSteps") _this5.setState({ crossDeviceInitialStep: previousStep });
    };

    this.render = function (props) {
      return (0, _preact.h)(HistoryRouter, _extends({}, props, {
        steps: props.options.steps,
        onFlowChange: _this5.onFlowChange,
        mobileConfig: _this5.mobileConfig(),
        i18n: _this5.state.i18n
      }));
    };
  };

  var HistoryRouter = function (_Component3) {
    _inherits(HistoryRouter, _Component3);

    function HistoryRouter(props) {
      _classCallCheck(this, HistoryRouter);

      var _this3 = _possibleConstructorReturn(this, (HistoryRouter.__proto__ || (0, _getPrototypeOf2.default)(HistoryRouter)).call(this, props));

      _initialiseProps3.call(_this3);

      _this3.state = {
        flow: 'captureSteps',
        step: _this3.props.step || 0,
        initialStep: _this3.props.step || 0
      };
      _this3.unlisten = history.listen(_this3.onHistoryChange);
      _this3.setStepIndex(_this3.state.step, _this3.state.flow);
      return _this3;
    }

    _createClass(HistoryRouter, [{
      key: 'componentWillUpdate',
      value: function componentWillUpdate(nextProps, _ref) {
        var nextStep = _ref.step;

        if (nextStep !== this.state.step) {
          this.handleStepChange(nextStep);
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        var step = this.state.step;

        if (prevProps.steps[step] !== this.props.steps[step]) {
          this.handleStepChange(step);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.unlisten();
      }
    }]);

    return HistoryRouter;
  }(_preact.Component);

  var _initialiseProps3 = function _initialiseProps3() {
    var _this6 = this;

    this.handleStepChange = function (step) {
      _this6.props.onStepChange(step);
    };

    this.onHistoryChange = function (_ref2) {
      var historyState = _ref2.state;

      _this6.setState(_extends({}, historyState));
    };

    this.getStepType = function (step) {
      var componentList = _this6.componentsList();
      return componentList[step] ? componentList[step].step.type : null;
    };

    this.disableNavigation = function () {
      return _this6.initialStep() || _this6.getStepType(_this6.state.step) === 'complete';
    };

    this.initialStep = function () {
      return _this6.state.initialStep === _this6.state.step && _this6.state.flow === 'captureSteps';
    };

    this.changeFlowTo = function (newFlow) {
      var newStep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var excludeStepFromHistory = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var _state = _this6.state,
          previousFlow = _state.flow,
          previousStep = _state.step;

      if (previousFlow === newFlow) return;
      _this6.props.onFlowChange(newFlow, newStep, previousFlow, previousStep);
      _this6.setStepIndex(newStep, newFlow, excludeStepFromHistory);
    };

    this.nextStep = function () {
      var currentStep = _this6.state.step;

      var componentsList = _this6.componentsList();
      var newStepIndex = currentStep + 1;
      if (componentsList.length === newStepIndex) {
        _this6.triggerOnComplete();
      } else {
        _this6.setStepIndex(newStepIndex);
      }
    };

    this.triggerOnComplete = function () {
      var faceCapture = _this6.props.captures.face[0];
      var variant = faceCapture && faceCapture.variant;
      var data = variant ? { face: { variant: variant } } : {};
      _this6.props.options.events.emit('complete', data);
    };

    this.previousStep = function () {
      var currentStep = _this6.state.step;

      _this6.setStepIndex(currentStep - 1);
    };

    this.back = function () {
      history.goBack();
    };

    this.setStepIndex = function (newStepIndex, newFlow, excludeStepFromHistory) {
      var currentFlow = _this6.state.flow;

      var newState = {
        step: newStepIndex,
        flow: newFlow || currentFlow
      };
      if (excludeStepFromHistory) {
        _this6.setState(newState);
      } else {
        var path = '' + location.pathname + location.search + location.hash;
        history.push(path, newState);
      }
    };

    this.componentsList = function () {
      return _this6.buildComponentsList(_this6.state, _this6.props);
    };

    this.buildComponentsList = function (_ref3, _ref4) {
      var flow = _ref3.flow;
      var documentType = _ref4.documentType,
          steps = _ref4.steps,
          mobileFlow = _ref4.options.mobileFlow;
      return (0, _StepComponentMap.componentsList)({ flow: flow, documentType: documentType, steps: steps, mobileFlow: mobileFlow });
    };

    this.render = function (props) {
      return (0, _preact.h)(_StepsRouter2.default, _extends({}, props, {
        componentsList: _this6.componentsList(),
        step: _this6.state.step,
        disableNavigation: _this6.disableNavigation(),
        changeFlowTo: _this6.changeFlowTo,
        nextStep: _this6.nextStep,
        previousStep: _this6.previousStep,
        back: _this6.back
      }));
    };
  };

  HistoryRouter.defaultProps = {
    onStepChange: function onStepChange() {},
    onFlowChange: function onFlowChange() {}
  };

  function mapStateToProps(state) {
    return _extends({}, state.globals, { captures: state.captures });
  }

  function mapDispatchToProps(dispatch) {
    return { actions: (0, _redux.bindActionCreators)(_core.unboundActions, dispatch) };
  }

  exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Router);
  module.exports = exports['default'];
});

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * EventEmitter2
 * https://github.com/hij1nx/EventEmitter2
 *
 * Copyright (c) 2013 hij1nx
 * Licensed under the MIT license.
 */
;!function(undefined) {

  var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
    return Object.prototype.toString.call(obj) === "[object Array]";
  };
  var defaultMaxListeners = 10;

  function init() {
    this._events = {};
    if (this._conf) {
      configure.call(this, this._conf);
    }
  }

  function configure(conf) {
    if (conf) {
      this._conf = conf;

      conf.delimiter && (this.delimiter = conf.delimiter);
      this._events.maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
      conf.wildcard && (this.wildcard = conf.wildcard);
      conf.newListener && (this.newListener = conf.newListener);

      if (this.wildcard) {
        this.listenerTree = {};
      }
    } else {
      this._events.maxListeners = defaultMaxListeners;
    }
  }

  function logPossibleMemoryLeak(count) {
    console.error('(node) warning: possible EventEmitter memory ' +
      'leak detected. %d listeners added. ' +
      'Use emitter.setMaxListeners() to increase limit.',
      count);

    if (console.trace){
      console.trace();
    }
  }

  function EventEmitter(conf) {
    this._events = {};
    this.newListener = false;
    configure.call(this, conf);
  }
  EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property

  //
  // Attention, function return type now is array, always !
  // It has zero elements if no any matches found and one or more
  // elements (leafs) if there are matches
  //
  function searchListenerTree(handlers, type, tree, i) {
    if (!tree) {
      return [];
    }
    var listeners=[], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached,
        typeLength = type.length, currentType = type[i], nextType = type[i+1];
    if (i === typeLength && tree._listeners) {
      //
      // If at the end of the event(s) list and the tree has listeners
      // invoke those listeners.
      //
      if (typeof tree._listeners === 'function') {
        handlers && handlers.push(tree._listeners);
        return [tree];
      } else {
        for (leaf = 0, len = tree._listeners.length; leaf < len; leaf++) {
          handlers && handlers.push(tree._listeners[leaf]);
        }
        return [tree];
      }
    }

    if ((currentType === '*' || currentType === '**') || tree[currentType]) {
      //
      // If the event emitted is '*' at this part
      // or there is a concrete match at this patch
      //
      if (currentType === '*') {
        for (branch in tree) {
          if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i+1));
          }
        }
        return listeners;
      } else if(currentType === '**') {
        endReached = (i+1 === typeLength || (i+2 === typeLength && nextType === '*'));
        if(endReached && tree._listeners) {
          // The next element has a _listeners, add it to the handlers.
          listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
        }

        for (branch in tree) {
          if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
            if(branch === '*' || branch === '**') {
              if(tree[branch]._listeners && !endReached) {
                listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
              }
              listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
            } else if(branch === nextType) {
              listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i+2));
            } else {
              // No match on this one, shift into the tree but not in the type array.
              listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
            }
          }
        }
        return listeners;
      }

      listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i+1));
    }

    xTree = tree['*'];
    if (xTree) {
      //
      // If the listener tree will allow any match for this part,
      // then recursively explore all branches of the tree
      //
      searchListenerTree(handlers, type, xTree, i+1);
    }

    xxTree = tree['**'];
    if(xxTree) {
      if(i < typeLength) {
        if(xxTree._listeners) {
          // If we have a listener on a '**', it will catch all, so add its handler.
          searchListenerTree(handlers, type, xxTree, typeLength);
        }

        // Build arrays of matching next branches and others.
        for(branch in xxTree) {
          if(branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
            if(branch === nextType) {
              // We know the next element will match, so jump twice.
              searchListenerTree(handlers, type, xxTree[branch], i+2);
            } else if(branch === currentType) {
              // Current node matches, move into the tree.
              searchListenerTree(handlers, type, xxTree[branch], i+1);
            } else {
              isolatedBranch = {};
              isolatedBranch[branch] = xxTree[branch];
              searchListenerTree(handlers, type, { '**': isolatedBranch }, i+1);
            }
          }
        }
      } else if(xxTree._listeners) {
        // We have reached the end and still on a '**'
        searchListenerTree(handlers, type, xxTree, typeLength);
      } else if(xxTree['*'] && xxTree['*']._listeners) {
        searchListenerTree(handlers, type, xxTree['*'], typeLength);
      }
    }

    return listeners;
  }

  function growListenerTree(type, listener) {

    type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();

    //
    // Looks for two consecutive '**', if so, don't add the event at all.
    //
    for(var i = 0, len = type.length; i+1 < len; i++) {
      if(type[i] === '**' && type[i+1] === '**') {
        return;
      }
    }

    var tree = this.listenerTree;
    var name = type.shift();

    while (name !== undefined) {

      if (!tree[name]) {
        tree[name] = {};
      }

      tree = tree[name];

      if (type.length === 0) {

        if (!tree._listeners) {
          tree._listeners = listener;
        }
        else {
          if (typeof tree._listeners === 'function') {
            tree._listeners = [tree._listeners];
          }

          tree._listeners.push(listener);

          if (
            !tree._listeners.warned &&
            this._events.maxListeners > 0 &&
            tree._listeners.length > this._events.maxListeners
          ) {
            tree._listeners.warned = true;
            logPossibleMemoryLeak(tree._listeners.length);
          }
        }
        return true;
      }
      name = type.shift();
    }
    return true;
  }

  // By default EventEmitters will print a warning if more than
  // 10 listeners are added to it. This is a useful default which
  // helps finding memory leaks.
  //
  // Obviously not all Emitters should be limited to 10. This function allows
  // that to be increased. Set to zero for unlimited.

  EventEmitter.prototype.delimiter = '.';

  EventEmitter.prototype.setMaxListeners = function(n) {
    if (n !== undefined) {
      this._events || init.call(this);
      this._events.maxListeners = n;
      if (!this._conf) this._conf = {};
      this._conf.maxListeners = n;
    }
  };

  EventEmitter.prototype.event = '';

  EventEmitter.prototype.once = function(event, fn) {
    this.many(event, 1, fn);
    return this;
  };

  EventEmitter.prototype.many = function(event, ttl, fn) {
    var self = this;

    if (typeof fn !== 'function') {
      throw new Error('many only accepts instances of Function');
    }

    function listener() {
      if (--ttl === 0) {
        self.off(event, listener);
      }
      fn.apply(this, arguments);
    }

    listener._origin = fn;

    this.on(event, listener);

    return self;
  };

  EventEmitter.prototype.emit = function() {

    this._events || init.call(this);

    var type = arguments[0];

    if (type === 'newListener' && !this.newListener) {
      if (!this._events.newListener) {
        return false;
      }
    }

    var al = arguments.length;
    var args,l,i,j;
    var handler;

    if (this._all && this._all.length) {
      handler = this._all.slice();
      if (al > 3) {
        args = new Array(al);
        for (j = 0; j < al; j++) args[j] = arguments[j];
      }

      for (i = 0, l = handler.length; i < l; i++) {
        this.event = type;
        switch (al) {
        case 1:
          handler[i].call(this, type);
          break;
        case 2:
          handler[i].call(this, type, arguments[1]);
          break;
        case 3:
          handler[i].call(this, type, arguments[1], arguments[2]);
          break;
        default:
          handler[i].apply(this, args);
        }
      }
    }

    if (this.wildcard) {
      handler = [];
      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
      searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
    } else {
      handler = this._events[type];
      if (typeof handler === 'function') {
        this.event = type;
        switch (al) {
        case 1:
          handler.call(this);
          break;
        case 2:
          handler.call(this, arguments[1]);
          break;
        case 3:
          handler.call(this, arguments[1], arguments[2]);
          break;
        default:
          args = new Array(al - 1);
          for (j = 1; j < al; j++) args[j - 1] = arguments[j];
          handler.apply(this, args);
        }
        return true;
      } else if (handler) {
        // need to make copy of handlers because list can change in the middle
        // of emit call
        handler = handler.slice();
      }
    }

    if (handler && handler.length) {
      if (al > 3) {
        args = new Array(al - 1);
        for (j = 1; j < al; j++) args[j - 1] = arguments[j];
      }
      for (i = 0, l = handler.length; i < l; i++) {
        this.event = type;
        switch (al) {
        case 1:
          handler[i].call(this);
          break;
        case 2:
          handler[i].call(this, arguments[1]);
          break;
        case 3:
          handler[i].call(this, arguments[1], arguments[2]);
          break;
        default:
          handler[i].apply(this, args);
        }
      }
      return true;
    } else if (!this._all && type === 'error') {
      if (arguments[1] instanceof Error) {
        throw arguments[1]; // Unhandled 'error' event
      } else {
        throw new Error("Uncaught, unspecified 'error' event.");
      }
      return false;
    }

    return !!this._all;
  };

  EventEmitter.prototype.emitAsync = function() {

    this._events || init.call(this);

    var type = arguments[0];

    if (type === 'newListener' && !this.newListener) {
        if (!this._events.newListener) { return Promise.resolve([false]); }
    }

    var promises= [];

    var al = arguments.length;
    var args,l,i,j;
    var handler;

    if (this._all) {
      if (al > 3) {
        args = new Array(al);
        for (j = 1; j < al; j++) args[j] = arguments[j];
      }
      for (i = 0, l = this._all.length; i < l; i++) {
        this.event = type;
        switch (al) {
        case 1:
          promises.push(this._all[i].call(this, type));
          break;
        case 2:
          promises.push(this._all[i].call(this, type, arguments[1]));
          break;
        case 3:
          promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
          break;
        default:
          promises.push(this._all[i].apply(this, args));
        }
      }
    }

    if (this.wildcard) {
      handler = [];
      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
      searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
    } else {
      handler = this._events[type];
    }

    if (typeof handler === 'function') {
      this.event = type;
      switch (al) {
      case 1:
        promises.push(handler.call(this));
        break;
      case 2:
        promises.push(handler.call(this, arguments[1]));
        break;
      case 3:
        promises.push(handler.call(this, arguments[1], arguments[2]));
        break;
      default:
        args = new Array(al - 1);
        for (j = 1; j < al; j++) args[j - 1] = arguments[j];
        promises.push(handler.apply(this, args));
      }
    } else if (handler && handler.length) {
      if (al > 3) {
        args = new Array(al - 1);
        for (j = 1; j < al; j++) args[j - 1] = arguments[j];
      }
      for (i = 0, l = handler.length; i < l; i++) {
        this.event = type;
        switch (al) {
        case 1:
          promises.push(handler[i].call(this));
          break;
        case 2:
          promises.push(handler[i].call(this, arguments[1]));
          break;
        case 3:
          promises.push(handler[i].call(this, arguments[1], arguments[2]));
          break;
        default:
          promises.push(handler[i].apply(this, args));
        }
      }
    } else if (!this._all && type === 'error') {
      if (arguments[1] instanceof Error) {
        return Promise.reject(arguments[1]); // Unhandled 'error' event
      } else {
        return Promise.reject("Uncaught, unspecified 'error' event.");
      }
    }

    return Promise.all(promises);
  };

  EventEmitter.prototype.on = function(type, listener) {
    if (typeof type === 'function') {
      this.onAny(type);
      return this;
    }

    if (typeof listener !== 'function') {
      throw new Error('on only accepts instances of Function');
    }
    this._events || init.call(this);

    // To avoid recursion in the case that type == "newListeners"! Before
    // adding it to the listeners, first emit "newListeners".
    this.emit('newListener', type, listener);

    if (this.wildcard) {
      growListenerTree.call(this, type, listener);
      return this;
    }

    if (!this._events[type]) {
      // Optimize the case of one listener. Don't need the extra array object.
      this._events[type] = listener;
    }
    else {
      if (typeof this._events[type] === 'function') {
        // Change to array.
        this._events[type] = [this._events[type]];
      }

      // If we've already got an array, just append.
      this._events[type].push(listener);

      // Check for listener leak
      if (
        !this._events[type].warned &&
        this._events.maxListeners > 0 &&
        this._events[type].length > this._events.maxListeners
      ) {
        this._events[type].warned = true;
        logPossibleMemoryLeak(this._events[type].length);
      }
    }

    return this;
  };

  EventEmitter.prototype.onAny = function(fn) {
    if (typeof fn !== 'function') {
      throw new Error('onAny only accepts instances of Function');
    }

    if (!this._all) {
      this._all = [];
    }

    // Add the function to the event listener collection.
    this._all.push(fn);
    return this;
  };

  EventEmitter.prototype.addListener = EventEmitter.prototype.on;

  EventEmitter.prototype.off = function(type, listener) {
    if (typeof listener !== 'function') {
      throw new Error('removeListener only takes instances of Function');
    }

    var handlers,leafs=[];

    if(this.wildcard) {
      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
      leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
    }
    else {
      // does not use listeners(), so no side effect of creating _events[type]
      if (!this._events[type]) return this;
      handlers = this._events[type];
      leafs.push({_listeners:handlers});
    }

    for (var iLeaf=0; iLeaf<leafs.length; iLeaf++) {
      var leaf = leafs[iLeaf];
      handlers = leaf._listeners;
      if (isArray(handlers)) {

        var position = -1;

        for (var i = 0, length = handlers.length; i < length; i++) {
          if (handlers[i] === listener ||
            (handlers[i].listener && handlers[i].listener === listener) ||
            (handlers[i]._origin && handlers[i]._origin === listener)) {
            position = i;
            break;
          }
        }

        if (position < 0) {
          continue;
        }

        if(this.wildcard) {
          leaf._listeners.splice(position, 1);
        }
        else {
          this._events[type].splice(position, 1);
        }

        if (handlers.length === 0) {
          if(this.wildcard) {
            delete leaf._listeners;
          }
          else {
            delete this._events[type];
          }
        }

        this.emit("removeListener", type, listener);

        return this;
      }
      else if (handlers === listener ||
        (handlers.listener && handlers.listener === listener) ||
        (handlers._origin && handlers._origin === listener)) {
        if(this.wildcard) {
          delete leaf._listeners;
        }
        else {
          delete this._events[type];
        }

        this.emit("removeListener", type, listener);
      }
    }

    function recursivelyGarbageCollect(root) {
      if (root === undefined) {
        return;
      }
      var keys = Object.keys(root);
      for (var i in keys) {
        var key = keys[i];
        var obj = root[key];
        if ((obj instanceof Function) || (typeof obj !== "object") || (obj === null))
          continue;
        if (Object.keys(obj).length > 0) {
          recursivelyGarbageCollect(root[key]);
        }
        if (Object.keys(obj).length === 0) {
          delete root[key];
        }
      }
    }
    recursivelyGarbageCollect(this.listenerTree);

    return this;
  };

  EventEmitter.prototype.offAny = function(fn) {
    var i = 0, l = 0, fns;
    if (fn && this._all && this._all.length > 0) {
      fns = this._all;
      for(i = 0, l = fns.length; i < l; i++) {
        if(fn === fns[i]) {
          fns.splice(i, 1);
          this.emit("removeListenerAny", fn);
          return this;
        }
      }
    } else {
      fns = this._all;
      for(i = 0, l = fns.length; i < l; i++)
        this.emit("removeListenerAny", fns[i]);
      this._all = [];
    }
    return this;
  };

  EventEmitter.prototype.removeListener = EventEmitter.prototype.off;

  EventEmitter.prototype.removeAllListeners = function(type) {
    if (arguments.length === 0) {
      !this._events || init.call(this);
      return this;
    }

    if (this.wildcard) {
      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
      var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);

      for (var iLeaf=0; iLeaf<leafs.length; iLeaf++) {
        var leaf = leafs[iLeaf];
        leaf._listeners = null;
      }
    }
    else if (this._events) {
      this._events[type] = null;
    }
    return this;
  };

  EventEmitter.prototype.listeners = function(type) {
    if (this.wildcard) {
      var handlers = [];
      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
      searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
      return handlers;
    }

    this._events || init.call(this);

    if (!this._events[type]) this._events[type] = [];
    if (!isArray(this._events[type])) {
      this._events[type] = [this._events[type]];
    }
    return this._events[type];
  };

  EventEmitter.prototype.listenerCount = function(type) {
    return this.listeners(type).length;
  };

  EventEmitter.prototype.listenersAny = function() {

    if(this._all) {
      return this._all;
    }
    else {
      return [];
    }

  };

  if (true) {
     // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return EventEmitter;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    // CommonJS
    module.exports = EventEmitter;
  }
  else {
    // Browser global.
    window.EventEmitter2 = EventEmitter;
  }
}();


/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports = after

function after(count, callback, err_cb) {
    var bail = false
    err_cb = err_cb || noop
    proxy.count = count

    return (count === 0) ? callback() : proxy

    function proxy(err, result) {
        if (proxy.count <= 0) {
            throw new Error('after called too many times')
        }
        --proxy.count

        // after first error, rest are passed to err_cb
        if (err) {
            bail = true
            callback(err)
            // future error callbacks will go to error handler
            callback = err_cb
        } else if (proxy.count === 0 && !bail) {
            callback(null, result)
        }
    }
}

function noop() {}


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var BezierEasing = __webpack_require__(239)

// Predefined set of animations. Similar to CSS easing functions
var animations = {
  ease:  BezierEasing(0.25, 0.1, 0.25, 1),
  easeIn: BezierEasing(0.42, 0, 1, 1),
  easeOut: BezierEasing(0, 0, 0.58, 1),
  easeInOut: BezierEasing(0.42, 0, 0.58, 1),
  linear: BezierEasing(0, 0, 1, 1)
}


module.exports = animate;

function animate(source, target, options) {
  var start= Object.create(null)
  var diff = Object.create(null)
  options = options || {}
  // We let clients specify their own easing function
  var easing = (typeof options.easing === 'function') ? options.easing : animations[options.easing]

  // if nothing is specified, default to ease (similar to CSS animations)
  if (!easing) {
    if (options.easing) {
      console.warn('Unknown easing function in amator: ' + options.easing);
    }
    easing = animations.ease
  }

  var step = typeof options.step === 'function' ? options.step : noop
  var done = typeof options.done === 'function' ? options.done : noop

  var scheduler = getScheduler(options.scheduler)

  var keys = Object.keys(target)
  keys.forEach(function(key) {
    start[key] = source[key]
    diff[key] = target[key] - source[key]
  })

  var durationInMs = options.duration || 400
  var durationInFrames = Math.max(1, durationInMs * 0.06) // 0.06 because 60 frames pers 1,000 ms
  var previousAnimationId
  var frame = 0

  previousAnimationId = scheduler.next(loop)

  return {
    cancel: cancel
  }

  function cancel() {
    scheduler.cancel(previousAnimationId)
    previousAnimationId = 0
  }

  function loop() {
    var t = easing(frame/durationInFrames)
    frame += 1
    setValues(t)
    if (frame <= durationInFrames) {
      previousAnimationId = scheduler.next(loop)
      step(source)
    } else {
      previousAnimationId = 0
      setTimeout(function() { done(source) }, 0)
    }
  }

  function setValues(t) {
    keys.forEach(function(key) {
      source[key] = diff[key] * t + start[key]
    })
  }
}

function noop() { }

function getScheduler(scheduler) {
  if (!scheduler) {
    var canRaf = typeof window !== 'undefined' && window.requestAnimationFrame
    return canRaf ? rafScheduler() : timeoutScheduler()
  }
  if (typeof scheduler.next !== 'function') throw new Error('Scheduler is supposed to have next(cb) function')
  if (typeof scheduler.cancel !== 'function') throw new Error('Scheduler is supposed to have cancel(handle) function')

  return scheduler
}

function rafScheduler() {
  return {
    next: window.requestAnimationFrame.bind(window),
    cancel: window.cancelAnimationFrame.bind(window)
  }
}

function timeoutScheduler() {
  return {
    next: function(cb) {
      return setTimeout(cb, 1000/60)
    },
    cancel: function (id) {
      return clearTimeout(id)
    }
  }
}


/***/ }),
/* 184 */
/***/ (function(module, exports) {

/**
 * An abstraction for slicing an arraybuffer even when
 * ArrayBuffer.prototype.slice is not supported
 *
 * @api public
 */

module.exports = function(arraybuffer, start, end) {
  var bytes = arraybuffer.byteLength;
  start = start || 0;
  end = end || bytes;

  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }

  if (start < 0) { start += bytes; }
  if (end < 0) { end += bytes; }
  if (end > bytes) { end = bytes; }

  if (start >= bytes || start >= end || bytes === 0) {
    return new ArrayBuffer(0);
  }

  var abv = new Uint8Array(arraybuffer);
  var result = new Uint8Array(end - start);
  for (var i = start, ii = 0; i < end; i++, ii++) {
    result[ii] = abv[i];
  }
  return result.buffer;
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(10), __webpack_require__(3), __webpack_require__(7), __webpack_require__(6), __webpack_require__(4), __webpack_require__(5), __webpack_require__(0), __webpack_require__(473), __webpack_require__(53), __webpack_require__(112)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/object/assign'), require('babel-runtime/core-js/object/define-property'), require('babel-runtime/core-js/object/set-prototype-of'), require('babel-runtime/core-js/object/create'), require('babel-runtime/core-js/object/get-prototype-of'), require('react'), require('preact'), require('visibilityjs'), require('./index.js'), require('../utils/camera.js'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.assign, global.defineProperty, global.setPrototypeOf, global.create, global.getPrototypeOf, global.react, global.preact, global.visibilityjs, global.index, global.camera);
    global.AutoCapture = mod.exports;
  }
})(this, function (module, exports, _assign, _defineProperty, _setPrototypeOf, _create, _getPrototypeOf, _react, _preact, _visibilityjs, _index, _camera) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _assign2 = _interopRequireDefault(_assign);

  var _defineProperty2 = _interopRequireDefault(_defineProperty);

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create2 = _interopRequireDefault(_create);

  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

  var React = _interopRequireWildcard(_react);

  var _visibilityjs2 = _interopRequireDefault(_visibilityjs);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty2.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var AutoCapture = function (_React$Component) {
    _inherits(AutoCapture, _React$Component);

    function AutoCapture() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, AutoCapture);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AutoCapture.__proto__ || (0, _getPrototypeOf2.default)(AutoCapture)).call.apply(_ref, [this].concat(args))), _this), _this.webcam = null, _this.capture = {
        start: function start() {
          _this.capture.stop();
          _this.interval = _visibilityjs2.default.every(1000, function () {
            return (0, _camera.screenshot)(_this.webcam, _this.props.onScreenshot);
          });
        },
        stop: function stop() {
          return _visibilityjs2.default.stop(_this.interval);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(AutoCapture, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.webcamMounted();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.webcamUnmounted();
      }
    }, {
      key: 'webcamMounted',
      value: function webcamMounted() {
        var autoCapture = this.props.autoCapture;

        if (autoCapture) this.capture.start();
      }
    }, {
      key: 'webcamUnmounted',
      value: function webcamUnmounted() {
        this.capture.stop();
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return (0, _preact.h)(
          'div',
          null,
          (0, _preact.h)(_index.CameraPure, _extends({}, this.props, {
            webcamRef: function webcamRef(c) {
              _this2.webcam = c;
            }
          }))
        );
      }
    }]);

    return AutoCapture;
  }(React.Component);

  exports.default = AutoCapture;
  module.exports = exports['default'];
});

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(10), __webpack_require__(3), __webpack_require__(7), __webpack_require__(6), __webpack_require__(4), __webpack_require__(5), __webpack_require__(0), __webpack_require__(11), __webpack_require__(104), __webpack_require__(13), __webpack_require__(53), __webpack_require__(196), __webpack_require__(110)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/object/assign'), require('babel-runtime/core-js/object/define-property'), require('babel-runtime/core-js/object/set-prototype-of'), require('babel-runtime/core-js/object/create'), require('babel-runtime/core-js/object/get-prototype-of'), require('react'), require('preact'), require('classnames'), require('./style.css'), require('../Theme/style.css'), require('./index.js'), require('../Liveness/Challenge'), require('../Timeout'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.assign, global.defineProperty, global.setPrototypeOf, global.create, global.getPrototypeOf, global.react, global.preact, global.classnames, global.style, global.style, global.index, global.Challenge, global.Timeout);
    global.LivenessCamera = mod.exports;
  }
})(this, function (module, exports, _assign, _defineProperty2, _setPrototypeOf, _create, _getPrototypeOf, _react, _preact, _classnames, _style, _style3, _index, _Challenge, _Timeout) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _assign2 = _interopRequireDefault(_assign);

  var _defineProperty3 = _interopRequireDefault(_defineProperty2);

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create2 = _interopRequireDefault(_create);

  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

  var React = _interopRequireWildcard(_react);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _style2 = _interopRequireDefault(_style);

  var _style4 = _interopRequireDefault(_style3);

  var _Challenge2 = _interopRequireDefault(_Challenge);

  var _Timeout2 = _interopRequireDefault(_Timeout);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      (0, _defineProperty3.default)(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var _extends = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty3.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var initialState = {
    currentIndex: 0,
    isRecording: false,
    hasBecomeInactive: false,
    hasRecordingTakenTooLong: false
  };

  var inactiveError = { name: 'CAMERA_INACTIVE', type: 'warning' };
  var recordingTooLongError = { name: 'LIVENESS_TIMEOUT', type: 'warning' };

  var LivenessCamera = function (_React$Component) {
    _inherits(LivenessCamera, _React$Component);

    function LivenessCamera() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, LivenessCamera);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LivenessCamera.__proto__ || (0, _getPrototypeOf2.default)(LivenessCamera)).call.apply(_ref, [this].concat(args))), _this), _this.webcam = null, _this.state = _extends({}, initialState), _this.startRecording = function () {
        _this.webcam && _this.webcam.startRecording();
        _this.setState({ isRecording: true, hasBecomeInactive: false });
      }, _this.stopRecording = function () {
        _this.webcam && _this.webcam.stopRecording();
        _this.setState({ isRecording: false });
      }, _this.handleRecordingStart = function () {
        if (_this.props.hasMediaStream) {
          _this.startRecording();
          _this.props.onVideoRecordingStart();
        }
      }, _this.handleRecordingStop = function () {
        var hasRecordingTakenTooLong = _this.state.hasRecordingTakenTooLong;

        _this.stopRecording();
        if (_this.webcam && !hasRecordingTakenTooLong) {
          _this.props.onVideoRecorded(_this.webcam.getVideoBlob());
        }
      }, _this.handleNextChallenge = function () {
        _this.setState({ currentIndex: _this.state.currentIndex + 1 });
        _this.props.onSwitchChallenge();
      }, _this.handleInactivityTimeout = function () {
        _this.setState({ hasBecomeInactive: true });
      }, _this.handleRecordingTimeout = function () {
        _this.setState({ hasRecordingTakenTooLong: true });
        _this.stopRecording();
      }, _this.redoActionsFallback = function (text) {
        return (0, _preact.h)(
          'span',
          { onClick: _this.props.onRedo, className: _style2.default.fallbackLink },
          text
        );
      }, _this.cameraError = function () {
        var _this$state = _this.state,
            hasRecordingTakenTooLong = _this$state.hasRecordingTakenTooLong,
            hasBecomeInactive = _this$state.hasBecomeInactive;


        if (!_this.props.hasError) {
          if (hasBecomeInactive) {
            return {
              hasError: true,
              cameraError: inactiveError,
              cameraErrorIsDismissible: true
            };
          }

          if (hasRecordingTakenTooLong) {
            return {
              hasError: true,
              cameraError: recordingTooLongError,
              cameraErrorFallback: _this.redoActionsFallback,
              cameraErrorHasBackdrop: true
            };
          }
        }
      }, _this.render = function () {
        var _classNames2;

        var _this$props = _this.props,
            i18n = _this$props.i18n,
            _this$props$challenge = _this$props.challenges,
            challenges = _this$props$challenge === undefined ? [] : _this$props$challenge,
            hasGrantedPermission = _this$props.hasGrantedPermission,
            hasMediaStream = _this$props.hasMediaStream;
        var _this$state2 = _this.state,
            isRecording = _this$state2.isRecording,
            currentIndex = _this$state2.currentIndex;

        var currentChallenge = challenges[currentIndex] || {};
        var isLastChallenge = currentIndex === challenges.length - 1;
        var title = isRecording ? '' : i18n.t('capture.liveness.challenges.position_face');

        return (0, _preact.h)(
          'div',
          { className: _style2.default.livenessCamera },
          hasGrantedPermission ? isRecording ? (0, _preact.h)(_Timeout2.default, { key: 'recording', seconds: 20, onTimeout: _this.handleRecordingTimeout }) : (0, _preact.h)(_Timeout2.default, { key: 'notRecording', seconds: 12, onTimeout: _this.handleInactivityTimeout }) : null,
          (0, _preact.h)(_index.CameraPure, _extends({}, _extends({}, _this.props, {
            video: true,
            isWithoutHole: isRecording,
            webcamRef: function webcamRef(c) {
              return _this.webcam = c;
            },
            title: title,
            subTitle: ''
          }), _this.cameraError())),
          (0, _preact.h)(
            'div',
            { className: _style2.default.caption },
            isRecording && (0, _preact.h)(
              'div',
              null,
              (0, _preact.h)(
                'div',
                { className: _style2.default.recordingIndicator },
                i18n.t('capture.liveness.recording')
              ),
              (0, _preact.h)(_Challenge2.default, _extends({ i18n: i18n }, currentChallenge))
            )
          ),
          (0, _preact.h)(
            _index.CameraActions,
            null,
            (0, _preact.h)(
              'div',
              { className: (0, _classnames2.default)(_style2.default.captureActionsHint, _defineProperty({}, _style2.default.recordAction, !isRecording)) },
              isRecording ? i18n.t('capture.liveness.challenges.done_' + (isLastChallenge ? 'stop' : 'next')) : i18n.t('capture.liveness.press_record')
            ),
            !isLastChallenge && isRecording ? (0, _preact.h)(
              'button',
              {
                className: _style4.default.btn + ' ' + _style4.default['btn-centered'] + ' ' + _style4.default['btn-primary'],
                onClick: _this.handleNextChallenge },
              _this.props.i18n.t('capture.liveness.challenges.next')
            ) : (0, _preact.h)('button', {
              className: (0, _classnames2.default)(_style2.default.btn, (_classNames2 = {}, _defineProperty(_classNames2, _style2.default.stopRecording, isRecording), _defineProperty(_classNames2, _style2.default.startRecording, !isRecording), _classNames2)),
              onClick: isRecording ? _this.handleRecordingStop : _this.handleRecordingStart,
              disabled: _this.props.hasError
            })
          )
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(LivenessCamera, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (nextProps.challenges !== this.props.challenges) {
          this.setState(_extends({}, initialState));
        }
      }
    }]);

    return LivenessCamera;
  }(React.Component);

  LivenessCamera.defaultProps = {
    timeoutSeconds: 20
  };
  exports.default = LivenessCamera;
  module.exports = exports['default'];
});

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(0), __webpack_require__(15), __webpack_require__(191), __webpack_require__(13), __webpack_require__(8), __webpack_require__(9), __webpack_require__(437)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('preact'), require('components/Title'), require('components/Collapsible'), require('components/Theme/style.css'), require('components/utils'), require('Tracker'), require('./style.css'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.preact, global.Title, global.Collapsible, global.style, global.utils, global.Tracker, global.style);
    global.index = mod.exports;
  }
})(this, function (module, exports, _preact, _Title, _Collapsible, _style, _utils, _Tracker, _style3) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _Title2 = _interopRequireDefault(_Title);

  var _Collapsible2 = _interopRequireDefault(_Collapsible);

  var _style2 = _interopRequireDefault(_style);

  var _style4 = _interopRequireDefault(_style3);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Permissions = function Permissions(_ref) {
    var onNext = _ref.onNext,
        i18n = _ref.i18n;
    return (0, _preact.h)(
      'div',
      null,
      (0, _preact.h)(_Title2.default, { title: i18n.t('webcam_permissions.allow_access') }),
      (0, _preact.h)(
        'div',
        { className: _style2.default.thickWrapper },
        i18n.t('webcam_permissions.enable_webcam_for_selfie'),
        (0, _preact.h)(
          'div',
          { className: _style4.default.image },
          (0, _preact.h)(
            'p',
            null,
            i18n.t('webcam_permissions.click_allow')
          ),
          (0, _preact.h)(
            'div',
            { className: _style4.default.graphic },
            (0, _preact.h)(
              'span',
              { className: _style4.default.allow },
              i18n.t('webcam_permissions.allow')
            )
          )
        ),
        (0, _preact.h)(
          _Collapsible2.default,
          { trigger: i18n.t('webcam_permissions.why'), className: _style4.default.reasons },
          (0, _preact.h)(
            'p',
            { className: _style4.default.reason },
            i18n.t('webcam_permissions.if_denied')
          )
        ),
        (0, _preact.h)(
          'button',
          {
            href: '',
            className: _style2.default.btn + ' ' + _style2.default["btn-centered"] + ' ' + _style2.default["btn-primary"],
            onClick: (0, _utils.preventDefaultOnClick)(onNext) },
          i18n.t('webcam_permissions.enable_webcam')
        )
      )
    );
  };

  exports.default = (0, _Tracker.trackComponent)(Permissions);
  module.exports = exports['default'];
});

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(0), __webpack_require__(15), __webpack_require__(13), __webpack_require__(438), __webpack_require__(8), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('preact'), require('components/Title'), require('components/Theme/style.css'), require('./style.css'), require('components/utils'), require('Tracker'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.preact, global.Title, global.style, global.style, global.utils, global.Tracker);
    global.index = mod.exports;
  }
})(this, function (module, exports, _preact, _Title, _style, _style3, _utils, _Tracker) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _Title2 = _interopRequireDefault(_Title);

  var _style2 = _interopRequireDefault(_style);

  var _style4 = _interopRequireDefault(_style3);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Recover = function Recover(_ref) {
    var onRefresh = _ref.onRefresh,
        i18n = _ref.i18n;
    return (0, _preact.h)(
      'div',
      { className: _style2.default.fullHeightContainer },
      (0, _preact.h)(_Title2.default, {
        title: i18n.t('webcam_permissions.access_denied'),
        subTitle: i18n.t('webcam_permissions.recover_access')
      }),
      (0, _preact.h)(
        'div',
        { className: _style2.default.thickWrapper },
        (0, _preact.h)(
          'div',
          { className: _style4.default.instructions },
          (0, _preact.h)(
            'span',
            { className: _style4.default.recovery },
            i18n.t('webcam_permissions.recovery')
          ),
          (0, _preact.h)(
            'p',
            { className: _style4.default.instructionsTitle },
            i18n.t('webcam_permissions.follow_steps')
          ),
          (0, _preact.h)(
            'ol',
            { className: _style4.default.steps },
            ['grant_access', 'refresh_page'].map(function (key) {
              return (0, _preact.h)(
                'li',
                { key: key, className: _style4.default.step },
                i18n.t('webcam_permissions.' + key)
              );
            })
          )
        )
      ),
      (0, _preact.h)(
        'div',
        { className: _style2.default.thickWrapper },
        (0, _preact.h)(
          'button',
          {
            href: '',
            className: _style4.default.button + ' ' + _style2.default.btn + ' ' + _style2.default["btn-primary"],
            onClick: (0, _utils.preventDefaultOnClick)(onRefresh) },
          i18n.t('webcam_permissions.refresh')
        )
      )
    );
  };

  exports.default = (0, _Tracker.trackComponent)(Recover);
  module.exports = exports['default'];
});

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(10), __webpack_require__(3), __webpack_require__(7), __webpack_require__(6), __webpack_require__(4), __webpack_require__(5), __webpack_require__(0), __webpack_require__(104), __webpack_require__(112), __webpack_require__(110), __webpack_require__(53)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/object/assign'), require('babel-runtime/core-js/object/define-property'), require('babel-runtime/core-js/object/set-prototype-of'), require('babel-runtime/core-js/object/create'), require('babel-runtime/core-js/object/get-prototype-of'), require('react'), require('preact'), require('./style.css'), require('../utils/camera.js'), require('../Timeout'), require('./index.js'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.assign, global.defineProperty, global.setPrototypeOf, global.create, global.getPrototypeOf, global.react, global.preact, global.style, global.camera, global.Timeout, global.index);
    global.Photo = mod.exports;
  }
})(this, function (module, exports, _assign, _defineProperty, _setPrototypeOf, _create, _getPrototypeOf, _react, _preact, _style, _camera, _Timeout, _index) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _assign2 = _interopRequireDefault(_assign);

  var _defineProperty2 = _interopRequireDefault(_defineProperty);

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create2 = _interopRequireDefault(_create);

  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

  var React = _interopRequireWildcard(_react);

  var _style2 = _interopRequireDefault(_style);

  var _Timeout2 = _interopRequireDefault(_Timeout);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty2.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Photo = function (_React$Component) {
    _inherits(Photo, _React$Component);

    function Photo() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Photo);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Photo.__proto__ || (0, _getPrototypeOf2.default)(Photo)).call.apply(_ref, [this].concat(args))), _this), _this.webcam = null, _this.state = {
        hasBecomeInactive: false
      }, _this.handleTimeout = function () {
        return _this.setState({ hasBecomeInactive: true });
      }, _this.screenshot = function () {
        return (0, _camera.screenshot)(_this.webcam, _this.props.onScreenshot);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Photo, [{
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            hasError = _props.hasError,
            hasGrantedPermission = _props.hasGrantedPermission;
        var hasBecomeInactive = this.state.hasBecomeInactive;

        return (0, _preact.h)(
          'div',
          null,
          hasGrantedPermission ? (0, _preact.h)(_Timeout2.default, { seconds: 10, onTimeout: this.handleTimeout }) : null,
          (0, _preact.h)(_index.CameraPure, _extends({}, this.props, {
            webcamRef: function webcamRef(c) {
              _this2.webcam = c;
            }
          }, !hasError && hasBecomeInactive ? {
            hasError: true,
            cameraError: { name: 'CAMERA_INACTIVE', type: 'warning' },
            cameraErrorIsDismissible: true
          } : {})),
          (0, _preact.h)(
            _index.CameraActions,
            null,
            (0, _preact.h)('button', {
              className: _style2.default.btn + ' ' + _style2.default.fullScreenBtn,
              onClick: this.screenshot,
              disabled: !!hasError
            })
          )
        );
      }
    }]);

    return Photo;
  }(React.Component);

  exports.default = Photo;
  module.exports = exports['default'];
});

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(10), __webpack_require__(3), __webpack_require__(7), __webpack_require__(6), __webpack_require__(57), __webpack_require__(4), __webpack_require__(0), __webpack_require__(52), __webpack_require__(41), __webpack_require__(78), __webpack_require__(211), __webpack_require__(53), __webpack_require__(203), __webpack_require__(8), __webpack_require__(76), __webpack_require__(113), __webpack_require__(224)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/object/assign'), require('babel-runtime/core-js/object/define-property'), require('babel-runtime/core-js/object/set-prototype-of'), require('babel-runtime/core-js/object/create'), require('babel-runtime/core-js/json/stringify'), require('babel-runtime/core-js/object/get-prototype-of'), require('preact'), require('../../core'), require('react-redux'), require('../utils/string'), require('../Uploader'), require('../Camera'), require('../PrivacyStatement'), require('../utils'), require('../utils/canvas.js'), require('../utils/file.js'), require('../utils/sdkBackend'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.assign, global.defineProperty, global.setPrototypeOf, global.create, global.stringify, global.getPrototypeOf, global.preact, global.core, global.reactRedux, global.string, global.Uploader, global.Camera, global.PrivacyStatement, global.utils, global.canvas, global.file, global.sdkBackend);
    global.capture = mod.exports;
  }
})(this, function (module, exports, _assign, _defineProperty, _setPrototypeOf, _create, _stringify, _getPrototypeOf, _preact, _core, _reactRedux, _string, _Uploader, _Camera, _PrivacyStatement, _utils, _canvas, _file, _sdkBackend) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _assign2 = _interopRequireDefault(_assign);

  var _defineProperty2 = _interopRequireDefault(_defineProperty);

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create2 = _interopRequireDefault(_create);

  var _stringify2 = _interopRequireDefault(_stringify);

  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

  var _Camera2 = _interopRequireDefault(_Camera);

  var _PrivacyStatement2 = _interopRequireDefault(_PrivacyStatement);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var _extends = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty2.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Capture = function (_Component) {
    _inherits(Capture, _Component);

    function Capture(props) {
      _classCallCheck(this, Capture);

      var _this = _possibleConstructorReturn(this, (Capture.__proto__ || (0, _getPrototypeOf2.default)(Capture)).call(this, props));

      _this.acceptTerms = function () {
        _this.props.actions.acceptTerms();
      };

      _this.checkWebcamSupport = function () {
        (0, _utils.checkIfHasWebcam)(function (hasWebcam) {
          return _this.setState({ hasWebcam: hasWebcam });
        });
      };

      _this.maxAutomaticCaptures = 3;

      _this.onValidationServiceResponse = function (payload, _ref) {
        var valid = _ref.valid;
        var nextStep = _this.props.nextStep;

        _this.validateCaptures(payload, valid);
        if (valid) nextStep();
      };

      _this.handleCapture = function (blob, base64) {
        if (!blob) {
          console.warn('Cannot handle a null image');
          return;
        }

        var payload = _this.initialiseCapturePayload(blob, base64);
        (0, _utils.functionalSwitch)(_this.props.method, {
          document: function document() {
            return _this.handleDocument(payload);
          },
          face: function face() {
            return _this.handleFace(_extends({}, payload, { variant: 'standard' }));
          }
        });
      };

      _this.onVideoRecorded = function (blob, challengeData) {
        var payload = _this.createVideoPayload(blob, challengeData);
        _this.createCapture(payload);
        _this.validateAndProceed(payload);
      };

      _this.initialiseCapturePayload = function (blob, base64) {
        return { id: (0, _string.randomId)(), blob: blob, base64: base64 };
      };

      _this.validationServicePayload = function (_ref2) {
        var id = _ref2.id,
            base64 = _ref2.base64;
        return (0, _stringify2.default)({ id: id, image: base64 });
      };

      _this.onUploadFallback = function (file) {
        _this.setState({ uploadFallback: true });
        _this.clearErrors();
        _this.deleteCaptures();
        _this.onImageFileSelected(file);
      };

      _this.onWebcamError = function () {
        _this.deleteCaptures();
      };

      _this.onScreenshot = function (canvas) {
        return (0, _canvas.canvasToBase64Images)(canvas, function (lossyBase64, base64) {
          var blob = (0, _file.base64toBlob)(base64);
          _this.handleCapture(blob, lossyBase64);
        });
      };

      _this.onImageFileSelected = function (file) {
        var imageTypes = ['jpg', 'jpeg', 'png'];
        var pdfType = ['pdf'];
        var allAcceptedTypes = [].concat(imageTypes, pdfType);

        if (!(0, _file.isOfFileType)(allAcceptedTypes, file)) {
          _this.onFileTypeError();
          return;
        }

        // The Onfido API only accepts files below 10 MB
        if (file.size > 10000000) {
          _this.onFileSizeError();
          return;
        }

        var handleFile = function handleFile(file) {
          return (0, _file.fileToBase64)(file, function (base64) {
            return _this.handleCapture(file, base64);
          }, _this.onFileGeneralError);
        };

        if ((0, _file.isOfFileType)(pdfType, file)) {
          //avoid rendering pdfs, due to inconsistencies between different browsers
          handleFile(file);
        } else if ((0, _file.isOfFileType)(imageTypes, file)) {
          (0, _file.fileToLossyBase64Image)(file, function (lossyBase64) {
            return _this.handleCapture(file, lossyBase64);
          }, function () {
            return handleFile(file);
          });
        }
      };

      _this.onFileTypeError = function () {
        return _this.setError('INVALID_TYPE');
      };

      _this.onFileSizeError = function () {
        return _this.setError('INVALID_SIZE');
      };

      _this.onFileGeneralError = function () {
        return _this.setError('INVALID_CAPTURE');
      };

      _this.onValidationServerError = function () {
        _this.deleteCaptures();
        _this.setError('SERVER_ERROR');
      };

      _this.setError = function (name) {
        return _this.setState({ error: { name: name } });
      };

      _this.deleteCaptures = function () {
        var _this$props = _this.props,
            method = _this$props.method,
            side = _this$props.side,
            deleteCaptures = _this$props.actions.deleteCaptures;

        deleteCaptures({ method: method, side: side });
      };

      _this.validateCaptures = function (payload, valid) {
        var _this$props2 = _this.props,
            actions = _this$props2.actions,
            method = _this$props2.method;

        actions.validateCapture({ id: payload.id, valid: valid, method: method });
      };

      _this.clearErrors = function () {
        _this.setState({ error: null });
      };

      _this.state = {
        uploadFallback: false,
        error: null,
        hasWebcam: undefined
      };
      return _this;
    }

    _createClass(Capture, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.webcamChecker = setInterval(this.checkWebcamSupport, 2000);
        this.checkWebcamSupport();
      }
    }, {
      key: 'componentWillUpdate',
      value: function componentWillUpdate(nextProps, nextState) {
        if (nextState.hasWebcam !== this.state.hasWebcam) {
          this.props.onWebcamSupportChange(nextState.hasWebcam);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.setState({ uploadFallback: false });
        clearInterval(this.webcamChecker);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var validCaptures = nextProps.validCaptures,
            unprocessedCaptures = nextProps.unprocessedCaptures,
            allInvalid = nextProps.allInvalid;

        if (validCaptures.length > 0) this.setState({ uploadFallback: false });
        if (unprocessedCaptures.length > 0) this.clearErrors();
        if (allInvalid) this.onFileGeneralError();
      }
    }, {
      key: 'createCapture',
      value: function createCapture(payload) {
        var _props = this.props,
            actions = _props.actions,
            method = _props.method,
            side = _props.side;

        var capture = _extends({}, payload, { side: side });
        actions.createCapture({ method: method, capture: capture, maxCaptures: this.maxAutomaticCaptures });
      }
    }, {
      key: 'validateAndProceed',
      value: function validateAndProceed(payload) {
        var nextStep = this.props.nextStep;

        var valid = true;
        this.validateCaptures(payload, valid);
        nextStep();
      }
    }, {
      key: 'handleAutocapture',
      value: function handleAutocapture(payload) {
        var _this2 = this;

        var _props2 = this.props,
            token = _props2.token,
            unprocessedCaptures = _props2.unprocessedCaptures;

        if (unprocessedCaptures.length === this.maxAutomaticCaptures) {
          console.warn('Server response is slow, waiting for responses before uploading more');
          return;
        }
        (0, _sdkBackend.postToBackend)(this.validationServicePayload(payload), token, function (response) {
          return _this2.onValidationServiceResponse(payload, response);
        }, this.onValidationServerError);
      }
    }, {
      key: 'handleCaptureFromUploader',
      value: function handleCaptureFromUploader(payload) {
        this.validateAndProceed(payload);
      }
    }, {
      key: 'createDocumentPayload',
      value: function createDocumentPayload(payload) {
        var documentType = this.props.documentType;

        var expectedDocumentType = documentType === 'poa' ? 'unknown' : documentType;
        return _extends({}, payload, { documentType: expectedDocumentType });
      }
    }, {
      key: 'createVideoPayload',
      value: function createVideoPayload(blob, challengeData) {
        var capturePayload = this.initialiseCapturePayload(blob);
        return _extends({}, capturePayload, { variant: 'video', challengeData: challengeData });
      }
    }, {
      key: 'handleDocument',
      value: function handleDocument(payload) {
        var documentPayload = this.createDocumentPayload(payload);
        this.createCapture(documentPayload);
        if (this.props.useWebcam && !this.state.uploadFallback) {
          this.handleAutocapture(documentPayload);
        } else {
          this.handleCaptureFromUploader(documentPayload);
        }
      }
    }, {
      key: 'handleFace',
      value: function handleFace(payload) {
        this.createCapture(payload);
        this.validateAndProceed(payload);
      }
    }, {
      key: 'render',
      value: function render(_ref3) {
        var useWebcam = _ref3.useWebcam,
            back = _ref3.back,
            i18n = _ref3.i18n,
            termsAccepted = _ref3.termsAccepted,
            other = _objectWithoutProperties(_ref3, ['useWebcam', 'back', 'i18n', 'termsAccepted']);

        var canUseWebcam = this.state.hasWebcam && !this.state.uploadFallback;
        var shouldUseWebcam = useWebcam && (this.props.method === 'face' || _utils.isDesktop);
        var useCapture = canUseWebcam && shouldUseWebcam;

        return  false ? (0, _preact.h)(_PrivacyStatement2.default, _extends({ i18n: i18n, back: back, acceptTerms: this.acceptTerms }, other)) : (0, _preact.h)(CaptureMode, _extends({ useCapture: useCapture, i18n: i18n,
          onScreenshot: this.onScreenshot,
          onVideoRecorded: this.onVideoRecorded,
          onUploadFallback: this.onUploadFallback,
          onImageSelected: this.onImageFileSelected,
          onFailure: this.onWebcamError,
          error: this.state.error
        }, other));
      }
    }]);

    return Capture;
  }(_preact.Component);

  Capture.defaultProps = {
    onWebcamSupportChange: function onWebcamSupportChange() {}
  };


  var CaptureMode = function CaptureMode(_ref4) {
    var method = _ref4.method,
        documentType = _ref4.documentType,
        side = _ref4.side,
        useCapture = _ref4.useCapture,
        i18n = _ref4.i18n,
        other = _objectWithoutProperties(_ref4, ['method', 'documentType', 'side', 'useCapture', 'i18n']);

    var copyNamespace = method === 'face' ? 'capture.face' : 'capture.' + documentType + '.' + side;
    var title = !useCapture && i18n.t(copyNamespace + '.upload_title') ? i18n.t(copyNamespace + '.upload_title') : i18n.t(copyNamespace + '.title');
    var instructions = i18n.t(copyNamespace + '.instructions');
    return useCapture ? (0, _preact.h)(_Camera2.default, _extends({ i18n: i18n, method: method, title: title }, other)) : (0, _preact.h)(_Uploader.Uploader, _extends({ i18n: i18n, instructions: instructions, documentType: documentType, title: title }, other));
  };

  var mapStateToProps = function mapStateToProps(state, props) {
    return { allInvalid: _core.selectors.allInvalidCaptureSelector(state, props),
      validCaptures: _core.selectors.currentValidCaptures(state, props),
      unprocessedCaptures: _core.selectors.unprocessedCaptures(state, props) };
  };

  exports.default = (0, _reactRedux.connect)(mapStateToProps)(Capture);
  module.exports = exports['default'];
});

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(3), __webpack_require__(7), __webpack_require__(6), __webpack_require__(4), __webpack_require__(0), __webpack_require__(11), __webpack_require__(439)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/object/define-property'), require('babel-runtime/core-js/object/set-prototype-of'), require('babel-runtime/core-js/object/create'), require('babel-runtime/core-js/object/get-prototype-of'), require('preact'), require('classnames'), require('./style.css'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.defineProperty, global.setPrototypeOf, global.create, global.getPrototypeOf, global.preact, global.classnames, global.style);
    global.index = mod.exports;
  }
})(this, function (module, exports, _defineProperty2, _setPrototypeOf, _create, _getPrototypeOf, _preact, _classnames, _style) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _defineProperty3 = _interopRequireDefault(_defineProperty2);

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create2 = _interopRequireDefault(_create);

  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _style2 = _interopRequireDefault(_style);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      (0, _defineProperty3.default)(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty3.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Collapsible = function (_Component) {
    _inherits(Collapsible, _Component);

    function Collapsible(props) {
      _classCallCheck(this, Collapsible);

      var _this = _possibleConstructorReturn(this, (Collapsible.__proto__ || (0, _getPrototypeOf2.default)(Collapsible)).call(this, props));

      _this.toggleExpanded = function () {
        _this.setState({ isExpanded: !_this.state.isExpanded });
      };

      _this.state = {
        isExpanded: props.defaultIsExpanded
      };
      return _this;
    }

    _createClass(Collapsible, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            className = _props.className,
            trigger = _props.trigger,
            children = _props.children;
        var isExpanded = this.state.isExpanded;

        return (0, _preact.h)(
          'div',
          { className: (0, _classnames2.default)(_style2.default.wrapper, className, _defineProperty({}, _style2.default.isExpanded, isExpanded)) },
          (0, _preact.h)(
            'div',
            { className: _style2.default.trigger, onClick: this.toggleExpanded },
            typeof trigger === 'function' ? trigger() : trigger
          ),
          isExpanded ? children : null
        );
      }
    }]);

    return Collapsible;
  }(_preact.Component);

  exports.default = Collapsible;
  module.exports = exports['default'];
});

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(3), __webpack_require__(7), __webpack_require__(6), __webpack_require__(4), __webpack_require__(0), __webpack_require__(9), __webpack_require__(15), __webpack_require__(13), __webpack_require__(440)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/object/define-property'), require('babel-runtime/core-js/object/set-prototype-of'), require('babel-runtime/core-js/object/create'), require('babel-runtime/core-js/object/get-prototype-of'), require('preact'), require('../../Tracker'), require('../Title'), require('../Theme/style.css'), require('./style.css'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.defineProperty, global.setPrototypeOf, global.create, global.getPrototypeOf, global.preact, global.Tracker, global.Title, global.style, global.style);
    global.index = mod.exports;
  }
})(this, function (module, exports, _defineProperty, _setPrototypeOf, _create, _getPrototypeOf, _preact, _Tracker, _Title, _style, _style3) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _defineProperty2 = _interopRequireDefault(_defineProperty);

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create2 = _interopRequireDefault(_create);

  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

  var _Title2 = _interopRequireDefault(_Title);

  var _style2 = _interopRequireDefault(_style);

  var _style4 = _interopRequireDefault(_style3);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty2.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Complete = function (_Component) {
    _inherits(Complete, _Component);

    function Complete() {
      _classCallCheck(this, Complete);

      return _possibleConstructorReturn(this, (Complete.__proto__ || (0, _getPrototypeOf2.default)(Complete)).apply(this, arguments));
    }

    _createClass(Complete, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.props.nextStep();
      }
    }, {
      key: 'render',
      value: function render(_ref) {
        var message = _ref.message,
            submessage = _ref.submessage,
            i18n = _ref.i18n;

        var completeMessage = message || i18n.t('complete.message');
        var completeSubmessage = submessage || i18n.t('complete.submessage');
        return (0, _preact.h)(
          'div',
          { className: _style4.default.wrapper },
          (0, _preact.h)('span', { className: _style2.default.icon + '  ' + _style4.default.icon }),
          (0, _preact.h)(_Title2.default, { title: completeMessage, subTitle: completeSubmessage })
        );
      }
    }]);

    return Complete;
  }(_preact.Component);

  exports.default = (0, _Tracker.trackComponent)(Complete);
  module.exports = exports['default'];
});

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(3), __webpack_require__(7), __webpack_require__(6), __webpack_require__(4), __webpack_require__(0), __webpack_require__(399), __webpack_require__(8), __webpack_require__(173)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/object/define-property'), require('babel-runtime/core-js/object/set-prototype-of'), require('babel-runtime/core-js/object/create'), require('babel-runtime/core-js/object/get-prototype-of'), require('preact'), require('pdfobject'), require('../utils'), require('./style.css'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.defineProperty, global.setPrototypeOf, global.create, global.getPrototypeOf, global.preact, global.pdfobject, global.utils, global.style);
    global.PdfPreview = mod.exports;
  }
})(this, function (module, exports, _defineProperty, _setPrototypeOf, _create, _getPrototypeOf, _preact, _pdfobject, _utils, _style) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _defineProperty2 = _interopRequireDefault(_defineProperty);

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create2 = _interopRequireDefault(_create);

  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

  var _pdfobject2 = _interopRequireDefault(_pdfobject);

  var _style2 = _interopRequireDefault(_style);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty2.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var IEPdfBlobLink = function IEPdfBlobLink(_ref) {
    var blob = _ref.blob;

    // Object urls created from Blobs don't work on IE11 and Edge, so we use this component as a fallback
    // Without this component PDFObject would display an error instead of the expected PDFObject link fallback.
    var downloadPDF = function downloadPDF() {
      window.navigator.msSaveOrOpenBlob(blob, 'document.pdf');
    };
    return (0, _preact.h)('a', { href: '#',
      onClick: (0, _utils.preventDefaultOnClick)(downloadPDF),
      className: _style2.default.pdfIcon
    });
  };

  var i = 0;

  var PDFPreview = function (_Component) {
    _inherits(PDFPreview, _Component);

    function PDFPreview(props) {
      _classCallCheck(this, PDFPreview);

      var _this = _possibleConstructorReturn(this, (PDFPreview.__proto__ || (0, _getPrototypeOf2.default)(PDFPreview)).call(this, props));

      _this.options = {
        width: '100%',
        height: '290px',
        'max-height': '70vh',
        border: 0,
        fallbackLink: '<a href=\'[url]\' class=' + _style2.default.pdfIcon + ' download/>'
      };

      _this.id = 'pdfContainer' + i++;
      return _this;
    }

    _createClass(PDFPreview, [{
      key: 'embedPDF',
      value: function embedPDF(previewUrl) {
        _pdfobject2.default.embed(previewUrl, '#' + this.id, this.options);
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var previewUrl = this.props.previewUrl;

        this.embedPDF(previewUrl);
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate() {
        return false;
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(_ref2) {
        var previewUrl = _ref2.previewUrl;

        if (this.props.pdfPreview !== previewUrl) this.embedPDF(previewUrl);
      }
    }, {
      key: 'render',
      value: function render() {
        return (0, _preact.h)('div', { id: this.id });
      }
    }]);

    return PDFPreview;
  }(_preact.Component);

  var PdfViewer = function (_Component2) {
    _inherits(PdfViewer, _Component2);

    function PdfViewer() {
      _classCallCheck(this, PdfViewer);

      return _possibleConstructorReturn(this, (PdfViewer.__proto__ || (0, _getPrototypeOf2.default)(PdfViewer)).apply(this, arguments));
    }

    _createClass(PdfViewer, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate() {
        return false;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            blob = _props.blob,
            previewUrl = _props.previewUrl;

        return (0, _preact.h)(
          'div',
          { className: _style2.default.image + ' ' + _style2.default.pdfImage },
          window.navigator.msSaveOrOpenBlob ? (0, _preact.h)(IEPdfBlobLink, { blob: blob }) : (0, _preact.h)(PDFPreview, { previewUrl: previewUrl })
        );
      }
    }]);

    return PdfViewer;
  }(_preact.Component);

  exports.default = PdfViewer;
  module.exports = exports['default'];
});

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(10), __webpack_require__(56), __webpack_require__(234), __webpack_require__(3), __webpack_require__(7), __webpack_require__(6), __webpack_require__(4), __webpack_require__(0), __webpack_require__(52), __webpack_require__(41), __webpack_require__(13), __webpack_require__(173), __webpack_require__(11), __webpack_require__(113), __webpack_require__(8), __webpack_require__(114), __webpack_require__(73), __webpack_require__(193), __webpack_require__(195), __webpack_require__(74), __webpack_require__(54), __webpack_require__(15), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/core-js/object/assign'), require('babel-runtime/core-js/array/includes'), require('babel-runtime/core-js/object/entries'), require('babel-runtime/core-js/object/define-property'), require('babel-runtime/core-js/object/set-prototype-of'), require('babel-runtime/core-js/object/create'), require('babel-runtime/core-js/object/get-prototype-of'), require('preact'), require('../../core'), require('react-redux'), require('../Theme/style.css'), require('./style.css'), require('classnames'), require('../utils/file'), require('../utils'), require('../utils/onfidoApi'), require('../DocumentSelector'), require('./PdfPreview'), require('../EnlargedPreview'), require('../Error'), require('../Spinner'), require('../Title'), require('../../Tracker'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.assign, global.includes, global.entries, global.defineProperty, global.setPrototypeOf, global.create, global.getPrototypeOf, global.preact, global.core, global.reactRedux, global.style, global.style, global.classnames, global.file, global.utils, global.onfidoApi, global.DocumentSelector, global.PdfPreview, global.EnlargedPreview, global.Error, global.Spinner, global.Title, global.Tracker);
    global.index = mod.exports;
  }
})(this, function (exports, _assign, _includes, _entries, _defineProperty2, _setPrototypeOf, _create, _getPrototypeOf, _preact, _core, _reactRedux, _style, _style3, _classnames, _file, _utils, _onfidoApi, _DocumentSelector, _PdfPreview, _EnlargedPreview, _Error, _Spinner, _Title, _Tracker) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.LivenessConfirm = exports.FaceConfirm = exports.DocumentBackConfirm = exports.DocumentFrontConfirm = undefined;

  var _assign2 = _interopRequireDefault(_assign);

  var _includes2 = _interopRequireDefault(_includes);

  var _entries2 = _interopRequireDefault(_entries);

  var _defineProperty3 = _interopRequireDefault(_defineProperty2);

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create2 = _interopRequireDefault(_create);

  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

  var _style2 = _interopRequireDefault(_style);

  var _style4 = _interopRequireDefault(_style3);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _PdfPreview2 = _interopRequireDefault(_PdfPreview);

  var _EnlargedPreview2 = _interopRequireDefault(_EnlargedPreview);

  var _Error2 = _interopRequireDefault(_Error);

  var _Spinner2 = _interopRequireDefault(_Spinner);

  var _Title2 = _interopRequireDefault(_Title);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _slicedToArray = function () {
    function sliceIterator(arr, i) {
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = undefined;

      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);

          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }

      return _arr;
    }

    return function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty3.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var _extends = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      (0, _defineProperty3.default)(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var CaptureViewerPure = function CaptureViewerPure(_ref) {
    var _ref$capture = _ref.capture,
        blob = _ref$capture.blob,
        base64 = _ref$capture.base64,
        previewUrl = _ref$capture.previewUrl,
        variant = _ref$capture.variant,
        isDocument = _ref.isDocument,
        i18n = _ref.i18n,
        isFullScreen = _ref.isFullScreen,
        useFullScreen = _ref.useFullScreen;
    return (0, _preact.h)(
      'div',
      { className: _style4.default.captures },
      (0, _file.isOfFileType)(['pdf'], blob) ? (0, _preact.h)(_PdfPreview2.default, { previewUrl: previewUrl, blob: blob }) : variant === 'video' ? (0, _preact.h)('video', { className: _style4.default.video, src: previewUrl, controls: true }) : (0, _preact.h)(
        'span',
        { className: (0, _classnames2.default)(_style4.default.imageWrapper, _defineProperty({}, _style4.default.fullscreenImageWrapper, isFullScreen)) },
        isDocument && (0, _preact.h)(_EnlargedPreview2.default, _extends({ i18n: i18n, useFullScreen: useFullScreen }, {
          src: blob instanceof File ? base64 : previewUrl
        })),
        (0, _preact.h)('img', { className: _style4.default.image
          //we use base64 if the capture is a File, since its base64 version is exif rotated
          //if it's not a File (just a Blob), it means it comes from the webcam,
          //so the base64 version is actually lossy and since no rotation is necessary
          //the blob is the best candidate in this case
          , src: blob instanceof File ? base64 : previewUrl
        })
      )
    );
  };

  var CaptureViewer = function (_Component) {
    _inherits(CaptureViewer, _Component);

    function CaptureViewer(props) {
      _classCallCheck(this, CaptureViewer);

      var _this = _possibleConstructorReturn(this, (CaptureViewer.__proto__ || (0, _getPrototypeOf2.default)(CaptureViewer)).call(this, props));

      _initialiseProps.call(_this);

      var blob = props.capture.blob;

      _this.state = _this.previewUrlState(blob);
      return _this;
    }

    _createClass(CaptureViewer, [{
      key: 'updateBlobPreview',
      value: function updateBlobPreview(blob) {
        this.revokePreviewURL();
        this.setState(this.previewUrlState(blob));
      }
    }, {
      key: 'revokePreviewURL',
      value: function revokePreviewURL() {
        URL.revokeObjectURL(this.state.previewUrl);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(_ref2) {
        var blob = _ref2.capture.blob;

        if (this.props.capture.blob !== blob) this.updateBlobPreview(blob);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.revokePreviewURL();
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            capture = _props.capture,
            method = _props.method,
            i18n = _props.i18n,
            useFullScreen = _props.useFullScreen,
            isFullScreen = _props.isFullScreen;

        return (0, _preact.h)(CaptureViewerPure, {
          i18n: i18n,
          useFullScreen: useFullScreen,
          isFullScreen: isFullScreen,
          isDocument: method === 'document',
          capture: _extends({}, capture, {
            previewUrl: this.state.previewUrl
          }) });
      }
    }]);

    return CaptureViewer;
  }(_preact.Component);

  var _initialiseProps = function _initialiseProps() {
    this.previewUrlState = function (blob) {
      return blob ? { previewUrl: URL.createObjectURL(blob) } : {};
    };
  };

  var RetakeAction = function RetakeAction(_ref3) {
    var retakeAction = _ref3.retakeAction,
        i18n = _ref3.i18n;
    return (0, _preact.h)(
      'button',
      { onClick: retakeAction,
        className: _style2.default.btn + ' ' + _style2.default['btn-outline'] + ' ' + _style4.default.retake },
      i18n.t('confirm.redo')
    );
  };

  var ConfirmAction = function ConfirmAction(_ref4) {
    var confirmAction = _ref4.confirmAction,
        i18n = _ref4.i18n,
        error = _ref4.error;
    return (0, _preact.h)(
      'button',
      { href: '#', className: _style2.default.btn + ' ' + _style2.default["btn-primary"],
        onClick: (0, _utils.preventDefaultOnClick)(confirmAction) },
      error.type === 'warn' ? i18n.t('confirm.continue') : i18n.t('confirm.confirm')
    );
  };

  var Actions = function Actions(_ref5) {
    var retakeAction = _ref5.retakeAction,
        confirmAction = _ref5.confirmAction,
        error = _ref5.error,
        i18n = _ref5.i18n;
    return (0, _preact.h)(
      'div',
      { className: _style4.default.actionsContainer },
      (0, _preact.h)(
        'div',
        { className: (0, _classnames2.default)(_style2.default.actions, _style4.default.actions, _defineProperty({}, _style4.default.error, error.type === 'error')) },
        (0, _preact.h)(RetakeAction, { retakeAction: retakeAction, i18n: i18n }),
        error.type === 'error' ? null : (0, _preact.h)(ConfirmAction, { confirmAction: confirmAction, i18n: i18n, error: error })
      )
    );
  };

  var Previews = function Previews(_ref6) {
    var capture = _ref6.capture,
        retakeAction = _ref6.retakeAction,
        confirmAction = _ref6.confirmAction,
        error = _ref6.error,
        method = _ref6.method,
        documentType = _ref6.documentType,
        i18n = _ref6.i18n,
        useFullScreen = _ref6.useFullScreen,
        isFullScreen = _ref6.isFullScreen;

    var title = method === 'face' ? i18n.t('confirm.face.' + capture.variant + '.title') : i18n.t('confirm.' + method + '.title');

    var subTitle = method === 'face' ? i18n.t('confirm.face.' + capture.variant + '.message') : i18n.t('confirm.' + documentType + '.message');

    return (0, _preact.h)(
      'div',
      { className: (0, _classnames2.default)(_style4.default.previewsContainer, _defineProperty({}, _style4.default.previewsContainerIsFullScreen, isFullScreen)) },
      error.type ? (0, _preact.h)(_Error2.default, { error: error, i18n: i18n, withArrow: true }) : (0, _preact.h)(_Title2.default, { title: title, subTitle: subTitle, smaller: true, className: _style4.default.title }),
      (0, _preact.h)(
        'div',
        { className: (0, _classnames2.default)(_style2.default.imageWrapper, _defineProperty({}, _style4.default.videoWrapper, capture.variant === 'video')) },
        (0, _preact.h)(CaptureViewer, { capture: capture, i18n: i18n, method: method, useFullScreen: useFullScreen, isFullScreen: isFullScreen })
      ),
      (0, _preact.h)(Actions, { retakeAction: retakeAction, confirmAction: confirmAction, i18n: i18n, error: error })
    );
  };

  var Confirm = function (_Component2) {
    _inherits(Confirm, _Component2);

    function Confirm(props) {
      _classCallCheck(this, Confirm);

      var _this2 = _possibleConstructorReturn(this, (Confirm.__proto__ || (0, _getPrototypeOf2.default)(Confirm)).call(this, props));

      _this2.onGlareWarning = function () {
        _this2.setWarning('GLARE_DETECTED');
      };

      _this2.setError = function (name) {
        return _this2.setState({ error: { name: name, type: 'error' } });
      };

      _this2.setWarning = function (name) {
        return _this2.setState({ error: { name: name, type: 'warn' } });
      };

      _this2.onfidoErrorFieldMap = function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
            key = _ref8[0],
            val = _ref8[1];

        if (key === 'document_detection') return 'INVALID_CAPTURE';
        // on corrupted PDF or other unsupported file types
        if (key === 'file') return 'INVALID_TYPE';
        // hit on PDF/invalid file type submission for face detection
        if (key === 'attachment' || key === 'attachment_content_type') return 'UNSUPPORTED_FILE';
        if (key === 'face_detection') {
          return val[0].indexOf('Multiple faces') === -1 ? 'NO_FACE_ERROR' : 'MULTIPLE_FACES_ERROR';
        }
      };

      _this2.onfidoErrorReduce = function (_ref9) {
        var fields = _ref9.fields;

        var _Object$entries$map = (0, _entries2.default)(fields).map(_this2.onfidoErrorFieldMap),
            _Object$entries$map2 = _slicedToArray(_Object$entries$map, 1),
            first = _Object$entries$map2[0];

        return first;
      };

      _this2.onApiError = function (_ref10) {
        var status = _ref10.status,
            response = _ref10.response;

        var errorKey = void 0;
        if (_this2.props.mobileFlow && status === 401) {
          return _this2.props.crossDeviceClientError();
        } else if (status === 422) {
          errorKey = _this2.onfidoErrorReduce(response.error);
        } else {
          (0, _Tracker.sendError)(status + ' - ' + response);
          errorKey = 'SERVER_ERROR';
        }

        _this2.setState({ uploadInProgress: false });
        _this2.setError(errorKey);
      };

      _this2.onApiSuccess = function (apiResponse) {
        var duration = Math.round(performance.now() - _this2.startTime);
        (0, _Tracker.sendEvent)('Completed upload', { duration: duration, method: _this2.props.method });
        _this2.setState({ onfidoId: apiResponse.id });
        var warnings = apiResponse.sdk_warnings;
        if (warnings && !warnings.detect_glare.valid) {
          _this2.setState({ uploadInProgress: false });
          _this2.onGlareWarning();
        } else {
          _this2.props.nextStep();
        }
      };

      _this2.uploadCaptureToOnfido = function () {
        var _this2$props = _this2.props,
            validCaptures = _this2$props.validCaptures,
            method = _this2$props.method,
            side = _this2$props.side,
            token = _this2$props.token,
            documentType = _this2$props.documentType;

        _this2.startTime = performance.now();
        (0, _Tracker.sendEvent)('Starting upload', { method: method });
        _this2.setState({ uploadInProgress: true });
        var _validCaptures$ = validCaptures[0],
            blob = _validCaptures$.blob,
            type = _validCaptures$.documentType,
            id = _validCaptures$.id,
            variant = _validCaptures$.variant,
            challengeData = _validCaptures$.challengeData;

        _this2.setState({ captureId: id });

        if (method === 'document') {
          var isPoA = (0, _includes2.default)(_DocumentSelector.poaDocumentTypes, documentType);
          var shouldDetectGlare = !(0, _file.isOfFileType)(['pdf'], blob) && !isPoA;
          var shouldDetectDocument = !isPoA;
          var validations = _extends({}, shouldDetectDocument ? { 'detect_document': 'error' } : {}, shouldDetectGlare ? { 'detect_glare': 'warn' } : {});
          var data = { file: blob, type: type, side: side, validations: validations };
          (0, _onfidoApi.uploadDocument)(data, token, _this2.onApiSuccess, _this2.onApiError);
        } else if (method === 'face') {
          if (variant === 'video') {
            var _data = { challengeData: challengeData, blob: blob, language: _this2.props.i18n.currentLocale };
            (0, _onfidoApi.uploadLiveVideo)(_data, token, _this2.onApiSuccess, _this2.onApiError);
          } else {
            var _data2 = { file: blob };
            (0, _onfidoApi.uploadLivePhoto)(_data2, token, _this2.onApiSuccess, _this2.onApiError);
          }
        }
      };

      _this2.onConfirm = function () {
        _this2.state.error.type === 'warn' ? _this2.props.nextStep() : _this2.uploadCaptureToOnfido();
      };

      _this2.render = function (_ref11) {
        var validCaptures = _ref11.validCaptures,
            previousStep = _ref11.previousStep,
            method = _ref11.method,
            documentType = _ref11.documentType,
            i18n = _ref11.i18n,
            useFullScreen = _ref11.useFullScreen,
            isFullScreen = _ref11.isFullScreen;
        return _this2.state.uploadInProgress ? (0, _preact.h)(_Spinner2.default, null) : (0, _preact.h)(Previews, _extends({ i18n: i18n, useFullScreen: useFullScreen, isFullScreen: isFullScreen }, {
          capture: validCaptures[0],
          retakeAction: function retakeAction() {
            previousStep();
          },
          confirmAction: _this2.onConfirm,
          error: _this2.state.error,
          method: method,
          documentType: documentType
        }));
      };

      _this2.state = {
        uploadInProgress: false,
        error: {},
        captureId: null,
        onfidoId: null
      };
      return _this2;
    }

    return Confirm;
  }(_preact.Component);

  var mapStateToProps = function mapStateToProps(state, props) {
    return {
      validCaptures: _core.selectors.currentValidCaptures(state, props),
      unprocessedCaptures: _core.selectors.unprocessedCaptures(state, props)
    };
  };

  var TrackedConfirmComponent = (0, _Tracker.trackComponentAndMode)(Confirm, 'confirmation', 'error');

  var MapConfirm = (0, _reactRedux.connect)(mapStateToProps)(TrackedConfirmComponent);

  var DocumentFrontWrapper = function DocumentFrontWrapper(props) {
    return (0, _preact.h)(MapConfirm, _extends({}, props, { method: 'document', side: 'front' }));
  };

  var DocumentBackWrapper = function DocumentBackWrapper(props) {
    return (0, _preact.h)(MapConfirm, _extends({}, props, { method: 'document', side: 'back' }));
  };

  var BaseFaceConfirm = function BaseFaceConfirm(props) {
    return (0, _preact.h)(MapConfirm, _extends({}, props, { method: 'face' }));
  };

  var DocumentFrontConfirm = (0, _Tracker.appendToTracking)(DocumentFrontWrapper, 'front');
  var DocumentBackConfirm = (0, _Tracker.appendToTracking)(DocumentBackWrapper, 'back');
  var FaceConfirm = (0, _Tracker.appendToTracking)(BaseFaceConfirm, 'selfie');
  var LivenessConfirm = (0, _Tracker.appendToTracking)(BaseFaceConfirm, 'video');

  exports.DocumentFrontConfirm = DocumentFrontConfirm;
  exports.DocumentBackConfirm = DocumentBackConfirm;
  exports.FaceConfirm = FaceConfirm;
  exports.LivenessConfirm = LivenessConfirm;
});

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(3), __webpack_require__(7), __webpack_require__(6), __webpack_require__(4), __webpack_require__(5), __webpack_require__(0), __webpack_require__(11), __webpack_require__(443), __webpack_require__(13), __webpack_require__(200)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/object/define-property'), require('babel-runtime/core-js/object/set-prototype-of'), require('babel-runtime/core-js/object/create'), require('babel-runtime/core-js/object/get-prototype-of'), require('react'), require('preact'), require('classnames'), require('./style.css'), require('../Theme/style.css'), require('../Pannable'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.defineProperty, global.setPrototypeOf, global.create, global.getPrototypeOf, global.react, global.preact, global.classnames, global.style, global.style, global.Pannable);
    global.index = mod.exports;
  }
})(this, function (module, exports, _defineProperty2, _setPrototypeOf, _create, _getPrototypeOf, _react, _preact, _classnames, _style, _style3, _Pannable) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _defineProperty3 = _interopRequireDefault(_defineProperty2);

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create2 = _interopRequireDefault(_create);

  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

  var React = _interopRequireWildcard(_react);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _style2 = _interopRequireDefault(_style);

  var _style4 = _interopRequireDefault(_style3);

  var _Pannable2 = _interopRequireDefault(_Pannable);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      (0, _defineProperty3.default)(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty3.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var EnlargedPreview = function (_Component) {
    _inherits(EnlargedPreview, _Component);

    function EnlargedPreview() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, EnlargedPreview);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EnlargedPreview.__proto__ || (0, _getPrototypeOf2.default)(EnlargedPreview)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        isExpanded: false,
        hasEntered: false
      }, _this.handleImageLoad = function () {
        if (_this.container) {
          _this.container.center();
        }
      }, _this.toggle = function () {
        return _this.setState({
          isExpanded: !_this.state.isExpanded,
          hasEntered: false
        }, function () {
          return _this.setState({ hasEntered: true });
        });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(EnlargedPreview, [{
      key: 'componentWillUpdate',
      value: function componentWillUpdate(nextProps, nextState) {
        if (nextState.isExpanded !== this.state.isExpanded) {
          this.props.useFullScreen(nextState.isExpanded);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _classNames,
            _this2 = this;

        var _state = this.state,
            isExpanded = _state.isExpanded,
            hasEntered = _state.hasEntered;
        var _props = this.props,
            i18n = _props.i18n,
            src = _props.src;

        return (0, _preact.h)(
          'div',
          {
            className: (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, _style2.default.expanded, isExpanded), _defineProperty(_classNames, _style2.default.entered, hasEntered), _classNames))
          },
          isExpanded && (0, _preact.h)(
            _Pannable2.default,
            {
              ref: function ref(node) {
                return _this2.container = node;
              },
              className: _style2.default.imageContainer
            },
            (0, _preact.h)('img', { onLoad: this.handleImageLoad, className: _style2.default.image, src: src })
          ),
          (0, _preact.h)(
            'button',
            {
              className: (0, _classnames2.default)(_style4.default.btn, _style4.default['btn-alternative'], _style2.default.button),
              onClick: this.toggle },
            isExpanded ? i18n.t('confirm.enlarge_image.close') : i18n.t('confirm.enlarge_image.enlarge')
          )
        );
      }
    }]);

    return EnlargedPreview;
  }(_preact.Component);

  exports.default = EnlargedPreview;
  module.exports = exports['default'];
});

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(5), __webpack_require__(0), __webpack_require__(11), __webpack_require__(174), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('react'), require('preact'), require('classnames'), require('./style.css'), require('../utils'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.react, global.preact, global.classnames, global.style, global.utils);
    global.Challenge = mod.exports;
  }
})(this, function (module, exports, _react, _preact, _classnames, _style, _utils) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var React = _interopRequireWildcard(_react);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _style2 = _interopRequireDefault(_style);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  var ChallengeContainer = function ChallengeContainer(_ref) {
    var title = _ref.title,
        renderInstructions = _ref.renderInstructions;
    return (0, _preact.h)(
      'div',
      { className: _style2.default.challenge },
      (0, _preact.h)(
        'div',
        { className: _style2.default.challengeTitle },
        title
      ),
      (0, _preact.h)(
        'div',
        { className: _style2.default.challengeDescription },
        renderInstructions()
      )
    );
  };


  var Recite = function Recite(_ref2) {
    var i18n = _ref2.i18n,
        digits = _ref2.query;
    return (0, _preact.h)(ChallengeContainer, {
      title: i18n.t('capture.liveness.challenges.recite'),
      renderInstructions: function renderInstructions() {
        return (0, _preact.h)(
          'span',
          { className: _style2.default.recite },
          digits.join(' \u2013 ')
        );
      }
    });
  };

  var Movement = function Movement(_ref3) {
    var i18n = _ref3.i18n,
        _ref3$query = _ref3.query,
        query = _ref3$query === undefined ? '' : _ref3$query;

    var side = query.replace('turn', '').toLowerCase();
    return (0, _preact.h)(ChallengeContainer, {
      title: i18n.t('capture.liveness.challenges.movement', {
        side: i18n.t('capture.liveness.challenges.' + side)
      }),
      renderInstructions: function renderInstructions() {
        return (0, _preact.h)('span', { className: (0, _classnames2.default)(_style2.default.movement, _style2.default['movement-' + query]) });
      }
    });
  };

  var Challenge = function Challenge(props) {
    return (0, _utils.functionalSwitch)(props.type, {
      recite: function recite() {
        return (0, _preact.h)(Recite, props);
      },
      movement: function movement() {
        return (0, _preact.h)(Movement, props);
      }
    });
  };

  exports.default = Challenge;
  module.exports = exports['default'];
});

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(5), __webpack_require__(0), __webpack_require__(11), __webpack_require__(174), __webpack_require__(13), __webpack_require__(15), __webpack_require__(8), __webpack_require__(42), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('react'), require('preact'), require('classnames'), require('./style.css'), require('../Theme/style.css'), require('../Title'), require('../utils'), require('../../locales'), require('../../Tracker'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.react, global.preact, global.classnames, global.style, global.style, global.Title, global.utils, global.locales, global.Tracker);
    global.Intro = mod.exports;
  }
})(this, function (module, exports, _react, _preact, _classnames, _style, _style3, _Title, _utils, _locales, _Tracker) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var React = _interopRequireWildcard(_react);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _style2 = _interopRequireDefault(_style);

  var _style4 = _interopRequireDefault(_style3);

  var _Title2 = _interopRequireDefault(_Title);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  var Intro = function Intro(_ref) {
    var i18n = _ref.i18n,
        nextStep = _ref.nextStep;
    return (0, _preact.h)(
      'div',
      { className: _style4.default.fullHeightContainer },
      (0, _preact.h)(_Title2.default, { title: i18n.t('capture.liveness.intro.title') }),
      (0, _preact.h)(
        'div',
        { className: (0, _classnames2.default)(_style4.default.thickWrapper, _style2.default.introCopy) },
        (0, _preact.h)(
          'ul',
          { className: _style2.default.introBullets },
          ['two_actions', 'speak_out_loud'].map(function (key) {
            return (0, _preact.h)(
              'li',
              { key: key, className: _style2.default.introBullet },
              (0, _preact.h)('span', { className: (0, _classnames2.default)(_style2.default.introIcon, _style2.default[key + 'Icon']) }),
              (0, _locales.parseI18nWithXmlTags)(i18n, 'capture.liveness.intro.' + key, function (_ref2) {
                var text = _ref2.text;
                return (0, _preact.h)(
                  'span',
                  { className: _style2.default.bolder },
                  text
                );
              })
            );
          })
        )
      ),
      (0, _preact.h)(
        'div',
        { className: _style4.default.thickWrapper },
        (0, _preact.h)(
          'button',
          {
            className: (0, _classnames2.default)(_style4.default.btn, _style4.default['btn-primary'], _style4.default['btn-centered']),
            onClick: (0, _utils.preventDefaultOnClick)(nextStep) },
          i18n.t('capture.liveness.intro.continue')
        )
      )
    );
  };
  exports.default = (0, _Tracker.trackComponent)(Intro, 'video_intro');
  module.exports = exports['default'];
});

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(10), __webpack_require__(3), __webpack_require__(7), __webpack_require__(6), __webpack_require__(4), __webpack_require__(5), __webpack_require__(0), __webpack_require__(54), __webpack_require__(186), __webpack_require__(114), __webpack_require__(8), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/object/assign'), require('babel-runtime/core-js/object/define-property'), require('babel-runtime/core-js/object/set-prototype-of'), require('babel-runtime/core-js/object/create'), require('babel-runtime/core-js/object/get-prototype-of'), require('react'), require('preact'), require('../Spinner'), require('../Camera/LivenessCamera'), require('../utils/onfidoApi'), require('../utils'), require('../../Tracker'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.assign, global.defineProperty, global.setPrototypeOf, global.create, global.getPrototypeOf, global.react, global.preact, global.Spinner, global.LivenessCamera, global.onfidoApi, global.utils, global.Tracker);
    global.index = mod.exports;
  }
})(this, function (module, exports, _assign, _defineProperty, _setPrototypeOf, _create, _getPrototypeOf, _react, _preact, _Spinner, _LivenessCamera, _onfidoApi, _utils, _Tracker) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _assign2 = _interopRequireDefault(_assign);

  var _defineProperty2 = _interopRequireDefault(_defineProperty);

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create2 = _interopRequireDefault(_create);

  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

  var React = _interopRequireWildcard(_react);

  var _Spinner2 = _interopRequireDefault(_Spinner);

  var _LivenessCamera2 = _interopRequireDefault(_LivenessCamera);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty2.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var serverError = { name: 'SERVER_ERROR', type: 'error' };

  var initialState = {
    id: '',
    challenges: [],
    hasLoaded: false,
    hasError: false,
    startedAt: 0
  };

  var Liveness = function (_Component) {
    _inherits(Liveness, _Component);

    function Liveness() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Liveness);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Liveness.__proto__ || (0, _getPrototypeOf2.default)(Liveness)).call.apply(_ref, [this].concat(args))), _this), _this.state = _extends({}, initialState), _this.loadChallenges = function () {
        _this.setState(_extends({}, initialState), function () {
          return (0, _onfidoApi.requestChallenges)(_this.props.token, _this.handleResponse, _this.handleError);
        });
        _this.setState(_extends({}, initialState));
      }, _this.handleResponse = function (response) {
        var _response$data = response.data,
            challenge = _response$data.challenge,
            id = _response$data.id;

        _this.setState({ challenges: challenge, id: id, hasLoaded: true });
      }, _this.handleError = function () {
        _this.setState({ hasLoaded: true, hasError: true });
      }, _this.handleChallengeSwitch = function () {
        if (_this.state.startedAt) {
          _this.setState({ switchSeconds: (0, _utils.currentMilliseconds)() - _this.state.startedAt });
          (0, _Tracker.sendScreen)(['face_video_capture_step_2']);
        }
      }, _this.handleVideoRecordingStart = function () {
        _this.setState({ startedAt: (0, _utils.currentMilliseconds)() });
        (0, _Tracker.sendScreen)(['face_video_capture_step_1']);
      }, _this.handleVideoRecorded = function (blob) {
        var _this$state = _this.state,
            challenges = _this$state.challenges,
            id = _this$state.id,
            switchSeconds = _this$state.switchSeconds;

        _this.props.onVideoRecorded(blob, {
          challenges: challenges, id: id, switchSeconds: switchSeconds
        });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Liveness, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.loadChallenges();
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            hasLoaded = _state.hasLoaded,
            hasError = _state.hasError,
            challenges = _state.challenges;


        return (0, _preact.h)(
          'div',
          null,
          hasLoaded ? (0, _preact.h)(_LivenessCamera2.default, _extends({}, this.props, {
            hasError: hasError,
            cameraError: hasError ? serverError : undefined,
            challenges: challenges,
            onVideoRecorded: this.handleVideoRecorded,
            onVideoRecordingStart: this.handleVideoRecordingStart,
            onSwitchChallenge: this.handleChallengeSwitch,
            onRedo: this.loadChallenges
          })) : (0, _preact.h)(_Spinner2.default, null)
        );
      }
    }]);

    return Liveness;
  }(_preact.Component);

  exports.default = Liveness;
  module.exports = exports['default'];
});

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(3), __webpack_require__(0), __webpack_require__(11), __webpack_require__(8), __webpack_require__(447)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/core-js/object/define-property'), require('preact'), require('classnames'), require('../utils'), require('./style.css'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.preact, global.classnames, global.utils, global.style);
    global.index = mod.exports;
  }
})(this, function (exports, _defineProperty2, _preact, _classnames, _utils, _style) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Overlay = undefined;

  var _defineProperty3 = _interopRequireDefault(_defineProperty2);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _style2 = _interopRequireDefault(_style);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      (0, _defineProperty3.default)(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var Overlay = exports.Overlay = function Overlay(_ref) {
    var method = _ref.method,
        isFullScreen = _ref.isFullScreen,
        isWithoutHole = _ref.isWithoutHole;
    return (0, _utils.functionalSwitch)(method, {
      document: function document() {
        return (0, _preact.h)(DocumentOverlay, null);
      },
      face: function face() {
        var _classNames;

        return (0, _preact.h)(
          'div',
          { className: (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, _style2.default.fullScreenOverlay, isFullScreen), _defineProperty(_classNames, _style2.default.isWithoutHole, isWithoutHole), _classNames)) },
          (0, _preact.h)(FaceOverlay, null)
        );
      }
    });
  };

  var FaceOverlay = function FaceOverlay() {
    return (0, _preact.h)('span', { className: _style2.default.face });
  };

  var DocumentOverlay = function DocumentOverlay() {
    return (0, _preact.h)('span', { className: _style2.default.rectangle });
  };
});

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(3), __webpack_require__(7), __webpack_require__(6), __webpack_require__(4), __webpack_require__(5), __webpack_require__(0), __webpack_require__(11), __webpack_require__(448)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/object/define-property'), require('babel-runtime/core-js/object/set-prototype-of'), require('babel-runtime/core-js/object/create'), require('babel-runtime/core-js/object/get-prototype-of'), require('react'), require('preact'), require('classnames'), require('./style.css'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.defineProperty, global.setPrototypeOf, global.create, global.getPrototypeOf, global.react, global.preact, global.classnames, global.style);
    global.index = mod.exports;
  }
})(this, function (module, exports, _defineProperty, _setPrototypeOf, _create, _getPrototypeOf, _react, _preact, _classnames, _style) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _defineProperty2 = _interopRequireDefault(_defineProperty);

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create2 = _interopRequireDefault(_create);

  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

  var React = _interopRequireWildcard(_react);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _style2 = _interopRequireDefault(_style);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty2.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Pannable = function (_Component) {
    _inherits(Pannable, _Component);

    function Pannable() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Pannable);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Pannable.__proto__ || (0, _getPrototypeOf2.default)(Pannable)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        clientX: 0,
        clientY: 0
      }, _this.handleTouchStart = function (ev) {
        if (ev.touches.length === 1) {
          var _ev$touches$ = ev.touches[0],
              _clientX = _ev$touches$.clientX,
              _clientY = _ev$touches$.clientY;

          _this.setState({ clientX: _clientX, clientY: _clientY });
        }
      }, _this.handleTouchMove = function (ev) {
        ev.preventDefault();
        if (ev.touches.length === 1) {
          var _ev$touches$2 = ev.touches[0],
              _clientX2 = _ev$touches$2.clientX,
              _clientY2 = _ev$touches$2.clientY;

          _this.handlePan(_this.state.clientX - _clientX2, _this.state.clientY - _clientY2);
          _this.setState({ clientX: _clientX2, clientY: _clientY2 });
        }
      }, _this.handlePan = function (deltaX, deltaY) {
        if (_this.container) {
          _this.container.scrollLeft += deltaX;
          _this.container.scrollTop += deltaY;
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Pannable, [{
      key: 'center',
      value: function center() {
        if (this.container) {
          var _container = this.container,
              clientWidth = _container.clientWidth,
              scrollWidth = _container.scrollWidth,
              clientHeight = _container.clientHeight,
              scrollHeight = _container.scrollHeight;

          this.container.scrollLeft = (scrollWidth - clientWidth) / 2;
          this.container.scrollTop = (scrollHeight - clientHeight) / 2;
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            children = _props.children,
            className = _props.className;


        return (0, _preact.h)(
          'div',
          {
            ref: function ref(node) {
              return _this2.container = node;
            },
            className: (0, _classnames2.default)(_style2.default.container, className),
            onTouchStart: this.handleTouchStart,
            onTouchMove: this.handleTouchMove
          },
          children
        );
      }
    }]);

    return Pannable;
  }(_preact.Component);

  exports.default = Pannable;
  module.exports = exports['default'];
});

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(7), __webpack_require__(6), __webpack_require__(4), __webpack_require__(0), __webpack_require__(175), __webpack_require__(356)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/object/set-prototype-of'), require('babel-runtime/core-js/object/create'), require('babel-runtime/core-js/object/get-prototype-of'), require('preact'), require('./style.css'), require('es6-promise/auto'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.setPrototypeOf, global.create, global.getPrototypeOf, global.preact, global.style, global.auto);
    global.Lazy = mod.exports;
  }
})(this, function (module, exports, _setPrototypeOf, _create, _getPrototypeOf, _preact, _style) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create2 = _interopRequireDefault(_create);

  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

  var _style2 = _interopRequireDefault(_style);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Loading = function Loading(props) {
    return (0, _preact.h)(
      'div',
      { className: _style2.default.loading },
      props.i18n.t('cross_device.loading')
    );
  };

  var PhoneNumberInputLazy = function (_Component) {
    _inherits(PhoneNumberInputLazy, _Component);

    function PhoneNumberInputLazy(props) {
      _classCallCheck(this, PhoneNumberInputLazy);

      var _this = _possibleConstructorReturn(this, (PhoneNumberInputLazy.__proto__ || (0, _getPrototypeOf2.default)(PhoneNumberInputLazy)).call(this, props));

      _initialiseProps.call(_this);

      _this.state = { component: Loading
        // This is the first step toward the implementation of code splitting and lazy loading for the cross device feature
        // For now we are only separating the mobile number validation from the main bundle
        // but we are aiming to extract the cross device feature into
        // a separate bundle that can be lazy loaded on demand, to avoid bloating the loading time of the browser page

      };new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 202)).then(function (component) {
        _this.setState({ component: component });
      }).catch(function () {
        return props.i18n.t('errors.lazy_loading.message');
      });
      return _this;
    }

    return PhoneNumberInputLazy;
  }(_preact.Component);

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.render = function (props) {
      return (0, _preact.h)(_this2.state.component, props);
    };
  };

  exports.default = PhoneNumberInputLazy;
  module.exports = exports['default'];
});

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(0), __webpack_require__(414), __webpack_require__(11), __webpack_require__(175), __webpack_require__(464), __webpack_require__(465)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('preact'), require('react-phone-number-input'), require('classnames'), require('./style.css'), require('react-phone-number-input/rrui.css'), require('react-phone-number-input/style.css'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.preact, global.reactPhoneNumberInput, global.classnames, global.style, global.rrui, global.style);
    global.index = mod.exports;
  }
})(this, function (module, exports, _preact, _reactPhoneNumberInput, _classnames, _style) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactPhoneNumberInput2 = _interopRequireDefault(_reactPhoneNumberInput);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _style2 = _interopRequireDefault(_style);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var FlagComponent = function FlagComponent(_ref) {
    var countryCode = _ref.countryCode,
        flagsPath = _ref.flagsPath;
    return (0, _preact.h)('span', {
      className: (0, _classnames2.default)('react-phone-number-input__icon', _style2.default.flagIcon),
      style: {
        'background-image': 'url(' + flagsPath + countryCode.toLowerCase() + '.svg)'
      }
    });
  };

  var PhoneNumberInput = function PhoneNumberInput(_ref2) {
    var i18n = _ref2.i18n,
        clearErrors = _ref2.clearErrors,
        _ref2$actions = _ref2.actions,
        actions = _ref2$actions === undefined ? {} : _ref2$actions;


    var onChange = function onChange(number) {
      clearErrors();
      var valid = (0, _reactPhoneNumberInput.isValidPhoneNumber)(number);
      actions.setMobileNumber({ number: number, valid: valid });
    };

    return (0, _preact.h)(
      'form',
      { onSubmit: function onSubmit(e) {
          return e.preventDefault();
        } },
      (0, _preact.h)(_reactPhoneNumberInput2.default, { placeholder: i18n.t('cross_device.phone_number_placeholder'),
        onChange: onChange,
        country: 'GB',
        inputClassName: '' + _style2.default.mobileInput,
        className: '' + _style2.default.phoneNumberContainer,
        flagComponent: FlagComponent
      })
    );
  };

  exports.default = PhoneNumberInput;
  module.exports = exports['default'];
});

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(3), __webpack_require__(7), __webpack_require__(6), __webpack_require__(4), __webpack_require__(0), __webpack_require__(13), __webpack_require__(449), __webpack_require__(15), __webpack_require__(8), __webpack_require__(9), __webpack_require__(42)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/object/define-property'), require('babel-runtime/core-js/object/set-prototype-of'), require('babel-runtime/core-js/object/create'), require('babel-runtime/core-js/object/get-prototype-of'), require('preact'), require('../Theme/style.css'), require('./style.css'), require('../Title'), require('../utils'), require('../../Tracker'), require('../../locales'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.defineProperty, global.setPrototypeOf, global.create, global.getPrototypeOf, global.preact, global.style, global.style, global.Title, global.utils, global.Tracker, global.locales);
    global.index = mod.exports;
  }
})(this, function (module, exports, _defineProperty, _setPrototypeOf, _create, _getPrototypeOf, _preact, _style, _style3, _Title, _utils, _Tracker, _locales) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _defineProperty2 = _interopRequireDefault(_defineProperty);

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create2 = _interopRequireDefault(_create);

  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

  var _style2 = _interopRequireDefault(_style);

  var _style4 = _interopRequireDefault(_style3);

  var _Title2 = _interopRequireDefault(_Title);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty2.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var externalUrls = {
    terms: "https://onfido.com/termsofuse",
    privacy: "https://onfido.com/privacy"
  };

  var PrivacyStatement = function (_Component) {
    _inherits(PrivacyStatement, _Component);

    function PrivacyStatement() {
      _classCallCheck(this, PrivacyStatement);

      return _possibleConstructorReturn(this, (PrivacyStatement.__proto__ || (0, _getPrototypeOf2.default)(PrivacyStatement)).apply(this, arguments));
    }

    _createClass(PrivacyStatement, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        (0, _Tracker.sendScreen)(['privacy']);
      }
    }, {
      key: 'render',
      value: function render(_ref) {
        var i18n = _ref.i18n,
            back = _ref.back,
            acceptTerms = _ref.acceptTerms;

        var title = i18n.t('privacy.title');
        return (0, _preact.h)(
          'div',
          { className: _style4.default.privacy },
          (0, _preact.h)(_Title2.default, { title: title }),
          (0, _preact.h)(
            'div',
            { className: _style2.default.thickWrapper + ' ' + _style4.default.content },
            (0, _preact.h)(
              'ul',
              { className: _style4.default.list },
              (0, _preact.h)(
                'li',
                { className: _style4.default.item },
                i18n.t('privacy.item_1')
              ),
              (0, _preact.h)(
                'li',
                { className: _style4.default.item },
                i18n.t('privacy.item_2')
              ),
              (0, _preact.h)(
                'li',
                { className: _style4.default.item },
                i18n.t('privacy.item_3')
              )
            ),
            (0, _preact.h)(
              'div',
              null,
              (0, _preact.h)(
                'div',
                { className: _style4.default.smallPrint },
                (0, _locales.parseI18nWithXmlTags)(i18n, 'privacy.small_print', function (tagElement) {
                  return (0, _preact.h)(
                    'a',
                    { href: externalUrls[tagElement.type], target: '_blank' },
                    tagElement.text
                  );
                })
              ),
              (0, _preact.h)(
                'div',
                { className: _style4.default.actions },
                (0, _preact.h)(
                  'button',
                  { onClick: (0, _utils.preventDefaultOnClick)(back),
                    className: _style2.default.btn + ' ' + _style4.default.decline },
                  i18n.t('privacy.decline')
                ),
                (0, _preact.h)(
                  'button',
                  { href: '#', className: _style2.default.btn + ' ' + _style2.default["btn-primary"] + ' ' + _style4.default.primary,
                    onClick: (0, _utils.preventDefaultOnClick)(acceptTerms) },
                  i18n.t('privacy.continue')
                )
              )
            )
          )
        );
      }
    }]);

    return PrivacyStatement;
  }(_preact.Component);

  exports.default = PrivacyStatement;
  module.exports = exports['default'];
});

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(0), __webpack_require__(176)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('preact'), require('./style.css'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.preact, global.style);
    global.graphic = mod.exports;
  }
})(this, function (module, exports, _preact, _style) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _style2 = _interopRequireDefault(_style);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = function () {
    return (0, _preact.h)(
      'svg',
      { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 272 217', preserveAspectRatio: 'xMidYMin meet', className: _style2.default.docImage },
      (0, _preact.h)(
        'text',
        { transform: 'translate(0 59)', className: _style2.default.label },
        'Full name'
      ),
      (0, _preact.h)(
        'text',
        { transform: 'translate(0 90)', className: _style2.default.label },
        'Current'
      ),
      (0, _preact.h)(
        'text',
        { transform: 'translate(0 110)', className: _style2.default.label },
        'Address'
      ),
      (0, _preact.h)(
        'text',
        { transform: 'translate(0 141)', className: _style2.default.label },
        'Issue date or'
      ),
      (0, _preact.h)('text', { transform: 'translate(84.314 141)', className: _style2.default.label }),
      (0, _preact.h)(
        'text',
        { transform: 'translate(0 161)', className: _style2.default.label },
        'Summary dates'
      ),
      (0, _preact.h)(
        'text',
        { transform: 'translate(0 28)', className: _style2.default.label },
        'Logo'
      ),
      (0, _preact.h)(
        'g',
        { transform: 'translate(119)' },
        (0, _preact.h)('path', { fill: '#2C3E4F', d: 'M8 0h122.79c1.985.002 3.9.744 5.37 2.08l8.65 7.84c.092.084.182.171.27.26l5.57 5.56A8 8 0 0 1 153 21.4V209a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8a8 8 0 0 1 8-8z' }),
        (0, _preact.h)('path', { fill: '#FFF', d: 'M8.03 4.02h126.2a4.002 4.002 0 0 1 2.83 1.17L147.8 15.9a4.005 4.005 0 0 1 1.171 2.83v190.241a4 4 0 0 1-4 4H8.03a4 4 0 0 1-4-4V8.02a4 4 0 0 1 4-4z' }),
        (0, _preact.h)('path', { fill: '#2C3E4F', d: 'M135.189 2.95L142 9c.034.029.068.059.1.09l7.521 7.6a2 2 0 0 1-1.42 3.4H133.85a2 2 0 0 1-2-2V4.45a2 2 0 0 1 3.33-1.5h.009z' }),
        (0, _preact.h)('path', { fill: '#F3F3F4', d: 'M101.66 63.29h30.21a1 1 0 0 1 1 1v2.02a1 1 0 0 1-1 1h-30.21a1 1 0 0 1-1-1v-2.02a1 1 0 0 1 1-1z' }),
        (0, _preact.h)('path', { fill: '#D8DADC', d: 'M101.66 51.24h38.26a1 1 0 0 1 1 1v6.04a1 1 0 0 1-1 1h-38.26a1 1 0 0 1-1-1v-6.04a1 1 0 0 1 1-1zM13.08 99.46h90.609a1 1 0 0 1 1 1v6.04a1 1 0 0 1-1 1H13.08a1 1 0 0 1-1-1v-6.04a1 1 0 0 1 1-1z' }),
        (0, _preact.h)('path', { fill: '#F3F3F4', 'fill-opacity': '.5', d: 'M13.08 111.51h130.87a1 1 0 0 1 1 1v71.34a1 1 0 0 1-1 1H13.08a1 1 0 0 1-1-1v-71.34a1 1 0 0 1 1-1z' }),
        (0, _preact.h)('path', { fill: '#D8DADC', d: 'M41.6 79.37v7.03c0 .55-.399 1-.92 1H13c-.5 0-.92-.45-.92-1V64.3c0-.56.41-1 .92-1h42.45c.5 0 .92.44.92 1v14.06c0 .56-.41 1-.92 1H41.6v.01zM13.08 51.24h66.449a1 1 0 0 1 1 1v6.04a1 1 0 0 1-1 1H13.08a1 1 0 0 1-1-1v-6.04a1 1 0 0 1 1-1z' }),
        (0, _preact.h)('ellipse', { fill: '#D8DADC', cx: '28.18', cy: '28.13', rx: '16.11', ry: '16.07' })
      ),
      (0, _preact.h)('path', { fill: '#8B9094', d: 'M36.5 23h102a.5.5 0 0 1 0 1h-102a.5.5 0 0 1 0-1zM68.5 54h70a.5.5 0 0 1 0 1h-70a.5.5 0 0 1 0-1zM55.5 84h83a.5.5 0 0 1 0 1h-83a.5.5 0 0 1 0-1z' }),
      (0, _preact.h)(
        'g',
        { fill: '#8B9094' },
        (0, _preact.h)('path', { d: 'M89.5 136h142c.275 0 .5.225.5.5s-.225.5-.5.5h-142a.5.5 0 0 1 0-1z' }),
        (0, _preact.h)('path', { d: 'M139.5 102a.5.5 0 0 1 .5.5v34a.5.5 0 0 1-1 0v-34a.5.5 0 0 1 .5-.5zM231.5 56a.5.5 0 0 1 .5.5v80c0 .275-.225.5-.5.5a.501.501 0 0 1-.5-.5v-80a.5.5 0 0 1 .5-.5z' })
      )
    );
  };

  module.exports = exports['default'];
});

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(0), __webpack_require__(13), __webpack_require__(176), __webpack_require__(15), __webpack_require__(9), __webpack_require__(8), __webpack_require__(42), __webpack_require__(204)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('preact'), require('../../Theme/style.css'), require('./style.css'), require('../../Title'), require('../../../Tracker'), require('../../utils'), require('../../../locales'), require('./graphic'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.preact, global.style, global.style, global.Title, global.Tracker, global.utils, global.locales, global.graphic);
    global.index = mod.exports;
  }
})(this, function (module, exports, _preact, _style, _style3, _Title, _Tracker, _utils, _locales, _graphic) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _style2 = _interopRequireDefault(_style);

  var _style4 = _interopRequireDefault(_style3);

  var _Title2 = _interopRequireDefault(_Title);

  var _graphic2 = _interopRequireDefault(_graphic);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Guidance = function Guidance(_ref) {
    var i18n = _ref.i18n,
        documentType = _ref.documentType,
        nextStep = _ref.nextStep;

    return (0, _preact.h)(
      'div',
      { className: _style2.default.fullHeightContainer },
      (0, _preact.h)(_Title2.default, {
        title: i18n.t('capture.' + documentType + '.front.title'),
        subTitle: (0, _preact.h)(
          'span',
          { className: _style4.default.subTitle },
          (0, _locales.parseI18nWithXmlTags)(i18n, 'capture.' + documentType + '.front.sub_title', function (_ref2) {
            var text = _ref2.text;
            return (0, _preact.h)(
              'span',
              { className: _style4.default.bolder },
              text
            );
          })
        )
      }),
      (0, _preact.h)(
        'div',
        { className: _style4.default.content },
        (0, _preact.h)(
          'div',
          { className: _style4.default.makeSure },
          i18n.t('proof_of_address.guidance.make_sure_it_shows')
        ),
        (0, _preact.h)(
          'div',
          { className: _style4.default.docImageContainer },
          (0, _preact.h)(_graphic2.default, null)
        )
      ),
      (0, _preact.h)(
        'div',
        { className: _style2.default.thickWrapper },
        (0, _preact.h)(
          'button',
          {
            className: _style2.default.btn + ' ' + _style2.default['btn-primary'] + ' ' + _style2.default['btn-centered'],
            onClick: (0, _utils.preventDefaultOnClick)(nextStep)
          },
          i18n.t('proof_of_address.guidance.continue')
        )
      )
    );
  };

  exports.default = (0, _Tracker.trackComponent)(Guidance);
  module.exports = exports['default'];
});

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(0), __webpack_require__(13), __webpack_require__(450), __webpack_require__(15), __webpack_require__(9), __webpack_require__(8), __webpack_require__(42)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('preact'), require('../../Theme/style.css'), require('./style.css'), require('../../Title'), require('../../../Tracker'), require('../../utils'), require('../../../locales'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.preact, global.style, global.style, global.Title, global.Tracker, global.utils, global.locales);
    global.index = mod.exports;
  }
})(this, function (module, exports, _preact, _style, _style3, _Title, _Tracker, _utils, _locales) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _style2 = _interopRequireDefault(_style);

  var _style4 = _interopRequireDefault(_style3);

  var _Title2 = _interopRequireDefault(_Title);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var PoAIntro = function PoAIntro(_ref) {
    var i18n = _ref.i18n,
        nextStep = _ref.nextStep;
    return (0, _preact.h)(
      'div',
      { className: _style2.default.fullHeightContainer },
      (0, _preact.h)(_Title2.default, { title: i18n.t('proof_of_address.intro.title') }),
      (0, _preact.h)(
        'div',
        { className: _style4.default.content },
        (0, _preact.h)(
          'p',
          { className: _style4.default.requirements },
          i18n.t('proof_of_address.intro.requirements')
        ),
        ['shows_address', 'matches_signup', 'is_recent'].map(function (key) {
          return (0, _preact.h)(
            'div',
            { key: key, className: _style4.default.requirement },
            (0, _preact.h)(
              'span',
              null,
              (0, _locales.parseI18nWithXmlTags)(i18n, 'proof_of_address.intro.' + key, function (_ref2) {
                var text = _ref2.text;
                return (0, _preact.h)(
                  'span',
                  { className: _style4.default.bolder },
                  text
                );
              })
            )
          );
        })
      ),
      (0, _preact.h)(
        'div',
        { className: _style2.default.thickWrapper },
        (0, _preact.h)(
          'button',
          {
            className: _style2.default.btn + ' ' + _style2.default['btn-primary'] + ' ' + _style2.default['btn-centered'],
            onClick: (0, _utils.preventDefaultOnClick)(nextStep)
          },
          i18n.t('proof_of_address.intro.start')
        )
      )
    );
  };

  exports.default = (0, _Tracker.trackComponent)(PoAIntro);
  module.exports = exports['default'];
});

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(206), __webpack_require__(3), __webpack_require__(7), __webpack_require__(6), __webpack_require__(4), __webpack_require__(5), __webpack_require__(0), __webpack_require__(106), __webpack_require__(205), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./PoAIntro'), require('babel-runtime/core-js/object/define-property'), require('babel-runtime/core-js/object/set-prototype-of'), require('babel-runtime/core-js/object/create'), require('babel-runtime/core-js/object/get-prototype-of'), require('react'), require('preact'), require('../Capture'), require('./Guidance'), require('../../Tracker'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.PoAIntro, global.defineProperty, global.setPrototypeOf, global.create, global.getPrototypeOf, global.react, global.preact, global.Capture, global.Guidance, global.Tracker);
    global.index = mod.exports;
  }
})(this, function (exports, _PoAIntro, _defineProperty, _setPrototypeOf, _create, _getPrototypeOf, _react, _preact, _Capture, _Guidance, _Tracker) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.PoAIntro = undefined;
  Object.defineProperty(exports, 'PoAIntro', {
    enumerable: true,
    get: function () {
      return _interopRequireDefault(_PoAIntro).default;
    }
  });

  var _defineProperty2 = _interopRequireDefault(_defineProperty);

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create2 = _interopRequireDefault(_create);

  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

  var React = _interopRequireWildcard(_react);

  var _Guidance2 = _interopRequireDefault(_Guidance);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty2.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var PoACapture = function (_Component) {
    _inherits(PoACapture, _Component);

    function PoACapture() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, PoACapture);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PoACapture.__proto__ || (0, _getPrototypeOf2.default)(PoACapture)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        hasSeenGuidanceScreen: false
      }, _this.handleIntroNext = function () {
        _this.setState({ hasSeenGuidanceScreen: true });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PoACapture, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            i18n = _props.i18n,
            documentType = _props.documentType,
            trackScreen = _props.trackScreen;

        return this.state.hasSeenGuidanceScreen ? (0, _preact.h)(_Capture.FrontDocumentCapture, this.props) : (0, _preact.h)(_Guidance2.default, { i18n: i18n, trackScreen: trackScreen, documentType: documentType, nextStep: this.handleIntroNext });
      }
    }]);

    return PoACapture;
  }(_preact.Component);

  exports.default = (0, _Tracker.trackComponent)(PoACapture);
});

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(3), __webpack_require__(10), __webpack_require__(27), __webpack_require__(7), __webpack_require__(6), __webpack_require__(4), __webpack_require__(0), __webpack_require__(11), __webpack_require__(9), __webpack_require__(75), __webpack_require__(108), __webpack_require__(13)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/object/define-property'), require('babel-runtime/core-js/object/assign'), require('babel-runtime/core-js/array/from'), require('babel-runtime/core-js/object/set-prototype-of'), require('babel-runtime/core-js/object/create'), require('babel-runtime/core-js/object/get-prototype-of'), require('preact'), require('classnames'), require('../../Tracker'), require('../utils/array'), require('../NavigationBar'), require('../Theme/style.css'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.defineProperty, global.assign, global.from, global.setPrototypeOf, global.create, global.getPrototypeOf, global.preact, global.classnames, global.Tracker, global.array, global.NavigationBar, global.style);
    global.StepsRouter = mod.exports;
  }
})(this, function (module, exports, _defineProperty2, _assign, _from, _setPrototypeOf, _create, _getPrototypeOf, _preact, _classnames, _Tracker, _array, _NavigationBar, _style) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _defineProperty3 = _interopRequireDefault(_defineProperty2);

  var _assign2 = _interopRequireDefault(_assign);

  var _from2 = _interopRequireDefault(_from);

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create2 = _interopRequireDefault(_create);

  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _NavigationBar2 = _interopRequireDefault(_NavigationBar);

  var _style2 = _interopRequireDefault(_style);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      (0, _defineProperty3.default)(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var _extends = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    } else {
      return (0, _from2.default)(arr);
    }
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var StepsRouter = function (_Component) {
    _inherits(StepsRouter, _Component);

    function StepsRouter(props) {
      _classCallCheck(this, StepsRouter);

      var _this = _possibleConstructorReturn(this, (StepsRouter.__proto__ || (0, _getPrototypeOf2.default)(StepsRouter)).call(this, props));

      _this.trackScreen = function (screenNameHierarchy) {
        var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var _this$currentComponen = _this.currentComponent(),
            step = _this$currentComponen.step;

        (0, _Tracker.sendScreen)([step.type].concat(_toConsumableArray((0, _array.wrapArray)(screenNameHierarchy))), _extends({}, properties, step.options));
      };

      _this.currentComponent = function () {
        return _this.props.componentsList[_this.props.step];
      };

      _this.useFullScreen = function (value) {
        return _this.setState({
          isFullScreen: value
        });
      };

      _this.render = function (_ref) {
        var globalUserOptions = _objectWithoutProperties(_ref.options, []),
            otherProps = _objectWithoutProperties(_ref, ['options']);

        var componentBlob = _this.currentComponent();
        var CurrentComponent = componentBlob.component;
        var _this$props = _this.props,
            back = _this$props.back,
            i18n = _this$props.i18n,
            disableNavigation = _this$props.disableNavigation;

        var options = componentBlob.step.options;
        var isFullScreen = _this.state.isFullScreen;


        return (
          //TODO: Wrap CurrentComponent in themeWrap HOC
          (0, _preact.h)(
            'div',
            { className: (0, _classnames2.default)(_style2.default.step, _defineProperty({}, _style2.default.fullScreenStep, isFullScreen)) },
            (0, _preact.h)(_NavigationBar2.default, _extends({ back: back, i18n: i18n, isFullScreen: isFullScreen }, { disabled: disableNavigation, className: _style2.default.navigationBar })),
            (0, _preact.h)(
              'div',
              { className: (0, _classnames2.default)(_style2.default.content, _defineProperty({}, _style2.default.fullScreenContentWrapper, isFullScreen)) },
              (0, _preact.h)(CurrentComponent, _extends({}, _extends({}, options, globalUserOptions, otherProps, { isFullScreen: isFullScreen }), {
                trackScreen: _this.trackScreen, useFullScreen: _this.useFullScreen }))
            ),
            (0, _preact.h)('div', { className: _style2.default.footer })
          )
        );
      };

      _this.state = {
        isFullScreen: false
      };
      return _this;
    }

    return StepsRouter;
  }(_preact.Component);

  exports.default = StepsRouter;
  module.exports = exports['default'];
});

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(10), __webpack_require__(5), __webpack_require__(0), __webpack_require__(15), __webpack_require__(451), __webpack_require__(73), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/core-js/object/assign'), require('react'), require('preact'), require('../Title'), require('./style.css'), require('../DocumentSelector'), require('../../Tracker'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.assign, global.react, global.preact, global.Title, global.style, global.DocumentSelector, global.Tracker);
    global.index = mod.exports;
  }
})(this, function (exports, _assign, _react, _preact, _Title, _style, _DocumentSelector, _Tracker) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.SelectIdentityDocument = exports.SelectPoADocument = undefined;

  var _assign2 = _interopRequireDefault(_assign);

  var React = _interopRequireWildcard(_react);

  var _Title2 = _interopRequireDefault(_Title);

  var _style2 = _interopRequireDefault(_style);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var makeDocumentSelectorOfGroup = function makeDocumentSelectorOfGroup(group) {
    return function (props) {
      var setDocumentType = props.actions.setDocumentType,
          i18n = props.i18n;

      var DocumentSelector = group === 'proof_of_address' ? _DocumentSelector.PoADocumentSelector : _DocumentSelector.IdentityDocumentSelector;
      return (0, _preact.h)(
        'div',
        { className: _style2.default.wrapper },
        (0, _preact.h)(_Title2.default, {
          title: i18n.t('document_selector.' + group + '.title'),
          subTitle: i18n.t('document_selector.' + group + '.hint')
        }),
        (0, _preact.h)(DocumentSelector, _extends({ setDocumentType: setDocumentType }, props))
      );
    };
  };

  var SelectPoADocument = exports.SelectPoADocument = (0, _Tracker.trackComponent)(makeDocumentSelectorOfGroup('proof_of_address'), 'type_select');

  var SelectIdentityDocument = exports.SelectIdentityDocument = (0, _Tracker.trackComponent)(makeDocumentSelectorOfGroup('identity'), 'type_select');
});

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(10), __webpack_require__(0), __webpack_require__(108), __webpack_require__(13)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/core-js/object/assign'), require('preact'), require('../NavigationBar'), require('./style.css'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.assign, global.preact, global.NavigationBar, global.style);
    global.index = mod.exports;
  }
})(this, function (exports, _assign, _preact, _NavigationBar, _style) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.themeWrap = undefined;

  var _assign2 = _interopRequireDefault(_assign);

  var _NavigationBar2 = _interopRequireDefault(_NavigationBar);

  var _style2 = _interopRequireDefault(_style);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var themeWrap = exports.themeWrap = function themeWrap(WrappedComponent) {
    return function (props) {
      var back = props.back,
          i18n = props.i18n,
          isFullScreen = props.isFullScreen,
          disableNavigation = props.disableNavigation;


      return (0, _preact.h)(
        'div',
        { className: _style2.default.step },
        (0, _preact.h)(_NavigationBar2.default, _extends({ back: back, i18n: i18n, isFullScreen: isFullScreen }, { disabled: disableNavigation, className: _style2.default.navigationBar })),
        (0, _preact.h)(
          'div',
          { className: _style2.default.content },
          (0, _preact.h)(WrappedComponent, props)
        ),
        (0, _preact.h)('div', { className: _style2.default.footer })
      );
    };
  };
});

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(3), __webpack_require__(0), __webpack_require__(11), __webpack_require__(13), __webpack_require__(454), __webpack_require__(8), __webpack_require__(78), __webpack_require__(111), __webpack_require__(9), __webpack_require__(107), __webpack_require__(221), __webpack_require__(15), __webpack_require__(73)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/core-js/object/define-property'), require('preact'), require('classnames'), require('../Theme/style.css'), require('./style.css'), require('../utils'), require('../utils/string'), require('../strings/errors'), require('../../Tracker'), require('../CustomFileInput'), require('../crossDevice/SwitchDevice'), require('../Title'), require('../DocumentSelector'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.preact, global.classnames, global.style, global.style, global.utils, global.string, global.errors, global.Tracker, global.CustomFileInput, global.SwitchDevice, global.Title, global.DocumentSelector);
    global.index = mod.exports;
  }
})(this, function (exports, _defineProperty2, _preact, _classnames, _style, _style3, _utils, _string, _errors, _Tracker, _CustomFileInput, _SwitchDevice, _Title, _DocumentSelector) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Uploader = undefined;

  var _defineProperty3 = _interopRequireDefault(_defineProperty2);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _style2 = _interopRequireDefault(_style);

  var _style4 = _interopRequireDefault(_style3);

  var _CustomFileInput2 = _interopRequireDefault(_CustomFileInput);

  var _SwitchDevice2 = _interopRequireDefault(_SwitchDevice);

  var _Title2 = _interopRequireDefault(_Title);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      (0, _defineProperty3.default)(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var UploadError = function UploadError(_ref) {
    var error = _ref.error,
        i18n = _ref.i18n;

    var errorList = (0, _errors.errors)(i18n);
    var errorObj = errorList[error.name];
    return (0, _preact.h)(
      'div',
      { className: _style4.default.error },
      errorObj.message + '. ' + errorObj.instruction + '.'
    );
  };

  var Instructions = function Instructions(_ref2) {
    var error = _ref2.error,
        instructions = _ref2.instructions,
        i18n = _ref2.i18n,
        documentTypeGroup = _ref2.documentTypeGroup;
    return (0, _preact.h)(
      'div',
      { className: _style4.default.instructions },
      (0, _preact.h)('span', { className: (0, _classnames2.default)(_style2.default.icon, _style4.default.icon, _style4.default[(0, _string.camelCase)(documentTypeGroup) + 'Icon']) }),
      error ? (0, _preact.h)(UploadError, { error: error, i18n: i18n }) : (0, _preact.h)(
        'div',
        { className: _style4.default.instructionsCopy },
        instructions
      )
    );
  };

  var MobileUploadArea = function MobileUploadArea(_ref3) {
    var onImageSelected = _ref3.onImageSelected,
        children = _ref3.children,
        isPoA = _ref3.isPoA,
        i18n = _ref3.i18n;
    return (0, _preact.h)(
      'div',
      { className: (0, _classnames2.default)(_style4.default.uploadArea, _style4.default.uploadAreaMobile) },
      children,
      (0, _preact.h)(
        'div',
        { className: _style4.default.buttons },
        (0, _preact.h)(
          _CustomFileInput2.default,
          {
            className: (0, _classnames2.default)(_style2.default.btn, _style2.default['btn-centered'], _style2.default['btn-' + (isPoA ? 'outline' : 'primary')], _style4.default.button),
            onChange: onImageSelected,
            accept: 'image/*',
            capture: true
          },
          i18n.t('capture.take_photo')
        ),
        isPoA && (0, _preact.h)(
          _CustomFileInput2.default,
          {
            onChange: onImageSelected,
            className: (0, _classnames2.default)(_style2.default.btn, _style2.default['btn-centered'], _style2.default['btn-primary'], _style4.default.button)
          },
          i18n.t('capture.upload_' + (_utils.isDesktop ? 'file' : 'document'))
        )
      )
    );
  };

  var DesktopUploadArea = function DesktopUploadArea(_ref4) {
    var onImageSelected = _ref4.onImageSelected,
        i18n = _ref4.i18n,
        children = _ref4.children;
    return (0, _preact.h)(
      _CustomFileInput2.default,
      {
        className: (0, _classnames2.default)(_style4.default.uploadArea, _style4.default.uploadAreaDesktop),
        onChange: onImageSelected
      },
      children,
      (0, _preact.h)(
        'div',
        { className: _style4.default.buttons },
        (0, _preact.h)(
          'span',
          { className: (0, _classnames2.default)(_style2.default.btn, _style2.default['btn-centered'], _style2.default['btn-outline'], _style4.default.button) },
          i18n.t('capture.upload_' + (_utils.isDesktop ? 'file' : 'document'))
        )
      )
    );
  };

  var UploaderPure = function UploaderPure(_ref5) {
    var instructions = _ref5.instructions,
        title = _ref5.title,
        subTitle = _ref5.subTitle,
        error = _ref5.error,
        onImageSelected = _ref5.onImageSelected,
        documentType = _ref5.documentType,
        changeFlowTo = _ref5.changeFlowTo,
        allowCrossDeviceFlow = _ref5.allowCrossDeviceFlow,
        i18n = _ref5.i18n;

    var documentTypeGroup = (0, _DocumentSelector.getDocumentTypeGroup)(documentType);
    var isPoA = documentTypeGroup === 'proof_of_address';
    var UploadArea = _utils.isDesktop ? DesktopUploadArea : MobileUploadArea;
    return (0, _preact.h)(
      'div',
      { className: (0, _classnames2.default)(_style2.default.fullHeightContainer, _style4.default.container) },
      (0, _preact.h)(_Title2.default, { title: title, subTitle: subTitle }),
      (0, _preact.h)(
        'div',
        { className: (0, _classnames2.default)(_style4.default.uploaderWrapper, _defineProperty({}, _style4.default.crossDeviceClient, !allowCrossDeviceFlow)) },
        allowCrossDeviceFlow && (0, _preact.h)(_SwitchDevice2.default, { changeFlowTo: changeFlowTo, i18n: i18n }),
        (0, _preact.h)(
          UploadArea,
          { onImageSelected: onImageSelected, i18n: i18n, isPoA: isPoA },
          (0, _preact.h)(Instructions, { error: error, instructions: instructions, i18n: i18n, documentTypeGroup: documentTypeGroup })
        )
      )
    );
  };

  var Uploader = exports.Uploader = (0, _Tracker.trackComponentAndMode)(UploaderPure, 'file_upload', 'error');
});

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(0), __webpack_require__(15), __webpack_require__(13), __webpack_require__(455), __webpack_require__(8), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('preact'), require('../Title'), require('../Theme/style.css'), require('./style.css'), require('../utils'), require('../../Tracker'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.preact, global.Title, global.style, global.style, global.utils, global.Tracker);
    global.index = mod.exports;
  }
})(this, function (module, exports, _preact, _Title, _style, _style3, _utils, _Tracker) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _Title2 = _interopRequireDefault(_Title);

  var _style2 = _interopRequireDefault(_style);

  var _style4 = _interopRequireDefault(_style3);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var localisedDescriptions = function localisedDescriptions(i18n) {
    return [i18n.t('welcome.description_p_1'), i18n.t('welcome.description_p_2')];
  };

  var Welcome = function Welcome(_ref) {
    var title = _ref.title,
        descriptions = _ref.descriptions,
        nextStep = _ref.nextStep,
        i18n = _ref.i18n;

    var welcomeTitle = title ? title : i18n.t('welcome.title');
    var welcomeDescriptions = descriptions ? descriptions : localisedDescriptions(i18n);
    return (0, _preact.h)(
      'div',
      null,
      (0, _preact.h)(_Title2.default, { title: welcomeTitle }),
      (0, _preact.h)(
        'div',
        { className: _style2.default.thickWrapper },
        (0, _preact.h)(
          'div',
          { className: _style4.default.text },
          welcomeDescriptions.map(function (description) {
            return (0, _preact.h)(
              'p',
              null,
              description
            );
          })
        ),
        (0, _preact.h)(
          'button',
          {
            href: '',
            className: _style2.default.btn + ' ' + _style2.default["btn-centered"] + ' ' + _style2.default["btn-primary"],
            onClick: (0, _utils.preventDefaultOnClick)(nextStep) },
          i18n.t('welcome.next_button')
        )
      )
    );
  };

  exports.default = (0, _Tracker.trackComponent)(Welcome);
  module.exports = exports['default'];
});

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(3), __webpack_require__(7), __webpack_require__(6), __webpack_require__(4), __webpack_require__(0), __webpack_require__(15), __webpack_require__(13), __webpack_require__(456), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/object/define-property'), require('babel-runtime/core-js/object/set-prototype-of'), require('babel-runtime/core-js/object/create'), require('babel-runtime/core-js/object/get-prototype-of'), require('preact'), require('../../Title'), require('../../Theme/style.css'), require('./style.css'), require('../../../Tracker'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.defineProperty, global.setPrototypeOf, global.create, global.getPrototypeOf, global.preact, global.Title, global.style, global.style, global.Tracker);
    global.index = mod.exports;
  }
})(this, function (module, exports, _defineProperty, _setPrototypeOf, _create, _getPrototypeOf, _preact, _Title, _style, _style3, _Tracker) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _defineProperty2 = _interopRequireDefault(_defineProperty);

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create2 = _interopRequireDefault(_create);

  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

  var _Title2 = _interopRequireDefault(_Title);

  var _style2 = _interopRequireDefault(_style);

  var _style4 = _interopRequireDefault(_style3);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty2.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var ClientSuccess = function (_Component) {
    _inherits(ClientSuccess, _Component);

    function ClientSuccess() {
      _classCallCheck(this, ClientSuccess);

      return _possibleConstructorReturn(this, (ClientSuccess.__proto__ || (0, _getPrototypeOf2.default)(ClientSuccess)).apply(this, arguments));
    }

    _createClass(ClientSuccess, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.props.sendClientSuccess();
      }
    }, {
      key: 'render',
      value: function render() {
        var i18n = this.props.i18n;
        return (0, _preact.h)(
          'div',
          null,
          (0, _preact.h)(_Title2.default, { title: i18n.t('cross_device.client_success.title'), subTitle: i18n.t('cross_device.client_success.sub_title') }),
          (0, _preact.h)(
            'div',
            { 'class': _style2.default.thickWrapper },
            (0, _preact.h)('span', { className: _style2.default.icon + '  ' + _style4.default.icon }),
            (0, _preact.h)(
              'div',
              { className: _style4.default.text },
              i18n.t('cross_device.client_success.body')
            )
          )
        );
      }
    }]);

    return ClientSuccess;
  }(_preact.Component);

  exports.default = (0, _Tracker.trackComponent)(ClientSuccess, 'crossdevice_mobile_success');
  module.exports = exports['default'];
});

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(10), __webpack_require__(57), __webpack_require__(3), __webpack_require__(7), __webpack_require__(6), __webpack_require__(4), __webpack_require__(0), __webpack_require__(11), __webpack_require__(166), __webpack_require__(13), __webpack_require__(457), __webpack_require__(77), __webpack_require__(54), __webpack_require__(201), __webpack_require__(74), __webpack_require__(15), __webpack_require__(9), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/object/assign'), require('babel-runtime/core-js/json/stringify'), require('babel-runtime/core-js/object/define-property'), require('babel-runtime/core-js/object/set-prototype-of'), require('babel-runtime/core-js/object/create'), require('babel-runtime/core-js/object/get-prototype-of'), require('preact'), require('classnames'), require('socket.io-client'), require('../../Theme/style.css'), require('./style.css'), require('../../utils/http'), require('../../Spinner'), require('../../PhoneNumberInput/Lazy'), require('../../Error'), require('../../Title'), require('../../../Tracker'), require('../../utils'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.assign, global.stringify, global.defineProperty, global.setPrototypeOf, global.create, global.getPrototypeOf, global.preact, global.classnames, global.socket, global.style, global.style, global.http, global.Spinner, global.Lazy, global.Error, global.Title, global.Tracker, global.utils);
    global.index = mod.exports;
  }
})(this, function (module, exports, _assign, _stringify, _defineProperty2, _setPrototypeOf, _create, _getPrototypeOf, _preact, _classnames, _socket, _style, _style3, _http, _Spinner, _Lazy, _Error, _Title, _Tracker, _utils) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _assign2 = _interopRequireDefault(_assign);

  var _stringify2 = _interopRequireDefault(_stringify);

  var _defineProperty3 = _interopRequireDefault(_defineProperty2);

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create2 = _interopRequireDefault(_create);

  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _socket2 = _interopRequireDefault(_socket);

  var _style2 = _interopRequireDefault(_style);

  var _style4 = _interopRequireDefault(_style3);

  var _Spinner2 = _interopRequireDefault(_Spinner);

  var _Lazy2 = _interopRequireDefault(_Lazy);

  var _Error2 = _interopRequireDefault(_Error);

  var _Title2 = _interopRequireDefault(_Title);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      (0, _defineProperty3.default)(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty3.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var SmsError = function (_Component) {
    _inherits(SmsError, _Component);

    function SmsError() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, SmsError);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SmsError.__proto__ || (0, _getPrototypeOf2.default)(SmsError)).call.apply(_ref, [this].concat(args))), _this), _this.render = function (_ref2) {
        var error = _ref2.error,
            i18n = _ref2.i18n;
        return (0, _preact.h)(_Error2.default, { error: error, i18n: i18n });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SmsError, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var errorName = this.props.error.name.toLowerCase();
        this.props.trackScreen([errorName]);
      }
    }]);

    return SmsError;
  }(_preact.Component);

  var CrossDeviceLink = function (_Component2) {
    _inherits(CrossDeviceLink, _Component2);

    function CrossDeviceLink(props) {
      _classCallCheck(this, CrossDeviceLink);

      var _this2 = _possibleConstructorReturn(this, (CrossDeviceLink.__proto__ || (0, _getPrototypeOf2.default)(CrossDeviceLink)).call(this, props));

      _this2.unlisten = function (socket) {
        if (!socket) return;
        socket.off('get config', _this2.onGetConfig);
        socket.off('client success', _this2.onClientSuccess);
      };

      _this2.listen = function (socket) {
        if (!socket) return;
        socket.on('get config', _this2.onGetConfig);
        socket.on('client success', _this2.onClientSuccess);
      };

      _this2.onJoined = function (data) {
        var _this2$props = _this2.props,
            actions = _this2$props.actions,
            roomId = _this2$props.roomId;

        if (!roomId) {
          actions.setRoomId(data.roomId);
        }
      };

      _this2.onGetConfig = function (data) {
        var _this2$props2 = _this2.props,
            roomId = _this2$props2.roomId,
            mobileConfig = _this2$props2.mobileConfig,
            socket = _this2$props2.socket,
            actions = _this2$props2.actions,
            nextStep = _this2$props2.nextStep;

        if (roomId && roomId !== data.roomId) {
          socket.emit('leave', { roomId: roomId });
        }
        actions.mobileConnected(true);
        _this2.sendMessage('config', data.roomId, mobileConfig);
        nextStep();
      };

      _this2.onClientSuccess = function () {
        var actions = _this2.props.actions;

        actions.setClientSuccess(true);
        _this2.props.nextStep();
      };

      _this2.sendMessage = function (event, roomId, payload) {
        _this2.props.socket.emit('message', { event: event, payload: payload, roomId: roomId });
      };

      _this2.render = function () {
        return _this2.props.roomId ? (0, _preact.h)(CrossDeviceLinkUI, _this2.props) : (0, _preact.h)(_Spinner2.default, null);
      };

      if (!props.socket) {
        var socket = (0, _socket2.default)("https://sync.onfido.com", { autoConnect: false });
        socket.on('connect', function () {
          var roomId = _this2.props.roomId || null;
          socket.emit('join', { roomId: roomId });
        });
        socket.on('joined', _this2.onJoined);
        socket.open();
        props.actions.setSocket(socket);
      }
      return _this2;
    }

    _createClass(CrossDeviceLink, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.listen(this.props.socket);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (nextProps.socket !== this.props.socket) {
          this.unlisten(this.props.socket);
          this.listen(nextProps.socket);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.unlisten(this.props.socket);
      }
    }]);

    return CrossDeviceLink;
  }(_preact.Component);

  var CrossDeviceLinkUI = function (_Component3) {
    _inherits(CrossDeviceLinkUI, _Component3);

    function CrossDeviceLinkUI(props) {
      _classCallCheck(this, CrossDeviceLinkUI);

      var _this3 = _possibleConstructorReturn(this, (CrossDeviceLinkUI.__proto__ || (0, _getPrototypeOf2.default)(CrossDeviceLinkUI)).call(this, props));

      _this3.linkId = '' + "AI" + _this3.props.roomId;
      _this3.linkCopiedTimeoutId = null;

      _this3.copyToClipboard = function (e) {
        e.preventDefault();
        _this3.linkText.select();
        document.execCommand('copy');
        e.target.focus();
        _this3.setState({ copySuccess: true });
        _this3.clearLinkCopiedTimeout();
        _this3.linkCopiedTimeoutId = setTimeout(function () {
          _this3.setState({ copySuccess: false });
        }, 5000);
      };

      _this3.clearLinkCopiedTimeout = function () {
        if (_this3.linkCopiedTimeoutId) {
          clearTimeout(_this3.linkCopiedTimeoutId);
        }
      };

      _this3.setError = function (name) {
        return _this3.setState({ error: { name: name, type: 'error' } });
      };

      _this3.clearErrors = function () {
        _this3.setState({ error: {} });
        _this3.setState({ validNumber: true });
      };

      _this3.handleResponse = function (response) {
        _this3.setState({ sending: false });
        if (response.status === "OK") {
          _this3.props.nextStep();
        } else {
          _this3.setError('SMS_FAILED');
        }
      };

      _this3.handleSMSError = function (_ref3) {
        var status = _ref3.status;

        _this3.setState({ sending: false });
        status === 429 ? _this3.setError('SMS_OVERUSE') : _this3.setError('SMS_FAILED');
      };

      _this3.sendSms = function () {
        if (_this3.props.sms.valid) {
          _this3.setState({ sending: true });
          var language = _this3.props.i18n.currentLocale;
          var options = {
            payload: (0, _stringify2.default)({ to: _this3.props.sms.number, id: _this3.linkId, language: language }),
            endpoint: "https://telephony.onfido.com" + '/v1/cross_device_sms',
            contentType: 'application/json',
            token: 'Bearer ' + _this3.props.token
          };
          (0, _http.performHttpReq)(options, _this3.handleResponse, _this3.handleSMSError);
        } else {
          _this3.setState({ validNumber: false });
        }
      };

      _this3.mobileUrl = function () {
        return (
          // This lets us test the cross device flow locally and on surge.
          // We use the same location to test the same bundle as the desktop flow.
           false ? window.location.origin + '?link_id=' + _this3.linkId : "https://id.onfido.com" + '/' + _this3.linkId
        );
      };

      _this3.state = {
        copySuccess: false,
        sending: false,
        error: {},
        validNumber: true
      };
      return _this3;
    }

    _createClass(CrossDeviceLinkUI, [{
      key: 'render',
      value: function render() {
        var _this4 = this;

        var i18n = this.props.i18n;
        var mobileUrl = this.mobileUrl();
        var error = this.state.error;
        var linkCopy = this.state.copySuccess ? i18n.t('cross_device.link.link_copy.success') : i18n.t('cross_device.link.link_copy.action');
        var buttonCopy = this.state.sending ? i18n.t('cross_device.link.button_copy.status') : i18n.t('cross_device.link.button_copy.action');
        var invalidNumber = !this.state.validNumber;
        return (0, _preact.h)(
          'div',
          null,
          error.type ? (0, _preact.h)(SmsError, { error: error, trackScreen: this.props.trackScreen, i18n: i18n }) : (0, _preact.h)(_Title2.default, { title: i18n.t('cross_device.link.title') }),
          (0, _preact.h)(
            'div',
            { className: _style2.default.thickWrapper },
            (0, _preact.h)(
              'div',
              { className: _style4.default.subTitle },
              (0, _utils.parseTags)(i18n.t('cross_device.link.sub_title'), function (_ref4) {
                var text = _ref4.text;
                return (0, _preact.h)(
                  'span',
                  { className: _style4.default.bolder },
                  text
                );
              })
            ),
            (0, _preact.h)(
              'div',
              { className: _style4.default.smsSection },
              (0, _preact.h)(
                'div',
                { className: _style4.default.label },
                i18n.t('cross_device.link.sms_label')
              ),
              (0, _preact.h)(
                'div',
                { className: _style4.default.numberInputSection },
                (0, _preact.h)(
                  'div',
                  { className: (0, _classnames2.default)(_style4.default.inputContainer, _defineProperty({}, _style4.default.fieldError, invalidNumber)) },
                  (0, _preact.h)(_Lazy2.default, _extends({}, this.props, { clearErrors: this.clearErrors }))
                ),
                (0, _preact.h)(
                  'button',
                  { className: (0, _classnames2.default)(_style2.default.btn, _style2.default["btn-primary"], _style4.default.btn, _defineProperty({}, _style4.default.sending, this.state.sending)),
                    onClick: this.sendSms },
                  buttonCopy
                )
              )
            ),
            invalidNumber && (0, _preact.h)(
              'div',
              { className: _style4.default.numberError },
              i18n.t('errors.invalid_number.message')
            ),
            (0, _preact.h)(
              'div',
              { className: _style4.default.copyLinkSection },
              (0, _preact.h)(
                'div',
                { className: '' + _style4.default.label },
                i18n.t('cross_device.link.copy_link_label')
              ),
              (0, _preact.h)(
                'div',
                { className: (0, _classnames2.default)(_style4.default.linkContainer, _defineProperty({}, _style4.default.copySuccess, this.state.copySuccess)) },
                (0, _preact.h)('textarea', { className: _style4.default.linkText, value: mobileUrl, ref: function ref(element) {
                    return _this4.linkText = element;
                  } }),
                document.queryCommandSupported('copy') && (0, _preact.h)(
                  'div',
                  { className: _style4.default.actionContainer },
                  (0, _preact.h)(
                    'a',
                    { href: '', className: _style4.default.copyToClipboard, onClick: this.copyToClipboard },
                    linkCopy
                  )
                )
              ),
              (0, _preact.h)('hr', { className: _style4.default.divider })
            )
          )
        );
      }
    }]);

    return CrossDeviceLinkUI;
  }(_preact.Component);

  exports.default = (0, _Tracker.trackComponent)(CrossDeviceLink, 'crossdevice_link');
  module.exports = exports['default'];
});

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(3), __webpack_require__(7), __webpack_require__(6), __webpack_require__(4), __webpack_require__(0), __webpack_require__(41), __webpack_require__(9), __webpack_require__(8), __webpack_require__(15), __webpack_require__(13), __webpack_require__(458)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/object/define-property'), require('babel-runtime/core-js/object/set-prototype-of'), require('babel-runtime/core-js/object/create'), require('babel-runtime/core-js/object/get-prototype-of'), require('preact'), require('react-redux'), require('../../../Tracker'), require('../../utils'), require('../../Title'), require('../../Theme/style.css'), require('./style.css'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.defineProperty, global.setPrototypeOf, global.create, global.getPrototypeOf, global.preact, global.reactRedux, global.Tracker, global.utils, global.Title, global.style, global.style);
    global.index = mod.exports;
  }
})(this, function (module, exports, _defineProperty, _setPrototypeOf, _create, _getPrototypeOf, _preact, _reactRedux, _Tracker, _utils, _Title, _style, _style3) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _defineProperty2 = _interopRequireDefault(_defineProperty);

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create2 = _interopRequireDefault(_create);

  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

  var _Title2 = _interopRequireDefault(_Title);

  var _style2 = _interopRequireDefault(_style);

  var _style4 = _interopRequireDefault(_style3);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty2.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var CrossDeviceSubmit = function (_Component) {
    _inherits(CrossDeviceSubmit, _Component);

    function CrossDeviceSubmit() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, CrossDeviceSubmit);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CrossDeviceSubmit.__proto__ || (0, _getPrototypeOf2.default)(CrossDeviceSubmit)).call.apply(_ref, [this].concat(args))), _this), _this.hasMultipleDocuments = function () {
        var steps = _this.props.steps;

        var documentSteps = steps.filter(function (step) {
          return step.type === 'document';
        });
        return documentSteps.length > 1;
      }, _this.hasFace = function () {
        var steps = _this.props.steps;

        return steps.filter(function (step) {
          return step.type === 'face';
        }).length > 0;
      }, _this.faceVariant = function () {
        var _this$props$captures = _this.props.captures,
            captures = _this$props$captures === undefined ? {} : _this$props$captures;
        var _captures$face = captures.face,
            face = _captures$face === undefined ? [] : _captures$face;

        return face[0] ? face[0].variant : 'standard';
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CrossDeviceSubmit, [{
      key: 'render',
      value: function render() {
        var i18n = this.props.i18n;
        var documentCopy = this.hasMultipleDocuments() ? i18n.t('cross_device.submit.multiple_docs_uploaded') : i18n.t('cross_device.submit.one_doc_uploaded');
        return (0, _preact.h)(
          'div',
          null,
          (0, _preact.h)(_Title2.default, { title: i18n.t('cross_device.submit.title'), subTitle: i18n.t('cross_device.submit.sub_title') }),
          (0, _preact.h)(
            'div',
            { className: _style2.default.thickWrapper },
            (0, _preact.h)(
              'ul',
              { className: _style4.default.uploadList },
              (0, _preact.h)(
                'li',
                null,
                (0, _preact.h)('span', { className: _style2.default.icon + ' ' + _style4.default.icon }),
                (0, _preact.h)(
                  'span',
                  { className: _style4.default.listText },
                  documentCopy
                )
              ),
              this.hasFace() && (0, _preact.h)(
                'li',
                null,
                (0, _preact.h)('span', { className: _style2.default.icon + ' ' + _style4.default.icon }),
                (0, _preact.h)(
                  'span',
                  { className: _style4.default.listText },
                  i18n.t('cross_device.submit.' + (this.faceVariant() === 'standard' ? 'selfie' : 'video') + '_uploaded')
                )
              )
            ),
            (0, _preact.h)(
              'div',
              null,
              (0, _preact.h)(
                'button',
                {
                  className: _style2.default.btn + ' ' + _style2.default["btn-primary"] + ' ' + _style2.default["btn-centered"],
                  onClick: (0, _utils.preventDefaultOnClick)(this.props.nextStep)
                },
                i18n.t('cross_device.submit.action')
              )
            )
          )
        );
      }
    }]);

    return CrossDeviceSubmit;
  }(_preact.Component);

  var mapStateToProps = function mapStateToProps(_ref2) {
    var captures = _ref2.captures;
    return { captures: captures };
  };

  exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _Tracker.trackComponent)(CrossDeviceSubmit, 'desktop_submit'));
  module.exports = exports['default'];
});

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(3), __webpack_require__(7), __webpack_require__(6), __webpack_require__(4), __webpack_require__(0), __webpack_require__(15), __webpack_require__(13), __webpack_require__(459), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/object/define-property'), require('babel-runtime/core-js/object/set-prototype-of'), require('babel-runtime/core-js/object/create'), require('babel-runtime/core-js/object/get-prototype-of'), require('preact'), require('../../Title'), require('../../Theme/style.css'), require('./style.css'), require('../../../Tracker'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.defineProperty, global.setPrototypeOf, global.create, global.getPrototypeOf, global.preact, global.Title, global.style, global.style, global.Tracker);
    global.index = mod.exports;
  }
})(this, function (module, exports, _defineProperty, _setPrototypeOf, _create, _getPrototypeOf, _preact, _Title, _style, _style3, _Tracker) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _defineProperty2 = _interopRequireDefault(_defineProperty);

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create2 = _interopRequireDefault(_create);

  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

  var _Title2 = _interopRequireDefault(_Title);

  var _style2 = _interopRequireDefault(_style);

  var _style4 = _interopRequireDefault(_style3);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty2.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var GenericError = function (_Component) {
    _inherits(GenericError, _Component);

    function GenericError() {
      _classCallCheck(this, GenericError);

      return _possibleConstructorReturn(this, (GenericError.__proto__ || (0, _getPrototypeOf2.default)(GenericError)).apply(this, arguments));
    }

    _createClass(GenericError, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        (0, _Tracker.sendScreen)(['generic_client_error']);
      }
    }, {
      key: 'render',
      value: function render(_ref) {
        var i18n = _ref.i18n;

        return (0, _preact.h)(
          'div',
          null,
          (0, _preact.h)(_Title2.default, { title: i18n.t('errors.generic_client_error.message'), subTitle: i18n.t('errors.generic_client_error.instruction') }),
          (0, _preact.h)(
            'div',
            { className: _style2.default.thickWrapper },
            (0, _preact.h)('span', { className: _style2.default.icon + '  ' + _style4.default.icon })
          )
        );
      }
    }]);

    return GenericError;
  }(_preact.Component);

  exports.default = GenericError;
  module.exports = exports['default'];
});

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(10), __webpack_require__(43), __webpack_require__(0), __webpack_require__(11), __webpack_require__(13), __webpack_require__(460), __webpack_require__(15), __webpack_require__(9), __webpack_require__(8), __webpack_require__(109)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/object/assign'), require('babel-runtime/core-js/object/keys'), require('preact'), require('classnames'), require('../../Theme/style.css'), require('./style.css'), require('../../Title'), require('../../../Tracker'), require('../../utils'), require('../../Router/StepComponentMap'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.assign, global.keys, global.preact, global.classnames, global.style, global.style, global.Title, global.Tracker, global.utils, global.StepComponentMap);
    global.index = mod.exports;
  }
})(this, function (module, exports, _assign, _keys, _preact, _classnames, _style, _style3, _Title, _Tracker, _utils, _StepComponentMap) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _assign2 = _interopRequireDefault(_assign);

  var _keys2 = _interopRequireDefault(_keys);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _style2 = _interopRequireDefault(_style);

  var _style4 = _interopRequireDefault(_style3);

  var _Title2 = _interopRequireDefault(_Title);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var previousComponentType = function previousComponentType(_ref) {
    var _ref$flow = _ref.flow,
        flow = _ref$flow === undefined ? 'captureSteps' : _ref$flow,
        documentType = _ref.documentType,
        steps = _ref.steps,
        step = _ref.step;
    return (0, _StepComponentMap.componentsList)({ flow: flow, documentType: documentType, steps: steps })[step || 0].step.type;
  };

  var Intro = function Intro(_ref2) {
    var i18n = _ref2.i18n,
        nextStep = _ref2.nextStep,
        mobileConfig = _ref2.mobileConfig;

    var isFace = previousComponentType(mobileConfig) === 'face';
    var stages = _extends({
      'sms': 'sms'
    }, isFace ? { 'take-selfie': 'face.take_photos' } : { 'take-photos': 'document.take_photos' }, {
      'return-computer': 'return_computer'
    });

    return (0, _preact.h)(
      'div',
      { className: _style2.default.fullHeightMobileContainer },
      (0, _preact.h)(_Title2.default, {
        title: i18n.t('cross_device.intro.' + (isFace ? 'face' : 'document') + '.title')
      }),
      (0, _preact.h)(
        'div',
        { className: (0, _classnames2.default)(_style2.default.thickWrapper, _style4.default.content) },
        (0, _keys2.default)(stages).map(function (key) {
          return (0, _preact.h)(
            'div',
            { key: key, className: _style4.default.stage },
            (0, _preact.h)('div', { className: (0, _classnames2.default)(_style4.default.stageIcon, _style4.default['stageIcon-' + key]) }),
            (0, _preact.h)(
              'div',
              { className: _style4.default.stageMessage },
              i18n.t('cross_device.intro.' + stages[key])
            )
          );
        })
      ),
      (0, _preact.h)(
        'div',
        { className: _style2.default.thickWrapper },
        (0, _preact.h)(
          'button',
          {
            className: _style2.default.btn + ' ' + _style2.default["btn-primary"] + ' ' + _style2.default["btn-centered"],
            onClick: (0, _utils.preventDefaultOnClick)(nextStep)
          },
          i18n.t('cross_device.intro.' + (isFace ? 'face' : 'document') + '.action')
        )
      )
    );
  };

  exports.default = (0, _Tracker.trackComponent)(Intro);
  module.exports = exports['default'];
});

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(0), __webpack_require__(13), __webpack_require__(461), __webpack_require__(15), __webpack_require__(9), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('preact'), require('../../Theme/style.css'), require('./style.css'), require('../../Title'), require('../../../Tracker'), require('../../utils'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.preact, global.style, global.style, global.Title, global.Tracker, global.utils);
    global.index = mod.exports;
  }
})(this, function (module, exports, _preact, _style, _style3, _Title, _Tracker, _utils) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _style2 = _interopRequireDefault(_style);

  var _style4 = _interopRequireDefault(_style3);

  var _Title2 = _interopRequireDefault(_Title);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var MobileConnected = function MobileConnected(_ref) {
    var i18n = _ref.i18n,
        back = _ref.back;

    return (0, _preact.h)(
      'div',
      null,
      (0, _preact.h)(_Title2.default, {
        title: i18n.t('cross_device.mobile_connected.title.message'),
        subTitle: i18n.t('cross_device.mobile_connected.title.submessage')
      }),
      (0, _preact.h)(
        'div',
        { className: _style2.default.thickWrapper },
        (0, _preact.h)('span', { className: _style2.default.icon + ' ' + _style4.default.icon }),
        (0, _preact.h)(
          'div',
          { className: _style2.default.header },
          i18n.t('cross_device.tips')
        ),
        (0, _preact.h)(
          'div',
          { className: _style4.default.help + ' ' + _style2.default.help },
          (0, _preact.h)(
            'ul',
            { className: _style4.default.helpList + ' ' + _style2.default.helpList },
            (0, _preact.h)(
              'li',
              null,
              i18n.t('cross_device.mobile_connected.tips.item_1')
            ),
            (0, _preact.h)(
              'li',
              null,
              i18n.t('cross_device.mobile_connected.tips.item_2')
            ),
            (0, _preact.h)(
              'li',
              null,
              i18n.t('cross_device.mobile_connected.tips.item_3')
            )
          )
        ),
        (0, _preact.h)(
          'a',
          { href: '#', className: _style4.default.cancel,
            onClick: (0, _utils.preventDefaultOnClick)(back) },
          i18n.t('cancel')
        )
      )
    );
  };

  exports.default = (0, _Tracker.trackComponent)(MobileConnected, 'mobile_connected');
  module.exports = exports['default'];
});

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(3), __webpack_require__(7), __webpack_require__(6), __webpack_require__(4), __webpack_require__(0), __webpack_require__(218), __webpack_require__(215), __webpack_require__(220)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/object/define-property'), require('babel-runtime/core-js/object/set-prototype-of'), require('babel-runtime/core-js/object/create'), require('babel-runtime/core-js/object/get-prototype-of'), require('preact'), require('./MobileConnected'), require('./CrossDeviceSubmit'), require('./MobileNotificationSent'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.defineProperty, global.setPrototypeOf, global.create, global.getPrototypeOf, global.preact, global.MobileConnected, global.CrossDeviceSubmit, global.MobileNotificationSent);
    global.MobileFlow = mod.exports;
  }
})(this, function (module, exports, _defineProperty, _setPrototypeOf, _create, _getPrototypeOf, _preact, _MobileConnected, _CrossDeviceSubmit, _MobileNotificationSent) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _defineProperty2 = _interopRequireDefault(_defineProperty);

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create2 = _interopRequireDefault(_create);

  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

  var _MobileConnected2 = _interopRequireDefault(_MobileConnected);

  var _CrossDeviceSubmit2 = _interopRequireDefault(_CrossDeviceSubmit);

  var _MobileNotificationSent2 = _interopRequireDefault(_MobileNotificationSent);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty2.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var MobileFlow = function (_Component) {
    _inherits(MobileFlow, _Component);

    function MobileFlow() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, MobileFlow);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MobileFlow.__proto__ || (0, _getPrototypeOf2.default)(MobileFlow)).call.apply(_ref, [this].concat(args))), _this), _this.sendConfig = function (data) {
        var _this$props = _this.props,
            roomId = _this$props.roomId,
            mobileConfig = _this$props.mobileConfig,
            socket = _this$props.socket,
            actions = _this$props.actions;

        if (roomId && roomId !== data.roomId) {
          socket.emit('leave', { roomId: roomId });
        }
        actions.setRoomId(data.roomId);
        actions.mobileConnected(true);
        _this.sendMessage('config', data.roomId, mobileConfig);
      }, _this.sendMessage = function (event, roomId, payload) {
        _this.props.socket.emit('message', { event: event, payload: payload, roomId: roomId });
      }, _this.onClientSuccess = function (data) {
        if (data.faceCapture) {
          _this.props.actions.createCapture({ capture: data.faceCapture, method: 'face' });
        }
        _this.props.actions.setClientSuccess(true);
      }, _this.onDisconnectPing = function (data) {
        _this.sendMessage('disconnect pong', data.roomId);
      }, _this.render = function (props) {
        if (_this.props.clientSuccess) return (0, _preact.h)(_CrossDeviceSubmit2.default, props);
        return _this.props.mobileConnected ? (0, _preact.h)(_MobileConnected2.default, props) : (0, _preact.h)(_MobileNotificationSent2.default, props);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(MobileFlow, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.props.socket.on('disconnect ping', this.onDisconnectPing);
        this.props.socket.on('get config', this.sendConfig);
        this.props.socket.on('client success', this.onClientSuccess);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.props.socket.off('disconnect ping');
        this.props.socket.off('get config');
        this.props.socket.off('client success');
        var _props = this.props,
            socket = _props.socket,
            roomId = _props.roomId,
            actions = _props.actions;

        socket.emit('disconnecting', { roomId: roomId });
        actions.mobileConnected(false);
      }
    }]);

    return MobileFlow;
  }(_preact.Component);

  exports.default = MobileFlow;
  module.exports = exports['default'];
});

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(0), __webpack_require__(13), __webpack_require__(462), __webpack_require__(15), __webpack_require__(9), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('preact'), require('../../Theme/style.css'), require('./style.css'), require('../../Title'), require('../../../Tracker'), require('../../utils'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.preact, global.style, global.style, global.Title, global.Tracker, global.utils);
    global.index = mod.exports;
  }
})(this, function (module, exports, _preact, _style, _style3, _Title, _Tracker, _utils) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _style2 = _interopRequireDefault(_style);

  var _style4 = _interopRequireDefault(_style3);

  var _Title2 = _interopRequireDefault(_Title);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var MobileNotificationSent = function MobileNotificationSent(_ref) {
    var sms = _ref.sms,
        i18n = _ref.i18n,
        previousStep = _ref.previousStep;
    return (0, _preact.h)(
      'div',
      null,
      (0, _preact.h)(_Title2.default, { title: i18n.t('cross_device.mobile_notification_sent.title') }),
      (0, _preact.h)(
        'div',
        { className: _style2.default.thickWrapper },
        (0, _preact.h)(
          'div',
          { className: _style4.default.submessage },
          i18n.t('cross_device.mobile_notification_sent.submessage', { number: sms.number })
        ),
        (0, _preact.h)(
          'div',
          { className: _style4.default.boldMessage },
          i18n.t('cross_device.mobile_notification_sent.bold_message')
        ),
        (0, _preact.h)('span', { className: _style2.default.icon + ' ' + _style4.default.icon }),
        (0, _preact.h)(
          'div',
          { className: _style2.default.header },
          i18n.t('cross_device.tips')
        ),
        (0, _preact.h)(
          'div',
          { className: _style4.default.help + ' ' + _style2.default.help },
          (0, _preact.h)(
            'ul',
            { className: _style4.default.helpList + ' ' + _style2.default.helpList },
            (0, _preact.h)(
              'li',
              null,
              i18n.t('cross_device.mobile_notification_sent.tips.item_1')
            ),
            (0, _preact.h)(
              'li',
              null,
              i18n.t('cross_device.mobile_notification_sent.tips.item_2')
            )
          )
        ),
        (0, _preact.h)(
          'a',
          { href: '#', className: _style4.default.cancel,
            onClick: (0, _utils.preventDefaultOnClick)(previousStep) },
          i18n.t('cross_device.mobile_notification_sent.resend_link')
        )
      )
    );
  };

  exports.default = (0, _Tracker.trackComponent)(MobileNotificationSent, 'mobile_notification_sent');
  module.exports = exports['default'];
});

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(0), __webpack_require__(8), __webpack_require__(463)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('preact'), require('../../utils'), require('./style.css'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.preact, global.utils, global.style);
    global.index = mod.exports;
  }
})(this, function (module, exports, _preact, _utils, _style) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _style2 = _interopRequireDefault(_style);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var SwitchDevice = function SwitchDevice(_ref) {
    var i18n = _ref.i18n,
        changeFlowTo = _ref.changeFlowTo;
    return (0, _preact.h)(
      'a',
      { href: '#', className: _style2.default.switchClickableArea, onClick: (0, _utils.preventDefaultOnClick)(function () {
          return changeFlowTo('crossDeviceSteps');
        }) },
      (0, _preact.h)(
        'div',
        { className: _style2.default.container },
        (0, _preact.h)('div', { className: _style2.default.icon }),
        (0, _preact.h)(
          'div',
          { className: _style2.default.copy },
          (0, _preact.h)(
            'div',
            { className: _style2.default.header },
            i18n.t('cross_device.switch_device.header')
          ),
          (0, _preact.h)(
            'p',
            { className: _style2.default.submessage },
            i18n.t('cross_device.switch_device.submessage')
          )
        ),
        (0, _preact.h)('div', { className: _style2.default.chevron })
      )
    );
  };

  exports.default = SwitchDevice;
  module.exports = exports['default'];
});

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./index'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.index);
    global.jwt = mod.exports;
  }
})(this, function (exports, _index) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.jwtExpired = undefined;


  var parseJwt = function parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(atob(base64));
  };

  var jwtExpired = exports.jwtExpired = function jwtExpired(token) {
    var expTime = parseJwt(token).exp;
    return (0, _index.currentSeconds)() > expTime;
  };
});

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(43), __webpack_require__(70)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require("babel-runtime/core-js/object/keys"), require("babel-runtime/core-js/array/find"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.keys, global.find);
    global.object = mod.exports;
  }
})(this, function (exports, _keys, _find) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.find = undefined;

  var _keys2 = _interopRequireDefault(_keys);

  var _find2 = _interopRequireDefault(_find);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var find = exports.find = function find() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var fn = arguments[1];
    return (0, _find2.default)((0, _keys2.default)(obj), function (key) {
      return fn(obj[key], key);
    });
  };
});

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(77), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('../utils/http'), require('../../Tracker'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.http, global.Tracker);
    global.sdkBackend = mod.exports;
  }
})(this, function (exports, _http, _Tracker) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.postToBackend = undefined;

  var _Tracker2 = _interopRequireDefault(_Tracker);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var handleError = function handleError(_ref, callback) {
    var status = _ref.status,
        response = _ref.response;

    console.error(status, response);
    _Tracker2.default.sendError(status + ' - ' + response);
    callback();
  };

  var postToBackend = exports.postToBackend = function postToBackend(payload, token, onSuccess, errorCallback) {
    var endpoint = "https://sdk.onfido.com" + '/validate_document';
    var options = {
      payload: payload, endpoint: endpoint, token: token,
      contentType: 'application/json'
    };
    (0, _http.performHttpReq)(options, onSuccess, function (response) {
      return handleError(response, errorCallback);
    });
  };
});

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(10), __webpack_require__(33)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/core-js/object/assign'), require('../../constants'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.assign, global.constants);
    global.captures = mod.exports;
  }
})(this, function (exports, _assign, _constants) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.deleteCaptures = exports.validateCapture = exports.createCapture = undefined;

  var _assign2 = _interopRequireDefault(_assign);

  var constants = _interopRequireWildcard(_constants);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var identity = function identity(a) {
    return a;
  };

  //follows https://github.com/acdlite/redux-actions design
  var createAction = function createAction(type, payloadCreator) {
    return function (payload) {
      return {
        type: type,
        payload: (payloadCreator || identity)(payload)
      };
    };
  };

  var createCapture = exports.createCapture = createAction(constants.CAPTURE_CREATE, function (payload) {
    return _extends({ maxCaptures: 3 }, payload);
  });
  var validateCapture = exports.validateCapture = createAction(constants.CAPTURE_VALIDATE, function (payload) {
    return _extends({ valid: true }, payload);
  });
  var deleteCaptures = exports.deleteCaptures = createAction(constants.CAPTURE_DELETE);
});

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(33)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('../../constants'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.constants);
    global.globals = mod.exports;
  }
})(this, function (exports, _constants) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.setDocumentType = setDocumentType;
  exports.setRoomId = setRoomId;
  exports.setSocket = setSocket;
  exports.setClientSuccess = setClientSuccess;
  exports.setMobileNumber = setMobileNumber;
  exports.mobileConnected = mobileConnected;
  exports.acceptTerms = acceptTerms;

  var constants = _interopRequireWildcard(_constants);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function setDocumentType(payload) {
    return {
      type: constants.SET_DOCUMENT_TYPE,
      payload: payload
    };
  }

  function setRoomId(payload) {
    return {
      type: constants.SET_ROOM_ID,
      payload: payload
    };
  }

  function setSocket(payload) {
    return {
      type: constants.SET_SOCKET,
      payload: payload
    };
  }

  function setClientSuccess(payload) {
    return {
      type: constants.SET_CLIENT_SUCCESS,
      payload: payload
    };
  }

  function setMobileNumber(payload) {
    return {
      type: constants.SET_MOBILE_NUMBER,
      payload: payload
    };
  }

  function mobileConnected(payload) {
    return {
      type: constants.MOBILE_CONNECTED,
      payload: payload
    };
  }

  function acceptTerms() {
    return {
      type: constants.ACCEPT_TERMS
    };
  }
});

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(10), __webpack_require__(51), __webpack_require__(115), __webpack_require__(226), __webpack_require__(225), __webpack_require__(33)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/core-js/object/assign'), require('redux'), require('../store'), require('./globals'), require('./captures'), require('../../constants'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.assign, global.redux, global.store, global.globals, global.captures, global.constants);
    global.index = mod.exports;
  }
})(this, function (exports, _assign, _redux, _store, _globals, _captures, _constants) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.actions = exports.unboundActions = undefined;

  var _assign2 = _interopRequireDefault(_assign);

  var _store2 = _interopRequireDefault(_store);

  var globals = _interopRequireWildcard(_globals);

  var captures = _interopRequireWildcard(_captures);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var reset = function reset(payload) {
    return { type: _constants.RESET_STORE, payload: payload };
  };

  var unboundActions = exports.unboundActions = _extends({}, globals, captures, { reset: reset });
  var actions = exports.actions = (0, _redux.bindActionCreators)(unboundActions, _store2.default.dispatch);
});

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(27), __webpack_require__(3), __webpack_require__(10), __webpack_require__(33)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/core-js/array/from'), require('babel-runtime/core-js/object/define-property'), require('babel-runtime/core-js/object/assign'), require('../../constants'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.from, global.defineProperty, global.assign, global.constants);
    global.captures = mod.exports;
  }
})(this, function (exports, _from, _defineProperty2, _assign, _constants) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.captures = captures;

  var _from2 = _interopRequireDefault(_from);

  var _defineProperty3 = _interopRequireDefault(_defineProperty2);

  var _assign2 = _interopRequireDefault(_assign);

  var constants = _interopRequireWildcard(_constants);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    } else {
      return (0, _from2.default)(arr);
    }
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      (0, _defineProperty3.default)(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var _extends = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var initialState = {
    document: [],
    face: []
  };

  var changeCapturesThatMatchValidator = function changeCapturesThatMatchValidator(captures, validator, newCaptureDiffState) {
    return captures.map(function (capture) {
      return validator(capture) ? _extends({}, capture, newCaptureDiffState) : capture;
    });
  };

  function captures() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    var payload = action.payload || {};
    var captureType = payload.method;
    var captures = state[captureType];

    var changeStateWithNewCaptures = function changeStateWithNewCaptures(newCaptureState) {
      return _extends({}, state, _defineProperty({}, captureType, newCaptureState));
    };
    var changeCapturesThatMatchPayloadId = changeCapturesThatMatchValidator.bind(this, captures, function (capture) {
      return capture.id === payload.id;
    });

    switch (action.type) {
      case constants.CAPTURE_CREATE:
        {
          var maxCaptures = payload.maxCaptures,
              capture = payload.capture;

          var oldCaptures = captures.slice(0, maxCaptures - 1);
          return changeStateWithNewCaptures([capture].concat(_toConsumableArray(oldCaptures)));
        }
      case constants.CAPTURE_VALIDATE:
        {
          var validatedCaptures = changeCapturesThatMatchPayloadId({ valid: payload.valid, processed: true });
          return changeStateWithNewCaptures(validatedCaptures);
        }
      case constants.CAPTURE_DELETE:
        {
          // Only delete the captures with the side specified in the payload.
          var differentSideCaptures = captures.filter(function (capture) {
            return capture.side !== payload.side;
          });
          return changeStateWithNewCaptures(differentSideCaptures);
        }
      default:
        {
          return state;
        }
    }
  }
});

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(10), __webpack_require__(33)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/object/assign'), require('../../constants'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.assign, global.constants);
    global.globals = mod.exports;
  }
})(this, function (module, exports, _assign, _constants) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = globals;

  var _assign2 = _interopRequireDefault(_assign);

  var constants = _interopRequireWildcard(_constants);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var initialState = {
    documentType: null,
    roomId: null,
    socket: null,
    sms: { number: null, valid: false },
    clientSuccess: false,
    i18n: null,
    termsAccepted: false
  };

  function globals() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
      case constants.SET_DOCUMENT_TYPE:
        return _extends({}, state, { documentType: action.payload });
      case constants.SET_ROOM_ID:
        return _extends({}, state, { roomId: action.payload });
      case constants.SET_SOCKET:
        return _extends({}, state, { socket: action.payload });
      case constants.SET_MOBILE_NUMBER:
        return _extends({}, state, { sms: action.payload });
      case constants.SET_CLIENT_SUCCESS:
        return _extends({}, state, { clientSuccess: action.payload });
      case constants.MOBILE_CONNECTED:
        return _extends({}, state, { mobileConnected: action.payload });
      case constants.ACCEPT_TERMS:
        return _extends({}, state, { termsAccepted: true });
      default:
        return state;
    }
  }
  module.exports = exports['default'];
});

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(51), __webpack_require__(228), __webpack_require__(229), __webpack_require__(33)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('redux'), require('./captures'), require('./globals'), require('../../constants'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.redux, global.captures, global.globals, global.constants);
    global.index = mod.exports;
  }
})(this, function (module, exports, _redux, _captures, _globals, _constants) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _globals2 = _interopRequireDefault(_globals);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var appReducer = (0, _redux.combineReducers)({
    captures: _captures.captures,
    globals: _globals2.default
  });

  exports.default = function (state, action) {
    if (action.type === _constants.RESET_STORE) {
      return appReducer({}, {});
    }
    return appReducer(state, action);
  };

  module.exports = exports['default'];
});

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(427)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('reselect'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.reselect);
    global.index = mod.exports;
  }
})(this, function (exports, _reselect) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.mobileNumber = exports.socket = exports.allInvalidCaptureSelector = exports.unprocessedCaptures = exports.currentValidCaptures = undefined;


  var currentCaptures = function currentCaptures(state, _ref) {
    var method = _ref.method,
        _ref$side = _ref.side,
        side = _ref$side === undefined ? null : _ref$side;
    return state.captures[method].filter(function (c) {
      return c.side === side;
    });
  };

  var currentValidCaptures = exports.currentValidCaptures = (0, _reselect.createSelector)(currentCaptures, function (captures) {
    return captures.filter(function (capture) {
      return capture.valid;
    });
  });

  var unprocessedCaptures = exports.unprocessedCaptures = (0, _reselect.createSelector)(currentCaptures, function (captures) {
    return captures.filter(function (capture) {
      return !capture.processed;
    });
  });

  var allInvalidCaptureSelector = exports.allInvalidCaptureSelector = (0, _reselect.createSelector)(currentCaptures, function (captures) {
    return captures.length > 0 && captures.every(function (c) {
      return c.processed && !c.valid;
    });
  });

  // TODO remove the socket from the store. The store should just contain data,
  // not working objects.
  var socket = exports.socket = function socket(state) {
    return state.globals.socket;
  };

  var mobileNumber = exports.mobileNumber = function mobileNumber(state) {
    return state.globals.mobileNumber;
  };
});

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(72), __webpack_require__(71), __webpack_require__(10), __webpack_require__(70), __webpack_require__(0), __webpack_require__(41), __webpack_require__(181), __webpack_require__(52), __webpack_require__(179), __webpack_require__(180), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/core-js/symbol/iterator'), require('babel-runtime/core-js/symbol'), require('babel-runtime/core-js/object/assign'), require('babel-runtime/core-js/array/find'), require('preact'), require('react-redux'), require('eventemitter2'), require('./core'), require('./components/Modal'), require('./components/Router'), require('./Tracker'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.iterator, global.symbol, global.assign, global.find, global.preact, global.reactRedux, global.eventemitter2, global.core, global.Modal, global.Router, global.Tracker);
    global.index = mod.exports;
  }
})(this, function (module, exports, _iterator, _symbol, _assign, _find, _preact, _reactRedux, _eventemitter, _core, _Modal, _Router, _Tracker) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _iterator2 = _interopRequireDefault(_iterator);

  var _symbol2 = _interopRequireDefault(_symbol);

  var _assign2 = _interopRequireDefault(_assign);

  var _find2 = _interopRequireDefault(_find);

  var _eventemitter2 = _interopRequireDefault(_eventemitter);

  var _Modal2 = _interopRequireDefault(_Modal);

  var _Router2 = _interopRequireDefault(_Router);

  var _Tracker2 = _interopRequireDefault(_Tracker);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj;
  };

  var _extends = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var events = new _eventemitter2.default();

  _Tracker2.default.setUp();

  var ModalApp = function ModalApp(_ref) {
    var _ref$options = _ref.options,
        useModal = _ref$options.useModal,
        isModalOpen = _ref$options.isModalOpen,
        onModalRequestClose = _ref$options.onModalRequestClose,
        buttonId = _ref$options.buttonId,
        otherOptions = _objectWithoutProperties(_ref$options, ['useModal', 'isModalOpen', 'onModalRequestClose', 'buttonId']),
        otherProps = _objectWithoutProperties(_ref, ['options']);

    return (0, _preact.h)(
      _Modal2.default,
      _extends({ useModal: useModal, buttonId: buttonId }, { isOpen: isModalOpen, onRequestClose: onModalRequestClose }),
      (0, _preact.h)(_Router2.default, _extends({ options: otherOptions }, otherProps))
    );
  };

  var Container = function Container(_ref2) {
    var options = _ref2.options;
    return (0, _preact.h)(
      _reactRedux.Provider,
      { store: _core.store },
      (0, _preact.h)(ModalApp, { options: options })
    );
  };

  /**
   * Renders the Onfido component
   *
   * @param {DOMelement} [merge] preact requires the element which was created from the first render to be passed as 3rd argument for a rerender
   * @returns {DOMelement} Element which was generated from render
   */
  var onfidoRender = function onfidoRender(options, el, merge) {
    return (0, _preact.render)((0, _preact.h)(Container, { options: options }), el, merge);
  };

  var trackOnComplete = function trackOnComplete() {
    return _Tracker2.default.sendEvent('completed flow');
  };
  events.on('complete', trackOnComplete);

  var bindOnComplete = function bindOnComplete(_ref3) {
    var onComplete = _ref3.onComplete;

    events.on('complete', onComplete);
  };

  var rebindOnComplete = function rebindOnComplete(oldOptions, newOptions) {
    events.off('complete', oldOptions.onComplete);
    bindOnComplete(newOptions);
  };

  var Onfido = {};

  var noOp = function noOp() {};

  var defaults = {
    token: 'some token',
    buttonId: 'onfido-button',
    containerId: 'onfido-mount',
    onComplete: noOp
  };

  var isStep = function isStep(val) {
    return (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object';
  };
  var formatStep = function formatStep(typeOrStep) {
    return isStep(typeOrStep) ? typeOrStep : { type: typeOrStep };
  };

  var formatOptions = function formatOptions(_ref4) {
    var steps = _ref4.steps,
        otherOptions = _objectWithoutProperties(_ref4, ['steps']);

    return _extends({}, otherOptions, {
      steps: (steps || ['welcome', 'document', 'face', 'complete']).map(formatStep)
    });
  };

  var deprecationWarnings = function deprecationWarnings(_ref5) {
    var steps = _ref5.steps;

    var isDocument = function isDocument(step) {
      return step.type === 'document';
    };
    var documentStep = (0, _find2.default)(steps, isDocument);
    var useWebcamOption = documentStep && documentStep.options && documentStep.options.useWebcam;
    if (useWebcamOption) {
      console.warn("`useWebcam` is an experimental option and is currently discouraged");
    }
  };

  Onfido.init = function (opts) {
    console.log("onfido_sdk_version", "2.8.0");
    _Tracker2.default.track();
    var options = formatOptions(_extends({}, defaults, opts, { events: events }));
    deprecationWarnings(options);

    bindOnComplete(options);

    var containerEl = document.getElementById(options.containerId);
    var element = onfidoRender(options, containerEl);

    return {
      options: options,
      element: element,
      setOptions: function setOptions(changedOptions) {
        var oldOptions = this.options;
        this.options = formatOptions(_extends({}, this.options, changedOptions));
        rebindOnComplete(oldOptions, this.options);
        this.element = onfidoRender(this.options, containerEl, this.element);
        return this.options;
      },
      tearDown: function tearDown() {
        var socket = _core.selectors.socket(_core.store.getState());
        socket && socket.close();
        _core.actions.reset();
        events.removeAllListeners('complete');
        (0, _preact.render)(null, containerEl, this.element);
      }
    };
  };

  exports.default = Onfido;
  module.exports = exports['default'];
});

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(244), __esModule: true };

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(254), __esModule: true };

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(258), __esModule: true };

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(116);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(23);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 237 */
/***/ (function(module, exports) {


/**
 * Expose `Backoff`.
 */

module.exports = Backoff;

/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */

function Backoff(opts) {
  opts = opts || {};
  this.ms = opts.min || 100;
  this.max = opts.max || 10000;
  this.factor = opts.factor || 2;
  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
  this.attempts = 0;
}

/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */

Backoff.prototype.duration = function(){
  var ms = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var rand =  Math.random();
    var deviation = Math.floor(rand * this.jitter * ms);
    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
  }
  return Math.min(ms, this.max) | 0;
};

/**
 * Reset the number of attempts.
 *
 * @api public
 */

Backoff.prototype.reset = function(){
  this.attempts = 0;
};

/**
 * Set the minimum duration
 *
 * @api public
 */

Backoff.prototype.setMin = function(min){
  this.ms = min;
};

/**
 * Set the maximum duration
 *
 * @api public
 */

Backoff.prototype.setMax = function(max){
  this.max = max;
};

/**
 * Set the jitter
 *
 * @api public
 */

Backoff.prototype.setJitter = function(jitter){
  this.jitter = jitter;
};



/***/ }),
/* 238 */
/***/ (function(module, exports) {

/*
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */
(function(){
  "use strict";

  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

  // Use a lookup table to find the index.
  var lookup = new Uint8Array(256);
  for (var i = 0; i < chars.length; i++) {
    lookup[chars.charCodeAt(i)] = i;
  }

  exports.encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer),
    i, len = bytes.length, base64 = "";

    for (i = 0; i < len; i+=3) {
      base64 += chars[bytes[i] >> 2];
      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
      base64 += chars[bytes[i + 2] & 63];
    }

    if ((len % 3) === 2) {
      base64 = base64.substring(0, base64.length - 1) + "=";
    } else if (len % 3 === 1) {
      base64 = base64.substring(0, base64.length - 2) + "==";
    }

    return base64;
  };

  exports.decode =  function(base64) {
    var bufferLength = base64.length * 0.75,
    len = base64.length, i, p = 0,
    encoded1, encoded2, encoded3, encoded4;

    if (base64[base64.length - 1] === "=") {
      bufferLength--;
      if (base64[base64.length - 2] === "=") {
        bufferLength--;
      }
    }

    var arraybuffer = new ArrayBuffer(bufferLength),
    bytes = new Uint8Array(arraybuffer);

    for (i = 0; i < len; i+=4) {
      encoded1 = lookup[base64.charCodeAt(i)];
      encoded2 = lookup[base64.charCodeAt(i+1)];
      encoded3 = lookup[base64.charCodeAt(i+2)];
      encoded4 = lookup[base64.charCodeAt(i+3)];

      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
    }

    return arraybuffer;
  };
})();


/***/ }),
/* 239 */
/***/ (function(module, exports) {

/**
 * https://github.com/gre/bezier-easing
 * BezierEasing - use bezier curve for transition easing function
 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
 */

// These values are established by empiricism with tests (tradeoff: performance VS precision)
var NEWTON_ITERATIONS = 4;
var NEWTON_MIN_SLOPE = 0.001;
var SUBDIVISION_PRECISION = 0.0000001;
var SUBDIVISION_MAX_ITERATIONS = 10;

var kSplineTableSize = 11;
var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);

var float32ArraySupported = typeof Float32Array === 'function';

function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
function C (aA1)      { return 3.0 * aA1; }

// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
function calcBezier (aT, aA1, aA2) { return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT; }

// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
function getSlope (aT, aA1, aA2) { return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1); }

function binarySubdivide (aX, aA, aB, mX1, mX2) {
  var currentX, currentT, i = 0;
  do {
    currentT = aA + (aB - aA) / 2.0;
    currentX = calcBezier(currentT, mX1, mX2) - aX;
    if (currentX > 0.0) {
      aB = currentT;
    } else {
      aA = currentT;
    }
  } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
  return currentT;
}

function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
 for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
   var currentSlope = getSlope(aGuessT, mX1, mX2);
   if (currentSlope === 0.0) {
     return aGuessT;
   }
   var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
   aGuessT -= currentX / currentSlope;
 }
 return aGuessT;
}

module.exports = function bezier (mX1, mY1, mX2, mY2) {
  if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
    throw new Error('bezier x values must be in [0, 1] range');
  }

  // Precompute samples table
  var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
  if (mX1 !== mY1 || mX2 !== mY2) {
    for (var i = 0; i < kSplineTableSize; ++i) {
      sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
    }
  }

  function getTForX (aX) {
    var intervalStart = 0.0;
    var currentSample = 1;
    var lastSample = kSplineTableSize - 1;

    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
      intervalStart += kSampleStepSize;
    }
    --currentSample;

    // Interpolate to provide an initial guess for t
    var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
    var guessForT = intervalStart + dist * kSampleStepSize;

    var initialSlope = getSlope(guessForT, mX1, mX2);
    if (initialSlope >= NEWTON_MIN_SLOPE) {
      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
    } else if (initialSlope === 0.0) {
      return guessForT;
    } else {
      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
    }
  }

  return function BezierEasing (x) {
    if (mX1 === mY1 && mX2 === mY2) {
      return x; // linear
    }
    // Because JavaScript number are imprecise, we should guarantee the extremes are right.
    if (x === 0) {
      return 0;
    }
    if (x === 1) {
      return 1;
    }
    return calcBezier(getTForX(x), mY1, mY2);
  };
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Create a blob builder even when vendor prefixes exist
 */

var BlobBuilder = global.BlobBuilder
  || global.WebKitBlobBuilder
  || global.MSBlobBuilder
  || global.MozBlobBuilder;

/**
 * Check if Blob constructor is supported
 */

var blobSupported = (function() {
  try {
    var a = new Blob(['hi']);
    return a.size === 2;
  } catch(e) {
    return false;
  }
})();

/**
 * Check if Blob constructor supports ArrayBufferViews
 * Fails in Safari 6, so we need to map to ArrayBuffers there.
 */

var blobSupportsArrayBufferView = blobSupported && (function() {
  try {
    var b = new Blob([new Uint8Array([1,2])]);
    return b.size === 2;
  } catch(e) {
    return false;
  }
})();

/**
 * Check if BlobBuilder is supported
 */

var blobBuilderSupported = BlobBuilder
  && BlobBuilder.prototype.append
  && BlobBuilder.prototype.getBlob;

/**
 * Helper function that maps ArrayBufferViews to ArrayBuffers
 * Used by BlobBuilder constructor and old browsers that didn't
 * support it in the Blob constructor.
 */

function mapArrayBufferViews(ary) {
  for (var i = 0; i < ary.length; i++) {
    var chunk = ary[i];
    if (chunk.buffer instanceof ArrayBuffer) {
      var buf = chunk.buffer;

      // if this is a subarray, make a copy so we only
      // include the subarray region from the underlying buffer
      if (chunk.byteLength !== buf.byteLength) {
        var copy = new Uint8Array(chunk.byteLength);
        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
        buf = copy.buffer;
      }

      ary[i] = buf;
    }
  }
}

function BlobBuilderConstructor(ary, options) {
  options = options || {};

  var bb = new BlobBuilder();
  mapArrayBufferViews(ary);

  for (var i = 0; i < ary.length; i++) {
    bb.append(ary[i]);
  }

  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
};

function BlobConstructor(ary, options) {
  mapArrayBufferViews(ary);
  return new Blob(ary, options || {});
};

module.exports = (function() {
  if (blobSupported) {
    return blobSupportsArrayBufferView ? global.Blob : BlobConstructor;
  } else if (blobBuilderSupported) {
    return BlobBuilderConstructor;
  } else {
    return undefined;
  }
})();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image Exif Parser
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define */

;(function (factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(47), __webpack_require__(118)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'), require('./load-image-meta'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
}(function (loadImage) {
  'use strict'

  loadImage.ExifMap = function () {
    return this
  }

  loadImage.ExifMap.prototype.map = {
    'Orientation': 0x0112
  }

  loadImage.ExifMap.prototype.get = function (id) {
    return this[id] || this[this.map[id]]
  }

  loadImage.getExifThumbnail = function (dataView, offset, length) {
    var hexData,
      i,
      b
    if (!length || offset + length > dataView.byteLength) {
      console.log('Invalid Exif data: Invalid thumbnail data.')
      return
    }
    hexData = []
    for (i = 0; i < length; i += 1) {
      b = dataView.getUint8(offset + i)
      hexData.push((b < 16 ? '0' : '') + b.toString(16))
    }
    return 'data:image/jpeg,%' + hexData.join('%')
  }

  loadImage.exifTagTypes = {
    // byte, 8-bit unsigned int:
    1: {
      getValue: function (dataView, dataOffset) {
        return dataView.getUint8(dataOffset)
      },
      size: 1
    },
    // ascii, 8-bit byte:
    2: {
      getValue: function (dataView, dataOffset) {
        return String.fromCharCode(dataView.getUint8(dataOffset))
      },
      size: 1,
      ascii: true
    },
    // short, 16 bit int:
    3: {
      getValue: function (dataView, dataOffset, littleEndian) {
        return dataView.getUint16(dataOffset, littleEndian)
      },
      size: 2
    },
    // long, 32 bit int:
    4: {
      getValue: function (dataView, dataOffset, littleEndian) {
        return dataView.getUint32(dataOffset, littleEndian)
      },
      size: 4
    },
    // rational = two long values, first is numerator, second is denominator:
    5: {
      getValue: function (dataView, dataOffset, littleEndian) {
        return dataView.getUint32(dataOffset, littleEndian) /
        dataView.getUint32(dataOffset + 4, littleEndian)
      },
      size: 8
    },
    // slong, 32 bit signed int:
    9: {
      getValue: function (dataView, dataOffset, littleEndian) {
        return dataView.getInt32(dataOffset, littleEndian)
      },
      size: 4
    },
    // srational, two slongs, first is numerator, second is denominator:
    10: {
      getValue: function (dataView, dataOffset, littleEndian) {
        return dataView.getInt32(dataOffset, littleEndian) /
        dataView.getInt32(dataOffset + 4, littleEndian)
      },
      size: 8
    }
  }
  // undefined, 8-bit byte, value depending on field:
  loadImage.exifTagTypes[7] = loadImage.exifTagTypes[1]

  loadImage.getExifValue = function (dataView, tiffOffset, offset, type, length, littleEndian) {
    var tagType = loadImage.exifTagTypes[type]
    var tagSize
    var dataOffset
    var values
    var i
    var str
    var c
    if (!tagType) {
      console.log('Invalid Exif data: Invalid tag type.')
      return
    }
    tagSize = tagType.size * length
    // Determine if the value is contained in the dataOffset bytes,
    // or if the value at the dataOffset is a pointer to the actual data:
    dataOffset = tagSize > 4
      ? tiffOffset + dataView.getUint32(offset + 8, littleEndian)
      : (offset + 8)
    if (dataOffset + tagSize > dataView.byteLength) {
      console.log('Invalid Exif data: Invalid data offset.')
      return
    }
    if (length === 1) {
      return tagType.getValue(dataView, dataOffset, littleEndian)
    }
    values = []
    for (i = 0; i < length; i += 1) {
      values[i] = tagType.getValue(dataView, dataOffset + i * tagType.size, littleEndian)
    }
    if (tagType.ascii) {
      str = ''
      // Concatenate the chars:
      for (i = 0; i < values.length; i += 1) {
        c = values[i]
        // Ignore the terminating NULL byte(s):
        if (c === '\u0000') {
          break
        }
        str += c
      }
      return str
    }
    return values
  }

  loadImage.parseExifTag = function (dataView, tiffOffset, offset, littleEndian, data) {
    var tag = dataView.getUint16(offset, littleEndian)
    data.exif[tag] = loadImage.getExifValue(
      dataView,
      tiffOffset,
      offset,
      dataView.getUint16(offset + 2, littleEndian), // tag type
      dataView.getUint32(offset + 4, littleEndian), // tag length
      littleEndian
    )
  }

  loadImage.parseExifTags = function (dataView, tiffOffset, dirOffset, littleEndian, data) {
    var tagsNumber,
      dirEndOffset,
      i
    if (dirOffset + 6 > dataView.byteLength) {
      console.log('Invalid Exif data: Invalid directory offset.')
      return
    }
    tagsNumber = dataView.getUint16(dirOffset, littleEndian)
    dirEndOffset = dirOffset + 2 + 12 * tagsNumber
    if (dirEndOffset + 4 > dataView.byteLength) {
      console.log('Invalid Exif data: Invalid directory size.')
      return
    }
    for (i = 0; i < tagsNumber; i += 1) {
      this.parseExifTag(
        dataView,
        tiffOffset,
        dirOffset + 2 + 12 * i, // tag offset
        littleEndian,
        data
      )
    }
    // Return the offset to the next directory:
    return dataView.getUint32(dirEndOffset, littleEndian)
  }

  loadImage.parseExifData = function (dataView, offset, length, data, options) {
    if (options.disableExif) {
      return
    }
    var tiffOffset = offset + 10
    var littleEndian
    var dirOffset
    var thumbnailData
    // Check for the ASCII code for "Exif" (0x45786966):
    if (dataView.getUint32(offset + 4) !== 0x45786966) {
      // No Exif data, might be XMP data instead
      return
    }
    if (tiffOffset + 8 > dataView.byteLength) {
      console.log('Invalid Exif data: Invalid segment size.')
      return
    }
    // Check for the two null bytes:
    if (dataView.getUint16(offset + 8) !== 0x0000) {
      console.log('Invalid Exif data: Missing byte alignment offset.')
      return
    }
    // Check the byte alignment:
    switch (dataView.getUint16(tiffOffset)) {
      case 0x4949:
        littleEndian = true
        break
      case 0x4D4D:
        littleEndian = false
        break
      default:
        console.log('Invalid Exif data: Invalid byte alignment marker.')
        return
    }
    // Check for the TIFF tag marker (0x002A):
    if (dataView.getUint16(tiffOffset + 2, littleEndian) !== 0x002A) {
      console.log('Invalid Exif data: Missing TIFF marker.')
      return
    }
    // Retrieve the directory offset bytes, usually 0x00000008 or 8 decimal:
    dirOffset = dataView.getUint32(tiffOffset + 4, littleEndian)
    // Create the exif object to store the tags:
    data.exif = new loadImage.ExifMap()
    // Parse the tags of the main image directory and retrieve the
    // offset to the next directory, usually the thumbnail directory:
    dirOffset = loadImage.parseExifTags(
      dataView,
      tiffOffset,
      tiffOffset + dirOffset,
      littleEndian,
      data
    )
    if (dirOffset && !options.disableExifThumbnail) {
      thumbnailData = {exif: {}}
      dirOffset = loadImage.parseExifTags(
        dataView,
        tiffOffset,
        tiffOffset + dirOffset,
        littleEndian,
        thumbnailData
      )
      // Check for JPEG Thumbnail offset:
      if (thumbnailData.exif[0x0201]) {
        data.exif.Thumbnail = loadImage.getExifThumbnail(
          dataView,
          tiffOffset + thumbnailData.exif[0x0201],
          thumbnailData.exif[0x0202] // Thumbnail data length
        )
      }
    }
    // Check for Exif Sub IFD Pointer:
    if (data.exif[0x8769] && !options.disableExifSub) {
      loadImage.parseExifTags(
        dataView,
        tiffOffset,
        tiffOffset + data.exif[0x8769], // directory offset
        littleEndian,
        data
      )
    }
    // Check for GPS Info IFD Pointer:
    if (data.exif[0x8825] && !options.disableExifGps) {
      loadImage.parseExifTags(
        dataView,
        tiffOffset,
        tiffOffset + data.exif[0x8825], // directory offset
        littleEndian,
        data
      )
    }
  }

  // Registers the Exif parser for the APP1 JPEG meta data segment:
  loadImage.metaDataParsers.jpeg[0xffe1].push(loadImage.parseExifData)

  // Adds the following properties to the parseMetaData callback data:
  // * exif: The exif tags, parsed by the parseExifData method

  // Adds the following options to the parseMetaData method:
  // * disableExif: Disables Exif parsing.
  // * disableExifThumbnail: Disables parsing of the Exif Thumbnail.
  // * disableExifSub: Disables parsing of the Exif Sub IFD.
  // * disableExifGps: Disables parsing of the Exif GPS Info IFD.
}))


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image Orientation
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define */

;(function (factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(47), __webpack_require__(243), __webpack_require__(118)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(
      require('./load-image'),
      require('./load-image-scale'),
      require('./load-image-meta')
    )
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
}(function (loadImage) {
  'use strict'

  var originalHasCanvasOption = loadImage.hasCanvasOption
  var originalHasMetaOption = loadImage.hasMetaOption
  var originalTransformCoordinates = loadImage.transformCoordinates
  var originalGetTransformedOptions = loadImage.getTransformedOptions

  // Determines if the target image should be a canvas element:
  loadImage.hasCanvasOption = function (options) {
    return !!options.orientation ||
      originalHasCanvasOption.call(loadImage, options)
  }

  // Determines if meta data should be loaded automatically:
  loadImage.hasMetaOption = function (options) {
    return options && options.orientation === true ||
      originalHasMetaOption.call(loadImage, options)
  }

  // Transform image orientation based on
  // the given EXIF orientation option:
  loadImage.transformCoordinates = function (canvas, options) {
    originalTransformCoordinates.call(loadImage, canvas, options)
    var ctx = canvas.getContext('2d')
    var width = canvas.width
    var height = canvas.height
    var styleWidth = canvas.style.width
    var styleHeight = canvas.style.height
    var orientation = options.orientation
    if (!orientation || orientation > 8) {
      return
    }
    if (orientation > 4) {
      canvas.width = height
      canvas.height = width
      canvas.style.width = styleHeight
      canvas.style.height = styleWidth
    }
    switch (orientation) {
      case 2:
        // horizontal flip
        ctx.translate(width, 0)
        ctx.scale(-1, 1)
        break
      case 3:
        // 180° rotate left
        ctx.translate(width, height)
        ctx.rotate(Math.PI)
        break
      case 4:
        // vertical flip
        ctx.translate(0, height)
        ctx.scale(1, -1)
        break
      case 5:
        // vertical flip + 90 rotate right
        ctx.rotate(0.5 * Math.PI)
        ctx.scale(1, -1)
        break
      case 6:
        // 90° rotate right
        ctx.rotate(0.5 * Math.PI)
        ctx.translate(0, -height)
        break
      case 7:
        // horizontal flip + 90 rotate right
        ctx.rotate(0.5 * Math.PI)
        ctx.translate(width, -height)
        ctx.scale(-1, 1)
        break
      case 8:
        // 90° rotate left
        ctx.rotate(-0.5 * Math.PI)
        ctx.translate(-width, 0)
        break
    }
  }

  // Transforms coordinate and dimension options
  // based on the given orientation option:
  loadImage.getTransformedOptions = function (img, opts, data) {
    var options = originalGetTransformedOptions.call(loadImage, img, opts)
    var orientation = options.orientation
    var newOptions
    var i
    if (orientation === true && data && data.exif) {
      orientation = data.exif.get('Orientation')
    }
    if (!orientation || orientation > 8 || orientation === 1) {
      return options
    }
    newOptions = {}
    for (i in options) {
      if (options.hasOwnProperty(i)) {
        newOptions[i] = options[i]
      }
    }
    newOptions.orientation = orientation
    switch (orientation) {
      case 2:
        // horizontal flip
        newOptions.left = options.right
        newOptions.right = options.left
        break
      case 3:
        // 180° rotate left
        newOptions.left = options.right
        newOptions.top = options.bottom
        newOptions.right = options.left
        newOptions.bottom = options.top
        break
      case 4:
        // vertical flip
        newOptions.top = options.bottom
        newOptions.bottom = options.top
        break
      case 5:
        // vertical flip + 90 rotate right
        newOptions.left = options.top
        newOptions.top = options.left
        newOptions.right = options.bottom
        newOptions.bottom = options.right
        break
      case 6:
        // 90° rotate right
        newOptions.left = options.top
        newOptions.top = options.right
        newOptions.right = options.bottom
        newOptions.bottom = options.left
        break
      case 7:
        // horizontal flip + 90 rotate right
        newOptions.left = options.bottom
        newOptions.top = options.right
        newOptions.right = options.top
        newOptions.bottom = options.left
        break
      case 8:
        // 90° rotate left
        newOptions.left = options.bottom
        newOptions.top = options.left
        newOptions.right = options.top
        newOptions.bottom = options.right
        break
    }
    if (newOptions.orientation > 4) {
      newOptions.maxWidth = options.maxHeight
      newOptions.maxHeight = options.maxWidth
      newOptions.minWidth = options.minHeight
      newOptions.minHeight = options.minWidth
      newOptions.sourceWidth = options.sourceHeight
      newOptions.sourceHeight = options.sourceWidth
    }
    return newOptions
  }
}))


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image Scaling
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define */

;(function (factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(47)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
}(function (loadImage) {
  'use strict'

  var originalTransform = loadImage.transform

  loadImage.transform = function (img, options, callback, file, data) {
    originalTransform.call(
      loadImage,
      loadImage.scale(img, options, data),
      options,
      callback,
      file,
      data
    )
  }

  // Transform image coordinates, allows to override e.g.
  // the canvas orientation based on the orientation option,
  // gets canvas, options passed as arguments:
  loadImage.transformCoordinates = function () {
    return
  }

  // Returns transformed options, allows to override e.g.
  // maxWidth, maxHeight and crop options based on the aspectRatio.
  // gets img, options passed as arguments:
  loadImage.getTransformedOptions = function (img, options) {
    var aspectRatio = options.aspectRatio
    var newOptions
    var i
    var width
    var height
    if (!aspectRatio) {
      return options
    }
    newOptions = {}
    for (i in options) {
      if (options.hasOwnProperty(i)) {
        newOptions[i] = options[i]
      }
    }
    newOptions.crop = true
    width = img.naturalWidth || img.width
    height = img.naturalHeight || img.height
    if (width / height > aspectRatio) {
      newOptions.maxWidth = height * aspectRatio
      newOptions.maxHeight = height
    } else {
      newOptions.maxWidth = width
      newOptions.maxHeight = width / aspectRatio
    }
    return newOptions
  }

  // Canvas render method, allows to implement a different rendering algorithm:
  loadImage.renderImageToCanvas = function (
    canvas,
    img,
    sourceX,
    sourceY,
    sourceWidth,
    sourceHeight,
    destX,
    destY,
    destWidth,
    destHeight
  ) {
    canvas.getContext('2d').drawImage(
      img,
      sourceX,
      sourceY,
      sourceWidth,
      sourceHeight,
      destX,
      destY,
      destWidth,
      destHeight
    )
    return canvas
  }

  // Determines if the target image should be a canvas element:
  loadImage.hasCanvasOption = function (options) {
    return options.canvas || options.crop || !!options.aspectRatio
  }

  // Scales and/or crops the given image (img or canvas HTML element)
  // using the given options.
  // Returns a canvas object if the browser supports canvas
  // and the hasCanvasOption method returns true or a canvas
  // object is passed as image, else the scaled image:
  loadImage.scale = function (img, options, data) {
    options = options || {}
    var canvas = document.createElement('canvas')
    var useCanvas = img.getContext ||
                    (loadImage.hasCanvasOption(options) && canvas.getContext)
    var width = img.naturalWidth || img.width
    var height = img.naturalHeight || img.height
    var destWidth = width
    var destHeight = height
    var maxWidth
    var maxHeight
    var minWidth
    var minHeight
    var sourceWidth
    var sourceHeight
    var sourceX
    var sourceY
    var pixelRatio
    var downsamplingRatio
    var tmp
    function scaleUp () {
      var scale = Math.max(
        (minWidth || destWidth) / destWidth,
        (minHeight || destHeight) / destHeight
      )
      if (scale > 1) {
        destWidth *= scale
        destHeight *= scale
      }
    }
    function scaleDown () {
      var scale = Math.min(
        (maxWidth || destWidth) / destWidth,
        (maxHeight || destHeight) / destHeight
      )
      if (scale < 1) {
        destWidth *= scale
        destHeight *= scale
      }
    }
    if (useCanvas) {
      options = loadImage.getTransformedOptions(img, options, data)
      sourceX = options.left || 0
      sourceY = options.top || 0
      if (options.sourceWidth) {
        sourceWidth = options.sourceWidth
        if (options.right !== undefined && options.left === undefined) {
          sourceX = width - sourceWidth - options.right
        }
      } else {
        sourceWidth = width - sourceX - (options.right || 0)
      }
      if (options.sourceHeight) {
        sourceHeight = options.sourceHeight
        if (options.bottom !== undefined && options.top === undefined) {
          sourceY = height - sourceHeight - options.bottom
        }
      } else {
        sourceHeight = height - sourceY - (options.bottom || 0)
      }
      destWidth = sourceWidth
      destHeight = sourceHeight
    }
    maxWidth = options.maxWidth
    maxHeight = options.maxHeight
    minWidth = options.minWidth
    minHeight = options.minHeight
    if (useCanvas && maxWidth && maxHeight && options.crop) {
      destWidth = maxWidth
      destHeight = maxHeight
      tmp = sourceWidth / sourceHeight - maxWidth / maxHeight
      if (tmp < 0) {
        sourceHeight = maxHeight * sourceWidth / maxWidth
        if (options.top === undefined && options.bottom === undefined) {
          sourceY = (height - sourceHeight) / 2
        }
      } else if (tmp > 0) {
        sourceWidth = maxWidth * sourceHeight / maxHeight
        if (options.left === undefined && options.right === undefined) {
          sourceX = (width - sourceWidth) / 2
        }
      }
    } else {
      if (options.contain || options.cover) {
        minWidth = maxWidth = maxWidth || minWidth
        minHeight = maxHeight = maxHeight || minHeight
      }
      if (options.cover) {
        scaleDown()
        scaleUp()
      } else {
        scaleUp()
        scaleDown()
      }
    }
    if (useCanvas) {
      pixelRatio = options.pixelRatio
      if (pixelRatio > 1) {
        canvas.style.width = destWidth + 'px'
        canvas.style.height = destHeight + 'px'
        destWidth *= pixelRatio
        destHeight *= pixelRatio
        canvas.getContext('2d').scale(pixelRatio, pixelRatio)
      }
      downsamplingRatio = options.downsamplingRatio
      if (downsamplingRatio > 0 && downsamplingRatio < 1 &&
            destWidth < sourceWidth && destHeight < sourceHeight) {
        while (sourceWidth * downsamplingRatio > destWidth) {
          canvas.width = sourceWidth * downsamplingRatio
          canvas.height = sourceHeight * downsamplingRatio
          loadImage.renderImageToCanvas(
            canvas,
            img,
            sourceX,
            sourceY,
            sourceWidth,
            sourceHeight,
            0,
            0,
            canvas.width,
            canvas.height
          )
          sourceX = 0
          sourceY = 0
          sourceWidth = canvas.width
          sourceHeight = canvas.height
          img = document.createElement('canvas')
          img.width = sourceWidth
          img.height = sourceHeight
          loadImage.renderImageToCanvas(
            img,
            canvas,
            0,
            0,
            sourceWidth,
            sourceHeight,
            0,
            0,
            sourceWidth,
            sourceHeight
          )
        }
      }
      canvas.width = destWidth
      canvas.height = destHeight
      loadImage.transformCoordinates(
        canvas,
        options
      )
      return loadImage.renderImageToCanvas(
        canvas,
        img,
        sourceX,
        sourceY,
        sourceWidth,
        sourceHeight,
        0,
        0,
        destWidth,
        destHeight
      )
    }
    img.width = destWidth
    img.height = destHeight
    return img
  }
}))


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(285);
module.exports = __webpack_require__(12).Array.filter;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(286);
module.exports = __webpack_require__(12).Array.find;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50);
__webpack_require__(287);
module.exports = __webpack_require__(12).Array.from;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(297);
module.exports = __webpack_require__(12).Array.includes;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(64);
__webpack_require__(50);
module.exports = __webpack_require__(283);


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(64);
__webpack_require__(50);
module.exports = __webpack_require__(284);


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(12);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(289);
module.exports = __webpack_require__(12).Object.assign;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(290);
var $Object = __webpack_require__(12).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(291);
var $Object = __webpack_require__(12).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(298);
module.exports = __webpack_require__(12).Object.entries;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(292);
module.exports = __webpack_require__(12).Object.getPrototypeOf;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(293);
module.exports = __webpack_require__(12).Object.keys;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(294);
module.exports = __webpack_require__(12).Object.setPrototypeOf;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(137);
__webpack_require__(50);
__webpack_require__(64);
__webpack_require__(295);
__webpack_require__(301);
__webpack_require__(300);
__webpack_require__(299);
module.exports = __webpack_require__(12).Set;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(296);
__webpack_require__(137);
__webpack_require__(302);
__webpack_require__(303);
module.exports = __webpack_require__(12).Symbol;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50);
__webpack_require__(64);
module.exports = __webpack_require__(96).f('iterator');


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(59);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(21);
var isArray = __webpack_require__(126);
var SPECIES = __webpack_require__(17)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(262);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(18).f;
var create = __webpack_require__(60);
var redefineAll = __webpack_require__(134);
var ctx = __webpack_require__(30);
var anInstance = __webpack_require__(121);
var forOf = __webpack_require__(59);
var $iterDefine = __webpack_require__(87);
var step = __webpack_require__(128);
var setSpecies = __webpack_require__(279);
var DESCRIPTORS = __webpack_require__(19);
var fastKey = __webpack_require__(89).fastKey;
var validate = __webpack_require__(136);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(82);
var from = __webpack_require__(261);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(20);
var $export = __webpack_require__(16);
var meta = __webpack_require__(89);
var fails = __webpack_require__(25);
var hide = __webpack_require__(26);
var redefineAll = __webpack_require__(134);
var forOf = __webpack_require__(59);
var anInstance = __webpack_require__(121);
var isObject = __webpack_require__(21);
var setToStringTag = __webpack_require__(61);
var dP = __webpack_require__(18).f;
var each = __webpack_require__(81)(0);
var DESCRIPTORS = __webpack_require__(19);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(18);
var createDesc = __webpack_require__(49);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(36);
var gOPS = __webpack_require__(90);
var pIE = __webpack_require__(48);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(20).document;
module.exports = document && document.documentElement;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(60);
var descriptor = __webpack_require__(49);
var setToStringTag = __webpack_require__(61);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(26)(IteratorPrototype, __webpack_require__(17)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(17)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(36);
var gOPS = __webpack_require__(90);
var pIE = __webpack_require__(48);
var toObject = __webpack_require__(37);
var IObject = __webpack_require__(86);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(25)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(18);
var anObject = __webpack_require__(24);
var getKeys = __webpack_require__(36);

module.exports = __webpack_require__(19) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(32);
var gOPN = __webpack_require__(130).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(36);
var toIObject = __webpack_require__(32);
var isEnum = __webpack_require__(48).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(16);
var aFunction = __webpack_require__(120);
var ctx = __webpack_require__(30);
var forOf = __webpack_require__(59);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(16);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(21);
var anObject = __webpack_require__(24);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(30)(Function.call, __webpack_require__(129).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(20);
var core = __webpack_require__(12);
var dP = __webpack_require__(18);
var DESCRIPTORS = __webpack_require__(19);
var SPECIES = __webpack_require__(17)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(25);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(93);
var defined = __webpack_require__(84);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(93);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(24);
var get = __webpack_require__(97);
module.exports = __webpack_require__(12).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(82);
var ITERATOR = __webpack_require__(17)('iterator');
var Iterators = __webpack_require__(35);
module.exports = __webpack_require__(12).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(16);
var $filter = __webpack_require__(81)(2);

$export($export.P + $export.F * !__webpack_require__(280)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(16);
var $find = __webpack_require__(81)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(80)(KEY);


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(30);
var $export = __webpack_require__(16);
var toObject = __webpack_require__(37);
var call = __webpack_require__(127);
var isArrayIter = __webpack_require__(125);
var toLength = __webpack_require__(62);
var createProperty = __webpack_require__(267);
var getIterFn = __webpack_require__(97);

$export($export.S + $export.F * !__webpack_require__(271)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(80);
var step = __webpack_require__(128);
var Iterators = __webpack_require__(35);
var toIObject = __webpack_require__(32);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(87)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(16);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(272) });


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(16);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(60) });


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(16);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(19), 'Object', { defineProperty: __webpack_require__(18).f });


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(37);
var $getPrototypeOf = __webpack_require__(131);

__webpack_require__(133)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(37);
var $keys = __webpack_require__(36);

__webpack_require__(133)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(16);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(278).set });


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(264);
var validate = __webpack_require__(136);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(266)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(20);
var has = __webpack_require__(31);
var DESCRIPTORS = __webpack_require__(19);
var $export = __webpack_require__(16);
var redefine = __webpack_require__(135);
var META = __webpack_require__(89).KEY;
var $fails = __webpack_require__(25);
var shared = __webpack_require__(92);
var setToStringTag = __webpack_require__(61);
var uid = __webpack_require__(63);
var wks = __webpack_require__(17);
var wksExt = __webpack_require__(96);
var wksDefine = __webpack_require__(95);
var enumKeys = __webpack_require__(268);
var isArray = __webpack_require__(126);
var anObject = __webpack_require__(24);
var isObject = __webpack_require__(21);
var toIObject = __webpack_require__(32);
var toPrimitive = __webpack_require__(94);
var createDesc = __webpack_require__(49);
var _create = __webpack_require__(60);
var gOPNExt = __webpack_require__(274);
var $GOPD = __webpack_require__(129);
var $DP = __webpack_require__(18);
var $keys = __webpack_require__(36);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(130).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(48).f = $propertyIsEnumerable;
  __webpack_require__(90).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(88)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(26)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(16);
var $includes = __webpack_require__(122)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(80)('includes');


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(16);
var $entries = __webpack_require__(275)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(276)('Set');


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(277)('Set');


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(16);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(265)('Set') });


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(95)('asyncIterator');


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(95)('observable');


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, "/*===========================================================\n= Inputs                                                    =\n===========================================================*/\n.rrui__input-field,\n.rrui__select__button {\n  border: none;\n  border-bottom: 1px solid #C5D2E0;\n  -webkit-transition: border 0.1s;\n  transition: border 0.1s;\n}\n.rrui__input-field:focus,\n.rrui__select__button:focus,\n.rrui__select__native-expanded:focus + .rrui__select__button {\n  border-bottom-color: #03B2CB;\n}\n/*===========================================================\n= Input                                                     =\n===========================================================*/\n.rrui__input {\n  /* `position: relative` is for the floating label absolute positioning\n\t   and also for `.rrui__select__options width` sizing */\n  position: relative;\n}\n.rrui__input:not(.rrui__input--multiline),\n.rrui__input-label {\n  height: calc(1.8rem);\n}\n/* For native `<select/>` in Safari */\n.rrui__select__native {\n  min-height: calc(1.8rem);\n}\n.rrui__input-error {\n  margin-top: calc(0.3rem);\n  color: #D30F00;\n}\n/*===========================================================\n= Input field                                               =\n===========================================================*/\n.rrui__input-field {\n  outline: none;\n  border-radius: 0;\n  /* Some web browsers add <input/> padding by default */\n  padding: 0;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n}\n.rrui__input-field--invalid,\n.rrui__input-field--invalid:focus {\n  border-color: #EB2010;\n}\n.rrui__input-field--disabled {\n  cursor: default;\n}\n/*===========================================================\n= Buttons                                                   =\n===========================================================*/\n/* Reset the default `<button/>` styles */\n.rrui__select__button,\n.rrui__select__option,\n.rrui__select__close {\n  margin: 0;\n  padding: 0;\n  white-space: nowrap;\n  outline: none;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  border: none;\n  background: none;\n  cursor: pointer;\n  font-size: inherit;\n  font-family: inherit;\n  font-weight: inherit;\n  font-style: inherit;\n}\n/*===========================================================\n= Select                                                    =\n===========================================================*/\n.rrui__expandable {\n  opacity: 0;\n  pointer-events: none;\n  -webkit-transform: scaleY(0);\n          transform: scaleY(0);\n  -webkit-transform-origin: 50% top 0px;\n          transform-origin: 50% top 0px;\n  /* 250ms - too slow for short lists */\n  -webkit-transition: all 150ms cubic-bezier(0.76, 0.04, 0.46, 0.75) 0ms;\n  transition: all 150ms cubic-bezier(0.76, 0.04, 0.46, 0.75) 0ms;\n  /* prevent white background showing through the transparent border */\n  /* http://stackoverflow.com/questions/7473200/transparent-border-expands-background-color-image */\n  background-clip: padding-box;\n  -webkit-background-clip: padding-box;\n}\n.rrui__expandable--expanded {\n  opacity: 1;\n  pointer-events: auto;\n  -webkit-transform: scaleY(1);\n          transform: scaleY(1);\n  -webkit-transform-origin: 50% top 0px;\n          transform-origin: 50% top 0px;\n  -webkit-transition: all 150ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n  transition: all 150ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.rrui__expandable--overlay {\n  position: absolute;\n  z-index: 1;\n}\n.rrui__expandable__content {\n  /*\n\tThe inner block's `opacity` is animated too\n\t(it fades in and out by itself too).\n\tThis is done to fade out the inner block when the dropdown is collapsed\n\ttherefore hiding an otherwise bizarre and unwanted visual clutter\n\t*/\n  opacity: 0;\n  /* Mitigates inner content overlapping with itself creating a feeling of a mess */\n  -webkit-transition: opacity 150ms ease-out;\n  transition: opacity 150ms ease-out;\n}\n.rrui__expandable__content--expanded {\n  opacity: 1;\n}\n.rrui__shadow {\n  -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);\n          box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);\n}\n.rrui__select {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.rrui__select--menu {\n  position: relative;\n}\n.rrui__select__options {\n  margin: 0;\n  padding-left: 0;\n  padding-top: calc(0.6rem);\n  padding-bottom: calc(0.6rem);\n  overflow-y: auto;\n  background-color: white;\n  list-style-type: none;\n  overflow-x: hidden;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.rrui__expandable--left-aligned {\n  left: 0;\n}\n.rrui__expandable--right-aligned {\n  right: 0;\n}\n.rrui__select__options--left-aligned {\n  left: calc(-1.2rem);\n}\n.rrui__select__options--right-aligned {\n  right: calc(-1.2rem);\n}\n.rrui__select__options:not(.rrui__select__options--menu) {\n  width: calc(102.4%);\n}\n.rrui__select__options--downward {\n  /* When an html page is overflown by a long list\n\t   then this bottom margin helps to see that\n\t   there's no more options left out being clipped or something */\n  margin-bottom: 1em;\n}\n.rrui__select__options--upward {\n  bottom: 100%;\n  /* When an html page is overflown by a long list\n\t   then this bottom margin helps to see that\n\t   there's no more options left out being clipped or something */\n  margin-top: 1em;\n}\n.rrui__select__option {\n  display: block;\n  width: 100%;\n  padding-left: calc(1.2rem);\n  padding-right: calc(1.2rem);\n  padding-top: calc(0.3rem);\n  padding-bottom: calc(0.3rem);\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  text-align: left;\n  white-space: nowrap;\n}\n.rrui__select__option:hover {\n  background-color: #FBFDFD;\n}\n.rrui__select__button--disabled,\n.rrui__select__option--disabled {\n  cursor: default;\n}\n.rrui__select__option-icon {\n  margin-right: calc(0.9rem);\n}\n.rrui__select__options--upward {\n  -webkit-transform-origin: 50% bottom 0px;\n          transform-origin: 50% bottom 0px;\n}\n.rrui__select__option--focused {\n  background-color: #ECF1F6;\n}\n.rrui__select__option--focused:hover {\n  background-color: #EFF3F8;\n}\n.rrui__select__option:active {\n  background-color: #3678D1;\n  color: white;\n}\n.rrui__select__option-icon {\n  margin-right: 0.5em;\n}\n.rrui__select__toggler,\n.rrui__select__button,\n.rrui__select__autocomplete {\n  height: 100%;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.rrui__select__button {\n  border-bottom: 1px solid #C5D2E0;\n  -webkit-transition: border 0.1s;\n  transition: border 0.1s;\n  /* Because Chrome adds `text-align: center` for all buttons */\n  text-align: left;\n}\n.rrui__select__button:focus,\n.rrui__select__native-expanded:focus + .rrui__select__button {\n  border-bottom-color: #03B2CB;\n}\n.rrui__select__button:active {\n  color: #03B2CB;\n}\n.rrui__select__button--expanded {\n  color: #3678D1;\n}\n.rrui__select__button--empty {\n  color: #888C91;\n}\n.rrui__select__button,\n.rrui__select__option {\n  color: inherit;\n}\n/* Not introducing an animation on `.rrui__select__option`\n   because it would introduce a little clutter due to\n   focused option animation in autocomplete mode */\n.rrui__select__button {\n  -webkit-transition: color 30ms ease-out;\n  transition: color 30ms ease-out;\n}\n.rrui__select__selected-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.rrui__select__selected-label {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 0 auto;\n          flex: 1 0 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rrui__select__arrow {\n  width: 0;\n  height: 0;\n  margin-left: 0.35em;\n  margin-top: 0.1em;\n  margin-bottom: 0.1em;\n  opacity: 0.7;\n  -webkit-transition: opacity 100ms ease-out;\n  transition: opacity 100ms ease-out;\n  /* border-width: arrow_height arrow_width/2 0 arrow_width/2 */\n  border-width: 0.35em 0.2em 0 0.2em;\n  border-style: solid;\n  border-left-color: transparent;\n  border-right-color: transparent;\n  color: #B8BDC4;\n}\n.rrui__select__arrow--expanded {\n  opacity: 0.3;\n}\n.rrui__select__native-expanded {\n  position: absolute;\n  left: 0;\n  z-index: 1;\n  opacity: 0;\n  cursor: pointer;\n}\n.rrui__select__close {\n  /*\n\tSet `display` to `block` for fullscreen `.rrui__expandable` design.\n\tdisplay      : block;\n\t*/\n  display: none;\n  position: fixed;\n  top: 0;\n  right: 0;\n  z-index: 1;\n}\n.rrui__select__close-icon {\n  margin-top: calc(4.6rem);\n  margin-right: calc(4.6rem);\n  width: calc(1.5rem);\n  height: calc(1.5rem);\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/rrui.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/node_modules/react-phone-number-input/rrui.css"],"names":[],"mappings":"AAAA;;6DAE6D;ACE7D;;EAGC,aAAA;EACA,iCAAA;EACA,gCAAA;EAAA,wBAAA;CDDA;ACID;;;EAIC,6BAAA;CDHA;AACD;;6DAE6D;ACO7D;EDLE;yDACuD;ECQxD,mBAAA;CDNA;ACSD;;EAGC,qBAAA;CDRA;AACD,sCAAsC;ACWtC;EAEC,yBAAA;CDVA;ACaD;EAEC,yBAAA;EACA,eAAA;CDZA;AACD;;6DAE6D;ACgB7D;EAEC,cAAA;EACA,iBAAA;EDfC,uDAAuD;ECiBxD,WAAA;EACA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;CDfA;ACkBD;;EAGC,sBAAA;CDjBA;ACoBD;EAEC,gBAAA;CDnBA;AACD;;6DAE6D;AAC7D,0CAA0C;ACuB1C;;;EAIC,UAAA;EACA,WAAA;EACA,oBAAA;EACA,cAAA;EACA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;CDtBA;AACD;;6DAE6D;AC0B7D;EAEC,WAAA;EACA,qBAAA;EAEA,6BAAA;UAAA,qBAAA;EACA,sCAAA;UAAA,8BAAA;ED1BC,sCAAsC;EC6BvC,uEAAA;EAAA,+DAAA;ED3BC,qEAAqE;EACrE,kGAAkG;EC8BnG,6BAAA;EACA,qCAAA;CD5BA;AC+BD;EAEC,WAAA;EACA,qBAAA;EAEA,6BAAA;UAAA,qBAAA;EACA,sCAAA;UAAA,8BAAA;EAEA,iEAAA;EAAA,yDAAA;CDhCA;ACmCD;EAEC,mBAAA;EACA,WAAA;CDlCA;ACqCD;EDnCE;;;;;GAKC;ECsCF,WAAA;EDpCC,kFAAkF;ECuCnF,2CAAA;EAAA,mCAAA;CDrCA;ACwCD;EAEC,WAAA;CDvCA;AC0CD;EAEC,sFAAA;UAAA,8EAAA;CDzCA;AC4CD;EAEC,0BAAA;KAAA,uBAAA;MAAA,sBAAA;UAAA,kBAAA;CD3CA;AC8CD;EAEC,mBAAA;CD7CA;ACgDD;EAEC,UAAA;EACA,gBAAA;EACA,0BAAA;EACA,6BAAA;EACA,iBAAA;EACA,wBAAA;EACA,sBAAA;EACA,mBAAA;EACA,+BAAA;UAAA,uBAAA;CD/CA;ACkDD;EAEC,QAAA;CDjDA;ACoDD;EAEC,SAAA;CDnDA;ACsDD;EAEC,oBAAA;CDrDA;ACwDD;EAEC,qBAAA;CDvDA;AC0DD;EAEC,oBAAA;CDzDA;AC4DD;ED1DE;;kEAEgE;EC6DjE,mBAAA;CD3DA;AC8DD;EAEC,aAAA;ED7DC;;kEAEgE;ECgEjE,gBAAA;CD9DA;ACiED;EAEC,eAAA;EACA,YAAA;EAEA,2BAAA;EACA,4BAAA;EAEA,0BAAA;EACA,6BAAA;EAEA,+BAAA;UAAA,uBAAA;EACA,iBAAA;EACA,oBAAA;CDnEA;ACsED;EAEC,0BAAA;CDrEA;ACwED;;EAGC,gBAAA;CDvEA;AC0ED;EAEC,2BAAA;CDzEA;AC4ED;EAEC,yCAAA;UAAA,iCAAA;CD3EA;AC8ED;EAEC,0BAAA;CD7EA;ACgFD;EAEC,0BAAA;CD/EA;ACkFD;EAEC,0BAAA;EACA,aAAA;CDjFA;ACoFD;EAEC,oBAAA;CDnFA;ACsFD;;;EAIC,aAAA;EACA,+BAAA;UAAA,uBAAA;CDrFA;ACwFD;EAEC,iCAAA;EACA,gCAAA;EAAA,wBAAA;EDvFC,8DAA8D;EC0F/D,iBAAA;CDxFA;AC2FD;;EAGC,6BAAA;CD1FA;AC6FD;EAEC,eAAA;CD5FA;AC+FD;EAEC,eAAA;CD9FA;ACiGD;EAEC,eAAA;CDhGA;ACmGD;;EAGC,eAAA;CDlGA;AACD;;mDAEmD;ACqGnD;EAEC,wCAAA;EAAA,gCAAA;CDpGA;ACuGD;EAEC,qBAAA;EAAA,qBAAA;EAAA,cAAA;EACA,0BAAA;MAAA,uBAAA;UAAA,oBAAA;CDtGA;ACyGD;EAEC,oBAAA;MAAA,mBAAA;UAAA,eAAA;EACA,iBAAA;EACA,wBAAA;CDxGA;AC2GD;EAEC,SAAA;EACA,UAAA;EAEA,oBAAA;EACA,kBAAA;EACA,qBAAA;EAEA,aAAA;EAEA,2CAAA;EAAA,mCAAA;ED7GC,8DAA8D;ECgH/D,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,gCAAA;EAEA,eAAA;CDhHA;ACmHD;EAEC,aAAA;CDlHA;ACqHD;EAEC,mBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;CDpHA;ACuHD;EDrHE;;;GAGC;ECwHF,cAAA;EACA,gBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;CDtHA;ACyHD;EAEC,yBAAA;EACA,2BAAA;EACA,oBAAA;EACA,qBAAA;CDxHA","file":"rrui.css","sourcesContent":["/*===========================================================\n= Inputs                                                    =\n===========================================================*/\n.rrui__input-field,\n.rrui__select__button {\n  border: none;\n  border-bottom: 1px solid #C5D2E0;\n  transition: border 0.1s;\n}\n.rrui__input-field:focus,\n.rrui__select__button:focus,\n.rrui__select__native-expanded:focus + .rrui__select__button {\n  border-bottom-color: #03B2CB;\n}\n/*===========================================================\n= Input                                                     =\n===========================================================*/\n.rrui__input {\n  /* `position: relative` is for the floating label absolute positioning\n\t   and also for `.rrui__select__options width` sizing */\n  position: relative;\n}\n.rrui__input:not(.rrui__input--multiline),\n.rrui__input-label {\n  height: calc(1.8rem);\n}\n/* For native `<select/>` in Safari */\n.rrui__select__native {\n  min-height: calc(1.8rem);\n}\n.rrui__input-error {\n  margin-top: calc(0.3rem);\n  color: #D30F00;\n}\n/*===========================================================\n= Input field                                               =\n===========================================================*/\n.rrui__input-field {\n  outline: none;\n  border-radius: 0;\n  /* Some web browsers add <input/> padding by default */\n  padding: 0;\n  appearance: none;\n}\n.rrui__input-field--invalid,\n.rrui__input-field--invalid:focus {\n  border-color: #EB2010;\n}\n.rrui__input-field--disabled {\n  cursor: default;\n}\n/*===========================================================\n= Buttons                                                   =\n===========================================================*/\n/* Reset the default `<button/>` styles */\n.rrui__select__button,\n.rrui__select__option,\n.rrui__select__close {\n  margin: 0;\n  padding: 0;\n  white-space: nowrap;\n  outline: none;\n  appearance: none;\n  border: none;\n  background: none;\n  cursor: pointer;\n  font-size: inherit;\n  font-family: inherit;\n  font-weight: inherit;\n  font-style: inherit;\n}\n/*===========================================================\n= Select                                                    =\n===========================================================*/\n.rrui__expandable {\n  opacity: 0;\n  pointer-events: none;\n  transform: scaleY(0);\n  transform-origin: 50% top 0px;\n  /* 250ms - too slow for short lists */\n  transition: all 150ms cubic-bezier(0.76, 0.04, 0.46, 0.75) 0ms;\n  /* prevent white background showing through the transparent border */\n  /* http://stackoverflow.com/questions/7473200/transparent-border-expands-background-color-image */\n  background-clip: padding-box;\n  -webkit-background-clip: padding-box;\n}\n.rrui__expandable--expanded {\n  opacity: 1;\n  pointer-events: auto;\n  transform: scaleY(1);\n  transform-origin: 50% top 0px;\n  transition: all 150ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n.rrui__expandable--overlay {\n  position: absolute;\n  z-index: 1;\n}\n.rrui__expandable__content {\n  /*\n\tThe inner block's `opacity` is animated too\n\t(it fades in and out by itself too).\n\tThis is done to fade out the inner block when the dropdown is collapsed\n\ttherefore hiding an otherwise bizarre and unwanted visual clutter\n\t*/\n  opacity: 0;\n  /* Mitigates inner content overlapping with itself creating a feeling of a mess */\n  transition: opacity 150ms ease-out;\n}\n.rrui__expandable__content--expanded {\n  opacity: 1;\n}\n.rrui__shadow {\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);\n}\n.rrui__select {\n  user-select: none;\n}\n.rrui__select--menu {\n  position: relative;\n}\n.rrui__select__options {\n  margin: 0;\n  padding-left: 0;\n  padding-top: calc(0.6rem);\n  padding-bottom: calc(0.6rem);\n  overflow-y: auto;\n  background-color: white;\n  list-style-type: none;\n  overflow-x: hidden;\n  box-sizing: border-box;\n}\n.rrui__expandable--left-aligned {\n  left: 0;\n}\n.rrui__expandable--right-aligned {\n  right: 0;\n}\n.rrui__select__options--left-aligned {\n  left: calc(-1.2rem);\n}\n.rrui__select__options--right-aligned {\n  right: calc(-1.2rem);\n}\n.rrui__select__options:not(.rrui__select__options--menu) {\n  width: calc(102.4%);\n}\n.rrui__select__options--downward {\n  /* When an html page is overflown by a long list\n\t   then this bottom margin helps to see that\n\t   there's no more options left out being clipped or something */\n  margin-bottom: 1em;\n}\n.rrui__select__options--upward {\n  bottom: 100%;\n  /* When an html page is overflown by a long list\n\t   then this bottom margin helps to see that\n\t   there's no more options left out being clipped or something */\n  margin-top: 1em;\n}\n.rrui__select__option {\n  display: block;\n  width: 100%;\n  padding-left: calc(1.2rem);\n  padding-right: calc(1.2rem);\n  padding-top: calc(0.3rem);\n  padding-bottom: calc(0.3rem);\n  box-sizing: border-box;\n  text-align: left;\n  white-space: nowrap;\n}\n.rrui__select__option:hover {\n  background-color: #FBFDFD;\n}\n.rrui__select__button--disabled,\n.rrui__select__option--disabled {\n  cursor: default;\n}\n.rrui__select__option-icon {\n  margin-right: calc(0.9rem);\n}\n.rrui__select__options--upward {\n  transform-origin: 50% bottom 0px;\n}\n.rrui__select__option--focused {\n  background-color: #ECF1F6;\n}\n.rrui__select__option--focused:hover {\n  background-color: #EFF3F8;\n}\n.rrui__select__option:active {\n  background-color: #3678D1;\n  color: white;\n}\n.rrui__select__option-icon {\n  margin-right: 0.5em;\n}\n.rrui__select__toggler,\n.rrui__select__button,\n.rrui__select__autocomplete {\n  height: 100%;\n  box-sizing: border-box;\n}\n.rrui__select__button {\n  border-bottom: 1px solid #C5D2E0;\n  transition: border 0.1s;\n  /* Because Chrome adds `text-align: center` for all buttons */\n  text-align: left;\n}\n.rrui__select__button:focus,\n.rrui__select__native-expanded:focus + .rrui__select__button {\n  border-bottom-color: #03B2CB;\n}\n.rrui__select__button:active {\n  color: #03B2CB;\n}\n.rrui__select__button--expanded {\n  color: #3678D1;\n}\n.rrui__select__button--empty {\n  color: #888C91;\n}\n.rrui__select__button,\n.rrui__select__option {\n  color: inherit;\n}\n/* Not introducing an animation on `.rrui__select__option`\n   because it would introduce a little clutter due to\n   focused option animation in autocomplete mode */\n.rrui__select__button {\n  transition: color 30ms ease-out;\n}\n.rrui__select__selected-content {\n  display: flex;\n  align-items: center;\n}\n.rrui__select__selected-label {\n  flex: 1 0 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rrui__select__arrow {\n  width: 0;\n  height: 0;\n  margin-left: 0.35em;\n  margin-top: 0.1em;\n  margin-bottom: 0.1em;\n  opacity: 0.7;\n  transition: opacity 100ms ease-out;\n  /* border-width: arrow_height arrow_width/2 0 arrow_width/2 */\n  border-width: 0.35em 0.2em 0 0.2em;\n  border-style: solid;\n  border-left-color: transparent;\n  border-right-color: transparent;\n  color: #B8BDC4;\n}\n.rrui__select__arrow--expanded {\n  opacity: 0.3;\n}\n.rrui__select__native-expanded {\n  position: absolute;\n  left: 0;\n  z-index: 1;\n  opacity: 0;\n  cursor: pointer;\n}\n.rrui__select__close {\n  /*\n\tSet `display` to `block` for fullscreen `.rrui__expandable` design.\n\tdisplay      : block;\n\t*/\n  display: none;\n  position: fixed;\n  top: 0;\n  right: 0;\n  z-index: 1;\n}\n.rrui__select__close-icon {\n  margin-top: calc(4.6rem);\n  margin-right: calc(4.6rem);\n  width: calc(1.5rem);\n  height: calc(1.5rem);\n}\n","/*===========================================================\n= Inputs                                                    =\n===========================================================*/\n\n.rrui__input-field,\n.rrui__select__button\n{\n\tborder        : none;\n\tborder-bottom : 1px solid #C5D2E0;\n\ttransition    : border 0.1s;\n}\n\n.rrui__input-field:focus,\n.rrui__select__button:focus,\n.rrui__select__native-expanded:focus + .rrui__select__button\n{\n\tborder-bottom-color: #03B2CB;\n}\n\n/*===========================================================\n= Input                                                     =\n===========================================================*/\n\n.rrui__input\n{\n\t/* `position: relative` is for the floating label absolute positioning\n\t   and also for `.rrui__select__options width` sizing */\n\tposition : relative;\n}\n\n.rrui__input:not(.rrui__input--multiline),\n.rrui__input-label\n{\n\theight : calc(0.3rem * 6);\n}\n\n/* For native `<select/>` in Safari */\n.rrui__select__native\n{\n\tmin-height : calc(0.3rem * 6);\n}\n\n.rrui__input-error\n{\n\tmargin-top : calc(0.3rem);\n\tcolor      : #D30F00;\n}\n\n/*===========================================================\n= Input field                                               =\n===========================================================*/\n\n.rrui__input-field\n{\n\toutline       : none;\n\tborder-radius : 0;\n\t/* Some web browsers add <input/> padding by default */\n\tpadding       : 0;\n\tappearance    : none;\n}\n\n.rrui__input-field--invalid,\n.rrui__input-field--invalid:focus\n{\n\tborder-color: #EB2010;\n}\n\n.rrui__input-field--disabled\n{\n\tcursor: default;\n}\n\n/*===========================================================\n= Buttons                                                   =\n===========================================================*/\n\n/* Reset the default `<button/>` styles */\n.rrui__select__button,\n.rrui__select__option,\n.rrui__select__close\n{\n\tmargin      : 0;\n\tpadding     : 0;\n\twhite-space : nowrap;\n\toutline     : none;\n\tappearance  : none;\n\tborder      : none;\n\tbackground  : none;\n\tcursor      : pointer;\n\tfont-size   : inherit;\n\tfont-family : inherit;\n\tfont-weight : inherit;\n\tfont-style  : inherit;\n}\n\n/*===========================================================\n= Select                                                    =\n===========================================================*/\n\n.rrui__expandable\n{\n\topacity : 0;\n\tpointer-events : none;\n\n\ttransform        : scaleY(0);\n\ttransform-origin : 50% top 0px;\n\n\t/* 250ms - too slow for short lists */\n\ttransition : all 150ms cubic-bezier(.76,.04,.46,.75) 0ms;\n\n\t/* prevent white background showing through the transparent border */\n\t/* http://stackoverflow.com/questions/7473200/transparent-border-expands-background-color-image */\n\tbackground-clip         : padding-box;\n\t-webkit-background-clip : padding-box;\n}\n\n.rrui__expandable--expanded\n{\n\topacity        : 1;\n\tpointer-events : auto;\n\n\ttransform        : scaleY(1);\n\ttransform-origin : 50% top 0px;\n\n\ttransition : all 150ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n\n.rrui__expandable--overlay\n{\n\tposition : absolute;\n\tz-index  : 1;\n}\n\n.rrui__expandable__content\n{\n\t/*\n\tThe inner block's `opacity` is animated too\n\t(it fades in and out by itself too).\n\tThis is done to fade out the inner block when the dropdown is collapsed\n\ttherefore hiding an otherwise bizarre and unwanted visual clutter\n\t*/\n\topacity: 0;\n\n\t/* Mitigates inner content overlapping with itself creating a feeling of a mess */\n\ttransition: opacity 150ms ease-out;\n}\n\n.rrui__expandable__content--expanded\n{\n\topacity: 1;\n}\n\n.rrui__shadow\n{\n\tbox-shadow : 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);\n}\n\n.rrui__select\n{\n\tuser-select : none;\n}\n\n.rrui__select--menu\n{\n\tposition : relative;\n}\n\n.rrui__select__options\n{\n\tmargin           : 0;\n\tpadding-left     : 0;\n\tpadding-top      : calc(2 * 0.3rem);\n\tpadding-bottom   : calc(2 * 0.3rem);\n\toverflow-y       : auto;\n\tbackground-color : white;\n\tlist-style-type  : none;\n\toverflow-x       : hidden;\n\tbox-sizing       : border-box;\n}\n\n.rrui__expandable--left-aligned\n{\n\tleft : 0;\n}\n\n.rrui__expandable--right-aligned\n{\n\tright : 0;\n}\n\n.rrui__select__options--left-aligned\n{\n\tleft : calc(0.3rem * 4 * -1);\n}\n\n.rrui__select__options--right-aligned\n{\n\tright : calc(0.3rem * 4 * -1);\n}\n\n.rrui__select__options:not(.rrui__select__options--menu)\n{\n\twidth : calc(100% + 0.3rem * 4 * 2);\n}\n\n.rrui__select__options--downward\n{\n\t/* When an html page is overflown by a long list\n\t   then this bottom margin helps to see that\n\t   there's no more options left out being clipped or something */\n\tmargin-bottom : 1em;\n}\n\n.rrui__select__options--upward\n{\n\tbottom : 100%;\n\n\t/* When an html page is overflown by a long list\n\t   then this bottom margin helps to see that\n\t   there's no more options left out being clipped or something */\n\tmargin-top : 1em;\n}\n\n.rrui__select__option\n{\n\tdisplay : block;\n\twidth   : 100%;\n\n\tpadding-left  : calc(0.3rem * 4);\n\tpadding-right : calc(0.3rem * 4);\n\n\tpadding-top    : calc(0.3rem * 1);\n\tpadding-bottom : calc(0.3rem * 1);\n\n\tbox-sizing  : border-box;\n\ttext-align  : left;\n\twhite-space : nowrap;\n}\n\n.rrui__select__option:hover\n{\n\tbackground-color : #FBFDFD;\n}\n\n.rrui__select__button--disabled,\n.rrui__select__option--disabled\n{\n\tcursor : default;\n}\n\n.rrui__select__option-icon\n{\n\tmargin-right : calc(0.3rem * 3);\n}\n\n.rrui__select__options--upward\n{\n\ttransform-origin: 50% bottom 0px;\n}\n\n.rrui__select__option--focused\n{\n\tbackground-color: #ECF1F6;\n}\n\n.rrui__select__option--focused:hover\n{\n\tbackground-color: #EFF3F8;\n}\n\n.rrui__select__option:active\n{\n\tbackground-color : #3678D1;\n\tcolor            : white;\n}\n\n.rrui__select__option-icon\n{\n\tmargin-right: 0.5em\n}\n\n.rrui__select__toggler,\n.rrui__select__button,\n.rrui__select__autocomplete\n{\n\theight     : 100%;\n\tbox-sizing : border-box;\n}\n\n.rrui__select__button\n{\n\tborder-bottom : 1px solid #C5D2E0;\n\ttransition    : border 0.1s;\n\n\t/* Because Chrome adds `text-align: center` for all buttons */\n\ttext-align : left;\n}\n\n.rrui__select__button:focus,\n.rrui__select__native-expanded:focus + .rrui__select__button\n{\n\tborder-bottom-color: #03B2CB;\n}\n\n.rrui__select__button:active\n{\n\tcolor: #03B2CB;\n}\n\n.rrui__select__button--expanded\n{\n\tcolor: #3678D1;\n}\n\n.rrui__select__button--empty\n{\n\tcolor: #888C91;\n}\n\n.rrui__select__button,\n.rrui__select__option\n{\n\tcolor : inherit;\n}\n\n/* Not introducing an animation on `.rrui__select__option`\n   because it would introduce a little clutter due to\n   focused option animation in autocomplete mode */\n.rrui__select__button\n{\n\ttransition : color 30ms ease-out;\n}\n\n.rrui__select__selected-content\n{\n\tdisplay     : flex;\n\talign-items : center;\n}\n\n.rrui__select__selected-label\n{\n\tflex          : 1 0 auto;\n\toverflow      : hidden;\n\ttext-overflow : ellipsis;\n}\n\n.rrui__select__arrow\n{\n\twidth  : 0;\n\theight : 0;\n\n\tmargin-left   : 0.35em;\n\tmargin-top    : 0.1em;\n\tmargin-bottom : 0.1em;\n\n\topacity: 0.7;\n\n\ttransition: opacity 100ms ease-out;\n\n\t/* border-width: arrow_height arrow_width/2 0 arrow_width/2 */\n\tborder-width : 0.35em 0.2em 0 0.2em;\n\n\tborder-style       : solid;\n\tborder-left-color  : transparent;\n\tborder-right-color : transparent;\n\n\tcolor: #B8BDC4;\n}\n\n.rrui__select__arrow--expanded\n{\n\topacity: 0.3;\n}\n\n.rrui__select__native-expanded\n{\n\tposition : absolute;\n\tleft     : 0;\n\tz-index  : 1;\n\topacity  : 0;\n\tcursor   : pointer;\n}\n\n.rrui__select__close\n{\n\t/*\n\tSet `display` to `block` for fullscreen `.rrui__expandable` design.\n\tdisplay      : block;\n\t*/\n\tdisplay      : none;\n\tposition     : fixed;\n\ttop          : 0;\n\tright        : 0;\n\tz-index      : 1;\n}\n\n.rrui__select__close-icon\n{\n\tmargin-top   : calc(0.3rem * 2 + 4px);\n\tmargin-right : calc(0.3rem * 2 + 4px);\n\twidth        : calc(0.3rem * 5);\n\theight       : calc(0.3rem * 5);\n}"],"sourceRoot":""}]);

// exports


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".react-phone-number-input__row {\n  /* This is done to stretch `.rrui__select__options` */\n  /* to the full width of `.react-phone-number-input__phone` */\n  position: relative;\n  /* This is done to stretch the contents of this component */\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n/* Overrides `width: 100%` setting from `react-resonsive-ui` */\n.react-phone-number-input__country {\n  width: auto;\n}\n/* The phone number input stretches to fill all empty space */\n.react-phone-number-input__phone,\n.react-phone-number-input__country.rrui__select--expanded {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n.react-phone-number-input__phone {\n  font-size: inherit;\n}\n.react-phone-number-input__country.rrui__select--collapsed {\n  margin-right: 0.5em;\n}\n.react-phone-number-input__country .rrui__select__autocomplete {\n  width: 100%;\n}\n.react-phone-number-input__country,\n.react-phone-number-input__country:not(.react-phone-number-input__country--native-expanded) .rrui__input {\n  /* This is done to stretch `.rrui__select__options` */\n  /* to the full width of `.react-phone-number-input__phone` */\n  /* rather than to the full width of `.rrui__select` */\n  /* because the `.rrui__select` is contracted */\n  /* as soon as a user selects a country which caused */\n  /* the `.rrui__select__options` to contract too */\n  /* while the list collapse animation is still in progress. */\n  /* The `position: relative` container is now `.react-phone-number-input`. */\n  /* The `:not(.react-phone-number-input__country--native-expanded)` selector */\n  /* is required because native `<select/>` is positioned absolutely. */\n  position: static;\n}\n.react-phone-number-input .rrui__select__arrow {\n  margin-top: 0.3em;\n  margin-left: 0.3em;\n}\n.react-phone-number-input .rrui__select__option {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.react-phone-number-input .rrui__select__option-icon {\n  margin-bottom: 0.1em;\n}\n.react-phone-number-input__icon {\n  /* The flag icon size is 4x3 hence the exact `width` and `height` values */\n  width: 1.24em;\n  height: 0.93em;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  /* Makes sure `width`x`height` is exactly `4x3` and `border` width is not included in it */\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n}\n.react-phone-number-input__icon--international {\n  /* The international icon size is square */\n  /* and also has no border hence the `2 * 1px` `width` and `height` compensation */\n  width: calc(2.93em);\n  height: calc(2.93em);\n  /* The international icon size is square hence the exact `padding` value */\n  /* for precise alignment with `4x3` sized country flags. */\n  padding-left: 0.155em;\n  padding-right: 0.155em;\n  border: none;\n}\n.react-phone-number-input__error {\n  margin-left: calc(2.93em);\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/node_modules/react-phone-number-input/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css"],"names":[],"mappings":"AAAA;ECCE,sDAAsD;EACtD,6DAA6D;EDE9D,mBAAA;ECAC,4DAA4D;EDG7D,qBAAA;EAAA,qBAAA;EAAA,cAAA;EACA,0BAAA;MAAA,uBAAA;UAAA,oBAAA;CCDA;AACD,+DAA+D;ADI/D;EAEC,YAAA;CCHA;AACD,8DAA8D;ADM9D;;EAIC,oBAAA;MAAA,YAAA;UAAA,QAAA;CCNA;ADSD;EAEC,mBAAA;CCRA;ADWD;EAEC,oBAAA;CCVA;ADaD;EAEC,YAAA;CCZA;ADeD;;ECZE,sDAAsD;EACtD,6DAA6D;EAC7D,sDAAsD;EACtD,+CAA+C;EAC/C,sDAAsD;EACtD,kDAAkD;EAClD,6DAA6D;EAC7D,4EAA4E;EAC5E,8EAA8E;EAC9E,sEAAsE;EDgBvE,iBAAA;CCdA;ADiBD;EAEC,kBAAA;EACA,mBAAA;CChBA;ADmBD;EAEC,qBAAA;EAAA,qBAAA;EAAA,cAAA;EACA,0BAAA;MAAA,uBAAA;UAAA,oBAAA;CClBA;ADqBD;EAEC,qBAAA;CCpBA;ADuBD;ECrBE,2EAA2E;EDwB5E,cAAA;EACA,eAAA;EAEA,sCAAA;ECvBC,2FAA2F;EDyB5F,gCAAA;UAAA,wBAAA;CCvBA;AD0BD;ECxBE,2CAA2C;EAC3C,kFAAkF;ED2BnF,oBAAA;EACA,qBAAA;ECzBC,2EAA2E;EAC3E,2DAA2D;ED4B5D,sBAAA;EACA,uBAAA;EAEA,aAAA;CC3BA;AD8BD;EAEC,0BAAA;CC7BA","file":"style.css","sourcesContent":[".react-phone-number-input__row\n{\n\t/* This is done to stretch `.rrui__select__options` */\n\t/* to the full width of `.react-phone-number-input__phone` */\n\tposition    : relative;\n\n\t/* This is done to stretch the contents of this component */\n\tdisplay     : flex;\n\talign-items : center;\n}\n\n/* Overrides `width: 100%` setting from `react-resonsive-ui` */\n.react-phone-number-input__country\n{\n\twidth : auto;\n}\n\n/* The phone number input stretches to fill all empty space */\n.react-phone-number-input__phone,\n/* The country select, when expanded, stretches to fill all empty space */\n.react-phone-number-input__country.rrui__select--expanded\n{\n\tflex : 1;\n}\n\n.react-phone-number-input__phone\n{\n\tfont-size : inherit;\n}\n\n.react-phone-number-input__country.rrui__select--collapsed\n{\n\tmargin-right : 0.5em;\n}\n\n.react-phone-number-input__country .rrui__select__autocomplete\n{\n\twidth : 100%;\n}\n\n.react-phone-number-input__country,\n.react-phone-number-input__country:not(.react-phone-number-input__country--native-expanded) .rrui__input\n{\n\t/* This is done to stretch `.rrui__select__options` */\n\t/* to the full width of `.react-phone-number-input__phone` */\n\t/* rather than to the full width of `.rrui__select` */\n\t/* because the `.rrui__select` is contracted */\n\t/* as soon as a user selects a country which caused */\n\t/* the `.rrui__select__options` to contract too */\n\t/* while the list collapse animation is still in progress. */\n\t/* The `position: relative` container is now `.react-phone-number-input`. */\n\t/* The `:not(.react-phone-number-input__country--native-expanded)` selector */\n\t/* is required because native `<select/>` is positioned absolutely. */\n\tposition : static;\n}\n\n.react-phone-number-input .rrui__select__arrow\n{\n\tmargin-top  : 0.3em;\n\tmargin-left : 0.3em;\n}\n\n.react-phone-number-input .rrui__select__option\n{\n\tdisplay     : flex;\n\talign-items : center;\n}\n\n.react-phone-number-input .rrui__select__option-icon\n{\n\tmargin-bottom : 0.1em;\n}\n\n.react-phone-number-input__icon\n{\n\t/* The flag icon size is 4x3 hence the exact `width` and `height` values */\n\twidth      : 1.24em;\n\theight     : 0.93em;\n\n\tborder     : 1px solid rgba(0, 0, 0, 0.25);\n\t/* Makes sure `width`x`height` is exactly `4x3` and `border` width is not included in it */\n\tbox-sizing : content-box;\n}\n\n.react-phone-number-input__icon--international\n{\n\t/* The international icon size is square */\n\t/* and also has no border hence the `2 * 1px` `width` and `height` compensation */\n\twidth         : calc(0.93em + 2px);\n\theight        : calc(0.93em + 2px);\n\n\t/* The international icon size is square hence the exact `padding` value */\n\t/* for precise alignment with `4x3` sized country flags. */\n\tpadding-left  : 0.155em;\n\tpadding-right : 0.155em;\n\n\tborder : none;\n}\n\n.react-phone-number-input__error\n{\n\tmargin-left : calc(0.93em + 2px);\n}",".react-phone-number-input__row {\n  /* This is done to stretch `.rrui__select__options` */\n  /* to the full width of `.react-phone-number-input__phone` */\n  position: relative;\n  /* This is done to stretch the contents of this component */\n  display: flex;\n  align-items: center;\n}\n/* Overrides `width: 100%` setting from `react-resonsive-ui` */\n.react-phone-number-input__country {\n  width: auto;\n}\n/* The phone number input stretches to fill all empty space */\n.react-phone-number-input__phone,\n.react-phone-number-input__country.rrui__select--expanded {\n  flex: 1;\n}\n.react-phone-number-input__phone {\n  font-size: inherit;\n}\n.react-phone-number-input__country.rrui__select--collapsed {\n  margin-right: 0.5em;\n}\n.react-phone-number-input__country .rrui__select__autocomplete {\n  width: 100%;\n}\n.react-phone-number-input__country,\n.react-phone-number-input__country:not(.react-phone-number-input__country--native-expanded) .rrui__input {\n  /* This is done to stretch `.rrui__select__options` */\n  /* to the full width of `.react-phone-number-input__phone` */\n  /* rather than to the full width of `.rrui__select` */\n  /* because the `.rrui__select` is contracted */\n  /* as soon as a user selects a country which caused */\n  /* the `.rrui__select__options` to contract too */\n  /* while the list collapse animation is still in progress. */\n  /* The `position: relative` container is now `.react-phone-number-input`. */\n  /* The `:not(.react-phone-number-input__country--native-expanded)` selector */\n  /* is required because native `<select/>` is positioned absolutely. */\n  position: static;\n}\n.react-phone-number-input .rrui__select__arrow {\n  margin-top: 0.3em;\n  margin-left: 0.3em;\n}\n.react-phone-number-input .rrui__select__option {\n  display: flex;\n  align-items: center;\n}\n.react-phone-number-input .rrui__select__option-icon {\n  margin-bottom: 0.1em;\n}\n.react-phone-number-input__icon {\n  /* The flag icon size is 4x3 hence the exact `width` and `height` values */\n  width: 1.24em;\n  height: 0.93em;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  /* Makes sure `width`x`height` is exactly `4x3` and `border` width is not included in it */\n  box-sizing: content-box;\n}\n.react-phone-number-input__icon--international {\n  /* The international icon size is square */\n  /* and also has no border hence the `2 * 1px` `width` and `height` compensation */\n  width: calc(2.93em);\n  height: calc(2.93em);\n  /* The international icon size is square hence the exact `padding` value */\n  /* for precise alignment with `4x3` sized country flags. */\n  padding-left: 0.155em;\n  padding-right: 0.155em;\n  border: none;\n}\n.react-phone-number-input__error {\n  margin-left: calc(2.93em);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-Camera-Permissions\\/Primer-absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.onfido-sdk-ui-Camera-Permissions\\/Primer-text {\n  margin-top: 64px;\n  margin-bottom: 80px;\n}\n.onfido-sdk-ui-Camera-Permissions\\/Primer-image {\n  border-radius: 3px;\n  border: 1px solid #D8D8D8;\n  font-size: 14px;\n  margin: 30px 0 8px;\n}\n.onfido-sdk-ui-Camera-Permissions\\/Primer-image p {\n  margin: 16px;\n}\n.onfido-sdk-ui-Camera-Permissions\\/Primer-reasons {\n  text-align: center;\n  font-size: 14px;\n  min-height: 3em;\n}\n.onfido-sdk-ui-Camera-Permissions\\/Primer-reason {\n  margin-top: 8px;\n}\n.onfido-sdk-ui-Camera-Permissions\\/Primer-graphic {\n  border: 1px solid #DFE0E0;\n  border-radius: 5px;\n  background-color: #fff;\n  -webkit-box-shadow: 0 3px 6px #D8D8D8;\n          box-shadow: 0 3px 6px #D8D8D8;\n  background-image: url(\"data:image/svg+xml,%3Csvg width%3D%22275%22 height%3D%22121%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg transform%3D%22translate(2 2)%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E%3Cpath d%3D%22M.435 68.118H272.03M137.608 118.889V68.156%22 stroke%3D%22%23DFE0E0%22%2F%3E%3Crect fill%3D%22%23D8D8D8%22 x%3D%2236%22 y%3D%2219%22 width%3D%22200%22 height%3D%2210%22 rx%3D%225%22%2F%3E%3Crect fill%3D%22%23D8D8D8%22 x%3D%2249%22 y%3D%2237%22 width%3D%22175%22 height%3D%2210%22 rx%3D%225%22%2F%3E%3Cpath d%3D%22M36 88h65a5 5 0 1 1 0 10H36a5 5 0 0 1 0-10z%22 fill%3D%22%23D8D8D8%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\n  background-repeat: no-repeat;\n  background-size: 100%;\n  height: 121px;\n  margin: 0 auto 30px;\n  position: relative;\n  width: 270px;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Camera-Permissions\\/Primer-graphic {\n    height: 100px;\n    width: 224px;\n  }\n}\n.onfido-sdk-ui-Camera-Permissions\\/Primer-allow {\n  top: 70%;\n  position: absolute;\n  right: 0;\n  text-align: center;\n  width: 50%;\n  font-weight: 600;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Camera-Permissions\\/Primer-allow {\n    top: 65%;\n  }\n}\n.onfido-sdk-ui-Camera-Permissions\\/Primer-allow::after {\n  content: '';\n  border: 4px solid #00C9A1;\n  width: 80px;\n  height: 80px;\n  border-radius: 100%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Theme/constants.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Camera/Permissions/Primer/style.css"],"names":[],"mappings":"AAMA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;CCFD;ACRD;EACE,iBAAA;EACA,oBAAA;CDUD;ACPD;EACE,mBAAA;EACA,0BAAA;EACA,gBAAA;EACA,mBAAA;CDSD;ACND;EACE,aAAA;CDQD;ACLD;EACE,mBAAA;EACA,gBAAA;EACA,gBAAA;CDOD;ACJD;EACE,gBAAA;CDMD;ACHD;EACE,0BAAA;EACA,mBAAA;EACA,uBAAA;EACA,sCAAA;UAAA,8BAAA;EACA,2oBAAA;EACA,6BAAA;EACA,sBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,aAAA;CDKD;ACHC;EA6BD;IA5BG,cAAA;IACA,aAAA;GDMD;CACF;ACHD;EACE,SAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;CDKD;ACHC;EAeD;IAdG,SAAA;GDMD;CACF;ACHD;EACE,YAAA;EACA,0BAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,yCAAA;UAAA,iCAAA;CDKD","file":"style.css","sourcesContent":["@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n@large-text-margin: 40px;\n@small-text-margin: 24px;\n\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.width-parent-relative(@base-width,@parent-width) {\n  width: 100%*(@base-width/@parent-width)\n}\n","@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.text {\n  margin-top: 64px;\n  margin-bottom: 80px;\n}\n.image {\n  border-radius: 3px;\n  border: 1px solid #D8D8D8;\n  font-size: 14px;\n  margin: 30px 0 8px;\n}\n.image p {\n  margin: 16px;\n}\n.reasons {\n  text-align: center;\n  font-size: 14px;\n  min-height: 3em;\n}\n.reason {\n  margin-top: 8px;\n}\n.graphic {\n  border: 1px solid #DFE0E0;\n  border-radius: 5px;\n  background-color: #fff;\n  box-shadow: 0 3px 6px #D8D8D8;\n  background-image: url('assets/allow.svg');\n  background-repeat: no-repeat;\n  background-size: 100%;\n  height: 121px;\n  margin: 0 auto 30px;\n  position: relative;\n  width: 270px;\n}\n@media (--small-viewport) {\n  .graphic {\n    height: 100px;\n    width: 224px;\n  }\n}\n.allow {\n  top: 70%;\n  position: absolute;\n  right: 0;\n  text-align: center;\n  width: 50%;\n  font-weight: 600;\n}\n@media (--small-viewport) {\n  .allow {\n    top: 65%;\n  }\n}\n.allow::after {\n  content: '';\n  border: 4px solid #00C9A1;\n  width: 80px;\n  height: 80px;\n  border-radius: 100%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n","@import (less) \"../../../Theme/constants.css\";\n\n.text {\n  margin-top: 64px;\n  margin-bottom: 80px;\n}\n\n.image {\n  border-radius: 3px;\n  border: 1px solid #D8D8D8;\n  font-size: 14px;\n  margin: 30px 0 8px;\n}\n\n.image p {\n  margin: 16px;\n}\n\n.reasons {\n  text-align: center;\n  font-size: 14px;\n  min-height: 3em;\n}\n\n.reason {\n  margin-top: 8px;\n}\n\n.graphic {\n  border: 1px solid #DFE0E0;\n  border-radius: 5px;\n  background-color: #fff;\n  box-shadow: 0 3px 6px #D8D8D8;\n  background-image: url('assets/allow.svg');\n  background-repeat: no-repeat;\n  background-size: 100%;\n  height: 121px;\n  margin: 0 auto 30px;\n  position: relative;\n  width: 270px;\n\n  @media (--small-viewport) {\n    height: 100px;\n    width: 224px;\n  }\n}\n\n.allow {\n  top: 70%;\n  position: absolute;\n  right: 0;\n  text-align: center;\n  width: 50%;\n  font-weight: 600;\n\n  @media (--small-viewport) {\n    top: 65%;\n  }\n}\n\n.allow::after {\n  content: '';\n  border: 4px solid #00C9A1;\n  width: 80px;\n  height: 80px;\n  border-radius: 100%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"absolute-center": "onfido-sdk-ui-Camera-Permissions/Primer-absolute-center",
	"text": "onfido-sdk-ui-Camera-Permissions/Primer-text",
	"image": "onfido-sdk-ui-Camera-Permissions/Primer-image",
	"reasons": "onfido-sdk-ui-Camera-Permissions/Primer-reasons",
	"reason": "onfido-sdk-ui-Camera-Permissions/Primer-reason",
	"graphic": "onfido-sdk-ui-Camera-Permissions/Primer-graphic",
	"allow": "onfido-sdk-ui-Camera-Permissions/Primer-allow"
};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-Camera-Permissions\\/Recover-absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.onfido-sdk-ui-Camera-Permissions\\/Recover-text {\n  margin-top: 64px;\n  margin-bottom: 80px;\n}\n.onfido-sdk-ui-Camera-Permissions\\/Recover-instructions {\n  text-align: left;\n  border-radius: 3px;\n  border: 1px solid #D8D8D8;\n  font-size: 14px;\n  margin: 30px 0 24px;\n  position: relative;\n  padding: 24px 24px 12px;\n}\n.onfido-sdk-ui-Camera-Permissions\\/Recover-instructionsTitle {\n  font-weight: 600;\n  margin: 0 0 8px;\n}\n.onfido-sdk-ui-Camera-Permissions\\/Recover-recovery {\n  background: #585E5F;\n  border-radius: 1em;\n  color: #fff;\n  font-weight: 600;\n  left: 20px;\n  line-height: 24px;\n  padding: 0 15px;\n  position: absolute;\n  top: 0;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n}\n.onfido-sdk-ui-Camera-Permissions\\/Recover-steps {\n  padding: 0;\n  margin: 0;\n}\n.onfido-sdk-ui-Camera-Permissions\\/Recover-step {\n  margin: 0 15px 10px;\n}\n.onfido-sdk-ui-Camera-Permissions\\/Recover-button {\n  margin-left: auto;\n  margin-right: auto;\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Theme/constants.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Camera/Permissions/Recover/style.css"],"names":[],"mappings":"AAMA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;CCFD;ACRD;EACE,iBAAA;EACA,oBAAA;CDUD;ACPD;EACE,iBAAA;EACA,mBAAA;EACA,0BAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,wBAAA;CDSD;ACND;EACE,iBAAA;EACA,gBAAA;CDQD;ACLD;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,OAAA;EACA,oCAAA;UAAA,4BAAA;CDOD;ACJD;EACE,WAAA;EACA,UAAA;CDMD;ACHD;EACE,oBAAA;CDKD;ACFD;EACE,kBAAA;EACA,mBAAA;CDID","file":"style.css","sourcesContent":["@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n@large-text-margin: 40px;\n@small-text-margin: 24px;\n\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.width-parent-relative(@base-width,@parent-width) {\n  width: 100%*(@base-width/@parent-width)\n}\n","@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.text {\n  margin-top: 64px;\n  margin-bottom: 80px;\n}\n.instructions {\n  text-align: left;\n  border-radius: 3px;\n  border: 1px solid #D8D8D8;\n  font-size: 14px;\n  margin: 30px 0 24px;\n  position: relative;\n  padding: 24px 24px 12px;\n}\n.instructionsTitle {\n  font-weight: 600;\n  margin: 0 0 8px;\n}\n.recovery {\n  background: #585E5F;\n  border-radius: 1em;\n  color: #fff;\n  font-weight: 600;\n  left: 20px;\n  line-height: 24px;\n  padding: 0 15px;\n  position: absolute;\n  top: 0;\n  transform: translateY(-50%);\n}\n.steps {\n  padding: 0;\n  margin: 0;\n}\n.step {\n  margin: 0 15px 10px;\n}\n.button {\n  margin-left: auto;\n  margin-right: auto;\n}\n","@import (less) \"../../../Theme/constants.css\";\n\n.text {\n  margin-top: 64px;\n  margin-bottom: 80px;\n}\n\n.instructions {\n  text-align: left;\n  border-radius: 3px;\n  border: 1px solid #D8D8D8;\n  font-size: 14px;\n  margin: 30px 0 24px;\n  position: relative;\n  padding: 24px 24px 12px;\n}\n\n.instructionsTitle {\n  font-weight: 600;\n  margin: 0 0 8px;\n}\n\n.recovery {\n  background: #585E5F;\n  border-radius: 1em;\n  color: #fff;\n  font-weight: 600;\n  left: 20px;\n  line-height: 24px;\n  padding: 0 15px;\n  position: absolute;\n  top: 0;\n  transform: translateY(-50%);\n}\n\n.steps {\n  padding: 0;\n  margin: 0;\n}\n\n.step {\n  margin: 0 15px 10px;\n}\n\n.button {\n  margin-left: auto;\n  margin-right: auto;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"absolute-center": "onfido-sdk-ui-Camera-Permissions/Recover-absolute-center",
	"text": "onfido-sdk-ui-Camera-Permissions/Recover-text",
	"instructions": "onfido-sdk-ui-Camera-Permissions/Recover-instructions",
	"instructionsTitle": "onfido-sdk-ui-Camera-Permissions/Recover-instructionsTitle",
	"recovery": "onfido-sdk-ui-Camera-Permissions/Recover-recovery",
	"steps": "onfido-sdk-ui-Camera-Permissions/Recover-steps",
	"step": "onfido-sdk-ui-Camera-Permissions/Recover-step",
	"button": "onfido-sdk-ui-Camera-Permissions/Recover-button"
};

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-Camera-absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.onfido-sdk-ui-Camera-step {\n  width: 100%;\n  min-height: 100%;\n  height: 0;\n  /*necessary for IE11, see: https://stackoverflow.com/questions/24396205/flex-grow-not-working-in-internet-explorer-11-0*/\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.onfido-sdk-ui-Camera-fullScreenStep {\n  overflow: hidden;\n  border-radius: 8px;\n}\n.onfido-sdk-ui-Camera-fullHeightContainer {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Camera-fullHeightMobileContainer {\n    width: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n  }\n}\n.onfido-sdk-ui-Camera-navigationBar {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 auto;\n          flex: 0 0 auto;\n}\n.onfido-sdk-ui-Camera-content {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 0 auto;\n          flex: 1 0 auto;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.onfido-sdk-ui-Camera-content > * {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}\n.onfido-sdk-ui-Camera-fullScreenContentWrapper {\n  position: static;\n}\n.onfido-sdk-ui-Camera-footer {\n  width: 100%;\n  height: 48px;\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 auto;\n          flex: 0 0 auto;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 width%3D%2299%22 height%3D%2216%22 viewBox%3D%220 0 99 16%22%3E  %3Cpath d%3D%22M66.658 11.219c1.658 0 3.054-1.198 3.054-3.026 0-1.827-1.396-2.988-3.054-2.988-1.646 0-3.03 1.16-3.03 2.988s1.384 3.026 3.03 3.026zm15.993-5.89h-2.678v-.532c0-.728.187-1.383 1.035-1.383h.636V2.192h-.636c-1.596 0-2.331 1.025-2.331 2.605v.531h-1.06v1.05h1.06v4.717h1.296V6.378h2.678v4.717h1.272V5.328h-1.272zm-15.96 4.7c-.96 0-1.757-.703-1.757-1.79 0-1.062.798-1.741 1.758-1.741.972 0 1.77.68 1.77 1.741 0 1.087-.798 1.79-1.77 1.79zm5.699-1.99c0-1.136.735-1.544 1.496-1.544.748 0 1.221.519 1.221 1.433v3.21h1.285V7.78c0-1.63-.81-2.532-2.22-2.532-.648 0-1.446.321-1.782.988v-.864h-1.285v5.767h1.285v-3.1zm10.037-5.236c0 .457.399.802.86.802.474 0 .848-.345.848-.802 0-.457-.374-.803-.848-.803-.461 0-.86.346-.86.803zm7.795 8.292h1.272V2.192h-1.272v3.964c-.361-.63-1.147-.951-1.97-.951-1.57 0-2.904 1.16-2.904 3.013 0 1.815 1.334 3 2.904 3 .798 0 1.609-.345 1.97-.962v.84zm-.025-2.902c0 1.124-.835 1.79-1.783 1.79-.972 0-1.745-.728-1.745-1.79s.773-1.753 1.745-1.753c.873 0 1.783.617 1.783 1.753zm8.8 0c0-1.827-1.397-2.988-3.055-2.988-1.646 0-3.03 1.16-3.03 2.988s1.384 3.026 3.03 3.026c1.658 0 3.054-1.198 3.054-3.026zM56.688 5.32a4.375 4.375 0 0 0-3.291-1.482c-2.412 0-4.368 1.937-4.368 4.327 0 2.389 1.956 4.326 4.368 4.326 2.412 0 4.367-1.937 4.367-4.326 0-.077-.002-.112-.002-.112a.309.309 0 0 1 .08-.201l1.394-1.38c.047-.047.1-.033.118.03a6.07 6.07 0 0 1 .239 1.686c0 3.376-2.764 6.113-6.172 6.113-3.409 0-6.172-2.737-6.172-6.113 0-3.376 2.763-6.113 6.172-6.113 1.798 0 3.417.762 4.545 1.979l1.559-1.544a.327.327 0 0 1 .201-.082h1.9c.262 0 .324.149.138.333l-8.21 8.131a.238.238 0 0 1-.335.001l-2.325-2.185a.322.322 0 0 1-.084-.201V6.625c0-.26.15-.322.335-.138l2.157 2.019a.12.12 0 0 0 .167 0L56.69 5.32zm39.253 4.665c-.96 0-1.758-.704-1.758-1.79 0-1.063.798-1.742 1.758-1.742.972 0 1.77.68 1.77 1.741 0 1.087-.798 1.79-1.77 1.79zm-91.867-4.2c0 .65-.222 1.15-.666 1.5-.444.351-1.079.526-1.905.526H.747v2.527H0V3.913h1.666c1.605 0 2.408.624 2.408 1.872zM.747 7.17h.672c.663 0 1.142-.106 1.437-.32.296-.214.444-.557.444-1.029 0-.424-.139-.74-.417-.949-.279-.208-.712-.312-1.301-.312H.747v2.61zm8.404.756c0 .785-.198 1.398-.593 1.84-.396.44-.942.66-1.64.66-.43 0-.813-.1-1.147-.302a2.001 2.001 0 0 1-.773-.87c-.182-.378-.272-.82-.272-1.328 0-.785.196-1.396.588-1.834.393-.438.938-.657 1.635-.657.674 0 1.21.224 1.606.672.397.448.596 1.055.596 1.82zm-3.67 0c0 .616.123 1.084.37 1.407.246.322.607.483 1.085.483s.84-.16 1.088-.481c.247-.321.371-.79.371-1.409 0-.612-.124-1.077-.371-1.395-.248-.318-.613-.477-1.097-.477-.477 0-.838.157-1.08.47-.244.314-.366.781-.366 1.402zm8.387 2.413l-.884-2.826c-.055-.173-.16-.565-.312-1.178h-.035c-.117.513-.22.909-.308 1.187l-.91 2.817h-.843L9.262 5.52h.765l.71 2.765c.162.632.255 1.059.279 1.278h.035c.032-.167.084-.383.156-.648.071-.265.134-.475.186-.63l.884-2.765h.79l.862 2.765c.164.504.275.927.334 1.27h.035c.012-.106.043-.268.095-.488.051-.22.356-1.402.916-3.547h.756l-1.332 4.817h-.865zm4.787.088c-.712 0-1.274-.217-1.686-.65-.411-.434-.617-1.036-.617-1.807 0-.776.191-1.393.573-1.85.383-.457.896-.685 1.54-.685.604 0 1.082.198 1.433.595.352.397.528.92.528 1.571v.462h-3.318c.014.565.157.994.428 1.287.271.293.653.44 1.145.44a3.88 3.88 0 0 0 1.538-.326v.65a3.86 3.86 0 0 1-.732.24c-.23.049-.507.073-.832.073zm-.198-4.382c-.387 0-.695.126-.925.378-.23.252-.366.6-.407 1.046h2.518c0-.46-.102-.812-.307-1.057-.205-.244-.498-.367-.88-.367zm5.095-.61c.213 0 .405.017.575.052l-.1.677a2.485 2.485 0 0 0-.528-.066c-.39 0-.723.158-1 .475-.277.316-.415.71-.415 1.182v2.584h-.73V5.52h.602l.084.893h.035c.179-.314.394-.556.646-.726.252-.17.529-.254.83-.254zm3.016 4.992c-.712 0-1.274-.217-1.686-.65-.411-.434-.617-1.036-.617-1.807 0-.776.191-1.393.573-1.85.383-.457.896-.685 1.54-.685.604 0 1.082.198 1.433.595.352.397.528.92.528 1.571v.462H25.02c.014.565.157.994.428 1.287.271.293.653.44 1.145.44a3.88 3.88 0 0 0 1.538-.326v.65a3.86 3.86 0 0 1-.732.24c-.23.049-.507.073-.832.073zm-.198-4.382c-.387 0-.695.126-.925.378-.23.252-.366.6-.407 1.046h2.518c0-.46-.102-.812-.307-1.057-.205-.244-.498-.367-.88-.367zm6.176 3.648h-.04c-.337.49-.84.734-1.512.734-.63 0-1.12-.216-1.47-.646-.35-.43-.525-1.043-.525-1.837s.176-1.41.528-1.85c.351-.44.84-.66 1.467-.66.654 0 1.155.238 1.503.713h.057l-.03-.348-.018-.338V3.5h.73v6.838h-.594l-.096-.646zm-1.46.123c.499 0 .86-.136 1.084-.407.224-.27.336-.708.336-1.311v-.154c0-.683-.114-1.17-.34-1.461-.228-.292-.59-.438-1.088-.438-.428 0-.755.167-.982.5-.227.332-.341.801-.341 1.408 0 .615.113 1.08.338 1.393.226.313.557.47.994.47zm7.645-4.373c.633 0 1.125.216 1.475.649.35.432.525 1.043.525 1.834 0 .791-.177 1.406-.53 1.844-.353.438-.843.657-1.47.657-.313 0-.6-.058-.859-.174a1.616 1.616 0 0 1-.652-.534h-.053l-.154.62h-.523V3.5h.73v1.661c0 .372-.012.706-.035 1.002h.035c.34-.48.843-.72 1.511-.72zm-.105.611c-.498 0-.857.143-1.077.429-.22.285-.33.767-.33 1.443 0 .677.114 1.161.34 1.453.225.291.587.437 1.085.437.448 0 .782-.163 1.002-.49.22-.327.33-.796.33-1.408 0-.627-.11-1.095-.33-1.402-.22-.308-.56-.462-1.02-.462zm2.12-.532h.782l1.054 2.747c.232.627.375 1.08.431 1.358h.035c.038-.15.118-.405.24-.767.121-.362.52-1.474 1.193-3.338h.782l-2.07 5.485c-.205.542-.444.926-.718 1.153-.274.227-.61.341-1.009.341-.222 0-.442-.025-.659-.075v-.584c.161.035.341.053.54.053.502 0 .859-.282 1.073-.844l.268-.686-1.942-4.843z%22 fill%3D%22%238B9094%22 fill-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E\");\n  background-position: 50% 50%;\n  background-repeat: no-repeat;\n  z-index: 1;\n  /* hide the footer if view height is too small */\n}\n@media (max-height: 420px) {\n  .onfido-sdk-ui-Camera-footer {\n    z-index: -1;\n  }\n}\n.onfido-sdk-ui-Camera-thickWrapper {\n  margin: 0rem 40px;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Camera-thickWrapper {\n    margin: 0rem 24px;\n  }\n}\n.onfido-sdk-ui-Camera-imageWrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 300px;\n  min-height: 100px;\n  margin: auto 3rem;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Camera-imageWrapper {\n    margin: 0rem 24px;\n  }\n}\n.onfido-sdk-ui-Camera-mbottom-large {\n  margin-bottom: 5.5rem;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Camera-mbottom-large {\n    margin-bottom: 2.5rem;\n  }\n}\n.onfido-sdk-ui-Camera-btn,\n.onfido-sdk-ui-Camera-btn {\n  height: 56px;\n  font: inherit;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: inherit;\n  text-decoration: none;\n  text-align: center;\n  cursor: pointer;\n  display: inline-block;\n  border: none;\n  border-radius: 2rem;\n  padding: 0;\n  outline: none;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Camera-btn,\n  .onfido-sdk-ui-Camera-btn {\n    padding: 1.2rem 2rem;\n  }\n}\n.onfido-sdk-ui-Camera-btn-centered,\n.onfido-sdk-ui-Camera-btn,\n.onfido-sdk-ui-Camera-btn {\n  margin: auto;\n}\n.onfido-sdk-ui-Camera-btn-primary,\n.onfido-sdk-ui-Camera-btn,\n.onfido-sdk-ui-Camera-btn {\n  /*layout*/\n  display: block;\n  width: 216px;\n  border-radius: 28px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 16px;\n  border: none;\n  background: #00C8A0;\n  /*text*/\n  color: #fff;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Camera-btn-primary,\n  .onfido-sdk-ui-Camera-btn,\n  .onfido-sdk-ui-Camera-btn {\n    width: 100%;\n  }\n}\n.onfido-sdk-ui-Camera-btn-alternative {\n  background-color: rgba(15, 37, 54, 0.85);\n  border-radius: 4px;\n  color: #fff;\n  font-weight: 600;\n  height: auto;\n  line-height: 1.4;\n  padding: .8em 1.4em;\n}\n.onfido-sdk-ui-Camera-btn-ghost {\n  background-color: transparent;\n  border: 1px solid #fff;\n  color: #fff;\n}\n.onfido-sdk-ui-Camera-btn-outline {\n  border: 1px solid #8A9293;\n  border-radius: 28px;\n  background-color: transparent;\n  color: #585E5F;\n  line-height: 16px;\n  padding: 1.2rem 2rem;\n}\n.onfido-sdk-ui-Camera-center {\n  text-align: center;\n}\n.onfido-sdk-ui-Camera-icon {\n  display: block;\n  background-repeat: no-repeat;\n  background-position: center;\n  height: 4rem;\n}\n.onfido-sdk-ui-Camera-actions {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: .75rem 1.5rem 0 1.5rem;\n}\n@media (min-width: 480px) {\n  .onfido-sdk-ui-Camera-actions {\n    padding: 1.5em 3rem 0 3rem;\n  }\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Camera-actions .onfido-sdk-ui-Camera-btn-primary {\n    width: 152px;\n  }\n}\n.onfido-sdk-ui-Camera-help {\n  padding: 1.5rem 1rem 1rem;\n  text-align: left;\n  -webkit-box-shadow: inset 0 0 0px 1px rgba(138, 146, 147, 0.35);\n          box-shadow: inset 0 0 0px 1px rgba(138, 146, 147, 0.35);\n  border-radius: 8px;\n}\n.onfido-sdk-ui-Camera-header {\n  border-radius: 12px;\n  background-color: #5D6B78;\n  color: #FFFFFF;\n  font-size: 14px;\n  font-weight: 600;\n  position: absolute;\n  margin-top: -12px;\n  margin-left: 12px;\n  padding: 0rem 1rem;\n}\n.onfido-sdk-ui-Camera-helpList {\n  margin: 0rem;\n}\n.onfido-sdk-ui-Camera-camera {\n  height: auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.onfido-sdk-ui-Camera-fullScreenContainer {\n  position: static;\n}\n.onfido-sdk-ui-Camera-autoCaptureContainer {\n  position: relative;\n  overflow: hidden;\n  margin: 0 40px 16px;\n}\n.onfido-sdk-ui-Camera-container {\n  overflow: hidden;\n}\n.onfido-sdk-ui-Camera-fullScreenBtn {\n  width: 56px;\n  height: 56px;\n  background-color: white;\n  border: 3px solid black;\n  -webkit-box-shadow: 0px 0px 0px 4px white;\n          box-shadow: 0px 0px 0px 4px white;\n  border-radius: 50%;\n}\n.onfido-sdk-ui-Camera-fullScreenCenteredButton {\n  padding: 0;\n  margin-left: auto;\n  margin-right: auto;\n}\n.onfido-sdk-ui-Camera-btn:disabled {\n  background-color: #8A9293;\n}\n.onfido-sdk-ui-Camera-btn {\n  padding: 0;\n  margin-left: auto;\n  margin-right: auto;\n}\n.onfido-sdk-ui-Camera-livenessCamera .onfido-sdk-ui-Camera-btn {\n  padding: 0;\n  margin-left: auto;\n  margin-right: auto;\n}\n.onfido-sdk-ui-Camera-recordingIndicator {\n  font-size: 11px;\n  text-align: center;\n  line-height: 16px;\n  margin-bottom: 16px;\n  /* Red circle */\n}\n.onfido-sdk-ui-Camera-recordingIndicator::before {\n  content: '';\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  margin-right: 5px;\n  background: #DC2A2A;\n  border-radius: 4px;\n  line-height: 120%;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Camera-startRecording {\n    width: 60px;\n    height: 60px;\n    border: none;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-color: transparent;\n    -webkit-box-shadow: none;\n            box-shadow: none;\n    background-image: url(\"data:image/svg+xml,%3Csvg width%3D%2256%22 height%3D%2256%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E  %3Cg fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E    %3Ccircle stroke%3D%22%23FFF%22 stroke-width%3D%224%22 cx%3D%2228%22 cy%3D%2228%22 r%3D%2226%22%2F%3E    %3Ccircle fill%3D%22%23DC2A2A%22 cx%3D%2228%22 cy%3D%2228%22 r%3D%2222%22%2F%3E    %3Cg transform%3D%22translate(16 21)%22 fill%3D%22%23FFF%22%3E      %3Crect width%3D%2216.5%22 height%3D%2215%22 rx%3D%223%22%2F%3E      %3Cpath d%3D%22M18 6l6-4.5v12l-6-3z%22%2F%3E    %3C%2Fg%3E  %3C%2Fg%3E%3C%2Fsvg%3E\");\n  }\n}\n.onfido-sdk-ui-Camera-livenessCamera .onfido-sdk-ui-Camera-startRecording {\n  width: 60px;\n  height: 60px;\n  border: none;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg width%3D%2256%22 height%3D%2256%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E  %3Cg fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E    %3Ccircle stroke%3D%22%23FFF%22 stroke-width%3D%224%22 cx%3D%2228%22 cy%3D%2228%22 r%3D%2226%22%2F%3E    %3Ccircle fill%3D%22%23DC2A2A%22 cx%3D%2228%22 cy%3D%2228%22 r%3D%2222%22%2F%3E    %3Cg transform%3D%22translate(16 21)%22 fill%3D%22%23FFF%22%3E      %3Crect width%3D%2216.5%22 height%3D%2215%22 rx%3D%223%22%2F%3E      %3Cpath d%3D%22M18 6l6-4.5v12l-6-3z%22%2F%3E    %3C%2Fg%3E  %3C%2Fg%3E%3C%2Fsvg%3E\");\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Camera-stopRecording {\n    width: 60px;\n    height: 60px;\n    border: none;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-color: transparent;\n    -webkit-box-shadow: none;\n            box-shadow: none;\n    background-image: url(\"data:image/svg+xml,%3Csvg width%3D%2256%22 height%3D%2256%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E  %3Cg fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E    %3Ccircle stroke%3D%22%23FFF%22 stroke-width%3D%224%22 cx%3D%2228%22 cy%3D%2228%22 r%3D%2226%22%2F%3E    %3Crect fill%3D%22%23DC2A2A%22 x%3D%2216%22 y%3D%2216%22 width%3D%2224%22 height%3D%2224%22 rx%3D%223%22%2F%3E  %3C%2Fg%3E%3C%2Fsvg%3E\");\n  }\n}\n.onfido-sdk-ui-Camera-livenessCamera .onfido-sdk-ui-Camera-stopRecording {\n  width: 60px;\n  height: 60px;\n  border: none;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg width%3D%2256%22 height%3D%2256%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E  %3Cg fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E    %3Ccircle stroke%3D%22%23FFF%22 stroke-width%3D%224%22 cx%3D%2228%22 cy%3D%2228%22 r%3D%2226%22%2F%3E    %3Crect fill%3D%22%23DC2A2A%22 x%3D%2216%22 y%3D%2216%22 width%3D%2224%22 height%3D%2224%22 rx%3D%223%22%2F%3E  %3C%2Fg%3E%3C%2Fsvg%3E\");\n}\n.onfido-sdk-ui-Camera-container:before {\n  content: \"\";\n  display: block;\n  padding-top: 70%;\n}\n.onfido-sdk-ui-Camera-overlay {\n  width: 100%;\n  height: 100%;\n  top: 0;\n  position: absolute;\n  z-index: 0;\n}\n.onfido-sdk-ui-Camera-video {\n  display: block;\n  height: 100%;\n  z-index: 0;\n  /* Use `object-fit: cover` on every browser but Edge */\n}\n@supports not (-ms-ime-align:auto) {\n  .onfido-sdk-ui-Camera-video {\n    width: 100%;\n    top: 0;\n    left: 0;\n    margin: auto;\n    -o-object-fit: cover;\n       object-fit: cover;\n  }\n}\n.onfido-sdk-ui-Camera-webcamContainer {\n  position: absolute;\n  top: 0;\n  height: 100%;\n  /* Only apply styles on Edge where there is no `object-fit:cover` support for video */\n}\n@supports (-ms-ime-align:auto) {\n  .onfido-sdk-ui-Camera-webcamContainer {\n    left: 50%;\n    margin: auto;\n    -webkit-transform: translate(-50%, 0%);\n            transform: translate(-50%, 0%);\n  }\n}\n.onfido-sdk-ui-Camera-uploadFallback {\n  display: block;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  padding-right: 16px;\n  padding-bottom: 4px;\n}\n.onfido-sdk-ui-Camera-uploadFallback button {\n  /* ref: http://stackoverflow.com/a/12642009/689223 */\n  /* Remove all decorations to look like normal text */\n  background: none;\n  border: none;\n  display: inline;\n  font: inherit;\n  margin: 0;\n  padding: 0;\n  outline: none;\n  outline-offset: 0;\n  /* Additional styles to look like a link */\n  cursor: pointer;\n  /*Custom style*/\n  color: white;\n}\n.onfido-sdk-ui-Camera-uploadFallback button:hover {\n  text-decoration: underline;\n}\n.onfido-sdk-ui-Camera-errorContainer {\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 4;\n}\n.onfido-sdk-ui-Camera-errorContainerType::before {\n  content: '';\n  display: block;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 100%;\n  z-index: 1;\n}\n.onfido-sdk-ui-Camera-errorHasBackdrop {\n  bottom: 0;\n}\n.onfido-sdk-ui-Camera-errorHasBackdrop::before {\n  content: '';\n  display: block;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 100%;\n  z-index: 1;\n}\n.onfido-sdk-ui-Camera-errorHasBackdrop::before {\n  background-color: #1C1F21;\n  opacity: .57;\n}\n.onfido-sdk-ui-Camera-errorMessage {\n  top: 48px;\n  left: 0;\n  right: 0;\n  position: absolute;\n  z-index: 2;\n}\n.onfido-sdk-ui-Camera-fallbackLink {\n  display: inline;\n  text-decoration: underline;\n  cursor: pointer;\n}\n.onfido-sdk-ui-Camera-captureActions {\n  position: absolute;\n  bottom: 48px;\n  left: 16px;\n  right: 16px;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Camera-captureActionsHint {\n    color: #fff;\n    font-size: 14px;\n    margin-bottom: 10px;\n  }\n}\n.onfido-sdk-ui-Camera-livenessCamera .onfido-sdk-ui-Camera-captureActionsHint {\n  color: #fff;\n  font-size: 14px;\n  margin-bottom: 10px;\n}\n@media (max-width: 359px) {\n  .onfido-sdk-ui-Camera-captureActionsHint.onfido-sdk-ui-Camera-recordAction {\n    display: none;\n  }\n}\n.onfido-sdk-ui-Camera-caption {\n  color: #fff;\n  text-align: center;\n  position: absolute;\n  z-index: 1;\n  top: 64px;\n  left: 0;\n  right: 0;\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Theme/constants.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Theme/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Camera/style.css"],"names":[],"mappings":"AAMA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;CCFD;ACRD;EACE,YAAA;EACA,iBAAA;EACA,UAAA;EDUA,yHAAyH;ECTzH,mBAAA;EACA,qBAAA;EAAA,qBAAA;EAAA,cAAA;EACA,6BAAA;EAAA,8BAAA;MAAA,2BAAA;UAAA,uBAAA;CDWD;ACPD;EACE,iBAAA;EACA,mBAAA;CDSD;ACND;EACE,YAAA;EACA,qBAAA;EAAA,qBAAA;EAAA,cAAA;EACA,6BAAA;EAAA,8BAAA;MAAA,2BAAA;UAAA,uBAAA;EACA,0BAAA;MAAA,uBAAA;UAAA,+BAAA;CDQD;ACJC;EAmLF;IA1LE,YAAA;IACA,qBAAA;IAAA,qBAAA;IAAA,cAAA;IACA,6BAAA;IAAA,8BAAA;QAAA,2BAAA;YAAA,uBAAA;IACA,0BAAA;QAAA,uBAAA;YAAA,+BAAA;GDeC;CACF;ACPD;EACE,oBAAA;MAAA,mBAAA;UAAA,eAAA;CDSD;ACND;EACE,oBAAA;MAAA,mBAAA;UAAA,eAAA;EACA,mBAAA;EACA,qBAAA;EAAA,qBAAA;EAAA,cAAA;CDQD;ACXD;EAKI,oBAAA;MAAA,qBAAA;UAAA,aAAA;CDSH;ACLD;EACE,iBAAA;CDOD;ACJD;EACE,YAAA;EACA,aAAA;EACA,oBAAA;MAAA,mBAAA;UAAA,eAAA;EAEA,y5KAAA;EACA,6BAAA;EACA,6BAAA;EACA,WAAA;EDKA,iDAAiD;CAClD;ACJC;EAmJF;IAlJI,YAAA;GDOD;CACF;ACJD;EACE,kBAAA;CDMD;ACLC;EA4IF;IA3II,kBAAA;GDQD;CACF;ACLD;EACE,qBAAA;EAAA,qBAAA;EAAA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;CDOD;ACNC;EAkIF;IAjII,kBAAA;GDSD;CACF;ACND;EACE,sBAAA;CDQD;ACPC;EA2HF;IA1HI,sBAAA;GDUD;CACF;ACPD;;EACE,aAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,mBAAA;EACA,gBAAA;EAEA,sBAAA;EACA,aAAA;EACA,oBAAA;EACA,WAAA;EACA,cAAA;CDQD;ACPC;EAsGF;;IArGI,qBAAA;GDWD;CACF;ACRD;;;EACE,aAAA;CDYD;ACTD;;;EDaE,UAAU;ECXV,eAAA;EACA,aAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EAIA,aAAA;EAEA,oBAAA;EDSA,QAAQ;ECNR,YAAA;CDQD;AChBC;EAqFF;;;IApFI,YAAA;GDqBD;CACF;ACZD;EACE,yCAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;CDcD;ACXD;EACE,8BAAA;EACA,uBAAA;EACA,YAAA;CDaD;ACVD;EACE,0BAAA;EACA,oBAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;CDYD;ACTD;EACE,mBAAA;CDWD;ACRD;EACE,eAAA;EACA,6BAAA;EACA,4BAAA;EACA,aAAA;CDUD;ACPD;EACE,YAAA;EACA,qBAAA;EAAA,qBAAA;EAAA,cAAA;EACA,0BAAA;MAAA,uBAAA;UAAA,+BAAA;EACA,gCAAA;CDSD;ACRC;EAiCF;IAhCI,2BAAA;GDWD;CACF;ACPC;EA2BF;IA1BI,aAAA;GDUD;CACF;ACPD;EACE,0BAAA;EACA,iBAAA;EACA,gEAAA;UAAA,wDAAA;EACA,mBAAA;CDSD;ACND;EACE,oBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;CDQD;ACLD;EACE,aAAA;CDOD;AE9MD;EACE,aAAA;EACA,qBAAA;EAAA,qBAAA;EAAA,cAAA;EACA,6BAAA;EAAA,8BAAA;MAAA,2BAAA;UAAA,uBAAA;EACA,0BAAA;MAAA,uBAAA;UAAA,+BAAA;CFgND;AE7MD;EACE,iBAAA;CF+MD;AE5MD;EACE,mBAAA;EACA,iBAAA;EACA,oBAAA;CF8MD;AE3MD;EACE,iBAAA;CF6MD;AE1MD;EACE,YAAA;EACA,aAAA;EACA,wBAAA;EACA,wBAAA;EACA,0CAAA;UAAA,kCAAA;EACA,mBAAA;CF4MD;AEzMD;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;CF2MD;AExMD;EACE,0BAAA;CF0MD;AEvMD;EATE,WAAA;EACA,kBAAA;EACA,mBAAA;CFmND;AEzMC;EAZA,WAAA;EACA,kBAAA;EACA,mBAAA;CFwND;AEzMD;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EF2MA,gBAAgB;CACjB;AEzMC;EACE,YAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;CF2MH;AElLC;EAiLF;IArME,YAAA;IACA,aAAA;IACA,aAAA;IACA,yBAAA;IACA,6BAAA;IACA,8BAAA;IACA,yBAAA;YAAA,iBAAA;IAKA,4lBAAA;GFsMC;CACF;AE1LC;EAxBA,YAAA;EACA,aAAA;EACA,aAAA;EACA,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,yBAAA;UAAA,iBAAA;EAKA,4lBAAA;CFiND;AE9LC;EAuKF;IArME,YAAA;IACA,aAAA;IACA,aAAA;IACA,yBAAA;IACA,6BAAA;IACA,8BAAA;IACA,yBAAA;YAAA,iBAAA;IAUA,obAAA;GFuNC;CACF;AEtMC;EAlCA,YAAA;EACA,aAAA;EACA,aAAA;EACA,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,yBAAA;UAAA,iBAAA;EAUA,obAAA;CFkOD;AE3MD;EACE,YAAA;EACA,eAAA;EACA,iBAAA;CF6MD;AE1MD;EACE,YAAA;EACA,aAAA;EACA,OAAA;EACA,mBAAA;EACA,WAAA;CF4MD;AEzMD;EACE,eAAA;EACA,aAAA;EACA,WAAA;EF2MA,uDAAuD;CACxD;AE1MC;EA2IF;IA1II,YAAA;IACA,OAAA;IACA,QAAA;IACA,aAAA;IACA,qBAAA;OAAA,kBAAA;GF6MD;CACF;AEzMC;EACE,mBAAA;EACA,OAAA;EACA,aAAA;EF2MF,sFAAsF;CACvF;AE1MG;EA4HJ;IA3HM,UAAA;IACA,aAAA;IACA,uCAAA;YAAA,+BAAA;GF6MH;CACF;AE1MD;EACE,eAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;EACA,oBAAA;EACA,oBAAA;CF4MD;AE1MC;EF4MA,qDAAqD;EACrD,qDAAqD;EE1MnD,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EF4MF,2CAA2C;EE1MzC,gBAAA;EF4MF,gBAAgB;EEzMd,aAAA;CF2MH;AE1MG;EACE,2BAAA;CF4ML;AEvMD;EACE,QAAA;EACA,mBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;CFyMD;AErMC;EACE,YAAA;EACA,eAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;CFuMH;AE/LD;EAEE,UAAA;CFgMD;AEnNC;EACE,YAAA;EACA,eAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;CFqNH;AE1MC;EACE,0BAAA;EACA,aAAA;CF4MH;AExMD;EACE,UAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;CF0MD;AEvMD;EACE,gBAAA;EACA,2BAAA;EACA,gBAAA;CFyMD;AEtMD;EACE,mBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;CFwMD;AE9LC;EAwBF;IA9BE,YAAA;IACA,gBAAA;IACA,oBAAA;GFwMC;CACF;AEjMC;EAVA,YAAA;EACA,gBAAA;EACA,oBAAA;CF8MD;AEjMG;EAeJ;IAdM,cAAA;GFoMH;CACF;AEhMD;EACE,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;CFkMD","file":"style.css","sourcesContent":["@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n@large-text-margin: 40px;\n@small-text-margin: 24px;\n\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.width-parent-relative(@base-width,@parent-width) {\n  width: 100%*(@base-width/@parent-width)\n}\n","@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.step {\n  width: 100%;\n  min-height: 100%;\n  height: 0;\n  /*necessary for IE11, see: https://stackoverflow.com/questions/24396205/flex-grow-not-working-in-internet-explorer-11-0*/\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n.fullScreenStep {\n  overflow: hidden;\n  border-radius: 8px;\n}\n.fullHeightContainer {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n@media (--small-viewport) {\n  .fullHeightMobileContainer {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n}\n.navigationBar {\n  flex: 0 0 auto;\n}\n.content {\n  flex: 1 0 auto;\n  position: relative;\n  display: flex;\n}\n.content > * {\n  flex-grow: 1;\n}\n.fullScreenContentWrapper {\n  position: static;\n}\n.footer {\n  width: 100%;\n  height: 48px;\n  flex: 0 0 auto;\n  background-image: url('../Theme/assets/powered-by-onfido.svg');\n  background-position: 50% 50%;\n  background-repeat: no-repeat;\n  z-index: 1;\n  /* hide the footer if view height is too small */\n}\n@media (max-height: 420px) {\n  .footer {\n    z-index: -1;\n  }\n}\n.thickWrapper {\n  margin: 0rem 40px;\n}\n@media (--small-viewport) {\n  .thickWrapper {\n    margin: 0rem 24px;\n  }\n}\n.imageWrapper {\n  display: flex;\n  height: 300px;\n  min-height: 100px;\n  margin: auto 3rem;\n}\n@media (--small-viewport) {\n  .imageWrapper {\n    margin: 0rem 24px;\n  }\n}\n.mbottom-large {\n  margin-bottom: 5.5rem;\n}\n@media (--small-viewport) {\n  .mbottom-large {\n    margin-bottom: 2.5rem;\n  }\n}\n.btn,\n.btn {\n  height: 56px;\n  font: inherit;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: inherit;\n  text-decoration: none;\n  text-align: center;\n  cursor: pointer;\n  display: inline-block;\n  border: none;\n  border-radius: 2rem;\n  padding: 0;\n  outline: none;\n}\n@media (--small-viewport) {\n  .btn,\n  .btn {\n    padding: 1.2rem 2rem;\n  }\n}\n.btn-centered,\n.btn,\n.btn {\n  margin: auto;\n}\n.btn-primary,\n.btn,\n.btn {\n  /*layout*/\n  display: block;\n  width: 216px;\n  border-radius: 28px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 16px;\n  border: none;\n  background: #00C8A0;\n  /*text*/\n  color: #fff;\n}\n@media (--small-viewport) {\n  .btn-primary,\n  .btn,\n  .btn {\n    width: 100%;\n  }\n}\n.btn-alternative {\n  background-color: rgba(15, 37, 54, 0.85);\n  border-radius: 4px;\n  color: #fff;\n  font-weight: 600;\n  height: auto;\n  line-height: 1.4;\n  padding: .8em 1.4em;\n}\n.btn-ghost {\n  background-color: transparent;\n  border: 1px solid #fff;\n  color: #fff;\n}\n.btn-outline {\n  border: 1px solid #8A9293;\n  border-radius: 28px;\n  background-color: transparent;\n  color: #585E5F;\n  line-height: 16px;\n  padding: 1.2rem 2rem;\n}\n.center {\n  text-align: center;\n}\n.icon {\n  display: block;\n  background-repeat: no-repeat;\n  background-position: center;\n  height: 4rem;\n}\n.actions {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  padding: .75rem 1.5rem 0 1.5rem;\n}\n@media (--large) {\n  .actions {\n    padding: 1.5em 3rem 0 3rem;\n  }\n}\n@media (--small-viewport) {\n  .actions .btn-primary {\n    width: 152px;\n  }\n}\n.help {\n  padding: 1.5rem 1rem 1rem;\n  text-align: left;\n  box-shadow: inset 0 0 0px 1px rgba(138, 146, 147, 0.35);\n  border-radius: 8px;\n}\n.header {\n  border-radius: 12px;\n  background-color: #5D6B78;\n  color: #FFFFFF;\n  font-size: 14px;\n  font-weight: 600;\n  position: absolute;\n  margin-top: -12px;\n  margin-left: 12px;\n  padding: 0rem 1rem;\n}\n.helpList {\n  margin: 0rem;\n}\n.camera {\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.fullScreenContainer {\n  position: static;\n}\n.autoCaptureContainer {\n  position: relative;\n  overflow: hidden;\n  margin: 0 40px 16px;\n}\n.container {\n  overflow: hidden;\n}\n.fullScreenBtn {\n  width: 56px;\n  height: 56px;\n  background-color: white;\n  border: 3px solid black;\n  box-shadow: 0px 0px 0px 4px white;\n  border-radius: 50%;\n}\n.fullScreenCenteredButton {\n  padding: 0;\n  margin-left: auto;\n  margin-right: auto;\n}\n.btn:disabled {\n  background-color: #8A9293;\n}\n.btn {\n  padding: 0;\n  margin-left: auto;\n  margin-right: auto;\n}\n.livenessCamera .btn {\n  padding: 0;\n  margin-left: auto;\n  margin-right: auto;\n}\n.recordingIndicator {\n  font-size: 11px;\n  text-align: center;\n  line-height: 16px;\n  margin-bottom: 16px;\n  /* Red circle */\n}\n.recordingIndicator::before {\n  content: '';\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  margin-right: 5px;\n  background: #DC2A2A;\n  border-radius: 4px;\n  line-height: 120%;\n}\n@media (--small-viewport) {\n  .startRecording {\n    width: 60px;\n    height: 60px;\n    border: none;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-color: transparent;\n    box-shadow: none;\n    background-image: url('assets/start.svg');\n  }\n}\n.livenessCamera .startRecording {\n  width: 60px;\n  height: 60px;\n  border: none;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-color: transparent;\n  box-shadow: none;\n  background-image: url('assets/start.svg');\n}\n@media (--small-viewport) {\n  .stopRecording {\n    width: 60px;\n    height: 60px;\n    border: none;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-color: transparent;\n    box-shadow: none;\n    background-image: url('assets/stop.svg');\n  }\n}\n.livenessCamera .stopRecording {\n  width: 60px;\n  height: 60px;\n  border: none;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-color: transparent;\n  box-shadow: none;\n  background-image: url('assets/stop.svg');\n}\n.container:before {\n  content: \"\";\n  display: block;\n  padding-top: 70%;\n}\n.overlay {\n  width: 100%;\n  height: 100%;\n  top: 0;\n  position: absolute;\n  z-index: 0;\n}\n.video {\n  display: block;\n  height: 100%;\n  z-index: 0;\n  /* Use `object-fit: cover` on every browser but Edge */\n}\n@supports not (-ms-ime-align:auto) {\n  .video {\n    width: 100%;\n    top: 0;\n    left: 0;\n    margin: auto;\n    object-fit: cover;\n  }\n}\n.webcamContainer {\n  position: absolute;\n  top: 0;\n  height: 100%;\n  /* Only apply styles on Edge where there is no `object-fit:cover` support for video */\n}\n@supports (-ms-ime-align:auto) {\n  .webcamContainer {\n    left: 50%;\n    margin: auto;\n    transform: translate(-50%, 0%);\n  }\n}\n.uploadFallback {\n  display: block;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  padding-right: 16px;\n  padding-bottom: 4px;\n}\n.uploadFallback button {\n  /* ref: http://stackoverflow.com/a/12642009/689223 */\n  /* Remove all decorations to look like normal text */\n  background: none;\n  border: none;\n  display: inline;\n  font: inherit;\n  margin: 0;\n  padding: 0;\n  outline: none;\n  outline-offset: 0;\n  /* Additional styles to look like a link */\n  cursor: pointer;\n  /*Custom style*/\n  color: white;\n}\n.uploadFallback button:hover {\n  text-decoration: underline;\n}\n.errorContainer {\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 4;\n}\n.errorContainerType::before {\n  content: '';\n  display: block;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 100%;\n  z-index: 1;\n}\n.errorHasBackdrop {\n  bottom: 0;\n}\n.errorHasBackdrop::before {\n  content: '';\n  display: block;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 100%;\n  z-index: 1;\n}\n.errorHasBackdrop::before {\n  background-color: #1C1F21;\n  opacity: .57;\n}\n.errorMessage {\n  top: 48px;\n  left: 0;\n  right: 0;\n  position: absolute;\n  z-index: 2;\n}\n.fallbackLink {\n  display: inline;\n  text-decoration: underline;\n  cursor: pointer;\n}\n.captureActions {\n  position: absolute;\n  bottom: 48px;\n  left: 16px;\n  right: 16px;\n}\n@media (--small-viewport) {\n  .captureActionsHint {\n    color: #fff;\n    font-size: 14px;\n    margin-bottom: 10px;\n  }\n}\n.livenessCamera .captureActionsHint {\n  color: #fff;\n  font-size: 14px;\n  margin-bottom: 10px;\n}\n@media (--smaller-viewport) {\n  .captureActionsHint.recordAction {\n    display: none;\n  }\n}\n.caption {\n  color: #fff;\n  text-align: center;\n  position: absolute;\n  z-index: 1;\n  top: 64px;\n  left: 0;\n  right: 0;\n}\n","@import (less) \"./constants.css\";\n\n.step {\n  width: 100%;\n  min-height: 100%;\n  height: 0;/*necessary for IE11, see: https://stackoverflow.com/questions/24396205/flex-grow-not-working-in-internet-explorer-11-0*/\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n\n.fullScreenStep {\n  overflow: hidden;\n  border-radius: 8px;\n}\n\n.fullHeightContainer {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.fullHeightMobileContainer {\n  @media (--small-viewport) {\n    .fullHeightContainer();\n  }\n}\n\n.navigationBar{\n  flex: 0 0 auto;\n}\n\n.content {\n  flex: 1 0 auto;\n  position: relative;\n  display: flex;\n  > * {\n    flex-grow: 1;\n  }\n}\n\n.fullScreenContentWrapper {\n  position: static;\n}\n\n.footer {\n  width: 100%;\n  height: 48px;\n  flex: 0 0 auto;\n\n  background-image: url('assets/powered-by-onfido.svg');\n  background-position: 50% 50%;\n  background-repeat: no-repeat;\n  z-index: 1;\n  /* hide the footer if view height is too small */\n  @media (max-height: 420px) {\n    z-index: -1;\n  }\n}\n\n.thickWrapper {\n  margin: 0rem @large-text-margin;\n  @media (--small-viewport) {\n    margin: 0rem @small-text-margin;\n  }\n}\n\n.imageWrapper {\n  display: flex;\n  height: 300px;\n  min-height: 100px;\n  margin: auto 3rem;\n  @media (--small-viewport) {\n    margin: 0rem @small-text-margin;\n  }\n}\n\n.mbottom-large {\n  margin-bottom: 5.5rem;\n  @media (--small-viewport) {\n    margin-bottom: 2.5rem;\n  }\n}\n\n.btn {\n  height: 56px;\n  font: inherit;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: inherit;\n\n  text-decoration: none;\n  text-align: center;\n  cursor: pointer;\n\n  display: inline-block;\n  border: none;\n  border-radius: 2rem;\n  padding: 0;\n  outline: none;\n  @media (--small-viewport) {\n    padding: 1.2rem 2rem;\n  }\n}\n\n.btn-centered {\n  margin: auto;\n}\n\n.btn-primary {\n  /*layout*/\n  display: block;\n  width: 216px;\n  border-radius: 28px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 16px;\n  @media (--small-viewport) {\n    width: 100%;\n  }\n  border: none;\n\n  background: #00C8A0;\n\n  /*text*/\n  color: #fff;\n}\n\n.btn-alternative {\n  background-color: rgba(15, 37, 54, 0.85);\n  border-radius: 4px;\n  color: #fff;\n  font-weight: 600;\n  height: auto;\n  line-height: 1.4;\n  padding: .8em 1.4em;\n}\n\n.btn-ghost {\n  background-color: transparent;\n  border: 1px solid #fff;\n  color: #fff;\n}\n\n.btn-outline {\n  border: 1px solid #8A9293;\n  border-radius: 28px;\n  background-color: transparent;\n  color: #585E5F;\n  line-height: 16px;\n  padding: 1.2rem 2rem;\n}\n\n.center {\n  text-align: center;\n}\n\n.icon {\n  display: block;\n  background-repeat: no-repeat;\n  background-position: center;\n  height: 4rem;\n}\n\n.actions {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  padding: .75rem 1.5rem 0 1.5rem;\n  @media (--large) {\n    padding: 1.5em 3rem 0 3rem;\n  }\n}\n\n.actions .btn-primary {\n  @media (--small-viewport) {\n    width: 152px;\n  }\n}\n\n.help {\n  padding: 1.5rem 1rem 1rem;;\n  text-align: left;\n  box-shadow: inset 0 0 0px 1px rgba(138,146,147,0.35);\n  border-radius: 8px;\n}\n\n.header {\n  border-radius: 12px;\n  background-color: #5D6B78;\n  color: #FFFFFF;\n  font-size: 14px;\n  font-weight: 600;\n  position: absolute;\n  margin-top: -12px;\n  margin-left: 12px;;\n  padding: 0rem 1rem;\n}\n\n.helpList {\n  margin: 0rem;\n}\n","@import (less) \"../Theme/constants.css\";\n@import (less) \"../Theme/style.css\";\n\n.camera {\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.fullScreenContainer {\n  position: static;\n}\n\n.autoCaptureContainer {\n  position: relative;\n  overflow: hidden;\n  margin: 0 40px 16px;\n}\n\n.container {\n  overflow: hidden;\n}\n\n.fullScreenBtn {\n  width: 56px;\n  height: 56px;\n  background-color: white;\n  border: 3px solid black;\n  box-shadow: 0px 0px 0px 4px white;\n  border-radius: 50%;\n}\n\n.fullScreenCenteredButton {\n  padding: 0;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.btn:disabled {\n  background-color: #8A9293;\n}\n\n.btn:extend(.btn, .btn-centered, .btn-primary) {\n.fullScreenCenteredButton();\n\n  .livenessCamera & {\n    .fullScreenCenteredButton();\n  }\n}\n\n.recordingIndicator {\n  font-size: 11px;\n  text-align: center;\n  line-height: 16px;\n  margin-bottom: 16px;\n\n  /* Red circle */\n  &::before {\n    content: '';\n    display: inline-block;\n    width: 8px;\n    height: 8px;\n    margin-right: 5px;\n    background: #DC2A2A;\n    border-radius: 4px;\n    line-height: 120%;\n  }\n}\n\n.fullScreenRoundedIcon() {\n  width: 60px;\n  height: 60px;\n  border: none;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-color: transparent;\n  box-shadow: none;\n}\n\n.fullScreenStartRecordingIcon() {\n  .fullScreenRoundedIcon();\n  background-image: url('./assets/start.svg');\n}\n\n.fullScreenStopRecordingIcon() {\n  .fullScreenRoundedIcon();\n  background-image: url('./assets/stop.svg');\n}\n\n.startRecording {\n  @media (--small-viewport) {\n    .fullScreenStartRecordingIcon();\n  }\n\n  .livenessCamera & {\n    .fullScreenStartRecordingIcon();\n  }\n}\n\n.stopRecording {\n  @media (--small-viewport) {\n    .fullScreenStopRecordingIcon();\n  }\n\n  .livenessCamera & {\n    .fullScreenStopRecordingIcon();\n  }\n}\n\n.container:before {\n  content: \"\";\n  display: block;\n  padding-top: 70%;\n}\n\n.overlay {\n  width: 100%;\n  height: 100%;\n  top: 0;\n  position: absolute;\n  z-index: 0;\n}\n\n.video {\n  display: block;\n  height: 100%;\n  z-index: 0;\n  /* Use `object-fit: cover` on every browser but Edge */\n  @supports not (-ms-ime-align:auto) {\n    width:100%;\n    top: 0;\n    left: 0;\n    margin: auto;\n    object-fit: cover;\n  }\n}\n\n\n  .webcamContainer {\n    position: absolute;\n    top: 0;\n    height: 100%;\n    /* Only apply styles on Edge where there is no `object-fit:cover` support for video */\n    @supports (-ms-ime-align:auto) {\n      left: 50%;\n      margin: auto;\n      transform: translate(-50%, 0%);\n    }\n}\n\n.uploadFallback {\n  display: block;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  padding-right: 16px;\n  padding-bottom: 4px;\n\n  & button{\n    /* ref: http://stackoverflow.com/a/12642009/689223 */\n    /* Remove all decorations to look like normal text */\n    background: none;\n    border: none;\n    display: inline;\n    font: inherit;\n    margin: 0;\n    padding: 0;\n    outline: none;\n    outline-offset: 0;\n    /* Additional styles to look like a link */\n    cursor: pointer;\n\n    /*Custom style*/\n    color: white;\n    &:hover{\n      text-decoration: underline;\n    }\n  }\n}\n\n.errorContainer {\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 4;\n}\n\n.errorOverlay() {\n  &::before {\n    content: '';\n    display: block;\n    height: 100%;\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 100%;\n    z-index: 1;\n  }\n}\n\n.errorContainerType {\n  .errorOverlay();\n}\n\n.errorHasBackdrop {\n  .errorOverlay();\n  bottom: 0;\n  &::before {\n    background-color: #1C1F21;\n    opacity: .57;\n  }\n}\n\n.errorMessage {\n  top: 48px;\n  left: 0;\n  right: 0;\n  position: absolute;\n  z-index: 2;\n}\n\n.fallbackLink {\n  display: inline;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.captureActions {\n  position: absolute;\n  bottom: 48px;\n  left: 16px;\n  right: 16px;\n}\n\n.fullScreenCaptureActionsHintText() {\n  color: #fff;\n  font-size: 14px;\n  margin-bottom: 10px;\n}\n\n.captureActionsHint {\n  @media (--small-viewport) {\n    .fullScreenCaptureActionsHintText();\n  }\n\n  .livenessCamera & {\n    .fullScreenCaptureActionsHintText();\n  }\n\n  &.recordAction {\n    @media (--smaller-viewport) {\n      display: none;\n    }\n  }\n}\n\n.caption {\n  color: #fff;\n  text-align: center;\n  position: absolute;\n  z-index: 1;\n  top: 64px;\n  left: 0;\n  right: 0;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"absolute-center": "onfido-sdk-ui-Camera-absolute-center",
	"step": "onfido-sdk-ui-Camera-step",
	"fullScreenStep": "onfido-sdk-ui-Camera-fullScreenStep",
	"fullHeightContainer": "onfido-sdk-ui-Camera-fullHeightContainer",
	"fullHeightMobileContainer": "onfido-sdk-ui-Camera-fullHeightMobileContainer",
	"navigationBar": "onfido-sdk-ui-Camera-navigationBar",
	"content": "onfido-sdk-ui-Camera-content",
	"fullScreenContentWrapper": "onfido-sdk-ui-Camera-fullScreenContentWrapper",
	"footer": "onfido-sdk-ui-Camera-footer",
	"thickWrapper": "onfido-sdk-ui-Camera-thickWrapper",
	"imageWrapper": "onfido-sdk-ui-Camera-imageWrapper",
	"mbottom-large": "onfido-sdk-ui-Camera-mbottom-large",
	"btn": "onfido-sdk-ui-Camera-btn",
	"btn-centered": "onfido-sdk-ui-Camera-btn-centered",
	"btn-primary": "onfido-sdk-ui-Camera-btn-primary",
	"btn-alternative": "onfido-sdk-ui-Camera-btn-alternative",
	"btn-ghost": "onfido-sdk-ui-Camera-btn-ghost",
	"btn-outline": "onfido-sdk-ui-Camera-btn-outline",
	"center": "onfido-sdk-ui-Camera-center",
	"icon": "onfido-sdk-ui-Camera-icon",
	"actions": "onfido-sdk-ui-Camera-actions",
	"help": "onfido-sdk-ui-Camera-help",
	"header": "onfido-sdk-ui-Camera-header",
	"helpList": "onfido-sdk-ui-Camera-helpList",
	"camera": "onfido-sdk-ui-Camera-camera",
	"fullScreenContainer": "onfido-sdk-ui-Camera-fullScreenContainer",
	"autoCaptureContainer": "onfido-sdk-ui-Camera-autoCaptureContainer",
	"container": "onfido-sdk-ui-Camera-container",
	"fullScreenBtn": "onfido-sdk-ui-Camera-fullScreenBtn",
	"fullScreenCenteredButton": "onfido-sdk-ui-Camera-fullScreenCenteredButton",
	"livenessCamera": "onfido-sdk-ui-Camera-livenessCamera",
	"recordingIndicator": "onfido-sdk-ui-Camera-recordingIndicator",
	"startRecording": "onfido-sdk-ui-Camera-startRecording",
	"stopRecording": "onfido-sdk-ui-Camera-stopRecording",
	"overlay": "onfido-sdk-ui-Camera-overlay",
	"video": "onfido-sdk-ui-Camera-video",
	"webcamContainer": "onfido-sdk-ui-Camera-webcamContainer",
	"uploadFallback": "onfido-sdk-ui-Camera-uploadFallback",
	"errorContainer": "onfido-sdk-ui-Camera-errorContainer",
	"errorContainerType": "onfido-sdk-ui-Camera-errorContainerType",
	"errorHasBackdrop": "onfido-sdk-ui-Camera-errorHasBackdrop",
	"errorMessage": "onfido-sdk-ui-Camera-errorMessage",
	"fallbackLink": "onfido-sdk-ui-Camera-fallbackLink",
	"captureActions": "onfido-sdk-ui-Camera-captureActions",
	"captureActionsHint": "onfido-sdk-ui-Camera-captureActionsHint",
	"recordAction": "onfido-sdk-ui-Camera-recordAction",
	"caption": "onfido-sdk-ui-Camera-caption"
};

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-Collapsible-trigger {\n  cursor: pointer;\n  text-decoration: underline;\n  -webkit-text-decoration-color: #00C8A0;\n          text-decoration-color: #00C8A0;\n}\n.onfido-sdk-ui-Collapsible-trigger::after {\n  background-image: url(\"data:image/svg+xml,%3Csvg version%3D%221.1%22 id%3D%22Layer_1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 x%3D%220px%22 y%3D%220px%22 width%3D%2212px%22 height%3D%228px%22 viewBox%3D%220 0 12 8%22 enable-background%3D%22new 0 0 12 8%22 xml%3Aspace%3D%22preserve%22%3E%0D%3Cg id%3D%22Symbols%22%3E%0D%09%3Cg id%3D%22icons_x2F_chevron_x2F_right-black%22 transform%3D%22translate(-12.000000%2C -10.000000)%22%3E%0D%09%09%3Cpath id%3D%22chevron-right-black%22 fill%3D%22%232C3E4F%22 d%3D%22M13.811%2C17.669L18%2C12.739l4.189%2C4.93c0.414%2C0.441%2C1.086%2C0.441%2C1.5%2C0%0D%09%09%09c0.414-0.442%2C0.414-1.162%2C0-1.604l-4.873-5.735c-0.225-0.24-0.523-0.346-0.816-0.326c-0.294-0.02-0.592%2C0.086-0.816%2C0.326%0D%09%09%09l-4.873%2C5.735c-0.414%2C0.442-0.414%2C1.162%2C0%2C1.604C12.725%2C18.11%2C13.397%2C18.11%2C13.811%2C17.669z%22%2F%3E%0D%09%3C%2Fg%3E%0D%3C%2Fg%3E%0D%3C%2Fsvg%3E%0D\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  content: '';\n  display: inline-block;\n  height: 6px;\n  margin-left: 5px;\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n  vertical-align: middle;\n  width: 10px;\n}\n.onfido-sdk-ui-Collapsible-isExpanded .onfido-sdk-ui-Collapsible-trigger::after {\n  -webkit-transform: rotate(0deg);\n          transform: rotate(0deg);\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Collapsible/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,2BAAA;EACA,uCAAA;UAAA,+BAAA;CCCD;ADED;EACE,g9BAAA;EACA,yBAAA;EACA,6BAAA;EACA,YAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,kCAAA;UAAA,0BAAA;EACA,uBAAA;EACA,YAAA;CCAD;ADGD;EACE,gCAAA;UAAA,wBAAA;CCDD","file":"style.css","sourcesContent":[".trigger {\n  cursor: pointer;\n  text-decoration: underline;\n  text-decoration-color: #00C8A0;\n}\n\n.trigger::after {\n  background-image: url('assets/arrow.svg');\n  background-size: contain;\n  background-repeat: no-repeat;\n  content: '';\n  display: inline-block;\n  height: 6px;\n  margin-left: 5px;\n  transform: rotate(180deg);\n  vertical-align: middle;\n  width: 10px;\n}\n\n.isExpanded .trigger::after {\n  transform: rotate(0deg);\n}",".trigger {\n  cursor: pointer;\n  text-decoration: underline;\n  text-decoration-color: #00C8A0;\n}\n.trigger::after {\n  background-image: url('assets/arrow.svg');\n  background-size: contain;\n  background-repeat: no-repeat;\n  content: '';\n  display: inline-block;\n  height: 6px;\n  margin-left: 5px;\n  transform: rotate(180deg);\n  vertical-align: middle;\n  width: 10px;\n}\n.isExpanded .trigger::after {\n  transform: rotate(0deg);\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"trigger": "onfido-sdk-ui-Collapsible-trigger",
	"isExpanded": "onfido-sdk-ui-Collapsible-isExpanded"
};

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-Complete-wrapper {\n  margin-top: 116px;\n}\n.onfido-sdk-ui-Complete-submessage {\n  font-size: 20px;\n  line-height: 32px;\n}\n.onfido-sdk-ui-Complete-icon {\n  height: 4rem;\n  background-size: contain;\n  background-image: url(\"data:image/svg+xml,%3Csvg width%3D%2256%22 height%3D%2256%22 viewBox%3D%220 0 56 56%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E  %3Ctitle%3E    complete-tick  %3C%2Ftitle%3E  %3Cg fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E    %3Ccircle fill%3D%22%2300C8A0%22 cx%3D%2228%22 cy%3D%2228%22 r%3D%2228%22%2F%3E    %3Cpath d%3D%22M37.723 16.373l-13.69 14.53-3.423-3.633c-1.512-1.6-3.964-1.6-5.476 0-1.512 1.608-1.512 4.214 0 5.813l6.16 6.544c1.513 1.61 3.964 1.61 5.477 0l16.43-17.44c1.51-1.61 1.51-4.215 0-5.814-1.513-1.61-3.964-1.61-5.477 0z%22 fill%3D%22%23FFF%22%2F%3E  %3C%2Fg%3E%3C%2Fsvg%3E\");\n  margin-bottom: 1.5rem;\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Complete/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;CCCD;ADED;EACE,gBAAA;EACA,kBAAA;CCAD;ADED;EACE,aAAA;EACA,yBAAA;EACA,ynBAAA;EACA,sBAAA;CCAD","file":"style.css","sourcesContent":[".wrapper {\n  margin-top: 116px;\n}\n\n.submessage {\n  font-size: 20px;\n  line-height: 32px;\n}\n.icon {\n  height: 4rem;\n  background-size: contain;\n  background-image: url('assets/complete.svg');\n  margin-bottom: 1.5rem;\n}\n",".wrapper {\n  margin-top: 116px;\n}\n.submessage {\n  font-size: 20px;\n  line-height: 32px;\n}\n.icon {\n  height: 4rem;\n  background-size: contain;\n  background-image: url('assets/complete.svg');\n  margin-bottom: 1.5rem;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"wrapper": "onfido-sdk-ui-Complete-wrapper",
	"submessage": "onfido-sdk-ui-Complete-submessage",
	"icon": "onfido-sdk-ui-Complete-icon"
};

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-Confirm-absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.onfido-sdk-ui-Confirm-previewsContainer {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.onfido-sdk-ui-Confirm-previewsContainer.onfido-sdk-ui-Confirm-previewsContainerIsFullScreen {\n  top: 0;\n}\n.onfido-sdk-ui-Confirm-actionsContainer {\n  margin: 0rem 3rem;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Confirm-actionsContainer {\n    margin: 0rem 24px;\n  }\n}\n.onfido-sdk-ui-Confirm-title {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 auto;\n          flex: 0 0 auto;\n}\n.onfido-sdk-ui-Confirm-captures {\n  height: 90%;\n  width: 100%;\n  margin-bottom: 2rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Confirm-captures {\n    margin-bottom: 1rem;\n  }\n}\n.onfido-sdk-ui-Confirm-imageWrapper {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-item-align: start;\n      align-self: flex-start;\n  width: 100%;\n  height: 100%;\n  max-width: 100%;\n  max-height: 100%;\n}\n.onfido-sdk-ui-Confirm-imageWrapper.onfido-sdk-ui-Confirm-fullscreenImageWrapper {\n  position: static;\n}\n.onfido-sdk-ui-Confirm-videoWrapper {\n  margin-top: 0;\n  height: 340px;\n}\n.onfido-sdk-ui-Confirm-image {\n  max-width: 100%;\n  max-height: 100%;\n  display: block;\n  margin: 0 auto;\n  border-radius: 3px;\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 auto;\n          flex: 0 0 auto;\n  -ms-flex-item-align: stretch;\n      align-self: stretch;\n  -o-object-fit: contain;\n     object-fit: contain;\n}\n.onfido-sdk-ui-Confirm-video {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n     object-fit: contain;\n}\n.onfido-sdk-ui-Confirm-pdfImage {\n  width: 100%;\n}\n.onfido-sdk-ui-Confirm-retake {\n  width: 136px;\n  padding: 0;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Confirm-retake {\n    width: 112px;\n  }\n}\n.onfido-sdk-ui-Confirm-actions {\n  padding: 0;\n}\n.onfido-sdk-ui-Confirm-pdfIcon {\n  display: inline-block;\n  width: 180px;\n  height: 180px;\n  max-width: 100%;\n  margin: 1rem auto 1rem;\n  background-position: 50% 50%;\n  background-repeat: no-repeat;\n  background-image: url(\"data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22utf-8%22%3F%3E%3C!-- Generator%3A Adobe Illustrator 21.0.0%2C SVG Export Plug-In . SVG Version%3A 6.00 Build 0)  --%3E%3Csvg version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 x%3D%220px%22 y%3D%220px%22 width%3D%2264px%22%09 height%3D%2264px%22 viewBox%3D%220 0 64 64%22 enable-background%3D%22new 0 0 64 64%22 xml%3Aspace%3D%22preserve%22%3E%3Cg id%3D%22passport-large%22%3E%3C%2Fg%3E%3Cg id%3D%22visa-large%22%3E%3C%2Fg%3E%3Cg id%3D%22support-docs-large%22%3E%3C%2Fg%3E%3Cg id%3D%22support-docs-empty-large%22%3E%3C%2Fg%3E%3Cg id%3D%22letter-large%22%3E%3C%2Fg%3E%3Cg id%3D%22pdf-large%22%3E%09%3Cg id%3D%22pdf-outline%22%3E%09%09%3Cpath fill%3D%22%23FFFFFF%22 d%3D%22M17%2C55c-1.1%2C0-2-0.9-2-2V11c0-1.1%2C0.9-2%2C2-2h24.4l7.6%2C8.4V53c0%2C1.1-0.9%2C2-2%2C2H17z%22%2F%3E%09%09%3Cpath fill%3D%22%232C3E4F%22 d%3D%22M40.9%2C10l7.1%2C7.8V53c0%2C0.5-0.5%2C1-1%2C1H17c-0.5%2C0-1-0.5-1-1V11c0-0.5%2C0.5-1%2C1-1H40.9 M41.8%2C8H17%09%09%09c-1.7%2C0-3%2C1.4-3%2C3v42c0%2C1.6%2C1.3%2C3%2C3%2C3h30c1.7%2C0%2C3-1.4%2C3-3V17L41.8%2C8L41.8%2C8z%22%2F%3E%09%3C%2Fg%3E%09%3Cpath id%3D%22fold_8_%22 fill%3D%22none%22 stroke%3D%22%232C3E4F%22 stroke-width%3D%222%22 stroke-miterlimit%3D%2210%22 d%3D%22M48%2C18h-5c-1.1%2C0-2-0.9-2-2v-6%22%2F%3E%09%3Cg id%3D%22pdf-container%22%3E%09%09%3Cpath id%3D%22container%22 fill%3D%22%23F5272E%22 d%3D%22M53%2C48H28c-0.5%2C0-1-0.5-1-1V37c0-0.5%2C0.5-1%2C1-1h25c0.5%2C0%2C1%2C0.5%2C1%2C1v10%09%09%09C54%2C47.5%2C53.5%2C48%2C53%2C48z%22%2F%3E%09%09%3Cg id%3D%22pdf-text%22%3E%09%09%09%3Cpath id%3D%22P%22 fill%3D%22%23FFFFFF%22 d%3D%22M35.7%2C40.4c0%2C0.8-0.3%2C1.5-0.9%2C1.9c-0.6%2C0.4-1.4%2C0.7-2.5%2C0.7h-0.9v3H30v-8h2.5%09%09%09%09c1.1%2C0%2C1.9%2C0.2%2C2.4%2C0.6C35.4%2C39%2C35.7%2C39.6%2C35.7%2C40.4z M31.4%2C41.9h0.7c0.7%2C0%2C1.2-0.1%2C1.6-0.4c0.3-0.2%2C0.5-0.6%2C0.5-1.1%09%09%09%09c0-0.5-0.1-0.8-0.5-1c-0.3-0.2-0.8-0.3-1.4-0.3h-1V41.9z%22%2F%3E%09%09%09%3Cpath id%3D%22D%22 fill%3D%22%23FFFFFF%22 d%3D%22M44%2C41.9c0%2C1.3-0.4%2C2.3-1.2%2C3c-0.8%2C0.7-1.9%2C1-3.4%2C1H37v-8h2.6c1.4%2C0%2C2.4%2C0.3%2C3.2%2C1%09%09%09%09C43.6%2C39.7%2C44%2C40.7%2C44%2C41.9z M42.5%2C42c0-1.9-1-2.9-2.9-2.9h-1.2v5.8h1C41.5%2C44.9%2C42.5%2C43.9%2C42.5%2C42z%22%2F%3E%09%09%09%3Cpath id%3D%22F%22 fill%3D%22%23FFFFFF%22 d%3D%22M47.4%2C46H46v-8h5v1.1h-3.6v2.5h3.3v1.1h-3.3V46z%22%2F%3E%09%09%3C%2Fg%3E%09%3C%2Fg%3E%09%3Cg id%3D%22success-tick%22%3E%09%09%3Ccircle id%3D%22circle_5_%22 fill%3D%22%232C3E4F%22 cx%3D%2216%22 cy%3D%2211%22 r%3D%227%22%2F%3E%09%09%3Cpath id%3D%22tick_1_%22 fill-rule%3D%22evenodd%22 clip-rule%3D%22evenodd%22 fill%3D%22%23FFFFFF%22 d%3D%22M18.1%2C8.5l-2.9%2C3.1l-0.7-0.8%09%09%09c-0.3-0.3-0.8-0.3-1.2%2C0c-0.3%2C0.3-0.3%2C0.9%2C0%2C1.2l1.3%2C1.4c0.3%2C0.3%2C0.8%2C0.3%2C1.2%2C0l3.5-3.7c0.3-0.3%2C0.3-0.9%2C0-1.2%09%09%09C18.9%2C8.2%2C18.4%2C8.2%2C18.1%2C8.5z%22%2F%3E%09%3C%2Fg%3E%3C%2Fg%3E%3Cg id%3D%22certificate-large%22%3E%3C%2Fg%3E%3Cg id%3D%22ukbrp-large%22%3E%3C%2Fg%3E%3Cg id%3D%22id-card-large%22%3E%3C%2Fg%3E%3Cg id%3D%22drivers-licence-large%22%3E%3C%2Fg%3E%3Cg id%3D%22national-insurance-card%22%3E%3C%2Fg%3E%3Cg id%3D%22passport%22%3E%3C%2Fg%3E%3Cg id%3D%22visa%22%3E%3C%2Fg%3E%3Cg id%3D%22support-docs%22%3E%3C%2Fg%3E%3Cg id%3D%22support-docs-empty%22%3E%3C%2Fg%3E%3Cg id%3D%22letter%22%3E%3C%2Fg%3E%3Cg id%3D%22certificate%22%3E%3C%2Fg%3E%3Cg id%3D%22ukbrp%22%3E%3C%2Fg%3E%3Cg id%3D%22id-card%22%3E%3C%2Fg%3E%3Cg id%3D%22drivers-licence%22%3E%3C%2Fg%3E%3Cg id%3D%22national-insurance-card_1_%22%3E%3C%2Fg%3E%3Cg id%3D%22passport-disabled%22%3E%3C%2Fg%3E%3Cg id%3D%22support-docs-empty-disabled%22%3E%3C%2Fg%3E%3Cg id%3D%22letter-disabled%22%3E%3C%2Fg%3E%3Cg id%3D%22certificate-disabled%22%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\n}\n.onfido-sdk-ui-Confirm-error {\n  display: block;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Confirm-error {\n    font-size: 11px;\n  }\n}\n.onfido-sdk-ui-Confirm-error .onfido-sdk-ui-Confirm-btn-outline {\n  width: 90%;\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Theme/constants.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Confirm/style.css"],"names":[],"mappings":"AAMA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;CCFD;ACRD;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EAAA,qBAAA;EAAA,cAAA;EACA,6BAAA;EAAA,8BAAA;MAAA,2BAAA;UAAA,uBAAA;EACA,0BAAA;MAAA,uBAAA;UAAA,+BAAA;CDUD;ACRC;EACE,OAAA;CDUH;ACND;EACE,kBAAA;CDQD;ACPC;EA6FF;IA5FI,kBAAA;GDUD;CACF;ACPD;EACE,oBAAA;MAAA,mBAAA;UAAA,eAAA;CDSD;ACND;EACE,YAAA;EACA,YAAA;EACA,oBAAA;EACA,qBAAA;EAAA,qBAAA;EAAA,cAAA;CDQD;ACNC;EA8EF;IA7EI,oBAAA;GDSD;CACF;ACND;EACE,mBAAA;EACA,qBAAA;EAAA,qBAAA;EAAA,cAAA;EACA,2BAAA;MAAA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;CDQD;ACNC;EACE,iBAAA;CDQH;ACJD;EACE,cAAA;EACA,cAAA;CDMD;ACHD;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;MAAA,mBAAA;UAAA,eAAA;EACA,6BAAA;MAAA,oBAAA;EACA,uBAAA;KAAA,oBAAA;CDKD;ACFD;EACE,YAAA;EACA,aAAA;EACA,uBAAA;KAAA,oBAAA;CDID;ACDD;EACE,YAAA;CDGD;ACAD;EACE,aAAA;EACA,WAAA;CDED;ACDC;EA8BF;IA7BI,aAAA;GDID;CACF;ACDD;EACE,WAAA;CDGD;ACAD;EACE,sBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EAEA,6BAAA;EACA,6BAAA;EACA,gwHAAA;CDCD;ACED;EACE,eAAA;CDAD;ACCC;EAOF;IANI,gBAAA;GDED;CACF;ACND;EAMI,WAAA;CDGH","file":"style.css","sourcesContent":["@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n@large-text-margin: 40px;\n@small-text-margin: 24px;\n\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.width-parent-relative(@base-width,@parent-width) {\n  width: 100%*(@base-width/@parent-width)\n}\n","@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.previewsContainer {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.previewsContainer.previewsContainerIsFullScreen {\n  top: 0;\n}\n.actionsContainer {\n  margin: 0rem 3rem;\n}\n@media (--small-viewport) {\n  .actionsContainer {\n    margin: 0rem 24px;\n  }\n}\n.title {\n  flex: 0 0 auto;\n}\n.captures {\n  height: 90%;\n  width: 100%;\n  margin-bottom: 2rem;\n  display: flex;\n}\n@media (--small-viewport) {\n  .captures {\n    margin-bottom: 1rem;\n  }\n}\n.imageWrapper {\n  position: relative;\n  display: flex;\n  align-self: flex-start;\n  width: 100%;\n  height: 100%;\n  max-width: 100%;\n  max-height: 100%;\n}\n.imageWrapper.fullscreenImageWrapper {\n  position: static;\n}\n.videoWrapper {\n  margin-top: 0;\n  height: 340px;\n}\n.image {\n  max-width: 100%;\n  max-height: 100%;\n  display: block;\n  margin: 0 auto;\n  border-radius: 3px;\n  flex: 0 0 auto;\n  align-self: stretch;\n  object-fit: contain;\n}\n.video {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.pdfImage {\n  width: 100%;\n}\n.retake {\n  width: 136px;\n  padding: 0;\n}\n@media (--small-viewport) {\n  .retake {\n    width: 112px;\n  }\n}\n.actions {\n  padding: 0;\n}\n.pdfIcon {\n  display: inline-block;\n  width: 180px;\n  height: 180px;\n  max-width: 100%;\n  margin: 1rem auto 1rem;\n  background-position: 50% 50%;\n  background-repeat: no-repeat;\n  background-image: url('assets/pdf-success.svg');\n}\n.error {\n  display: block;\n}\n@media (--small-viewport) {\n  .error {\n    font-size: 11px;\n  }\n}\n.error .btn-outline {\n  width: 90%;\n}\n","@import (less) \"../Theme/constants.css\";\n\n.previewsContainer {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  &.previewsContainerIsFullScreen {\n    top: 0;\n  }\n}\n\n.actionsContainer {\n  margin: 0rem 3rem;\n  @media (--small-viewport) {\n    margin: 0rem @small-text-margin;\n  }\n}\n\n.title {\n  flex: 0 0 auto;\n}\n\n.captures {\n  height: 90%;\n  width: 100%;\n  margin-bottom: 2rem;\n  display: flex;\n\n  @media (--small-viewport) {\n    margin-bottom: 1rem;\n  }\n}\n\n.imageWrapper {\n  position: relative;\n  display: flex;\n  align-self: flex-start;\n  width: 100%;\n  height: 100%;\n  max-width: 100%;\n  max-height: 100%;\n\n  &.fullscreenImageWrapper {\n    position: static;\n  }\n}\n\n.videoWrapper {\n  margin-top: 0;\n  height: 340px;\n}\n\n.image {\n  max-width: 100%;\n  max-height: 100%;\n  display: block;\n  margin: 0 auto;\n  border-radius: 3px;\n  flex: 0 0 auto;\n  align-self: stretch;\n  object-fit: contain;\n}\n\n.video {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.pdfImage {\n  width: 100%;\n}\n\n.retake {\n  width: 136px;\n  padding: 0;\n  @media (--small-viewport) {\n    width: 112px;\n  }\n}\n\n.actions{\n  padding: 0;\n}\n\n.pdfIcon {\n  display: inline-block;\n  width: 180px;\n  height: 180px;\n  max-width: 100%;\n  margin: 1rem auto 1rem;\n\n  background-position: 50% 50%;\n  background-repeat: no-repeat;\n  background-image: url('assets/pdf-success.svg');\n}\n\n.error {\n  display: block;\n  @media (--small-viewport) {\n    font-size: 11px;\n  }\n  .btn-outline {\n    width: 90%;\n  }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"absolute-center": "onfido-sdk-ui-Confirm-absolute-center",
	"previewsContainer": "onfido-sdk-ui-Confirm-previewsContainer",
	"previewsContainerIsFullScreen": "onfido-sdk-ui-Confirm-previewsContainerIsFullScreen",
	"actionsContainer": "onfido-sdk-ui-Confirm-actionsContainer",
	"title": "onfido-sdk-ui-Confirm-title",
	"captures": "onfido-sdk-ui-Confirm-captures",
	"imageWrapper": "onfido-sdk-ui-Confirm-imageWrapper",
	"fullscreenImageWrapper": "onfido-sdk-ui-Confirm-fullscreenImageWrapper",
	"videoWrapper": "onfido-sdk-ui-Confirm-videoWrapper",
	"image": "onfido-sdk-ui-Confirm-image",
	"video": "onfido-sdk-ui-Confirm-video",
	"pdfImage": "onfido-sdk-ui-Confirm-pdfImage",
	"retake": "onfido-sdk-ui-Confirm-retake",
	"actions": "onfido-sdk-ui-Confirm-actions",
	"pdfIcon": "onfido-sdk-ui-Confirm-pdfIcon",
	"error": "onfido-sdk-ui-Confirm-error",
	"btn-outline": "onfido-sdk-ui-Confirm-btn-outline"
};

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-CustomFileInput-container {\n  position: relative;\n  cursor: pointer;\n}\n.onfido-sdk-ui-CustomFileInput-input {\n  bottom: 0;\n  left: 0;\n  display: none;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 100%;\n  z-index: 1;\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/CustomFileInput/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,gBAAA;CCCD;ADED;EACE,UAAA;EACA,QAAA;EACA,cAAA;EACA,mBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;CCAD","file":"style.css","sourcesContent":[".container {\n  position: relative;\n  cursor: pointer;\n}\n\n.input {\n  bottom: 0;\n  left: 0;\n  display: none;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 100%;\n  z-index: 1;\n}",".container {\n  position: relative;\n  cursor: pointer;\n}\n.input {\n  bottom: 0;\n  left: 0;\n  display: none;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 100%;\n  z-index: 1;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "onfido-sdk-ui-CustomFileInput-container",
	"input": "onfido-sdk-ui-CustomFileInput-input"
};

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-DocumentSelector-absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.onfido-sdk-ui-DocumentSelector-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  position: relative;\n  margin: 8px 40px 0;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-DocumentSelector-wrapper {\n    margin: 0 16px;\n  }\n}\n.onfido-sdk-ui-DocumentSelector-option {\n  background: #fff;\n  border-radius: 4px;\n  border: 1px solid #8B9094;\n  color: #2C3E4F;\n  cursor: pointer;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 14px;\n  line-height: 20px;\n  margin-bottom: 8px;\n  padding: 16px;\n  position: relative;\n}\n.onfido-sdk-ui-DocumentSelector-option::after {\n  background: url(\"data:image/svg+xml,%3Csvg width%3D%228%22 height%3D%2212%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E  %3Cpath d%3D%22M.3318 1.8112l4.9309 4.1886-4.9309 4.189c-.4424.4141-.4424 1.0865 0 1.5006.4425.4141 1.1621.4141 1.6046 0l5.7358-4.873c.2398-.2242.3465-.5234.3251-.8166.0214-.2933-.0853-.592-.3251-.8163L1.9364.3105c-.4425-.414-1.1621-.414-1.6046 0-.4424.4142-.4424 1.0866 0 1.5007z%22 fill%3D%22%232C3E4F%22 fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E\") no-repeat;\n  content: '';\n  display: block;\n  height: 12px;\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  -webkit-transform: translateY(-6px);\n          transform: translateY(-6px);\n  width: 8px;\n}\n.onfido-sdk-ui-DocumentSelector-content {\n  text-align: left;\n  -ms-flex-item-align: center;\n      align-self: center;\n  -ms-flex-preferred-size: 100%;\n      flex-basis: 100%;\n}\n.onfido-sdk-ui-DocumentSelector-optionMain {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  margin-right: 18px;\n  min-height: 48px;\n}\n.onfido-sdk-ui-DocumentSelector-label {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n}\n.onfido-sdk-ui-DocumentSelector-hint {\n  color: #565B5E;\n  margin-bottom: 4px;\n}\n.onfido-sdk-ui-DocumentSelector-warning {\n  font-weight: 600;\n  margin-bottom: 6px;\n}\n.onfido-sdk-ui-DocumentSelector-tag {\n  display: inline-block;\n  background-color: #F3F3F4;\n  padding: 0 12px;\n  border-radius: 12px;\n  margin-left: -12px;\n  margin-top: 2px;\n}\n.onfido-sdk-ui-DocumentSelector-icon {\n  max-width: 100%;\n  background-position: 50% 50%;\n  background-repeat: no-repeat;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  width: 48px;\n  height: 48px;\n  margin-right: 16px;\n  -ms-flex-item-align: start;\n      align-self: flex-start;\n}\n.onfido-sdk-ui-DocumentSelector-icon-passport {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 width%3D%2248%22 height%3D%2248%22 viewBox%3D%22-12 -6.5 48 48%22%3E%0D  %3Ccircle fill%3D%22%2320C7A0%22 cx%3D%2212%22 cy%3D%2217.5%22 r%3D%2224%22%2F%3E%0D  %3Cpath fill%3D%22%23FFF%22 stroke%3D%22%232C3E4F%22 stroke-width%3D%222%22 d%3D%22M1 5.762v15.95l18-4.6V2.11c0-.552-.447-1-1-1-.09 0-.18.012-.266.036L1 5.762z%22%2F%3E%0D  %3Cpath fill%3D%22%23FFF%22 stroke%3D%22%232C3E4F%22 stroke-width%3D%222%22 d%3D%22M1 6v28h20c1.104 0 2-.896 2-2V8c0-1.104-.896-2-2-2H1z%22%2F%3E%0D  %3Cpath fill%3D%22%232C3E4F%22 d%3D%22M7 28h10c.553 0 1 .447 1 1 0 .553-.447 1-1 1H7c-.552 0-1-.447-1-1 0-.553.448-1 1-1z%22%2F%3E%0D  %3Cpath fill%3D%22%23FFF%22 stroke%3D%22%232C3E4F%22 stroke-width%3D%222%22 d%3D%22M12 24c3.313 0 6-2.687 6-6s-2.687-6-6-6-6 2.687-6 6 2.687 6 6 6z%22%2F%3E%0D  %3Cpath fill%3D%22%232C3E4F%22 d%3D%22M6 15h12v2H6v-2zm0 4h12v2H6v-2z%22%2F%3E%0D  %3Cpath fill%3D%22%232C3E4F%22 d%3D%22M11 12h2v12h-2V12z%22%2F%3E%0D%3C%2Fsvg%3E\");\n}\n.onfido-sdk-ui-DocumentSelector-icon-national-identity-card {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 width%3D%2248%22 height%3D%2248%22 viewBox%3D%22-6.5 -12 48 48%22%3E%0D  %3Ccircle fill%3D%22%2320C7A0%22 cx%3D%2217.5%22 cy%3D%2212%22 r%3D%2224%22%2F%3E%0D  %3Cpath fill%3D%22%23FFF%22 stroke%3D%22%232C3E4F%22 stroke-width%3D%222%22 d%3D%22M4 1h27c1.656 0 3 1.343 3 3v16c0 1.656-1.344 3-3 3H4c-1.657 0-3-1.344-3-3V4c0-1.657 1.343-3 3-3z%22%2F%3E%0D  %3Cg fill%3D%22%232C3E4F%22%3E%0D    %3Cpath d%3D%22M17 11h8c.553 0 1 .448 1 1 0 .553-.447 1-1 1h-8c-.552 0-1-.447-1-1 0-.552.448-1 1-1zM17 7h12c.553 0 1 .448 1 1s-.447 1-1 1H17c-.552 0-1-.448-1-1s.448-1 1-1z%22%2F%3E%0D  %3C%2Fg%3E%0D  %3Cpath fill%3D%22%23FFF%22 stroke%3D%22%232C3E4F%22 stroke-width%3D%222%22 d%3D%22M5.01 18h8.979c.014-.078.014-.169.003-.211C13.379 15.538 11.554 14 9.5 14c-2.055 0-3.88 1.539-4.493 3.791-.011.041-.01.131.003.209zm8.964.073c-.002.003-.004.005-.005.005.001-.003.002-.006.004-.01l.001.005zM9.5 11c1.275 0 2.5-1.369 2.5-2.733C12 7.031 10.896 6 9.5 6c-.936 0-1.771.469-2.203 1.195C7.103 7.522 7 7.887 7 8.267 7 9.631 8.225 11 9.5 11z%22%2F%3E%0D%3C%2Fsvg%3E\");\n}\n.onfido-sdk-ui-DocumentSelector-icon-driving-licence {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 width%3D%2248%22 height%3D%2248%22 viewBox%3D%22-6 -15 48 48%22%3E%0D  %3Ccircle fill%3D%22%2320C7A0%22 cx%3D%2218%22 cy%3D%229%22 r%3D%2224%22%2F%3E%0D  %3Cpath fill%3D%22%23FFF%22 d%3D%22M3.13 16C.97 16 0 12.32 0 9.561 0 7.3.79 5.38 2.34 3.85l-.58-1.17c-.27-.28-.35-.7-.2-1.07.14-.36.48-.6.85-.6l3.49.55A22.5725 22.5725 0 0 1 14.29 0c7.59 0 12.64 3.81 13.7 4.69 5.539.15 8.01 4.15 8.01 5.65v3.12c0 1.47-1.439 2.54-2.41 2.54H3.13z%22%2F%3E%0D  %3Cg fill%3D%22%232C3E4F%22%3E%0D    %3Cpath d%3D%22M11 14h15v2H11v-2z%22%2F%3E%0D    %3Cpath d%3D%22M32.1 16c-.523-.011-.94-.445-.93-.969v-.012c0-.539.42-1.02.93-1.02h1.49C34 14 34 13.28 34 13v-2.66c0-.63-1.67-3.7-6.35-3.7a.8958.8958 0 0 1-.61-.24c-.2-.18-5.08-4.44-12.75-4.44-1.35 0-4.83.14-7.89 1.48a.865.865 0 0 1-.35.08L4 3c.06.15.66.82.65.98-.019.283-.157.545-.38.72a5.85 5.85 0 0 0-2.41 4.86c0 3.5 1.15 4.33 1.27 4.479.48.05 1.04.47 1.04.979C4.17 15.29 4 16 4 16h-.87C.97 16 0 12.32 0 9.561 0 7.3.79 5.38 2.34 3.85l-.58-1.17c-.27-.28-.35-.7-.2-1.07.14-.36.48-.6.85-.6l3.49.55A22.5725 22.5725 0 0 1 14.29 0c7.59 0 12.64 3.81 13.7 4.69 5.539.15 8.01 4.15 8.01 5.65v3.12c0 1.47-1.439 2.54-2.41 2.54H32.1z%22%2F%3E%0D  %3C%2Fg%3E%0D  %3Cg fill%3D%22%232C3E4F%22%3E%0D    %3Cpath d%3D%22M18 4c.553 0 1 .448 1 1v2c0 .552-.447 1-1 1-.552 0-1-.448-1-1V5c0-.552.448-1 1-1z%22%2F%3E%0D    %3Cpath d%3D%22M18 6h5c.553 0 1 .448 1 1s-.447 1-1 1h-5c-.552 0-1-.448-1-1s.448-1 1-1z%22%2F%3E%0D  %3C%2Fg%3E%0D  %3Cg transform%3D%22translate(3 9)%22 fill%3D%22%23FFF%22 stroke%3D%22%232C3E4F%22 stroke-width%3D%222%22%3E%0D    %3Ccircle cx%3D%2225.5%22 cy%3D%224.5%22 r%3D%223.5%22%2F%3E%0D    %3Ccircle cx%3D%224.5%22 cy%3D%224.5%22 r%3D%223.5%22%2F%3E%0D  %3C%2Fg%3E%0D%3C%2Fsvg%3E\");\n}\n.onfido-sdk-ui-DocumentSelector-icon-bank-building-society-statement {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 width%3D%2248%22 height%3D%2248%22%3E  %3Ccircle fill%3D%22%2320c7a0%22 cx%3D%2224%22 cy%3D%2224%22 r%3D%2224%22%2F%3E  %3Cg fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E    %3Cg transform%3D%22translate(16 25)%22%3E      %3Ccircle cx%3D%228%22 cy%3D%228%22 r%3D%228%22 fill%3D%22%23FFF%22 stroke%3D%22%232C3E4F%22 stroke-width%3D%222%22%2F%3E      %3Ctext fill%3D%22%232C3E4F%22 font-family%3D%22OpenSans-Bold%2C Open Sans%22 font-size%3D%2211%22 font-weight%3D%22bold%22%3E        %3Ctspan x%3D%224%22 y%3D%2212%22%3E%E2%82%AC%3C%2Ftspan%3E      %3C%2Ftext%3E    %3C%2Fg%3E    %3Cg transform%3D%22translate(25 13)%22%3E      %3Ccircle cx%3D%228%22 cy%3D%228%22 r%3D%228%22 fill%3D%22%23FFF%22 stroke%3D%22%232C3E4F%22 stroke-width%3D%222%22%2F%3E      %3Ctext fill%3D%22%232C3E4F%22 font-family%3D%22OpenSans-Bold%2C Open Sans%22 font-size%3D%2211%22 font-weight%3D%22bold%22%3E        %3Ctspan x%3D%225%22 y%3D%2212%22%3E%C2%A3%3C%2Ftspan%3E      %3C%2Ftext%3E    %3C%2Fg%3E    %3Cg transform%3D%22translate(9 9)%22%3E      %3Ccircle cx%3D%228%22 cy%3D%228%22 r%3D%228%22 fill%3D%22%23FFF%22 stroke%3D%22%232C3E4F%22 stroke-width%3D%222%22%2F%3E      %3Ctext fill%3D%22%232C3E4F%22 font-family%3D%22OpenSans-Bold%2C Open Sans%22 font-size%3D%2211%22 font-weight%3D%22bold%22%3E        %3Ctspan x%3D%225%22 y%3D%2212%22%3E%24%3C%2Ftspan%3E      %3C%2Ftext%3E    %3C%2Fg%3E  %3C%2Fg%3E%3C%2Fsvg%3E\");\n}\n.onfido-sdk-ui-DocumentSelector-icon-utility-bill {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 width%3D%2248%22 height%3D%2248%22%3E  %3Ccircle fill%3D%22%2320c7a0%22 cx%3D%2224%22 cy%3D%2224%22 r%3D%2224%22%2F%3E  %3Cg fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E    %3Cg transform%3D%22translate(15 13)%22%3E      %3Cpath fill%3D%22%23FFF%22 stroke%3D%22%232C3E4F%22 stroke-width%3D%222%22 d%3D%22M4.5527 15.651l.3326.223.7429 3.343a1 1 0 0 0 .9761.783h4.7914a1 1 0 0 0 .9761-.783l.743-3.343.3325-.223C15.6512 14.1741 17 11.7022 17 9c0-4.4183-3.5817-8-8-8S1 4.5817 1 9c0 2.7022 1.3488 5.1741 3.5527 6.651z%22%2F%3E      %3Crect width%3D%228%22 height%3D%222%22 x%3D%225%22 y%3D%2222%22 fill%3D%22%232C3E4F%22 rx%3D%221%22%2F%3E      %3Crect width%3D%226%22 height%3D%222%22 x%3D%226%22 y%3D%2225%22 fill%3D%22%232C3E4F%22 rx%3D%221%22%2F%3E    %3C%2Fg%3E    %3Cg fill%3D%22%232C3E4F%22 transform%3D%22translate(10 8)%22%3E      %3Crect width%3D%221%22 height%3D%224%22 x%3D%224.268%22 y%3D%223.768%22 rx%3D%22.5%22 transform%3D%22rotate(-45 4.768 5.768)%22%2F%3E      %3Crect width%3D%221%22 height%3D%224%22 x%3D%2213%22 rx%3D%22.5%22%2F%3E      %3Crect width%3D%221%22 height%3D%224%22 x%3D%2222.268%22 y%3D%223.768%22 rx%3D%22.5%22 transform%3D%22rotate(45 22.768 5.768)%22%2F%3E      %3Crect width%3D%224%22 height%3D%221%22 y%3D%2212%22 rx%3D%22.5%22%2F%3E      %3Crect width%3D%224%22 height%3D%221%22 x%3D%2224%22 y%3D%2212%22 rx%3D%22.5%22%2F%3E    %3C%2Fg%3E  %3C%2Fg%3E%3C%2Fsvg%3E\");\n}\n.onfido-sdk-ui-DocumentSelector-icon-letter {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2248%22 height%3D%2248%22%3E  %3Cdefs%3E    %3Ccircle id%3D%22a%22 cx%3D%2224%22 cy%3D%2224%22 r%3D%2224%22%2F%3E  %3C%2Fdefs%3E  %3Ccircle fill%3D%22%2320c7a0%22 cx%3D%2224%22 cy%3D%2224%22 r%3D%2224%22%2F%3E  %3Cg fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E    %3Cmask id%3D%22b%22 fill%3D%22%23FFF%22%3E      %3Cuse xlink%3Ahref%3D%22%23a%22%2F%3E    %3C%2Fmask%3E    %3Crect width%3D%2230%22 height%3D%2243%22 x%3D%229%22 y%3D%2212%22 fill%3D%22%23FFF%22 stroke%3D%22%232C3E4F%22 stroke-width%3D%222%22 mask%3D%22url(%23b)%22 rx%3D%223%22%2F%3E    %3Cg fill%3D%22%232C3E4F%22 mask%3D%22url(%23b)%22%3E      %3Cg transform%3D%22translate(11.8 14.857)%22%3E        %3Crect width%3D%2215%22 height%3D%222%22 x%3D%22.2%22 y%3D%2216.143%22 rx%3D%221%22%2F%3E        %3Crect width%3D%2219%22 height%3D%222%22 x%3D%22.2%22 y%3D%2212.143%22 rx%3D%221%22%2F%3E        %3Crect width%3D%2212%22 height%3D%222%22 x%3D%226.2%22 y%3D%221.143%22 rx%3D%221%22%2F%3E        %3Crect width%3D%225%22 height%3D%224%22 x%3D%2219.2%22 y%3D%22.143%22 rx%3D%221%22%2F%3E      %3C%2Fg%3E    %3C%2Fg%3E  %3C%2Fg%3E%3C%2Fsvg%3E\");\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Theme/constants.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/DocumentSelector/style.css"],"names":[],"mappings":"AAMA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;CCFD;ACRD;EACE,qBAAA;EAAA,qBAAA;EAAA,cAAA;EACA,6BAAA;EAAA,8BAAA;MAAA,2BAAA;UAAA,uBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,wBAAA;EACA,mBAAA;EACA,mBAAA;CDUD;ACTC;EA6FF;IA5FI,eAAA;GDYD;CACF;ACTD;EACE,iBAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EAAA,qBAAA;EAAA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;CDWD;ACTC;EACE,+eAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,oCAAA;UAAA,4BAAA;EACA,WAAA;CDWH;ACPD;EACE,iBAAA;EACA,4BAAA;MAAA,mBAAA;EACA,8BAAA;MAAA,iBAAA;CDSD;ACND;EACE,qBAAA;EAAA,qBAAA;EAAA,cAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,wBAAA;EACA,6BAAA;EAAA,8BAAA;MAAA,2BAAA;UAAA,uBAAA;EACA,mBAAA;EACA,iBAAA;CDQD;ACLD;EACE,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;CDOD;ACJD;EACE,eAAA;EACA,mBAAA;CDMD;ACHD;EACE,iBAAA;EACA,mBAAA;CDKD;ACFD;EACE,sBAAA;EACA,0BAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;CDID;ACDD;EACE,gBAAA;EACA,6BAAA;EACA,6BAAA;EACA,qBAAA;MAAA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;MAAA,uBAAA;CDGD;ACKC;EACE,ohCAAA;CDHH;ACEC;EACE,0nCAAA;CDAH;ACDC;EACE,4xDAAA;CDGH;ACJC;EACE,89CAAA;CDMH;ACPC;EACE,+9CAAA;CDSH;ACVC;EACE,gwCAAA;CDYH","file":"style.css","sourcesContent":["@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n@large-text-margin: 40px;\n@small-text-margin: 24px;\n\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.width-parent-relative(@base-width,@parent-width) {\n  width: 100%*(@base-width/@parent-width)\n}\n","@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  position: relative;\n  margin: 8px 40px 0;\n}\n@media (--small-viewport) {\n  .wrapper {\n    margin: 0 16px;\n  }\n}\n.option {\n  background: #fff;\n  border-radius: 4px;\n  border: 1px solid #8B9094;\n  color: #2C3E4F;\n  cursor: pointer;\n  display: flex;\n  font-size: 14px;\n  line-height: 20px;\n  margin-bottom: 8px;\n  padding: 16px;\n  position: relative;\n}\n.option::after {\n  background: url('assets/right.svg') no-repeat;\n  content: '';\n  display: block;\n  height: 12px;\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  transform: translateY(-6px);\n  width: 8px;\n}\n.content {\n  text-align: left;\n  align-self: center;\n  flex-basis: 100%;\n}\n.optionMain {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  margin-right: 18px;\n  min-height: 48px;\n}\n.label {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n}\n.hint {\n  color: #565B5E;\n  margin-bottom: 4px;\n}\n.warning {\n  font-weight: 600;\n  margin-bottom: 6px;\n}\n.tag {\n  display: inline-block;\n  background-color: #F3F3F4;\n  padding: 0 12px;\n  border-radius: 12px;\n  margin-left: -12px;\n  margin-top: 2px;\n}\n.icon {\n  max-width: 100%;\n  background-position: 50% 50%;\n  background-repeat: no-repeat;\n  flex-shrink: 0;\n  width: 48px;\n  height: 48px;\n  margin-right: 16px;\n  align-self: flex-start;\n}\n.icon-passport {\n  background-image: url('assets/icon-passport.svg');\n}\n.icon-national-identity-card {\n  background-image: url('assets/icon-national-identity-card.svg');\n}\n.icon-driving-licence {\n  background-image: url('assets/icon-driving-licence.svg');\n}\n.icon-bank-building-society-statement {\n  background-image: url('assets/icon-bank-building-society-statement.svg');\n}\n.icon-utility-bill {\n  background-image: url('assets/icon-utility-bill.svg');\n}\n.icon-letter {\n  background-image: url('assets/icon-letter.svg');\n}\n","@import (less) \"../Theme/constants.css\";\n\n.wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  position: relative;\n  margin: 8px @large-text-margin 0;\n  @media (--small-viewport) {\n    margin: 0 16px;\n  }\n}\n\n.option {\n  background: #fff;\n  border-radius: 4px;\n  border: 1px solid #8B9094;\n  color: #2C3E4F;\n  cursor: pointer;\n  display: flex;\n  font-size: 14px;\n  line-height: 20px;\n  margin-bottom: 8px;\n  padding: 16px;\n  position: relative;\n\n  &::after {\n    background: url('assets/right.svg') no-repeat;\n    content: '';\n    display: block;\n    height: 12px;\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translateY(-6px);\n    width: 8px;\n  }\n}\n\n.content {\n  text-align: left;\n  align-self: center;\n  flex-basis: 100%;\n}\n\n.optionMain {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  margin-right: 18px;\n  min-height: 48px;\n}\n\n.label {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n}\n\n.hint {\n  color: #565B5E;\n  margin-bottom: 4px;\n}\n\n.warning {\n  font-weight: 600;\n  margin-bottom: 6px;\n}\n\n.tag {\n  display: inline-block;\n  background-color: #F3F3F4;\n  padding: 0 12px;\n  border-radius: 12px;\n  margin-left: -12px;\n  margin-top: 2px;\n}\n\n.icon {\n  max-width: 100%;\n  background-position: 50% 50%;\n  background-repeat: no-repeat;\n  flex-shrink: 0;\n  width: 48px;\n  height: 48px;\n  margin-right: 16px;\n  align-self: flex-start;\n}\n\n@document-types: passport, national-identity-card, driving-licence,\n                 bank-building-society-statement, utility-bill, letter;\n\n.loop(@index: 1) when (@index <= length(@document-types)) {\n  @value: extract(@document-types, @index);\n  .icon-@{value} {\n    background-image: url('assets/icon-@{value}.svg');\n  }\n  .loop(@index + 1);\n}\n.loop();\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"absolute-center": "onfido-sdk-ui-DocumentSelector-absolute-center",
	"wrapper": "onfido-sdk-ui-DocumentSelector-wrapper",
	"option": "onfido-sdk-ui-DocumentSelector-option",
	"content": "onfido-sdk-ui-DocumentSelector-content",
	"optionMain": "onfido-sdk-ui-DocumentSelector-optionMain",
	"label": "onfido-sdk-ui-DocumentSelector-label",
	"hint": "onfido-sdk-ui-DocumentSelector-hint",
	"warning": "onfido-sdk-ui-DocumentSelector-warning",
	"tag": "onfido-sdk-ui-DocumentSelector-tag",
	"icon": "onfido-sdk-ui-DocumentSelector-icon",
	"icon-passport": "onfido-sdk-ui-DocumentSelector-icon-passport",
	"icon-national-identity-card": "onfido-sdk-ui-DocumentSelector-icon-national-identity-card",
	"icon-driving-licence": "onfido-sdk-ui-DocumentSelector-icon-driving-licence",
	"icon-bank-building-society-statement": "onfido-sdk-ui-DocumentSelector-icon-bank-building-society-statement",
	"icon-utility-bill": "onfido-sdk-ui-DocumentSelector-icon-utility-bill",
	"icon-letter": "onfido-sdk-ui-DocumentSelector-icon-letter"
};

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-EnlargedPreview-expanded {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 4;\n  background-color: #fff;\n}\n.onfido-sdk-ui-EnlargedPreview-imageContainer {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.onfido-sdk-ui-EnlargedPreview-image {\n  min-height: 100%;\n  min-width: 100%;\n  -o-object-fit: contain;\n     object-fit: contain;\n  -o-object-position: center;\n     object-position: center;\n  display: block;\n  -ms-touch-action: none;\n      touch-action: none;\n}\n.onfido-sdk-ui-EnlargedPreview-button {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  font-size: 11px;\n  -webkit-transform: translate3d(-50%, -50%, 0);\n          transform: translate3d(-50%, -50%, 0);\n}\n.onfido-sdk-ui-EnlargedPreview-button::before {\n  content: '';\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  background-image: url(\"data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2212%22 height%3D%2212%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%3C!--Generator%3A Sketch 51.2 (57519) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch--%3E%3Cdefs%3E%3Cpath d%3D%22M1.24 3.33h3.1V2H.63C.28 2 0 2.3 0 2.67v4h1.24V3.33zM.62 14h3.73v-1.33h-3.1V9.33H0v4c0 .37.28.67.62.67zM12 13.33v-4h-1.25v3.34h-3.1V14h3.73c.34 0 .62-.3.62-.67zm-4.35-10h3.1v3.34H12v-4c0-.37-.28-.67-.62-.67H7.65v1.33z%22 id%3D%22a%22%2F%3E%3C%2Fdefs%3E%3Cuse fill%3D%22%23FFF%22 fill-rule%3D%22nonzero%22 xlink%3Ahref%3D%22%23a%22 transform%3D%22translate(0 -2)%22 opacity%3D%22.85%22%2F%3E%3C%2Fsvg%3E\");\n  background-repeat: no-repeat;\n  background-size: contain;\n  vertical-align: middle;\n  margin-top: -2px;\n  margin-right: 10px;\n}\n.onfido-sdk-ui-EnlargedPreview-expanded .onfido-sdk-ui-EnlargedPreview-button {\n  top: auto;\n  bottom: 16px;\n  font-size: 16px;\n  opacity: 0;\n  -webkit-transition: opacity 0.75s cubic-bezier(0.19, 1, 0.22, 1), -webkit-transform 0.75s cubic-bezier(0.19, 1, 0.22, 1);\n  transition: opacity 0.75s cubic-bezier(0.19, 1, 0.22, 1), -webkit-transform 0.75s cubic-bezier(0.19, 1, 0.22, 1);\n  transition: opacity 0.75s cubic-bezier(0.19, 1, 0.22, 1), transform 0.75s cubic-bezier(0.19, 1, 0.22, 1);\n  transition: opacity 0.75s cubic-bezier(0.19, 1, 0.22, 1), transform 0.75s cubic-bezier(0.19, 1, 0.22, 1), -webkit-transform 0.75s cubic-bezier(0.19, 1, 0.22, 1);\n  -webkit-transform: translate3d(-50%, 32px, 0);\n          transform: translate3d(-50%, 32px, 0);\n}\n.onfido-sdk-ui-EnlargedPreview-expanded .onfido-sdk-ui-EnlargedPreview-button::before {\n  width: 18px;\n  height: 18px;\n  margin-top: -3px;\n  margin-right: 8px;\n  background-image: url(\"data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2212%22 height%3D%2212%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%3C!--Generator%3A Sketch 51.2 (57519) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch--%3E%3Cdefs%3E%3Cpath d%3D%22M.943 13.471l2.114-2.114 1.414 1.414V9H.701l1.414 1.414L0 12.529l.943.942zM11.029 2L8.914 4.115 7.5 2.7v3.77h3.77L9.858 5.057l2.114-2.114L11.03 2zM7.5 9v3.77l1.414-1.413 2.115 2.114.942-.942-2.114-2.115L11.27 9H7.5zM4.471 2.7L3.057 4.116.943 2 0 2.943l2.115 2.114L.7 6.471h3.77v-3.77z%22 id%3D%22a%22%2F%3E%3C%2Fdefs%3E%3Cuse fill%3D%22%23FFF%22 fill-rule%3D%22nonzero%22 xlink%3Ahref%3D%22%23a%22 transform%3D%22translate(0 -2)%22 opacity%3D%22.85%22%2F%3E%3C%2Fsvg%3E\");\n}\n.onfido-sdk-ui-EnlargedPreview-expanded.onfido-sdk-ui-EnlargedPreview-entered .onfido-sdk-ui-EnlargedPreview-button {\n  opacity: 1;\n  -webkit-transform: translate3d(-50%, -50%, 0);\n          transform: translate3d(-50%, -50%, 0);\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/EnlargedPreview/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;CCCD;ADED;EACE,mBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;CCAD;ADGD;EACE,iBAAA;EACA,gBAAA;EACA,uBAAA;KAAA,oBAAA;EACA,2BAAA;KAAA,wBAAA;EACA,eAAA;EACA,uBAAA;MAAA,mBAAA;CCDD;ADID;EACE,mBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,8CAAA;UAAA,sCAAA;CCFD;ADIC;EACE,YAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,wwBAAA;EACA,6BAAA;EACA,yBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;CCFH;ADMD;EAEI,UAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,yHAAA;EAAA,iHAAA;EAAA,yGAAA;EAAA,iKAAA;EAEA,8CAAA;UAAA,sCAAA;CCNH;ADQG;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,20BAAA;CCNL;ADUC;EAEI,WAAA;EACA,8CAAA;UAAA,sCAAA;CCTL","file":"style.css","sourcesContent":[".expanded {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 4;\n  background-color: #fff;\n}\n\n.imageContainer {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.image {\n  min-height: 100%;\n  min-width: 100%;\n  object-fit: contain;\n  object-position: center;\n  display: block;\n  touch-action: none;\n}\n\n.button {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  font-size: 11px;\n  transform: translate3d(-50%, -50%, 0);\n\n  &::before {\n    content: '';\n    display: inline-block;\n    width: 12px;\n    height: 12px;\n    background-image: url('assets/enlarge.svg');\n    background-repeat: no-repeat;\n    background-size: contain;\n    vertical-align: middle;\n    margin-top: -2px;\n    margin-right: 10px;\n  }\n}\n\n.expanded {\n  .button {\n    top: auto;\n    bottom: 16px;\n    font-size: 16px;\n    opacity: 0;\n    transition: opacity .75s cubic-bezier(0.19, 1, 0.22, 1),\n                transform .75s cubic-bezier(0.19, 1, 0.22, 1);\n    transform: translate3d(-50%, 32px, 0);\n\n    &::before {\n      width: 18px;\n      height: 18px;\n      margin-top: -3px;\n      margin-right: 8px;\n      background-image: url('assets/collapse.svg'); \n    }\n  }\n\n  &.entered {\n    .button {\n      opacity: 1;\n      transform: translate3d(-50%, -50%, 0);\n    }\n  }\n}",".expanded {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 4;\n  background-color: #fff;\n}\n.imageContainer {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.image {\n  min-height: 100%;\n  min-width: 100%;\n  object-fit: contain;\n  object-position: center;\n  display: block;\n  touch-action: none;\n}\n.button {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  font-size: 11px;\n  transform: translate3d(-50%, -50%, 0);\n}\n.button::before {\n  content: '';\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  background-image: url('assets/enlarge.svg');\n  background-repeat: no-repeat;\n  background-size: contain;\n  vertical-align: middle;\n  margin-top: -2px;\n  margin-right: 10px;\n}\n.expanded .button {\n  top: auto;\n  bottom: 16px;\n  font-size: 16px;\n  opacity: 0;\n  transition: opacity 0.75s cubic-bezier(0.19, 1, 0.22, 1), transform 0.75s cubic-bezier(0.19, 1, 0.22, 1);\n  transform: translate3d(-50%, 32px, 0);\n}\n.expanded .button::before {\n  width: 18px;\n  height: 18px;\n  margin-top: -3px;\n  margin-right: 8px;\n  background-image: url('assets/collapse.svg');\n}\n.expanded.entered .button {\n  opacity: 1;\n  transform: translate3d(-50%, -50%, 0);\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"expanded": "onfido-sdk-ui-EnlargedPreview-expanded",
	"imageContainer": "onfido-sdk-ui-EnlargedPreview-imageContainer",
	"image": "onfido-sdk-ui-EnlargedPreview-image",
	"button": "onfido-sdk-ui-EnlargedPreview-button",
	"entered": "onfido-sdk-ui-EnlargedPreview-entered"
};

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-Error-absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.onfido-sdk-ui-Error-container,\n.onfido-sdk-ui-Error-container-error,\n.onfido-sdk-ui-Error-container-warning {\n  border-radius: 6px;\n  text-align: left;\n  color: #FFFFFF;\n  margin: 0 40px 16px;\n  padding: 8px 16px 12px 16px;\n  position: relative;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Error-container,\n  .onfido-sdk-ui-Error-container-error,\n  .onfido-sdk-ui-Error-container-warning {\n    margin: 0 16px;\n  }\n}\n.onfido-sdk-ui-Error-container-error {\n  background-color: #DC2A2A;\n}\n.onfido-sdk-ui-Error-container-warning {\n  background-color: #2A7AB0;\n}\n.onfido-sdk-ui-Error-instruction {\n  margin-top: 0px;\n  margin-bottom: 0px;\n  margin-left: 24px;\n  font-size: 14px;\n  line-height: 20px;\n}\n.onfido-sdk-ui-Error-title {\n  position: relative;\n}\n.onfido-sdk-ui-Error-title-text {\n  display: inline-block;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  padding-left: 24px;\n}\n.onfido-sdk-ui-Error-title-icon,\n.onfido-sdk-ui-Error-title-icon-error,\n.onfido-sdk-ui-Error-title-icon-warning {\n  position: absolute;\n  height: 100%;\n  width: 16px;\n  margin-right: 8px;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n.onfido-sdk-ui-Error-title-icon-error {\n  background-image: url(\"data:image/svg+xml,%3Csvg width%3D%2216%22 height%3D%2216%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E%3Ccircle fill%3D%22%23FFF%22 cx%3D%228%22 cy%3D%228%22 r%3D%228%22%2F%3E%3Ccircle stroke%3D%22%23FFF%22 stroke-width%3D%221.333%22 cx%3D%228%22 cy%3D%228%22 r%3D%227.333%22%2F%3E%3Crect fill%3D%22%23DC2A2A%22 x%3D%227%22 y%3D%223%22 width%3D%222%22 height%3D%227%22 rx%3D%221%22%2F%3E%3Ccircle fill%3D%22%23DC2A2A%22 cx%3D%228%22 cy%3D%2212%22 r%3D%221%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\n}\n.onfido-sdk-ui-Error-title-icon-warning {\n  background-image: url(\"data:image/svg+xml,%3Csvg width%3D%2216%22 height%3D%2216%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E%3Ccircle fill%3D%22%23FFF%22 fill-rule%3D%22nonzero%22 cx%3D%228%22 cy%3D%228%22 r%3D%228%22%2F%3E%3Cpath d%3D%22M9.883 12.446s-.05.074-.186.144c-.635.33-1.295.494-1.989.367-.58-.106-.992-.525-1.066-1.147a2.677 2.677 0 0 1 .05-.874c.23-1.082.484-2.157.695-3.244a.781.781 0 0 0-.082-.533c-.097-.176-.254-.208-.42-.212A1.812 1.812 0 0 0 6 7.151c.045-.213.088-.409.13-.595.005-.02.032-.038.052-.049.533-.275 1.076-.503 1.669-.507.39-.002.77.052 1.093.346.263.239.404.554.424.941.02.366-.045.718-.127 1.068-.19.8-.377 1.601-.559 2.404-.059.262-.101.53-.067.804.039.314.2.484.48.497.275.013.543-.037.803-.14l.102-.044-.117.57zM9.003 5A.997.997 0 0 1 8 3.986c.001-.532.456-.981.999-.986A1 1 0 0 1 10 4.005.992.992 0 0 1 9.003 5%22 fill%3D%22%232A7AB0%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\n}\n.onfido-sdk-ui-Error-roundedTriangle {\n  position: absolute;\n  bottom: -6px;\n  left: calc(50% - 8px);\n  width: 8px;\n  height: 8px;\n  border-top: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-bottom: 8px solid transparent;\n  border-left: 8px solid transparent;\n  border-bottom-left-radius: 3px;\n  -webkit-transform: rotate(-45deg);\n          transform: rotate(-45deg);\n}\n.onfido-sdk-ui-Error-warningTriangle {\n  border-bottom: 8px solid #2A7AB0;\n  border-left: 8px solid #2A7AB0;\n}\n.onfido-sdk-ui-Error-errorTriangle {\n  border-bottom: 8px solid #DC2A2A;\n  border-left: 8px solid #DC2A2A;\n}\n.onfido-sdk-ui-Error-dismiss {\n  background: url(\"data:image/svg+xml,%3Csvg width%3D%2224%22 height%3D%2224%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath d%3D%22M10.556 12L7.294 8.737a1 1 0 0 1 0-1.414l.029-.03a1 1 0 0 1 1.414 0L12 10.557l3.263-3.262a1 1 0 0 1 1.414 0l.03.029a1 1 0 0 1 0 1.414L13.443 12l3.262 3.263a1 1 0 0 1 0 1.414l-.029.03a1 1 0 0 1-1.414 0L12 13.443l-3.263 3.262a1 1 0 0 1-1.414 0l-.03-.029a1 1 0 0 1 0-1.414L10.557 12z%22 fill%3D%22%23FFF%22 fill-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  width: 24px;\n  height: 24px;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  cursor: pointer;\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Theme/constants.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Error/style.css"],"names":[],"mappings":"AAMA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;CCFD;ACRD;;;EACE,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,4BAAA;EACA,mBAAA;CDYD;ACXC;EA8FD;;;IA7FG,eAAA;GDgBD;CACF;ACbD;EAEE,0BAAA;CDcD;ACXD;EAEE,0BAAA;CDYD;ACTD;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;CDWD;ACND;EACE,mBAAA;CDQD;ACLD;EACE,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;CDOD;ACHD;;;EACE,mBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,4BAAA;EACA,6BAAA;EACA,yBAAA;CDOD;ACJD;EAEE,+jBAAA;CDKD;ACFD;EAEE,u8BAAA;CDGD;ACAD;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,oCAAA;EACA,qCAAA;EACA,mCAAA;EACA,+BAAA;EACA,kCAAA;UAAA,0BAAA;CDED;ACED;EACE,iCAAA;EACA,+BAAA;CDAD;ACGD;EACE,iCAAA;EACA,+BAAA;CDDD;ACID;EACE,gfAAA;EACA,4BAAA;EACA,6BAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;CDFD","file":"style.css","sourcesContent":["@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n@large-text-margin: 40px;\n@small-text-margin: 24px;\n\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.width-parent-relative(@base-width,@parent-width) {\n  width: 100%*(@base-width/@parent-width)\n}\n","@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.container,\n.container-error,\n.container-warning {\n  border-radius: 6px;\n  text-align: left;\n  color: #FFFFFF;\n  margin: 0 40px 16px;\n  padding: 8px 16px 12px 16px;\n  position: relative;\n}\n@media (--small-viewport) {\n  .container,\n  .container-error,\n  .container-warning {\n    margin: 0 16px;\n  }\n}\n.container-error {\n  background-color: #DC2A2A;\n}\n.container-warning {\n  background-color: #2A7AB0;\n}\n.instruction {\n  margin-top: 0px;\n  margin-bottom: 0px;\n  margin-left: 24px;\n  font-size: 14px;\n  line-height: 20px;\n}\n.title {\n  position: relative;\n}\n.title-text {\n  display: inline-block;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  padding-left: 24px;\n}\n.title-icon,\n.title-icon-error,\n.title-icon-warning {\n  position: absolute;\n  height: 100%;\n  width: 16px;\n  margin-right: 8px;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n.title-icon-error {\n  background-image: url('assets/error.svg');\n}\n.title-icon-warning {\n  background-image: url('assets/warning.svg');\n}\n.roundedTriangle {\n  position: absolute;\n  bottom: -6px;\n  left: calc(50% - 8px);\n  width: 8px;\n  height: 8px;\n  border-top: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-bottom: 8px solid transparent;\n  border-left: 8px solid transparent;\n  border-bottom-left-radius: 3px;\n  transform: rotate(-45deg);\n}\n.warningTriangle {\n  border-bottom: 8px solid #2A7AB0;\n  border-left: 8px solid #2A7AB0;\n}\n.errorTriangle {\n  border-bottom: 8px solid #DC2A2A;\n  border-left: 8px solid #DC2A2A;\n}\n.dismiss {\n  background: url('assets/cross.svg');\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  width: 24px;\n  height: 24px;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  cursor: pointer;\n}\n","@import (less) \"../Theme/constants.css\";\n\n.container {\n  border-radius: 6px;\n  text-align: left;\n  color: #FFFFFF;\n  margin: 0 40px 16px;\n  padding: 8px 16px 12px 16px;\n  position: relative;\n  @media (--small-viewport) {\n    margin: 0 16px;\n  }\n}\n\n.container-error {\n  &:extend(.container);\n  background-color: #DC2A2A;\n}\n\n.container-warning {\n  &:extend(.container);\n  background-color: #2A7AB0;\n}\n\n.instruction {\n  margin-top: 0px;\n  margin-bottom: 0px;\n  margin-left: 24px;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n@title-height: 24px;\n\n.title {\n  position: relative;\n}\n\n.title-text {\n  display: inline-block;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: @title-height;\n  padding-left: 24px;\n}\n\n\n.title-icon {\n  position: absolute;\n  height: 100%;\n  width: 16px;\n  margin-right: 8px;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n.title-icon-error {\n  &:extend(.title-icon);\n  background-image: url('assets/error.svg');\n}\n\n.title-icon-warning {\n  &:extend(.title-icon);\n  background-image: url('assets/warning.svg');\n}\n\n.roundedTriangle {\n  position: absolute;\n  bottom: -6px;\n  left: ~\"calc(50% - 8px)\";\n  width: 8px;\n  height: 8px;\n  border-top: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-bottom: 8px solid transparent;\n  border-left: 8px solid transparent;\n  border-bottom-left-radius: 3px;\n  transform: rotate(-45deg);\n}\n\n\n.warningTriangle {\n  border-bottom: 8px solid #2A7AB0;\n  border-left: 8px solid #2A7AB0;\n}\n\n.errorTriangle {\n  border-bottom: 8px solid #DC2A2A;\n  border-left: 8px solid #DC2A2A;\n}\n\n.dismiss {\n  background: url('assets/cross.svg');\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  width: 24px;\n  height: 24px;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  cursor: pointer;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"absolute-center": "onfido-sdk-ui-Error-absolute-center",
	"container": "onfido-sdk-ui-Error-container",
	"container-error": "onfido-sdk-ui-Error-container-error",
	"container-warning": "onfido-sdk-ui-Error-container-warning",
	"instruction": "onfido-sdk-ui-Error-instruction",
	"title": "onfido-sdk-ui-Error-title",
	"title-text": "onfido-sdk-ui-Error-title-text",
	"title-icon": "onfido-sdk-ui-Error-title-icon",
	"title-icon-error": "onfido-sdk-ui-Error-title-icon-error",
	"title-icon-warning": "onfido-sdk-ui-Error-title-icon-warning",
	"roundedTriangle": "onfido-sdk-ui-Error-roundedTriangle",
	"warningTriangle": "onfido-sdk-ui-Error-warningTriangle",
	"errorTriangle": "onfido-sdk-ui-Error-errorTriangle",
	"dismiss": "onfido-sdk-ui-Error-dismiss"
};

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-NavigationBar-absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.onfido-sdk-ui-NavigationBar-navigation {\n  height: 32px;\n  padding: 16px 16px 0;\n  text-align: left;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-NavigationBar-navigation {\n    padding-left: 12px;\n  }\n}\n.onfido-sdk-ui-NavigationBar-fullScreenNav {\n  background: -webkit-gradient(linear, left bottom, left top, from(rgba(28, 31, 33, 0)), to(rgba(28, 31, 33, 0.35)));\n  background: linear-gradient(0deg, rgba(28, 31, 33, 0) 0%, rgba(28, 31, 33, 0.35) 100%);\n  z-index: 3;\n}\n.onfido-sdk-ui-NavigationBar-fullScreenNav .onfido-sdk-ui-NavigationBar-back {\n  color: white;\n}\n.onfido-sdk-ui-NavigationBar-fullScreenNav .onfido-sdk-ui-NavigationBar-iconBack {\n  background-image: url(\"data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22 standalone%3D%22no%22%3F%3E%3Csvg width%3D%228px%22 height%3D%2212px%22 viewBox%3D%220 0 8 12%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 47.1 (45422) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3Echevron-right-black%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Symbols%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22icons%2Fchevron%2Fright-black%22 transform%3D%22translate(-12.000000%2C -10.000000)%22 fill%3D%22white%22%3E            %3Cpath d%3D%22M20.188823%2C12.3318342 L16.0002498%2C17.262704 L11.811177%2C12.3318342 C11.3970653%2C11.8893886 10.7246956%2C11.8893886 10.3105838%2C12.3318342 C9.89647206%2C12.7742798 9.89647206%2C13.4939203 10.3105838%2C13.9363659 L15.1835155%2C19.6721669 C15.4078052%2C19.912047 15.7070247%2C20.0186604 16.0002498%2C19.9973377 C16.2934749%2C20.0186604 16.5921948%2C19.912047 16.8164845%2C19.6721669 L21.6894162%2C13.9363659 C22.1035279%2C13.4939203 22.1035279%2C12.7742798 21.6894162%2C12.3318342 C21.2753044%2C11.8893886 20.6029347%2C11.8893886 20.188823%2C12.3318342 Z%22 id%3D%22chevron-right-black%22 transform%3D%22translate(16.000000%2C 16.000000) rotate(-90.000000) translate(-16.000000%2C -16.000000) %22%3E%3C%2Fpath%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E\");\n}\n.onfido-sdk-ui-NavigationBar-disabled {\n  display: none;\n}\n.onfido-sdk-ui-NavigationBar-back {\n  width: 72px;\n  height: 32px;\n  color: #2C3E4F;\n  font-size: 14px;\n  line-height: 17px;\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-NavigationBar-back {\n    width: auto;\n  }\n}\n.onfido-sdk-ui-NavigationBar-iconBack {\n  height: 12px;\n  width: 8px;\n  background-image: url(\"data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22 standalone%3D%22no%22%3F%3E%3Csvg width%3D%228px%22 height%3D%2212px%22 viewBox%3D%220 0 8 12%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 47.1 (45422) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3Echevron-right-black%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Symbols%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22icons%2Fchevron%2Fright-black%22 transform%3D%22translate(-12.000000%2C -10.000000)%22 fill%3D%22%232C3E4F%22%3E            %3Cpath d%3D%22M20.188823%2C12.3318342 L16.0002498%2C17.262704 L11.811177%2C12.3318342 C11.3970653%2C11.8893886 10.7246956%2C11.8893886 10.3105838%2C12.3318342 C9.89647206%2C12.7742798 9.89647206%2C13.4939203 10.3105838%2C13.9363659 L15.1835155%2C19.6721669 C15.4078052%2C19.912047 15.7070247%2C20.0186604 16.0002498%2C19.9973377 C16.2934749%2C20.0186604 16.5921948%2C19.912047 16.8164845%2C19.6721669 L21.6894162%2C13.9363659 C22.1035279%2C13.4939203 22.1035279%2C12.7742798 21.6894162%2C12.3318342 C21.2753044%2C11.8893886 20.6029347%2C11.8893886 20.188823%2C12.3318342 Z%22 id%3D%22chevron-right-black%22 transform%3D%22translate(16.000000%2C 16.000000) rotate(-90.000000) translate(-16.000000%2C -16.000000) %22%3E%3C%2Fpath%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n  float: left;\n  margin-top: 3px;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-NavigationBar-label {\n    display: none;\n  }\n}\n.onfido-sdk-ui-NavigationBar-back:hover .onfido-sdk-ui-NavigationBar-iconBack {\n  background-image: url(\"data:image/svg+xml,%3Csvg width%3D%228%22 height%3D%2212%22 viewBox%3D%220 0 8 12%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E  %3Ctitle%3E    chevron-right-green  %3C%2Ftitle%3E  %3Cpath d%3D%22M.3318 1.8112l4.931 4.1886-4.931 4.189c-.4424.414-.4424 1.0865 0 1.5006.4425.414 1.162.414 1.6046 0l5.7358-4.873c.2398-.2242.3465-.5234.325-.8166.0215-.2933-.0852-.592-.325-.8163L1.9364.3105c-.4425-.414-1.162-.414-1.6046 0-.4424.4142-.4424 1.0866 0 1.5007z%22 fill%3D%22%2300C8A0%22 fill-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E\");\n}\n.onfido-sdk-ui-NavigationBar-back:focus {\n  outline: none;\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Theme/constants.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/NavigationBar/style.css"],"names":[],"mappings":"AAMA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;CCFD;ACRD;EACE,aAAA;EACA,qBAAA;EACA,iBAAA;EACA,gCAAA;UAAA,wBAAA;CDUD;ACTC;EA2DF;IA1DI,mBAAA;GDYD;CACF;ACTD;EACE,mHAAA;EAAA,uFAAA;EACA,WAAA;CDWD;ACbD;EAII,aAAA;CDYH;AChBD;EAOI,4iDAAA;CDYH;ACRD;EACE,cAAA;CDUD;ACPD;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;CDSD;ACPC;EA6BF;IA5BI,YAAA;GDUD;CACF;ACPD;EACE,aAAA;EACA,WAAA;EACA,gjDAAA;EACA,6BAAA;EACA,4BAAA;EACA,gCAAA;UAAA,wBAAA;EACA,YAAA;EACA,gBAAA;CDSD;ACLC;EAYF;IAXI,cAAA;GDQD;CACF;ACLD;EACE,+iBAAA;CDOD;ACJD;EACE,cAAA;CDMD","file":"style.css","sourcesContent":["@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n@large-text-margin: 40px;\n@small-text-margin: 24px;\n\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.width-parent-relative(@base-width,@parent-width) {\n  width: 100%*(@base-width/@parent-width)\n}\n","@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.navigation {\n  height: 32px;\n  padding: 16px 16px 0;\n  text-align: left;\n  box-sizing: content-box;\n}\n@media (--small-viewport) {\n  .navigation {\n    padding-left: 12px;\n  }\n}\n.fullScreenNav {\n  background: linear-gradient(0deg, rgba(28, 31, 33, 0) 0%, rgba(28, 31, 33, 0.35) 100%);\n  z-index: 3;\n}\n.fullScreenNav .back {\n  color: white;\n}\n.fullScreenNav .iconBack {\n  background-image: url('assets/chevron-right-white.svg');\n}\n.disabled {\n  display: none;\n}\n.back {\n  width: 72px;\n  height: 32px;\n  color: #2C3E4F;\n  font-size: 14px;\n  line-height: 17px;\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n}\n@media (--small-viewport) {\n  .back {\n    width: auto;\n  }\n}\n.iconBack {\n  height: 12px;\n  width: 8px;\n  background-image: url('assets/chevron-right-black.svg');\n  background-repeat: no-repeat;\n  background-position: center;\n  transform: scale(-1, 1);\n  float: left;\n  margin-top: 3px;\n}\n@media (--small-viewport) {\n  .label {\n    display: none;\n  }\n}\n.back:hover .iconBack {\n  background-image: url('assets/chevron-right-green.svg');\n}\n.back:focus {\n  outline: none;\n}\n","@import (less) \"../Theme/constants.css\";\n\n.navigation {\n  height: 32px;\n  padding: 16px 16px 0;\n  text-align: left;\n  box-sizing: content-box;\n  @media (--small-viewport) {\n    padding-left: 12px;\n  }\n}\n\n.fullScreenNav {\n  background: linear-gradient(0deg, rgba(28,31,33,0) 0%, rgba(28,31,33,0.35) 100%);\n  z-index: 3;\n  .back {\n    color: white;\n  }\n  .iconBack {\n    background-image: url('assets/chevron-right-white.svg');\n  }\n}\n\n.disabled {\n  display: none;\n}\n\n.back {\n  width: 72px;\n  height: 32px;\n  color: #2C3E4F;\n  font-size: 14px;\n  line-height: 17px;\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n\n  @media (--small-viewport) {\n    width: auto;\n  }\n}\n\n.iconBack {\n  height: 12px;\n  width: 8px;\n  background-image: url('assets/chevron-right-black.svg');\n  background-repeat: no-repeat;\n  background-position: center;\n  transform: scale(-1, 1);\n  float: left;\n  margin-top: 3px;\n}\n\n.label {\n  @media (--small-viewport) {\n    display: none;\n  }\n}\n\n.back:hover .iconBack {\n  background-image: url('assets/chevron-right-green.svg');\n}\n\n.back:focus {\n  outline: none;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"absolute-center": "onfido-sdk-ui-NavigationBar-absolute-center",
	"navigation": "onfido-sdk-ui-NavigationBar-navigation",
	"fullScreenNav": "onfido-sdk-ui-NavigationBar-fullScreenNav",
	"back": "onfido-sdk-ui-NavigationBar-back",
	"iconBack": "onfido-sdk-ui-NavigationBar-iconBack",
	"disabled": "onfido-sdk-ui-NavigationBar-disabled",
	"label": "onfido-sdk-ui-NavigationBar-label"
};

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-Overlay-absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.onfido-sdk-ui-Overlay-overlay,\n.onfido-sdk-ui-Overlay-rectangle {\n  border: 1px solid #00c8a0;\n  position: absolute;\n  bottom: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, 50%);\n          transform: translate(-50%, 50%);\n  /* 300px box-shadow, so 600px by 600px, so as to definitely cover the modal */\n  -webkit-box-shadow: 0 0 0 300px rgba(0, 0, 0, 0.7);\n          box-shadow: 0 0 0 300px rgba(0, 0, 0, 0.7);\n}\n.onfido-sdk-ui-Overlay-rectangle {\n  /*\n    From the equation below one can find out @height-percent\n    aspect-ratio = (width-frame * width-percent) / (height-frame * height-percent)\n   */\n  width: 80%;\n  height: 67.94055202%;\n}\n.onfido-sdk-ui-Overlay-face {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 width%3D%22740%22 height%3D%221800%22%3E%0D  %3Cpath fill-opacity%3D%22.66%22 d%3D%22M0 1800V0h740v1800H0zm237-914.056c0 71.601 59.104 175.672 132.021 175.672s132.022-101.453 132.022-175.672c0-83.917-59.107-151.944-132.022-151.944C296.108 734 237 802.027 237 885.944z%22%2F%3E%0D  %3Cpath fill%3D%22none%22 stroke%3D%22%23FFF%22 stroke-width%3D%223%22 d%3D%22M237 885.944c0 71.601 59.104 175.672 132.021 175.672s132.022-101.453 132.022-175.672c0-83.917-59.107-151.944-132.022-151.944C296.108 734 237 802.027 237 885.944z%22%2F%3E%0D%3C%2Fsvg%3E%0D\");\n  background-size: 555px 1350px;\n  background-position: 50% calc((328px - 1800px) * 0.75 / 2 + 30px);\n  background-repeat: no-repeat;\n  height: 100%;\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  background-size: 740px 1800px;\n  background-position: 50% calc((328px - 1800px) * 1 / 2 + 105px);\n}\n@media (max-width: 359px) {\n  .onfido-sdk-ui-Overlay-face {\n    background-size: 629px 1530px;\n    background-position: 50% calc((328px - 1800px) * 0.85 / 2 + 105px);\n  }\n}\n.onfido-sdk-ui-Overlay-isWithoutHole .onfido-sdk-ui-Overlay-face {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 width%3D%22740%22 height%3D%221800%22%3E%0D  %3Cpath fill-opacity%3D%22.66%22 d%3D%22M0 1800V0h740v1800H0z%22%2F%3E%0D  %3Cpath opacity%3D%22.2%22 fill%3D%22none%22 stroke%3D%22%23FFF%22 stroke-width%3D%223%22 d%3D%22M237 885.944c0 71.601 59.104 175.672 132.021 175.672s132.022-101.453 132.022-175.672c0-83.917-59.107-151.944-132.022-151.944C296.108 734 237 802.027 237 885.944z%22%2F%3E%0D%3C%2Fsvg%3E%0D\");\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Theme/constants.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Overlay/style.css"],"names":[],"mappings":"AAMA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;CCFD;ACRD;;EACE,0BAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,wCAAA;UAAA,gCAAA;EDWA,8EAA8E;ECT9E,mDAAA;UAAA,2CAAA;CDWD;ACRD;EDUE;;;KAGG;ECIH,WAAA;EACA,qBAAA;CDFD;ACeD;EACE,0oBAAA;EALA,8BAAA;EACA,kEAAA;EAMA,6BAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EAbA,8BAAA;EACA,gEAAA;CDED;ACcC;EAQF;IAzBE,8BAAA;IACA,mEAAA;GDOC;CACF;ACYC;EACE,4fAAA;CDVH","file":"style.css","sourcesContent":["@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n@large-text-margin: 40px;\n@small-text-margin: 24px;\n\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.width-parent-relative(@base-width,@parent-width) {\n  width: 100%*(@base-width/@parent-width)\n}\n","@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.overlay,\n.rectangle {\n  border: 1px solid #00c8a0;\n  position: absolute;\n  bottom: 50%;\n  left: 50%;\n  transform: translate(-50%, 50%);\n  /* 300px box-shadow, so 600px by 600px, so as to definitely cover the modal */\n  box-shadow: 0 0 0 300px rgba(0, 0, 0, 0.7);\n}\n.rectangle {\n  /*\n    From the equation below one can find out @height-percent\n    aspect-ratio = (width-frame * width-percent) / (height-frame * height-percent)\n   */\n  width: 80%;\n  height: 67.94055202%;\n}\n.face {\n  background-image: url('assets/face-with-hole.svg');\n  background-size: 555px 1350px;\n  background-position: 50% calc((328px - 1800px) * 0.75 / 2 + 30px);\n  background-repeat: no-repeat;\n  height: 100%;\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  background-size: 740px 1800px;\n  background-position: 50% calc((328px - 1800px) * 1 / 2 + 105px);\n}\n@media (--smaller-viewport) {\n  .face {\n    background-size: 629px 1530px;\n    background-position: 50% calc((328px - 1800px) * 0.85 / 2 + 105px);\n  }\n}\n.isWithoutHole .face {\n  background-image: url('assets/face-without-hole.svg');\n}\n","@import (less) \"../Theme/constants.css\";\n\n.overlay {\n  border: 1px solid #00c8a0;\n  position: absolute;\n  bottom: 50%;\n  left: 50%;\n  transform: translate(-50%, 50%);\n  /* 300px box-shadow, so 600px by 600px, so as to definitely cover the modal */\n  box-shadow: 0 0 0 300px rgba(0, 0, 0, 0.7);\n}\n\n.rectangle {\n  &:extend(.overlay);\n\n  //default value of react-webcam https://github.com/cezary/react-webcam\n  @width-frame: 640;\n  @height-frame: 480;\n\n  //Spec of overlay\n  @width-percent: 80%;\n  @aspect-ratio: 1.57;\n\n  /*\n    From the equation below one can find out @height-percent\n    aspect-ratio = (width-frame * width-percent) / (height-frame * height-percent)\n   */\n  @height-percent: (@width-frame * @width-percent) / (@height-frame * @aspect-ratio);\n\n  width: @width-percent;\n  height: @height-percent;\n}\n\n\n.positionHole(@scale: 1, @offset-y: 105px) {\n  @overlay-width: 740px;\n  @overlay-height: 1800px;\n  @hole-width: 264px;\n  @hole-height: 328px;\n  background-size: (@overlay-width * @scale) (@overlay-height * @scale);\n  background-position: 50% ~\"calc((@{hole-height} - @{overlay-height}) * @{scale} / 2 + @{offset-y})\";\n}\n\n.face {\n  background-image: url('assets/face-with-hole.svg');\n  .positionHole(.75, 30px);\n  background-repeat: no-repeat;\n  height: 100%;\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n\n  .positionHole(1);\n\n  @media (--smaller-viewport) {\n    .positionHole(.85);\n  }\n\n  .isWithoutHole & {\n    background-image: url('assets/face-without-hole.svg');\n  }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"absolute-center": "onfido-sdk-ui-Overlay-absolute-center",
	"overlay": "onfido-sdk-ui-Overlay-overlay",
	"rectangle": "onfido-sdk-ui-Overlay-rectangle",
	"face": "onfido-sdk-ui-Overlay-face",
	"isWithoutHole": "onfido-sdk-ui-Overlay-isWithoutHole"
};

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-Pannable-container {\n  overflow: auto;\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Pannable/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css"],"names":[],"mappings":"AAAA;EACE,eAAA;CCCD","file":"style.css","sourcesContent":[".container {\n  overflow: auto;\n}",".container {\n  overflow: auto;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "onfido-sdk-ui-Pannable-container"
};

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-PhoneNumberInput-loading {\n  color: #5D6B78;\n  font-size: 20px;\n  line-height: 32px;\n  margin: 8px;\n  float: left;\n}\n.onfido-sdk-ui-PhoneNumberInput-mobileInput {\n  font-size: 16px;\n}\n.onfido-sdk-ui-PhoneNumberInput-phoneNumberContainer {\n  float: left;\n  width: 100%;\n  padding: 8px 12px;\n}\n.onfido-sdk-ui-PhoneNumberInput-phoneNumberContainer .react-phone-number-input__icon {\n  height: 1.8em;\n  width: 1.8em;\n  border: none;\n  display: block;\n}\n.onfido-sdk-ui-PhoneNumberInput-phoneNumberContainer .rrui__select__arrow {\n  color: #2C3E4F;\n}\n.onfido-sdk-ui-PhoneNumberInput-phoneNumberContainer .rrui__select__options:not(.rrui__select__options--menu) {\n  width: 438px;\n}\n.onfido-sdk-ui-PhoneNumberInput-phoneNumberContainer button {\n  border-bottom: none;\n}\n.onfido-sdk-ui-PhoneNumberInput-phoneNumberContainer input {\n  width: 100%;\n  border-bottom: none;\n  overflow: hidden;\n}\n.onfido-sdk-ui-PhoneNumberInput-flagIcon {\n  background-size: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/PhoneNumberInput/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;CCCD;ADED;EACE,gBAAA;CCAD;ADGD;EACE,YAAA;EACA,YAAA;EACA,kBAAA;CCDD;ADID;EACE,cAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;CCFD;ADKD;EACE,eAAA;CCHD;ADMD;EACE,aAAA;CCJD;ADOD;EACE,oBAAA;CCLD;ADQD;EACE,YAAA;EACA,oBAAA;EACA,iBAAA;CCND;ADUD;EACE,sBAAA;EACA,6BAAA;EACA,4BAAA;CCRD","file":"style.css","sourcesContent":[".loading {\n  color: #5D6B78;\n  font-size: 20px;\n  line-height: 32px;\n  margin: 8px;\n  float: left;\n}\n\n.mobileInput {\n  font-size: 16px;\n}\n\n.phoneNumberContainer {\n  float: left;\n  width: 100%;\n  padding: 8px 12px;\n}\n\n.phoneNumberContainer :global .react-phone-number-input__icon {\n  height: 1.8em;\n  width: 1.8em;\n  border: none;\n  display: block;\n}\n\n.phoneNumberContainer :global .rrui__select__arrow {\n  color: #2C3E4F;\n}\n\n.phoneNumberContainer :global .rrui__select__options:not(.rrui__select__options--menu) {\n  width: 438px;\n}\n\n.phoneNumberContainer button {\n  border-bottom: none;\n}\n\n.phoneNumberContainer input {\n  width: 100%;\n  border-bottom: none;\n  overflow: hidden;\n}\n\n\n.flagIcon {\n  background-size: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n}",".loading {\n  color: #5D6B78;\n  font-size: 20px;\n  line-height: 32px;\n  margin: 8px;\n  float: left;\n}\n.mobileInput {\n  font-size: 16px;\n}\n.phoneNumberContainer {\n  float: left;\n  width: 100%;\n  padding: 8px 12px;\n}\n.phoneNumberContainer :global .react-phone-number-input__icon {\n  height: 1.8em;\n  width: 1.8em;\n  border: none;\n  display: block;\n}\n.phoneNumberContainer :global .rrui__select__arrow {\n  color: #2C3E4F;\n}\n.phoneNumberContainer :global .rrui__select__options:not(.rrui__select__options--menu) {\n  width: 438px;\n}\n.phoneNumberContainer button {\n  border-bottom: none;\n}\n.phoneNumberContainer input {\n  width: 100%;\n  border-bottom: none;\n  overflow: hidden;\n}\n.flagIcon {\n  background-size: 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"loading": "onfido-sdk-ui-PhoneNumberInput-loading",
	"mobileInput": "onfido-sdk-ui-PhoneNumberInput-mobileInput",
	"phoneNumberContainer": "onfido-sdk-ui-PhoneNumberInput-phoneNumberContainer",
	"flagIcon": "onfido-sdk-ui-PhoneNumberInput-flagIcon"
};

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-PrivacyStatement-absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.onfido-sdk-ui-PrivacyStatement-privacy {\n  width: 100%;\n}\n.onfido-sdk-ui-PrivacyStatement-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  color: #0F2536;\n}\n.onfido-sdk-ui-PrivacyStatement-actions {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  margin-bottom: 24px;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-PrivacyStatement-actions {\n    margin-bottom: 0;\n  }\n}\n.onfido-sdk-ui-PrivacyStatement-list {\n  font-size: 16px;\n  line-height: 24px;\n  text-align: left;\n  padding-left: 64px;\n  position: relative;\n  margin-bottom: 0;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-PrivacyStatement-list {\n    padding-left: 32px;\n  }\n}\n.onfido-sdk-ui-PrivacyStatement-item {\n  list-style: none;\n  margin-bottom: 16px;\n}\n.onfido-sdk-ui-PrivacyStatement-item:before {\n  content: '';\n  display: inline-block;\n  height: 16px;\n  width: 32px;\n  background-image: url(\"data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2220px%22 height%3D%2220px%22 viewBox%3D%220 0 20 20%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 48.2 (47327) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3Eicons%2Ftick-grey%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Symbols%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22icons%2Ftick-grey%22%3E            %3Cpolygon id%3D%22Shape%22 points%3D%220 0 20 0 20 20 0 20%22%3E%3C%2Fpolygon%3E            %3Cpath d%3D%22M14.1670887%2C5.51711209 L8.29950298%2C11.743607 L6.83291133%2C10.1869833 C6.18475016%2C9.50173044 5.13387568%2C9.50173044 4.48612088%2C10.1869833 C3.83795971%2C10.8764661 3.83795971%2C11.9931744 4.48612088%2C12.6784272 L7.12631094%2C15.4828879 C7.77447211%2C16.1723707 8.82494022%2C16.1723707 9.47310139%2C15.4828879 L16.5138791%2C8.00855605 C17.1620403%2C7.31907326 17.1620403%2C6.20236493 16.5138791%2C5.51711209 C15.8657179%2C4.8276293 14.8152498%2C4.8276293 14.1670887%2C5.51711209 Z%22 id%3D%22checkmark%22 fill%3D%22%238B9094%22%3E%3C%2Fpath%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E\");\n  background-repeat: no-repeat;\n  position: relative;\n  margin-left: -32px;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-PrivacyStatement-item:before {\n    margin-left: -32px;\n  }\n}\n.onfido-sdk-ui-PrivacyStatement-smallPrint {\n  text-align: left;\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 18px;\n  margin-bottom: 24px;\n}\n.onfido-sdk-ui-PrivacyStatement-smallPrint a {\n  color: #0F2536;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.onfido-sdk-ui-PrivacyStatement-decline {\n  width: 136px;\n  border: 1px solid #8A9293;\n  border-radius: 28px;\n  background-color: transparent;\n  color: #585E5F;\n  line-height: 16px;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-PrivacyStatement-decline {\n    width: 112px;\n    padding: 0px 16px;\n  }\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-PrivacyStatement-primary {\n    width: 152px;\n  }\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Theme/constants.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/PrivacyStatement/style.css"],"names":[],"mappings":"AAMA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;CCFD;ACRD;EACE,YAAA;CDUD;ACPD;EACE,qBAAA;EAAA,qBAAA;EAAA,cAAA;EACA,0BAAA;MAAA,8BAAA;EACA,6BAAA;EAAA,8BAAA;MAAA,2BAAA;UAAA,uBAAA;EACA,eAAA;CDSD;ACND;EACE,qBAAA;EAAA,qBAAA;EAAA,cAAA;EACA,0BAAA;MAAA,uBAAA;UAAA,+BAAA;EACA,+BAAA;EAAA,8BAAA;MAAA,wBAAA;UAAA,oBAAA;EACA,oBAAA;CDQD;ACPC;EAoEF;IAnEI,iBAAA;GDUD;CACF;ACPD;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;CDSD;ACRC;EAwDF;IAvDI,mBAAA;GDWD;CACF;ACRD;EACG,iBAAA;EACA,oBAAA;CDUF;ACPD;EACG,YAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,y3CAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;CDSF;ACRE;EAqCH;IApCK,mBAAA;GDWF;CACF;ACRD;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;CDUD;ACPD;EACE,eAAA;EACA,iBAAA;EACA,oBAAA;CDSD;ACND;EACE,aAAA;EACA,0BAAA;EACA,oBAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;CDQD;ACPC;EAWF;IAVI,aAAA;IACA,kBAAA;GDUD;CACF;ACNC;EAIF;IAHI,aAAA;GDSD;CACF","file":"style.css","sourcesContent":["@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n@large-text-margin: 40px;\n@small-text-margin: 24px;\n\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.width-parent-relative(@base-width,@parent-width) {\n  width: 100%*(@base-width/@parent-width)\n}\n","@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.privacy {\n  width: 100%;\n}\n.content {\n  display: flex;\n  justify-content: space-around;\n  flex-direction: column;\n  color: #0F2536;\n}\n.actions {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n  margin-bottom: 24px;\n}\n@media (--small-viewport) {\n  .actions {\n    margin-bottom: 0;\n  }\n}\n.list {\n  font-size: 16px;\n  line-height: 24px;\n  text-align: left;\n  padding-left: 64px;\n  position: relative;\n  margin-bottom: 0;\n}\n@media (--small-viewport) {\n  .list {\n    padding-left: 32px;\n  }\n}\n.item {\n  list-style: none;\n  margin-bottom: 16px;\n}\n.item:before {\n  content: '';\n  display: inline-block;\n  height: 16px;\n  width: 32px;\n  background-image: url('assets/tick-grey.svg');\n  background-repeat: no-repeat;\n  position: relative;\n  margin-left: -32px;\n}\n@media (--small-viewport) {\n  .item:before {\n    margin-left: -32px;\n  }\n}\n.smallPrint {\n  text-align: left;\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 18px;\n  margin-bottom: 24px;\n}\n.smallPrint a {\n  color: #0F2536;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.decline {\n  width: 136px;\n  border: 1px solid #8A9293;\n  border-radius: 28px;\n  background-color: transparent;\n  color: #585E5F;\n  line-height: 16px;\n}\n@media (--small-viewport) {\n  .decline {\n    width: 112px;\n    padding: 0px 16px;\n  }\n}\n@media (--small-viewport) {\n  .primary {\n    width: 152px;\n  }\n}\n","@import (less) \"../Theme/constants.css\";\n\n.privacy {\n  width: 100%;\n}\n\n.content {\n  display: flex;\n  justify-content: space-around;\n  flex-direction: column;\n  color: #0F2536;\n}\n\n.actions {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n  margin-bottom: 24px;\n  @media (--small-viewport) {\n    margin-bottom: 0;\n  }\n}\n\n.list {\n  font-size: 16px;\n  line-height: 24px;\n  text-align: left;\n  padding-left: 64px;\n  position: relative;\n  margin-bottom: 0;\n  @media (--small-viewport) {\n    padding-left: 32px;\n  }\n}\n\n.item {\n   list-style: none;\n   margin-bottom: 16px;\n}\n\n.item:before{\n   content: '';\n   display: inline-block;\n   height: 16px;\n   width: 32px;\n   background-image: url('assets/tick-grey.svg');\n   background-repeat: no-repeat;\n   position: relative;\n   margin-left: -32px;\n   @media (--small-viewport) {\n     margin-left: -32px;\n   }\n}\n\n.smallPrint {\n  text-align: left;\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 18px;\n  margin-bottom: 24px;\n}\n\n.smallPrint a {\n  color: #0F2536;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.decline {\n  width: 136px;\n  border: 1px solid #8A9293;\n  border-radius: 28px;\n  background-color: transparent;\n  color: #585E5F;\n  line-height: 16px;\n  @media (--small-viewport) {\n    width: 112px;\n    padding: 0px 16px;\n  }\n}\n\n.primary {\n  @media (--small-viewport) {\n    width: 152px;\n  }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"absolute-center": "onfido-sdk-ui-PrivacyStatement-absolute-center",
	"privacy": "onfido-sdk-ui-PrivacyStatement-privacy",
	"content": "onfido-sdk-ui-PrivacyStatement-content",
	"actions": "onfido-sdk-ui-PrivacyStatement-actions",
	"list": "onfido-sdk-ui-PrivacyStatement-list",
	"item": "onfido-sdk-ui-PrivacyStatement-item",
	"smallPrint": "onfido-sdk-ui-PrivacyStatement-smallPrint",
	"decline": "onfido-sdk-ui-PrivacyStatement-decline",
	"primary": "onfido-sdk-ui-PrivacyStatement-primary"
};

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-ProofOfAddress-Guidance-absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.onfido-sdk-ui-ProofOfAddress-Guidance-content {\n  position: relative;\n  margin: 0 40px 1rem;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-ProofOfAddress-Guidance-content {\n    margin: 0 24px 1rem;\n  }\n}\n.onfido-sdk-ui-ProofOfAddress-Guidance-subTitle {\n  font-size: 14px;\n}\n.onfido-sdk-ui-ProofOfAddress-Guidance-subTitle::before {\n  content: '';\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  background-image: url(\"data:image/svg+xml,%3Csvg width%3D%2216%22 height%3D%2216%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E  %3Cg fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E    %3Ccircle fill%3D%22%232C3E4F%22 cx%3D%228%22 cy%3D%228%22 r%3D%228%22%2F%3E    %3Cg transform%3D%22translate(7 3)%22 fill%3D%22%23fff%22%3E      %3Crect y%3D%223%22 width%3D%222%22 height%3D%227%22 rx%3D%221%22%2F%3E      %3Ccircle cx%3D%221%22 cy%3D%221%22 r%3D%221%22%2F%3E    %3C%2Fg%3E  %3C%2Fg%3E%3C%2Fsvg%3E\");\n  vertical-align: middle;\n  line-height: 1em;\n  margin-right: 5px;\n  margin-top: -2px;\n}\n.onfido-sdk-ui-ProofOfAddress-Guidance-bolder {\n  font-weight: 600;\n}\n.onfido-sdk-ui-ProofOfAddress-Guidance-makeSure {\n  color: #2C3E4F;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-ProofOfAddress-Guidance-makeSure {\n    text-align: left;\n  }\n}\n.onfido-sdk-ui-ProofOfAddress-Guidance-docImageContainer {\n  position: relative;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  width: 340px;\n  margin: 0 auto;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-ProofOfAddress-Guidance-docImageContainer {\n    width: 100%;\n  }\n}\n.onfido-sdk-ui-ProofOfAddress-Guidance-docImage {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n.onfido-sdk-ui-ProofOfAddress-Guidance-label {\n  fill: #2C3E4F;\n  font-size: 14px;\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Theme/constants.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/ProofOfAddress/Guidance/style.css"],"names":[],"mappings":"AAMA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;CCFD;ACRD;EACE,mBAAA;EACA,oBAAA;EACA,oBAAA;MAAA,YAAA;UAAA,QAAA;EACA,6BAAA;EAAA,8BAAA;MAAA,2BAAA;UAAA,uBAAA;EACA,qBAAA;EAAA,qBAAA;EAAA,cAAA;CDUD;ACRC;EA2DF;IA1DI,oBAAA;GDWD;CACF;ACRD;EACE,gBAAA;CDUD;ACRC;EACE,YAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,+fAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;CDUH;ACND;EACE,iBAAA;CDQD;ACLD;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;CDOD;ACLC;EA6BF;IA5BI,iBAAA;GDQD;CACF;ACLD;EACE,mBAAA;EACA,oBAAA;MAAA,YAAA;UAAA,QAAA;EACA,aAAA;EACA,eAAA;CDOD;ACNC;EAmBF;IAlBI,YAAA;GDSD;CACF;ACND;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;CDQD;ACLD;EACE,cAAA;EACA,gBAAA;CDOD","file":"style.css","sourcesContent":["@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n@large-text-margin: 40px;\n@small-text-margin: 24px;\n\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.width-parent-relative(@base-width,@parent-width) {\n  width: 100%*(@base-width/@parent-width)\n}\n","@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.content {\n  position: relative;\n  margin: 0 40px 1rem;\n  flex: 1;\n  flex-direction: column;\n  display: flex;\n}\n@media (--small-viewport) {\n  .content {\n    margin: 0 24px 1rem;\n  }\n}\n.subTitle {\n  font-size: 14px;\n}\n.subTitle::before {\n  content: '';\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  background-image: url('assets/warningSmall.svg');\n  vertical-align: middle;\n  line-height: 1em;\n  margin-right: 5px;\n  margin-top: -2px;\n}\n.bolder {\n  font-weight: 600;\n}\n.makeSure {\n  color: #2C3E4F;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n@media (--small-viewport) {\n  .makeSure {\n    text-align: left;\n  }\n}\n.docImageContainer {\n  position: relative;\n  flex: 1;\n  width: 340px;\n  margin: 0 auto;\n}\n@media (--small-viewport) {\n  .docImageContainer {\n    width: 100%;\n  }\n}\n.docImage {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n.label {\n  fill: #2C3E4F;\n  font-size: 14px;\n}\n","@import (less) \"../../Theme/constants.css\";\n\n.content {\n  position: relative;\n  margin: 0 40px 1rem;\n  flex: 1;\n  flex-direction: column;\n  display: flex;\n\n  @media (--small-viewport) {\n    margin: 0 24px 1rem;\n  }\n}\n\n.subTitle {\n  font-size: 14px;\n\n  &::before {\n    content: '';\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    background-image: url('assets/warningSmall.svg');\n    vertical-align: middle;\n    line-height: 1em;\n    margin-right: 5px;\n    margin-top: -2px;\n  }\n}\n\n.bolder {\n  font-weight: 600;\n}\n\n.makeSure {\n  color: #2C3E4F;\n  font-weight: 600;\n  margin-bottom: 8px;\n\n  @media (--small-viewport) {\n    text-align: left;\n  }\n}\n\n.docImageContainer {\n  position: relative;\n  flex: 1;\n  width: 340px;\n  margin: 0 auto;\n  @media (--small-viewport) {\n    width: 100%;\n  }\n}\n\n.docImage {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.label {\n  fill: #2C3E4F;\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"absolute-center": "onfido-sdk-ui-ProofOfAddress-Guidance-absolute-center",
	"content": "onfido-sdk-ui-ProofOfAddress-Guidance-content",
	"subTitle": "onfido-sdk-ui-ProofOfAddress-Guidance-subTitle",
	"bolder": "onfido-sdk-ui-ProofOfAddress-Guidance-bolder",
	"makeSure": "onfido-sdk-ui-ProofOfAddress-Guidance-makeSure",
	"docImageContainer": "onfido-sdk-ui-ProofOfAddress-Guidance-docImageContainer",
	"docImage": "onfido-sdk-ui-ProofOfAddress-Guidance-docImage",
	"label": "onfido-sdk-ui-ProofOfAddress-Guidance-label"
};

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-ProofOfAddress-PoAIntro-absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.onfido-sdk-ui-ProofOfAddress-PoAIntro-content {\n  text-align: left;\n  margin: 0 80px auto;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-ProofOfAddress-PoAIntro-content {\n    margin-left: 24px;\n    margin-right: 24px;\n  }\n}\n.onfido-sdk-ui-ProofOfAddress-PoAIntro-requirements {\n  font-weight: 600;\n  color: #2C3E4F;\n  margin-bottom: 16px;\n}\n.onfido-sdk-ui-ProofOfAddress-PoAIntro-requirement {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-bottom: 16px;\n  padding-left: 16px;\n  position: relative;\n}\n.onfido-sdk-ui-ProofOfAddress-PoAIntro-requirement::before {\n  content: '';\n  background-color: #00C9A1;\n  border-radius: 50%;\n  display: inline-block;\n  height: 6px;\n  width: 6px;\n  position: absolute;\n  left: 0;\n  top: 6px;\n}\n.onfido-sdk-ui-ProofOfAddress-PoAIntro-bolder {\n  font-weight: 600;\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Theme/constants.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/ProofOfAddress/PoAIntro/style.css"],"names":[],"mappings":"AAMA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;CCFD;ACRD;EACE,iBAAA;EACA,oBAAA;CDUD;ACRC;EAiCF;IAhCI,kBAAA;IACA,mBAAA;GDWD;CACF;ACRD;EACE,iBAAA;EACA,eAAA;EACA,oBAAA;CDUD;ACPD;EACE,qBAAA;EAAA,qBAAA;EAAA,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;CDSD;ACRC;EACE,YAAA;EACA,0BAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;CDUH;ACND;EACE,iBAAA;CDQD","file":"style.css","sourcesContent":["@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n@large-text-margin: 40px;\n@small-text-margin: 24px;\n\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.width-parent-relative(@base-width,@parent-width) {\n  width: 100%*(@base-width/@parent-width)\n}\n","@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.content {\n  text-align: left;\n  margin: 0 80px auto;\n}\n@media (--small-viewport) {\n  .content {\n    margin-left: 24px;\n    margin-right: 24px;\n  }\n}\n.requirements {\n  font-weight: 600;\n  color: #2C3E4F;\n  margin-bottom: 16px;\n}\n.requirement {\n  display: flex;\n  padding-bottom: 16px;\n  padding-left: 16px;\n  position: relative;\n}\n.requirement::before {\n  content: '';\n  background-color: #00C9A1;\n  border-radius: 50%;\n  display: inline-block;\n  height: 6px;\n  width: 6px;\n  position: absolute;\n  left: 0;\n  top: 6px;\n}\n.bolder {\n  font-weight: 600;\n}\n","@import (less) \"../../Theme/constants.css\";\n\n.content {\n  text-align: left;\n  margin: 0 80px auto;\n\n  @media (--small-viewport) {\n    margin-left: 24px;\n    margin-right: 24px;\n  }\n}\n\n.requirements {\n  font-weight: 600;\n  color: #2C3E4F;\n  margin-bottom: 16px;\n}\n\n.requirement {\n  display: flex;\n  padding-bottom: 16px;\n  padding-left: 16px;\n  position: relative;\n  &::before {\n    content: '';\n    background-color: #00C9A1;\n    border-radius: 50%;\n    display: inline-block;\n    height: 6px;\n    width: 6px;\n    position: absolute;\n    left: 0;\n    top: 6px;\n  }\n}\n\n.bolder {\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"absolute-center": "onfido-sdk-ui-ProofOfAddress-PoAIntro-absolute-center",
	"content": "onfido-sdk-ui-ProofOfAddress-PoAIntro-content",
	"requirements": "onfido-sdk-ui-ProofOfAddress-PoAIntro-requirements",
	"requirement": "onfido-sdk-ui-ProofOfAddress-PoAIntro-requirement",
	"bolder": "onfido-sdk-ui-ProofOfAddress-PoAIntro-bolder"
};

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-Select-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -ms-flex-preferred-size: 100%;\n      flex-basis: 100%;\n}\n.onfido-sdk-ui-Select-select {\n  max-width: 100%;\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Select/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css"],"names":[],"mappings":"AAAA;EACE,qBAAA;EAAA,qBAAA;EAAA,cAAA;EACA,6BAAA;EAAA,8BAAA;MAAA,2BAAA;UAAA,uBAAA;EACA,8BAAA;MAAA,iBAAA;CCCD;ADED;EACE,gBAAA;CCAD","file":"style.css","sourcesContent":[".wrapper {\n  display: flex;\n  flex-direction: column;\n  flex-basis: 100%;\n}\n\n.select {\n  max-width: 100%;\n}\n",".wrapper {\n  display: flex;\n  flex-direction: column;\n  flex-basis: 100%;\n}\n.select {\n  max-width: 100%;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"wrapper": "onfido-sdk-ui-Select-wrapper",
	"select": "onfido-sdk-ui-Select-select"
};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-Title-absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.onfido-sdk-ui-Title-title {\n  color: #2C3E4F;\n  font-weight: 600;\n  font-size: 30px;\n  line-height: 40px;\n  margin-bottom: 16px;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Title-title {\n    font-size: 24px;\n    line-height: 32px;\n  }\n}\n.onfido-sdk-ui-Title-titleWrapper {\n  margin: 32px 40px 16px;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Title-titleWrapper {\n    margin: 0 24px 16px;\n  }\n}\n@media (min-width: 480px) {\n  .onfido-sdk-ui-Title-smaller {\n    margin-top: 0;\n  }\n}\n.onfido-sdk-ui-Title-fullScreen {\n  color: white;\n  margin: 0;\n  z-index: 1;\n}\n.onfido-sdk-ui-Title-fullScreen .onfido-sdk-ui-Title-title {\n  color: white;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Theme/constants.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Title/style.css"],"names":[],"mappings":"AAMA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;CCFD;ACRD;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;CDUD;ACTC;EA8BF;IA7BI,gBAAA;IACA,kBAAA;GDYD;CACF;ACTD;EACE,uBAAA;CDWD;ACVC;EAsBF;IArBI,oBAAA;GDaD;CACF;ACTC;EAgBF;IAfI,cAAA;GDYD;CACF;ACTD;EACE,aAAA;EACA,UAAA;EACA,WAAA;CDWD;ACdD;EAKI,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;CDYH","file":"style.css","sourcesContent":["@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n@large-text-margin: 40px;\n@small-text-margin: 24px;\n\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.width-parent-relative(@base-width,@parent-width) {\n  width: 100%*(@base-width/@parent-width)\n}\n","@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.title {\n  color: #2C3E4F;\n  font-weight: 600;\n  font-size: 30px;\n  line-height: 40px;\n  margin-bottom: 16px;\n}\n@media (--small-viewport) {\n  .title {\n    font-size: 24px;\n    line-height: 32px;\n  }\n}\n.titleWrapper {\n  margin: 32px 40px 16px;\n}\n@media (--small-viewport) {\n  .titleWrapper {\n    margin: 0 24px 16px;\n  }\n}\n@media (--large) {\n  .smaller {\n    margin-top: 0;\n  }\n}\n.fullScreen {\n  color: white;\n  margin: 0;\n  z-index: 1;\n}\n.fullScreen .title {\n  color: white;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n}\n","@import (less) \"../Theme/constants.css\";\n\n.title {\n  color: #2C3E4F;\n  font-weight: 600;\n  font-size: 30px;\n  line-height: 40px;\n  margin-bottom: 16px;\n  @media (--small-viewport) {\n    font-size: 24px;\n    line-height: 32px;\n  }\n}\n\n.titleWrapper {\n  margin: 32px @large-text-margin 16px;\n  @media (--small-viewport) {\n    margin: 0 @small-text-margin 16px;\n  }\n}\n\n.smaller {\n  @media (--large) {\n    margin-top: 0;\n  }\n}\n\n.fullScreen {\n  color: white;\n  margin: 0;\n  z-index: 1;\n  .title {\n    color: white;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px;\n  }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"absolute-center": "onfido-sdk-ui-Title-absolute-center",
	"title": "onfido-sdk-ui-Title-title",
	"titleWrapper": "onfido-sdk-ui-Title-titleWrapper",
	"smaller": "onfido-sdk-ui-Title-smaller",
	"fullScreen": "onfido-sdk-ui-Title-fullScreen"
};

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-Uploader-absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.onfido-sdk-ui-Uploader-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.onfido-sdk-ui-Uploader-instructions {\n  margin: 16px 0 0;\n}\n.onfido-sdk-ui-Uploader-instructionsCopy {\n  margin: 1rem 24px;\n  font-size: 14px;\n  line-height: 1.43;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Uploader-instructionsCopy {\n    font-size: 16px;\n  }\n}\n.onfido-sdk-ui-Uploader-error {\n  color: #DC0505;\n}\n.onfido-sdk-ui-Uploader-icon,\n.onfido-sdk-ui-Uploader-identityIcon {\n  background-size: 4rem auto;\n}\n.onfido-sdk-ui-Uploader-buttons {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.onfido-sdk-ui-Uploader-button {\n  display: block;\n  margin: 0 5px;\n  width: auto;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  padding: 1.2rem 1rem;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Uploader-button {\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n  }\n}\n.onfido-sdk-ui-Uploader-identityIcon {\n  background-image: url(\"data:image/svg+xml,%3Csvg width%3D%2273%22 height%3D%2267%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg stroke%3D%22%232A7AB0%22 stroke-width%3D%224%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%3E%3Cpath d%3D%22M42 50h14c8.283 0 15-6.717 15-15 0-8.283-6.717-15-15-15-.081 0-.156.021-.234.024C54.317 9.839 45.584 2 35 2c-11.598 0-21 9.402-21 21 0 1.029.099 2.034.243 3.024-.084 0-.159-.024-.243-.024-6.627 0-12 5.373-12 12s5.373 12 12 12h14%22%2F%3E%3Cpath d%3D%22M35 65V35l-6 6M41 41l-6-6%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Uploader-identityIcon {\n    background-image: url(\"data:image/svg+xml,%3Csvg width%3D%2256%22 height%3D%2246%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath d%3D%22M16 24c0-6.617 5.383-12 12-12s12 5.383 12 12-5.383 12-12 12-12-5.383-12-12zM36.036 2H19.964l-4.456 4.842H4.87C3.28 6.842 2 8.116 2 9.684v31.474C2 42.726 3.281 44 4.87 44h46.26C52.72 44 54 42.726 54 41.158V9.684c0-1.568-1.281-2.842-2.87-2.842H40.492L36.036 2z%22 stroke%3D%22%232A7AB0%22 stroke-width%3D%224%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E\");\n  }\n}\n.onfido-sdk-ui-Uploader-proofOfAddressIcon {\n  background-image: url(\"data:image/svg+xml,%3Csvg width%3D%2272%22 height%3D%2276%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E%3Cpath d%3D%22M36 .333c19.883 0 36 16.118 36 36.001 0 19.882-16.117 36-36 36-19.882 0-36-16.118-36-36 0-19.883 16.118-36 36-36%22 fill%3D%22%2320C7A0%22%2F%3E%3Cpath d%3D%22M52 19.719l-6.5-6.386H21.84c-1.02 0-1.84.804-1.84 1.788v42.424c0 .988.816 1.788 1.84 1.788h28.32c1.02 0 1.84-.804 1.84-1.788V19.719z%22 fill%3D%22%23FFF%22%2F%3E%3Cpath d%3D%22M52 19.719l-6.5-6.386H21.84c-1.02 0-1.84.804-1.84 1.788v42.424c0 .988.816 1.788 1.84 1.788h28.32c1.02 0 1.84-.804 1.84-1.788V19.719z%22 stroke%3D%22%232C3E4F%22 stroke-width%3D%222%22%2F%3E%3Cpath d%3D%22M53 19.444v.89h-5.63c-1.384 0-2.37-.99-2.37-2.37v-5.63h.889M25 29.333h14a1 1 0 0 1 0 2H25a1 1 0 0 1 0-2M25 34.333h7a1 1 0 0 1 0 2h-7a1 1 0 0 1 0-2M25 24.333h16a1 1 0 0 1 0 2H25a1 1 0 0 1 0-2%22 fill%3D%22%232C3E4F%22%2F%3E%3Cpath d%3D%22M57.264 68.595h6.064c3.588 0 6.498-2.871 6.498-6.41 0-3.541-2.911-6.41-6.498-6.41-.035 0-.068.008-.101.009-.627-4.351-4.41-7.702-8.994-7.702-5.024 0-9.096 4.019-9.096 8.974 0 .44.043.87.106 1.293-.038 0-.071-.011-.106-.011-2.871 0-5.198 2.296-5.198 5.128 0 2.832 2.327 5.129 5.198 5.129h12.127z%22 fill%3D%22%23FFF%22%2F%3E%3Cpath d%3D%22M57.266 68.595h6.063c3.588 0 6.498-2.871 6.498-6.41 0-3.541-2.911-6.41-6.498-6.41-.035 0-.067.008-.1.009-.63-4.351-4.41-7.702-8.996-7.702-5.023 0-9.094 4.019-9.094 8.974 0 .44.042.87.105 1.293-.038 0-.07-.011-.105-.011-2.871 0-5.2 2.296-5.2 5.128 0 2.832 2.328 5.129 5.2 5.129H51.2%22 stroke%3D%22%232C3E4F%22 stroke-width%3D%222%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3Cpath d%3D%22M56.831 64.748l-2.599-2.563m-.004 12.82v-12.82l-2.598 2.563%22 stroke%3D%22%232C3E4F%22 stroke-width%3D%222%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\n  background-size: auto;\n  height: 76px;\n  margin: auto;\n  width: 72px;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Uploader-proofOfAddressIcon {\n    height: 144px;\n    width: 144px;\n    background-image: url(\"data:image/svg+xml,%3Csvg width%3D%22144%22 height%3D%22144%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E%3Cpath d%3D%22M72 0c39.766 0 72 32.235 72 72s-32.234 72-72 72c-39.765 0-72-32.235-72-72S32.235 0 72 0%22 fill%3D%22%2320C7A0%22%2F%3E%3Cpath d%3D%22M121 140h-16a3.001 3.001 0 0 1 0-6h13v-13a3.001 3.001 0 0 1 6 0v16c0 1.656-1.344 3-3 3zm-95-6h13a3 3 0 0 1 0 6H23a3 3 0 0 1-3-3v-16a3 3 0 0 1 6 0v13zM124 7v16a3 3 0 0 1-6 0V10h-13a3 3 0 0 1 0-6h16a3 3 0 0 1 3 3zm-98 3v13a3 3 0 1 1-6 0V7a3 3 0 0 1 3-3h16a3 3 0 1 1 0 6H26z%22 fill%3D%22%232C3E4F%22%2F%3E%3Cpath d%3D%22M110 33.1L94.5 18H38.68A4.6 4.6 0 0 0 34 22.5v99c0 2.48 2.08 4.5 4.68 4.5h66.64a4.6 4.6 0 0 0 4.68-4.5V33.1z%22 fill%3D%22%23FFF%22%2F%3E%3Cpath d%3D%22M110 33.1L94.5 18H38.68A4.6 4.6 0 0 0 34 22.5v99c0 2.48 2.08 4.5 4.68 4.5h66.64a4.6 4.6 0 0 0 4.68-4.5V33.1z%22 stroke%3D%22%232C3E4F%22 stroke-width%3D%224%22%2F%3E%3Cpath d%3D%22M110 31v3H98c-3.5 0-6-2.5-6-6V16h3M46 60h35a2 2 0 0 1 0 4H46a2 2 0 0 1 0-4M46 72h19a2 2 0 0 1 0 4H46a2 2 0 0 1 0-4M46 48h44a2 2 0 0 1 0 4H46a2 2 0 0 1 0-4%22 fill%3D%22%232C3E4F%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\n  }\n}\n.onfido-sdk-ui-Uploader-uploaderWrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  margin: 0rem 1rem;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Uploader-uploaderWrapper {\n    margin-top: 48px;\n  }\n}\n.onfido-sdk-ui-Uploader-uploadArea {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  position: relative;\n  padding: 1.5rem 24px .5rem;\n  border: 1px solid #2C3E4F;\n  border-radius: 4px;\n  background-color: #FFFFFF;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Uploader-uploadArea {\n    background-color: transparent;\n    border: none;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    padding: 0;\n  }\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Theme/constants.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Uploader/style.css"],"names":[],"mappings":"AAMA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;CCFD;ACRD;EACE,qBAAA;EAAA,qBAAA;EAAA,cAAA;CDUD;ACPD;EACE,iBAAA;CDSD;ACND;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;CDQD;ACNC;EAmFF;IAlFI,gBAAA;GDSD;CACF;ACND;EAEE,eAAA;CDOD;ACJD;;EACE,2BAAA;CDOD;ACJD;EACE,qBAAA;EAAA,qBAAA;EAAA,cAAA;EACA,0BAAA;MAAA,8BAAA;CDMD;ACHD;EACE,eAAA;EACA,cAAA;EACA,YAAA;EACA,oBAAA;MAAA,YAAA;UAAA,QAAA;EACA,qBAAA;CDKD;ACHC;EAyDF;IAxDI,oBAAA;QAAA,qBAAA;YAAA,aAAA;GDMD;CACF;ACHD;EAEE,6mBAAA;CDID;ACFC;EAgDF;IA/CI,8gBAAA;GDKD;CACF;ACFD;EACE,y4DAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;CDID;ACFC;EAoCF;IAnCI,cAAA;IACA,aAAA;IACA,grCAAA;GDKD;CACF;ACFD;EACE,qBAAA;EAAA,qBAAA;EAAA,cAAA;EACA,6BAAA;EAAA,8BAAA;MAAA,2BAAA;UAAA,uBAAA;EACA,kBAAA;EACA,oBAAA;MAAA,qBAAA;UAAA,aAAA;CDID;ACHC;EAwBF;IAvBI,iBAAA;GDMD;CACF;ACHD;EACE,qBAAA;EAAA,qBAAA;EAAA,cAAA;EACA,6BAAA;EAAA,8BAAA;MAAA,2BAAA;UAAA,uBAAA;EACA,oBAAA;MAAA,qBAAA;UAAA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,0BAAA;EACA,mBAAA;EACA,0BAAA;EACA,0BAAA;MAAA,8BAAA;CDKD;ACHC;EAQF;IAPI,8BAAA;IACA,aAAA;IACA,0BAAA;QAAA,uBAAA;YAAA,+BAAA;IACA,WAAA;GDMD;CACF","file":"style.css","sourcesContent":["@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n@large-text-margin: 40px;\n@small-text-margin: 24px;\n\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.width-parent-relative(@base-width,@parent-width) {\n  width: 100%*(@base-width/@parent-width)\n}\n","@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.container {\n  display: flex;\n}\n.instructions {\n  margin: 16px 0 0;\n}\n.instructionsCopy {\n  margin: 1rem 24px;\n  font-size: 14px;\n  line-height: 1.43;\n}\n@media (--small-viewport) {\n  .instructionsCopy {\n    font-size: 16px;\n  }\n}\n.error {\n  color: #DC0505;\n}\n.icon,\n.identityIcon {\n  background-size: 4rem auto;\n}\n.buttons {\n  display: flex;\n  justify-content: space-around;\n}\n.button {\n  display: block;\n  margin: 0 5px;\n  width: auto;\n  flex: 1;\n  padding: 1.2rem 1rem;\n}\n@media (--small-viewport) {\n  .button {\n    flex-grow: 1;\n  }\n}\n.identityIcon {\n  background-image: url('assets/upload.svg');\n}\n@media (--small-viewport) {\n  .identityIcon {\n    background-image: url('assets/camera.svg');\n  }\n}\n.proofOfAddressIcon {\n  background-image: url('assets/letter-upload.svg');\n  background-size: auto;\n  height: 76px;\n  margin: auto;\n  width: 72px;\n}\n@media (--small-viewport) {\n  .proofOfAddressIcon {\n    height: 144px;\n    width: 144px;\n    background-image: url('assets/letter-focus.svg');\n  }\n}\n.uploaderWrapper {\n  display: flex;\n  flex-direction: column;\n  margin: 0rem 1rem;\n  flex-grow: 1;\n}\n@media (--small-viewport) {\n  .uploaderWrapper {\n    margin-top: 48px;\n  }\n}\n.uploadArea {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  position: relative;\n  padding: 1.5rem 24px .5rem;\n  border: 1px solid #2C3E4F;\n  border-radius: 4px;\n  background-color: #FFFFFF;\n  justify-content: space-around;\n}\n@media (--small-viewport) {\n  .uploadArea {\n    background-color: transparent;\n    border: none;\n    justify-content: space-between;\n    padding: 0;\n  }\n}\n","@import (less) \"../Theme/constants.css\";\n\n.container {\n  display: flex;\n}\n\n.instructions {\n  margin: 16px 0 0;\n}\n\n.instructionsCopy {\n  margin: 1rem 24px;\n  font-size: 14px;\n  line-height: 1.43;\n\n  @media (--small-viewport) {\n    font-size: 16px;\n  }\n}\n\n.error {\n  &:extend(.text);\n  color: #DC0505;\n}\n\n.icon {\n  background-size: 4rem auto;\n}\n\n.buttons {\n  display: flex;\n  justify-content: space-around;\n}\n\n.button {\n  display: block;\n  margin: 0 5px;\n  width: auto;\n  flex: 1;\n  padding: 1.2rem 1rem;\n\n  @media (--small-viewport) {\n    flex-grow: 1;\n  }\n}\n\n.identityIcon {\n  &:extend(.icon);\n  background-image: url('assets/upload.svg');\n\n  @media (--small-viewport) {\n    background-image: url('assets/camera.svg');\n  }\n}\n\n.proofOfAddressIcon {\n  background-image: url('assets/letter-upload.svg');\n  background-size: auto;\n  height: 76px;\n  margin: auto;\n  width: 72px;\n\n  @media (--small-viewport) {\n    height: 144px;\n    width: 144px;\n    background-image: url('assets/letter-focus.svg');\n  }\n}\n\n.uploaderWrapper {\n  display: flex;\n  flex-direction: column;\n  margin: 0rem 1rem;\n  flex-grow: 1;\n  @media (--small-viewport) {\n    margin-top: 48px;\n  }\n}\n\n.uploadArea {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  position: relative;\n  padding: 1.5rem 24px .5rem;\n  border: 1px solid #2C3E4F;\n  border-radius: 4px;\n  background-color: #FFFFFF;\n  justify-content: space-around;\n\n  @media (--small-viewport) {\n    background-color: transparent;\n    border: none;\n    justify-content: space-between;\n    padding: 0;\n  }\n}\n\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"absolute-center": "onfido-sdk-ui-Uploader-absolute-center",
	"container": "onfido-sdk-ui-Uploader-container",
	"instructions": "onfido-sdk-ui-Uploader-instructions",
	"instructionsCopy": "onfido-sdk-ui-Uploader-instructionsCopy",
	"error": "onfido-sdk-ui-Uploader-error",
	"icon": "onfido-sdk-ui-Uploader-icon",
	"identityIcon": "onfido-sdk-ui-Uploader-identityIcon",
	"buttons": "onfido-sdk-ui-Uploader-buttons",
	"button": "onfido-sdk-ui-Uploader-button",
	"proofOfAddressIcon": "onfido-sdk-ui-Uploader-proofOfAddressIcon",
	"uploaderWrapper": "onfido-sdk-ui-Uploader-uploaderWrapper",
	"uploadArea": "onfido-sdk-ui-Uploader-uploadArea"
};

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-Welcome-text {\n  margin-top: 64px;\n  margin-bottom: 80px;\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Welcome/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,oBAAA;CCCD","file":"style.css","sourcesContent":[".text {\n  margin-top: 64px;\n  margin-bottom: 80px;\n}\n",".text {\n  margin-top: 64px;\n  margin-bottom: 80px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"text": "onfido-sdk-ui-Welcome-text"
};

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-crossDevice-ClientSuccess-icon {\n  height: 144px;\n  background-size: contain;\n  background-image: url(\"data:image/svg+xml,%3Csvg width%3D%22144%22 height%3D%22144%22 viewBox%3D%220 0 144 144%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E  %3Ctitle%3E    return-to-computer-large  %3C%2Ftitle%3E  %3Cdefs%3E    %3Crect id%3D%22a%22 width%3D%2248%22 height%3D%2280%22 rx%3D%228%22%2F%3E    %3Ccircle id%3D%22b%22 cx%3D%2224%22 cy%3D%2269%22 r%3D%225%22%2F%3E    %3Crect id%3D%22c%22 width%3D%2296%22 height%3D%2264%22 rx%3D%228%22%2F%3E  %3C%2Fdefs%3E  %3Cg fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E    %3Ccircle fill%3D%22%2300C8A0%22 cx%3D%2272%22 cy%3D%2272%22 r%3D%2272%22%2F%3E    %3Cg transform%3D%22translate(10 10)%22%3E      %3Cuse fill%3D%22%23FFF%22 xlink%3Ahref%3D%22%23a%22%2F%3E      %3Crect stroke%3D%22%232C3E4F%22 stroke-width%3D%224%22 x%3D%222%22 y%3D%222%22 width%3D%2244%22 height%3D%2276%22 rx%3D%228%22%2F%3E      %3Cuse fill%3D%22%23FFF%22 xlink%3Ahref%3D%22%23b%22%2F%3E      %3Ccircle stroke%3D%22%23283E4F%22 stroke-width%3D%222%22 cx%3D%2224%22 cy%3D%2269%22 r%3D%224%22%2F%3E      %3Crect fill%3D%22%232C3E4F%22 x%3D%2215%22 y%3D%228%22 width%3D%2218%22 height%3D%222%22 rx%3D%221%22%2F%3E    %3C%2Fg%3E    %3Cg transform%3D%22translate(22 37)%22%3E      %3Ccircle fill%3D%22%2300C8A0%22 cx%3D%2212%22 cy%3D%2212%22 r%3D%2212%22%2F%3E      %3Cpath d%3D%22M16.17 7.52l-5.87 6.22-1.47-1.55c-.65-.7-1.7-.7-2.34 0-.66.68-.66 1.8 0 2.48l2.63 2.8c.64.7 1.7.7 2.34 0L18.5 10c.66-.68.66-1.8 0-2.48-.63-.7-1.68-.7-2.33 0z%22 fill%3D%22%23FFF%22%2F%3E    %3C%2Fg%3E    %3Cg transform%3D%22translate(42 48)%22%3E      %3Cuse fill%3D%22%23FFF%22 xlink%3Ahref%3D%22%23c%22%2F%3E      %3Crect stroke%3D%22%232C3E4F%22 stroke-width%3D%224%22 x%3D%222%22 y%3D%222%22 width%3D%2292%22 height%3D%2260%22 rx%3D%228%22%2F%3E      %3Crect fill%3D%22%232C3E4F%22 x%3D%2224%22 y%3D%2272%22 width%3D%2248%22 height%3D%224%22 rx%3D%222%22%2F%3E      %3Cpath d%3D%22M25 54h46c.55 0 1 .45 1 1s-.45 1-1 1H25c-.55 0-1-.45-1-1s.45-1 1-1z%22 fill%3D%22%232C3E4F%22%2F%3E      %3Crect fill%3D%22%232C3E4F%22 x%3D%2246%22 y%3D%2260%22 width%3D%224%22 height%3D%2216%22 rx%3D%222%22%2F%3E    %3C%2Fg%3E    %3Cg stroke%3D%22%232C3E4F%22 stroke-width%3D%223%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%3E      %3Cpath d%3D%22M75.12 59.37C77.5 50 71.86 40.25 62.56 37.6c-4.66-1.3-9.35-.6-13.17 1.6%22%2F%3E      %3Cpath d%3D%22M79.3 59.35l-5.2 3-3-5.2%22%2F%3E    %3C%2Fg%3E  %3C%2Fg%3E%3C%2Fsvg%3E\");\n  margin-top: 50px;\n  margin-bottom: 50px;\n}\n.onfido-sdk-ui-crossDevice-ClientSuccess-text {\n  font-size: 14px;\n  line-height: 20px;\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/crossDevice/ClientSuccess/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,yBAAA;EACA,y8EAAA;EACA,iBAAA;EACA,oBAAA;CCCD;ADED;EACE,gBAAA;EACA,kBAAA;CCAD","file":"style.css","sourcesContent":[".icon {\n  height: 144px;\n  background-size: contain;\n  background-image: url('assets/return-to-computer-large.svg');\n  margin-top: 50px;\n  margin-bottom: 50px;\n}\n\n.text {\n  font-size: 14px;\n  line-height: 20px;\n}\n",".icon {\n  height: 144px;\n  background-size: contain;\n  background-image: url('assets/return-to-computer-large.svg');\n  margin-top: 50px;\n  margin-bottom: 50px;\n}\n.text {\n  font-size: 14px;\n  line-height: 20px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"icon": "onfido-sdk-ui-crossDevice-ClientSuccess-icon",
	"text": "onfido-sdk-ui-crossDevice-ClientSuccess-text"
};

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-crossDevice-CrossDeviceLink-absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.onfido-sdk-ui-crossDevice-CrossDeviceLink-smsSection {\n  height: 76px;\n  margin-top: 56px;\n}\n.onfido-sdk-ui-crossDevice-CrossDeviceLink-bolder {\n  font-weight: 600;\n}\n.onfido-sdk-ui-crossDevice-CrossDeviceLink-label {\n  font-weight: 600;\n  text-align: left;\n  color: #2C3E4F;\n  float: left;\n}\n.onfido-sdk-ui-crossDevice-CrossDeviceLink-numberInputSection {\n  height: 48px;\n  width: 100%;\n  float: left;\n  margin-top: 4px;\n}\n.onfido-sdk-ui-crossDevice-CrossDeviceLink-inputContainer,\n.onfido-sdk-ui-crossDevice-CrossDeviceLink-linkText {\n  width: 74.07407407%;\n}\n.onfido-sdk-ui-crossDevice-CrossDeviceLink-inputContainer {\n  height: 100%;\n  border: 1px solid #667080;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  border-right: none;\n  background-color: #FFFFFF;\n  float: left;\n  -webkit-box-shadow: 0px -0.1px 0px 0px #667080;\n          box-shadow: 0px -0.1px 0px 0px #667080;\n}\n.onfido-sdk-ui-crossDevice-CrossDeviceLink-fieldError {\n  border: 1px solid #DC2A2A;\n  border-right: none;\n  -webkit-box-shadow: 0px -0.1px 0px 0px #dc2a2a;\n          box-shadow: 0px -0.1px 0px 0px #dc2a2a;\n}\n.onfido-sdk-ui-crossDevice-CrossDeviceLink-numberError {\n  color: #DC2A2A;\n  font-size: 14px;\n  line-height: 20px;\n  float: left;\n  margin-top: 4px;\n}\n.onfido-sdk-ui-crossDevice-CrossDeviceLink-sending:before {\n  float: left;\n  margin-left: 12px;\n  width: 16px;\n  height: 16px;\n  content: \"\";\n  opacity: 0.5;\n  background-image: url(\"data:image/svg+xml,%3Csvg width%3D%2216%22 height%3D%2216%22 viewBox%3D%220 0 16 16%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E  %3Ctitle%3E    Spinner  %3C%2Ftitle%3E  %3Cpath d%3D%22M8 0c.32727985 0 .5925926.26531274.5925926.5925926v2.96296296c0 .32727985-.26531275.5925926-.5925926.5925926-.32727985 0-.5925926-.26531275-.5925926-.5925926V.5925926C7.4074074.26531273 7.67272016 0 8 0zm4 1.07179677c.2834327.16363993.3805439.52606387.2169039.80949654l-1.4814814 2.5660012c-.16364.28343267-.5260639.38054387-.80949657.21690394-.28343267-.16363992-.38054387-.52606387-.21690395-.80949653l1.48148152-2.5660012c.1636399-.28343265.5260638-.38054386.8094965-.21690393zM14.9282032 4c.16364.28343267.0665288.6458566-.2169039.80949654l-2.5660012 1.48148148c-.2834327.16363992-.6458566.06652872-.8094965-.21690395-.16364-.28343266-.0665288-.6458566.2169039-.80949653l2.5660012-1.48148148c.2834327-.16363993.6458566-.06652873.8094965.21690394zM16 8c0 .32727985-.2653127.5925926-.5925926.5925926h-2.962963c-.3272798 0-.5925925-.26531275-.5925925-.5925926 0-.32727985.2653127-.5925926.5925925-.5925926h2.962963C15.7346873 7.4074074 16 7.67272016 16 8zm-1.0717968 4c-.1636399.2834327-.5260638.3805439-.8094965.2169039l-2.5660012-1.4814814c-.2834327-.16364-.3805439-.5260639-.2169039-.80949657.1636399-.28343267.5260638-.38054387.8094965-.21690395l2.5660012 1.48148152c.2834327.1636399.3805439.5260638.2169039.8094965zM12 14.9282032c-.2834327.16364-.6458566.0665288-.8094965-.2169039l-1.48148152-2.5660012c-.16363992-.2834327-.06652872-.6458566.21690395-.8094965.28343267-.16364.64585657-.0665288.80949657.2169039l1.4814814 2.5660012c.16364.2834327.0665288.6458566-.2169039.8094965zM8 16c-.32727985 0-.5925926-.2653127-.5925926-.5925926v-2.962963c0-.3272798.26531275-.5925925.5925926-.5925925.32727985 0 .5925926.2653127.5925926.5925925v2.962963C8.5925926 15.7346873 8.32727984 16 8 16zm-4-1.0717968c-.28343267-.1636399-.38054387-.5260638-.21690394-.8094965l1.48148148-2.5660012c.16363992-.2834327.52606387-.3805439.80949653-.2169039.28343267.1636399.38054387.5260638.21690395.8094965l-1.48148148 2.5660012c-.16363993.2834327-.52606387.3805439-.80949654.2169039zM1.07179677 12c-.16363993-.2834327-.06652872-.6458566.21690394-.8094965l2.5660012-1.48148152c.28343267-.16363992.64585662-.06652872.80949654.21690395.16363993.28343267.06652873.64585657-.21690394.80949657l-2.5660012 1.4814814c-.28343266.16364-.6458566.0665288-.80949653-.2169039zM0 8c0-.32727985.26531274-.5925926.5925926-.5925926h2.96296296c.32727985 0 .5925926.26531275.5925926.5925926 0 .32727985-.26531275.5925926-.5925926.5925926H.5925926C.26531273 8.5925926 0 8.32727984 0 8zm1.07179677-4c.16363993-.28343267.52606387-.38054387.80949654-.21690394l2.5660012 1.48148148c.28343267.16363992.38054387.52606387.21690394.80949653-.16363992.28343267-.52606387.38054387-.80949653.21690395L1.2887007 4.80949654C1.00526806 4.6458566.90815685 4.28343267 1.07179678 4zM4 1.07179677c.28343267-.16363993.6458566-.06652872.80949654.21690394l1.48148148 2.5660012c.16363992.28343267.06652872.64585662-.21690395.80949654-.28343266.16363993-.6458566.06652873-.80949653-.21690394L3.78309606 1.8812933C3.61945613 1.59786065 3.71656733 1.2354367 4 1.07179678z%22 fill-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E\");\n  background-position: left center;\n  background-repeat: no-repeat;\n  -webkit-animation-name: onfido-sdk-ui-crossDevice-CrossDeviceLink-spin;\n          animation-name: onfido-sdk-ui-crossDevice-CrossDeviceLink-spin;\n  -webkit-animation-duration: 4000ms;\n          animation-duration: 4000ms;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n}\n@-webkit-keyframes onfido-sdk-ui-crossDevice-CrossDeviceLink-spin {\n  from {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes onfido-sdk-ui-crossDevice-CrossDeviceLink-spin {\n  from {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.onfido-sdk-ui-crossDevice-CrossDeviceLink-copyLinkSection {\n  height: 68px;\n  margin-top: 86px;\n  text-align: left;\n}\n.onfido-sdk-ui-crossDevice-CrossDeviceLink-linkContainer {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-top: 8px;\n}\n.onfido-sdk-ui-crossDevice-CrossDeviceLink-copySuccess .onfido-sdk-ui-crossDevice-CrossDeviceLink-actionContainer:before {\n  width: 13px;\n  height: 11px;\n  display: inline-block;\n  content: \"\";\n  background-repeat: no-repeat;\n  background-image: url(\"data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22 standalone%3D%22no%22%3F%3E%3Csvg width%3D%2213px%22 height%3D%2211px%22 viewBox%3D%220 0 13 11%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 47.1 (45422) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3Echeckmark-green%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22hi-fidelity-UI%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%225.1.4_desktop_document-step_mobile-method_copy-url-clicked%22 transform%3D%22translate(-409.000000%2C -442.000000)%22 fill%3D%22%2300C8A0%22%3E            %3Cpath d%3D%22M419.167089%2C442.517112 L413.299503%2C448.743607 L411.832911%2C447.186983 C411.18475%2C446.50173 410.133876%2C446.50173 409.486121%2C447.186983 C408.83796%2C447.876466 408.83796%2C448.993174 409.486121%2C449.678427 L412.126311%2C452.482888 C412.774472%2C453.172371 413.82494%2C453.172371 414.473101%2C452.482888 L421.513879%2C445.008556 C422.16204%2C444.319073 422.16204%2C443.202365 421.513879%2C442.517112 C420.865718%2C441.827629 419.81525%2C441.827629 419.167089%2C442.517112 Z%22 id%3D%22checkmark-green%22%3E%3C%2Fpath%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E\");\n  z-index: 1;\n}\n.onfido-sdk-ui-crossDevice-CrossDeviceLink-linkText {\n  resize: none;\n  height: 24px;\n  border: none;\n  background-color: #f3f3f4;\n  overflow: hidden;\n  font-size: 16px;\n  line-height: 24px;\n  color: #2C3E4F;\n  white-space: nowrap;\n  font-family: \"Open Sans\", sans-serif;\n}\n.onfido-sdk-ui-crossDevice-CrossDeviceLink-copyToClipboard {\n  float: right;\n  font-size: 14px;\n  border-bottom: 1px solid #00C8A0;\n  margin-left: 4px;\n  text-decoration: none;\n}\n.onfido-sdk-ui-crossDevice-CrossDeviceLink-copyToClipboard:visited {\n  text-decoration: none;\n  color: #2C3E4F;\n  font-size: 14px;\n}\n.onfido-sdk-ui-crossDevice-CrossDeviceLink-copySuccess .onfido-sdk-ui-crossDevice-CrossDeviceLink-copyToClipboard {\n  border-bottom: none;\n}\n.onfido-sdk-ui-crossDevice-CrossDeviceLink-divider {\n  border-style: solid;\n  border: 1px solid #8A9293;\n  opacity: 0.35;\n  margin-top: 11px;\n}\n.onfido-sdk-ui-crossDevice-CrossDeviceLink-btn {\n  height: 48px;\n  width: 25.92592593%;\n  float: right;\n  border-radius: 0 4px 4px 0;\n  padding: 0;\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Theme/constants.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/crossDevice/CrossDeviceLink/style.css"],"names":[],"mappings":"AAMA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;CCFD;ACPD;EACE,aAAA;EACA,iBAAA;CDSD;ACND;EACE,iBAAA;CDQD;ACLD;EACE,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;CDOD;ACJD;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;CDMD;ACHD;;EFVE,oBAAA;CCiBD;ACHD;EACE,aAAA;EACA,0BAAA;EACA,4BAAA;EACA,+BAAA;EACA,mBAAA;EACA,0BAAA;EACA,YAAA;EACA,+CAAA;UAAA,uCAAA;CDKD;ACFD;EACE,0BAAA;EACA,mBAAA;EACA,+CAAA;UAAA,uCAAA;CDID;ACDD;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;CDGD;ACAD;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EAEA,6sGAAA;EACA,iCAAA;EACA,6BAAA;EAEA,uEAAA;UAAA,+DAAA;EACA,mCAAA;UAAA,2BAAA;EACA,4CAAA;UAAA,oCAAA;EACA,0CAAA;UAAA,kCAAA;CDAD;ACGD;EACI;IAAM,gCAAA;YAAA,wBAAA;GDAP;ECCC;IAAI,kCAAA;YAAA,0BAAA;GDEL;CACF;ACLD;EACI;IAAM,gCAAA;YAAA,wBAAA;GDAP;ECCC;IAAI,kCAAA;YAAA,0BAAA;GDEL;CACF;ACAD;EACE,aAAA;EACA,iBAAA;EACA,iBAAA;CDED;ACCD;EACE,YAAA;EACA,qBAAA;EAAA,qBAAA;EAAA,cAAA;EACA,0BAAA;MAAA,uBAAA;UAAA,+BAAA;EACA,gBAAA;CDCD;ACED;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,w5CAAA;EACA,WAAA;CDAD;ACGD;EACE,aAAA;EACA,aAAA;EACA,aAAA;EACA,0BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,qCAAA;CDDD;ACID;EACE,aAAA;EACA,gBAAA;EACA,iCAAA;EACA,iBAAA;EACA,sBAAA;CDFD;ACKD;EACE,sBAAA;EACA,eAAA;EACA,gBAAA;CDHD;ACMD;EACE,oBAAA;CDJD;ACOD;EACE,oBAAA;EACA,0BAAA;EACA,cAAA;EACA,iBAAA;CDLD;ACQD;EACE,aAAA;EF5HA,oBAAA;EE8HA,aAAA;EACA,2BAAA;EACA,WAAA;CDND","file":"style.css","sourcesContent":["@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n@large-text-margin: 40px;\n@small-text-margin: 24px;\n\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.width-parent-relative(@base-width,@parent-width) {\n  width: 100%*(@base-width/@parent-width)\n}\n","@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.smsSection {\n  height: 76px;\n  margin-top: 56px;\n}\n.bolder {\n  font-weight: 600;\n}\n.label {\n  font-weight: 600;\n  text-align: left;\n  color: #2C3E4F;\n  float: left;\n}\n.numberInputSection {\n  height: 48px;\n  width: 100%;\n  float: left;\n  margin-top: 4px;\n}\n.inputContainer,\n.linkText {\n  width: 74.07407407%;\n}\n.inputContainer {\n  height: 100%;\n  border: 1px solid #667080;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  border-right: none;\n  background-color: #FFFFFF;\n  float: left;\n  box-shadow: 0px -0.1px 0px 0px #667080;\n}\n.fieldError {\n  border: 1px solid #DC2A2A;\n  border-right: none;\n  box-shadow: 0px -0.1px 0px 0px #dc2a2a;\n}\n.numberError {\n  color: #DC2A2A;\n  font-size: 14px;\n  line-height: 20px;\n  float: left;\n  margin-top: 4px;\n}\n.sending:before {\n  float: left;\n  margin-left: 12px;\n  width: 16px;\n  height: 16px;\n  content: \"\";\n  opacity: 0.5;\n  background-image: url('assets/spinner.svg');\n  background-position: left center;\n  background-repeat: no-repeat;\n  animation-name: spin;\n  animation-duration: 4000ms;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n}\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.copyLinkSection {\n  height: 68px;\n  margin-top: 86px;\n  text-align: left;\n}\n.linkContainer {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  margin-top: 8px;\n}\n.copySuccess .actionContainer:before {\n  width: 13px;\n  height: 11px;\n  display: inline-block;\n  content: \"\";\n  background-repeat: no-repeat;\n  background-image: url('assets/checkmark-green.svg');\n  z-index: 1;\n}\n.linkText {\n  resize: none;\n  height: 24px;\n  border: none;\n  background-color: #f3f3f4;\n  overflow: hidden;\n  font-size: 16px;\n  line-height: 24px;\n  color: #2C3E4F;\n  white-space: nowrap;\n  font-family: \"Open Sans\", sans-serif;\n}\n.copyToClipboard {\n  float: right;\n  font-size: 14px;\n  border-bottom: 1px solid #00C8A0;\n  margin-left: 4px;\n  text-decoration: none;\n}\n.copyToClipboard:visited {\n  text-decoration: none;\n  color: #2C3E4F;\n  font-size: 14px;\n}\n.copySuccess .copyToClipboard {\n  border-bottom: none;\n}\n.divider {\n  border-style: solid;\n  border: 1px solid #8A9293;\n  opacity: 0.35;\n  margin-top: 11px;\n}\n.btn {\n  height: 48px;\n  width: 25.92592593%;\n  float: right;\n  border-radius: 0 4px 4px 0;\n  padding: 0;\n}\n","@import (less) \"../../Theme/constants.css\";\n@parent-width: 432;\n\n.smsSection {\n  height: 76px;\n  margin-top: 56px;\n}\n\n.bolder {\n  font-weight: 600;\n}\n\n.label {\n  font-weight: 600;\n  text-align: left;\n  color: #2C3E4F;\n  float: left;\n}\n\n.numberInputSection {\n  height: 48px;\n  width: 100%;\n  float: left;\n  margin-top: 4px;\n}\n\n.inputContainer, .linkText {\n  .width-parent-relative(320, @parent-width);\n}\n\n.inputContainer {\n  height: 100%;\n  border: 1px solid #667080;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  border-right: none;\n  background-color: #FFFFFF;\n  float: left;\n  box-shadow: 0px -0.1px 0px 0px rgba(102,112,128,1);\n}\n\n.fieldError {\n  border: 1px solid #DC2A2A;\n  border-right: none;\n  box-shadow: 0px -0.1px 0px 0px rgba(220,42,42,1);\n}\n\n.numberError {\n  color: #DC2A2A;\n  font-size: 14px;\n  line-height: 20px;\n  float: left;\n  margin-top: 4px;\n}\n\n.sending:before {\n  float: left;\n  margin-left: 12px;\n  width: 16px;\n  height: 16px;\n  content: \"\";\n  opacity: 0.5;\n\n  background-image: url('./assets/spinner.svg');\n  background-position: left center;\n  background-repeat: no-repeat;\n\n  animation-name: spin;\n  animation-duration: 4000ms;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n}\n\n@keyframes spin {\n    from {transform:rotate(0deg);}\n    to {transform:rotate(360deg);}\n}\n\n.copyLinkSection {\n  height: 68px;\n  margin-top: 86px;\n  text-align: left;\n}\n\n.linkContainer {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  margin-top: 8px;\n}\n\n.copySuccess .actionContainer:before {\n  width: 13px;\n  height: 11px;\n  display: inline-block;\n  content: \"\";\n  background-repeat: no-repeat;\n  background-image: url('./assets/checkmark-green.svg');\n  z-index: 1;\n}\n\n.linkText {\n  resize: none;\n  height: 24px;\n  border: none;\n  background-color: #f3f3f4;\n  overflow: hidden;\n  font-size: 16px;\n  line-height: 24px;\n  color: #2C3E4F;\n  white-space: nowrap;\n  font-family: \"Open Sans\", sans-serif;\n}\n\n.copyToClipboard {\n  float: right;\n  font-size: 14px;\n  border-bottom: 1px solid #00C8A0;\n  margin-left: 4px;\n  text-decoration: none;\n}\n\n.copyToClipboard:visited {\n  text-decoration: none;\n  color: #2C3E4F;\n  font-size: 14px;\n}\n\n.copySuccess .copyToClipboard {\n  border-bottom: none;\n}\n\n.divider {\n  border-style: solid;\n  border: 1px solid #8A9293;\n  opacity: 0.35;\n  margin-top: 11px;\n}\n\n.btn {\n  height: 48px;\n  .width-parent-relative(112, @parent-width);\n  float: right;\n  border-radius: 0 4px 4px 0;\n  padding: 0;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"absolute-center": "onfido-sdk-ui-crossDevice-CrossDeviceLink-absolute-center",
	"smsSection": "onfido-sdk-ui-crossDevice-CrossDeviceLink-smsSection",
	"bolder": "onfido-sdk-ui-crossDevice-CrossDeviceLink-bolder",
	"label": "onfido-sdk-ui-crossDevice-CrossDeviceLink-label",
	"numberInputSection": "onfido-sdk-ui-crossDevice-CrossDeviceLink-numberInputSection",
	"inputContainer": "onfido-sdk-ui-crossDevice-CrossDeviceLink-inputContainer",
	"linkText": "onfido-sdk-ui-crossDevice-CrossDeviceLink-linkText",
	"fieldError": "onfido-sdk-ui-crossDevice-CrossDeviceLink-fieldError",
	"numberError": "onfido-sdk-ui-crossDevice-CrossDeviceLink-numberError",
	"sending": "onfido-sdk-ui-crossDevice-CrossDeviceLink-sending",
	"spin": "onfido-sdk-ui-crossDevice-CrossDeviceLink-spin",
	"copyLinkSection": "onfido-sdk-ui-crossDevice-CrossDeviceLink-copyLinkSection",
	"linkContainer": "onfido-sdk-ui-crossDevice-CrossDeviceLink-linkContainer",
	"copySuccess": "onfido-sdk-ui-crossDevice-CrossDeviceLink-copySuccess",
	"actionContainer": "onfido-sdk-ui-crossDevice-CrossDeviceLink-actionContainer",
	"copyToClipboard": "onfido-sdk-ui-crossDevice-CrossDeviceLink-copyToClipboard",
	"divider": "onfido-sdk-ui-crossDevice-CrossDeviceLink-divider",
	"btn": "onfido-sdk-ui-crossDevice-CrossDeviceLink-btn"
};

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-crossDevice-CrossDeviceSubmit-icon {\n  height: 36px;\n  width: 36px;\n  margin-right: 14px;\n  float: left;\n  background-image: url(\"data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22 standalone%3D%22no%22%3F%3E%3Csvg width%3D%2236px%22 height%3D%2236px%22 viewBox%3D%220 0 36 36%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 46.2 (44496) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3Ecomplete-tick-small%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Symbols%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22icons%2Fcomplete-tick%2Fmedium%22 transform%3D%22translate(-6.000000%2C -6.000000)%22%3E            %3Cg id%3D%22complete-tick-medium%22%3E                %3Cg id%3D%22complete-tick-small%22 transform%3D%22translate(6.000000%2C 6.000000)%22%3E                    %3Ccircle id%3D%22Oval%22 fill%3D%22%2300C8A0%22 cx%3D%2218%22 cy%3D%2218%22 r%3D%2218%22%3E%3C%2Fcircle%3E                    %3Cpath d%3D%22M24.250633%2C10.5256681 L15.4492545%2C19.8654105 L13.249367%2C17.5304749 C12.2771252%2C16.5025957 10.7008135%2C16.5025957 9.72918132%2C17.5304749 C8.75693956%2C18.5646991 8.75693956%2C20.2397616 9.72918132%2C21.2676408 L13.6894664%2C25.4743319 C14.6617082%2C26.508556 16.2374103%2C26.508556 17.2096521%2C25.4743319 L27.7708187%2C14.2628341 C28.7430604%2C13.2286099 28.7430604%2C11.5535474 27.7708187%2C10.5256681 C26.7985769%2C9.49144395 25.2228748%2C9.49144395 24.250633%2C10.5256681 Z%22 id%3D%22checkmark%22 fill%3D%22%23FFFFFF%22%3E%3C%2Fpath%3E                %3C%2Fg%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E\");\n}\n.onfido-sdk-ui-crossDevice-CrossDeviceSubmit-uploadList {\n  display: inline-block;\n  padding-left: 0px;\n  margin-top: 48px;\n  margin-bottom: 56px;\n}\n.onfido-sdk-ui-crossDevice-CrossDeviceSubmit-uploadList li {\n  margin-bottom: 24px;\n  list-style: none;\n  text-align: left;\n}\n.onfido-sdk-ui-crossDevice-CrossDeviceSubmit-listText {\n  line-height: 36px;\n  font-weight: 600;\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/crossDevice/CrossDeviceSubmit/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,qsDAAA;CCCD;ADED;EACE,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;CCAD;ADGD;EACE,oBAAA;EACA,iBAAA;EACA,iBAAA;CCDD;ADID;EACE,kBAAA;EACA,iBAAA;CCFD","file":"style.css","sourcesContent":[".icon {\n  height: 36px;\n  width: 36px;\n  margin-right: 14px;\n  float: left;\n  background-image: url('assets/complete-tick-small.svg');\n}\n\n.uploadList {\n  display: inline-block;\n  padding-left: 0px;\n  margin-top: 48px;\n  margin-bottom: 56px;\n}\n\n.uploadList li {\n  margin-bottom: 24px;\n  list-style: none;\n  text-align: left;\n}\n\n.listText {\n  line-height: 36px;\n  font-weight: 600;\n}\n",".icon {\n  height: 36px;\n  width: 36px;\n  margin-right: 14px;\n  float: left;\n  background-image: url('assets/complete-tick-small.svg');\n}\n.uploadList {\n  display: inline-block;\n  padding-left: 0px;\n  margin-top: 48px;\n  margin-bottom: 56px;\n}\n.uploadList li {\n  margin-bottom: 24px;\n  list-style: none;\n  text-align: left;\n}\n.listText {\n  line-height: 36px;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"icon": "onfido-sdk-ui-crossDevice-CrossDeviceSubmit-icon",
	"uploadList": "onfido-sdk-ui-crossDevice-CrossDeviceSubmit-uploadList",
	"listText": "onfido-sdk-ui-crossDevice-CrossDeviceSubmit-listText"
};

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-crossDevice-Intro-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.onfido-sdk-ui-crossDevice-Intro-stage {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-bottom: 32px;\n  position: relative;\n  /* blue line connecting all three icons */\n}\n.onfido-sdk-ui-crossDevice-Intro-stage::before {\n  content: '';\n  display: block;\n  background-color: #2C3E4F;\n  width: 2px;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 23px;\n}\n.onfido-sdk-ui-crossDevice-Intro-stage:last-child::before {\n  display: none;\n}\n.onfido-sdk-ui-crossDevice-Intro-stageIcon {\n  background-size: contain;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  float: left;\n  height: 48px;\n  width: 48px;\n  position: relative;\n  z-index: 1;\n}\n.onfido-sdk-ui-crossDevice-Intro-stageIcon-sms {\n  background-image: url(\"data:image/svg+xml,%3Csvg width%3D%2248%22 height%3D%2248%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E  %3Cg fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E    %3Ccircle fill%3D%22%2300C9A1%22 cx%3D%2224%22 cy%3D%2224%22 r%3D%2224%22%2F%3E    %3Cg transform%3D%22translate(12 4)%22%3E      %3Crect stroke%3D%22%232C3E4F%22 stroke-width%3D%221.3333%22 fill%3D%22%23FFF%22 x%3D%22.6667%22 y%3D%224.6667%22 width%3D%2222.6667%22 height%3D%2238.6667%22 rx%3D%222.6667%22%2F%3E      %3Ccircle stroke%3D%22%23283E4F%22 stroke-width%3D%22.6667%22 fill%3D%22%23FFF%22 cx%3D%2212%22 cy%3D%2239%22 r%3D%221.6667%22%2F%3E      %3Crect fill%3D%22%232C3E4F%22 x%3D%227.3333%22 y%3D%227.3333%22 width%3D%229.3333%22 height%3D%221%22 rx%3D%22.5%22%2F%3E      %3Cg fill%3D%22%232C3E4F%22%3E        %3Cpath d%3D%22M25.5 5h2.3333a.5.5 0 0 1 0 1H25.5a.5.5 0 1 1 0-1zM23.5.6667V3a.5.5 0 1 1-1 0V.6667a.5.5 0 0 1 1 0zM24.6869 3.0035l1.6499-1.65a.5.5 0 1 1 .7071.7071l-1.65 1.65a.5.5 0 1 1-.7071-.7071z%22%2F%3E      %3C%2Fg%3E      %3Cg transform%3D%22translate(2.6667 16)%22%3E        %3Crect stroke%3D%22%238B9094%22 stroke-width%3D%22.5%22 fill%3D%22%23F3F3F4%22 x%3D%22.25%22 y%3D%22.25%22 width%3D%2218.1667%22 height%3D%224.8333%22 rx%3D%22.6667%22%2F%3E        %3Cpath d%3D%22M2 2.6667a.6667.6667 0 1 0 0-1.3334.6667.6667 0 0 0 0 1.3334z%22 fill%3D%22%2300C8A0%22%2F%3E        %3Crect fill%3D%22%238B9094%22 x%3D%223.6667%22 y%3D%221.6667%22 width%3D%2210.3333%22 height%3D%221%22 rx%3D%22.5%22%2F%3E        %3Crect fill%3D%22%238B9094%22 x%3D%223.6667%22 y%3D%223.3333%22 width%3D%2213%22 height%3D%221%22 rx%3D%22.5%22%2F%3E      %3C%2Fg%3E    %3C%2Fg%3E  %3C%2Fg%3E%3C%2Fsvg%3E\");\n}\n.onfido-sdk-ui-crossDevice-Intro-stageIcon-take-photos {\n  background-image: url(\"data:image/svg+xml,%3Csvg width%3D%2248%22 height%3D%2248%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E  %3Cg fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E    %3Ccircle fill%3D%22%2300C8A0%22 cx%3D%2224%22 cy%3D%2224%22 r%3D%2224%22%2F%3E    %3Cg transform%3D%22translate(14.6667 8)%22%3E      %3Crect stroke%3D%22%232C3E4F%22 stroke-width%3D%221.3333%22 fill%3D%22%23FFF%22 x%3D%22.6667%22 y%3D%22.6667%22 width%3D%2217.3333%22 height%3D%2230.6667%22 rx%3D%222.6667%22%2F%3E      %3Crect fill%3D%22%232C3E4F%22 x%3D%226%22 y%3D%222.6667%22 width%3D%226.6667%22 height%3D%221%22 rx%3D%22.5%22%2F%3E      %3Ccircle stroke%3D%22%232C3E4F%22 stroke-width%3D%22.6667%22 fill%3D%22%23FFF%22 cx%3D%229.3333%22 cy%3D%2228.6667%22 r%3D%221%22%2F%3E    %3C%2Fg%3E    %3Cpath d%3D%22M6.7075 20.165c-.5335.143-.85.6913-.7071 1.2248L8.7612 31.693c.143.5335.6913.85 1.2247.7071l18.0306-4.8313c.5335-.143.85-.6913.7071-1.2247L25.963 16.0408c-.143-.5334-.6913-.85-1.2248-.707L6.7075 20.165z%22 stroke%3D%22%23283E4F%22 stroke-width%3D%22.6667%22 fill%3D%22%23FFF%22%2F%3E    %3Cg transform%3D%22rotate(-15 86.665 -52.3386)%22 fill%3D%22%23283E4F%22%3E      %3Crect y%3D%224%22 width%3D%226%22 height%3D%221%22 rx%3D%22.5%22%2F%3E      %3Crect y%3D%222%22 width%3D%228.6667%22 height%3D%221%22 rx%3D%22.5%22%2F%3E      %3Crect width%3D%228.6667%22 height%3D%221%22 rx%3D%22.5%22%2F%3E    %3C%2Fg%3E    %3Cpath d%3D%22M13.0543 28.472c1.198-.321 2.8214.3619 3.9288 1.7081l.644-.1725c-1.2813-1.7173-3.0806-2.6255-4.7453-2.1795-1.638.4389-2.7083 2.1708-2.9822 4.25l.644-.1725c.3083-1.7117 1.3651-3.1266 2.5107-3.4335z%22 fill%3D%22%23283E4F%22 fill-rule%3D%22nonzero%22%2F%3E    %3Cpath d%3D%22M12.9637 26.7709c1.3395-.359 2.1645-2.2254 1.7419-3.8026-.3978-1.4844-1.8749-2.3734-3.2948-1.993-.9439.253-1.6563 1.0157-1.8821 1.9824-.1056.452-.0989.9276.0253 1.391.4226 1.5771 2.0703 2.781 3.4097 2.4222z%22 stroke%3D%22%23283E4F%22 stroke-width%3D%22.6667%22%2F%3E    %3Cpath fill%3D%22%23283E4F%22 d%3D%22M14.6667 16H16v20.6667h-1.3333z%22%2F%3E    %3Cpath fill-opacity%3D%22.67%22 fill%3D%22%23FFF%22 d%3D%22M16 14.6667h16v18H16z%22%2F%3E    %3Cpath stroke%3D%22%23FFF%22 stroke-width%3D%22.6667%22 d%3D%22M16.3334 14.3333h15.3333v17.3333H16.3334z%22%2F%3E  %3C%2Fg%3E%3C%2Fsvg%3E\");\n}\n.onfido-sdk-ui-crossDevice-Intro-stageIcon-take-selfie {\n  background-image: url(\"data:image/svg+xml,%3Csvg width%3D%2248%22 height%3D%2248%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%3Cdefs%3E%3Ccircle id%3D%22a%22 cx%3D%228%22 cy%3D%228%22 r%3D%227.5%22%2F%3E%3C%2Fdefs%3E%3Cg fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E%3Ccircle fill%3D%22%2300C8A0%22 fill-rule%3D%22nonzero%22 cx%3D%2224%22 cy%3D%2224%22 r%3D%2224%22%2F%3E%3Crect stroke%3D%22%232C3E4F%22 stroke-width%3D%221.333%22 fill%3D%22%23FFF%22 fill-rule%3D%22nonzero%22 x%3D%2213%22 y%3D%229%22 width%3D%2222%22 height%3D%2238%22 rx%3D%222.667%22%2F%3E%3Crect fill%3D%22%232C3E4F%22 fill-rule%3D%22nonzero%22 x%3D%2220%22 y%3D%2211%22 width%3D%228%22 height%3D%221%22 rx%3D%22.5%22%2F%3E%3Cg transform%3D%22translate(16 18)%22%3E%3Cmask id%3D%22b%22 fill%3D%22%23fff%22%3E%3Cuse xlink%3Ahref%3D%22%23a%22%2F%3E%3C%2Fmask%3E%3Ccircle stroke%3D%22%232C3E4F%22 mask%3D%22url(%23b)%22 cx%3D%2212.85%22 cy%3D%22-.85%22 r%3D%227.35%22%2F%3E%3Ccircle stroke%3D%22%232C3E4F%22 mask%3D%22url(%23b)%22 cx%3D%22-1.65%22 cy%3D%22.85%22 r%3D%227.35%22%2F%3E%3C%2Fg%3E%3Ccircle stroke%3D%22%232C3E4F%22 fill%3D%22%23FFF%22 fill-rule%3D%22nonzero%22 cx%3D%2224%22 cy%3D%2243%22 r%3D%221.5%22%2F%3E%3Ccircle fill%3D%22%232C3E4F%22 fill-rule%3D%22nonzero%22 cx%3D%2222%22 cy%3D%2227%22 r%3D%221%22%2F%3E%3Ccircle fill%3D%22%232C3E4F%22 fill-rule%3D%22nonzero%22 cx%3D%2226%22 cy%3D%2227%22 r%3D%221%22%2F%3E%3Ccircle stroke%3D%22%232C3E4F%22 cx%3D%2224%22 cy%3D%2226%22 r%3D%227.5%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\n}\n.onfido-sdk-ui-crossDevice-Intro-stageIcon-return-computer {\n  background-image: url(\"data:image/svg+xml,%3Csvg width%3D%22144%22 height%3D%22144%22 viewBox%3D%220 0 144 144%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E  %3Ctitle%3E    return-to-computer-large  %3C%2Ftitle%3E  %3Cdefs%3E    %3Crect id%3D%22a%22 width%3D%2248%22 height%3D%2280%22 rx%3D%228%22%2F%3E    %3Ccircle id%3D%22b%22 cx%3D%2224%22 cy%3D%2269%22 r%3D%225%22%2F%3E    %3Crect id%3D%22c%22 width%3D%2296%22 height%3D%2264%22 rx%3D%228%22%2F%3E  %3C%2Fdefs%3E  %3Cg fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E    %3Ccircle fill%3D%22%2300C8A0%22 cx%3D%2272%22 cy%3D%2272%22 r%3D%2272%22%2F%3E    %3Cg transform%3D%22translate(10 10)%22%3E      %3Cuse fill%3D%22%23FFF%22 xlink%3Ahref%3D%22%23a%22%2F%3E      %3Crect stroke%3D%22%232C3E4F%22 stroke-width%3D%224%22 x%3D%222%22 y%3D%222%22 width%3D%2244%22 height%3D%2276%22 rx%3D%228%22%2F%3E      %3Cuse fill%3D%22%23FFF%22 xlink%3Ahref%3D%22%23b%22%2F%3E      %3Ccircle stroke%3D%22%23283E4F%22 stroke-width%3D%222%22 cx%3D%2224%22 cy%3D%2269%22 r%3D%224%22%2F%3E      %3Crect fill%3D%22%232C3E4F%22 x%3D%2215%22 y%3D%228%22 width%3D%2218%22 height%3D%222%22 rx%3D%221%22%2F%3E    %3C%2Fg%3E    %3Cg transform%3D%22translate(22 37)%22%3E      %3Ccircle fill%3D%22%2300C8A0%22 cx%3D%2212%22 cy%3D%2212%22 r%3D%2212%22%2F%3E      %3Cpath d%3D%22M16.17 7.52l-5.87 6.22-1.47-1.55c-.65-.7-1.7-.7-2.34 0-.66.68-.66 1.8 0 2.48l2.63 2.8c.64.7 1.7.7 2.34 0L18.5 10c.66-.68.66-1.8 0-2.48-.63-.7-1.68-.7-2.33 0z%22 fill%3D%22%23FFF%22%2F%3E    %3C%2Fg%3E    %3Cg transform%3D%22translate(42 48)%22%3E      %3Cuse fill%3D%22%23FFF%22 xlink%3Ahref%3D%22%23c%22%2F%3E      %3Crect stroke%3D%22%232C3E4F%22 stroke-width%3D%224%22 x%3D%222%22 y%3D%222%22 width%3D%2292%22 height%3D%2260%22 rx%3D%228%22%2F%3E      %3Crect fill%3D%22%232C3E4F%22 x%3D%2224%22 y%3D%2272%22 width%3D%2248%22 height%3D%224%22 rx%3D%222%22%2F%3E      %3Cpath d%3D%22M25 54h46c.55 0 1 .45 1 1s-.45 1-1 1H25c-.55 0-1-.45-1-1s.45-1 1-1z%22 fill%3D%22%232C3E4F%22%2F%3E      %3Crect fill%3D%22%232C3E4F%22 x%3D%2246%22 y%3D%2260%22 width%3D%224%22 height%3D%2216%22 rx%3D%222%22%2F%3E    %3C%2Fg%3E    %3Cg stroke%3D%22%232C3E4F%22 stroke-width%3D%223%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%3E      %3Cpath d%3D%22M75.12 59.37C77.5 50 71.86 40.25 62.56 37.6c-4.66-1.3-9.35-.6-13.17 1.6%22%2F%3E      %3Cpath d%3D%22M79.3 59.35l-5.2 3-3-5.2%22%2F%3E    %3C%2Fg%3E  %3C%2Fg%3E%3C%2Fsvg%3E\");\n}\n.onfido-sdk-ui-crossDevice-Intro-stageMessage {\n  text-align: left;\n  margin-left: 15px;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  -ms-flex-preferred-size: 100%;\n      flex-basis: 100%;\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/crossDevice/Intro/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css"],"names":[],"mappings":"AAAA;EACE,qBAAA;EAAA,qBAAA;EAAA,cAAA;EACA,6BAAA;EAAA,8BAAA;MAAA,2BAAA;UAAA,uBAAA;EACA,oBAAA;MAAA,qBAAA;UAAA,aAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,wBAAA;CCCD;ADED;EACE,qBAAA;EAAA,qBAAA;EAAA,cAAA;EACA,qBAAA;EACA,mBAAA;ECAA,0CAA0C;CAC3C;ADEC;EACE,YAAA;EACA,eAAA;EACA,0BAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,OAAA;EACA,WAAA;CCAH;ADGC;EACE,cAAA;CCDH;ADKD;EACE,yBAAA;EACA,qBAAA;MAAA,eAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;CCHD;ADKC;EACE,uqDAAA;CCHH;ADMC;EACE,yvEAAA;CCJH;ADOC;EACE,0iDAAA;CCLH;ADQC;EACE,y8EAAA;CCNH;ADUD;EACE,iBAAA;EACA,kBAAA;EACA,oBAAA;MAAA,qBAAA;UAAA,aAAA;EACA,8BAAA;MAAA,iBAAA;CCRD","file":"style.css","sourcesContent":[".content {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  justify-content: center;\n}\n\n.stage {\n  display: flex;\n  padding-bottom: 32px;\n  position: relative;\n\n  /* blue line connecting all three icons */\n  &::before {\n    content: '';\n    display: block;\n    background-color: #2C3E4F;\n    width: 2px;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 23px;\n  }\n\n  &:last-child::before {\n    display: none;\n  }\n}\n\n.stageIcon {\n  background-size: contain;\n  flex-shrink: 0;\n  float: left;\n  height: 48px;\n  width: 48px;\n  position: relative;\n  z-index: 1;\n\n  &-sms {\n    background-image: url('assets/connection-large.svg')\n  }\n\n  &-take-photos {\n    background-image: url('assets/take-photos.svg');\n  }\n\n  &-take-selfie {\n    background-image: url('assets/take-selfie.svg');\n  }\n\n  &-return-computer {\n    background-image: url('assets/return-to-computer-large.svg')\n  }\n}\n\n.stageMessage {\n  text-align: left;\n  margin-left: 15px;\n  flex-grow: 1;\n  flex-basis: 100%;\n}",".content {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  justify-content: center;\n}\n.stage {\n  display: flex;\n  padding-bottom: 32px;\n  position: relative;\n  /* blue line connecting all three icons */\n}\n.stage::before {\n  content: '';\n  display: block;\n  background-color: #2C3E4F;\n  width: 2px;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 23px;\n}\n.stage:last-child::before {\n  display: none;\n}\n.stageIcon {\n  background-size: contain;\n  flex-shrink: 0;\n  float: left;\n  height: 48px;\n  width: 48px;\n  position: relative;\n  z-index: 1;\n}\n.stageIcon-sms {\n  background-image: url('assets/connection-large.svg');\n}\n.stageIcon-take-photos {\n  background-image: url('assets/take-photos.svg');\n}\n.stageIcon-take-selfie {\n  background-image: url('assets/take-selfie.svg');\n}\n.stageIcon-return-computer {\n  background-image: url('assets/return-to-computer-large.svg');\n}\n.stageMessage {\n  text-align: left;\n  margin-left: 15px;\n  flex-grow: 1;\n  flex-basis: 100%;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"content": "onfido-sdk-ui-crossDevice-Intro-content",
	"stage": "onfido-sdk-ui-crossDevice-Intro-stage",
	"stageIcon": "onfido-sdk-ui-crossDevice-Intro-stageIcon",
	"stageIcon-sms": "onfido-sdk-ui-crossDevice-Intro-stageIcon-sms",
	"stageIcon-take-photos": "onfido-sdk-ui-crossDevice-Intro-stageIcon-take-photos",
	"stageIcon-take-selfie": "onfido-sdk-ui-crossDevice-Intro-stageIcon-take-selfie",
	"stageIcon-return-computer": "onfido-sdk-ui-crossDevice-Intro-stageIcon-return-computer",
	"stageMessage": "onfido-sdk-ui-crossDevice-Intro-stageMessage"
};

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-crossDevice-MobileConnected-icon {\n  height: 9rem;\n  background-size: contain;\n  background-image: url(\"data:image/svg+xml,%3Csvg width%3D%22144%22 height%3D%22144%22 viewBox%3D%220 0 144 144%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%3Ctitle%3Econnection-large%3C%2Ftitle%3E%3Cdefs%3E%3Crect id%3D%22a%22 width%3D%2296%22 height%3D%2264%22 rx%3D%228%22%2F%3E%3Crect id%3D%22b%22 width%3D%2248%22 height%3D%2280%22 rx%3D%228%22%2F%3E%3Ccircle id%3D%22c%22 cx%3D%2224%22 cy%3D%2269%22 r%3D%225%22%2F%3E%3C%2Fdefs%3E%3Cg fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E%3Ccircle fill%3D%22%2300C8A0%22 cx%3D%2272%22 cy%3D%2272%22 r%3D%2272%22%2F%3E%3Cg transform%3D%22translate(43 32)%22%3E%3Cuse fill%3D%22%23FFF%22 xlink%3Ahref%3D%22%23a%22%2F%3E%3Crect stroke%3D%22%232C3E4F%22 stroke-width%3D%224%22 x%3D%222%22 y%3D%222%22 width%3D%2292%22 height%3D%2260%22 rx%3D%228%22%2F%3E%3Crect fill%3D%22%232C3E4F%22 x%3D%2224%22 y%3D%2272%22 width%3D%2248%22 height%3D%224%22 rx%3D%222%22%2F%3E%3Cpath d%3D%22M25 54h46c.552 0 1 .448 1 1s-.448 1-1 1H25c-.552 0-1-.448-1-1s.448-1 1-1z%22 fill%3D%22%232C3E4F%22%2F%3E%3Crect fill%3D%22%232C3E4F%22 x%3D%2246%22 y%3D%2260%22 width%3D%224%22 height%3D%2216%22 rx%3D%222%22%2F%3E%3C%2Fg%3E%3Cg transform%3D%22translate(11 50)%22%3E%3Cuse fill%3D%22%23FFF%22 xlink%3Ahref%3D%22%23b%22%2F%3E%3Crect stroke%3D%22%232C3E4F%22 stroke-width%3D%224%22 x%3D%222%22 y%3D%222%22 width%3D%2244%22 height%3D%2276%22 rx%3D%228%22%2F%3E%3Cuse fill%3D%22%23FFF%22 xlink%3Ahref%3D%22%23c%22%2F%3E%3Ccircle stroke%3D%22%23283E4F%22 stroke-width%3D%222%22 cx%3D%2224%22 cy%3D%2269%22 r%3D%224%22%2F%3E%3Crect fill%3D%22%232C3E4F%22 x%3D%2215%22 y%3D%228%22 width%3D%2218%22 height%3D%222%22 rx%3D%221%22%2F%3E%3C%2Fg%3E%3Cpath d%3D%22M48 16c0-1.1.9-2 2.02-2 1.1 0 1.98.9 1.98 2s-.88 2-1.98 2C48.9 18 48 17.1 48 16m8 0c0-1.1.9-2 2-2 1.12 0 2 .9 2 2s-.88 2-2 2c-1.1 0-2-.9-2-2m8 0c0-1.1.88-2 1.98-2 1.12 0 2.02.9 2.02 2s-.9 2-2.02 2c-1.1 0-1.98-.9-1.98-2m8 0c0-1.1.9-2 2-2 1.12 0 2 .9 2 2s-.88 2-2 2c-1.1 0-2-.9-2-2m8 0c0-1.1.9-2 2.02-2 1.1 0 1.98.9 1.98 2s-.88 2-1.98 2C80.9 18 80 17.1 80 16m8 0c0-1.1.9-2 2-2 1.12 0 2 .9 2 2s-.88 2-2 2c-1.1 0-2-.9-2-2m-47.98.142c-.02-.04-.02-.1-.02-.16.02-1.018.82-1.897 1.88-1.977 1.1-.08 2.04.76 2.12 1.858v.16c0 1.038-.8 1.897-1.84 1.977h-.14c-1.06 0-1.94-.8-2-1.858M95.398 20.2C95.14 19.84 95 19.42 95 19c0-.6.28-1.202.8-1.602.88-.66 2.14-.48 2.8.4.28.36.4.78.4 1.2 0 .62-.28 1.222-.8 1.602-.36.28-.78.4-1.2.4-.602 0-1.2-.28-1.602-.8M35.04 21.76c-.66-.36-1.04-1.063-1.04-1.764 0-.32.08-.66.24-.962.54-.962 1.74-1.323 2.72-.782.66.36 1.04 1.042 1.04 1.764 0 .32-.08.64-.24.942h-.02C37.38 21.638 36.7 22 36 22c-.32 0-.66-.08-.96-.24M97 27c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2m-64 1c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2m0 8c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2m0 8c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2%22 fill%3D%22%232C3E4F%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\n  margin-top: 40px;\n  margin-bottom: 32px;\n}\n.onfido-sdk-ui-crossDevice-MobileConnected-cancel {\n  line-height: 20px;\n  font-size: 14px;\n  width: 50px;\n  margin: auto;\n  color: #2C3E4F;\n  text-decoration: none;\n  -webkit-box-shadow: inset 0 -1px 0 0 #00C8A0;\n          box-shadow: inset 0 -1px 0 0 #00C8A0;\n  cursor: pointer;\n}\n.onfido-sdk-ui-crossDevice-MobileConnected-help {\n  margin-bottom: 1.5rem;\n}\n.onfido-sdk-ui-crossDevice-MobileConnected-helpList {\n  padding-left: 1.5rem;\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/crossDevice/MobileConnected/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,yBAAA;EACA,y2FAAA;EACA,iBAAA;EACA,oBAAA;CCCD;ADED;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,6CAAA;UAAA,qCAAA;EACA,gBAAA;CCAD;ADGD;EACE,sBAAA;CCDD;ADID;EACE,qBAAA;CCFD","file":"style.css","sourcesContent":[".icon {\n  height: 9rem;\n  background-size: contain;\n  background-image: url('assets/connection-large.svg');\n  margin-top: 40px;\n  margin-bottom: 32px;\n}\n\n.cancel {\n  line-height: 20px;\n  font-size: 14px;\n  width: 50px;\n  margin: auto;\n  color: #2C3E4F;\n  text-decoration: none;\n  box-shadow: inset 0 -1px 0 0 #00C8A0;\n  cursor: pointer;\n}\n\n.help {\n  margin-bottom: 1.5rem;\n}\n\n.helpList {\n  padding-left: 1.5rem;\n}\n",".icon {\n  height: 9rem;\n  background-size: contain;\n  background-image: url('assets/connection-large.svg');\n  margin-top: 40px;\n  margin-bottom: 32px;\n}\n.cancel {\n  line-height: 20px;\n  font-size: 14px;\n  width: 50px;\n  margin: auto;\n  color: #2C3E4F;\n  text-decoration: none;\n  box-shadow: inset 0 -1px 0 0 #00C8A0;\n  cursor: pointer;\n}\n.help {\n  margin-bottom: 1.5rem;\n}\n.helpList {\n  padding-left: 1.5rem;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"icon": "onfido-sdk-ui-crossDevice-MobileConnected-icon",
	"cancel": "onfido-sdk-ui-crossDevice-MobileConnected-cancel",
	"help": "onfido-sdk-ui-crossDevice-MobileConnected-help",
	"helpList": "onfido-sdk-ui-crossDevice-MobileConnected-helpList"
};

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-crossDevice-MobileNotificationSent-icon {\n  height: 9rem;\n  background-size: contain;\n  background-image: url(\"data:image/svg+xml,%3Csvg width%3D%22144%22 height%3D%22152%22 viewBox%3D%220 0 144 152%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%3Ctitle%3Emobile-notification-large%3C%2Ftitle%3E%3Cdefs%3E%3Crect id%3D%22a%22 width%3D%2272%22 height%3D%22120%22 rx%3D%228%22%2F%3E%3Ccircle id%3D%22b%22 cx%3D%2236%22 cy%3D%22106%22 r%3D%226%22%2F%3E%3C%2Fdefs%3E%3Cg fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E%3Ccircle fill%3D%22%2300C8A0%22 cx%3D%2272%22 cy%3D%2272%22 r%3D%2272%22%2F%3E%3Cg transform%3D%22translate(37 32)%22%3E%3Cuse fill%3D%22%23FFF%22 xlink%3Ahref%3D%22%23a%22%2F%3E%3Crect stroke%3D%22%232C3E4F%22 stroke-width%3D%224%22 x%3D%222%22 y%3D%222%22 width%3D%2268%22 height%3D%22116%22 rx%3D%228%22%2F%3E%3Cuse fill%3D%22%23FFF%22 xlink%3Ahref%3D%22%23b%22%2F%3E%3Ccircle stroke%3D%22%23283E4F%22 stroke-width%3D%222%22 cx%3D%2236%22 cy%3D%22106%22 r%3D%225%22%2F%3E%3Crect fill%3D%22%232C3E4F%22 x%3D%2222.5%22 y%3D%2210%22 width%3D%2227%22 height%3D%223%22 rx%3D%221.5%22%2F%3E%3C%2Fg%3E%3Cg transform%3D%22translate(106 20)%22 fill%3D%22%232C3E4F%22%3E%3Crect width%3D%223%22 height%3D%2210%22 rx%3D%221.5%22%2F%3E%3Cpath d%3D%22M13.0355339 4.4644661c.58578643.5857864.58578644 1.5355339 0 2.12132034L8.08578645 11.5355339c-.58578642.58578643-1.53553393.58578643-2.12132035 0-.58578644-.58578643-.58578643-1.53553392 0-2.12132034l4.94974746-4.94974747c.58578644-.58578644 1.5355339-.58578644 2.12132035 0z%22%2F%3E%3Crect x%3D%227%22 y%3D%2215%22 width%3D%2210%22 height%3D%223%22 rx%3D%221.5%22%2F%3E%3C%2Fg%3E%3Cpath d%3D%22M62.78144005 103h-3.720834C55.7212545 103 53 100.1711826 53 97V80.72641108C53 77.55522844 55.7212545 75 59.06060606 75H86.9393939C90.2787455 75 93 77.55522844 93 80.72641108V97c0 3.1711826-2.7212545 6-6.0606061 6H73.2301023l-13.74189365 7.8786773c-.75162775.4411065-1.59887846-.4086172-1.1335458-1.1368543L62.78144004 103z%22 fill%3D%22%232C3E4F%22 fill-rule%3D%22nonzero%22%2F%3E%3Cpath d%3D%22M72.5799999 101c.1268986-.0731884.272154 0 .4200001 0h13.6859504C89.0767193 101 91 99.1718721 91 97V80.94666707C91 78.77479495 89.0767193 77 86.6859504 77H59.3140496C56.9232807 77 55 78.77479495 55 80.94666707V97c0 2.1718721 1.9232807 4 4.3140496 4h5.1322314c.643229 0 1.0349087.4743129.6931079 1L61.5 108l11.0799999-7z%22 fill%3D%22%23FFF%22%2F%3E%3Cg%3E%3Cg transform%3D%22translate(65 81)%22%3E%3Ccircle fill%3D%22%2300C8A0%22 cx%3D%228%22 cy%3D%228%22 r%3D%228%22%2F%3E%3Cpath d%3D%22M10.7780591 5.01140806l-3.91172378 4.1509966-.97772776-1.03774915c-.43210745-.4568352-1.13269044-.4568352-1.56452697 0-.43210746.4596552-.43210746 1.20412743 0 1.66096265l1.7601267 1.86964045c.43210744.4596552 1.1324195.4596552 1.56452696 0l4.69385184-4.9828879c.4321074-.4596552.4321074-1.2041274 0-1.66096264-.4321075-.4596552-1.1324195-.4596552-1.564527 0z%22 fill%3D%22%23FFF%22%2F%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\n  margin-bottom: 2rem;\n}\n.onfido-sdk-ui-crossDevice-MobileNotificationSent-submessage {\n  margin-bottom: 0;\n}\n.onfido-sdk-ui-crossDevice-MobileNotificationSent-boldMessage {\n  margin-top: 0;\n  margin-bottom: 2rem;\n  font-weight: 600;\n}\n.onfido-sdk-ui-crossDevice-MobileNotificationSent-cancel {\n  line-height: 20px;\n  font-size: 14px;\n  width: 80px;\n  margin: auto;\n  color: #2C3E4F;\n  -webkit-box-shadow: inset 0 -1px 0 0 #00C8A0;\n          box-shadow: inset 0 -1px 0 0 #00C8A0;\n  cursor: pointer;\n  text-decoration: none;\n}\n.onfido-sdk-ui-crossDevice-MobileNotificationSent-help {\n  margin-bottom: 1.5rem;\n}\n.onfido-sdk-ui-crossDevice-MobileNotificationSent-helpList {\n  padding-left: 1.5rem;\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/crossDevice/MobileNotificationSent/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,yBAAA;EACA,s4FAAA;EACA,oBAAA;CCCD;ADED;EACE,iBAAA;CCAD;ADGD;EACE,cAAA;EACA,oBAAA;EACA,iBAAA;CCDD;ADID;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,6CAAA;UAAA,qCAAA;EACA,gBAAA;EACA,sBAAA;CCFD;ADKD;EACE,sBAAA;CCHD;ADMD;EACE,qBAAA;CCJD","file":"style.css","sourcesContent":[".icon {\n  height: 9rem;\n  background-size: contain;\n  background-image: url('assets/mobile-notification-large.svg');\n  margin-bottom: 2rem;\n}\n\n.submessage {\n  margin-bottom: 0;\n}\n\n.boldMessage {\n  margin-top: 0;\n  margin-bottom: 2rem;\n  font-weight: 600;\n}\n\n.cancel {\n  line-height: 20px;\n  font-size: 14px;\n  width: 80px;\n  margin: auto;\n  color: #2C3E4F;\n  box-shadow: inset 0 -1px 0 0 #00C8A0;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.help {\n  margin-bottom: 1.5rem;\n}\n\n.helpList {\n  padding-left: 1.5rem;\n}\n",".icon {\n  height: 9rem;\n  background-size: contain;\n  background-image: url('assets/mobile-notification-large.svg');\n  margin-bottom: 2rem;\n}\n.submessage {\n  margin-bottom: 0;\n}\n.boldMessage {\n  margin-top: 0;\n  margin-bottom: 2rem;\n  font-weight: 600;\n}\n.cancel {\n  line-height: 20px;\n  font-size: 14px;\n  width: 80px;\n  margin: auto;\n  color: #2C3E4F;\n  box-shadow: inset 0 -1px 0 0 #00C8A0;\n  cursor: pointer;\n  text-decoration: none;\n}\n.help {\n  margin-bottom: 1.5rem;\n}\n.helpList {\n  padding-left: 1.5rem;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"icon": "onfido-sdk-ui-crossDevice-MobileNotificationSent-icon",
	"submessage": "onfido-sdk-ui-crossDevice-MobileNotificationSent-submessage",
	"boldMessage": "onfido-sdk-ui-crossDevice-MobileNotificationSent-boldMessage",
	"cancel": "onfido-sdk-ui-crossDevice-MobileNotificationSent-cancel",
	"help": "onfido-sdk-ui-crossDevice-MobileNotificationSent-help",
	"helpList": "onfido-sdk-ui-crossDevice-MobileNotificationSent-helpList"
};

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-crossDevice-SwitchDevice-container {\n  height: 96px;\n  width: 100%;\n  border: 1px solid #2C3E4F;\n  border-radius: 4px;\n  background-color: #FFFFFF;\n  margin-bottom: 1rem;\n  padding: 12px 14px;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n.onfido-sdk-ui-crossDevice-SwitchDevice-switchClickableArea {\n  text-decoration: none;\n}\n.onfido-sdk-ui-crossDevice-SwitchDevice-copy {\n  width: 84%;\n  color: #2C3E4F;\n  font-size: 16px;\n  text-align: left;\n  line-height: 24px;\n  float: left;\n  -ms-flex-item-align: center;\n      align-self: center;\n}\n.onfido-sdk-ui-crossDevice-SwitchDevice-header {\n  font-weight: 600;\n}\n.onfido-sdk-ui-crossDevice-SwitchDevice-submessage {\n  margin: 0px;\n  font-size: 14px;\n  float: left;\n}\n.onfido-sdk-ui-crossDevice-SwitchDevice-icon {\n  height: 72px;\n  width: 72px;\n  min-width: 16%;\n  margin-right: 14px;\n  border-radius: 72px 72px;\n  background-color: #00C8A0;\n  background-image: url(\"data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22 standalone%3D%22no%22%3F%3E%3Csvg width%3D%2242px%22 height%3D%2248px%22 viewBox%3D%220 0 42 48%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 46.2 (44496) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3Ecross-device-small-icon%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E        %3Crect id%3D%22path-1%22 x%3D%220%22 y%3D%220%22 width%3D%2228%22 height%3D%2248%22 rx%3D%224%22%3E%3C%2Frect%3E        %3Ccircle id%3D%22path-2%22 cx%3D%2214%22 cy%3D%2243%22 r%3D%222%22%3E%3C%2Fcircle%3E        %3Cpath d%3D%22M2%2C-1.82839905e-15 L30%2C1.10433735e-14 L30%2C1.24344979e-14 C31.1045695%2C1.02694822e-14 32%2C0.8954305 32%2C2 L32%2C18 L32%2C18 C32%2C19.1045695 31.1045695%2C20 30%2C20 L2%2C20 L2%2C20 C0.8954305%2C20 1.3527075e-16%2C19.1045695 0%2C18 L0%2C2 L-1.11022302e-15%2C2 C-1.24549377e-15%2C0.8954305 0.8954305%2C-3.34980755e-15 2%2C-3.55271368e-15 Z%22 id%3D%22path-3%22%3E%3C%2Fpath%3E    %3C%2Fdefs%3E    %3Cg id%3D%22Symbols%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22icons%2Fcross-device%2Fmobile-use%22 transform%3D%22translate(-8.000000%2C -12.000000)%22%3E            %3Cg id%3D%22cross-device-small-icon%22 transform%3D%22translate(7.000000%2C 12.000000)%22%3E                %3Cg id%3D%22icons%2Fmobile%2Fsmall%22 transform%3D%22translate(15.000000%2C 0.000000)%22%3E                    %3Cg id%3D%22mobile%22 transform%3D%22translate(-0.000000%2C 0.000000)%22%3E                        %3Cg id%3D%22Rectangle-5%22%3E                            %3Cuse fill%3D%22%23FFFFFF%22 fill-rule%3D%22evenodd%22 xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E                            %3Crect stroke%3D%22%232C3E4F%22 stroke-width%3D%222%22 x%3D%221%22 y%3D%221%22 width%3D%2226%22 height%3D%2246%22 rx%3D%224%22%3E%3C%2Frect%3E                        %3C%2Fg%3E                        %3Crect id%3D%22Rectangle-4%22 fill%3D%22%232C3E4F%22 x%3D%229%22 y%3D%224%22 width%3D%2210%22 height%3D%221%22 rx%3D%220.5%22%3E%3C%2Frect%3E                        %3Cg id%3D%22Oval%22%3E                            %3Cuse fill%3D%22%23FFFFFF%22 fill-rule%3D%22evenodd%22 xlink%3Ahref%3D%22%23path-2%22%3E%3C%2Fuse%3E                            %3Ccircle stroke%3D%22%232C3E4F%22 stroke-width%3D%221%22 cx%3D%2214%22 cy%3D%2243%22 r%3D%221.5%22%3E%3C%2Fcircle%3E                        %3C%2Fg%3E                    %3C%2Fg%3E                %3C%2Fg%3E                %3Cg id%3D%22id-card%22 transform%3D%22translate(19.368684%2C 23.901745) rotate(-15.000000) translate(-19.368684%2C -23.901745) translate(2.868684%2C 12.901745)%22%3E                    %3Cg id%3D%22icons%2Fid-card%22 transform%3D%22translate(0.211657%2C 0.817780)%22%3E                        %3Cg id%3D%22id-card%22 transform%3D%22translate(0.000000%2C 1.000000)%22%3E                            %3Cg id%3D%22container%22%3E                                %3Cuse fill%3D%22%23FFFFFF%22 fill-rule%3D%22evenodd%22 xlink%3Ahref%3D%22%23path-3%22%3E%3C%2Fuse%3E                                %3Cpath stroke%3D%22%23283E4F%22 stroke-width%3D%221%22 d%3D%22M2%2C0.5 C1.17157288%2C0.5 0.5%2C1.17157288 0.5%2C2 L0.5%2C18 C0.5%2C18.8284271 1.17157288%2C19.5 2%2C19.5 L30%2C19.5 C30.8284271%2C19.5 31.5%2C18.8284271 31.5%2C18 L31.5%2C2 C31.5%2C1.17157288 30.8284271%2C0.5 30%2C0.5 L2%2C0.5 Z%22%3E%3C%2Fpath%3E                            %3C%2Fg%3E                            %3Cg id%3D%22inset%22 transform%3D%22translate(16.000000%2C 5.000000)%22 fill%3D%22%23283E4F%22%3E                                %3Crect id%3D%22Rectangle%22 x%3D%220%22 y%3D%226%22 width%3D%2213%22 height%3D%221%22 rx%3D%220.5%22%3E%3C%2Frect%3E                                %3Crect id%3D%22Rectangle-Copy%22 x%3D%223%22 y%3D%223%22 width%3D%2210%22 height%3D%221%22 rx%3D%220.5%22%3E%3C%2Frect%3E                                %3Crect id%3D%22Rectangle-Copy-2%22 x%3D%225%22 y%3D%220%22 width%3D%222%22 height%3D%221%22 rx%3D%220.5%22%3E%3C%2Frect%3E                                %3Crect id%3D%22Rectangle-Copy-3%22 x%3D%228%22 y%3D%220%22 width%3D%222%22 height%3D%221%22 rx%3D%220.5%22%3E%3C%2Frect%3E                                %3Crect id%3D%22Rectangle-Copy-4%22 x%3D%2211%22 y%3D%220%22 width%3D%222%22 height%3D%221%22 rx%3D%220.5%22%3E%3C%2Frect%3E                            %3C%2Fg%3E                            %3Cg id%3D%22body%22 transform%3D%22translate(2.000000%2C 14.000000)%22 stroke%3D%22%23283E4F%22 stroke-width%3D%221.20000005%22%3E                                %3Cpath d%3D%22M11.0742251%2C4.39999998 C9.88650623%2C2.03104807 7.99453539%2C0.600000024 5.97080049%2C0.600000024 C4.02201232%2C0.600000024 2.15032108%2C2.04925975 0.938564144%2C4.39999998 L11.0742251%2C4.39999998 Z%22 id%3D%22Oval-2%22%3E%3C%2Fpath%3E                            %3C%2Fg%3E                            %3Cg id%3D%22face%22 transform%3D%22translate(2.617647%2C 1.400000)%22 stroke%3D%22%23283E4F%22%3E                                %3Cpath d%3D%22M5.38235294%2C11.1 C7.72845912%2C11.1 9.88235294%2C8.4522511 9.88235294%2C5.73333333 C9.88235294%2C3.17151192 7.86464652%2C1.1 5.38235294%2C1.1 C3.73158637%2C1.1 2.23679347%2C2.02311952 1.44722596%2C3.48395069 C1.07860412%2C4.16596237 0.882352941%2C4.93436589 0.882352941%2C5.73333333 C0.882352941%2C8.4522511 3.03624677%2C11.1 5.38235294%2C11.1 Z%22 id%3D%22Oval%22%3E%3C%2Fpath%3E                            %3C%2Fg%3E                        %3C%2Fg%3E                    %3C%2Fg%3E                %3C%2Fg%3E                %3Crect id%3D%22mobile-left-frame%22 fill%3D%22%23283E4F%22 x%3D%2215%22 y%3D%2212%22 width%3D%222%22 height%3D%2231%22%3E%3C%2Frect%3E                %3Crect id%3D%22overlay%22 fill-opacity%3D%220.670000017%22 fill%3D%22%23FFFFFF%22 x%3D%2217%22 y%3D%2210%22 width%3D%2224%22 height%3D%2227%22%3E%3C%2Frect%3E                %3Crect id%3D%22mobile-screen-frame%22 stroke%3D%22%23FFFFFF%22 x%3D%2217.5%22 y%3D%2210.5%22 width%3D%2223%22 height%3D%2226%22%3E%3C%2Frect%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E\");\n  background-repeat: no-repeat;\n  background-position: 25% 50%;\n  display: block;\n  float: left;\n}\n.onfido-sdk-ui-crossDevice-SwitchDevice-chevron {\n  height: 12px;\n  width: 9px;\n  float: right;\n  margin-left: 14px;\n  margin: auto;\n  background-image: url(\"data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22 standalone%3D%22no%22%3F%3E%3Csvg width%3D%228px%22 height%3D%2212px%22 viewBox%3D%220 0 8 12%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 46.2 (44496) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3Echevron-right%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Symbols%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22icons%2Fchevron%2Fright-black%22 transform%3D%22translate(-13.000000%2C -10.000000)%22 fill%3D%22%232C3E4F%22%3E            %3Cpath d%3D%22M21.188823%2C12.3318342 L17.0002498%2C17.262704 L12.811177%2C12.3318342 C12.3970653%2C11.8893886 11.7246956%2C11.8893886 11.3105838%2C12.3318342 C10.8964721%2C12.7742798 10.8964721%2C13.4939203 11.3105838%2C13.9363659 L16.1835155%2C19.6721669 C16.4078052%2C19.912047 16.7070247%2C20.0186604 17.0002498%2C19.9973377 C17.2934749%2C20.0186604 17.5921948%2C19.912047 17.8164845%2C19.6721669 L22.6894162%2C13.9363659 C23.1035279%2C13.4939203 23.1035279%2C12.7742798 22.6894162%2C12.3318342 C22.2753044%2C11.8893886 21.6029347%2C11.8893886 21.188823%2C12.3318342 Z%22 id%3D%22chevron-right%22 transform%3D%22translate(17.000000%2C 16.000000) rotate(-90.000000) translate(-17.000000%2C -16.000000) %22%3E%3C%2Fpath%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E\");\n  background-repeat: no-repeat;\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/crossDevice/SwitchDevice/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;EACA,0BAAA;EACA,mBAAA;EACA,0BAAA;EACA,oBAAA;EACA,mBAAA;EACA,4BAAA;EAAA,4BAAA;EAAA,qBAAA;CCCD;ADED;EACE,sBAAA;CCAD;ADGD;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,4BAAA;MAAA,mBAAA;CCDD;ADID;EACE,iBAAA;CCFD;ADKD;EACE,YAAA;EACA,gBAAA;EACA,YAAA;CCHD;ADMD;EACE,aAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EAGA,yBAAA;EACA,0BAAA;EACA,+oMAAA;EACA,6BAAA;EACA,6BAAA;EACA,eAAA;EACA,YAAA;CCJD;ADOD;EACE,aAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,oiDAAA;EACA,6BAAA;CCLD","file":"style.css","sourcesContent":[".container {\n  height: 96px;\n  width: 100%;\n  border: 1px solid #2C3E4F;\n  border-radius: 4px;\n  background-color: #FFFFFF;\n  margin-bottom: 1rem;\n  padding: 12px 14px;\n  display: inline-flex;\n}\n\n.switchClickableArea {\n  text-decoration: none;\n}\n\n.copy {\n  width: 84%;\n  color: #2C3E4F;\n  font-size: 16px;\n  text-align: left;\n  line-height: 24px;\n  float: left;\n  align-self: center;\n}\n\n.header {\n  font-weight: 600;\n}\n\n.submessage {\n  margin: 0px;\n  font-size: 14px;\n  float: left;\n}\n\n.icon {\n  height: 72px;\n  width: 72px;\n  min-width: 16%;\n  margin-right: 14px;\n  -moz-border-radius: 72px 72px;\n  -webkit-border-radius: 72px 72px;\n  border-radius: 72px 72px;\n  background-color: #00C8A0;\n  background-image: url('assets/cross-device-small-icon.svg');\n  background-repeat: no-repeat;\n  background-position: 25% 50%;\n  display: block;\n  float: left;\n}\n\n.chevron {\n  height: 12px;\n  width: 9px;\n  float: right;\n  margin-left: 14px;\n  margin: auto;\n  background-image: url('assets/chevron-right.svg');\n  background-repeat: no-repeat;\n}\n",".container {\n  height: 96px;\n  width: 100%;\n  border: 1px solid #2C3E4F;\n  border-radius: 4px;\n  background-color: #FFFFFF;\n  margin-bottom: 1rem;\n  padding: 12px 14px;\n  display: inline-flex;\n}\n.switchClickableArea {\n  text-decoration: none;\n}\n.copy {\n  width: 84%;\n  color: #2C3E4F;\n  font-size: 16px;\n  text-align: left;\n  line-height: 24px;\n  float: left;\n  align-self: center;\n}\n.header {\n  font-weight: 600;\n}\n.submessage {\n  margin: 0px;\n  font-size: 14px;\n  float: left;\n}\n.icon {\n  height: 72px;\n  width: 72px;\n  min-width: 16%;\n  margin-right: 14px;\n  -moz-border-radius: 72px 72px;\n  -webkit-border-radius: 72px 72px;\n  border-radius: 72px 72px;\n  background-color: #00C8A0;\n  background-image: url('assets/cross-device-small-icon.svg');\n  background-repeat: no-repeat;\n  background-position: 25% 50%;\n  display: block;\n  float: left;\n}\n.chevron {\n  height: 12px;\n  width: 9px;\n  float: right;\n  margin-left: 14px;\n  margin: auto;\n  background-image: url('assets/chevron-right.svg');\n  background-repeat: no-repeat;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "onfido-sdk-ui-crossDevice-SwitchDevice-container",
	"switchClickableArea": "onfido-sdk-ui-crossDevice-SwitchDevice-switchClickableArea",
	"copy": "onfido-sdk-ui-crossDevice-SwitchDevice-copy",
	"header": "onfido-sdk-ui-crossDevice-SwitchDevice-header",
	"submessage": "onfido-sdk-ui-crossDevice-SwitchDevice-submessage",
	"icon": "onfido-sdk-ui-crossDevice-SwitchDevice-icon",
	"chevron": "onfido-sdk-ui-crossDevice-SwitchDevice-chevron"
};

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-Liveness-absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.onfido-sdk-ui-Liveness-challenge {\n  line-height: 36px;\n}\n.onfido-sdk-ui-Liveness-challengeTitle {\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 24px;\n}\n.onfido-sdk-ui-Liveness-introCopy {\n  margin-bottom: auto;\n}\n.onfido-sdk-ui-Liveness-introBullets {\n  text-align: left;\n  padding-left: 40px;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Liveness-introBullets {\n    padding-left: 0;\n  }\n}\n.onfido-sdk-ui-Liveness-introBullet {\n  padding-left: 46px;\n  margin-bottom: 24px;\n  list-style: none;\n  position: relative;\n}\n.onfido-sdk-ui-Liveness-bolder {\n  font-weight: 600;\n}\n.onfido-sdk-ui-Liveness-introIcon {\n  display: block;\n  position: absolute;\n  left: 0;\n  top: 0;\n  background-repeat: no-repeat;\n  width: 26px;\n  height: 26px;\n}\n.onfido-sdk-ui-Liveness-speak_out_loudIcon {\n  background-image: url(\"data:image/svg+xml,%3Csvg width%3D%2224%22 height%3D%2224%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E%3Cpath d%3D%22M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12%22 fill%3D%22%2300c8a0%22%2F%3E%3Cpath d%3D%22M12 15c1.656 0 3-1.376 3-3.074V6.074C15 4.376 13.656 3 12 3S9 4.376 9 6.074v5.852C9 13.624 10.344 15 12 15%22 fill%3D%22%23FEFEFE%22%2F%3E%3Cpath d%3D%22M16.277 12c0 2.594-1.914 4.695-4.277 4.695-2.363 0-4.277-2.101-4.277-4.695H6c0 3.281 2.189 5.994 5.05 6.494V22h1.9v-3.506C15.81 17.994 18 15.281 18 12h-1.723z%22 fill%3D%22%23FEFEFE%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\n}\n.onfido-sdk-ui-Liveness-two_actionsIcon {\n  background-image: url(\"data:image/svg+xml,%3Csvg width%3D%2227%22 height%3D%2227%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%3Cdefs%3E%3Cpath id%3D%22a%22 d%3D%22M.03 0H26.62v26.592H.029z%22%2F%3E%3C%2Fdefs%3E%3Cg fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E%3Cmask id%3D%22b%22 fill%3D%22%23fff%22%3E%3Cuse xlink%3Ahref%3D%22%23a%22%2F%3E%3C%2Fmask%3E%3Cpath d%3D%22M25 14c0 6.627-5.373 12-12 12S1 20.627 1 14 6.373 2 13 2s12 5.373 12 12%22 fill%3D%22%2300c8a0%22 mask%3D%22url(%23b)%22%2F%3E%3Cpath d%3D%22M21.358 10.334l-3.62 3.191c-.507.446-.507 1.172 0 1.618l3.62 3.19v-8zM16 17.367c0 .749-.552 1.356-1.234 1.356H6.234c-.682 0-1.234-.607-1.234-1.356V10.08c0-.749.552-1.357 1.234-1.357h8.532c.682 0 1.234.608 1.234 1.357v7.287z%22 fill%3D%22%23FEFEFE%22 mask%3D%22url(%23b)%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\");\n}\n.onfido-sdk-ui-Liveness-movement {\n  background-image: url(\"data:image/svg+xml,%3Csvg width%3D%2265%22 height%3D%2221%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath fill%3D%22%23FEFEFE%22 d%3D%22M54.288 0l-1.381 1.38L60.76 9.23H0v1.952h60.782l-7.851 7.851 1.38 1.38 10.195-10.196-1.379-1.379z%22 fill-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E\");\n  display: inline-block;\n  width: 65px;\n  height: 21px;\n  margin-top: 16px;\n}\n.onfido-sdk-ui-Liveness-movement-turnLeft {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n.onfido-sdk-ui-Liveness-recite {\n  display: block;\n  font-size: 54px;\n  font-weight: 600;\n  line-height: 64px;\n  margin-top: 8px;\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Theme/constants.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Liveness/style.css"],"names":[],"mappings":"AAMA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;CCFD;ACRD;EACE,kBAAA;CDUD;ACPD;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;CDSD;ACND;EACE,oBAAA;CDQD;ACLD;EACE,iBAAA;EACA,mBAAA;CDOD;ACLC;EAqDF;IApDI,gBAAA;GDQD;CACF;ACLD;EACE,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;CDOD;ACJD;EACE,iBAAA;CDMD;ACHD;EACE,eAAA;EACA,mBAAA;EACA,QAAA;EACA,OAAA;EACA,6BAAA;EACA,YAAA;EACA,aAAA;CDKD;ACFD;EACE,irBAAA;CDID;ACDD;EACE,u3BAAA;CDGD;ACAD;EACE,kUAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;CDED;ACCD;EACE,kCAAA;UAAA,0BAAA;CDCD;ACED;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;CDAD","file":"style.css","sourcesContent":["@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n@large-text-margin: 40px;\n@small-text-margin: 24px;\n\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.width-parent-relative(@base-width,@parent-width) {\n  width: 100%*(@base-width/@parent-width)\n}\n","@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.challenge {\n  line-height: 36px;\n}\n.challengeTitle {\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 24px;\n}\n.introCopy {\n  margin-bottom: auto;\n}\n.introBullets {\n  text-align: left;\n  padding-left: 40px;\n}\n@media (--small-viewport) {\n  .introBullets {\n    padding-left: 0;\n  }\n}\n.introBullet {\n  padding-left: 46px;\n  margin-bottom: 24px;\n  list-style: none;\n  position: relative;\n}\n.bolder {\n  font-weight: 600;\n}\n.introIcon {\n  display: block;\n  position: absolute;\n  left: 0;\n  top: 0;\n  background-repeat: no-repeat;\n  width: 26px;\n  height: 26px;\n}\n.speak_out_loudIcon {\n  background-image: url('assets/mic.svg');\n}\n.two_actionsIcon {\n  background-image: url('assets/camera.svg');\n}\n.movement {\n  background-image: url('assets/move-arrow.svg');\n  display: inline-block;\n  width: 65px;\n  height: 21px;\n  margin-top: 16px;\n}\n.movement-turnLeft {\n  transform: rotate(180deg);\n}\n.recite {\n  display: block;\n  font-size: 54px;\n  font-weight: 600;\n  line-height: 64px;\n  margin-top: 8px;\n}\n","@import (less) \"../Theme/constants.css\";\n\n.challenge {\n  line-height: 36px;\n}\n\n.challengeTitle {\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 24px;\n}\n\n.introCopy {\n  margin-bottom: auto;\n}\n\n.introBullets {\n  text-align: left;\n  padding-left: 40px;\n\n  @media (--small-viewport) {\n    padding-left: 0;\n  }\n}\n\n.introBullet {\n  padding-left: 46px;\n  margin-bottom: 24px;\n  list-style: none;\n  position: relative;\n}\n\n.bolder {\n  font-weight: 600;\n}\n\n.introIcon {\n  display: block;\n  position: absolute;\n  left: 0;\n  top: 0;\n  background-repeat: no-repeat;\n  width: 26px;\n  height: 26px;\n}\n\n.speak_out_loudIcon {\n  background-image: url('assets/mic.svg');\n}\n\n.two_actionsIcon {\n  background-image: url('assets/camera.svg');\n}\n\n.movement {\n  background-image: url('assets/move-arrow.svg');\n  display: inline-block;\n  width: 65px;\n  height: 21px;\n  margin-top: 16px;\n}\n\n.movement-turnLeft {\n  transform: rotate(180deg);\n}\n\n.recite {\n  display: block;\n  font-size: 54px;\n  font-weight: 600;\n  line-height: 64px;\n  margin-top: 8px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"absolute-center": "onfido-sdk-ui-Liveness-absolute-center",
	"challenge": "onfido-sdk-ui-Liveness-challenge",
	"challengeTitle": "onfido-sdk-ui-Liveness-challengeTitle",
	"introCopy": "onfido-sdk-ui-Liveness-introCopy",
	"introBullets": "onfido-sdk-ui-Liveness-introBullets",
	"introBullet": "onfido-sdk-ui-Liveness-introBullet",
	"bolder": "onfido-sdk-ui-Liveness-bolder",
	"introIcon": "onfido-sdk-ui-Liveness-introIcon",
	"speak_out_loudIcon": "onfido-sdk-ui-Liveness-speak_out_loudIcon",
	"two_actionsIcon": "onfido-sdk-ui-Liveness-two_actionsIcon",
	"movement": "onfido-sdk-ui-Liveness-movement",
	"movement-turnLeft": "onfido-sdk-ui-Liveness-movement-turnLeft",
	"recite": "onfido-sdk-ui-Liveness-recite"
};

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-Modal-absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.onfido-sdk-ui-Modal-portal > * {\n  opacity: 0;\n}\n.onfido-sdk-ui-Modal-modalBody {\n  /*! Just a placeholder no namespace this element using css modules*/\n}\n.onfido-sdk-ui-Modal-overlay {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  -webkit-transition: opacity 200ms, z-index 0s 200ms;\n  transition: opacity 200ms, z-index 0s 200ms;\n}\n.onfido-sdk-ui-Modal-overlay--after-open {\n  opacity: 1;\n}\n.onfido-sdk-ui-Modal-overlay--before-close {\n  opacity: 0;\n}\n.onfido-sdk-ui-Modal-inner {\n  /* Relative positioning so overflow affects absolute children */\n  position: relative;\n  overflow: auto;\n  margin: auto;\n  width: 94vw;\n  max-width: 32rem;\n  height: 600px;\n  text-align: center;\n  max-height: calc(100% + 4px);\n  border-radius: 8px;\n  font-family: \"Open Sans\", sans-serif !important;\n  background-color: #f3f3f4;\n  color: #585E5F;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Modal-inner {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    border-radius: 0px;\n  }\n}\n.onfido-sdk-ui-Modal-inner,\n.onfido-sdk-ui-Modal-inner *,\n.onfido-sdk-ui-Modal-inner *:before,\n.onfido-sdk-ui-Modal-inner *:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.onfido-sdk-ui-Modal-portal .onfido-sdk-ui-Modal-inner {\n  margin: auto;\n  z-index: -1;\n  opacity: 0;\n  -webkit-transform: scale(0);\n          transform: scale(0);\n  -webkit-transition: opacity 200ms, z-index 0s 200ms, -webkit-transform 200ms;\n  transition: opacity 200ms, z-index 0s 200ms, -webkit-transform 200ms;\n  transition: opacity 200ms, transform 200ms, z-index 0s 200ms;\n  transition: opacity 200ms, transform 200ms, z-index 0s 200ms, -webkit-transform 200ms;\n}\n.onfido-sdk-ui-Modal-overlay--after-open .onfido-sdk-ui-Modal-inner {\n  z-index: 100;\n  opacity: 1;\n  -webkit-transform: scale(1);\n          transform: scale(1);\n  -webkit-transition: opacity 200ms, -webkit-transform 200ms;\n  transition: opacity 200ms, -webkit-transform 200ms;\n  transition: opacity 200ms, transform 200ms;\n  transition: opacity 200ms, transform 200ms, -webkit-transform 200ms;\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Theme/constants.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Modal/style.css"],"names":[],"mappings":"AAMA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;CCFD;ACRD;EAGE,WAAA;CDQD;ACLD;EDOE,oEAAoE;CACrE;ACFD;EACE,qBAAA;EAAA,qBAAA;EAAA,cAAA;EACA,gBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EAEA,qCAAA;EACA,oDAAA;EAAA,4CAAA;CDID;ACFC;EACE,WAAA;CDIH;ACFC;EACE,WAAA;CDIH;ACAD;EDEE,gEAAgE;ECAhE,mBAAA;EACA,eAAA;EACA,aAAA;EAEA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EAEA,gDAAA;EACA,0BAAA;EAEA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;CDDD;ACGC;EA0BF;IAzBI,YAAA;IACA,aAAA;IACA,mBAAA;IACA,mBAAA;GDAD;CACF;ACEC;;;;EACE,+BAAA;UAAA,uBAAA;CDGH;ACAC;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,4BAAA;UAAA,oBAAA;EACA,6EAAA;EAAA,qEAAA;EAAA,6DAAA;EAAA,sFAAA;CDEH;ACCC;EACE,aAAA;EACA,WAAA;EACA,4BAAA;UAAA,oBAAA;EACA,2DAAA;EAAA,mDAAA;EAAA,2CAAA;EAAA,oEAAA;CDCH","file":"style.css","sourcesContent":["@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n@large-text-margin: 40px;\n@small-text-margin: 24px;\n\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.width-parent-relative(@base-width,@parent-width) {\n  width: 100%*(@base-width/@parent-width)\n}\n","@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.portal > * {\n  opacity: 0;\n}\n.modalBody {\n  /*! Just a placeholder no namespace this element using css modules*/\n}\n@value modal_animation_duration: 200ms;\n.overlay {\n  display: flex;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  transition: opacity modal_animation_duration, z-index 0s modal_animation_duration;\n}\n.overlay--after-open {\n  opacity: 1;\n}\n.overlay--before-close {\n  opacity: 0;\n}\n.inner {\n  /* Relative positioning so overflow affects absolute children */\n  position: relative;\n  overflow: auto;\n  margin: auto;\n  width: 94vw;\n  max-width: 32rem;\n  height: 600px;\n  text-align: center;\n  max-height: calc(100% + 4px);\n  border-radius: 8px;\n  font-family: \"Open Sans\", sans-serif !important;\n  background-color: #f3f3f4;\n  color: #585E5F;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n}\n@media (--small-viewport) {\n  .inner {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    border-radius: 0px;\n  }\n}\n.inner,\n.inner *,\n.inner *:before,\n.inner *:after {\n  box-sizing: border-box;\n}\n.portal .inner {\n  margin: auto;\n  z-index: -1;\n  opacity: 0;\n  transform: scale(0);\n  transition: opacity modal_animation_duration, transform modal_animation_duration, z-index 0s modal_animation_duration;\n}\n.overlay--after-open .inner {\n  z-index: 100;\n  opacity: 1;\n  transform: scale(1);\n  transition: opacity modal_animation_duration, transform modal_animation_duration;\n}\n","@import (less) \"../Theme/constants.css\";\n\n.portal > * {\n  // When the modal is closed, overlay div has no css class\n  // This selector should be overridden by the `&--after-open` class below\n  opacity: 0;\n}\n\n.modalBody {\n  /*! Just a placeholder no namespace this element using css modules*/\n}\n\n@value modal_animation_duration: 200ms;\n\n.overlay {\n  display: flex;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n\n  background-color: rgba(0, 0, 0, 0.6);\n  transition: opacity modal_animation_duration, z-index 0s modal_animation_duration;\n\n  &--after-open {\n    opacity: 1;\n  }\n  &--before-close {\n    opacity: 0;\n  }\n}\n\n.inner {\n  /* Relative positioning so overflow affects absolute children */\n  position: relative;\n  overflow: auto;\n  margin: auto;\n\n  width: 94vw;\n  max-width: 32rem;\n  height: 600px;\n  text-align: center;\n  max-height: ~\"calc(100% + 4px)\";\n  border-radius: 8px;\n\n  font-family: \"Open Sans\", sans-serif !important;\n  background-color: #f3f3f4;\n\n  color: #585E5F;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n\n  @media (--small-viewport) {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    border-radius: 0px;\n  }\n\n  &, *, *:before, *:after {\n    box-sizing: border-box;\n  }\n\n  .portal & {\n    margin: auto;\n    z-index: -1;\n    opacity: 0;\n    transform: scale(0);\n    transition: opacity modal_animation_duration, transform modal_animation_duration, z-index 0s modal_animation_duration;\n  }\n\n  .overlay--after-open & {\n    z-index: 100;\n    opacity: 1;\n    transform: scale(1);\n    transition: opacity modal_animation_duration, transform modal_animation_duration;\n  }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"modal_animation_duration": "200ms",
	"absolute-center": "onfido-sdk-ui-Modal-absolute-center",
	"portal": "onfido-sdk-ui-Modal-portal",
	"modalBody": "onfido-sdk-ui-Modal-modalBody",
	"overlay": "onfido-sdk-ui-Modal-overlay",
	"overlay--after-open": "onfido-sdk-ui-Modal-overlay--after-open",
	"overlay--before-close": "onfido-sdk-ui-Modal-overlay--before-close",
	"inner": "onfido-sdk-ui-Modal-inner"
};

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-Spinner-absolute-center,\n.onfido-sdk-ui-Spinner-loader {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.onfido-sdk-ui-Spinner-loader {\n  width: 48px;\n  height: 48px;\n}\n@-webkit-keyframes onfido-sdk-ui-Spinner-ball-scale-ripple-multiple {\n  0% {\n    -webkit-transform: scale(0.1);\n            transform: scale(0.1);\n    opacity: 1;\n  }\n  70% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 0.0;\n  }\n}\n@keyframes onfido-sdk-ui-Spinner-ball-scale-ripple-multiple {\n  0% {\n    -webkit-transform: scale(0.1);\n            transform: scale(0.1);\n    opacity: 1;\n  }\n  70% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 0.0;\n  }\n}\n.onfido-sdk-ui-Spinner-inner {\n  position: relative;\n  -webkit-transform: translateX(25px);\n          transform: translateX(25px);\n}\n.onfido-sdk-ui-Spinner-inner > div:nth-child(0) {\n  -webkit-animation-delay: -0.8s;\n          animation-delay: -0.8s;\n}\n.onfido-sdk-ui-Spinner-inner > div:nth-child(1) {\n  -webkit-animation-delay: -0.6s;\n          animation-delay: -0.6s;\n}\n.onfido-sdk-ui-Spinner-inner > div:nth-child(2) {\n  -webkit-animation-delay: -0.4s;\n          animation-delay: -0.4s;\n}\n.onfido-sdk-ui-Spinner-inner > div:nth-child(3) {\n  -webkit-animation-delay: -0.2s;\n          animation-delay: -0.2s;\n}\n.onfido-sdk-ui-Spinner-inner > div {\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  position: absolute;\n  top: -2px;\n  left: -26px;\n  width: 50px;\n  height: 50px;\n  border-radius: 100%;\n  border: 2px solid #ccc;\n  -webkit-animation: onfido-sdk-ui-Spinner-ball-scale-ripple-multiple 1.25s 0s infinite cubic-bezier(0.21, 0.53, 0.56, 0.8);\n          animation: onfido-sdk-ui-Spinner-ball-scale-ripple-multiple 1.25s 0s infinite cubic-bezier(0.21, 0.53, 0.56, 0.8);\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Theme/constants.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Spinner/style.css"],"names":[],"mappings":"AAMA;;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;CCDD;ACTD;EACE,YAAA;EACA,aAAA;CDWD;ACPD;EACE;IACE,8BAAA;YAAA,sBAAA;IACA,WAAA;GDSD;ECPD;IACE,4BAAA;YAAA,oBAAA;IACA,aAAA;GDSD;ECPD;IACE,aAAA;GDSD;CACF;ACpBD;EACE;IACE,8BAAA;YAAA,sBAAA;IACA,WAAA;GDSD;ECPD;IACE,4BAAA;YAAA,oBAAA;IACA,aAAA;GDSD;ECPD;IACE,aAAA;GDSD;CACF;ACND;EACE,mBAAA;EACA,oCAAA;UAAA,4BAAA;CDQD;ACNC;EACE,+BAAA;UAAA,uBAAA;CDQH;ACLC;EACE,+BAAA;UAAA,uBAAA;CDOH;ACJC;EACE,+BAAA;UAAA,uBAAA;CDMH;ACHC;EACE,+BAAA;UAAA,uBAAA;CDKH;ACFC;EACE,kCAAA;UAAA,0BAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,uBAAA;EACA,0HAAA;UAAA,kHAAA;CDIH","file":"style.css","sourcesContent":["@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n@large-text-margin: 40px;\n@small-text-margin: 24px;\n\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.width-parent-relative(@base-width,@parent-width) {\n  width: 100%*(@base-width/@parent-width)\n}\n","@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n.absolute-center,\n.loader {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.loader {\n  width: 48px;\n  height: 48px;\n}\n@keyframes ball-scale-ripple-multiple {\n  0% {\n    transform: scale(0.1);\n    opacity: 1;\n  }\n  70% {\n    transform: scale(1);\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 0.0;\n  }\n}\n.inner {\n  position: relative;\n  transform: translateX(25px);\n}\n.inner > div:nth-child(0) {\n  animation-delay: -0.8s;\n}\n.inner > div:nth-child(1) {\n  animation-delay: -0.6s;\n}\n.inner > div:nth-child(2) {\n  animation-delay: -0.4s;\n}\n.inner > div:nth-child(3) {\n  animation-delay: -0.2s;\n}\n.inner > div {\n  animation-fill-mode: both;\n  position: absolute;\n  top: -2px;\n  left: -26px;\n  width: 50px;\n  height: 50px;\n  border-radius: 100%;\n  border: 2px solid #ccc;\n  animation: ball-scale-ripple-multiple 1.25s 0s infinite cubic-bezier(0.21, 0.53, 0.56, 0.8);\n}\n","@import (less) \"../Theme/constants.css\";\n\n.loader {\n  width: 48px;\n  height: 48px;\n  &:extend(.absolute-center);\n}\n\n@keyframes ball-scale-ripple-multiple {\n  0% {\n    transform: scale(0.1);\n    opacity: 1;\n  }\n  70% {\n    transform: scale(1);\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 0.0;\n  }\n}\n\n.inner {\n  position: relative;\n  transform: translateX(25px);\n\n  & > div:nth-child(0) {\n    animation-delay: -0.8s;\n  }\n\n  & > div:nth-child(1) {\n    animation-delay: -0.6s;\n  }\n\n  & > div:nth-child(2) {\n    animation-delay: -0.4s;\n  }\n\n  & > div:nth-child(3) {\n    animation-delay: -0.2s;\n  }\n\n  & > div {\n    animation-fill-mode: both;\n    position: absolute;\n    top: -2px;\n    left: -26px;\n    width: 50px;\n    height: 50px;\n    border-radius: 100%;\n    border: 2px solid #ccc;\n    animation: ball-scale-ripple-multiple 1.25s 0s infinite cubic-bezier(0.21, 0.53, 0.56, 0.8);\n  }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"absolute-center": "onfido-sdk-ui-Spinner-absolute-center",
	"loader": "onfido-sdk-ui-Spinner-loader",
	"inner": "onfido-sdk-ui-Spinner-inner",
	"ball-scale-ripple-multiple": "onfido-sdk-ui-Spinner-ball-scale-ripple-multiple"
};

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-Theme-absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.onfido-sdk-ui-Theme-step {\n  width: 100%;\n  min-height: 100%;\n  height: 0;\n  /*necessary for IE11, see: https://stackoverflow.com/questions/24396205/flex-grow-not-working-in-internet-explorer-11-0*/\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.onfido-sdk-ui-Theme-fullScreenStep {\n  overflow: hidden;\n  border-radius: 8px;\n}\n.onfido-sdk-ui-Theme-fullHeightContainer {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Theme-fullHeightMobileContainer {\n    width: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n  }\n}\n.onfido-sdk-ui-Theme-navigationBar {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 auto;\n          flex: 0 0 auto;\n}\n.onfido-sdk-ui-Theme-content {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 0 auto;\n          flex: 1 0 auto;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.onfido-sdk-ui-Theme-content > * {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}\n.onfido-sdk-ui-Theme-fullScreenContentWrapper {\n  position: static;\n}\n.onfido-sdk-ui-Theme-footer {\n  width: 100%;\n  height: 48px;\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 auto;\n          flex: 0 0 auto;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 width%3D%2299%22 height%3D%2216%22 viewBox%3D%220 0 99 16%22%3E  %3Cpath d%3D%22M66.658 11.219c1.658 0 3.054-1.198 3.054-3.026 0-1.827-1.396-2.988-3.054-2.988-1.646 0-3.03 1.16-3.03 2.988s1.384 3.026 3.03 3.026zm15.993-5.89h-2.678v-.532c0-.728.187-1.383 1.035-1.383h.636V2.192h-.636c-1.596 0-2.331 1.025-2.331 2.605v.531h-1.06v1.05h1.06v4.717h1.296V6.378h2.678v4.717h1.272V5.328h-1.272zm-15.96 4.7c-.96 0-1.757-.703-1.757-1.79 0-1.062.798-1.741 1.758-1.741.972 0 1.77.68 1.77 1.741 0 1.087-.798 1.79-1.77 1.79zm5.699-1.99c0-1.136.735-1.544 1.496-1.544.748 0 1.221.519 1.221 1.433v3.21h1.285V7.78c0-1.63-.81-2.532-2.22-2.532-.648 0-1.446.321-1.782.988v-.864h-1.285v5.767h1.285v-3.1zm10.037-5.236c0 .457.399.802.86.802.474 0 .848-.345.848-.802 0-.457-.374-.803-.848-.803-.461 0-.86.346-.86.803zm7.795 8.292h1.272V2.192h-1.272v3.964c-.361-.63-1.147-.951-1.97-.951-1.57 0-2.904 1.16-2.904 3.013 0 1.815 1.334 3 2.904 3 .798 0 1.609-.345 1.97-.962v.84zm-.025-2.902c0 1.124-.835 1.79-1.783 1.79-.972 0-1.745-.728-1.745-1.79s.773-1.753 1.745-1.753c.873 0 1.783.617 1.783 1.753zm8.8 0c0-1.827-1.397-2.988-3.055-2.988-1.646 0-3.03 1.16-3.03 2.988s1.384 3.026 3.03 3.026c1.658 0 3.054-1.198 3.054-3.026zM56.688 5.32a4.375 4.375 0 0 0-3.291-1.482c-2.412 0-4.368 1.937-4.368 4.327 0 2.389 1.956 4.326 4.368 4.326 2.412 0 4.367-1.937 4.367-4.326 0-.077-.002-.112-.002-.112a.309.309 0 0 1 .08-.201l1.394-1.38c.047-.047.1-.033.118.03a6.07 6.07 0 0 1 .239 1.686c0 3.376-2.764 6.113-6.172 6.113-3.409 0-6.172-2.737-6.172-6.113 0-3.376 2.763-6.113 6.172-6.113 1.798 0 3.417.762 4.545 1.979l1.559-1.544a.327.327 0 0 1 .201-.082h1.9c.262 0 .324.149.138.333l-8.21 8.131a.238.238 0 0 1-.335.001l-2.325-2.185a.322.322 0 0 1-.084-.201V6.625c0-.26.15-.322.335-.138l2.157 2.019a.12.12 0 0 0 .167 0L56.69 5.32zm39.253 4.665c-.96 0-1.758-.704-1.758-1.79 0-1.063.798-1.742 1.758-1.742.972 0 1.77.68 1.77 1.741 0 1.087-.798 1.79-1.77 1.79zm-91.867-4.2c0 .65-.222 1.15-.666 1.5-.444.351-1.079.526-1.905.526H.747v2.527H0V3.913h1.666c1.605 0 2.408.624 2.408 1.872zM.747 7.17h.672c.663 0 1.142-.106 1.437-.32.296-.214.444-.557.444-1.029 0-.424-.139-.74-.417-.949-.279-.208-.712-.312-1.301-.312H.747v2.61zm8.404.756c0 .785-.198 1.398-.593 1.84-.396.44-.942.66-1.64.66-.43 0-.813-.1-1.147-.302a2.001 2.001 0 0 1-.773-.87c-.182-.378-.272-.82-.272-1.328 0-.785.196-1.396.588-1.834.393-.438.938-.657 1.635-.657.674 0 1.21.224 1.606.672.397.448.596 1.055.596 1.82zm-3.67 0c0 .616.123 1.084.37 1.407.246.322.607.483 1.085.483s.84-.16 1.088-.481c.247-.321.371-.79.371-1.409 0-.612-.124-1.077-.371-1.395-.248-.318-.613-.477-1.097-.477-.477 0-.838.157-1.08.47-.244.314-.366.781-.366 1.402zm8.387 2.413l-.884-2.826c-.055-.173-.16-.565-.312-1.178h-.035c-.117.513-.22.909-.308 1.187l-.91 2.817h-.843L9.262 5.52h.765l.71 2.765c.162.632.255 1.059.279 1.278h.035c.032-.167.084-.383.156-.648.071-.265.134-.475.186-.63l.884-2.765h.79l.862 2.765c.164.504.275.927.334 1.27h.035c.012-.106.043-.268.095-.488.051-.22.356-1.402.916-3.547h.756l-1.332 4.817h-.865zm4.787.088c-.712 0-1.274-.217-1.686-.65-.411-.434-.617-1.036-.617-1.807 0-.776.191-1.393.573-1.85.383-.457.896-.685 1.54-.685.604 0 1.082.198 1.433.595.352.397.528.92.528 1.571v.462h-3.318c.014.565.157.994.428 1.287.271.293.653.44 1.145.44a3.88 3.88 0 0 0 1.538-.326v.65a3.86 3.86 0 0 1-.732.24c-.23.049-.507.073-.832.073zm-.198-4.382c-.387 0-.695.126-.925.378-.23.252-.366.6-.407 1.046h2.518c0-.46-.102-.812-.307-1.057-.205-.244-.498-.367-.88-.367zm5.095-.61c.213 0 .405.017.575.052l-.1.677a2.485 2.485 0 0 0-.528-.066c-.39 0-.723.158-1 .475-.277.316-.415.71-.415 1.182v2.584h-.73V5.52h.602l.084.893h.035c.179-.314.394-.556.646-.726.252-.17.529-.254.83-.254zm3.016 4.992c-.712 0-1.274-.217-1.686-.65-.411-.434-.617-1.036-.617-1.807 0-.776.191-1.393.573-1.85.383-.457.896-.685 1.54-.685.604 0 1.082.198 1.433.595.352.397.528.92.528 1.571v.462H25.02c.014.565.157.994.428 1.287.271.293.653.44 1.145.44a3.88 3.88 0 0 0 1.538-.326v.65a3.86 3.86 0 0 1-.732.24c-.23.049-.507.073-.832.073zm-.198-4.382c-.387 0-.695.126-.925.378-.23.252-.366.6-.407 1.046h2.518c0-.46-.102-.812-.307-1.057-.205-.244-.498-.367-.88-.367zm6.176 3.648h-.04c-.337.49-.84.734-1.512.734-.63 0-1.12-.216-1.47-.646-.35-.43-.525-1.043-.525-1.837s.176-1.41.528-1.85c.351-.44.84-.66 1.467-.66.654 0 1.155.238 1.503.713h.057l-.03-.348-.018-.338V3.5h.73v6.838h-.594l-.096-.646zm-1.46.123c.499 0 .86-.136 1.084-.407.224-.27.336-.708.336-1.311v-.154c0-.683-.114-1.17-.34-1.461-.228-.292-.59-.438-1.088-.438-.428 0-.755.167-.982.5-.227.332-.341.801-.341 1.408 0 .615.113 1.08.338 1.393.226.313.557.47.994.47zm7.645-4.373c.633 0 1.125.216 1.475.649.35.432.525 1.043.525 1.834 0 .791-.177 1.406-.53 1.844-.353.438-.843.657-1.47.657-.313 0-.6-.058-.859-.174a1.616 1.616 0 0 1-.652-.534h-.053l-.154.62h-.523V3.5h.73v1.661c0 .372-.012.706-.035 1.002h.035c.34-.48.843-.72 1.511-.72zm-.105.611c-.498 0-.857.143-1.077.429-.22.285-.33.767-.33 1.443 0 .677.114 1.161.34 1.453.225.291.587.437 1.085.437.448 0 .782-.163 1.002-.49.22-.327.33-.796.33-1.408 0-.627-.11-1.095-.33-1.402-.22-.308-.56-.462-1.02-.462zm2.12-.532h.782l1.054 2.747c.232.627.375 1.08.431 1.358h.035c.038-.15.118-.405.24-.767.121-.362.52-1.474 1.193-3.338h.782l-2.07 5.485c-.205.542-.444.926-.718 1.153-.274.227-.61.341-1.009.341-.222 0-.442-.025-.659-.075v-.584c.161.035.341.053.54.053.502 0 .859-.282 1.073-.844l.268-.686-1.942-4.843z%22 fill%3D%22%238B9094%22 fill-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E\");\n  background-position: 50% 50%;\n  background-repeat: no-repeat;\n  z-index: 1;\n  /* hide the footer if view height is too small */\n}\n@media (max-height: 420px) {\n  .onfido-sdk-ui-Theme-footer {\n    z-index: -1;\n  }\n}\n.onfido-sdk-ui-Theme-thickWrapper {\n  margin: 0rem 40px;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Theme-thickWrapper {\n    margin: 0rem 24px;\n  }\n}\n.onfido-sdk-ui-Theme-imageWrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 300px;\n  min-height: 100px;\n  margin: auto 3rem;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Theme-imageWrapper {\n    margin: 0rem 24px;\n  }\n}\n.onfido-sdk-ui-Theme-mbottom-large {\n  margin-bottom: 5.5rem;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Theme-mbottom-large {\n    margin-bottom: 2.5rem;\n  }\n}\n.onfido-sdk-ui-Theme-btn {\n  height: 56px;\n  font: inherit;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: inherit;\n  text-decoration: none;\n  text-align: center;\n  cursor: pointer;\n  display: inline-block;\n  border: none;\n  border-radius: 2rem;\n  padding: 0;\n  outline: none;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Theme-btn {\n    padding: 1.2rem 2rem;\n  }\n}\n.onfido-sdk-ui-Theme-btn-centered {\n  margin: auto;\n}\n.onfido-sdk-ui-Theme-btn-primary {\n  /*layout*/\n  display: block;\n  width: 216px;\n  border-radius: 28px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 16px;\n  border: none;\n  background: #00C8A0;\n  /*text*/\n  color: #fff;\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Theme-btn-primary {\n    width: 100%;\n  }\n}\n.onfido-sdk-ui-Theme-btn-alternative {\n  background-color: rgba(15, 37, 54, 0.85);\n  border-radius: 4px;\n  color: #fff;\n  font-weight: 600;\n  height: auto;\n  line-height: 1.4;\n  padding: .8em 1.4em;\n}\n.onfido-sdk-ui-Theme-btn-ghost {\n  background-color: transparent;\n  border: 1px solid #fff;\n  color: #fff;\n}\n.onfido-sdk-ui-Theme-btn-outline {\n  border: 1px solid #8A9293;\n  border-radius: 28px;\n  background-color: transparent;\n  color: #585E5F;\n  line-height: 16px;\n  padding: 1.2rem 2rem;\n}\n.onfido-sdk-ui-Theme-center {\n  text-align: center;\n}\n.onfido-sdk-ui-Theme-icon {\n  display: block;\n  background-repeat: no-repeat;\n  background-position: center;\n  height: 4rem;\n}\n.onfido-sdk-ui-Theme-actions {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: .75rem 1.5rem 0 1.5rem;\n}\n@media (min-width: 480px) {\n  .onfido-sdk-ui-Theme-actions {\n    padding: 1.5em 3rem 0 3rem;\n  }\n}\n@media (max-width: 479px) {\n  .onfido-sdk-ui-Theme-actions .onfido-sdk-ui-Theme-btn-primary {\n    width: 152px;\n  }\n}\n.onfido-sdk-ui-Theme-help {\n  padding: 1.5rem 1rem 1rem;\n  text-align: left;\n  -webkit-box-shadow: inset 0 0 0px 1px rgba(138, 146, 147, 0.35);\n          box-shadow: inset 0 0 0px 1px rgba(138, 146, 147, 0.35);\n  border-radius: 8px;\n}\n.onfido-sdk-ui-Theme-header {\n  border-radius: 12px;\n  background-color: #5D6B78;\n  color: #FFFFFF;\n  font-size: 14px;\n  font-weight: 600;\n  position: absolute;\n  margin-top: -12px;\n  margin-left: 12px;\n  padding: 0rem 1rem;\n}\n.onfido-sdk-ui-Theme-helpList {\n  margin: 0rem;\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Theme/constants.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/Theme/style.css"],"names":[],"mappings":"AAMA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;CCFD;ACRD;EACE,YAAA;EACA,iBAAA;EACA,UAAA;EDUA,yHAAyH;ECTzH,mBAAA;EACA,qBAAA;EAAA,qBAAA;EAAA,cAAA;EACA,6BAAA;EAAA,8BAAA;MAAA,2BAAA;UAAA,uBAAA;CDWD;ACPD;EACE,iBAAA;EACA,mBAAA;CDSD;ACND;EACE,YAAA;EACA,qBAAA;EAAA,qBAAA;EAAA,cAAA;EACA,6BAAA;EAAA,8BAAA;MAAA,2BAAA;UAAA,uBAAA;EACA,0BAAA;MAAA,uBAAA;UAAA,+BAAA;CDQD;ACJC;EAmLF;IA1LE,YAAA;IACA,qBAAA;IAAA,qBAAA;IAAA,cAAA;IACA,6BAAA;IAAA,8BAAA;QAAA,2BAAA;YAAA,uBAAA;IACA,0BAAA;QAAA,uBAAA;YAAA,+BAAA;GDeC;CACF;ACPD;EACE,oBAAA;MAAA,mBAAA;UAAA,eAAA;CDSD;ACND;EACE,oBAAA;MAAA,mBAAA;UAAA,eAAA;EACA,mBAAA;EACA,qBAAA;EAAA,qBAAA;EAAA,cAAA;CDQD;ACXD;EAKI,oBAAA;MAAA,qBAAA;UAAA,aAAA;CDSH;ACLD;EACE,iBAAA;CDOD;ACJD;EACE,YAAA;EACA,aAAA;EACA,oBAAA;MAAA,mBAAA;UAAA,eAAA;EAEA,y5KAAA;EACA,6BAAA;EACA,6BAAA;EACA,WAAA;EDKA,iDAAiD;CAClD;ACJC;EAmJF;IAlJI,YAAA;GDOD;CACF;ACJD;EACE,kBAAA;CDMD;ACLC;EA4IF;IA3II,kBAAA;GDQD;CACF;ACLD;EACE,qBAAA;EAAA,qBAAA;EAAA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;CDOD;ACNC;EAkIF;IAjII,kBAAA;GDSD;CACF;ACND;EACE,sBAAA;CDQD;ACPC;EA2HF;IA1HI,sBAAA;GDUD;CACF;ACPD;EACE,aAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,mBAAA;EACA,gBAAA;EAEA,sBAAA;EACA,aAAA;EACA,oBAAA;EACA,WAAA;EACA,cAAA;CDOD;ACNC;EAsGF;IArGI,qBAAA;GDSD;CACF;ACND;EACE,aAAA;CDQD;ACLD;EDOE,UAAU;ECLV,eAAA;EACA,aAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EAIA,aAAA;EAEA,oBAAA;EDGA,QAAQ;ECAR,YAAA;CDED;ACVC;EAqFF;IApFI,YAAA;GDaD;CACF;ACJD;EACE,yCAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;CDMD;ACHD;EACE,8BAAA;EACA,uBAAA;EACA,YAAA;CDKD;ACFD;EACE,0BAAA;EACA,oBAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;CDID;ACDD;EACE,mBAAA;CDGD;ACAD;EACE,eAAA;EACA,6BAAA;EACA,4BAAA;EACA,aAAA;CDED;ACCD;EACE,YAAA;EACA,qBAAA;EAAA,qBAAA;EAAA,cAAA;EACA,0BAAA;MAAA,uBAAA;UAAA,+BAAA;EACA,gCAAA;CDCD;ACAC;EAiCF;IAhCI,2BAAA;GDGD;CACF;ACCC;EA2BF;IA1BI,aAAA;GDED;CACF;ACCD;EACE,0BAAA;EACA,iBAAA;EACA,gEAAA;UAAA,wDAAA;EACA,mBAAA;CDCD;ACED;EACE,oBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;CDAD;ACGD;EACE,aAAA;CDDD","file":"style.css","sourcesContent":["@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n@large-text-margin: 40px;\n@small-text-margin: 24px;\n\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.width-parent-relative(@base-width,@parent-width) {\n  width: 100%*(@base-width/@parent-width)\n}\n","@custom-media --large (min-width: 480px);\n@custom-media --small-viewport (max-width: 479px);\n@custom-media --smaller-viewport (max-width: 359px);\n.absolute-center {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.step {\n  width: 100%;\n  min-height: 100%;\n  height: 0;\n  /*necessary for IE11, see: https://stackoverflow.com/questions/24396205/flex-grow-not-working-in-internet-explorer-11-0*/\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n.fullScreenStep {\n  overflow: hidden;\n  border-radius: 8px;\n}\n.fullHeightContainer {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n@media (--small-viewport) {\n  .fullHeightMobileContainer {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n}\n.navigationBar {\n  flex: 0 0 auto;\n}\n.content {\n  flex: 1 0 auto;\n  position: relative;\n  display: flex;\n}\n.content > * {\n  flex-grow: 1;\n}\n.fullScreenContentWrapper {\n  position: static;\n}\n.footer {\n  width: 100%;\n  height: 48px;\n  flex: 0 0 auto;\n  background-image: url('assets/powered-by-onfido.svg');\n  background-position: 50% 50%;\n  background-repeat: no-repeat;\n  z-index: 1;\n  /* hide the footer if view height is too small */\n}\n@media (max-height: 420px) {\n  .footer {\n    z-index: -1;\n  }\n}\n.thickWrapper {\n  margin: 0rem 40px;\n}\n@media (--small-viewport) {\n  .thickWrapper {\n    margin: 0rem 24px;\n  }\n}\n.imageWrapper {\n  display: flex;\n  height: 300px;\n  min-height: 100px;\n  margin: auto 3rem;\n}\n@media (--small-viewport) {\n  .imageWrapper {\n    margin: 0rem 24px;\n  }\n}\n.mbottom-large {\n  margin-bottom: 5.5rem;\n}\n@media (--small-viewport) {\n  .mbottom-large {\n    margin-bottom: 2.5rem;\n  }\n}\n.btn {\n  height: 56px;\n  font: inherit;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: inherit;\n  text-decoration: none;\n  text-align: center;\n  cursor: pointer;\n  display: inline-block;\n  border: none;\n  border-radius: 2rem;\n  padding: 0;\n  outline: none;\n}\n@media (--small-viewport) {\n  .btn {\n    padding: 1.2rem 2rem;\n  }\n}\n.btn-centered {\n  margin: auto;\n}\n.btn-primary {\n  /*layout*/\n  display: block;\n  width: 216px;\n  border-radius: 28px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 16px;\n  border: none;\n  background: #00C8A0;\n  /*text*/\n  color: #fff;\n}\n@media (--small-viewport) {\n  .btn-primary {\n    width: 100%;\n  }\n}\n.btn-alternative {\n  background-color: rgba(15, 37, 54, 0.85);\n  border-radius: 4px;\n  color: #fff;\n  font-weight: 600;\n  height: auto;\n  line-height: 1.4;\n  padding: .8em 1.4em;\n}\n.btn-ghost {\n  background-color: transparent;\n  border: 1px solid #fff;\n  color: #fff;\n}\n.btn-outline {\n  border: 1px solid #8A9293;\n  border-radius: 28px;\n  background-color: transparent;\n  color: #585E5F;\n  line-height: 16px;\n  padding: 1.2rem 2rem;\n}\n.center {\n  text-align: center;\n}\n.icon {\n  display: block;\n  background-repeat: no-repeat;\n  background-position: center;\n  height: 4rem;\n}\n.actions {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  padding: .75rem 1.5rem 0 1.5rem;\n}\n@media (--large) {\n  .actions {\n    padding: 1.5em 3rem 0 3rem;\n  }\n}\n@media (--small-viewport) {\n  .actions .btn-primary {\n    width: 152px;\n  }\n}\n.help {\n  padding: 1.5rem 1rem 1rem;\n  text-align: left;\n  box-shadow: inset 0 0 0px 1px rgba(138, 146, 147, 0.35);\n  border-radius: 8px;\n}\n.header {\n  border-radius: 12px;\n  background-color: #5D6B78;\n  color: #FFFFFF;\n  font-size: 14px;\n  font-weight: 600;\n  position: absolute;\n  margin-top: -12px;\n  margin-left: 12px;\n  padding: 0rem 1rem;\n}\n.helpList {\n  margin: 0rem;\n}\n","@import (less) \"./constants.css\";\n\n.step {\n  width: 100%;\n  min-height: 100%;\n  height: 0;/*necessary for IE11, see: https://stackoverflow.com/questions/24396205/flex-grow-not-working-in-internet-explorer-11-0*/\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n\n.fullScreenStep {\n  overflow: hidden;\n  border-radius: 8px;\n}\n\n.fullHeightContainer {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.fullHeightMobileContainer {\n  @media (--small-viewport) {\n    .fullHeightContainer();\n  }\n}\n\n.navigationBar{\n  flex: 0 0 auto;\n}\n\n.content {\n  flex: 1 0 auto;\n  position: relative;\n  display: flex;\n  > * {\n    flex-grow: 1;\n  }\n}\n\n.fullScreenContentWrapper {\n  position: static;\n}\n\n.footer {\n  width: 100%;\n  height: 48px;\n  flex: 0 0 auto;\n\n  background-image: url('assets/powered-by-onfido.svg');\n  background-position: 50% 50%;\n  background-repeat: no-repeat;\n  z-index: 1;\n  /* hide the footer if view height is too small */\n  @media (max-height: 420px) {\n    z-index: -1;\n  }\n}\n\n.thickWrapper {\n  margin: 0rem @large-text-margin;\n  @media (--small-viewport) {\n    margin: 0rem @small-text-margin;\n  }\n}\n\n.imageWrapper {\n  display: flex;\n  height: 300px;\n  min-height: 100px;\n  margin: auto 3rem;\n  @media (--small-viewport) {\n    margin: 0rem @small-text-margin;\n  }\n}\n\n.mbottom-large {\n  margin-bottom: 5.5rem;\n  @media (--small-viewport) {\n    margin-bottom: 2.5rem;\n  }\n}\n\n.btn {\n  height: 56px;\n  font: inherit;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: inherit;\n\n  text-decoration: none;\n  text-align: center;\n  cursor: pointer;\n\n  display: inline-block;\n  border: none;\n  border-radius: 2rem;\n  padding: 0;\n  outline: none;\n  @media (--small-viewport) {\n    padding: 1.2rem 2rem;\n  }\n}\n\n.btn-centered {\n  margin: auto;\n}\n\n.btn-primary {\n  /*layout*/\n  display: block;\n  width: 216px;\n  border-radius: 28px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 16px;\n  @media (--small-viewport) {\n    width: 100%;\n  }\n  border: none;\n\n  background: #00C8A0;\n\n  /*text*/\n  color: #fff;\n}\n\n.btn-alternative {\n  background-color: rgba(15, 37, 54, 0.85);\n  border-radius: 4px;\n  color: #fff;\n  font-weight: 600;\n  height: auto;\n  line-height: 1.4;\n  padding: .8em 1.4em;\n}\n\n.btn-ghost {\n  background-color: transparent;\n  border: 1px solid #fff;\n  color: #fff;\n}\n\n.btn-outline {\n  border: 1px solid #8A9293;\n  border-radius: 28px;\n  background-color: transparent;\n  color: #585E5F;\n  line-height: 16px;\n  padding: 1.2rem 2rem;\n}\n\n.center {\n  text-align: center;\n}\n\n.icon {\n  display: block;\n  background-repeat: no-repeat;\n  background-position: center;\n  height: 4rem;\n}\n\n.actions {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  padding: .75rem 1.5rem 0 1.5rem;\n  @media (--large) {\n    padding: 1.5em 3rem 0 3rem;\n  }\n}\n\n.actions .btn-primary {\n  @media (--small-viewport) {\n    width: 152px;\n  }\n}\n\n.help {\n  padding: 1.5rem 1rem 1rem;;\n  text-align: left;\n  box-shadow: inset 0 0 0px 1px rgba(138,146,147,0.35);\n  border-radius: 8px;\n}\n\n.header {\n  border-radius: 12px;\n  background-color: #5D6B78;\n  color: #FFFFFF;\n  font-size: 14px;\n  font-weight: 600;\n  position: absolute;\n  margin-top: -12px;\n  margin-left: 12px;;\n  padding: 0rem 1rem;\n}\n\n.helpList {\n  margin: 0rem;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"absolute-center": "onfido-sdk-ui-Theme-absolute-center",
	"step": "onfido-sdk-ui-Theme-step",
	"fullScreenStep": "onfido-sdk-ui-Theme-fullScreenStep",
	"fullHeightContainer": "onfido-sdk-ui-Theme-fullHeightContainer",
	"fullHeightMobileContainer": "onfido-sdk-ui-Theme-fullHeightMobileContainer",
	"navigationBar": "onfido-sdk-ui-Theme-navigationBar",
	"content": "onfido-sdk-ui-Theme-content",
	"fullScreenContentWrapper": "onfido-sdk-ui-Theme-fullScreenContentWrapper",
	"footer": "onfido-sdk-ui-Theme-footer",
	"thickWrapper": "onfido-sdk-ui-Theme-thickWrapper",
	"imageWrapper": "onfido-sdk-ui-Theme-imageWrapper",
	"mbottom-large": "onfido-sdk-ui-Theme-mbottom-large",
	"btn": "onfido-sdk-ui-Theme-btn",
	"btn-centered": "onfido-sdk-ui-Theme-btn-centered",
	"btn-primary": "onfido-sdk-ui-Theme-btn-primary",
	"btn-alternative": "onfido-sdk-ui-Theme-btn-alternative",
	"btn-ghost": "onfido-sdk-ui-Theme-btn-ghost",
	"btn-outline": "onfido-sdk-ui-Theme-btn-outline",
	"center": "onfido-sdk-ui-Theme-center",
	"icon": "onfido-sdk-ui-Theme-icon",
	"actions": "onfido-sdk-ui-Theme-actions",
	"help": "onfido-sdk-ui-Theme-help",
	"header": "onfido-sdk-ui-Theme-header",
	"helpList": "onfido-sdk-ui-Theme-helpList"
};

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(true);
// imports


// module
exports.push([module.i, ".onfido-sdk-ui-crossDevice-GenericError-icon {\n  height: 144px;\n  background-size: contain;\n  background-image: url(\"data:image/svg+xml,%3Csvg width%3D%22144%22 height%3D%22144%22 viewBox%3D%220 0 144 144%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E  %3Ctitle%3E    connection-error-large  %3C%2Ftitle%3E  %3Cdefs%3E    %3Crect id%3D%22a%22 width%3D%2296%22 height%3D%2264%22 rx%3D%228%22%2F%3E    %3Crect id%3D%22b%22 width%3D%2248%22 height%3D%2280%22 rx%3D%228%22%2F%3E    %3Ccircle id%3D%22c%22 cx%3D%2224%22 cy%3D%2269%22 r%3D%225%22%2F%3E  %3C%2Fdefs%3E  %3Cg fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E    %3Ccircle fill%3D%22%23E2E3E5%22 cx%3D%2272%22 cy%3D%2272%22 r%3D%2272%22%2F%3E    %3Cg transform%3D%22translate(46 35)%22%3E      %3Cuse fill%3D%22%23FFF%22 xlink%3Ahref%3D%22%23a%22%2F%3E      %3Crect stroke%3D%22%232C3E4F%22 stroke-width%3D%224%22 x%3D%222%22 y%3D%222%22 width%3D%2292%22 height%3D%2260%22 rx%3D%228%22%2F%3E      %3Crect fill%3D%22%232C3E4F%22 x%3D%2224%22 y%3D%2272%22 width%3D%2248%22 height%3D%224%22 rx%3D%222%22%2F%3E      %3Cpath d%3D%22M25 54h46c.552 0 1 .448 1 1s-.448 1-1 1H25c-.552 0-1-.448-1-1s.448-1 1-1z%22 fill%3D%22%232C3E4F%22%2F%3E      %3Crect fill%3D%22%232C3E4F%22 x%3D%2246%22 y%3D%2260%22 width%3D%224%22 height%3D%2216%22 rx%3D%222%22%2F%3E    %3C%2Fg%3E    %3Cg transform%3D%22translate(14 53)%22%3E      %3Cuse fill%3D%22%23FFF%22 xlink%3Ahref%3D%22%23b%22%2F%3E      %3Crect stroke%3D%22%232C3E4F%22 stroke-width%3D%224%22 x%3D%222%22 y%3D%222%22 width%3D%2244%22 height%3D%2276%22 rx%3D%228%22%2F%3E      %3Cuse fill%3D%22%23FFF%22 xlink%3Ahref%3D%22%23c%22%2F%3E      %3Ccircle stroke%3D%22%23283E4F%22 stroke-width%3D%222%22 cx%3D%2224%22 cy%3D%2269%22 r%3D%224%22%2F%3E      %3Crect fill%3D%22%232C3E4F%22 x%3D%2215%22 y%3D%228%22 width%3D%2218%22 height%3D%222%22 rx%3D%221%22%2F%3E    %3C%2Fg%3E    %3Cpath d%3D%22M51 19c0-1.1.9-2 2.02-2 1.1 0 1.98.9 1.98 2s-.88 2-1.98 2C51.9 21 51 20.1 51 19m8 0c0-1.1.9-2 2-2 1.12 0 2 .9 2 2s-.88 2-2 2c-1.1 0-2-.9-2-2m8 0c0-1.1.88-2 1.98-2 1.12 0 2.02.9 2.02 2s-.9 2-2.02 2c-1.1 0-1.98-.9-1.98-2m8 0c0-1.1.9-2 2-2 1.12 0 2 .9 2 2s-.88 2-2 2c-1.1 0-2-.9-2-2m8 0c0-1.1.9-2 2.02-2 1.1 0 1.98.9 1.98 2s-.88 2-1.98 2C83.9 21 83 20.1 83 19m8 0c0-1.1.9-2 2-2 1.12 0 2 .9 2 2s-.88 2-2 2c-1.1 0-2-.9-2-2m-47.98.142c-.02-.04-.02-.1-.02-.16.02-1.018.82-1.897 1.88-1.977 1.1-.08 2.04.76 2.12 1.858v.16c0 1.038-.8 1.897-1.84 1.977h-.14c-1.06 0-1.94-.8-2-1.858M98.398 23.2C98.14 22.84 98 22.42 98 22c0-.6.28-1.202.8-1.602.88-.66 2.14-.48 2.8.4.28.36.4.78.4 1.2 0 .62-.28 1.222-.8 1.602-.36.28-.78.4-1.2.4-.602 0-1.2-.28-1.602-.8M38.04 24.76c-.66-.36-1.04-1.063-1.04-1.764 0-.32.08-.66.24-.962.54-.962 1.74-1.323 2.72-.782.66.36 1.04 1.042 1.04 1.764 0 .32-.08.64-.24.942h-.02C40.38 24.638 39.7 25 39 25c-.32 0-.66-.08-.96-.24M100 30c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2m-64 1c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2m0 8c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2m0 8c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2%22 fill%3D%22%232C3E4F%22%2F%3E    %3Cg transform%3D%22translate(56 6)%22%3E      %3Ccircle fill%3D%22%23FF5457%22 cx%3D%2212%22 cy%3D%2212%22 r%3D%2212%22%2F%3E      %3Cpath d%3D%22M9.914 12l-3.482 3.48c-.576.578-.576 1.51 0 2.088.577.576 1.51.576 2.087 0L12 14.086l3.48 3.482c.578.576 1.51.576 2.088 0 .576-.577.576-1.51 0-2.087L14.086 12l3.482-3.48c.576-.578.576-1.51 0-2.088-.577-.576-1.51-.576-2.087 0L12 9.914 8.52 6.432c-.578-.576-1.51-.576-2.088 0-.576.577-.576 1.51 0 2.087L9.914 12z%22 fill%3D%22%23FFF%22%2F%3E    %3C%2Fg%3E  %3C%2Fg%3E%3C%2Fsvg%3E\");\n  margin-top: 56px;\n  margin-bottom: 192px;\n}\n", "", {"version":3,"sources":["/Users/stefania/Projects/onfido/onfido-sdk-ui/src/components/crossDevice/GenericError/style.css","/Users/stefania/Projects/onfido/onfido-sdk-ui/style.css"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,yBAAA;EACA,w9GAAA;EACA,iBAAA;EACA,qBAAA;CCCD","file":"style.css","sourcesContent":[".icon {\n  height: 144px;\n  background-size: contain;\n  background-image: url('assets/connection-error-large.svg');\n  margin-top: 56px;\n  margin-bottom: 192px;\n}\n",".icon {\n  height: 144px;\n  background-size: contain;\n  background-image: url('assets/connection-error-large.svg');\n  margin-top: 56px;\n  margin-bottom: 192px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"icon": "onfido-sdk-ui-crossDevice-GenericError-icon"
};

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(393);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 340 */
/***/ (function(module, exports) {

module.exports = function(opts) {
  return new ElementClass(opts)
}

function indexOf(arr, prop) {
  if (arr.indexOf) return arr.indexOf(prop)
  for (var i = 0, len = arr.length; i < len; i++)
    if (arr[i] === prop) return i
  return -1
}

function ElementClass(opts) {
  if (!(this instanceof ElementClass)) return new ElementClass(opts)
  var self = this
  if (!opts) opts = {}

  // similar doing instanceof HTMLElement but works in IE8
  if (opts.nodeType) opts = {el: opts}

  this.opts = opts
  this.el = opts.el || document.body
  if (typeof this.el !== 'object') this.el = document.querySelector(this.el)
}

ElementClass.prototype.add = function(className) {
  var el = this.el
  if (!el) return
  if (el.className === "") return el.className = className
  var classes = el.className.split(' ')
  if (indexOf(classes, className) > -1) return classes
  classes.push(className)
  el.className = classes.join(' ')
  return classes
}

ElementClass.prototype.remove = function(className) {
  var el = this.el
  if (!el) return
  if (el.className === "") return
  var classes = el.className.split(' ')
  var idx = indexOf(classes, className)
  if (idx > -1) classes.splice(idx, 1)
  el.className = classes.join(' ')
  return classes
}

ElementClass.prototype.has = function(className) {
  var el = this.el
  if (!el) return
  var classes = el.className.split(' ')
  return indexOf(classes, className) > -1
}

ElementClass.prototype.toggle = function(className) {
  var el = this.el
  if (!el) return
  if (this.has(className)) this.remove(className)
  else this.add(className)
}


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {


module.exports = __webpack_require__(342);

/**
 * Exports parser
 *
 * @api public
 *
 */
module.exports.parser = __webpack_require__(38);


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Module dependencies.
 */

var transports = __webpack_require__(139);
var Emitter = __webpack_require__(34);
var debug = __webpack_require__(22)('engine.io-client:socket');
var index = __webpack_require__(144);
var parser = __webpack_require__(38);
var parseuri = __webpack_require__(158);
var parseqs = __webpack_require__(68);

/**
 * Module exports.
 */

module.exports = Socket;

/**
 * Socket constructor.
 *
 * @param {String|Object} uri or options
 * @param {Object} options
 * @api public
 */

function Socket (uri, opts) {
  if (!(this instanceof Socket)) return new Socket(uri, opts);

  opts = opts || {};

  if (uri && 'object' === typeof uri) {
    opts = uri;
    uri = null;
  }

  if (uri) {
    uri = parseuri(uri);
    opts.hostname = uri.host;
    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
    opts.port = uri.port;
    if (uri.query) opts.query = uri.query;
  } else if (opts.host) {
    opts.hostname = parseuri(opts.host).host;
  }

  this.secure = null != opts.secure ? opts.secure
    : (global.location && 'https:' === location.protocol);

  if (opts.hostname && !opts.port) {
    // if no port is specified manually, use the protocol default
    opts.port = this.secure ? '443' : '80';
  }

  this.agent = opts.agent || false;
  this.hostname = opts.hostname ||
    (global.location ? location.hostname : 'localhost');
  this.port = opts.port || (global.location && location.port
      ? location.port
      : (this.secure ? 443 : 80));
  this.query = opts.query || {};
  if ('string' === typeof this.query) this.query = parseqs.decode(this.query);
  this.upgrade = false !== opts.upgrade;
  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
  this.forceJSONP = !!opts.forceJSONP;
  this.jsonp = false !== opts.jsonp;
  this.forceBase64 = !!opts.forceBase64;
  this.enablesXDR = !!opts.enablesXDR;
  this.timestampParam = opts.timestampParam || 't';
  this.timestampRequests = opts.timestampRequests;
  this.transports = opts.transports || ['polling', 'websocket'];
  this.transportOptions = opts.transportOptions || {};
  this.readyState = '';
  this.writeBuffer = [];
  this.prevBufferLen = 0;
  this.policyPort = opts.policyPort || 843;
  this.rememberUpgrade = opts.rememberUpgrade || false;
  this.binaryType = null;
  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;

  if (true === this.perMessageDeflate) this.perMessageDeflate = {};
  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
    this.perMessageDeflate.threshold = 1024;
  }

  // SSL options for Node.js client
  this.pfx = opts.pfx || null;
  this.key = opts.key || null;
  this.passphrase = opts.passphrase || null;
  this.cert = opts.cert || null;
  this.ca = opts.ca || null;
  this.ciphers = opts.ciphers || null;
  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? true : opts.rejectUnauthorized;
  this.forceNode = !!opts.forceNode;

  // other options for Node.js client
  var freeGlobal = typeof global === 'object' && global;
  if (freeGlobal.global === freeGlobal) {
    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
      this.extraHeaders = opts.extraHeaders;
    }

    if (opts.localAddress) {
      this.localAddress = opts.localAddress;
    }
  }

  // set on handshake
  this.id = null;
  this.upgrades = null;
  this.pingInterval = null;
  this.pingTimeout = null;

  // set on heartbeat
  this.pingIntervalTimer = null;
  this.pingTimeoutTimer = null;

  this.open();
}

Socket.priorWebsocketSuccess = false;

/**
 * Mix in `Emitter`.
 */

Emitter(Socket.prototype);

/**
 * Protocol version.
 *
 * @api public
 */

Socket.protocol = parser.protocol; // this is an int

/**
 * Expose deps for legacy compatibility
 * and standalone browser access.
 */

Socket.Socket = Socket;
Socket.Transport = __webpack_require__(98);
Socket.transports = __webpack_require__(139);
Socket.parser = __webpack_require__(38);

/**
 * Creates transport of the given type.
 *
 * @param {String} transport name
 * @return {Transport}
 * @api private
 */

Socket.prototype.createTransport = function (name) {
  debug('creating transport "%s"', name);
  var query = clone(this.query);

  // append engine.io protocol identifier
  query.EIO = parser.protocol;

  // transport name
  query.transport = name;

  // per-transport options
  var options = this.transportOptions[name] || {};

  // session id if we already have one
  if (this.id) query.sid = this.id;

  var transport = new transports[name]({
    query: query,
    socket: this,
    agent: options.agent || this.agent,
    hostname: options.hostname || this.hostname,
    port: options.port || this.port,
    secure: options.secure || this.secure,
    path: options.path || this.path,
    forceJSONP: options.forceJSONP || this.forceJSONP,
    jsonp: options.jsonp || this.jsonp,
    forceBase64: options.forceBase64 || this.forceBase64,
    enablesXDR: options.enablesXDR || this.enablesXDR,
    timestampRequests: options.timestampRequests || this.timestampRequests,
    timestampParam: options.timestampParam || this.timestampParam,
    policyPort: options.policyPort || this.policyPort,
    pfx: options.pfx || this.pfx,
    key: options.key || this.key,
    passphrase: options.passphrase || this.passphrase,
    cert: options.cert || this.cert,
    ca: options.ca || this.ca,
    ciphers: options.ciphers || this.ciphers,
    rejectUnauthorized: options.rejectUnauthorized || this.rejectUnauthorized,
    perMessageDeflate: options.perMessageDeflate || this.perMessageDeflate,
    extraHeaders: options.extraHeaders || this.extraHeaders,
    forceNode: options.forceNode || this.forceNode,
    localAddress: options.localAddress || this.localAddress,
    requestTimeout: options.requestTimeout || this.requestTimeout,
    protocols: options.protocols || void (0)
  });

  return transport;
};

function clone (obj) {
  var o = {};
  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      o[i] = obj[i];
    }
  }
  return o;
}

/**
 * Initializes transport to use and starts probe.
 *
 * @api private
 */
Socket.prototype.open = function () {
  var transport;
  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
    transport = 'websocket';
  } else if (0 === this.transports.length) {
    // Emit error on next tick so it can be listened to
    var self = this;
    setTimeout(function () {
      self.emit('error', 'No transports available');
    }, 0);
    return;
  } else {
    transport = this.transports[0];
  }
  this.readyState = 'opening';

  // Retry with the next transport if the transport is disabled (jsonp: false)
  try {
    transport = this.createTransport(transport);
  } catch (e) {
    this.transports.shift();
    this.open();
    return;
  }

  transport.open();
  this.setTransport(transport);
};

/**
 * Sets the current transport. Disables the existing one (if any).
 *
 * @api private
 */

Socket.prototype.setTransport = function (transport) {
  debug('setting transport %s', transport.name);
  var self = this;

  if (this.transport) {
    debug('clearing existing transport %s', this.transport.name);
    this.transport.removeAllListeners();
  }

  // set up transport
  this.transport = transport;

  // set up transport listeners
  transport
  .on('drain', function () {
    self.onDrain();
  })
  .on('packet', function (packet) {
    self.onPacket(packet);
  })
  .on('error', function (e) {
    self.onError(e);
  })
  .on('close', function () {
    self.onClose('transport close');
  });
};

/**
 * Probes a transport.
 *
 * @param {String} transport name
 * @api private
 */

Socket.prototype.probe = function (name) {
  debug('probing transport "%s"', name);
  var transport = this.createTransport(name, { probe: 1 });
  var failed = false;
  var self = this;

  Socket.priorWebsocketSuccess = false;

  function onTransportOpen () {
    if (self.onlyBinaryUpgrades) {
      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
      failed = failed || upgradeLosesBinary;
    }
    if (failed) return;

    debug('probe transport "%s" opened', name);
    transport.send([{ type: 'ping', data: 'probe' }]);
    transport.once('packet', function (msg) {
      if (failed) return;
      if ('pong' === msg.type && 'probe' === msg.data) {
        debug('probe transport "%s" pong', name);
        self.upgrading = true;
        self.emit('upgrading', transport);
        if (!transport) return;
        Socket.priorWebsocketSuccess = 'websocket' === transport.name;

        debug('pausing current transport "%s"', self.transport.name);
        self.transport.pause(function () {
          if (failed) return;
          if ('closed' === self.readyState) return;
          debug('changing transport and sending upgrade packet');

          cleanup();

          self.setTransport(transport);
          transport.send([{ type: 'upgrade' }]);
          self.emit('upgrade', transport);
          transport = null;
          self.upgrading = false;
          self.flush();
        });
      } else {
        debug('probe transport "%s" failed', name);
        var err = new Error('probe error');
        err.transport = transport.name;
        self.emit('upgradeError', err);
      }
    });
  }

  function freezeTransport () {
    if (failed) return;

    // Any callback called by transport should be ignored since now
    failed = true;

    cleanup();

    transport.close();
    transport = null;
  }

  // Handle any error that happens while probing
  function onerror (err) {
    var error = new Error('probe error: ' + err);
    error.transport = transport.name;

    freezeTransport();

    debug('probe transport "%s" failed because of error: %s', name, err);

    self.emit('upgradeError', error);
  }

  function onTransportClose () {
    onerror('transport closed');
  }

  // When the socket is closed while we're probing
  function onclose () {
    onerror('socket closed');
  }

  // When the socket is upgraded while we're probing
  function onupgrade (to) {
    if (transport && to.name !== transport.name) {
      debug('"%s" works - aborting "%s"', to.name, transport.name);
      freezeTransport();
    }
  }

  // Remove all listeners on the transport and on self
  function cleanup () {
    transport.removeListener('open', onTransportOpen);
    transport.removeListener('error', onerror);
    transport.removeListener('close', onTransportClose);
    self.removeListener('close', onclose);
    self.removeListener('upgrading', onupgrade);
  }

  transport.once('open', onTransportOpen);
  transport.once('error', onerror);
  transport.once('close', onTransportClose);

  this.once('close', onclose);
  this.once('upgrading', onupgrade);

  transport.open();
};

/**
 * Called when connection is deemed open.
 *
 * @api public
 */

Socket.prototype.onOpen = function () {
  debug('socket open');
  this.readyState = 'open';
  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
  this.emit('open');
  this.flush();

  // we check for `readyState` in case an `open`
  // listener already closed the socket
  if ('open' === this.readyState && this.upgrade && this.transport.pause) {
    debug('starting upgrade probes');
    for (var i = 0, l = this.upgrades.length; i < l; i++) {
      this.probe(this.upgrades[i]);
    }
  }
};

/**
 * Handles a packet.
 *
 * @api private
 */

Socket.prototype.onPacket = function (packet) {
  if ('opening' === this.readyState || 'open' === this.readyState ||
      'closing' === this.readyState) {
    debug('socket receive: type "%s", data "%s"', packet.type, packet.data);

    this.emit('packet', packet);

    // Socket is live - any packet counts
    this.emit('heartbeat');

    switch (packet.type) {
      case 'open':
        this.onHandshake(JSON.parse(packet.data));
        break;

      case 'pong':
        this.setPing();
        this.emit('pong');
        break;

      case 'error':
        var err = new Error('server error');
        err.code = packet.data;
        this.onError(err);
        break;

      case 'message':
        this.emit('data', packet.data);
        this.emit('message', packet.data);
        break;
    }
  } else {
    debug('packet received with socket readyState "%s"', this.readyState);
  }
};

/**
 * Called upon handshake completion.
 *
 * @param {Object} handshake obj
 * @api private
 */

Socket.prototype.onHandshake = function (data) {
  this.emit('handshake', data);
  this.id = data.sid;
  this.transport.query.sid = data.sid;
  this.upgrades = this.filterUpgrades(data.upgrades);
  this.pingInterval = data.pingInterval;
  this.pingTimeout = data.pingTimeout;
  this.onOpen();
  // In case open handler closes socket
  if ('closed' === this.readyState) return;
  this.setPing();

  // Prolong liveness of socket on heartbeat
  this.removeListener('heartbeat', this.onHeartbeat);
  this.on('heartbeat', this.onHeartbeat);
};

/**
 * Resets ping timeout.
 *
 * @api private
 */

Socket.prototype.onHeartbeat = function (timeout) {
  clearTimeout(this.pingTimeoutTimer);
  var self = this;
  self.pingTimeoutTimer = setTimeout(function () {
    if ('closed' === self.readyState) return;
    self.onClose('ping timeout');
  }, timeout || (self.pingInterval + self.pingTimeout));
};

/**
 * Pings server every `this.pingInterval` and expects response
 * within `this.pingTimeout` or closes connection.
 *
 * @api private
 */

Socket.prototype.setPing = function () {
  var self = this;
  clearTimeout(self.pingIntervalTimer);
  self.pingIntervalTimer = setTimeout(function () {
    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
    self.ping();
    self.onHeartbeat(self.pingTimeout);
  }, self.pingInterval);
};

/**
* Sends a ping packet.
*
* @api private
*/

Socket.prototype.ping = function () {
  var self = this;
  this.sendPacket('ping', function () {
    self.emit('ping');
  });
};

/**
 * Called on `drain` event
 *
 * @api private
 */

Socket.prototype.onDrain = function () {
  this.writeBuffer.splice(0, this.prevBufferLen);

  // setting prevBufferLen = 0 is very important
  // for example, when upgrading, upgrade packet is sent over,
  // and a nonzero prevBufferLen could cause problems on `drain`
  this.prevBufferLen = 0;

  if (0 === this.writeBuffer.length) {
    this.emit('drain');
  } else {
    this.flush();
  }
};

/**
 * Flush write buffers.
 *
 * @api private
 */

Socket.prototype.flush = function () {
  if ('closed' !== this.readyState && this.transport.writable &&
    !this.upgrading && this.writeBuffer.length) {
    debug('flushing %d packets in socket', this.writeBuffer.length);
    this.transport.send(this.writeBuffer);
    // keep track of current length of writeBuffer
    // splice writeBuffer and callbackBuffer on `drain`
    this.prevBufferLen = this.writeBuffer.length;
    this.emit('flush');
  }
};

/**
 * Sends a message.
 *
 * @param {String} message.
 * @param {Function} callback function.
 * @param {Object} options.
 * @return {Socket} for chaining.
 * @api public
 */

Socket.prototype.write =
Socket.prototype.send = function (msg, options, fn) {
  this.sendPacket('message', msg, options, fn);
  return this;
};

/**
 * Sends a packet.
 *
 * @param {String} packet type.
 * @param {String} data.
 * @param {Object} options.
 * @param {Function} callback function.
 * @api private
 */

Socket.prototype.sendPacket = function (type, data, options, fn) {
  if ('function' === typeof data) {
    fn = data;
    data = undefined;
  }

  if ('function' === typeof options) {
    fn = options;
    options = null;
  }

  if ('closing' === this.readyState || 'closed' === this.readyState) {
    return;
  }

  options = options || {};
  options.compress = false !== options.compress;

  var packet = {
    type: type,
    data: data,
    options: options
  };
  this.emit('packetCreate', packet);
  this.writeBuffer.push(packet);
  if (fn) this.once('flush', fn);
  this.flush();
};

/**
 * Closes the connection.
 *
 * @api private
 */

Socket.prototype.close = function () {
  if ('opening' === this.readyState || 'open' === this.readyState) {
    this.readyState = 'closing';

    var self = this;

    if (this.writeBuffer.length) {
      this.once('drain', function () {
        if (this.upgrading) {
          waitForUpgrade();
        } else {
          close();
        }
      });
    } else if (this.upgrading) {
      waitForUpgrade();
    } else {
      close();
    }
  }

  function close () {
    self.onClose('forced close');
    debug('socket closing - telling transport to close');
    self.transport.close();
  }

  function cleanupAndClose () {
    self.removeListener('upgrade', cleanupAndClose);
    self.removeListener('upgradeError', cleanupAndClose);
    close();
  }

  function waitForUpgrade () {
    // wait for upgrade to finish since we can't send packets while pausing a transport
    self.once('upgrade', cleanupAndClose);
    self.once('upgradeError', cleanupAndClose);
  }

  return this;
};

/**
 * Called upon transport error
 *
 * @api private
 */

Socket.prototype.onError = function (err) {
  debug('socket error %j', err);
  Socket.priorWebsocketSuccess = false;
  this.emit('error', err);
  this.onClose('transport error', err);
};

/**
 * Called upon transport close.
 *
 * @api private
 */

Socket.prototype.onClose = function (reason, desc) {
  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
    debug('socket close with reason: "%s"', reason);
    var self = this;

    // clear timers
    clearTimeout(this.pingIntervalTimer);
    clearTimeout(this.pingTimeoutTimer);

    // stop event from firing again for transport
    this.transport.removeAllListeners('close');

    // ensure transport won't stay open
    this.transport.close();

    // ignore further transport communication
    this.transport.removeAllListeners();

    // set ready state
    this.readyState = 'closed';

    // clear session id
    this.id = null;

    // emit close event
    this.emit('close', reason, desc);

    // clean buffers after, so users can still
    // grab the buffers on `close` event
    self.writeBuffer = [];
    self.prevBufferLen = 0;
  }
};

/**
 * Filters upgrades, returning only those matching client transports.
 *
 * @param {Array} server upgrades
 * @api private
 *
 */

Socket.prototype.filterUpgrades = function (upgrades) {
  var filteredUpgrades = [];
  for (var i = 0, j = upgrades.length; i < j; i++) {
    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
  }
  return filteredUpgrades;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module requirements.
 */

var Polling = __webpack_require__(140);
var inherit = __webpack_require__(58);

/**
 * Module exports.
 */

module.exports = JSONPPolling;

/**
 * Cached regular expressions.
 */

var rNewline = /\n/g;
var rEscapedNewline = /\\n/g;

/**
 * Global JSONP callbacks.
 */

var callbacks;

/**
 * Noop.
 */

function empty () { }

/**
 * JSONP Polling constructor.
 *
 * @param {Object} opts.
 * @api public
 */

function JSONPPolling (opts) {
  Polling.call(this, opts);

  this.query = this.query || {};

  // define global callbacks array if not present
  // we do this here (lazily) to avoid unneeded global pollution
  if (!callbacks) {
    // we need to consider multiple engines in the same page
    if (!global.___eio) global.___eio = [];
    callbacks = global.___eio;
  }

  // callback identifier
  this.index = callbacks.length;

  // add callback to jsonp global
  var self = this;
  callbacks.push(function (msg) {
    self.onData(msg);
  });

  // append to query string
  this.query.j = this.index;

  // prevent spurious errors from being emitted when the window is unloaded
  if (global.document && global.addEventListener) {
    global.addEventListener('beforeunload', function () {
      if (self.script) self.script.onerror = empty;
    }, false);
  }
}

/**
 * Inherits from Polling.
 */

inherit(JSONPPolling, Polling);

/*
 * JSONP only supports binary as base64 encoded strings
 */

JSONPPolling.prototype.supportsBinary = false;

/**
 * Closes the socket.
 *
 * @api private
 */

JSONPPolling.prototype.doClose = function () {
  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }

  if (this.form) {
    this.form.parentNode.removeChild(this.form);
    this.form = null;
    this.iframe = null;
  }

  Polling.prototype.doClose.call(this);
};

/**
 * Starts a poll cycle.
 *
 * @api private
 */

JSONPPolling.prototype.doPoll = function () {
  var self = this;
  var script = document.createElement('script');

  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }

  script.async = true;
  script.src = this.uri();
  script.onerror = function (e) {
    self.onError('jsonp poll error', e);
  };

  var insertAt = document.getElementsByTagName('script')[0];
  if (insertAt) {
    insertAt.parentNode.insertBefore(script, insertAt);
  } else {
    (document.head || document.body).appendChild(script);
  }
  this.script = script;

  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);

  if (isUAgecko) {
    setTimeout(function () {
      var iframe = document.createElement('iframe');
      document.body.appendChild(iframe);
      document.body.removeChild(iframe);
    }, 100);
  }
};

/**
 * Writes with a hidden iframe.
 *
 * @param {String} data to send
 * @param {Function} called upon flush.
 * @api private
 */

JSONPPolling.prototype.doWrite = function (data, fn) {
  var self = this;

  if (!this.form) {
    var form = document.createElement('form');
    var area = document.createElement('textarea');
    var id = this.iframeId = 'eio_iframe_' + this.index;
    var iframe;

    form.className = 'socketio';
    form.style.position = 'absolute';
    form.style.top = '-1000px';
    form.style.left = '-1000px';
    form.target = id;
    form.method = 'POST';
    form.setAttribute('accept-charset', 'utf-8');
    area.name = 'd';
    form.appendChild(area);
    document.body.appendChild(form);

    this.form = form;
    this.area = area;
  }

  this.form.action = this.uri();

  function complete () {
    initIframe();
    fn();
  }

  function initIframe () {
    if (self.iframe) {
      try {
        self.form.removeChild(self.iframe);
      } catch (e) {
        self.onError('jsonp polling iframe removal error', e);
      }
    }

    try {
      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
      var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
      iframe = document.createElement(html);
    } catch (e) {
      iframe = document.createElement('iframe');
      iframe.name = self.iframeId;
      iframe.src = 'javascript:0';
    }

    iframe.id = self.iframeId;

    self.form.appendChild(iframe);
    self.iframe = iframe;
  }

  initIframe();

  // escape \n to prevent it from being converted into \r\n by some UAs
  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
  data = data.replace(rEscapedNewline, '\\\n');
  this.area.value = data.replace(rNewline, '\\n');

  try {
    this.form.submit();
  } catch (e) {}

  if (this.iframe.attachEvent) {
    this.iframe.onreadystatechange = function () {
      if (self.iframe.readyState === 'complete') {
        complete();
      }
    };
  } else {
    this.iframe.onload = complete;
  }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Module requirements.
 */

var XMLHttpRequest = __webpack_require__(99);
var Polling = __webpack_require__(140);
var Emitter = __webpack_require__(34);
var inherit = __webpack_require__(58);
var debug = __webpack_require__(22)('engine.io-client:polling-xhr');

/**
 * Module exports.
 */

module.exports = XHR;
module.exports.Request = Request;

/**
 * Empty function
 */

function empty () {}

/**
 * XHR Polling constructor.
 *
 * @param {Object} opts
 * @api public
 */

function XHR (opts) {
  Polling.call(this, opts);
  this.requestTimeout = opts.requestTimeout;
  this.extraHeaders = opts.extraHeaders;

  if (global.location) {
    var isSSL = 'https:' === location.protocol;
    var port = location.port;

    // some user agents have empty `location.port`
    if (!port) {
      port = isSSL ? 443 : 80;
    }

    this.xd = opts.hostname !== global.location.hostname ||
      port !== opts.port;
    this.xs = opts.secure !== isSSL;
  }
}

/**
 * Inherits from Polling.
 */

inherit(XHR, Polling);

/**
 * XHR supports binary
 */

XHR.prototype.supportsBinary = true;

/**
 * Creates a request.
 *
 * @param {String} method
 * @api private
 */

XHR.prototype.request = function (opts) {
  opts = opts || {};
  opts.uri = this.uri();
  opts.xd = this.xd;
  opts.xs = this.xs;
  opts.agent = this.agent || false;
  opts.supportsBinary = this.supportsBinary;
  opts.enablesXDR = this.enablesXDR;

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;
  opts.requestTimeout = this.requestTimeout;

  // other options for Node.js client
  opts.extraHeaders = this.extraHeaders;

  return new Request(opts);
};

/**
 * Sends data.
 *
 * @param {String} data to send.
 * @param {Function} called upon flush.
 * @api private
 */

XHR.prototype.doWrite = function (data, fn) {
  var isBinary = typeof data !== 'string' && data !== undefined;
  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
  var self = this;
  req.on('success', fn);
  req.on('error', function (err) {
    self.onError('xhr post error', err);
  });
  this.sendXhr = req;
};

/**
 * Starts a poll cycle.
 *
 * @api private
 */

XHR.prototype.doPoll = function () {
  debug('xhr poll');
  var req = this.request();
  var self = this;
  req.on('data', function (data) {
    self.onData(data);
  });
  req.on('error', function (err) {
    self.onError('xhr poll error', err);
  });
  this.pollXhr = req;
};

/**
 * Request constructor
 *
 * @param {Object} options
 * @api public
 */

function Request (opts) {
  this.method = opts.method || 'GET';
  this.uri = opts.uri;
  this.xd = !!opts.xd;
  this.xs = !!opts.xs;
  this.async = false !== opts.async;
  this.data = undefined !== opts.data ? opts.data : null;
  this.agent = opts.agent;
  this.isBinary = opts.isBinary;
  this.supportsBinary = opts.supportsBinary;
  this.enablesXDR = opts.enablesXDR;
  this.requestTimeout = opts.requestTimeout;

  // SSL options for Node.js client
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;

  // other options for Node.js client
  this.extraHeaders = opts.extraHeaders;

  this.create();
}

/**
 * Mix in `Emitter`.
 */

Emitter(Request.prototype);

/**
 * Creates the XHR object and sends the request.
 *
 * @api private
 */

Request.prototype.create = function () {
  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;

  var xhr = this.xhr = new XMLHttpRequest(opts);
  var self = this;

  try {
    debug('xhr open %s: %s', this.method, this.uri);
    xhr.open(this.method, this.uri, this.async);
    try {
      if (this.extraHeaders) {
        xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
        for (var i in this.extraHeaders) {
          if (this.extraHeaders.hasOwnProperty(i)) {
            xhr.setRequestHeader(i, this.extraHeaders[i]);
          }
        }
      }
    } catch (e) {}

    if ('POST' === this.method) {
      try {
        if (this.isBinary) {
          xhr.setRequestHeader('Content-type', 'application/octet-stream');
        } else {
          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
        }
      } catch (e) {}
    }

    try {
      xhr.setRequestHeader('Accept', '*/*');
    } catch (e) {}

    // ie6 check
    if ('withCredentials' in xhr) {
      xhr.withCredentials = true;
    }

    if (this.requestTimeout) {
      xhr.timeout = this.requestTimeout;
    }

    if (this.hasXDR()) {
      xhr.onload = function () {
        self.onLoad();
      };
      xhr.onerror = function () {
        self.onError(xhr.responseText);
      };
    } else {
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 2) {
          var contentType;
          try {
            contentType = xhr.getResponseHeader('Content-Type');
          } catch (e) {}
          if (contentType === 'application/octet-stream') {
            xhr.responseType = 'arraybuffer';
          }
        }
        if (4 !== xhr.readyState) return;
        if (200 === xhr.status || 1223 === xhr.status) {
          self.onLoad();
        } else {
          // make sure the `error` event handler that's user-set
          // does not throw in the same tick and gets caught here
          setTimeout(function () {
            self.onError(xhr.status);
          }, 0);
        }
      };
    }

    debug('xhr data %s', this.data);
    xhr.send(this.data);
  } catch (e) {
    // Need to defer since .create() is called directly fhrom the constructor
    // and thus the 'error' event can only be only bound *after* this exception
    // occurs.  Therefore, also, we cannot throw here at all.
    setTimeout(function () {
      self.onError(e);
    }, 0);
    return;
  }

  if (global.document) {
    this.index = Request.requestsCount++;
    Request.requests[this.index] = this;
  }
};

/**
 * Called upon successful response.
 *
 * @api private
 */

Request.prototype.onSuccess = function () {
  this.emit('success');
  this.cleanup();
};

/**
 * Called if we have data.
 *
 * @api private
 */

Request.prototype.onData = function (data) {
  this.emit('data', data);
  this.onSuccess();
};

/**
 * Called upon error.
 *
 * @api private
 */

Request.prototype.onError = function (err) {
  this.emit('error', err);
  this.cleanup(true);
};

/**
 * Cleans up house.
 *
 * @api private
 */

Request.prototype.cleanup = function (fromError) {
  if ('undefined' === typeof this.xhr || null === this.xhr) {
    return;
  }
  // xmlhttprequest
  if (this.hasXDR()) {
    this.xhr.onload = this.xhr.onerror = empty;
  } else {
    this.xhr.onreadystatechange = empty;
  }

  if (fromError) {
    try {
      this.xhr.abort();
    } catch (e) {}
  }

  if (global.document) {
    delete Request.requests[this.index];
  }

  this.xhr = null;
};

/**
 * Called upon load.
 *
 * @api private
 */

Request.prototype.onLoad = function () {
  var data;
  try {
    var contentType;
    try {
      contentType = this.xhr.getResponseHeader('Content-Type');
    } catch (e) {}
    if (contentType === 'application/octet-stream') {
      data = this.xhr.response || this.xhr.responseText;
    } else {
      data = this.xhr.responseText;
    }
  } catch (e) {
    this.onError(e);
  }
  if (null != data) {
    this.onData(data);
  }
};

/**
 * Check if it has XDomainRequest.
 *
 * @api private
 */

Request.prototype.hasXDR = function () {
  return 'undefined' !== typeof global.XDomainRequest && !this.xs && this.enablesXDR;
};

/**
 * Aborts the request.
 *
 * @api public
 */

Request.prototype.abort = function () {
  this.cleanup();
};

/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */

Request.requestsCount = 0;
Request.requests = {};

if (global.document) {
  if (global.attachEvent) {
    global.attachEvent('onunload', unloadHandler);
  } else if (global.addEventListener) {
    global.addEventListener('beforeunload', unloadHandler, false);
  }
}

function unloadHandler () {
  for (var i in Request.requests) {
    if (Request.requests.hasOwnProperty(i)) {
      Request.requests[i].abort();
    }
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Module dependencies.
 */

var Transport = __webpack_require__(98);
var parser = __webpack_require__(38);
var parseqs = __webpack_require__(68);
var inherit = __webpack_require__(58);
var yeast = __webpack_require__(178);
var debug = __webpack_require__(22)('engine.io-client:websocket');
var BrowserWebSocket = global.WebSocket || global.MozWebSocket;
var NodeWebSocket;
if (typeof window === 'undefined') {
  try {
    NodeWebSocket = __webpack_require__(476);
  } catch (e) { }
}

/**
 * Get either the `WebSocket` or `MozWebSocket` globals
 * in the browser or try to resolve WebSocket-compatible
 * interface exposed by `ws` for Node-like environment.
 */

var WebSocket = BrowserWebSocket;
if (!WebSocket && typeof window === 'undefined') {
  WebSocket = NodeWebSocket;
}

/**
 * Module exports.
 */

module.exports = WS;

/**
 * WebSocket transport constructor.
 *
 * @api {Object} connection options
 * @api public
 */

function WS (opts) {
  var forceBase64 = (opts && opts.forceBase64);
  if (forceBase64) {
    this.supportsBinary = false;
  }
  this.perMessageDeflate = opts.perMessageDeflate;
  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
  this.protocols = opts.protocols;
  if (!this.usingBrowserWebSocket) {
    WebSocket = NodeWebSocket;
  }
  Transport.call(this, opts);
}

/**
 * Inherits from Transport.
 */

inherit(WS, Transport);

/**
 * Transport name.
 *
 * @api public
 */

WS.prototype.name = 'websocket';

/*
 * WebSockets support binary
 */

WS.prototype.supportsBinary = true;

/**
 * Opens socket.
 *
 * @api private
 */

WS.prototype.doOpen = function () {
  if (!this.check()) {
    // let probe timeout
    return;
  }

  var uri = this.uri();
  var protocols = this.protocols;
  var opts = {
    agent: this.agent,
    perMessageDeflate: this.perMessageDeflate
  };

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;
  if (this.extraHeaders) {
    opts.headers = this.extraHeaders;
  }
  if (this.localAddress) {
    opts.localAddress = this.localAddress;
  }

  try {
    this.ws = this.usingBrowserWebSocket ? (protocols ? new WebSocket(uri, protocols) : new WebSocket(uri)) : new WebSocket(uri, protocols, opts);
  } catch (err) {
    return this.emit('error', err);
  }

  if (this.ws.binaryType === undefined) {
    this.supportsBinary = false;
  }

  if (this.ws.supports && this.ws.supports.binary) {
    this.supportsBinary = true;
    this.ws.binaryType = 'nodebuffer';
  } else {
    this.ws.binaryType = 'arraybuffer';
  }

  this.addEventListeners();
};

/**
 * Adds event listeners to the socket
 *
 * @api private
 */

WS.prototype.addEventListeners = function () {
  var self = this;

  this.ws.onopen = function () {
    self.onOpen();
  };
  this.ws.onclose = function () {
    self.onClose();
  };
  this.ws.onmessage = function (ev) {
    self.onData(ev.data);
  };
  this.ws.onerror = function (e) {
    self.onError('websocket error', e);
  };
};

/**
 * Writes data to socket.
 *
 * @param {Array} array of packets.
 * @api private
 */

WS.prototype.write = function (packets) {
  var self = this;
  this.writable = false;

  // encodePacket efficient as it uses WS framing
  // no need for encodePayload
  var total = packets.length;
  for (var i = 0, l = total; i < l; i++) {
    (function (packet) {
      parser.encodePacket(packet, self.supportsBinary, function (data) {
        if (!self.usingBrowserWebSocket) {
          // always create a new object (GH-437)
          var opts = {};
          if (packet.options) {
            opts.compress = packet.options.compress;
          }

          if (self.perMessageDeflate) {
            var len = 'string' === typeof data ? global.Buffer.byteLength(data) : data.length;
            if (len < self.perMessageDeflate.threshold) {
              opts.compress = false;
            }
          }
        }

        // Sometimes the websocket has already been closed but the browser didn't
        // have a chance of informing us about it yet, in that case send will
        // throw an error
        try {
          if (self.usingBrowserWebSocket) {
            // TypeError is thrown when passing the second argument on Safari
            self.ws.send(data);
          } else {
            self.ws.send(data, opts);
          }
        } catch (e) {
          debug('websocket closed before onclose event');
        }

        --total || done();
      });
    })(packets[i]);
  }

  function done () {
    self.emit('flush');

    // fake drain
    // defer to next tick to allow Socket to clear writeBuffer
    setTimeout(function () {
      self.writable = true;
      self.emit('drain');
    }, 0);
  }
};

/**
 * Called upon close
 *
 * @api private
 */

WS.prototype.onClose = function () {
  Transport.prototype.onClose.call(this);
};

/**
 * Closes socket.
 *
 * @api private
 */

WS.prototype.doClose = function () {
  if (typeof this.ws !== 'undefined') {
    this.ws.close();
  }
};

/**
 * Generates uri for connection.
 *
 * @api private
 */

WS.prototype.uri = function () {
  var query = this.query || {};
  var schema = this.secure ? 'wss' : 'ws';
  var port = '';

  // avoid port if default for schema
  if (this.port && (('wss' === schema && Number(this.port) !== 443) ||
    ('ws' === schema && Number(this.port) !== 80))) {
    port = ':' + this.port;
  }

  // append timestamp to URI
  if (this.timestampRequests) {
    query[this.timestampParam] = yeast();
  }

  // communicate binary support capabilities
  if (!this.supportsBinary) {
    query.b64 = 1;
  }

  query = parseqs.encode(query);

  // prepend ? to query
  if (query.length) {
    query = '?' + query;
  }

  var ipv6 = this.hostname.indexOf(':') !== -1;
  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};

/**
 * Feature detection for WebSocket.
 *
 * @return {Boolean} whether this transport is available.
 * @api public
 */

WS.prototype.check = function () {
  return !!WebSocket && !('__initialize' in WebSocket && this.name === WS.prototype.name);
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 346 */
/***/ (function(module, exports) {


/**
 * Gets the keys for an object.
 *
 * @return {Array} keys
 * @api private
 */

module.exports = Object.keys || function keys (obj){
  var arr = [];
  var has = Object.prototype.hasOwnProperty;

  for (var i in obj) {
    if (has.call(obj, i)) {
      arr.push(i);
    }
  }
  return arr;
};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/utf8js v2.1.2 by @mathias */
;(function(root) {

	// Detect free variables `exports`
	var freeExports = typeof exports == 'object' && exports;

	// Detect free variable `module`
	var freeModule = typeof module == 'object' && module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code,
	// and use it as `root`
	var freeGlobal = typeof global == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	var stringFromCharCode = String.fromCharCode;

	// Taken from https://mths.be/punycode
	function ucs2decode(string) {
		var output = [];
		var counter = 0;
		var length = string.length;
		var value;
		var extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	// Taken from https://mths.be/punycode
	function ucs2encode(array) {
		var length = array.length;
		var index = -1;
		var value;
		var output = '';
		while (++index < length) {
			value = array[index];
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
		}
		return output;
	}

	function checkScalarValue(codePoint, strict) {
		if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
			if (strict) {
				throw Error(
					'Lone surrogate U+' + codePoint.toString(16).toUpperCase() +
					' is not a scalar value'
				);
			}
			return false;
		}
		return true;
	}
	/*--------------------------------------------------------------------------*/

	function createByte(codePoint, shift) {
		return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
	}

	function encodeCodePoint(codePoint, strict) {
		if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
			return stringFromCharCode(codePoint);
		}
		var symbol = '';
		if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
			symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
		}
		else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
			if (!checkScalarValue(codePoint, strict)) {
				codePoint = 0xFFFD;
			}
			symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
			symbol += createByte(codePoint, 6);
		}
		else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
			symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
			symbol += createByte(codePoint, 12);
			symbol += createByte(codePoint, 6);
		}
		symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
		return symbol;
	}

	function utf8encode(string, opts) {
		opts = opts || {};
		var strict = false !== opts.strict;

		var codePoints = ucs2decode(string);
		var length = codePoints.length;
		var index = -1;
		var codePoint;
		var byteString = '';
		while (++index < length) {
			codePoint = codePoints[index];
			byteString += encodeCodePoint(codePoint, strict);
		}
		return byteString;
	}

	/*--------------------------------------------------------------------------*/

	function readContinuationByte() {
		if (byteIndex >= byteCount) {
			throw Error('Invalid byte index');
		}

		var continuationByte = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		if ((continuationByte & 0xC0) == 0x80) {
			return continuationByte & 0x3F;
		}

		// If we end up here, it’s not a continuation byte
		throw Error('Invalid continuation byte');
	}

	function decodeSymbol(strict) {
		var byte1;
		var byte2;
		var byte3;
		var byte4;
		var codePoint;

		if (byteIndex > byteCount) {
			throw Error('Invalid byte index');
		}

		if (byteIndex == byteCount) {
			return false;
		}

		// Read first byte
		byte1 = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		// 1-byte sequence (no continuation bytes)
		if ((byte1 & 0x80) == 0) {
			return byte1;
		}

		// 2-byte sequence
		if ((byte1 & 0xE0) == 0xC0) {
			byte2 = readContinuationByte();
			codePoint = ((byte1 & 0x1F) << 6) | byte2;
			if (codePoint >= 0x80) {
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 3-byte sequence (may include unpaired surrogates)
		if ((byte1 & 0xF0) == 0xE0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
			if (codePoint >= 0x0800) {
				return checkScalarValue(codePoint, strict) ? codePoint : 0xFFFD;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 4-byte sequence
		if ((byte1 & 0xF8) == 0xF0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			byte4 = readContinuationByte();
			codePoint = ((byte1 & 0x07) << 0x12) | (byte2 << 0x0C) |
				(byte3 << 0x06) | byte4;
			if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
				return codePoint;
			}
		}

		throw Error('Invalid UTF-8 detected');
	}

	var byteArray;
	var byteCount;
	var byteIndex;
	function utf8decode(byteString, opts) {
		opts = opts || {};
		var strict = false !== opts.strict;

		byteArray = ucs2decode(byteString);
		byteCount = byteArray.length;
		byteIndex = 0;
		var codePoints = [];
		var tmp;
		while ((tmp = decodeSymbol(strict)) !== false) {
			codePoints.push(tmp);
		}
		return ucs2encode(codePoints);
	}

	/*--------------------------------------------------------------------------*/

	var utf8 = {
		'version': '2.1.2',
		'encode': utf8encode,
		'decode': utf8decode
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return utf8;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}	else if (freeExports && !freeExports.nodeType) {
		if (freeModule) { // in Node.js or RingoJS v0.8.0+
			freeModule.exports = utf8;
		} else { // in Narwhal or RingoJS v0.7.0-
			var object = {};
			var hasOwnProperty = object.hasOwnProperty;
			for (var key in utf8) {
				hasOwnProperty.call(utf8, key) && (freeExports[key] = utf8[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.utf8 = utf8;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(177)(module), __webpack_require__(14)))

/***/ }),
/* 348 */
/***/ (function(module, exports) {

module.exports = function (cb) {
    if (typeof Promise !== 'function') {
      var err = new Error('Device enumeration not supported.');
      err.kind = 'METHOD_NOT_AVAILABLE';
      if (cb) {
          console.warn('module now uses promise based api - callback is deprecated');
          return cb(err);
      }
      throw err;
    }

    return new Promise(function(resolve, reject) {
        var processDevices = function (devices) {
            var normalizedDevices = [];
            for (var i = 0; i < devices.length; i++) {
                var device = devices[i];
                //make chrome values match spec
                var kind = device.kind || null;
                if (kind && kind.toLowerCase() === 'audio') {
                    kind = 'audioinput';
                } else if (kind && kind.toLowerCase() === 'video') {
                    kind = 'videoinput';
                }
                normalizedDevices.push({
                    facing: device.facing || null,
                    deviceId: device.id || device.deviceId || null,
                    label: device.label || null,
                    kind: kind,
                    groupId: device.groupId || null
                });
            }
            resolve(normalizedDevices);
            if (cb) {
                console.warn('module now uses promise based api - callback is deprecated');
                cb(null, normalizedDevices);
            }
        };

        if (window.navigator && window.navigator.mediaDevices && window.navigator.mediaDevices.enumerateDevices) {
            window.navigator.mediaDevices.enumerateDevices().then(processDevices);
        } else if (window.MediaStreamTrack && window.MediaStreamTrack.getSources) {
            window.MediaStreamTrack.getSources(processDevices);
        } else {
            var err = new Error('Device enumeration not supported.');
            err.kind = 'METHOD_NOT_AVAILABLE';
            reject(err);
            if (cb) {
                console.warn('module now uses promise based api - callback is deprecated');
                cb(err);
            }
        }
    });
};


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(351);
var $isFinite = __webpack_require__(350);

var sign = __webpack_require__(353);
var mod = __webpack_require__(352);

var IsCallable = __webpack_require__(150);
var toPrimitive = __webpack_require__(354);

var has = __webpack_require__(142);

// https://es5.github.io/#x9
var ES5 = {
	ToPrimitive: toPrimitive,

	ToBoolean: function ToBoolean(value) {
		return !!value;
	},
	ToNumber: function ToNumber(value) {
		return Number(value);
	},
	ToInteger: function ToInteger(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number)) { return 0; }
		if (number === 0 || !$isFinite(number)) { return number; }
		return sign(number) * Math.floor(Math.abs(number));
	},
	ToInt32: function ToInt32(x) {
		return this.ToNumber(x) >> 0;
	},
	ToUint32: function ToUint32(x) {
		return this.ToNumber(x) >>> 0;
	},
	ToUint16: function ToUint16(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
		var posInt = sign(number) * Math.floor(Math.abs(number));
		return mod(posInt, 0x10000);
	},
	ToString: function ToString(value) {
		return String(value);
	},
	ToObject: function ToObject(value) {
		this.CheckObjectCoercible(value);
		return Object(value);
	},
	CheckObjectCoercible: function CheckObjectCoercible(value, optMessage) {
		/* jshint eqnull:true */
		if (value == null) {
			throw new TypeError(optMessage || 'Cannot call method on ' + value);
		}
		return value;
	},
	IsCallable: IsCallable,
	SameValue: function SameValue(x, y) {
		if (x === y) { // 0 === -0, but they are not identical.
			if (x === 0) { return 1 / x === 1 / y; }
			return true;
		}
		return $isNaN(x) && $isNaN(y);
	},

	// http://www.ecma-international.org/ecma-262/5.1/#sec-8
	Type: function Type(x) {
		if (x === null) {
			return 'Null';
		}
		if (typeof x === 'undefined') {
			return 'Undefined';
		}
		if (typeof x === 'function' || typeof x === 'object') {
			return 'Object';
		}
		if (typeof x === 'number') {
			return 'Number';
		}
		if (typeof x === 'boolean') {
			return 'Boolean';
		}
		if (typeof x === 'string') {
			return 'String';
		}
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
	IsPropertyDescriptor: function IsPropertyDescriptor(Desc) {
		if (this.Type(Desc) !== 'Object') {
			return false;
		}
		var allowed = {
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Get]]': true,
			'[[Set]]': true,
			'[[Value]]': true,
			'[[Writable]]': true
		};
		// jscs:disable
		for (var key in Desc) { // eslint-disable-line
			if (has(Desc, key) && !allowed[key]) {
				return false;
			}
		}
		// jscs:enable
		var isData = has(Desc, '[[Value]]');
		var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
		if (isData && IsAccessor) {
			throw new TypeError('Property Descriptors may not be both accessor and data descriptors');
		}
		return true;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.1
	IsAccessorDescriptor: function IsAccessorDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (!has(Desc, '[[Get]]') && !has(Desc, '[[Set]]')) {
			return false;
		}

		return true;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.2
	IsDataDescriptor: function IsDataDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (!has(Desc, '[[Value]]') && !has(Desc, '[[Writable]]')) {
			return false;
		}

		return true;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.3
	IsGenericDescriptor: function IsGenericDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (!this.IsAccessorDescriptor(Desc) && !this.IsDataDescriptor(Desc)) {
			return true;
		}

		return false;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.4
	FromPropertyDescriptor: function FromPropertyDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return Desc;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (this.IsDataDescriptor(Desc)) {
			return {
				value: Desc['[[Value]]'],
				writable: !!Desc['[[Writable]]'],
				enumerable: !!Desc['[[Enumerable]]'],
				configurable: !!Desc['[[Configurable]]']
			};
		} else if (this.IsAccessorDescriptor(Desc)) {
			return {
				get: Desc['[[Get]]'],
				set: Desc['[[Set]]'],
				enumerable: !!Desc['[[Enumerable]]'],
				configurable: !!Desc['[[Configurable]]']
			};
		} else {
			throw new TypeError('FromPropertyDescriptor must be called with a fully populated Property Descriptor');
		}
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.5
	ToPropertyDescriptor: function ToPropertyDescriptor(Obj) {
		if (this.Type(Obj) !== 'Object') {
			throw new TypeError('ToPropertyDescriptor requires an object');
		}

		var desc = {};
		if (has(Obj, 'enumerable')) {
			desc['[[Enumerable]]'] = this.ToBoolean(Obj.enumerable);
		}
		if (has(Obj, 'configurable')) {
			desc['[[Configurable]]'] = this.ToBoolean(Obj.configurable);
		}
		if (has(Obj, 'value')) {
			desc['[[Value]]'] = Obj.value;
		}
		if (has(Obj, 'writable')) {
			desc['[[Writable]]'] = this.ToBoolean(Obj.writable);
		}
		if (has(Obj, 'get')) {
			var getter = Obj.get;
			if (typeof getter !== 'undefined' && !this.IsCallable(getter)) {
				throw new TypeError('getter must be a function');
			}
			desc['[[Get]]'] = getter;
		}
		if (has(Obj, 'set')) {
			var setter = Obj.set;
			if (typeof setter !== 'undefined' && !this.IsCallable(setter)) {
				throw new TypeError('setter must be a function');
			}
			desc['[[Set]]'] = setter;
		}

		if ((has(desc, '[[Get]]') || has(desc, '[[Set]]')) && (has(desc, '[[Value]]') || has(desc, '[[Writable]]'))) {
			throw new TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
		}
		return desc;
	}
};

module.exports = ES5;


/***/ }),
/* 350 */
/***/ (function(module, exports) {

var $isNaN = Number.isNaN || function (a) { return a !== a; };

module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ }),
/* 351 */
/***/ (function(module, exports) {

module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),
/* 352 */
/***/ (function(module, exports) {

module.exports = function mod(number, modulo) {
	var remain = number % modulo;
	return Math.floor(remain >= 0 ? remain : remain + modulo);
};


/***/ }),
/* 353 */
/***/ (function(module, exports) {

module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

var isPrimitive = __webpack_require__(355);

var isCallable = __webpack_require__(150);

// https://es5.github.io/#x8.12
var ES5internalSlots = {
	'[[DefaultValue]]': function (O, hint) {
		var actualHint = hint || (toStr.call(O) === '[object Date]' ? String : Number);

		if (actualHint === String || actualHint === Number) {
			var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
			var value, i;
			for (i = 0; i < methods.length; ++i) {
				if (isCallable(O[methods[i]])) {
					value = O[methods[i]]();
					if (isPrimitive(value)) {
						return value;
					}
				}
			}
			throw new TypeError('No default value');
		}
		throw new TypeError('invalid [[DefaultValue]] hint supplied');
	}
};

// https://es5.github.io/#x9
module.exports = function ToPrimitive(input, PreferredType) {
	if (isPrimitive(input)) {
		return input;
	}
	return ES5internalSlots['[[DefaultValue]]'](input, PreferredType);
};


/***/ }),
/* 355 */
/***/ (function(module, exports) {

module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// This file can be required in Browserify and Node.js for automatic polyfill
// To use it:  require('es6-promise/auto');

module.exports = __webpack_require__(357).polyfill();


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var require;/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   4.1.1
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}

var _isArray = undefined;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = undefined;
var customSchedulerFn = undefined;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var r = require;
    var vertx = __webpack_require__(477);
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = undefined;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var _arguments = arguments;

  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;

  if (_state) {
    (function () {
      var callback = _arguments[_state - 1];
      asap(function () {
        return invokeCallback(_state, child, callback, parent._result);
      });
    })();
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(16);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var GET_THEN_ERROR = new ErrorObject();

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    GET_THEN_ERROR.error = error;
    return GET_THEN_ERROR;
  }
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === GET_THEN_ERROR) {
      reject(promise, GET_THEN_ERROR.error);
      GET_THEN_ERROR.error = null;
    } else if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;

  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = undefined,
      callback = undefined,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function ErrorObject() {
  this.error = null;
}

var TRY_CATCH_ERROR = new ErrorObject();

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = undefined,
      error = undefined,
      succeeded = undefined,
      failed = undefined;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value.error = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
      resolve(promise, value);
    } else if (failed) {
      reject(promise, error);
    } else if (settled === FULFILLED) {
      fulfill(promise, value);
    } else if (settled === REJECTED) {
      reject(promise, value);
    }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function Enumerator$1(Constructor, input) {
  this._instanceConstructor = Constructor;
  this.promise = new Constructor(noop);

  if (!this.promise[PROMISE_ID]) {
    makePromise(this.promise);
  }

  if (isArray(input)) {
    this.length = input.length;
    this._remaining = input.length;

    this._result = new Array(this.length);

    if (this.length === 0) {
      fulfill(this.promise, this._result);
    } else {
      this.length = this.length || 0;
      this._enumerate(input);
      if (this._remaining === 0) {
        fulfill(this.promise, this._result);
      }
    }
  } else {
    reject(this.promise, validationError());
  }
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

Enumerator$1.prototype._enumerate = function (input) {
  for (var i = 0; this._state === PENDING && i < input.length; i++) {
    this._eachEntry(input[i], i);
  }
};

Enumerator$1.prototype._eachEntry = function (entry, i) {
  var c = this._instanceConstructor;
  var resolve$$1 = c.resolve;

  if (resolve$$1 === resolve$1) {
    var _then = getThen(entry);

    if (_then === then && entry._state !== PENDING) {
      this._settledAt(entry._state, i, entry._result);
    } else if (typeof _then !== 'function') {
      this._remaining--;
      this._result[i] = entry;
    } else if (c === Promise$2) {
      var promise = new c(noop);
      handleMaybeThenable(promise, entry, _then);
      this._willSettleAt(promise, i);
    } else {
      this._willSettleAt(new c(function (resolve$$1) {
        return resolve$$1(entry);
      }), i);
    }
  } else {
    this._willSettleAt(resolve$$1(entry), i);
  }
};

Enumerator$1.prototype._settledAt = function (state, i, value) {
  var promise = this.promise;

  if (promise._state === PENDING) {
    this._remaining--;

    if (state === REJECTED) {
      reject(promise, value);
    } else {
      this._result[i] = value;
    }
  }

  if (this._remaining === 0) {
    fulfill(promise, this._result);
  }
};

Enumerator$1.prototype._willSettleAt = function (promise, i) {
  var enumerator = this;

  subscribe(promise, undefined, function (value) {
    return enumerator._settledAt(FULFILLED, i, value);
  }, function (reason) {
    return enumerator._settledAt(REJECTED, i, reason);
  });
};

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all$1(entries) {
  return new Enumerator$1(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race$1(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {function} resolver
  Useful for tooling.
  @constructor
*/
function Promise$2(resolver) {
  this[PROMISE_ID] = nextId();
  this._result = this._state = undefined;
  this._subscribers = [];

  if (noop !== resolver) {
    typeof resolver !== 'function' && needsResolver();
    this instanceof Promise$2 ? initializePromise(this, resolver) : needsNew();
  }
}

Promise$2.all = all$1;
Promise$2.race = race$1;
Promise$2.resolve = resolve$1;
Promise$2.reject = reject$1;
Promise$2._setScheduler = setScheduler;
Promise$2._setAsap = setAsap;
Promise$2._asap = asap;

Promise$2.prototype = {
  constructor: Promise$2,

  /**
    The primary way of interacting with a promise is through its `then` method,
    which registers callbacks to receive either a promise's eventual value or the
    reason why the promise cannot be fulfilled.
  
    ```js
    findUser().then(function(user){
      // user is available
    }, function(reason){
      // user is unavailable, and you are given the reason why
    });
    ```
  
    Chaining
    --------
  
    The return value of `then` is itself a promise.  This second, 'downstream'
    promise is resolved with the return value of the first promise's fulfillment
    or rejection handler, or rejected if the handler throws an exception.
  
    ```js
    findUser().then(function (user) {
      return user.name;
    }, function (reason) {
      return 'default name';
    }).then(function (userName) {
      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
      // will be `'default name'`
    });
  
    findUser().then(function (user) {
      throw new Error('Found user, but still unhappy');
    }, function (reason) {
      throw new Error('`findUser` rejected and we're unhappy');
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
    });
    ```
    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
  
    ```js
    findUser().then(function (user) {
      throw new PedagogicalException('Upstream error');
    }).then(function (value) {
      // never reached
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // The `PedgagocialException` is propagated all the way down to here
    });
    ```
  
    Assimilation
    ------------
  
    Sometimes the value you want to propagate to a downstream promise can only be
    retrieved asynchronously. This can be achieved by returning a promise in the
    fulfillment or rejection handler. The downstream promise will then be pending
    until the returned promise is settled. This is called *assimilation*.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // The user's comments are now available
    });
    ```
  
    If the assimliated promise rejects, then the downstream promise will also reject.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // If `findCommentsByAuthor` fulfills, we'll have the value here
    }, function (reason) {
      // If `findCommentsByAuthor` rejects, we'll have the reason here
    });
    ```
  
    Simple Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let result;
  
    try {
      result = findResult();
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
    findResult(function(result, err){
      if (err) {
        // failure
      } else {
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findResult().then(function(result){
      // success
    }, function(reason){
      // failure
    });
    ```
  
    Advanced Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let author, books;
  
    try {
      author = findAuthor();
      books  = findBooksByAuthor(author);
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
  
    function foundBooks(books) {
  
    }
  
    function failure(reason) {
  
    }
  
    findAuthor(function(author, err){
      if (err) {
        failure(err);
        // failure
      } else {
        try {
          findBoooksByAuthor(author, function(books, err) {
            if (err) {
              failure(err);
            } else {
              try {
                foundBooks(books);
              } catch(reason) {
                failure(reason);
              }
            }
          });
        } catch(error) {
          failure(err);
        }
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findAuthor().
      then(findBooksByAuthor).
      then(function(books){
        // found books
    }).catch(function(reason){
      // something went wrong
    });
    ```
  
    @method then
    @param {Function} onFulfilled
    @param {Function} onRejected
    Useful for tooling.
    @return {Promise}
  */
  then: then,

  /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
  
    ```js
    function findAuthor(){
      throw new Error('couldn't find that author');
    }
  
    // synchronous
    try {
      findAuthor();
    } catch(reason) {
      // something went wrong
    }
  
    // async with promises
    findAuthor().catch(function(reason){
      // something went wrong
    });
    ```
  
    @method catch
    @param {Function} onRejection
    Useful for tooling.
    @return {Promise}
  */
  'catch': function _catch(onRejection) {
    return this.then(null, onRejection);
  }
};

/*global self*/
function polyfill$1() {
    var local = undefined;

    if (typeof global !== 'undefined') {
        local = global;
    } else if (typeof self !== 'undefined') {
        local = self;
    } else {
        try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
    }

    var P = local.Promise;

    if (P) {
        var promiseToString = null;
        try {
            promiseToString = Object.prototype.toString.call(P.resolve());
        } catch (e) {
            // silently ignored
        }

        if (promiseToString === '[object Promise]' && !P.cast) {
            return;
        }
    }

    local.Promise = Promise$2;
}

// Strange compat..
Promise$2.polyfill = polyfill$1;
Promise$2.Promise = Promise$2;

return Promise$2;

})));

//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(378)

module.exports = forEach

var toString = Object.prototype.toString
var hasOwnProperty = Object.prototype.hasOwnProperty

function forEach(list, iterator, context) {
    if (!isFunction(iterator)) {
        throw new TypeError('iterator must be a function')
    }

    if (arguments.length < 3) {
        context = this
    }
    
    if (toString.call(list) === '[object Array]')
        forEachArray(list, iterator, context)
    else if (typeof list === 'string')
        forEachString(list, iterator, context)
    else
        forEachObject(list, iterator, context)
}

function forEachArray(array, iterator, context) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            iterator.call(context, array[i], i, array)
        }
    }
}

function forEachString(string, iterator, context) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        iterator.call(context, string.charAt(i), i, string)
    }
}

function forEachObject(object, iterator, context) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            iterator.call(context, object[k], k, object)
        }
    }
}


/***/ }),
/* 362 */
/***/ (function(module, exports) {


var hasOwn = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

module.exports = function forEach (obj, fn, ctx) {
    if (toString.call(fn) !== '[object Function]') {
        throw new TypeError('iterator must be a function');
    }
    var l = obj.length;
    if (l === +l) {
        for (var i = 0; i < l; i++) {
            fn.call(ctx, obj[i], i, obj);
        }
    } else {
        for (var k in obj) {
            if (hasOwn.call(obj, k)) {
                fn.call(ctx, obj[k], k, obj);
            }
        }
    }
};



/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 364 */
/***/ (function(module, exports) {


/**
 * Module exports.
 *
 * Logic borrowed from Modernizr:
 *
 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
 */

try {
  module.exports = typeof XMLHttpRequest !== 'undefined' &&
    'withCredentials' in new XMLHttpRequest();
} catch (err) {
  // if XMLHttp support is disabled in IE then it will throw
  // when trying to create
  module.exports = false;
}


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(428);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(472);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(143);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(105);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(149);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(367);

var _PathUtils = __webpack_require__(143);

var _createTransitionManager = __webpack_require__(369);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _ExecutionEnvironment = __webpack_require__(366);

var _DOMUtils = __webpack_require__(365);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/mjackson/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$basename = props.basename,
      basename = _props$basename === undefined ? '' : _props$basename,
      _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    if (basename) path = (0, _PathUtils.stripPrefix)(path, basename);

    return _extends({}, (0, _PathUtils.parsePath)(path), {
      state: state,
      key: key
    });
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      (function () {
        var action = 'POP';

        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
          if (ok) {
            setState({ action: action, location: location });
          } else {
            revertPop(location);
          }
        });
      })();
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
     false ? (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
         false ? (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
     false ? (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
         false ? (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      return unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(105);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
     false ? (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time') : void 0;

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = close_braces;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(101);


function close_braces(retained_template, template) {
	var placeholder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'x';
	var empty_placeholder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' ';

	var cut_before = retained_template.length;

	var opening_braces = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* count_occurences */])('(', retained_template);
	var closing_braces = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* count_occurences */])(')', retained_template);

	var dangling_braces = opening_braces - closing_braces;

	while (dangling_braces > 0 && cut_before < template.length) {
		retained_template += template[cut_before].replace(placeholder, empty_placeholder);

		if (template[cut_before] === ')') {
			dangling_braces--;
		}

		cut_before++;
	}

	return retained_template;
}
//# sourceMappingURL=close braces.js.map

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getSelection;
/* harmony export (immutable) */ __webpack_exports__["c"] = getOperation;
/* harmony export (immutable) */ __webpack_exports__["d"] = getCaretPosition;
/* harmony export (immutable) */ __webpack_exports__["a"] = setCaretPosition;
// Gets <input/> selection bounds
function getSelection(element) {
	// If no selection, return nothing
	if (element.selectionStart === element.selectionEnd) {
		return;
	}

	return { start: element.selectionStart, end: element.selectionEnd };
}

// Key codes
var Keys = {
	Backspace: 8,
	Delete: 46
};

// Finds out the operation to be intercepted and performed
// based on the key down event `keyCode`.
function getOperation(event) {
	switch (event.keyCode) {
		case Keys.Backspace:
			return 'Backspace';

		case Keys.Delete:
			return 'Delete';
	}
}

// Gets <input/> caret position
function getCaretPosition(element) {
	return element.selectionStart;
}

// Sets <input/> caret position
function setCaretPosition(element, caret_position) {
	// Sanity check
	if (caret_position === undefined) {
		return;
	}

	// Set caret position
	element.setSelectionRange(caret_position, caret_position);
}
//# sourceMappingURL=dom.js.map

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = edit;
// Edits text `value` (if `operation` is passed) and repositions the `caret` if needed.
//
// Example:
//
// value - '88005553535'
// caret - 2 // starting from 0; is positioned before the first zero
// operation - 'Backspace'
//
// Returns
// {
// 	value: '8005553535'
// 	caret: 1
// }
//
// Currently supports just 'Delete' and 'Backspace' operations
//
function edit(value, caret, operation) {
	switch (operation) {
		case 'Backspace':
			// If there exists the previous character,
			// then erase it and reposition the caret.
			if (caret > 0) {
				// Remove the previous character
				value = value.slice(0, caret - 1) + value.slice(caret);
				// Position the caret where the previous (erased) character was
				caret--;
			}
			break;

		case 'Delete':
			// Remove current digit (if any)
			value = value.slice(0, caret) + value.slice(caret + 1);
			break;
	}

	return { value: value, caret: caret };
}
//# sourceMappingURL=edit.js.map

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DIGITS */
// Copied from `libphonenumber-js`:
// https://github.com/catamphetamine/libphonenumber-js/blob/master/source/parse.js
//
// These mappings map a character (key) to a specific digit that should
// replace it for normalization purposes. Non-European digits that
// may be used in phone numbers are mapped to a European equivalent.
//
// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
//
var DIGITS = {
	'0': '0',
	'1': '1',
	'2': '2',
	'3': '3',
	'4': '4',
	'5': '5',
	'6': '6',
	'7': '7',
	'8': '8',
	'9': '9',
	'\uFF10': '0', // Fullwidth digit 0
	'\uFF11': '1', // Fullwidth digit 1
	'\uFF12': '2', // Fullwidth digit 2
	'\uFF13': '3', // Fullwidth digit 3
	'\uFF14': '4', // Fullwidth digit 4
	'\uFF15': '5', // Fullwidth digit 5
	'\uFF16': '6', // Fullwidth digit 6
	'\uFF17': '7', // Fullwidth digit 7
	'\uFF18': '8', // Fullwidth digit 8
	'\uFF19': '9', // Fullwidth digit 9
	'\u0660': '0', // Arabic-indic digit 0
	'\u0661': '1', // Arabic-indic digit 1
	'\u0662': '2', // Arabic-indic digit 2
	'\u0663': '3', // Arabic-indic digit 3
	'\u0664': '4', // Arabic-indic digit 4
	'\u0665': '5', // Arabic-indic digit 5
	'\u0666': '6', // Arabic-indic digit 6
	'\u0667': '7', // Arabic-indic digit 7
	'\u0668': '8', // Arabic-indic digit 8
	'\u0669': '9', // Arabic-indic digit 9
	'\u06F0': '0', // Eastern-Arabic digit 0
	'\u06F1': '1', // Eastern-Arabic digit 1
	'\u06F2': '2', // Eastern-Arabic digit 2
	'\u06F3': '3', // Eastern-Arabic digit 3
	'\u06F4': '4', // Eastern-Arabic digit 4
	'\u06F5': '5', // Eastern-Arabic digit 5
	'\u06F6': '6', // Eastern-Arabic digit 6
	'\u06F7': '7', // Eastern-Arabic digit 7
	'\u06F8': '8', // Eastern-Arabic digit 8
	'\u06F9': '9' // Eastern-Arabic digit 9
};

/* unused harmony default export */ var _unused_webpack_default_export = (function (character, value) {
	return DIGITS[character];
});
//# sourceMappingURL=parse digit.js.map

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__input_controller__ = __webpack_require__(146);













// Usage:
//
// <ReactInput
// 	value={this.state.phone}
// 	onChange={phone => this.setState({ phone })}
// 	parse={character => character}
// 	format={value => ({ text: value, template: 'xxxxxxxx' })}/>
//

var ReactInput = function (_React$Component) {
	__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ReactInput, _React$Component);

	function ReactInput(props) {
		__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ReactInput);

		var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ReactInput.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ReactInput)).call(this, props));

		_this.store_instance = function (instance) {
			_this.input = instance;
		};

		_this.get_input_element = function () {
			return __WEBPACK_IMPORTED_MODULE_9_react_dom__["default"].findDOMNode(_this.input);
		};

		_this.on_blur = function (event) {
			var onBlur = _this.props.onBlur;

			// This `onBlur` interceptor is a workaround for `redux-form`,
			// so that it gets the right (parsed, not the formatted one)
			// `event.target.value` in its `onBlur` handler.

			if (onBlur) {
				var _event = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, event, {
					target: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, event.target, {
						value: _this.input_controller.getParsedValue().value
					})
				});

				// For `redux-form` event detection.
				// https://github.com/erikras/redux-form/blob/v5/src/events/isEvent.js
				_event.stopPropagation = event.stopPropagation;
				_event.preventDefault = event.preventDefault;

				onBlur(_event);
			}
		};

		_this.on_key_down = function (event) {
			var onKeyDown = _this.props.onKeyDown;


			if (onKeyDown) {
				onKeyDown(event);
			}

			_this.input_controller.onKeyDown(event);
		};

		var _this$props = _this.props,
		    parse = _this$props.parse,
		    format = _this$props.format,
		    onChange = _this$props.onChange;


		_this.input_controller = new __WEBPACK_IMPORTED_MODULE_10__input_controller__["a" /* default */](_this.get_input_element, parse, format, onChange);
		return _this;
	}

	__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ReactInput, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    value = _props.value,
			    parse = _props.parse,
			    format = _props.format,
			    inputComponent = _props.inputComponent,
			    rest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['value', 'parse', 'format', 'inputComponent']);

			// Non-string `inputComponent`s would work in this case
			// but it would also introduce a caret reset bug:
			// the caret position would reset on each input.
			// The origins of this bug are unknown, they may be
			// somehow related to the `ref` property
			// being intercepted by React here.


			return __WEBPACK_IMPORTED_MODULE_7_react__["default"].createElement(inputComponent, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rest, {
				ref: this.store_instance,
				value: format(is_empty(value) ? '' : value).text,
				onKeyDown: this.on_key_down,
				onChange: this.input_controller.onChange,
				onPaste: this.input_controller.onPaste,
				onCut: this.input_controller.onCut,
				onBlur: this.on_blur
			}));
		}

		// Returns <input/> DOM Element


		// This handler is a workaround for `redux-form`

	}, {
		key: 'focus',
		value: function focus() {
			this.get_input_element().focus();
		}
	}]);

	return ReactInput;
}(__WEBPACK_IMPORTED_MODULE_7_react__["default"].Component);

ReactInput.propTypes = {
	// Parses a single characher of `<input/>` text
	parse: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,

	// Formats `value` into `<input/>` text
	format: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,

	// Renders `<input/>` by default
	inputComponent: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired,

	// `<input/>` `type` attribute
	type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired,

	// Is parsed from <input/> text
	value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,

	// This handler is called each time `<input/>` text is changed
	onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,

	// This `onBlur` interceptor is a workaround for `redux-form`,
	// so that it gets the parsed `value` in its `onBlur` handler,
	// not the formatted text.
	onBlur: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,

	// Passthrough
	onKeyDown: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
};
ReactInput.defaultProps = {
	// Renders `<input/>` by default
	inputComponent: 'input',

	// `<input/>` `type` attribute
	type: 'text'
};
/* harmony default export */ __webpack_exports__["a"] = (ReactInput);


function is_empty(value) {
	return value === undefined || value === null;
}
//# sourceMappingURL=react input.js.map

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(101);


function template_parser(template, placeholder, parse) {
	if (typeof placeholder === 'function') {
		parse = placeholder;
		placeholder = 'x';
	}

	var max_characters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* count_occurences */])(placeholder, template);

	return function parse_character(character, value) {
		if (value.length >= max_characters) {
			return;
		}

		return parse(character, value);
	};
}
//# sourceMappingURL=template parser.js.map

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__es6_template_parser__ = __webpack_require__(376);
/* unused harmony reexport templateParser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__es6_template_formatter__ = __webpack_require__(148);
/* unused harmony reexport templateFormatter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__es6_input_controller__ = __webpack_require__(146);
/* unused harmony reexport InputController */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__es6_react_input__ = __webpack_require__(375);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__es6_react_input__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__es6_parse_digit__ = __webpack_require__(374);
/* unused harmony reexport parseDigit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__es6_parse__ = __webpack_require__(147);
/* unused harmony reexport parse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__es6_format__ = __webpack_require__(145);
/* unused harmony reexport format */














/***/ }),
/* 378 */
/***/ (function(module, exports) {

module.exports = isFunction

var toString = Object.prototype.toString

function isFunction (fn) {
  var string = toString.call(fn)
  return string === '[object Function]' ||
    (typeof fn === 'function' && string !== '[object RegExp]') ||
    (typeof window !== 'undefined' &&
     // IE8 and below
     (fn === window.setTimeout ||
      fn === window.alert ||
      fn === window.confirm ||
      fn === window.prompt))
};


/***/ }),
/* 379 */
/***/ (function(module, exports) {

module.exports = [["af","Afghanistan (‫افغانستان‬‎)"],["ax","Åland Islands"],["al","Albania (Shqipëri)"],["dz","Algeria (‫الجزائر‬‎)"],["as","American Samoa (Amerika Sāmoa)"],["ad","Andorra"],["ao","Angola"],["ai","Anguilla"],["ag","Antigua and Barbuda"],["ar","Argentina"],["am","Armenia (Հայաստան)"],["aw","Aruba"],["au","Australia"],["at","Austria (Österreich)"],["az","Azerbaijan (Azərbaycan)"],["bs","Bahamas"],["bh","Bahrain (‫البحرين‬‎)"],["bd","Bangladesh (বাংলাদেশ)"],["bb","Barbados"],["by","Belarus (Беларусь)"],["be","Belgium (België)"],["bz","Belize"],["bj","Benin (Bénin)"],["bm","Bermuda"],["bt","Bhutan (འབྲུག)"],["bo","Bolivia"],["ba","Bosnia and Herzegovina"],["bw","Botswana"],["br","Brazil (Brasil)"],["io","British Indian Ocean Territory"],["vg","British Virgin Islands"],["bn","Brunei (Negara Brunei Darussalam)"],["bg","Bulgaria (България)"],["bf","Burkina Faso"],["bi","Burundi (Uburundi)"],["kh","Cambodia (កម្ពុជា)"],["cm","Cameroon (Cameroun)"],["ca","Canada"],["cv","Cape Verde (Kabu Verdi)"],["bq","Caribbean Netherlands"],["ky","Cayman Islands"],["cf","Central African Republic"],["td","Chad (Tchad)"],["cl","Chile"],["cn","China (中国)"],["cx","Christmas Island"],["cc","Cocos (Keeling) Islands"],["co","Colombia"],["km","Comoros (‫جزر القمر‬‎)"],["cd","Congo (DRC) (Kongo)"],["cg","Congo (Republic) (Congo-Brazzaville)"],["ck","Cook Islands"],["cr","Costa Rica"],["ci","Côte d’Ivoire"],["hr","Croatia (Hrvatska)"],["cu","Cuba"],["cw","Curaçao"],["cy","Cyprus (Κύπρος)"],["cz","Czech Republic (Česká republika)"],["dk","Denmark (Danmark)"],["dj","Djibouti"],["dm","Dominica"],["do","Dominican Republic"],["ec","Ecuador"],["eg","Egypt (‫مصر‬‎)"],["sv","El Salvador"],["gq","Equatorial Guinea (Guinea Ecuatorial)"],["er","Eritrea"],["ee","Estonia (Eesti)"],["et","Ethiopia"],["fk","Falkland Islands (Islas Malvinas)"],["fo","Faroe Islands (Føroyar)"],["fj","Fiji (Matanitu Tugalala o Viti)"],["fi","Finland (Suomi)"],["fr","France (République française)"],["gf","French Guiana (Guyane française)"],["pf","French Polynesia (Polynésie française)"],["ga","Gabon (République gabonaise)"],["gm","Gambia"],["ge","Georgia (საქართველო)"],["de","Germany (Deutschland)"],["gh","Ghana (Gaana)"],["gi","Gibraltar"],["gr","Greece (Ελλάδα)"],["gl","Greenland (Kalaallit Nunaat)"],["gd","Grenada"],["gp","Guadeloupe"],["gu","Guam (Guåhån)"],["gt","Guatemala"],["gg","Guernsey"],["gn","Guinea (Guinée)"],["gw","Guinea-Bissau (Guiné Bissau)"],["gy","Guyana"],["ht","Haiti (République d'Haïti)"],["hn","Honduras"],["hk","Hong Kong (香港)"],["hu","Hungary (Magyarország)"],["is","Iceland (Ísland)"],["in","India (भारत)"],["id","Indonesia"],["ir","Iran (‫ایران‬‎)"],["iq","Iraq (‫العراق‬‎)"],["ie","Ireland"],["im","Isle of Man"],["il","Israel (‫ישראל‬‎)"],["it","Italy (Italia)"],["jm","Jamaica"],["jp","Japan (日本)"],["je","Jersey"],["jo","Jordan (‫الأردن‬‎)"],["kz","Kazakhstan (Казахстан)"],["ke","Kenya"],["ki","Kiribati"],["kw","Kuwait (‫الكويت‬‎)"],["kg","Kyrgyzstan (Кыргызстан)"],["la","Laos (ລາວ)"],["lv","Latvia (Latvija)"],["lb","Lebanon (‫لبنان‬‎)"],["ls","Lesotho"],["lr","Liberia"],["ly","Libya (‫ليبيا‬‎)"],["li","Liechtenstein"],["lt","Lithuania (Lietuva)"],["lu","Luxembourg (Lëtzebuerg)"],["mo","Macau (澳門)"],["mk","Macedonia (FYROM) (Македонија)"],["mg","Madagascar (Madagasikara)"],["mw","Malawi (Malaŵi)"],["my","Malaysia"],["mv","Maldives"],["ml","Mali"],["mt","Malta"],["mh","Marshall Islands"],["mq","Martinique"],["mr","Mauritania (‫موريتانيا‬‎)"],["mu","Mauritius (Moris)"],["yt","Mayotte"],["mx","Mexico (México)"],["fm","Micronesia"],["md","Moldova (Republica Moldova)"],["mc","Monaco"],["mn","Mongolia (Монгол)"],["me","Montenegro (Crna Gora)"],["ms","Montserrat"],["ma","Morocco (‫المغرب‬‎)"],["mz","Mozambique (Moçambique)"],["mm","Myanmar (Burma) (မြန်မာ)"],["na","Namibia (Namibië)"],["nr","Nauru (Repubrikin Naoero)"],["np","Nepal (नेपाल)"],["nl","Netherlands (Nederland)"],["nc","New Caledonia (Nouvelle-Calédonie)"],["nz","New Zealand"],["ni","Nicaragua"],["ne","Niger (Nijar)"],["ng","Nigeria"],["nu","Niue (Niuē)"],["nf","Norfolk Island"],["kp","North Korea (조선 민주주의 인민 공화국)"],["mp","Northern Mariana Islands"],["no","Norway (Norge)"],["om","Oman (‫عُمان‬‎)"],["pk","Pakistan (‫پاکستان‬‎)"],["pw","Palau (Beluu er a Belau)"],["ps","Palestine (‫فلسطين‬‎)"],["pa","Panama (Panamá)"],["pg","Papua New Guinea"],["py","Paraguay (Tetã Paraguái)"],["pe","Peru (Perú)"],["ph","Philippines (Republika ng Pilipinas)"],["pl","Poland (Polska)"],["pt","Portugal (República Portuguesa)"],["pr","Puerto Rico"],["qa","Qatar (‫قطر‬‎)"],["re","Réunion (La Réunion)"],["ro","Romania (România)"],["ru","Russia (Россия)"],["rw","Rwanda"],["bl","Saint Barthélemy (Saint-Barthélemy)"],["sh","Saint Helena"],["kn","Saint Kitts and Nevis"],["lc","Saint Lucia"],["mf","Saint Martin (Saint-Martin)"],["pm","Saint Pierre and Miquelon"],["vc","Saint Vincent and the Grenadines"],["ws","Samoa (Sāmoa)"],["sm","San Marino"],["st","São Tomé and Príncipe"],["sa","Saudi Arabia (‫المملكة العربية السعودية‬‎)"],["sn","Senegal (Sénégal)"],["rs","Serbia (Србија)"],["sc","Seychelles (Repiblik Sesel)"],["sl","Sierra Leone"],["sg","Singapore (Singapura) (新加坡共和国)"],["sx","Sint Maarten"],["sk","Slovakia (Slovensko)"],["si","Slovenia (Slovenija)"],["sb","Solomon Islands"],["so","Somalia (Soomaaliya)"],["za","South Africa"],["kr","South Korea (대한민국)"],["ss","South Sudan (‫جنوب السودان‬‎)"],["es","Spain (España)"],["lk","Sri Lanka (ශ්‍රී ලංකාව)"],["sd","Sudan (‫السودان‬‎)"],["sr","Suriname"],["sj","Svalbard and Jan Mayen"],["sz","Swaziland (Umbuso weSwatini)"],["se","Sweden (Sverige)"],["ch","Switzerland (Schweiz)"],["sy","Syria (‫سوريا‬‎)"],["tw","Taiwan (台灣)"],["tj","Tajikistan (Ҷумҳурии Тоҷикистон)"],["tz","Tanzania"],["th","Thailand (ไทย)"],["tl","Timor-Leste (Timór-Leste)"],["tg","Togo (République togolaise)"],["tk","Tokelau"],["to","Tonga"],["tt","Trinidad and Tobago"],["tn","Tunisia (‫تونس‬‎)"],["tr","Turkey (Türkiye)"],["tm","Turkmenistan (Türkmenistan)"],["tc","Turks and Caicos Islands"],["tv","Tuvalu"],["vi","U.S. Virgin Islands"],["ug","Uganda"],["ua","Ukraine (Україна)"],["ae","United Arab Emirates (‫الإمارات العربية المتحدة‬‎)"],["gb","United Kingdom"],["us","United States"],["uy","Uruguay"],["uz","Uzbekistan (Oʻzbekiston)"],["vu","Vanuatu"],["va","Vatican City (Città del Vaticano)"],["ve","Venezuela"],["vn","Vietnam (Việt Nam)"],["wf","Wallis and Futuna (Wallis-et-Futuna)"],["eh","Western Sahara (‫الصحراء الغربية‬‎)"],["ye","Yemen (‫اليمن‬‎)"],["zm","Zambia"],["zw","Zimbabwe"]]

/***/ }),
/* 380 */
/***/ (function(module, exports) {

module.exports = {"welcome":{"title":"Open your new bank account","description_p_1":"To open a bank account, we will need to verify your identity.","description_p_2":"It will only take a couple of minutes.","next_button":"Verify Identity"},"document_selector":{"identity":{"title":"Verify your identity","hint":"Select the type of document you would like to upload","passport_hint":"Face photo page","driving_licence_hint":"Front and back","national_identity_card_hint":"Front and back"},"proof_of_address":{"title":"Select a UK document","hint":"These are the documents most likely to show your current home address","estatements_accepted":"e-statements accepted","utility_bill_hint":"Gas, electricity, water, landline, or broadband","utility_bill_warning":"Sorry, no mobile phone bills","benefits_letter_hint":"Government authorised household benefits eg. Jobseeker allowance, Housing benefit"}},"capture":{"driving_licence":{"front":{"title":"Front of license","instructions":"Upload front of license from your computer","webcam":"Position the front of license in the frame (it will be automatically detected)"},"back":{"title":"Back of license","instructions":"Upload back of license from your computer","webcam":"Position the back of license in the frame (it will be automatically detected)"}},"national_identity_card":{"front":{"title":"Front of card","instructions":"Upload front of card from your computer","webcam":"Position the front of card in the frame (it will be automatically detected)"},"back":{"title":"Back of card","instructions":"Upload back of card from your computer","webcam":"Position the back of card in the frame (it will be automatically detected)"}},"passport":{"front":{"title":"Passport photo page","instructions":"Upload passport photo page from your computer","webcam":"Position your passport photo page in the frame (it will be automatically detected)"}},"bank_building_society_statement":{"front":{"title":"Bank Statement","sub_title":"Must be issued in the <strong>last 3 months</strong>","instructions":"Provide the whole document page for best results","webcam":"Position your bank statement in the frame (it will be automatically detected)"}},"utility_bill":{"front":{"title":"Utility Bill","sub_title":"Must be issued in the <strong>last 3 months</strong>","instructions":"Provide the whole document page for best results","webcam":"Position your utility bill in the frame (it will be automatically detected)"}},"benefit_letters":{"front":{"title":"Benefits Letter","sub_title":"Must be issued in the <strong>last 12 months</strong>","instructions":"Provide the whole document page for best results","webcam":"Position your benefits letter in the frame (it will be automatically detected)"}},"council_tax":{"front":{"title":"Council Tax Letter","sub_title":"Must be issued in the <strong>last 12 months</strong>","instructions":"Provide the whole document page for best results","webcam":"Position your council tax letter in the frame (it will be automatically detected)"}},"face":{"title":"Take a selfie","upload_title":"Selfie","instructions":"Upload a selfie from your computer"},"liveness":{"start":"Start","stop":"Stop","recording":"Recording","press_record":"Press record and follow the instructions","intro":{"title":"Let’s make sure nobody’s impersonating you","two_actions":"We’ll ask you to film yourself performing <bolder>2 simple actions</bolder>","speak_out_loud":"One will involve <bolder>speaking out loud</bolder>","continue":"Continue"},"challenges":{"position_face":"Position your face in the oval","recite":"Say each digit out loud","movement":"Look over your %{side} shoulder","right":"right","left":"left","done_next":"When you’re done, press next","done_stop":"When you’re done, press stop","next":"Next"}},"upload_document":"Upload","upload_file":"Upload file","take_photo":"Take photo"},"confirm":{"document":{"title":"Check readability"},"driving_licence":{"message":"Make sure your license details are clear to read, with no blur or glare"},"national_identity_card":{"message":"Make sure your card details are clear to read, with no blur or glare"},"passport":{"message":"Make sure your passport details are clear to read, with no blur or glare"},"bank_building_society_statement":{"message":"Make sure details are clear to read, with no blur or glare"},"utility_bill":{"message":"Make sure details are clear to read, with no blur or glare"},"benefit_letters":{"message":"Make sure details are clear to read, with no blur or glare"},"council_tax":{"message":"Make sure details are clear to read, with no blur or glare"},"face":{"standard":{"title":"Check selfie","message":"Make sure your selfie clearly shows your face"},"video":{"title":"Check selfie video"}},"confirm":"Confirm","continue":"Continue","redo":"Redo","enlarge_image":{"enlarge":"Enlarge image","close":"Close"}},"complete":{"message":"Verification complete","submessage":"Thank you."},"cross_device":{"intro":{"document":{"title":"Continue verification on your mobile","take_photos":"We’ll walk you through taking the photos","action":"Let’s start"},"face":{"title":"Continue face verification on your mobile","take_photos":"Complete face verification to prove it’s really you","action":"Continue"},"sub_title":"It’s easy, fast and secure.","sms":"We’ll SMS a secure link to your mobile (no app download required)","return_computer":"Return to your computer to complete your verification"},"client_success":{"title":"Uploads successful","sub_title":"You can now return to your computer to continue","body":"Your computer may take a few seconds to update"},"link":{"title":"Get your secure link","sub_title":"We’ll text a <em>one-time secure link</em> to your mobile","link_copy":{"action":"Copy","success":"Copied"},"button_copy":{"action":"Send link","status":"Sending"},"sms_label":"Mobile number","copy_link_label":"Copy link instead:"},"submit":{"title":"Great, that’s everything we need","sub_title":"We’re now ready to verify your identity","selfie_uploaded":"Selfie uploaded","video_uploaded":"Video uploaded","action":"Submit verification","multiple_docs_uploaded":"Documents uploaded","one_doc_uploaded":"Document uploaded"},"phone_number_placeholder":"Enter mobile number","loading":"Loading...","mobile_connected":{"title":{"message":"Connected to your mobile","submessage":"Once you've finished we'll take you to the next step"},"tips":{"item_1":"Keep this window open while using your mobile","item_2":"Your mobile link will expire in one hour","item_3":"Don't refresh this page"}},"mobile_notification_sent":{"title":"Check your mobile","submessage":"We’ve sent a secure link to %{number}","bold_message":"It may take a few minutes to arrive","tips":{"item_1":"Keep this window open while using your mobile","item_2":"Your mobile link will expire in one hour"},"resend_link":"Resend link"},"switch_device":{"header":"Need to use your mobile to take photos?","submessage":"Securely continue verification on your mobile"},"tips":"Tips"},"privacy":{"title":"You'll have to upload a photo of your identity document","item_1":"All your document details must be visible","item_2":"Your document must be in colour","item_3":"Avoid light reflections","small_print":"By continuing, you agree to the <terms>Onfido Terms of Use</terms> and understand that your information, including your facial identifiers, will be processed in accordance with the <privacy>Onfido Privacy Policy</privacy>","decline":"Decline","continue":"Continue"},"webcam_permissions":{"allow_access":"Allow camera access","enable_webcam_for_selfie":"Enable your camera to continue face verification","click_allow":"Click Allow on the popup that will appear on the next screen","allow":"Allow","why":"Why do I need to do this?","if_denied":"If you deny camera access, you won't be able to take pictures and complete verification process.","enable_webcam":"Enable camera","access_denied":"Camera access is denied","recover_access":"Recover camera access to continue face verification","recovery":"Recovery","follow_steps":"Follow these steps to recover camera access:","grant_access":"Grant access to your camera from your browser settings","refresh_page":"Refresh this page to restart the identity verification process","refresh":"Refresh"},"proof_of_address":{"intro":{"title":"Let’s verify your UK address","requirements":"You’ll need a document that:","shows_address":"Shows your <strong>current</strong> address","matches_signup":"<strong>Matches</strong> the address you used on signup","is_recent":"Is your most <strong>recent</strong> document","start":"Start verification"},"guidance":{"logo":"Logo","full_name":"Full Name","make_sure_it_shows":"Make sure it clearly shows:","current_address":"Current Address","issue_date":"Issue date or Summary dates","continue":"Continue"}},"errors":{"invalid_capture":{"message":"No document detected","instruction":"Make sure all the document is in the photo"},"invalid_type":{"message":"File not uploading","instruction":"Try using another file type"},"unsupported_file":{"message":"Unsupported file type","instruction":"Try using a .jpg or .png file"},"invalid_size":{"message":"File size too large","instruction":"Size needs to be smaller than 10MB"},"no_face":{"message":"No face found","instruction":"Your face is needed in the selfie"},"multiple_faces":{"message":"Multiple faces found","instruction":"Only your face can be in the selfie"},"server_error":{"message":"Connection lost","instruction":"Please try again"},"glare_detected":{"message":"Glare detected","instruction":"All details should be clear and readable"},"sms_failed":{"message":"Something's gone wrong","instruction":"Copy the below link to your mobile instead"},"sms_overuse":{"message":"Too many resend attempts","instruction":"Copy the below link to your mobile instead"},"lazy_loading":{"message":"An error occurred while loading the component"},"invalid_number":{"message":"Check your mobile number is correct"},"generic_client_error":{"message":"Something's gone wrong","instruction":"You’ll need to restart your verification on your computer"},"camera_not_working":{"message":"Your camera isn’t working","instruction":"It may be disconnected or not functional. <fallback>Use your mobile</fallback> to continue verification."},"liveness_timeout":{"message":"Looks like you took too long","instruction":"Remember to press stop when you're done. <fallback>Redo video actions</fallback>"},"camera_inactive":{"message":"Having camera problems?","instruction":"<fallback>Use your mobile</fallback> to continue face verification"}},"passport":"Passport","driving_licence":"Driver's License","national_identity_card":"Identity Card","short_passport":"passport","short_driving_licence":"license","short_national_identity_card":"card","bank_building_society_statement":"Bank/Building Society Statement","utility_bill":"Utility Bill","benefit_letters":"Benefits Letter","council_tax":"Council Tax Letter","back":"back","cancel":"Cancel"}

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports = {"welcome":{"title":"Abra su nueva cuenta bancaria","description_p_1":"Para abrir una cuenta bancaria, necesitaremos verificar su identidad.","description_p_2":"Sólo tomará un par de minutos.","next_button":"Verificar identidad"},"document_selector":{"identity":{"title":"Verifique su identidad","hint":"Seleccione el tipo de documento que desea subir","passport_hint":"Página del pasaporte con su foto","driving_licence_hint":"Frente y reverso","national_identity_card_hint":"Frente y reverso"}},"capture":{"driving_licence":{"front":{"title":"Frente de la licencia","instructions":"Suba el frente de la licencia desde su computadora","webcam":"Coloque el frente de la licencia en el cuadro (será detectado automáticamente)"},"back":{"title":"Reverso de la licencia","instructions":"Suba el reverso de la licencia desde su computadora","webcam":"Coloque el reverso de la licencia en el cuadro (será detectado automáticamente)"}},"national_identity_card":{"front":{"title":"Frente de la tarjeta","instructions":"Suba el frente de la tarjeta desde su computadora","webcam":"Coloque el frente de la tarjeta en el cuadro (será detectado automáticamente)"},"back":{"title":"Reverso de la tarjeta","instructions":"Suba el reverso de la tarjeta desde su computadora","webcam":"Coloque el reverso de la tarjeta en el cuadro (será detectado automáticamente)"}},"passport":{"front":{"title":"Página del pasaporte con su foto","instructions":"Suba la página del pasaporte con su foto desde su computadora","webcam":"Coloque la página del pasaporte con su foto en el cuadro (será detectado automáticamente)"}},"face":{"title":"Tómese una selfie","upload_title":"Selfie","instructions":"Suba una selfie desde su computadora"},"liveness":{"start":"Iniciar","stop":"Parar","recording":"Grabando","press_record":"Presione grabar y siga las instrucciones","intro":{"title":"Asegurémonos de que nadie se está haciendo pasar por usted","two_actions":"Le pediremos que se grabe en video ejecutando <bolder>dos simples acciones</bolder>","speak_out_loud":"Una de ellas implicará <bolder>hablar en voz alta</bolder>","continue":"Continuar"},"challenges":{"position_face":"Coloque su cara en el óvalo","recite":"Lea en voz alta cada dígito","movement":"Mire sobre su hombro %{side}","right":"derecho","left":"izquierdo","done_next":"Cuando esté listo, presione continuar","done_stop":"Cuando esté listo, presione parar","next":"Siguiente"}},"upload_document":"Subir","upload_file":"Subir archivo","take_photo":"Tomar foto"},"confirm":{"document":{"title":"Compruebe la legibilidad"},"driving_licence":{"message":"Asegúrese de que los datos de su licencia se puedan leer claramente, sin borrosidades ni brillo"},"national_identity_card":{"message":"Asegúrese de que los datos de su tarjeta se puedan leer claramente, sin borrosidades ni brillo"},"passport":{"message":"Asegúrese de que los datos de su pasaporte se puedan leer claramente, sin borrosidades ni brillo"},"face":{"standard":{"title":"Verificar selfie","message":"Asegúrese de que la selfie muestre claramente su cara"},"video":{"title":"Verificar video selfie"}},"confirm":"Confirmar","continue":"Continuar","redo":"Reintentar","enlarge_image":{"enlarge":"Ampliar imagen","close":"Cerrar"}},"complete":{"message":"Verificación completa","submessage":"Gracias."},"cross_device":{"intro":{"document":{"title":"Continúe la verificación en su móvil","take_photos":"Lo guiaremos en cómo tomar fotos","action":"Empecemos"},"face":{"title":"Continúe la verificación facial en su móvil","take_photos":"Complete la verificación facial para probar que es realmente usted","action":"Continuar"},"sub_title":"Es fácil, rápido y seguro.","sms":"Enviaremos un vínculo seguro a su móvil por SMS (no requiere descargar una aplicación)","return_computer":"Vuelva a su computadora para completar la verificación"},"client_success":{"title":"Carga completa","sub_title":"Ahora puede volver a su computadora para continuar","body":"Su computadora puede tardar unos segundos en actualizarse"},"link":{"title":"Obtenga su link seguro","sub_title":"Le enviaremos un <em>mensaje de texto único</em> con un enlace a su móvil","link_copy":{"action":"Copiar","success":"Copiado"},"button_copy":{"action":"Enviar enlace","status":"Enviando"},"sms_label":"Número de teléfono móvil","copy_link_label":"Copiar enlace en su lugar"},"submit":{"title":"Genial, eso es todo","sub_title":"Estamos listos para verificar su identidad","selfie_uploaded":"Selfie cargado","video_uploaded":"Video cargado","action":"Enviar verificación","multiple_docs_uploaded":"Documentos cargados","one_doc_uploaded":"Documento cargado"},"phone_number_placeholder":"Introduzca su número de móvil","loading":"Cargando...","mobile_connected":{"title":{"message":"Conectado con su móvil","submessage":"Cuando haya terminado, le llevaremos al próximo paso"},"tips":{"item_1":"No cierre esta ventana mientras usa su móvil","item_2":"El enlace móvil caducará en una hora","item_3":"No actualizar esta página"}},"mobile_notification_sent":{"title":"Controle su dispositivo móvil","submessage":"Hemos enviado un enlace seguro a %{number}","bold_message":"Puede tardar unos minutos en llegar","tips":{"item_1":"Mantenga esta ventana abierta mientras usa su dispositivo móvil","item_2":"Su enlace móvil caducará en una hora"},"resend_link":"Reenviar enlace"},"switch_device":{"header":"¿Necesita usar su móvil para tomar fotos?","submessage":"Continúe la verificación de forma segura en su dispositivo móvil"},"tips":"Tips"},"privacy":{"title":"Tendrá que subir una foto de su documento de identidad","item_1":"Todos los datos de su documento tienen que ser visibles","item_2":"El documento debe ser en color","item_3":"Evite los reflejos","small_print":"Al continuar, usted está de acuerdo con los <terms>Términos de Uso de Onfido</terms> y comprende que su información, incluidos sus identificadores faciales, se procesará de acuerdo con la <privacy>Política de privacidad de Onfido</privacy>","decline":"Declinar","continue":"Continuar"},"webcam_permissions":{"allow_access":"Permitir acceso a la cámara","enable_webcam_for_selfie":"Active su cámara para continuar la verificación facial","click_allow":"Haga clic en Permitir en la ventana emergente que aparecerá a continuación","allow":"Permitir","why":"¿Por qué necesita hacer esto?","if_denied":"Si niega accesso a la cámara, no podrá tomar fotos para completar el proceso de verificación","enable_webcam":"Activar cámara","access_denied":"Acceso a la cámara no permitido","recover_access":"Recupere acceso a la cámara para continuar la verificación facial","recovery":"Recuperación","follow_steps":"Siga estos pasos para recuperar acceso a la cámara:","grant_access":"Autorice acceso a su cámara desde los ajustes del navegador","refresh_page":"Actualice esta página para reiniciar el proceso de verificación","refresh":"Actualizar"},"errors":{"invalid_capture":{"message":"Documento no detectado","instruction":"Asegúrese de que todo el documento esté en la foto"},"invalid_type":{"message":"Archivo no cargado","instruction":"Intenta usar otro tipo de archivo"},"unsupported_file":{"message":"Tipo de archivo no admitido","instruction":"Intente usar un archivo .jpg o .png"},"invalid_size":{"message":"Tamaño de archivo demasiado grande","instruction":"El tamaño debe ser menor de 10 MB"},"no_face":{"message":"Cara no encontrada","instruction":"Su cara debe de estar en la selfie"},"multiple_faces":{"message":"Múltiples caras encontradas","instruction":"Solo su cara puede estar en la selfie"},"server_error":{"message":"Conexión perdida","instruction":"Inténtalo de nuevo"},"glare_detected":{"message":"Brillo detectado","instruction":"Todos los detalles deben ser claros y legibles"},"sms_failed":{"message":"Algo salió mal","instruction":"Copie el enlace a continuación en su dispositivo móvil"},"sms_overuse":{"message":"Demasiados intentos de reenvío","instruction":"Copie el enlace a continuación en su dispositivo móvil"},"lazy_loading":{"message":"Se produjo un error al cargar el componente"},"invalid_number":{"message":"Compruebe que su número de móvil sea correcto"},"generic_client_error":{"message":"Algo salió mal","instruction":"Deberá reiniciar su verificación en su computadora"},"camera_not_working":{"message":"Su cámara no esta funcionando","instruction":"Puede estar desconectada o no funcionando. <fallback>Use su móvil</fallback> para continuar la verificación"},"liveness_timeout":{"message":"Parece que ha demorado demasiado","instruction":"Recuerde presionar detener cuando esté listo. <fallback>Rehacer acciones</fallback>"},"camera_inactive":{"message":"¿Algun problema con su cámara?","instruction":"<fallback>Use su móvil</fallback> para continuar la verificación facial"}},"passport":"Pasaporte","driving_licence":"Licencia de conducir","national_identity_card":"Tarjeta de identificación","short_passport":"pasaporte","short_driving_licence":"licencia","short_national_identity_card":"tarjeta","back":"atrás","cancel":"Cancelar"}

/***/ }),
/* 382 */
/***/ (function(module, exports) {

module.exports = {"capture":{"driving_licence":{"front":{"instructions":"Take a photo of the front of your license"},"back":{"instructions":"Take a photo of the back of your license"}},"national_identity_card":{"front":{"instructions":"Take a photo of the front of your card"},"back":{"instructions":"Take a photo of the back of your card"}},"passport":{"front":{"instructions":"Take a photo of your passport photo page"}},"face":{"instructions":"Take a selfie showing your face"}},"errors":{"camera_not_working":{"instruction":"Try the <fallback>basic camera mode</fallback> instead"},"camera_inactive":{"instruction":"Try the <fallback>basic camera mode</fallback> instead"}}}

/***/ }),
/* 383 */
/***/ (function(module, exports) {

module.exports = {"capture":{"driving_licence":{"front":{"instructions":"Tome una foto del frente de su licencia"},"back":{"instructions":"Tome una foto del reverso de su licencia"}},"national_identity_card":{"front":{"instructions":"Tome una foto del frente de su tarjeta"},"back":{"instructions":"Tome una foto del reverso de su tarjeta"}},"passport":{"front":{"instructions":"Tome una foto de la página del pasaporte que incluye su fotografía"}},"face":{"instructions":"Tome una selfie que muestre su cara"}},"errors":{"camera_not_working":{"instruction":"Puede estar desconectada o no funcionando. Pruebe el <fallback>modo de cámara básica</fallback> en su lugar"},"camera_inactive":{"instruction":"Pruebe el <fallback>modo de cámara básica</fallback> en su lugar"}}}

/***/ }),
/* 384 */
/***/ (function(module, exports) {

exports = module.exports = stringify
exports.getSerialize = serializer

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
}

function serializer(replacer, cycleReplacer) {
  var stack = [], keys = []

  if (cycleReplacer == null) cycleReplacer = function(key, value) {
    if (stack[0] === value) return "[Circular ~]"
    return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]"
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = stack.indexOf(this)
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
      if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value)
    }
    else stack.push(value)

    return replacer == null ? value : replacer.call(this, key, value)
  }
}


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(156),
    getRawTag = __webpack_require__(388),
    objectToString = __webpack_require__(389);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(390);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(156);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 389 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 390 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(386);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 392 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 393 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
//     (c) 2012-2016 Airbnb, Inc.
//
//     polyglot.js may be freely distributed under the terms of the BSD
//     license. For all licensing information, details, and documention:
//     http://airbnb.github.com/polyglot.js
//
//
// Polyglot.js is an I18n helper library written in JavaScript, made to
// work both in the browser and in Node. It provides a simple solution for
// interpolation and pluralization, based off of Airbnb's
// experience adding I18n functionality to its Backbone.js and Node apps.
//
// Polylglot is agnostic to your translation backend. It doesn't perform any
// translation; it simply gives you a way to manage translated phrases from
// your client- or server-side JavaScript application.
//



var forEach = __webpack_require__(361);
var warning = __webpack_require__(105);
var has = __webpack_require__(142);
var trim = __webpack_require__(435);

var warn = function warn(message) {
  warning(false, message);
};

var replace = String.prototype.replace;
var split = String.prototype.split;

// #### Pluralization methods
// The string that separates the different phrase possibilities.
var delimeter = '||||';

// Mapping from pluralization group plural logic.
var pluralTypes = {
  arabic: function (n) {
    // http://www.arabeyes.org/Plural_Forms
    if (n < 3) { return n; }
    if (n % 100 >= 3 && n % 100 <= 10) return 3;
    return n % 100 >= 11 ? 4 : 5;
  },
  chinese: function () { return 0; },
  german: function (n) { return n !== 1 ? 1 : 0; },
  french: function (n) { return n > 1 ? 1 : 0; },
  russian: function (n) {
    if (n % 10 === 1 && n % 100 !== 11) { return 0; }
    return n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
  },
  czech: function (n) {
    if (n === 1) { return 0; }
    return (n >= 2 && n <= 4) ? 1 : 2;
  },
  polish: function (n) {
    if (n === 1) { return 0; }
    return n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
  },
  icelandic: function (n) { return (n % 10 !== 1 || n % 100 === 11) ? 1 : 0; }
};

// Mapping from pluralization group to individual locales.
var pluralTypeToLanguages = {
  arabic: ['ar'],
  chinese: ['fa', 'id', 'ja', 'ko', 'lo', 'ms', 'th', 'tr', 'zh'],
  german: ['da', 'de', 'en', 'es', 'fi', 'el', 'he', 'hu', 'it', 'nl', 'no', 'pt', 'sv'],
  french: ['fr', 'tl', 'pt-br'],
  russian: ['hr', 'ru', 'lt'],
  czech: ['cs', 'sk'],
  polish: ['pl'],
  icelandic: ['is']
};

function langToTypeMap(mapping) {
  var ret = {};
  forEach(mapping, function (langs, type) {
    forEach(langs, function (lang) {
      ret[lang] = type;
    });
  });
  return ret;
}

function pluralTypeName(locale) {
  var langToPluralType = langToTypeMap(pluralTypeToLanguages);
  return langToPluralType[locale]
    || langToPluralType[split.call(locale, /-/, 1)[0]]
    || langToPluralType.en;
}

function pluralTypeIndex(locale, count) {
  return pluralTypes[pluralTypeName(locale)](count);
}

var dollarRegex = /\$/g;
var dollarBillsYall = '$$';
var tokenRegex = /%\{(.*?)\}/g;

// ### transformPhrase(phrase, substitutions, locale)
//
// Takes a phrase string and transforms it by choosing the correct
// plural form and interpolating it.
//
//     transformPhrase('Hello, %{name}!', {name: 'Spike'});
//     // "Hello, Spike!"
//
// The correct plural form is selected if substitutions.smart_count
// is set. You can pass in a number instead of an Object as `substitutions`
// as a shortcut for `smart_count`.
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', {smart_count: 1}, 'en');
//     // "1 new message"
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', {smart_count: 2}, 'en');
//     // "2 new messages"
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', 5, 'en');
//     // "5 new messages"
//
// You should pass in a third argument, the locale, to specify the correct plural type.
// It defaults to `'en'` with 2 plural forms.
function transformPhrase(phrase, substitutions, locale) {
  if (typeof phrase !== 'string') {
    throw new TypeError('Polyglot.transformPhrase expects argument #1 to be string');
  }

  if (substitutions == null) {
    return phrase;
  }

  var result = phrase;

  // allow number as a pluralization shortcut
  var options = typeof substitutions === 'number' ? { smart_count: substitutions } : substitutions;

  // Select plural form: based on a phrase text that contains `n`
  // plural forms separated by `delimeter`, a `locale`, and a `substitutions.smart_count`,
  // choose the correct plural form. This is only done if `count` is set.
  if (options.smart_count != null && result) {
    var texts = split.call(result, delimeter);
    result = trim(texts[pluralTypeIndex(locale || 'en', options.smart_count)] || texts[0]);
  }

  // Interpolate: Creates a `RegExp` object for each interpolation placeholder.
  result = replace.call(result, tokenRegex, function (expression, argument) {
    if (!has(options, argument) || options[argument] == null) { return expression; }
    // Ensure replacement value is escaped to prevent special $-prefixed regex replace tokens.
    return replace.call(options[argument], dollarRegex, dollarBillsYall);
  });

  return result;
}

// ### Polyglot class constructor
function Polyglot(options) {
  var opts = options || {};
  this.phrases = {};
  this.extend(opts.phrases || {});
  this.currentLocale = opts.locale || 'en';
  var allowMissing = opts.allowMissing ? transformPhrase : null;
  this.onMissingKey = typeof opts.onMissingKey === 'function' ? opts.onMissingKey : allowMissing;
  this.warn = opts.warn || warn;
}

// ### polyglot.locale([locale])
//
// Get or set locale. Internally, Polyglot only uses locale for pluralization.
Polyglot.prototype.locale = function (newLocale) {
  if (newLocale) this.currentLocale = newLocale;
  return this.currentLocale;
};

// ### polyglot.extend(phrases)
//
// Use `extend` to tell Polyglot how to translate a given key.
//
//     polyglot.extend({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     });
//
// The key can be any string.  Feel free to call `extend` multiple times;
// it will override any phrases with the same key, but leave existing phrases
// untouched.
//
// It is also possible to pass nested phrase objects, which get flattened
// into an object with the nested keys concatenated using dot notation.
//
//     polyglot.extend({
//       "nav": {
//         "hello": "Hello",
//         "hello_name": "Hello, %{name}",
//         "sidebar": {
//           "welcome": "Welcome"
//         }
//       }
//     });
//
//     console.log(polyglot.phrases);
//     // {
//     //   'nav.hello': 'Hello',
//     //   'nav.hello_name': 'Hello, %{name}',
//     //   'nav.sidebar.welcome': 'Welcome'
//     // }
//
// `extend` accepts an optional second argument, `prefix`, which can be used
// to prefix every key in the phrases object with some string, using dot
// notation.
//
//     polyglot.extend({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     }, "nav");
//
//     console.log(polyglot.phrases);
//     // {
//     //   'nav.hello': 'Hello',
//     //   'nav.hello_name': 'Hello, %{name}'
//     // }
//
// This feature is used internally to support nested phrase objects.
Polyglot.prototype.extend = function (morePhrases, prefix) {
  forEach(morePhrases, function (phrase, key) {
    var prefixedKey = prefix ? prefix + '.' + key : key;
    if (typeof phrase === 'object') {
      this.extend(phrase, prefixedKey);
    } else {
      this.phrases[prefixedKey] = phrase;
    }
  }, this);
};

// ### polyglot.unset(phrases)
// Use `unset` to selectively remove keys from a polyglot instance.
//
//     polyglot.unset("some_key");
//     polyglot.unset({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     });
//
// The unset method can take either a string (for the key), or an object hash with
// the keys that you would like to unset.
Polyglot.prototype.unset = function (morePhrases, prefix) {
  if (typeof morePhrases === 'string') {
    delete this.phrases[morePhrases];
  } else {
    forEach(morePhrases, function (phrase, key) {
      var prefixedKey = prefix ? prefix + '.' + key : key;
      if (typeof phrase === 'object') {
        this.unset(phrase, prefixedKey);
      } else {
        delete this.phrases[prefixedKey];
      }
    }, this);
  }
};

// ### polyglot.clear()
//
// Clears all phrases. Useful for special cases, such as freeing
// up memory if you have lots of phrases but no longer need to
// perform any translation. Also used internally by `replace`.
Polyglot.prototype.clear = function () {
  this.phrases = {};
};

// ### polyglot.replace(phrases)
//
// Completely replace the existing phrases with a new set of phrases.
// Normally, just use `extend` to add more phrases, but under certain
// circumstances, you may want to make sure no old phrases are lying around.
Polyglot.prototype.replace = function (newPhrases) {
  this.clear();
  this.extend(newPhrases);
};


// ### polyglot.t(key, options)
//
// The most-used method. Provide a key, and `t` will return the
// phrase.
//
//     polyglot.t("hello");
//     => "Hello"
//
// The phrase value is provided first by a call to `polyglot.extend()` or
// `polyglot.replace()`.
//
// Pass in an object as the second argument to perform interpolation.
//
//     polyglot.t("hello_name", {name: "Spike"});
//     => "Hello, Spike"
//
// If you like, you can provide a default value in case the phrase is missing.
// Use the special option key "_" to specify a default.
//
//     polyglot.t("i_like_to_write_in_language", {
//       _: "I like to write in %{language}.",
//       language: "JavaScript"
//     });
//     => "I like to write in JavaScript."
//
Polyglot.prototype.t = function (key, options) {
  var phrase, result;
  var opts = options == null ? {} : options;
  if (typeof this.phrases[key] === 'string') {
    phrase = this.phrases[key];
  } else if (typeof opts._ === 'string') {
    phrase = opts._;
  } else if (this.onMissingKey) {
    var onMissingKey = this.onMissingKey;
    result = onMissingKey(key, opts, this.currentLocale);
  } else {
    this.warn('Missing translation for key: "' + key + '"');
    result = key;
  }
  if (typeof phrase === 'string') {
    result = transformPhrase(phrase, opts, this.currentLocale);
  }
  return result;
};


// ### polyglot.has(key)
//
// Check if polyglot has a translation for given key
Polyglot.prototype.has = function (key) {
  return has(this.phrases, key);
};

// export transformPhrase
Polyglot.transformPhrase = transformPhrase;

module.exports = Polyglot;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// modified from https://github.com/es-shims/es5-shim
var has = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var slice = Array.prototype.slice;
var isArgs = __webpack_require__(396);
var isEnumerable = Object.prototype.propertyIsEnumerable;
var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
var dontEnums = [
	'toString',
	'toLocaleString',
	'valueOf',
	'hasOwnProperty',
	'isPrototypeOf',
	'propertyIsEnumerable',
	'constructor'
];
var equalsConstructorPrototype = function (o) {
	var ctor = o.constructor;
	return ctor && ctor.prototype === o;
};
var excludedKeys = {
	$console: true,
	$external: true,
	$frame: true,
	$frameElement: true,
	$frames: true,
	$innerHeight: true,
	$innerWidth: true,
	$outerHeight: true,
	$outerWidth: true,
	$pageXOffset: true,
	$pageYOffset: true,
	$parent: true,
	$scrollLeft: true,
	$scrollTop: true,
	$scrollX: true,
	$scrollY: true,
	$self: true,
	$webkitIndexedDB: true,
	$webkitStorageInfo: true,
	$window: true
};
var hasAutomationEqualityBug = (function () {
	/* global window */
	if (typeof window === 'undefined') { return false; }
	for (var k in window) {
		try {
			if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
				try {
					equalsConstructorPrototype(window[k]);
				} catch (e) {
					return true;
				}
			}
		} catch (e) {
			return true;
		}
	}
	return false;
}());
var equalsConstructorPrototypeIfNotBuggy = function (o) {
	/* global window */
	if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
		return equalsConstructorPrototype(o);
	}
	try {
		return equalsConstructorPrototype(o);
	} catch (e) {
		return false;
	}
};

var keysShim = function keys(object) {
	var isObject = object !== null && typeof object === 'object';
	var isFunction = toStr.call(object) === '[object Function]';
	var isArguments = isArgs(object);
	var isString = isObject && toStr.call(object) === '[object String]';
	var theKeys = [];

	if (!isObject && !isFunction && !isArguments) {
		throw new TypeError('Object.keys called on a non-object');
	}

	var skipProto = hasProtoEnumBug && isFunction;
	if (isString && object.length > 0 && !has.call(object, 0)) {
		for (var i = 0; i < object.length; ++i) {
			theKeys.push(String(i));
		}
	}

	if (isArguments && object.length > 0) {
		for (var j = 0; j < object.length; ++j) {
			theKeys.push(String(j));
		}
	} else {
		for (var name in object) {
			if (!(skipProto && name === 'prototype') && has.call(object, name)) {
				theKeys.push(String(name));
			}
		}
	}

	if (hasDontEnumBug) {
		var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

		for (var k = 0; k < dontEnums.length; ++k) {
			if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
				theKeys.push(dontEnums[k]);
			}
		}
	}
	return theKeys;
};

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			return (Object.keys(arguments) || '').length === 2;
		}(1, 2));
		if (!keysWorksWithArguments) {
			var originalKeys = Object.keys;
			Object.keys = function keys(object) {
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				} else {
					return originalKeys(object);
				}
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * @module object-loops/map
 */
var forEach = __webpack_require__(157)

/**
 * Creates a new object with the results of calling a provided function on every value in the object.
 * @function module:object-loops/map
 * @param {object} [obj] - object to map values, not accepted if being used directly on Object.prototype
 * @param {mapCallback} callback - function that produces the new value for the new mapped object
 * @param {*} [thisArg] - optional. context to bind to callback
 * @returns {object} newly created object with mapped values
 */
module.exports = map

function map (obj, callback, thisArg) {
  if (Array.isArray(obj)) {
    return obj.map(callback, thisArg)
  }
  if (typeof callback !== 'function') {
    throw new TypeError(callback + ' must be a function')
  }
  var mappedObj = {}
  forEach(obj, function (val, key, obj) {
    mappedObj[key] = callback.call(thisArg, val, key, obj)
  })
  return mappedObj
}
/**
 * This callback type is called `mapCallback` and is displayed as a global symbol.
 * @callback mapCallback
 * @param {*} val - value for key
 * @param {string} key - object key (used in current iteration)
 * @param {object} obj - object which values are being iterated
 * @returns {*} mappedValue - value for key in the new, mapped object
 */


/***/ }),
/* 398 */
/***/ (function(module, exports) {

module.exports = function parseUnit(str, out) {
    if (!out)
        out = [ 0, '' ]

    str = String(str)
    var num = parseFloat(str, 10)
    out[0] = num
    out[1] = str.match(/[\d.\-\+]*\s*(.*)/)[1] || ''
    return out
}

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*global ActiveXObject, window, console, define, module, jQuery */
//jshint unused:false, strict: false

/*
    PDFObject v2.0.201604172
    https://github.com/pipwerks/PDFObject
    Copyright (c) 2008-2016 Philip Hutchison
    MIT-style license: http://pipwerks.mit-license.org/
    UMD module pattern from https://github.com/umdjs/umd/blob/master/templates/returnExports.js
*/

(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory();
    } else {
        // Browser globals (root is window)
        root.PDFObject = factory();
  }
}(this, function () {

    "use strict";
    //jshint unused:true

    //PDFObject is designed for client-side (browsers), not server-side (node)
    //Will choke on undefined navigator and window vars when run on server
    //Return boolean false and exit function when running server-side

    if(typeof window === "undefined" || typeof navigator === "undefined"){ return false; }

    var pdfobjectversion = "2.0.201604172",
        supportsPDFs,

        //declare functions
        createAXO,
        isIE,
        supportsPdfMimeType = (typeof navigator.mimeTypes['application/pdf'] !== "undefined"),
        supportsPdfActiveX,
        buildFragmentString,
        log,
        embedError,
        embed,
        getTargetElement,
        generatePDFJSiframe,
        isIOS = (function (){ return (/iphone|ipad|ipod/i.test(navigator.userAgent.toLowerCase())); })(),
        generateEmbedElement;


    /* ----------------------------------------------------
       Supporting functions
       ---------------------------------------------------- */

    createAXO = function (type){
        var ax;
        try {
            ax = new ActiveXObject(type);
        } catch (e) {
            ax = null; //ensure ax remains null
        }
        return ax;
    };

    //IE11 still uses ActiveX for Adobe Reader, but IE 11 doesn't expose
    //window.ActiveXObject the same way previous versions of IE did
    //window.ActiveXObject will evaluate to false in IE 11, but "ActiveXObject" in window evaluates to true
    //so check the first one for older IE, and the second for IE11
    //FWIW, MS Edge (replacing IE11) does not support ActiveX at all, both will evaluate false
    //Constructed as a method (not a prop) to avoid unneccesarry overhead -- will only be evaluated if needed
    isIE = function (){ return !!(window.ActiveXObject || "ActiveXObject" in window); };

    //If either ActiveX support for "AcroPDF.PDF" or "PDF.PdfCtrl" are found, return true
    //Constructed as a method (not a prop) to avoid unneccesarry overhead -- will only be evaluated if needed
    supportsPdfActiveX = function (){ return !!(createAXO("AcroPDF.PDF") || createAXO("PDF.PdfCtrl")); };

    //Determines whether PDF support is available
    supportsPDFs = (supportsPdfMimeType || (isIE() && supportsPdfActiveX()));

    //Create a fragment identifier for using PDF Open parameters when embedding PDF
    buildFragmentString = function(pdfParams){

        var string = "",
            prop;

        if(pdfParams){

            for (prop in pdfParams) {
                if (pdfParams.hasOwnProperty(prop)) {
                    string += encodeURIComponent(prop) + "=" + encodeURIComponent(pdfParams[prop]) + "&";
                }
            }

            //The string will be empty if no PDF Params found
            if(string){

                string = "#" + string;

                //Remove last ampersand
                string = string.slice(0, string.length - 1);

            }

        }

        return string;

    };

    log = function (msg){
        if(typeof console !== "undefined" && console.log){
            console.log("[PDFObject] " + msg);
        }
    };

    embedError = function (msg){
        log(msg);
        return false;
    };

    getTargetElement = function (targetSelector){

        //Default to body for full-browser PDF
        var targetNode = document.body;

        //If a targetSelector is specified, check to see whether
        //it's passing a selector, jQuery object, or an HTML element

        if(typeof targetSelector === "string"){

            //Is CSS selector
            targetNode = document.querySelector(targetSelector);

        } else if (typeof jQuery !== "undefined" && targetSelector instanceof jQuery && targetSelector.length) {

            //Is jQuery element. Extract HTML node
            targetNode = targetSelector.get(0);

        } else if (typeof targetSelector.nodeType !== "undefined" && targetSelector.nodeType === 1){

            //Is HTML element
            targetNode = targetSelector;

        }

        return targetNode;

    };

    generatePDFJSiframe = function (targetNode, url, pdfOpenFragment, PDFJS_URL, id){

        var fullURL = PDFJS_URL + "?file=" + encodeURIComponent(url) + pdfOpenFragment;
        var scrollfix = (isIOS) ? "-webkit-overflow-scrolling: touch; overflow-y: scroll; " : "overflow: hidden; ";
        var iframe = "<div style='" + scrollfix + "position: absolute; top: 0; right: 0; bottom: 0; left: 0;'><iframe  " + id + " src='" + fullURL + "' style='border: none; width: 100%; height: 100%;' frameborder='0'></iframe></div>";
        targetNode.className += " pdfobject-container";
        targetNode.style.position = "relative";
        targetNode.style.overflow = "auto";
        targetNode.innerHTML = iframe;
        return targetNode.getElementsByTagName("iframe")[0];

    };

    generateEmbedElement = function (targetNode, targetSelector, url, pdfOpenFragment, width, height, id){

        var style = "";

        if(targetSelector && targetSelector !== document.body){
            style = "width: " + width + "; height: " + height + ";";
        } else {
            style = "position: absolute; top: 0; right: 0; bottom: 0; left: 0; width: 100%; height: 100%;";
        }

        targetNode.className += " pdfobject-container";
        targetNode.innerHTML = "<embed " + id + " class='pdfobject' src='" + url + pdfOpenFragment + "' type='application/pdf' style='overflow: auto; " + style + "'/>";

        return targetNode.getElementsByTagName("embed")[0];

    };

    embed = function(url, targetSelector, options){

        //Ensure URL is available. If not, exit now.
        if(typeof url !== "string"){ return embedError("URL is not valid"); }

        //If targetSelector is not defined, convert to boolean
        targetSelector = (typeof targetSelector !== "undefined") ? targetSelector : false;

        //Ensure options object is not undefined -- enables easier error checking below
        options = (typeof options !== "undefined") ? options : {};

        //Get passed options, or set reasonable defaults
        var id = (options.id && typeof options.id === "string") ? "id='" + options.id + "'" : "",
            page = (options.page) ? options.page : false,
            pdfOpenParams = (options.pdfOpenParams) ? options.pdfOpenParams : {},
            fallbackLink = (typeof options.fallbackLink !== "undefined") ? options.fallbackLink : true,
            width = (options.width) ? options.width : "100%",
            height = (options.height) ? options.height : "100%",
            forcePDFJS = (typeof options.forcePDFJS === "boolean") ? options.forcePDFJS : false,
            PDFJS_URL = (options.PDFJS_URL) ? options.PDFJS_URL : false,
            targetNode = getTargetElement(targetSelector),
            fallbackHTML = "",
            pdfOpenFragment = "",
            fallbackHTML_default = "<p>This browser does not support inline PDFs. Please download the PDF to view it: <a href='[url]'>Download PDF</a></p>";

        //If target element is specified but is not valid, exit without doing anything
        if(!targetNode){ return embedError("Target element cannot be determined"); }


        //page option overrides pdfOpenParams, if found
        if(page){
            pdfOpenParams.page = page;
        }

        //Stringify optional Adobe params for opening document (as fragment identifier)
        pdfOpenFragment = buildFragmentString(pdfOpenParams);

        //Do the dance
        if(forcePDFJS && PDFJS_URL){

            return generatePDFJSiframe(targetNode, url, pdfOpenFragment, PDFJS_URL, id);

        } else if(supportsPDFs){

            return generateEmbedElement(targetNode, targetSelector, url, pdfOpenFragment, width, height, id);

        } else {

            if(PDFJS_URL){

                return generatePDFJSiframe(targetNode, url, pdfOpenFragment, PDFJS_URL, id);

            } else if(fallbackLink){

                fallbackHTML = (typeof fallbackLink === "string") ? fallbackLink : fallbackHTML_default;
                targetNode.innerHTML = fallbackHTML.replace(/\[url\]/g, url);

            }

            return embedError("This browser does not support embedded PDFs");

        }

    };

    return {
        embed: function (a,b,c){ return embed(a,b,c); },
        pdfobjectversion: (function () { return pdfobjectversion; })(),
        supportsPDFs: (function (){ return supportsPDFs; })()
    };

}));

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(359);
var invariant = __webpack_require__(360);
var ReactPropTypesSecret = __webpack_require__(401);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function RavenConfigError(message) {
    this.name = 'RavenConfigError';
    this.message = message;
}
RavenConfigError.prototype = new Error();
RavenConfigError.prototype.constructor = RavenConfigError;

module.exports = RavenConfigError;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wrapMethod = function(console, level, callback) {
    var originalConsoleLevel = console[level];
    var originalConsole = console;

    if (!(level in console)) {
        return;
    }

    var sentryLevel = level === 'warn'
        ? 'warning'
        : level;

    console[level] = function () {
        var args = [].slice.call(arguments);

        var msg = '' + args.join(' ');
        var data = {level: sentryLevel, logger: 'console', extra: {'arguments': args}};
        callback && callback(msg, data);

        // this fails for some browsers. :(
        if (originalConsoleLevel) {
            // IE9 doesn't allow calling apply on console functions directly
            // See: https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
            Function.prototype.apply.call(
                originalConsoleLevel,
                originalConsole,
                args
            );
        }
    };
};

module.exports = {
    wrapMethod: wrapMethod
};


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*global XDomainRequest:false, __DEV__:false*/


var TraceKit = __webpack_require__(406);
var RavenConfigError = __webpack_require__(402);
var stringify = __webpack_require__(384);

var wrapConsoleMethod = __webpack_require__(403).wrapMethod;

var dsnKeys = 'source protocol user pass host port path'.split(' '),
    dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;

function now() {
    return +new Date();
}

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window = typeof window !== 'undefined' ? window
            : typeof global !== 'undefined' ? global
            : typeof self !== 'undefined' ? self
            : {};
var _document = _window.document;

// First, check for JSON support
// If there is no JSON, we no-op the core features of Raven
// since JSON is required to encode the payload
function Raven() {
    this._hasJSON = !!(typeof JSON === 'object' && JSON.stringify);
    // Raven can run in contexts where there's no document (react-native)
    this._hasDocument = !isUndefined(_document);
    this._lastCapturedException = null;
    this._lastEventId = null;
    this._globalServer = null;
    this._globalKey = null;
    this._globalProject = null;
    this._globalContext = {};
    this._globalOptions = {
        logger: 'javascript',
        ignoreErrors: [],
        ignoreUrls: [],
        whitelistUrls: [],
        includePaths: [],
        crossOrigin: 'anonymous',
        collectWindowErrors: true,
        maxMessageLength: 0,
        stackTraceLimit: 50,
        autoBreadcrumbs: true
    };
    this._ignoreOnError = 0;
    this._isRavenInstalled = false;
    this._originalErrorStackTraceLimit = Error.stackTraceLimit;
    // capture references to window.console *and* all its methods first
    // before the console plugin has a chance to monkey patch
    this._originalConsole = _window.console || {};
    this._originalConsoleMethods = {};
    this._plugins = [];
    this._startTime = now();
    this._wrappedBuiltIns = [];
    this._breadcrumbs = [];
    this._lastCapturedEvent = null;
    this._keypressTimeout;
    this._location = _window.location;
    this._lastHref = this._location && this._location.href;

    for (var method in this._originalConsole) {  // eslint-disable-line guard-for-in
      this._originalConsoleMethods[method] = this._originalConsole[method];
    }
}

/*
 * The core Raven singleton
 *
 * @this {Raven}
 */

Raven.prototype = {
    // Hardcode version string so that raven source can be loaded directly via
    // webpack (using a build step causes webpack #1617). Grunt verifies that
    // this value matches package.json during build.
    //   See: https://github.com/getsentry/raven-js/issues/465
    VERSION: '3.9.1',

    debug: false,

    TraceKit: TraceKit, // alias to TraceKit

    /*
     * Configure Raven with a DSN and extra options
     *
     * @param {string} dsn The public Sentry DSN
     * @param {object} options Optional set of of global options [optional]
     * @return {Raven}
     */
    config: function(dsn, options) {
        var self = this;

        if (self._globalServer) {
                this._logDebug('error', 'Error: Raven has already been configured');
            return self;
        }
        if (!dsn) return self;

        var globalOptions = self._globalOptions;

        // merge in options
        if (options) {
            each(options, function(key, value){
                // tags and extra are special and need to be put into context
                if (key === 'tags' || key === 'extra' || key === 'user') {
                    self._globalContext[key] = value;
                } else {
                    globalOptions[key] = value;
                }
            });
        }

        self.setDSN(dsn);

        // "Script error." is hard coded into browsers for errors that it can't read.
        // this is the result of a script being pulled in from an external domain and CORS.
        globalOptions.ignoreErrors.push(/^Script error\.?$/);
        globalOptions.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/);

        // join regexp rules into one big rule
        globalOptions.ignoreErrors = joinRegExp(globalOptions.ignoreErrors);
        globalOptions.ignoreUrls = globalOptions.ignoreUrls.length ? joinRegExp(globalOptions.ignoreUrls) : false;
        globalOptions.whitelistUrls = globalOptions.whitelistUrls.length ? joinRegExp(globalOptions.whitelistUrls) : false;
        globalOptions.includePaths = joinRegExp(globalOptions.includePaths);
        globalOptions.maxBreadcrumbs = Math.max(0, Math.min(globalOptions.maxBreadcrumbs || 100, 100)); // default and hard limit is 100

        var autoBreadcrumbDefaults = {
            xhr: true,
            console: true,
            dom: true,
            location: true
        };

        var autoBreadcrumbs = globalOptions.autoBreadcrumbs;
        if ({}.toString.call(autoBreadcrumbs) === '[object Object]') {
            autoBreadcrumbs = objectMerge(autoBreadcrumbDefaults, autoBreadcrumbs);
        } else if (autoBreadcrumbs !== false) {
            autoBreadcrumbs = autoBreadcrumbDefaults;
        }
        globalOptions.autoBreadcrumbs = autoBreadcrumbs;

        TraceKit.collectWindowErrors = !!globalOptions.collectWindowErrors;

        // return for chaining
        return self;
    },

    /*
     * Installs a global window.onerror error handler
     * to capture and report uncaught exceptions.
     * At this point, install() is required to be called due
     * to the way TraceKit is set up.
     *
     * @return {Raven}
     */
    install: function() {
        var self = this;
        if (self.isSetup() && !self._isRavenInstalled) {
            TraceKit.report.subscribe(function () {
                self._handleOnErrorStackInfo.apply(self, arguments);
            });
            self._instrumentTryCatch();
            if (self._globalOptions.autoBreadcrumbs)
                self._instrumentBreadcrumbs();

            // Install all of the plugins
            self._drainPlugins();

            self._isRavenInstalled = true;
        }

        Error.stackTraceLimit = self._globalOptions.stackTraceLimit;
        return this;
    },

    /*
     * Set the DSN (can be called multiple time unlike config)
     *
     * @param {string} dsn The public Sentry DSN
     */
    setDSN: function(dsn) {
        var self = this,
            uri = self._parseDSN(dsn),
          lastSlash = uri.path.lastIndexOf('/'),
          path = uri.path.substr(1, lastSlash);

        self._dsn = dsn;
        self._globalKey = uri.user;
        self._globalSecret = uri.pass && uri.pass.substr(1);
        self._globalProject = uri.path.substr(lastSlash + 1);

        self._globalServer = self._getGlobalServer(uri);

        self._globalEndpoint = self._globalServer +
            '/' + path + 'api/' + self._globalProject + '/store/';
    },

    /*
     * Wrap code within a context so Raven can capture errors
     * reliably across domains that is executed immediately.
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The callback to be immediately executed within the context
     * @param {array} args An array of arguments to be called with the callback [optional]
     */
    context: function(options, func, args) {
        if (isFunction(options)) {
            args = func || [];
            func = options;
            options = undefined;
        }

        return this.wrap(options, func).apply(this, args);
    },

    /*
     * Wrap code within a context and returns back a new function to be executed
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The function to be wrapped in a new context
     * @param {function} func A function to call before the try/catch wrapper [optional, private]
     * @return {function} The newly wrapped functions with a context
     */
    wrap: function(options, func, _before) {
        var self = this;
        // 1 argument has been passed, and it's not a function
        // so just return it
        if (isUndefined(func) && !isFunction(options)) {
            return options;
        }

        // options is optional
        if (isFunction(options)) {
            func = options;
            options = undefined;
        }

        // At this point, we've passed along 2 arguments, and the second one
        // is not a function either, so we'll just return the second argument.
        if (!isFunction(func)) {
            return func;
        }

        // We don't wanna wrap it twice!
        try {
            if (func.__raven__) {
                return func;
            }

            // If this has already been wrapped in the past, return that
            if (func.__raven_wrapper__ ){
                return func.__raven_wrapper__ ;
            }
        } catch (e) {
            // Just accessing custom props in some Selenium environments
            // can cause a "Permission denied" exception (see raven-js#495).
            // Bail on wrapping and return the function as-is (defers to window.onerror).
            return func;
        }

        function wrapped() {
            var args = [], i = arguments.length,
                deep = !options || options && options.deep !== false;

            if (_before && isFunction(_before)) {
                _before.apply(this, arguments);
            }

            // Recursively wrap all of a function's arguments that are
            // functions themselves.
            while(i--) args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];

            try {
                return func.apply(this, args);
            } catch(e) {
                self._ignoreNextOnError();
                self.captureException(e, options);
                throw e;
            }
        }

        // copy over properties of the old function
        for (var property in func) {
            if (hasKey(func, property)) {
                wrapped[property] = func[property];
            }
        }
        wrapped.prototype = func.prototype;

        func.__raven_wrapper__ = wrapped;
        // Signal that this function has been wrapped already
        // for both debugging and to prevent it to being wrapped twice
        wrapped.__raven__ = true;
        wrapped.__inner__ = func;

        return wrapped;
    },

    /*
     * Uninstalls the global error handler.
     *
     * @return {Raven}
     */
    uninstall: function() {
        TraceKit.report.uninstall();

        this._restoreBuiltIns();

        Error.stackTraceLimit = this._originalErrorStackTraceLimit;
        this._isRavenInstalled = false;

        return this;
    },

    /*
     * Manually capture an exception and send it over to Sentry
     *
     * @param {error} ex An exception to be logged
     * @param {object} options A specific set of options for this error [optional]
     * @return {Raven}
     */
    captureException: function(ex, options) {
        // If not an Error is passed through, recall as a message instead
        if (!isError(ex)) {
            return this.captureMessage(ex, objectMerge({
                trimHeadFrames: 1,
                stacktrace: true // if we fall back to captureMessage, default to attempting a new trace
            }, options));
        }

        // Store the raw exception object for potential debugging and introspection
        this._lastCapturedException = ex;

        // TraceKit.report will re-raise any exception passed to it,
        // which means you have to wrap it in try/catch. Instead, we
        // can wrap it here and only re-raise if TraceKit.report
        // raises an exception different from the one we asked to
        // report on.
        try {
            var stack = TraceKit.computeStackTrace(ex);
            this._handleStackInfo(stack, options);
        } catch(ex1) {
            if(ex !== ex1) {
                throw ex1;
            }
        }

        return this;
    },

    /*
     * Manually send a message to Sentry
     *
     * @param {string} msg A plain message to be captured in Sentry
     * @param {object} options A specific set of options for this message [optional]
     * @return {Raven}
     */
    captureMessage: function(msg, options) {
        // config() automagically converts ignoreErrors from a list to a RegExp so we need to test for an
        // early call; we'll error on the side of logging anything called before configuration since it's
        // probably something you should see:
        if (!!this._globalOptions.ignoreErrors.test && this._globalOptions.ignoreErrors.test(msg)) {
            return;
        }

        options = options || {};

        var data = objectMerge({
            message: msg + ''  // Make sure it's actually a string
        }, options);

        if (this._globalOptions.stacktrace || (options && options.stacktrace)) {
            var ex;
            // create a stack trace from this point; just trim
            // off extra frames so they don't include this function call (or
            // earlier Raven.js library fn calls)
            try {
                throw new Error(msg);
            } catch (ex1) {
                ex = ex1;
            }

            // null exception name so `Error` isn't prefixed to msg
            ex.name = null;

            options = objectMerge({
                // fingerprint on msg, not stack trace (legacy behavior, could be
                // revisited)
                fingerprint: msg,
                trimHeadFrames: (options.trimHeadFrames || 0) + 1
            }, options);

            var stack = TraceKit.computeStackTrace(ex);
            var frames = this._prepareFrames(stack, options);
            data.stacktrace = {
                // Sentry expects frames oldest to newest
                frames: frames.reverse()
            }
        }

        // Fire away!
        this._send(data);

        return this;
    },

    captureBreadcrumb: function (obj) {
        var crumb = objectMerge({
            timestamp: now() / 1000
        }, obj);

        if (isFunction(this._globalOptions.breadcrumbCallback)) {
            var result = this._globalOptions.breadcrumbCallback(crumb);

            if (isObject(result) && !isEmptyObject(result)) {
                crumb = result;
            } else if (result === false) {
                return this;
            }
        }

        this._breadcrumbs.push(crumb);
        if (this._breadcrumbs.length > this._globalOptions.maxBreadcrumbs) {
            this._breadcrumbs.shift();
        }
        return this;
    },

    addPlugin: function(plugin /*arg1, arg2, ... argN*/) {
        var pluginArgs = [].slice.call(arguments, 1);

        this._plugins.push([plugin, pluginArgs]);
        if (this._isRavenInstalled) {
            this._drainPlugins();
        }

        return this;
    },

    /*
     * Set/clear a user to be sent along with the payload.
     *
     * @param {object} user An object representing user data [optional]
     * @return {Raven}
     */
    setUserContext: function(user) {
        // Intentionally do not merge here since that's an unexpected behavior.
        this._globalContext.user = user;

        return this;
    },

    /*
     * Merge extra attributes to be sent along with the payload.
     *
     * @param {object} extra An object representing extra data [optional]
     * @return {Raven}
     */
    setExtraContext: function(extra) {
        this._mergeContext('extra', extra);

        return this;
    },

    /*
     * Merge tags to be sent along with the payload.
     *
     * @param {object} tags An object representing tags [optional]
     * @return {Raven}
     */
    setTagsContext: function(tags) {
        this._mergeContext('tags', tags);

        return this;
    },

    /*
     * Clear all of the context.
     *
     * @return {Raven}
     */
    clearContext: function() {
        this._globalContext = {};

        return this;
    },

    /*
     * Get a copy of the current context. This cannot be mutated.
     *
     * @return {object} copy of context
     */
    getContext: function() {
        // lol javascript
        return JSON.parse(stringify(this._globalContext));
    },


    /*
     * Set environment of application
     *
     * @param {string} environment Typically something like 'production'.
     * @return {Raven}
     */
    setEnvironment: function(environment) {
        this._globalOptions.environment = environment;

        return this;
    },

    /*
     * Set release version of application
     *
     * @param {string} release Typically something like a git SHA to identify version
     * @return {Raven}
     */
    setRelease: function(release) {
        this._globalOptions.release = release;

        return this;
    },

    /*
     * Set the dataCallback option
     *
     * @param {function} callback The callback to run which allows the
     *                            data blob to be mutated before sending
     * @return {Raven}
     */
    setDataCallback: function(callback) {
        var original = this._globalOptions.dataCallback;
        this._globalOptions.dataCallback = isFunction(callback)
          ? function (data) { return callback(data, original); }
          : callback;

        return this;
    },

    /*
     * Set the breadcrumbCallback option
     *
     * @param {function} callback The callback to run which allows filtering
     *                            or mutating breadcrumbs
     * @return {Raven}
     */
    setBreadcrumbCallback: function(callback) {
        var original = this._globalOptions.breadcrumbCallback;
        this._globalOptions.breadcrumbCallback = isFunction(callback)
          ? function (data) { return callback(data, original); }
          : callback;

        return this;
    },

    /*
     * Set the shouldSendCallback option
     *
     * @param {function} callback The callback to run which allows
     *                            introspecting the blob before sending
     * @return {Raven}
     */
    setShouldSendCallback: function(callback) {
        var original = this._globalOptions.shouldSendCallback;
        this._globalOptions.shouldSendCallback = isFunction(callback)
            ? function (data) { return callback(data, original); }
            : callback;

        return this;
    },

    /**
     * Override the default HTTP transport mechanism that transmits data
     * to the Sentry server.
     *
     * @param {function} transport Function invoked instead of the default
     *                             `makeRequest` handler.
     *
     * @return {Raven}
     */
    setTransport: function(transport) {
        this._globalOptions.transport = transport;

        return this;
    },

    /*
     * Get the latest raw exception that was captured by Raven.
     *
     * @return {error}
     */
    lastException: function() {
        return this._lastCapturedException;
    },

    /*
     * Get the last event id
     *
     * @return {string}
     */
    lastEventId: function() {
        return this._lastEventId;
    },

    /*
     * Determine if Raven is setup and ready to go.
     *
     * @return {boolean}
     */
    isSetup: function() {
        if (!this._hasJSON) return false;  // needs JSON support
        if (!this._globalServer) {
            if (!this.ravenNotConfiguredError) {
              this.ravenNotConfiguredError = true;
              this._logDebug('error', 'Error: Raven has not been configured.');
            }
            return false;
        }
        return true;
    },

    afterLoad: function () {
        // TODO: remove window dependence?

        // Attempt to initialize Raven on load
        var RavenConfig = _window.RavenConfig;
        if (RavenConfig) {
            this.config(RavenConfig.dsn, RavenConfig.config).install();
        }
    },

    showReportDialog: function (options) {
        if (!_document) // doesn't work without a document (React native)
            return;

        options = options || {};

        var lastEventId = options.eventId || this.lastEventId();
        if (!lastEventId) {
            throw new RavenConfigError('Missing eventId');
        }

        var dsn = options.dsn || this._dsn;
        if (!dsn) {
            throw new RavenConfigError('Missing DSN');
        }

        var encode = encodeURIComponent;
        var qs = '';
        qs += '?eventId=' + encode(lastEventId);
        qs += '&dsn=' + encode(dsn);

        var user = options.user || this._globalContext.user;
        if (user) {
            if (user.name)  qs += '&name=' + encode(user.name);
            if (user.email) qs += '&email=' + encode(user.email);
        }

        var globalServer = this._getGlobalServer(this._parseDSN(dsn));

        var script = _document.createElement('script');
        script.async = true;
        script.src = globalServer + '/api/embed/error-page/' + qs;
        (_document.head || _document.body).appendChild(script);
    },

    /**** Private functions ****/
    _ignoreNextOnError: function () {
        var self = this;
        this._ignoreOnError += 1;
        setTimeout(function () {
            // onerror should trigger before setTimeout
            self._ignoreOnError -= 1;
        });
    },

    _triggerEvent: function(eventType, options) {
        // NOTE: `event` is a native browser thing, so let's avoid conflicting wiht it
        var evt, key;

        if (!this._hasDocument)
            return;

        options = options || {};

        eventType = 'raven' + eventType.substr(0,1).toUpperCase() + eventType.substr(1);

        if (_document.createEvent) {
            evt = _document.createEvent('HTMLEvents');
            evt.initEvent(eventType, true, true);
        } else {
            evt = _document.createEventObject();
            evt.eventType = eventType;
        }

        for (key in options) if (hasKey(options, key)) {
            evt[key] = options[key];
        }

        if (_document.createEvent) {
            // IE9 if standards
            _document.dispatchEvent(evt);
        } else {
            // IE8 regardless of Quirks or Standards
            // IE9 if quirks
            try {
                _document.fireEvent('on' + evt.eventType.toLowerCase(), evt);
            } catch(e) {
                // Do nothing
            }
        }
    },

    /**
     * Wraps addEventListener to capture UI breadcrumbs
     * @param evtName the event name (e.g. "click")
     * @returns {Function}
     * @private
     */
    _breadcrumbEventHandler: function(evtName) {
        var self = this;
        return function (evt) {
            // reset keypress timeout; e.g. triggering a 'click' after
            // a 'keypress' will reset the keypress debounce so that a new
            // set of keypresses can be recorded
            self._keypressTimeout = null;

            // It's possible this handler might trigger multiple times for the same
            // event (e.g. event propagation through node ancestors). Ignore if we've
            // already captured the event.
            if (self._lastCapturedEvent === evt)
                return;

            self._lastCapturedEvent = evt;
            var elem = evt.target;

            var target;

            // try/catch htmlTreeAsString because it's particularly complicated, and
            // just accessing the DOM incorrectly can throw an exception in some circumstances.
            try {
                target = htmlTreeAsString(elem);
            } catch (e) {
                target = '<unknown>';
            }

            self.captureBreadcrumb({
                category: 'ui.' + evtName, // e.g. ui.click, ui.input
                message: target
            });
        };
    },

    /**
     * Wraps addEventListener to capture keypress UI events
     * @returns {Function}
     * @private
     */
    _keypressEventHandler: function() {
        var self = this,
            debounceDuration = 1000; // milliseconds

        // TODO: if somehow user switches keypress target before
        //       debounce timeout is triggered, we will only capture
        //       a single breadcrumb from the FIRST target (acceptable?)
        return function (evt) {
            var target = evt.target,
                tagName = target && target.tagName;

            // only consider keypress events on actual input elements
            // this will disregard keypresses targeting body (e.g. tabbing
            // through elements, hotkeys, etc)
            if (!tagName || tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)
                return;

            // record first keypress in a series, but ignore subsequent
            // keypresses until debounce clears
            var timeout = self._keypressTimeout;
            if (!timeout) {
                self._breadcrumbEventHandler('input')(evt);
            }
            clearTimeout(timeout);
            self._keypressTimeout = setTimeout(function () {
                self._keypressTimeout = null;
            }, debounceDuration);
        };
    },

    /**
     * Captures a breadcrumb of type "navigation", normalizing input URLs
     * @param to the originating URL
     * @param from the target URL
     * @private
     */
    _captureUrlChange: function(from, to) {
        var parsedLoc = parseUrl(this._location.href);
        var parsedTo = parseUrl(to);
        var parsedFrom = parseUrl(from);

        // because onpopstate only tells you the "new" (to) value of location.href, and
        // not the previous (from) value, we need to track the value of the current URL
        // state ourselves
        this._lastHref = to;

        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host)
            to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host)
            from = parsedFrom.relative;

        this.captureBreadcrumb({
            category: 'navigation',
            data: {
                to: to,
                from: from
            }
        });
    },

    /**
     * Install any queued plugins
     */
    _instrumentTryCatch: function() {
        var self = this;

        var wrappedBuiltIns = self._wrappedBuiltIns;

        function wrapTimeFn(orig) {
            return function (fn, t) { // preserve arity
                // Make a copy of the arguments to prevent deoptimization
                // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
                var args = new Array(arguments.length);
                for(var i = 0; i < args.length; ++i) {
                    args[i] = arguments[i];
                }
                var originalCallback = args[0];
                if (isFunction(originalCallback)) {
                    args[0] = self.wrap(originalCallback);
                }

                // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
                // also supports only two arguments and doesn't care what this is, so we
                // can just call the original function directly.
                if (orig.apply) {
                    return orig.apply(this, args);
                } else {
                    return orig(args[0], args[1]);
                }
            };
        }

        var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

        function wrapEventTarget(global) {
            var proto = _window[global] && _window[global].prototype;
            if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
                fill(proto, 'addEventListener', function(orig) {
                    return function (evtName, fn, capture, secure) { // preserve arity
                        try {
                            if (fn && fn.handleEvent) {
                                fn.handleEvent = self.wrap(fn.handleEvent);
                            }
                        } catch (err) {
                            // can sometimes get 'Permission denied to access property "handle Event'
                        }

                        // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
                        // so that we don't have more than one wrapper function
                        var before,
                            clickHandler,
                            keypressHandler;

                        if (autoBreadcrumbs && autoBreadcrumbs.dom && (global === 'EventTarget' || global === 'Node')) {
                            // NOTE: generating multiple handlers per addEventListener invocation, should
                            //       revisit and verify we can just use one (almost certainly)
                            clickHandler = self._breadcrumbEventHandler('click');
                            keypressHandler = self._keypressEventHandler();
                            before = function (evt) {
                                // need to intercept every DOM event in `before` argument, in case that
                                // same wrapped method is re-used for different events (e.g. mousemove THEN click)
                                // see #724
                                if (!evt) return;

                                if (evt.type === 'click')
                                    return clickHandler(evt);
                                else if (evt.type === 'keypress')
                                    return keypressHandler(evt);
                            };
                        }
                        return orig.call(this, evtName, self.wrap(fn, undefined, before), capture, secure);
                    };
                }, wrappedBuiltIns);
                fill(proto, 'removeEventListener', function (orig) {
                    return function (evt, fn, capture, secure) {
                        try {
                            fn = fn && (fn.__raven_wrapper__ ? fn.__raven_wrapper__  : fn);
                        } catch (e) {
                            // ignore, accessing __raven_wrapper__ will throw in some Selenium environments
                        }
                        return orig.call(this, evt, fn, capture, secure);
                    };
                }, wrappedBuiltIns);
            }
        }

        fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
        fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
        if (_window.requestAnimationFrame) {
            fill(_window, 'requestAnimationFrame', function (orig) {
                return function (cb) {
                    return orig(self.wrap(cb));
                };
            }, wrappedBuiltIns);
        }

        // event targets borrowed from bugsnag-js:
        // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
        var eventTargets = ['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'];
        for (var i = 0; i < eventTargets.length; i++) {
            wrapEventTarget(eventTargets[i]);
        }

        var $ = _window.jQuery || _window.$;
        if ($ && $.fn && $.fn.ready) {
            fill($.fn, 'ready', function (orig) {
                return function (fn) {
                    return orig.call(this, self.wrap(fn));
                };
            }, wrappedBuiltIns);
        }
    },


    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - XMLHttpRequests
     *  - DOM interactions (click/typing)
     *  - window.location changes
     *  - console
     *
     * Can be disabled or individually configured via the `autoBreadcrumbs` config option
     */
    _instrumentBreadcrumbs: function () {
        var self = this;
        var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

        var wrappedBuiltIns = self._wrappedBuiltIns;

        function wrapProp(prop, xhr) {
            if (prop in xhr && isFunction(xhr[prop])) {
                fill(xhr, prop, function (orig) {
                    return self.wrap(orig);
                }); // intentionally don't track filled methods on XHR instances
            }
        }

        if (autoBreadcrumbs.xhr && 'XMLHttpRequest' in _window) {
            var xhrproto = XMLHttpRequest.prototype;
            fill(xhrproto, 'open', function(origOpen) {
                return function (method, url) { // preserve arity

                    // if Sentry key appears in URL, don't capture
                    if (isString(url) && url.indexOf(self._globalKey) === -1) {
                        this.__raven_xhr = {
                            method: method,
                            url: url,
                            status_code: null
                        };
                    }

                    return origOpen.apply(this, arguments);
                };
            }, wrappedBuiltIns);

            fill(xhrproto, 'send', function(origSend) {
                return function (data) { // preserve arity
                    var xhr = this;

                    function onreadystatechangeHandler() {
                        if (xhr.__raven_xhr && (xhr.readyState === 1 || xhr.readyState === 4)) {
                            try {
                                // touching statusCode in some platforms throws
                                // an exception
                                xhr.__raven_xhr.status_code = xhr.status;
                            } catch (e) { /* do nothing */ }
                            self.captureBreadcrumb({
                                type: 'http',
                                category: 'xhr',
                                data: xhr.__raven_xhr
                            });
                        }
                    }

                    var props = ['onload', 'onerror', 'onprogress'];
                    for (var j = 0; j < props.length; j++) {
                        wrapProp(props[j], xhr);
                    }

                    if ('onreadystatechange' in xhr && isFunction(xhr.onreadystatechange)) {
                        fill(xhr, 'onreadystatechange', function (orig) {
                            return self.wrap(orig, undefined, onreadystatechangeHandler);
                        } /* intentionally don't track this instrumentation */);
                    } else {
                        // if onreadystatechange wasn't actually set by the page on this xhr, we
                        // are free to set our own and capture the breadcrumb
                        xhr.onreadystatechange = onreadystatechangeHandler;
                    }

                    return origSend.apply(this, arguments);
                };
            }, wrappedBuiltIns);
        }

        if (autoBreadcrumbs.xhr && 'fetch' in _window) {
            fill(_window, 'fetch', function(origFetch) {
                return function (fn, t) { // preserve arity
                    // Make a copy of the arguments to prevent deoptimization
                    // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
                    var args = new Array(arguments.length);
                    for(var i = 0; i < args.length; ++i) {
                        args[i] = arguments[i];
                    }

                    var method = 'GET';

                    if (args[1] && args[1].method) {
                        method = args[1].method;
                    }

                    var fetchData = {
                        method: method,
                        url: args[0],
                        status_code: null
                    };

                    self.captureBreadcrumb({
                        type: 'http',
                        category: 'fetch',
                        data: fetchData
                    });

                    return origFetch.apply(this, args).then(function (response) {
                        fetchData.status_code = response.status;

                        return response;
                    });
                };
            }, wrappedBuiltIns);
        }

        // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
        // to the document. Do this before we instrument addEventListener.
        if (autoBreadcrumbs.dom && this._hasDocument) {
            if (_document.addEventListener) {
                _document.addEventListener('click', self._breadcrumbEventHandler('click'), false);
                _document.addEventListener('keypress', self._keypressEventHandler(), false);
            }
            else {
                // IE8 Compatibility
                _document.attachEvent('onclick', self._breadcrumbEventHandler('click'));
                _document.attachEvent('onkeypress', self._keypressEventHandler());
            }
        }

        // record navigation (URL) changes
        // NOTE: in Chrome App environment, touching history.pushState, *even inside
        //       a try/catch block*, will cause Chrome to output an error to console.error
        // borrowed from: https://github.com/angular/angular.js/pull/13945/files
        var chrome = _window.chrome;
        var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
        var hasPushState = !isChromePackagedApp && _window.history && history.pushState;
        if (autoBreadcrumbs.location && hasPushState) {
            // TODO: remove onpopstate handler on uninstall()
            var oldOnPopState = _window.onpopstate;
            _window.onpopstate = function () {
                var currentHref = self._location.href;
                self._captureUrlChange(self._lastHref, currentHref);

                if (oldOnPopState) {
                    return oldOnPopState.apply(this, arguments);
                }
            };

            fill(history, 'pushState', function (origPushState) {
                // note history.pushState.length is 0; intentionally not declaring
                // params to preserve 0 arity
                return function (/* state, title, url */) {
                    var url = arguments.length > 2 ? arguments[2] : undefined;

                    // url argument is optional
                    if (url) {
                        // coerce to string (this is what pushState does)
                        self._captureUrlChange(self._lastHref, url + '');
                    }

                    return origPushState.apply(this, arguments);
                };
            }, wrappedBuiltIns);
        }

        if (autoBreadcrumbs.console && 'console' in _window && console.log) {
            // console
            var consoleMethodCallback = function (msg, data) {
                self.captureBreadcrumb({
                    message: msg,
                    level: data.level,
                    category: 'console'
                });
            };

            each(['debug', 'info', 'warn', 'error', 'log'], function (_, level) {
                wrapConsoleMethod(console, level, consoleMethodCallback);
            });
        }

    },

    _restoreBuiltIns: function () {
        // restore any wrapped builtins
        var builtin;
        while (this._wrappedBuiltIns.length) {
            builtin = this._wrappedBuiltIns.shift();

            var obj = builtin[0],
              name = builtin[1],
              orig = builtin[2];

            obj[name] = orig;
        }
    },

    _drainPlugins: function() {
        var self = this;

        // FIX ME TODO
        each(this._plugins, function(_, plugin) {
            var installer = plugin[0];
            var args = plugin[1];
            installer.apply(self, [self].concat(args));
        });
    },

    _parseDSN: function(str) {
        var m = dsnPattern.exec(str),
            dsn = {},
            i = 7;

        try {
            while (i--) dsn[dsnKeys[i]] = m[i] || '';
        } catch(e) {
            throw new RavenConfigError('Invalid DSN: ' + str);
        }

        if (dsn.pass && !this._globalOptions.allowSecretKey) {
            throw new RavenConfigError('Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key');
        }

        return dsn;
    },

    _getGlobalServer: function(uri) {
        // assemble the endpoint from the uri pieces
        var globalServer = '//' + uri.host +
            (uri.port ? ':' + uri.port : '');

        if (uri.protocol) {
            globalServer = uri.protocol + ':' + globalServer;
        }
        return globalServer;
    },

    _handleOnErrorStackInfo: function() {
        // if we are intentionally ignoring errors via onerror, bail out
        if (!this._ignoreOnError) {
            this._handleStackInfo.apply(this, arguments);
        }
    },

    _handleStackInfo: function(stackInfo, options) {
        var frames = this._prepareFrames(stackInfo, options);

        this._triggerEvent('handle', {
            stackInfo: stackInfo,
            options: options
        });

        this._processException(
            stackInfo.name,
            stackInfo.message,
            stackInfo.url,
            stackInfo.lineno,
            frames,
            options
        );
    },

    _prepareFrames: function(stackInfo, options) {
        var self = this;
        var frames = [];
        if (stackInfo.stack && stackInfo.stack.length) {
            each(stackInfo.stack, function(i, stack) {
                var frame = self._normalizeFrame(stack);
                if (frame) {
                    frames.push(frame);
                }
            });

            // e.g. frames captured via captureMessage throw
            if (options && options.trimHeadFrames) {
                for (var j = 0; j < options.trimHeadFrames && j < frames.length; j++) {
                    frames[j].in_app = false;
                }
            }
        }
        frames = frames.slice(0, this._globalOptions.stackTraceLimit);
        return frames;
    },


    _normalizeFrame: function(frame) {
        if (!frame.url) return;

        // normalize the frames data
        var normalized = {
            filename:   frame.url,
            lineno:     frame.line,
            colno:      frame.column,
            'function': frame.func || '?'
        };

        normalized.in_app = !( // determine if an exception came from outside of our app
            // first we check the global includePaths list.
            !!this._globalOptions.includePaths.test && !this._globalOptions.includePaths.test(normalized.filename) ||
            // Now we check for fun, if the function name is Raven or TraceKit
            /(Raven|TraceKit)\./.test(normalized['function']) ||
            // finally, we do a last ditch effort and check for raven.min.js
            /raven\.(min\.)?js$/.test(normalized.filename)
        );

        return normalized;
    },

    _processException: function(type, message, fileurl, lineno, frames, options) {
        var stacktrace;
        if (!!this._globalOptions.ignoreErrors.test && this._globalOptions.ignoreErrors.test(message)) return;

        message += '';

        if (frames && frames.length) {
            fileurl = frames[0].filename || fileurl;
            // Sentry expects frames oldest to newest
            // and JS sends them as newest to oldest
            frames.reverse();
            stacktrace = {frames: frames};
        } else if (fileurl) {
            stacktrace = {
                frames: [{
                    filename: fileurl,
                    lineno: lineno,
                    in_app: true
                }]
            };
        }

        if (!!this._globalOptions.ignoreUrls.test && this._globalOptions.ignoreUrls.test(fileurl)) return;
        if (!!this._globalOptions.whitelistUrls.test && !this._globalOptions.whitelistUrls.test(fileurl)) return;

        var data = objectMerge({
            // sentry.interfaces.Exception
            exception: {
                values: [{
                    type: type,
                    value: message,
                    stacktrace: stacktrace
                }]
            },
            culprit: fileurl
        }, options);

        // Fire away!
        this._send(data);
    },

    _trimPacket: function(data) {
        // For now, we only want to truncate the two different messages
        // but this could/should be expanded to just trim everything
        var max = this._globalOptions.maxMessageLength;
        if (data.message) {
            data.message = truncate(data.message, max);
        }
        if (data.exception) {
            var exception = data.exception.values[0];
            exception.value = truncate(exception.value, max);
        }

        return data;
    },

    _getHttpData: function() {
        if (!this._hasDocument || !_document.location || !_document.location.href) {
            return;
        }

        var httpData = {
            headers: {
                'User-Agent': navigator.userAgent
            }
        };

        httpData.url = _document.location.href;

        if (_document.referrer) {
            httpData.headers.Referer = _document.referrer;
        }

        return httpData;
    },


    _send: function(data) {
        var globalOptions = this._globalOptions;

        var baseData = {
            project: this._globalProject,
            logger: globalOptions.logger,
            platform: 'javascript'
        }, httpData = this._getHttpData();

        if (httpData) {
            baseData.request = httpData;
        }

        // HACK: delete `trimHeadFrames` to prevent from appearing in outbound payload
        if (data.trimHeadFrames) delete data.trimHeadFrames;

        data = objectMerge(baseData, data);

        // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
        data.tags = objectMerge(objectMerge({}, this._globalContext.tags), data.tags);
        data.extra = objectMerge(objectMerge({}, this._globalContext.extra), data.extra);

        // Send along our own collected metadata with extra
        data.extra['session:duration'] = now() - this._startTime;

        if (this._breadcrumbs && this._breadcrumbs.length > 0) {
            // intentionally make shallow copy so that additions
            // to breadcrumbs aren't accidentally sent in this request
            data.breadcrumbs = {
                values: [].slice.call(this._breadcrumbs, 0)
            };
        }

        // If there are no tags/extra, strip the key from the payload alltogther.
        if (isEmptyObject(data.tags)) delete data.tags;

        if (this._globalContext.user) {
            // sentry.interfaces.User
            data.user = this._globalContext.user;
        }

        // Include the environment if it's defined in globalOptions
        if (globalOptions.environment) data.environment = globalOptions.environment;

        // Include the release if it's defined in globalOptions
        if (globalOptions.release) data.release = globalOptions.release;

        // Include server_name if it's defined in globalOptions
        if (globalOptions.serverName) data.server_name = globalOptions.serverName;

        if (isFunction(globalOptions.dataCallback)) {
            data = globalOptions.dataCallback(data) || data;
        }

        // Why??????????
        if (!data || isEmptyObject(data)) {
            return;
        }

        // Check if the request should be filtered or not
        if (isFunction(globalOptions.shouldSendCallback) && !globalOptions.shouldSendCallback(data)) {
            return;
        }

        this._sendProcessedPayload(data);
    },

    _getUuid: function () {
      return uuid4();
    },

    _sendProcessedPayload: function(data, callback) {
        var self = this;
        var globalOptions = this._globalOptions;

        // Send along an event_id if not explicitly passed.
        // This event_id can be used to reference the error within Sentry itself.
        // Set lastEventId after we know the error should actually be sent
        this._lastEventId = data.event_id || (data.event_id = this._getUuid());

        // Try and clean up the packet before sending by truncating long values
        data = this._trimPacket(data);

        this._logDebug('debug', 'Raven about to send:', data);

        if (!this.isSetup()) return;

        var auth = {
            sentry_version: '7',
            sentry_client: 'raven-js/' + this.VERSION,
            sentry_key: this._globalKey
        };
        if (this._globalSecret) {
            auth.sentry_secret = this._globalSecret;
        }

        var exception = data.exception && data.exception.values[0];
        this.captureBreadcrumb({
            category: 'sentry',
            message: exception
                ? (exception.type ? exception.type + ': ' : '') + exception.value
                : data.message,
            event_id: data.event_id,
            level: data.level || 'error' // presume error unless specified
        });

        var url = this._globalEndpoint;
        (globalOptions.transport || this._makeRequest).call(this, {
            url: url,
            auth: auth,
            data: data,
            options: globalOptions,
            onSuccess: function success() {
                self._triggerEvent('success', {
                    data: data,
                    src: url
                });
                callback && callback();
            },
            onError: function failure(error) {
                self._triggerEvent('failure', {
                    data: data,
                    src: url
                });
                error = error || new Error('Raven send failed (no additional details provided)');
                callback && callback(error);
            }
        });
    },

    _makeRequest: function(opts) {
        var request = new XMLHttpRequest();

        // if browser doesn't support CORS (e.g. IE7), we are out of luck
        var hasCORS =
            'withCredentials' in request ||
            typeof XDomainRequest !== 'undefined';

        if (!hasCORS) return;

        var url = opts.url;
        function handler() {
            if (request.status === 200) {
                if (opts.onSuccess) {
                    opts.onSuccess();
                }
            } else if (opts.onError) {
                opts.onError(new Error('Sentry error code: ' + request.status));
            }
        }

        if ('withCredentials' in request) {
            request.onreadystatechange = function () {
                if (request.readyState !== 4) {
                    return;
                }
                handler();
            };
        } else {
            request = new XDomainRequest();
            // xdomainrequest cannot go http -> https (or vice versa),
            // so always use protocol relative
            url = url.replace(/^https?:/, '');

            // onreadystatechange not supported by XDomainRequest
            request.onload = handler;
        }

        // NOTE: auth is intentionally sent as part of query string (NOT as custom
        //       HTTP header) so as to avoid preflight CORS requests
        request.open('POST', url + '?' + urlencode(opts.auth));
        request.send(stringify(opts.data));
    },

    _logDebug: function(level) {
        if (this._originalConsoleMethods[level] && this.debug) {
            // In IE<10 console methods do not have their own 'apply' method
            Function.prototype.apply.call(
                this._originalConsoleMethods[level],
                this._originalConsole,
                [].slice.call(arguments, 1)
            );
        }
    },

    _mergeContext: function(key, context) {
        if (isUndefined(context)) {
            delete this._globalContext[key];
        } else {
            this._globalContext[key] = objectMerge(this._globalContext[key] || {}, context);
        }
    }
};

/*------------------------------------------------
 * utils
 *
 * conditionally exported for test via Raven.utils
 =================================================
 */
var objectPrototype = Object.prototype;

function isUndefined(what) {
    return what === void 0;
}

function isFunction(what) {
    return typeof what === 'function';
}

function isString(what) {
    return objectPrototype.toString.call(what) === '[object String]';
}

function isObject(what) {
    return typeof what === 'object' && what !== null;
}

function isEmptyObject(what) {
    for (var _ in what) return false;  // eslint-disable-line guard-for-in, no-unused-vars
    return true;
}

// Sorta yanked from https://github.com/joyent/node/blob/aa3b4b4/lib/util.js#L560
// with some tiny modifications
function isError(what) {
    var toString = objectPrototype.toString.call(what);
    return isObject(what) &&
        toString === '[object Error]' ||
        toString === '[object Exception]' || // Firefox NS_ERROR_FAILURE Exceptions
        what instanceof Error;
}

function each(obj, callback) {
    var i, j;

    if (isUndefined(obj.length)) {
        for (i in obj) {
            if (hasKey(obj, i)) {
                callback.call(null, i, obj[i]);
            }
        }
    } else {
        j = obj.length;
        if (j) {
            for (i = 0; i < j; i++) {
                callback.call(null, i, obj[i]);
            }
        }
    }
}

function objectMerge(obj1, obj2) {
    if (!obj2) {
        return obj1;
    }
    each(obj2, function(key, value){
        obj1[key] = value;
    });
    return obj1;
}

function truncate(str, max) {
    return !max || str.length <= max ? str : str.substr(0, max) + '\u2026';
}

/**
 * hasKey, a better form of hasOwnProperty
 * Example: hasKey(MainHostObject, property) === true/false
 *
 * @param {Object} host object to check property
 * @param {string} key to check
 */
function hasKey(object, key) {
    return objectPrototype.hasOwnProperty.call(object, key);
}

function joinRegExp(patterns) {
    // Combine an array of regular expressions and strings into one large regexp
    // Be mad.
    var sources = [],
        i = 0, len = patterns.length,
        pattern;

    for (; i < len; i++) {
        pattern = patterns[i];
        if (isString(pattern)) {
            // If it's a string, we need to escape it
            // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
            sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'));
        } else if (pattern && pattern.source) {
            // If it's a regexp already, we want to extract the source
            sources.push(pattern.source);
        }
        // Intentionally skip other cases
    }
    return new RegExp(sources.join('|'), 'i');
}

function urlencode(o) {
    var pairs = [];
    each(o, function(key, value) {
        pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    });
    return pairs.join('&');
}

// borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
// intentionally using regex and not <a/> href parsing trick because React Native and other
// environments where DOM might not be available
function parseUrl(url) {
    var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};

    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        protocol: match[2],
        host: match[4],
        path: match[5],
        relative: match[5] + query + fragment // everything minus origin
    };
}
function uuid4() {
    var crypto = _window.crypto || _window.msCrypto;

    if (!isUndefined(crypto) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);

        // set 4 in byte 7
        arr[3] = arr[3] & 0xFFF | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        arr[4] = arr[4] & 0x3FFF | 0x8000;

        var pad = function(num) {
            var v = num.toString(16);
            while (v.length < 4) {
                v = '0' + v;
            }
            return v;
        };

        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) +
        pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    } else {
        // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
        return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random()*16|0,
                v = c === 'x' ? r : r&0x3|0x8;
            return v.toString(16);
        });
    }
}

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @param elem
 * @returns {string}
 */
function htmlTreeAsString(elem) {
    /* eslint no-extra-parens:0*/
    var MAX_TRAVERSE_HEIGHT = 5,
        MAX_OUTPUT_LEN = 80,
        out = [],
        height = 0,
        len = 0,
        separator = ' > ',
        sepLength = separator.length,
        nextStr;

    while (elem && height++ < MAX_TRAVERSE_HEIGHT) {

        nextStr = htmlElementAsString(elem);
        // bail out if
        // - nextStr is the 'html' element
        // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
        //   (ignore this limit if we are on the first iteration)
        if (nextStr === 'html' || height > 1 && len + (out.length * sepLength) + nextStr.length >= MAX_OUTPUT_LEN) {
            break;
        }

        out.push(nextStr);

        len += nextStr.length;
        elem = elem.parentNode;
    }

    return out.reverse().join(separator);
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @param HTMLElement
 * @returns {string}
 */
function htmlElementAsString(elem) {
    var out = [],
        className,
        classes,
        key,
        attr,
        i;

    if (!elem || !elem.tagName) {
        return '';
    }

    out.push(elem.tagName.toLowerCase());
    if (elem.id) {
        out.push('#' + elem.id);
    }

    className = elem.className;
    if (className && isString(className)) {
        classes = className.split(' ');
        for (i = 0; i < classes.length; i++) {
            out.push('.' + classes[i]);
        }
    }
    var attrWhitelist = ['type', 'name', 'title', 'alt'];
    for (i = 0; i < attrWhitelist.length; i++) {
        key = attrWhitelist[i];
        attr = elem.getAttribute(key);
        if (attr) {
            out.push('[' + key + '="' + attr + '"]');
        }
    }
    return out.join('');
}

/**
 * Polyfill a method
 * @param obj object e.g. `document`
 * @param name method name present on object e.g. `addEventListener`
 * @param replacement replacement function
 * @param track {optional} record instrumentation to an array
 */
function fill(obj, name, replacement, track) {
    var orig = obj[name];
    obj[name] = replacement(orig);
    if (track) {
        track.push([obj, name, orig]);
    }
}

if (typeof __DEV__ !== 'undefined' && __DEV__) {
    Raven.utils = {
        isUndefined: isUndefined,
        isFunction: isFunction,
        isString: isString,
        isObject: isObject,
        isEmptyObject: isEmptyObject,
        isError: isError,
        each: each,
        objectMerge: objectMerge,
        truncate: truncate,
        hasKey: hasKey,
        joinRegExp: joinRegExp,
        urlencode: urlencode,
        uuid4: uuid4,
        htmlTreeAsString: htmlTreeAsString,
        htmlElementAsString: htmlElementAsString,
        parseUrl: parseUrl,
        fill: fill
    };
};

// Deprecations
Raven.prototype.setUser = Raven.prototype.setUserContext;
Raven.prototype.setReleaseContext = Raven.prototype.setRelease;

module.exports = Raven;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Enforces a single instance of the Raven client, and the
 * main entry point for Raven. If you are a consumer of the
 * Raven library, you SHOULD load this file (vs raven.js).
 **/



var RavenConstructor = __webpack_require__(404);

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window = typeof window !== 'undefined' ? window
            : typeof global !== 'undefined' ? global
            : typeof self !== 'undefined' ? self
            : {};
var _Raven = _window.Raven;

var Raven = new RavenConstructor();

/*
 * Allow multiple versions of Raven to be installed.
 * Strip Raven from the global context and returns the instance.
 *
 * @return {Raven}
 */
Raven.noConflict = function () {
	_window.Raven = _Raven;
	return Raven;
};

Raven.afterLoad();

module.exports = Raven;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

/*
 TraceKit - Cross brower stack traces - github.com/occ/TraceKit
 MIT license
*/

var TraceKit = {
    collectWindowErrors: true,
    debug: false
};

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window = typeof window !== 'undefined' ? window
            : typeof global !== 'undefined' ? global
            : typeof self !== 'undefined' ? self
            : {};

// global reference to slice
var _slice = [].slice;
var UNKNOWN_FUNCTION = '?';

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:Uncaught (?:exception: )?)?((?:Eval|Internal|Range|Reference|Syntax|Type|URI)Error): ?(.*)$/;

function getLocationHref() {
    if (typeof document === 'undefined')
        return '';

    return document.location.href;
}

/**
 * TraceKit.report: cross-browser processing of unhandled exceptions
 *
 * Syntax:
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *              on top frame; column number is not guaranteed
 *   - Opera:   full stack trace with line and column numbers
 *   - Chrome:  full stack trace with line and column numbers
 *   - Safari:  line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *   - IE:      line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit.computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a stackInfo object as described in the
 * TraceKit.computeStackTrace docs.
 */
TraceKit.report = (function reportModuleWrapper() {
    var handlers = [],
        lastArgs = null,
        lastException = null,
        lastExceptionStack = null;

    /**
     * Add a crash handler.
     * @param {Function} handler
     */
    function subscribe(handler) {
        installGlobalHandler();
        handlers.push(handler);
    }

    /**
     * Remove a crash handler.
     * @param {Function} handler
     */
    function unsubscribe(handler) {
        for (var i = handlers.length - 1; i >= 0; --i) {
            if (handlers[i] === handler) {
                handlers.splice(i, 1);
            }
        }
    }

    /**
     * Remove all crash handlers.
     */
    function unsubscribeAll() {
        uninstallGlobalHandler();
        handlers = [];
    }

    /**
     * Dispatch stack information to all handlers.
     * @param {Object.<string, *>} stack
     */
    function notifyHandlers(stack, isWindowError) {
        var exception = null;
        if (isWindowError && !TraceKit.collectWindowErrors) {
          return;
        }
        for (var i in handlers) {
            if (handlers.hasOwnProperty(i)) {
                try {
                    handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
                } catch (inner) {
                    exception = inner;
                }
            }
        }

        if (exception) {
            throw exception;
        }
    }

    var _oldOnerrorHandler, _onErrorHandlerInstalled;

    /**
     * Ensures all global unhandled exceptions are recorded.
     * Supported by Gecko and IE.
     * @param {string} message Error message.
     * @param {string} url URL of script that generated the exception.
     * @param {(number|string)} lineNo The line number at which the error
     * occurred.
     * @param {?(number|string)} colNo The column number at which the error
     * occurred.
     * @param {?Error} ex The actual Error object.
     */
    function traceKitWindowOnError(message, url, lineNo, colNo, ex) {
        var stack = null;

        if (lastExceptionStack) {
            TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
            processLastException();
        } else if (ex) {
            // New chrome and blink send along a real error object
            // Let's just report that like a normal error.
            // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
            stack = TraceKit.computeStackTrace(ex);
            notifyHandlers(stack, true);
        } else {
            var location = {
                'url': url,
                'line': lineNo,
                'column': colNo
            };

            var name = undefined;
            var msg = message; // must be new var or will modify original `arguments`
            var groups;
            if ({}.toString.call(message) === '[object String]') {
                var groups = message.match(ERROR_TYPES_RE);
                if (groups) {
                    name = groups[1];
                    msg = groups[2];
                }
            }

            location.func = UNKNOWN_FUNCTION;

            stack = {
                'name': name,
                'message': msg,
                'url': getLocationHref(),
                'stack': [location]
            };
            notifyHandlers(stack, true);
        }

        if (_oldOnerrorHandler) {
            return _oldOnerrorHandler.apply(this, arguments);
        }

        return false;
    }

    function installGlobalHandler ()
    {
        if (_onErrorHandlerInstalled) {
            return;
        }
        _oldOnerrorHandler = _window.onerror;
        _window.onerror = traceKitWindowOnError;
        _onErrorHandlerInstalled = true;
    }

    function uninstallGlobalHandler ()
    {
        if (!_onErrorHandlerInstalled) {
            return;
        }
        _window.onerror = _oldOnerrorHandler;
        _onErrorHandlerInstalled = false;
        _oldOnerrorHandler = undefined;
    }

    function processLastException() {
        var _lastExceptionStack = lastExceptionStack,
            _lastArgs = lastArgs;
        lastArgs = null;
        lastExceptionStack = null;
        lastException = null;
        notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
    }

    /**
     * Reports an unhandled Error to TraceKit.
     * @param {Error} ex
     * @param {?boolean} rethrow If false, do not re-throw the exception.
     * Only used for window.onerror to not cause an infinite loop of
     * rethrowing.
     */
    function report(ex, rethrow) {
        var args = _slice.call(arguments, 1);
        if (lastExceptionStack) {
            if (lastException === ex) {
                return; // already caught by an inner catch block, ignore
            } else {
              processLastException();
            }
        }

        var stack = TraceKit.computeStackTrace(ex);
        lastExceptionStack = stack;
        lastException = ex;
        lastArgs = args;

        // If the stack trace is incomplete, wait for 2 seconds for
        // slow slow IE to see if onerror occurs or not before reporting
        // this exception; otherwise, we will end up with an incomplete
        // stack trace
        setTimeout(function () {
            if (lastException === ex) {
                processLastException();
            }
        }, (stack.incomplete ? 2000 : 0));

        if (rethrow !== false) {
            throw ex; // re-throw to propagate to the top level (and cause window.onerror)
        }
    }

    report.subscribe = subscribe;
    report.unsubscribe = unsubscribe;
    report.uninstall = unsubscribeAll;
    return report;
}());

/**
 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 * Returns:
 *   s.name              - exception name
 *   s.message           - exception message
 *   s.stack[i].url      - JavaScript or HTML file URL
 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
 *   s.stack[i].args     - arguments passed to the function, if known
 *   s.stack[i].line     - line number, if known
 *   s.stack[i].column   - column number, if known
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit.computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit.computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 */
TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
    /**
     * Escapes special characters, except for whitespace, in a string to be
     * used inside a regular expression as a string literal.
     * @param {string} text The string.
     * @return {string} The escaped string literal.
     */
    function escapeRegExp(text) {
        return text.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g, '\\$&');
    }

    /**
     * Escapes special characters in a string to be used inside a regular
     * expression as a string literal. Also ensures that HTML entities will
     * be matched the same as their literal friends.
     * @param {string} body The string.
     * @return {string} The escaped string.
     */
    function escapeCodeAsRegExpForMatchingInsideHTML(body) {
        return escapeRegExp(body).replace('<', '(?:<|&lt;)').replace('>', '(?:>|&gt;)').replace('&', '(?:&|&amp;)').replace('"', '(?:"|&quot;)').replace(/\s+/g, '\\s+');
    }

    // Contents of Exception in various browsers.
    //
    // SAFARI:
    // ex.message = Can't find variable: qq
    // ex.line = 59
    // ex.sourceId = 580238192
    // ex.sourceURL = http://...
    // ex.expressionBeginOffset = 96
    // ex.expressionCaretOffset = 98
    // ex.expressionEndOffset = 98
    // ex.name = ReferenceError
    //
    // FIREFOX:
    // ex.message = qq is not defined
    // ex.fileName = http://...
    // ex.lineNumber = 59
    // ex.columnNumber = 69
    // ex.stack = ...stack trace... (see the example below)
    // ex.name = ReferenceError
    //
    // CHROME:
    // ex.message = qq is not defined
    // ex.name = ReferenceError
    // ex.type = not_defined
    // ex.arguments = ['aa']
    // ex.stack = ...stack trace...
    //
    // INTERNET EXPLORER:
    // ex.message = ...
    // ex.name = ReferenceError
    //
    // OPERA:
    // ex.message = ...message... (see the example below)
    // ex.name = ReferenceError
    // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
    // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'

    /**
     * Computes stack trace information from the stack property.
     * Chrome and Gecko use this property.
     * @param {Error} ex
     * @return {?Object.<string, *>} Stack trace information.
     */
    function computeStackTraceFromStackProp(ex) {
        if (typeof ex.stack === 'undefined' || !ex.stack) return;

        var chrome = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|<anonymous>).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
            gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|\[native).*?)(?::(\d+))?(?::(\d+))?\s*$/i,
            winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
            lines = ex.stack.split('\n'),
            stack = [],
            parts,
            element,
            reference = /^(.*) is undefined$/.exec(ex.message);

        for (var i = 0, j = lines.length; i < j; ++i) {
            if ((parts = chrome.exec(lines[i]))) {
                var isNative = parts[2] && parts[2].indexOf('native') !== -1;
                element = {
                    'url': !isNative ? parts[2] : null,
                    'func': parts[1] || UNKNOWN_FUNCTION,
                    'args': isNative ? [parts[2]] : [],
                    'line': parts[3] ? +parts[3] : null,
                    'column': parts[4] ? +parts[4] : null
                };
            } else if ( parts = winjs.exec(lines[i]) ) {
                element = {
                    'url': parts[2],
                    'func': parts[1] || UNKNOWN_FUNCTION,
                    'args': [],
                    'line': +parts[3],
                    'column': parts[4] ? +parts[4] : null
                };
            } else if ((parts = gecko.exec(lines[i]))) {
                element = {
                    'url': parts[3],
                    'func': parts[1] || UNKNOWN_FUNCTION,
                    'args': parts[2] ? parts[2].split(',') : [],
                    'line': parts[4] ? +parts[4] : null,
                    'column': parts[5] ? +parts[5] : null
                };
            } else {
                continue;
            }

            if (!element.func && element.line) {
                element.func = UNKNOWN_FUNCTION;
            }

            stack.push(element);
        }

        if (!stack.length) {
            return null;
        }

        if (!stack[0].column && typeof ex.columnNumber !== 'undefined') {
            // FireFox uses this awesome columnNumber property for its top frame
            // Also note, Firefox's column number is 0-based and everything else expects 1-based,
            // so adding 1
            stack[0].column = ex.columnNumber + 1;
        }

        return {
            'name': ex.name,
            'message': ex.message,
            'url': getLocationHref(),
            'stack': stack
        };
    }

    /**
     * Adds information about the first frame to incomplete stack traces.
     * Safari and IE require this to get complete data on the first frame.
     * @param {Object.<string, *>} stackInfo Stack trace information from
     * one of the compute* methods.
     * @param {string} url The URL of the script that caused an error.
     * @param {(number|string)} lineNo The line number of the script that
     * caused an error.
     * @param {string=} message The error generated by the browser, which
     * hopefully contains the name of the object that caused the error.
     * @return {boolean} Whether or not the stack information was
     * augmented.
     */
    function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
        var initial = {
            'url': url,
            'line': lineNo
        };

        if (initial.url && initial.line) {
            stackInfo.incomplete = false;

            if (!initial.func) {
                initial.func = UNKNOWN_FUNCTION;
            }

            if (stackInfo.stack.length > 0) {
                if (stackInfo.stack[0].url === initial.url) {
                    if (stackInfo.stack[0].line === initial.line) {
                        return false; // already in stack trace
                    } else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
                        stackInfo.stack[0].line = initial.line;
                        return false;
                    }
                }
            }

            stackInfo.stack.unshift(initial);
            stackInfo.partial = true;
            return true;
        } else {
            stackInfo.incomplete = true;
        }

        return false;
    }

    /**
     * Computes stack trace information by walking the arguments.caller
     * chain at the time the exception occurred. This will cause earlier
     * frames to be missed but is the only way to get any stack trace in
     * Safari and IE. The top frame is restored by
     * {@link augmentStackTraceWithInitialElement}.
     * @param {Error} ex
     * @return {?Object.<string, *>} Stack trace information.
     */
    function computeStackTraceByWalkingCallerChain(ex, depth) {
        var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
            stack = [],
            funcs = {},
            recursion = false,
            parts,
            item,
            source;

        for (var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
            if (curr === computeStackTrace || curr === TraceKit.report) {
                // console.log('skipping internal function');
                continue;
            }

            item = {
                'url': null,
                'func': UNKNOWN_FUNCTION,
                'line': null,
                'column': null
            };

            if (curr.name) {
                item.func = curr.name;
            } else if ((parts = functionName.exec(curr.toString()))) {
                item.func = parts[1];
            }

            if (typeof item.func === 'undefined') {
              try {
                item.func = parts.input.substring(0, parts.input.indexOf('{'));
              } catch (e) { }
            }

            if (funcs['' + curr]) {
                recursion = true;
            }else{
                funcs['' + curr] = true;
            }

            stack.push(item);
        }

        if (depth) {
            // console.log('depth is ' + depth);
            // console.log('stack is ' + stack.length);
            stack.splice(0, depth);
        }

        var result = {
            'name': ex.name,
            'message': ex.message,
            'url': getLocationHref(),
            'stack': stack
        };
        augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
        return result;
    }

    /**
     * Computes a stack trace for an exception.
     * @param {Error} ex
     * @param {(string|number)=} depth
     */
    function computeStackTrace(ex, depth) {
        var stack = null;
        depth = (depth == null ? 0 : +depth);

        try {
            stack = computeStackTraceFromStackProp(ex);
            if (stack) {
                return stack;
            }
        } catch (e) {
            if (TraceKit.debug) {
                throw e;
            }
        }

        try {
            stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
            if (stack) {
                return stack;
            }
        } catch (e) {
            if (TraceKit.debug) {
                throw e;
            }
        }

        return {
            'name': ex.name,
            'message': ex.message,
            'url': getLocationHref()
        };
    }

    computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
    computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;

    return computeStackTrace;
}());

module.exports = TraceKit;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 407 */
/***/ (function(module, exports) {

module.exports = "/*! wpt - v5.1.17 */!function(a,b){\"use strict\";var c,d,e,f,g={},h=[],i=!1,j=!1,k=!0,l=11,m=\"woopra.com/track/\",n=\"__woopraid\";!function(a,b){function c(a){var c=b[a];b[a]=function(a){return f(c(a))}}function d(b,c,d){return d=this,g.unshift([d,b,c,function(b){var b=b||a.event;b.preventDefault=b.preventDefault||function(){b.returnValue=!1},b.stopPropagation=b.stopPropagation||function(){b.cancelBubble=!0},b.currentTarget=d,b.target=b.srcElement||d,c.call(d,b)}]),this.attachEvent(\"on\"+b,g[0][3])}function e(a,b){for(var c,d=0;c=g[d];++d)if(c[0]==this&&c[1]==a&&c[2]==b)return this.detachEvent(\"on\"+a,g.splice(d,1)[0][3])}function f(a,b){if(a&&(b=a.length))for(;b--;)a[b].addEventListener=d,a[b].removeEventListener=e;else a&&(a.addEventListener=d,a.removeEventListener=e);return a}if(!a.addEventListener){var g=[];f([b,a]),\"Element\"in a?(a.Element.prototype.addEventListener=d,a.Element.prototype.removeEventListener=e):(b.attachEvent(\"onreadystatechange\",function(){f(b.all)}),c(\"getElementsByTagName\"),c(\"getElementById\"),c(\"createElement\"),f(b.all))}}(a,b),Array.prototype.indexOf||(Array.prototype.indexOf=function(a,b){if(void 0===this||null===this)throw new TypeError('\"this\" is null or not defined');var c=this.length>>>0;for(b=+b||0,Math.abs(b)===1/0&&(b=0),0>b&&(b+=c,0>b&&(b=0));c>b;b++)if(this[b]===a)return b;return-1}),g.extend=function(a,b){for(var c in b)a[c]=b[c]},g.serializeForm=function(a,b){if(a&&\"FORM\"===a.nodeName){var c,d,e=b||{},f=e.exclude||[],g={};for(c=a.elements.length-1;c>=0;c-=1)if(!(\"\"===a.elements[c].name||f.indexOf(a.elements[c].name)>-1))switch(a.elements[c].nodeName){case\"INPUT\":switch(a.elements[c].type){case\"text\":case\"hidden\":case\"button\":case\"reset\":case\"submit\":g[a.elements[c].name]=a.elements[c].value;break;case\"checkbox\":case\"radio\":a.elements[c].checked&&(g[a.elements[c].name]=a.elements[c].value);break;case\"file\":}break;case\"TEXTAREA\":g[a.elements[c].name]=a.elements[c].value;break;case\"SELECT\":switch(a.elements[c].type){case\"select-one\":g[a.elements[c].name]=a.elements[c].value;break;case\"select-multiple\":for(d=a.elements[c].options.length-1;d>=0;d-=1)a.elements[c].options[d].selected&&(g[a.elements[c].name]=a.elements[c].options[d].value)}break;case\"BUTTON\":switch(a.elements[c].type){case\"reset\":case\"submit\":case\"button\":g[a.elements[c].name]=a.elements[c].value}}return g}};var o={getItem:function(a){return a?decodeURIComponent(b.cookie.replace(new RegExp(\"(?:(?:^|.*;)\\\\s*\"+encodeURIComponent(a).replace(/[\\-\\.\\+\\*]/g,\"\\\\$&\")+\"\\\\s*\\\\=\\\\s*([^;]*).*$)|^.*$\"),\"$1\"))||null:null},setItem:function(a,c,d,e,f,g){if(!a||/^(?:expires|max\\-age|path|domain|secure)$/i.test(a))return!1;var h=\"\";if(d)switch(d.constructor){case Number:h=d===1/0?\"; expires=Fri, 31 Dec 9999 23:59:59 GMT\":\"; max-age=\"+d;break;case String:h=\"; expires=\"+d;break;case Date:h=\"; expires=\"+d.toUTCString()}return b.cookie=encodeURIComponent(a)+\"=\"+encodeURIComponent(c)+h+(f?\"; domain=\"+f:\"\")+(e?\"; path=\"+e:\"\")+(g?\"; secure\":\"\"),!0},removeItem:function(a,c,d){return this.hasItem(a)?(b.cookie=encodeURIComponent(a)+\"=; expires=Thu, 01 Jan 1970 00:00:00 GMT\"+(d?\"; domain=\"+d:\"\")+(c?\"; path=\"+c:\"\"),!0):!1},hasItem:function(a){return a?new RegExp(\"(?:^|;\\\\s*)\"+encodeURIComponent(a).replace(/[\\-\\.\\+\\*]/g,\"\\\\$&\")+\"\\\\s*\\\\=\").test(b.cookie):!1},keys:function(){for(var a=b.cookie.replace(/((?:^|\\s*;)[^\\=]+)(?=;|$)|^\\s*|\\s*(?:\\=[^;]*)?(?:\\1|$)/g,\"\").split(/\\s*(?:\\=[^;]*)?;\\s*/),c=a.length,d=0;c>d;d++)a[d]=decodeURIComponent(a[d]);return a}};g.docCookies=o,g.location=function(b,c){if(\"undefined\"!=typeof a.location[b]){if(\"undefined\"==typeof c)return a.location[b];a.location[b]=c}},g.getCampaignData=function(){for(var a,b,c=g.getUrlParams(),d={},e=[\"source\",\"medium\",\"content\",\"campaign\",\"term\"],f=0;f<e.length;f++)a=e[f],b=c[\"utm_\"+a]||c[\"woo_\"+a],\"undefined\"!=typeof b&&(d[\"campaign_\"+(\"campaign\"===a?\"name\":a)]=b);return d},g.mapQueryParams=function(a){var b=g.getUrlParams(),c={};for(var d in a){var e=b[d];\"undefined\"!=typeof e&&(c[a[d]]=e)}return c},g.getCustomData=function(a,b){var c,d,e,f=g.getUrlParams(),h=b||\"wv_\";for(c in f)f.hasOwnProperty(c)&&(e=f[c],c.substring(0,h.length)===h&&(d=c.substring(h.length),a.call(this,d,e)))},g.getVisitorUrlData=function(a){g.getCustomData.call(a,a.identify,\"wv_\")},g.hideCampaignData=function(){return g.hideUrlParams([\"wv_\",\"woo_\",\"utm_\"])},g.hideCrossDomainId=function(){return g.hideUrlParams([n])},g.hideUrlParams=function(b){var c=new RegExp(\"[?&]+((?:\"+b.join(\"|\")+\")[^=&]*)=([^&#]*)\",\"gi\"),d=g.location(\"href\").replace(c,\"\");return a.history&&a.history.replaceState&&a.history.replaceState(null,null,d),d},g.getUrlParams=function(){var a={},b=g.location(\"href\");return b&&b.replace(/[?&]+([^=&]+)=([^&]*)/gi,function(b,c,d){a[c]=decodeURIComponent(d.split(\"+\").join(\" \"))}),a},g.buildUrlParams=function(a,b){var c,d=b||\"\",e=[];if(\"undefined\"==typeof a)return a;for(c in a)a.hasOwnProperty(c)&&\"undefined\"!==a[c]&&\"null\"!==a[c]&&\"undefined\"!=typeof a[c]&&e.push(d+encodeURIComponent(c)+\"=\"+encodeURIComponent(a[c]));return e.join(\"&\")},g.randomString=function(){var a,b,c=\"0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz\",d=\"\";for(a=0;12>a;a++)b=Math.floor(Math.random()*c.length),d+=c.substring(b,b+1);return d},g.loadScript=function(a,c){var d,e,f=b.createElement(\"script\");f.type=\"text/javascript\",f.async=!0,c&&\"function\"==typeof c&&(e=c),\"undefined\"!=typeof f.onreadystatechange?f.onreadystatechange=function(){(4===this.readyState||\"complete\"===this.readyState||\"loaded\"===this.readyState)&&(e&&e(),g.removeScript(f))}:(f.onload=function(){e&&e(),g.removeScript(f)},f.onerror=function(){g.removeScript(f)}),f.src=a,d=b.getElementsByTagName(\"script\")[0],d.parentNode.insertBefore(f,d)},g.removeScript=function(a){a&&a.parentNode&&a.parentNode.removeChild(a)},g.getElement=function(a,c){var d=\"string\"==typeof a?c||{}:a||{},e=a;if(d.el)return d.el;if(\"string\"==typeof a){if(b.querySelectorAll)return b.querySelectorAll(e);if(\"#\"===a[0])return e=a.substr(1),b.getElementById(e);if(\".\"===a[0])return e=a.substr(1),b.getElementsByClassName(e)}},g.getDomain=function(a){var b=a||g.location(\"hostname\"),c={\"com.au\":1,\"net.au\":1,\"org.au\":1,\"co.hu\":1,\"com.ru\":1,\"ac.za\":1,\"net.za\":1,\"com.za\":1,\"co.za\":1,\"co.uk\":1,\"org.uk\":1,\"me.uk\":1,\"net.uk\":1},d=b.substring(b.lastIndexOf(\".\",b.lastIndexOf(\".\")-1)+1);return c[d]&&(d=b.substring(b.lastIndexOf(\".\",b.indexOf(d)-2)+1)),d},g.getHostnameNoWww=function(){var a=g.location(\"hostname\");return 0===a.indexOf(\"www.\")?a.replace(\"www.\",\"\"):a},g.endsWith=function(a,b){return-1!==a.indexOf(b,a.length-b.length)},g.startsWith=function(a,b){return 0===a.indexOf(b)},c=g._on=function(a,b,c){var d=a.instanceName;h[b]||(h[b]={}),h[b][d]=a,a.__l&&(a.__l[b]||(a.__l[b]=[]),a.__l[b].push(c))},g._fire=function(a){var b,c,d=h[a];if(d)for(var e in d)if(d.hasOwnProperty(e)&&(b=d[e],c=b&&b.__l,c&&c[a]))for(var f=0;f<c[a].length;f++)c[a][f].apply(this,Array.prototype.slice.call(arguments,1))},g.attachEvent=function(a,b,c){a.addEventListener?a.addEventListener(b,c):a.attachEvent&&a.attachEvent(\"on\"+b,function(a){var a=a||win.event;a.preventDefault=a.preventDefault||function(){a.returnValue=!1},a.stopPropagation=a.stopPropagation||function(){a.cancelBubble=!0},c.call(self,a)})},g.leftClick=function(b){b=b||a.event;var c=\"undefined\"!=typeof b.which&&1===b.which||\"undefined\"!=typeof b.button&&0===b.button;return c&&!b.metaKey&&!b.altKey&&!b.ctrlKey&&!b.shiftKey},g.redirect=function(a){g.location(\"href\",a)},g.isOutgoingLink=function(a){var b=g.location(\"hostname\"),c=g.getDomain(b);return!(a===b||a.replace(/^www\\./,\"\")===b.replace(/^www\\./,\"\")||k&&c===g.getDomain(a)||g.startsWith(a,\"javascript\")||\"\"===a||\"#\"===a)},function(c,h){c(b,\"mousedown\",function(a){var b;if(h(\"mousemove\",a,new Date),f){for(b=a.srcElement||a.target;\"undefined\"!=typeof b&&null!==b&&(!b.tagName||\"a\"!==b.tagName.toLowerCase());)b=b.parentNode;\"undefined\"!=typeof b&&null!==b&&h(\"auto_decorate\",b)}}),c(b,\"click\",function(b){var c,f,k,l=\"_blank\";if(c=b.srcElement||b.target,g.leftClick(b)&&h(\"click\",b,c),i||j){for(;\"undefined\"!=typeof c&&null!==c&&(!c.tagName||\"a\"!==c.tagName.toLowerCase());)c=c.parentNode;\"undefined\"==typeof c||null===c||c.getAttribute(\"data-woopra-tracked\")||(f=c,k=f.pathname.match(/(?:doc|dmg|eps|svg|xls|ppt|pdf|xls|zip|txt|vsd|vxd|js|css|rar|exe|wma|mov|avi|wmv|mp3|mp4|m4v)($|\\&)/),i&&k&&(h(\"download\",f.href),f.target!==l&&g.leftClick(b)&&(b.preventDefault(),b.stopPropagation(),f.setAttribute(\"data-woopra-tracked\",!0),a.setTimeout(function(){f.click()},d))),j&&!k&&g.isOutgoingLink(f.hostname)&&(h(\"outgoing\",f.href),f.target!==l&&g.leftClick(b)&&(b.preventDefault(),b.stopPropagation(),f.setAttribute(\"data-woopra-tracked\",!0),a.setTimeout(function(){f.click()},e))))}}),c(b,\"mousemove\",function(a){h(\"mousemove\",a,new Date)}),c(b,\"keydown\",function(){h(\"keydown\")})}(g.attachEvent,g._fire);var p=function(b){this.visitorData={},this.sessionData={},this.options={app:\"js-client\",use_cookies:!0,ping:!0,ping_interval:12e3,idle_timeout:3e5,idle_threshold:1e4,download_pause:d||200,outgoing_pause:e||200,download_tracking:!1,outgoing_tracking:!1,outgoing_ignore_subdomain:!0,hide_campaign:!1,hide_xdm_data:!1,campaign_once:!1,third_party:!1,save_url_hash:!0,cross_domain:!1,region:null,ignore_query_url:!1,map_query_params:{},cookie_name:\"wooTracker\",cookie_domain:\".\"+g.getHostnameNoWww(),cookie_path:\"/\",cookie_expire:new Date((new Date).setDate((new Date).getDate()+730))},this.instanceName=b||\"woopra\",this.idle=0,this.cookie=\"\",this.last_activity=new Date,this.loaded=!1,this.dirtyCookie=!1,this.sentCampaign=!1,this.version=l,b&&\"\"!==b&&(a[b]=this)};p.prototype={docCookies:o,init:function(){var a,b=this;this.__l={},this._processQueue(\"config\"),this._setupCookie(),this._bindEvents(),setTimeout(function(){b._processQueue()},1),this.loaded=!0,a=this.config(\"initialized\"),a&&\"function\"==typeof a&&a(this.instanceName),this.config(\"hide_xdm_data\")&&g.hideCrossDomainId()},_processQueue:function(b){var c,d,e,f;if(f=a.__woo?a.__woo[this.instanceName]:f,f=a._w?a._w[this.instanceName]:f,f&&f._e)for(e=f._e,c=0;c<e.length;c++)d=e[c],\"undefined\"==typeof d||!this[d[0]]||\"undefined\"!=typeof b&&b!==d[0]||this[d[0]].apply(this,Array.prototype.slice.call(d,1))},_setupCookie:function(){var a=this.getUrlId();this.cookie=this.getCookie(),a&&(this.cookie=a),(!this.cookie||this.cookie.length<1)&&(this.cookie=g.randomString()),o.setItem(this.config(\"cookie_name\"),this.cookie,this.config(\"cookie_expire\"),this.config(\"cookie_path\"),this.config(\"cookie_domain\")),this.dirtyCookie=!0},_bindEvents:function(){var a=this;c(this,\"mousemove\",function(){a.moved.apply(a,arguments)}),c(this,\"keydown\",function(){a.typed.apply(a,arguments)}),c(this,\"download\",function(){a.downloaded.apply(a,arguments)}),c(this,\"outgoing\",function(){a.outgoing.apply(a,arguments)}),c(this,\"auto_decorate\",function(){a.autoDecorate.apply(a,arguments)})},_dataSetter:function(a,b,c){var d;if(\"undefined\"==typeof b)return a;if(\"undefined\"==typeof c){if(\"string\"==typeof b)return a[b];if(\"object\"==typeof b)for(d in b)b.hasOwnProperty(d)&&(\"cookie_\"===d.substring(0,7)&&(this.dirtyCookie=!0),a[d]=b[d])}else\"cookie_\"===b.substring(0,7)&&(this.dirtyCookie=!0),a[b]=c;return this},_push:function(a){var b,c,d,e,f,h,i=a||{},j=\"ra=\"+g.randomString(),k=[[\"visitorData\",\"cv_\"],[\"eventData\",\"ce_\"],[\"sessionData\",\"cs_\"]],l=[];c=this.getEndpoint(i.endpoint),g.getVisitorUrlData(this),this.config(\"hide_campaign\")&&g.hideCampaignData(),l.push(j),l.push(g.buildUrlParams(this.getOptionParams())),i.eventName&&l.push(\"event=\"+i.eventName);for(h in k)k.hasOwnProperty(h)&&(f=k[h],i[f[0]]&&(d=g.buildUrlParams(i[f[0]],f[1]),d&&l.push(d)));b=\"?\"+l.join(\"&\"),e=c+b,g.loadScript(e,i.callback)},getCookie:function(){return o.getItem(this.config(\"cookie_name\"))},getEndpoint:function(a){var b,c=this.config(\"protocol\"),d=c&&\"\"!==c?c+\":\":\"\",e=a||\"\",f=d+\"//\",h=this.config(\"region\");if(this.config(\"third_party\")&&!this.config(\"domain\"))throw new Error(\"Error: `domain` is not set.\");return f+=h?h+\".t.\":\"www.\",b=this.config(\"third_party\")?\"tp/\"+this.config(\"domain\"):\"\",e&&!g.endsWith(e,\"/\")&&(e+=\"/\"),b&&!g.startsWith(e,\"/\")&&(b+=\"/\"),f+=m+b+e},config:function(a,b){var c=this._dataSetter(this.options,a,b);return c===this&&(this.options.ping_interval<6e3?this.options.ping_interval=6e3:this.options.ping_interval>6e4&&(this.options.ping_interval=6e4),j=this.options.outgoing_tracking,e=this.options.outgoing_pause,i=this.options.download_tracking,d=this.options.download_pause,f=\"undefined\"==typeof f&&this.options.cross_domain?this.options.cross_domain:f,k=this.options.outgoing_ignore_subdomain,this.dirtyCookie&&this.loaded&&this._setupCookie()),c},visit:function(a,b){return this._dataSetter(this.sessionData,a,b)},identify:function(a,b){return this._dataSetter(this.visitorData,a,b)},call:function(a){this[a]&&\"function\"==typeof this[a]&&this[a].apply(this,Array.prototype.slice.call(arguments,1))},track:function(a,b){var c,d,e={},f=\"\",h=arguments[arguments.length-1];this.config(\"campaign_once\")&&this.sentCampaign||(g.extend(e,g.getCampaignData()),this.sentCampaign=!0),g.extend(e,g.mapQueryParams(this.config(\"map_query_params\"))),\"function\"==typeof h&&(c=h),\"undefined\"==typeof a||a===c?f=\"pv\":\"undefined\"==typeof b||b===c?(\"string\"==typeof a&&(f=a),\"object\"==typeof a&&(a.name&&\"pv\"===a.name&&(f=\"pv\"),this._dataSetter(e,a))):(this._dataSetter(e,b),f=a),\"pv\"===f&&(e.url=e.url||this.getPageUrl(),e.title=e.title||this.getPageTitle(),e.domain=e.domain||this.getDomainName(),e.uri=e.uri||this.getURI(),this.config(\"save_url_hash\")&&(d=e.hash||this.getPageHash(),\"\"!==d&&(e.hash=d))),this._push({endpoint:\"ce\",visitorData:this.visitorData,sessionData:this.sessionData,eventName:f,eventData:e,callback:c}),this.startPing()},trackForm:function(a,b,c){var d,e,f=a||\"Tracked Form\",h=\"string\"==typeof b?c||{}:b||{},i=this;if(e=function(a,b,c,d){g.attachEvent(a,\"submit\",function(c){i.trackFormHandler(c,a,b,h)})},d=h.elements?h.elements:g.getElement(b,h),d&&d.length>0)for(var j in d)e(d[j],f,h)},trackFormHandler:function(a,b,c,d){var e,f,h=!1;b.getAttribute(\"data-tracked\")||(e=g.serializeForm(b,d),d.identify&&\"function\"==typeof d.identify&&(f=d.identify(e)||{},f&&this.identify(f)),d.noSubmit?this.track(c,e,function(){\"function\"==typeof d.callback&&d.callback(e)}):(a.preventDefault(),a.stopPropagation(),b.setAttribute(\"data-tracked\",1),this.track(c,e,function(){h=!0,\"function\"==typeof d.callback&&d.callback(e),b.submit()}),setTimeout(function(){h||b.submit()},250)))},trackClick:function(a,b,c,d){var e,f,h=[],i=d||{},j=a||\"Item Clicked\",k=this;if(f=function(a,b,c,d){g.attachEvent(a,\"click\",function(e){k.trackClickHandler(e,a,b,c,d)})},h=i.elements?i.elements:g.getElement(b,i))for(e=0;e<h.length;e++)f(h[e],j,c,i)},trackClickHandler:function(a,b,c,d,e){var f=!1;b.getAttribute(\"data-tracked\")||(e.noNav?this.track(c,d):(a.preventDefault(),b.setAttribute(\"data-tracked\",1),this.track(c,d,function(){f=!0,\"function\"==typeof e.callback&&e.callback(),b.click()}),setTimeout(function(){f||b.click()},250)))},startPing:function(){var b=this;\"undefined\"==typeof this.pingInterval&&(this.pingInterval=a.setInterval(function(){b.ping()},this.config(\"ping_interval\")))},stopPing:function(){\"undefined\"!=typeof this.pingInterval&&(a.clearInterval(this.pingInterval),delete this.pingInterval)},ping:function(){var a;return this.config(\"ping\")&&this.idle<this.config(\"idle_timeout\")?this._push({endpoint:\"ping\"}):this.stopPing(),a=new Date,a-this.last_activity>this.config(\"idle_threshold\")&&(this.idle=a-this.last_activity),this},push:function(a){return this._push({endpoint:\"identify\",visitorData:this.visitorData,sessionData:this.sessionData,callback:a}),this},sleep:function(){},moved:function(a,b){this.last_activity=b,this.idle=0},typed:function(){this.vs=2},downloaded:function(a){this.track(\"download\",{url:a})},outgoing:function(a){this.track(\"outgoing\",{url:a})},autoDecorate:function(a){var b,c,d=this.config(\"cross_domain\");d&&(\"string\"==typeof d?c=a.href.indexOf(d)>-1:d.push&&(c=d.indexOf(a.hostname)>-1),c&&(b=this.decorate(a),b&&(a.href=b)))},reset:function(){o.removeItem(this.config(\"cookie_name\"),this.config(\"cookie_path\"),this.config(\"cookie_domain\")),this.cookie=null,this._setupCookie()},decorate:function(a){var c,d,e,f;return\"string\"==typeof a?(c=b.createElement(\"a\"),c.href=a,d=c.search?\"&\":\"?\"):a&&a.href&&(c=a),c?(d=c.search?\"&\":\"?\",e=c.pathname&&\"/\"===c.pathname.charAt(0)?c.pathname:\"/\"+c.pathname,f=c.hostname+(c.port&&\"\"!==c.port&&\"80\"!==c.port&&\"0\"!==c.port?\":\"+c.port:\"\"),c.protocol+\"//\"+f+e+c.search+d+n+\"=\"+this.cookie+c.hash):void 0},undecorate:function(a){var b=new RegExp(\"[?&]+(?:\"+n+\")=([^&#]*)\",\"gi\"),c=a;return a&&a.href&&(c=a.href),c?c.replace(b,\"\"):void 0},getPageUrl:function(){return this.options.ignore_query_url?g.location(\"pathname\"):g.location(\"pathname\")+g.location(\"search\")},getPageHash:function(){return g.location(\"hash\")},getPageTitle:function(){return 0===b.getElementsByTagName(\"title\").length?\"\":b.getElementsByTagName(\"title\")[0].innerHTML},getDomainName:function(){return g.location(\"hostname\")},getURI:function(){return g.location(\"href\")},getUrlId:function(a){var b,c=a||g.location(\"href\"),d=new RegExp(n+\"=([^&#]+)\");return b=c.match(d),b&&b[1]?b[1]:void 0},getOptionParams:function(){var c={alias:this.config(\"domain\")||g.getHostnameNoWww(),instance:this.instanceName,ka:this.config(\"keep_alive\")||2*this.config(\"ping_interval\"),meta:o.getItem(\"wooMeta\")||\"\",screen:a.screen.width+\"x\"+a.screen.height,language:a.navigator.browserLanguage||a.navigator.language||\"\",app:this.config(\"app\"),referer:b.referrer,idle:\"\"+parseInt(this.idle/1e3,10),vs:\"i\"};return this.config(\"domain\")||(c._warn=\"no_domain\",g.getHostnameNoWww()!==g.getDomain()&&(c._warn+=\",domain_mismatch\")),this.config(\"use_cookies\")&&(c.cookie=this.getCookie()||this.cookie),this.config(\"ip\")&&(c.ip=this.config(\"ip\")),2===this.vs?(c.vs=\"w\",this.vs=0):0===this.idle&&(c.vs=\"r\"),c},dispose:function(){this.stopPing();for(var b in this.__l)this.__l.hasOwnProperty(b)&&(h[b][this.instanceName]=null);if(this.__l=null,\"undefined\"!=typeof a[this.instanceName])try{delete a[this.instanceName]}catch(c){a[this.instanceName]=void 0}}},a.WoopraTracker=p,a.WoopraLoadScript=g.loadScript,\"undefined\"!=typeof a.exports&&(g.Tracker=p,a.exports.Woopra=g,\"function\"==typeof a.woopraLoaded&&(a.woopraLoaded(),a.woopraLoaded=null));var q=a.__woo||a._w;if(\"undefined\"!=typeof q)for(var r in q)if(q.hasOwnProperty(r)){var s=new p(r);s.init(),\"undefined\"==typeof a.woopraTracker&&(a.woopraTracker=s)}}(window,document);"

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(5);
var ReactDOM = __webpack_require__(5);
var ExecutionEnvironment = __webpack_require__(358);
var ModalPortal = React.createFactory(__webpack_require__(409));
var ariaAppHider = __webpack_require__(410);
var elementClass = __webpack_require__(340);
var renderSubtreeIntoContainer = __webpack_require__(5).unstable_renderSubtreeIntoContainer;

var SafeHTMLElement = ExecutionEnvironment.canUseDOM ? window.HTMLElement : {};
var AppElement = ExecutionEnvironment.canUseDOM ? document.body : { appendChild: function appendChild() {} };

var Modal = React.createClass({

  displayName: 'Modal',
  statics: {
    setAppElement: function setAppElement(element) {
      AppElement = ariaAppHider.setElement(element);
    },
    injectCSS: function injectCSS() {
      "production" !== "production" && console.warn('React-Modal: injectCSS has been deprecated ' + 'and no longer has any effect. It will be removed in a later version');
    }
  },

  propTypes: {
    isOpen: React.PropTypes.bool.isRequired,
    style: React.PropTypes.shape({
      content: React.PropTypes.object,
      overlay: React.PropTypes.object
    }),
    portalClassName: React.PropTypes.string,
    bodyClassName: React.PropTypes.string,
    appElement: React.PropTypes.instanceOf(SafeHTMLElement),
    onAfterOpen: React.PropTypes.func,
    onRequestClose: React.PropTypes.func,
    closeTimeoutMS: React.PropTypes.number,
    ariaHideApp: React.PropTypes.bool,
    shouldCloseOnOverlayClick: React.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      isOpen: false,
      portalClassName: 'ReactModalPortal',
      bodyClassName: 'ReactModal__Body',
      ariaHideApp: true,
      closeTimeoutMS: 0,
      shouldCloseOnOverlayClick: true
    };
  },

  componentDidMount: function componentDidMount() {
    this.node = document.createElement('div');
    this.node.className = this.props.portalClassName;
    document.body.appendChild(this.node);
    this.renderPortal(this.props);
  },

  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
    this.renderPortal(newProps);
  },

  componentWillUnmount: function componentWillUnmount() {
    ReactDOM.unmountComponentAtNode(this.node);
    document.body.removeChild(this.node);
    elementClass(document.body).remove(this.openBodyClass());
  },

  openBodyClass: function openBodyClass() {
    return this.props.bodyClassName + "--open";
  },

  renderPortal: function renderPortal(props) {
    if (props.isOpen) {
      elementClass(document.body).add(this.openBodyClass());
    } else {
      elementClass(document.body).remove(this.openBodyClass());
    }

    if (props.ariaHideApp) {
      ariaAppHider.toggle(props.isOpen, props.appElement);
    }

    this.portal = renderSubtreeIntoContainer(this, ModalPortal(_extends({}, props, { defaultStyles: Modal.defaultStyles })), this.node);
  },

  render: function render() {
    return React.DOM.noscript();
  }
});

Modal.defaultStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.75)'
  },
  content: {
    position: 'absolute',
    top: '40px',
    left: '40px',
    right: '40px',
    bottom: '40px',
    border: '1px solid #ccc',
    background: '#fff',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '4px',
    outline: 'none',
    padding: '20px'
  }
};

module.exports = Modal;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(5);
var div = React.DOM.div;
var focusManager = __webpack_require__(411);
var scopeTab = __webpack_require__(412);

var noOp = function noOp() {};

var defaultProps = {
  onAfterClose: noOp,
  style: {
    overlay: {},
    content: {}
  },
  overlayClassName: 'ReactModal__Overlay',
  className: 'ReactModal__Content'
};

var ModalPortal = module.exports = React.createClass({
  displayName: 'ModalPortal',
  shouldClose: null,

  getDefaultProps: function getDefaultProps() {
    return defaultProps;
  },

  getInitialState: function getInitialState() {
    return {
      afterOpen: false,
      beforeClose: false
    };
  },

  componentDidMount: function componentDidMount() {
    // Focus needs to be set when mounting and already open
    if (this.props.isOpen) {
      this.setFocusAfterRender(true);
      this.open();
    }
  },

  componentWillUnmount: function componentWillUnmount() {
    clearTimeout(this.closeTimer);
  },

  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
    // Focus only needs to be set once when the modal is being opened
    if (!this.props.isOpen && newProps.isOpen) {
      this.setFocusAfterRender(true);
      this.open();
    } else if (this.props.isOpen && !newProps.isOpen) {
      this.close();
    }
  },

  componentDidUpdate: function componentDidUpdate() {
    if (this.focusAfterRender) {
      this.focusContent();
      this.setFocusAfterRender(false);
    }
  },

  setFocusAfterRender: function setFocusAfterRender(focus) {
    this.focusAfterRender = focus;
  },

  open: function open() {
    if (this.state.afterOpen && this.state.beforeClose) {
      clearTimeout(this.closeTimer);
      this.setState({ beforeClose: false });
    } else {
      focusManager.setupScopedFocus(this.node);
      focusManager.markForFocusLater();
      this.setState({ isOpen: true }, function () {
        this.setState({ afterOpen: true });

        if (this.props.isOpen && this.props.onAfterOpen) {
          this.props.onAfterOpen();
        }
      }.bind(this));
    }
  },

  close: function close() {
    if (!this.ownerHandlesClose()) return;
    if (this.props.closeTimeoutMS > 0) this.closeWithTimeout();else this.closeWithoutTimeout();
  },

  focusContent: function focusContent() {
    // Don't steal focus from inner elements
    if (!this.contentHasFocus()) {
      this.refs.content.focus();
    }
  },

  closeWithTimeout: function closeWithTimeout() {
    this.setState({ beforeClose: true }, function () {
      this.closeTimer = setTimeout(this.closeWithoutTimeout, this.props.closeTimeoutMS);
    }.bind(this));
  },

  closeWithoutTimeout: function closeWithoutTimeout() {
    this.setState({
      beforeClose: false,
      isOpen: false,
      afterOpen: false
    }, this.afterClose);
  },

  afterClose: function afterClose() {
    focusManager.returnFocus();
    focusManager.teardownScopedFocus();
    this.props.onAfterClose();
  },

  handleKeyDown: function handleKeyDown(event) {
    if (event.keyCode == 9 /*tab*/) scopeTab(this.refs.content, event);
    if (event.keyCode == 27 /*esc*/) {
        event.preventDefault();
        this.requestClose(event);
      }
  },

  handleOverlayMouseDown: function handleOverlayMouseDown(event) {
    if (this.shouldClose === null) {
      this.shouldClose = true;
    }
  },

  handleOverlayMouseUp: function handleOverlayMouseUp(event) {
    if (this.shouldClose && this.props.shouldCloseOnOverlayClick) {
      if (this.ownerHandlesClose()) this.requestClose(event);else this.focusContent();
    }
    this.shouldClose = null;
  },

  handleContentMouseDown: function handleContentMouseDown(event) {
    this.shouldClose = false;
  },

  handleContentMouseUp: function handleContentMouseUp(event) {
    this.shouldClose = false;
  },

  requestClose: function requestClose(event) {
    if (this.ownerHandlesClose()) this.props.onRequestClose(event);
  },

  ownerHandlesClose: function ownerHandlesClose() {
    return this.props.onRequestClose;
  },

  shouldBeClosed: function shouldBeClosed() {
    return !this.props.isOpen && !this.state.beforeClose;
  },

  contentHasFocus: function contentHasFocus() {
    return document.activeElement === this.refs.content || this.refs.content.contains(document.activeElement);
  },

  buildClassName: function buildClassName(baseClass) {
    var className = baseClass + " ";
    if (this.state.afterOpen) className += baseClass + '--after-open';
    if (this.state.beforeClose) className += baseClass + '--before-close';
    return className;
  },

  getPropInlineStyle: function getPropInlineStyle(useDefaultStyle, styleName) {
    var defaultStyles = useDefaultStyle ? this.props.defaultStyles[styleName] : {};
    var propsStyles = this.props.style[styleName] || {};
    return _extends({}, defaultStyles, propsStyles);
  },

  isPropEqualToDefault: function isPropEqualToDefault(propName) {
    return this.props[propName] === defaultProps[propName];
  },

  render: function render() {
    var contentStyles = this.getPropInlineStyle(this.isPropEqualToDefault("className"), "content");
    var overlayStyles = this.getPropInlineStyle(this.isPropEqualToDefault("overlayClassName"), "overlay");

    return this.shouldBeClosed() ? div() : div({
      ref: "overlay",
      className: this.buildClassName(this.props.overlayClassName),
      style: overlayStyles,
      onMouseDown: this.handleOverlayMouseDown,
      onMouseUp: this.handleOverlayMouseUp
    }, div({
      ref: "content",
      style: contentStyles,
      className: this.buildClassName(this.props.className),
      tabIndex: "-1",
      onKeyDown: this.handleKeyDown,
      onMouseDown: this.handleContentMouseDown,
      onMouseUp: this.handleContentMouseUp,
      role: "dialog"
    }, this.props.children));
  }
});

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _element = typeof document !== 'undefined' ? document.body : null;

function setElement(element) {
  if (typeof element === 'string') {
    var el = document.querySelectorAll(element);
    element = 'length' in el ? el[0] : el;
  }
  _element = element || _element;
  return _element;
}

function hide(appElement) {
  validateElement(appElement);
  (appElement || _element).setAttribute('aria-hidden', 'true');
}

function show(appElement) {
  validateElement(appElement);
  (appElement || _element).removeAttribute('aria-hidden');
}

function toggle(shouldHide, appElement) {
  if (shouldHide) hide(appElement);else show(appElement);
}

function validateElement(appElement) {
  if (!appElement && !_element) throw new Error('react-modal: You must set an element with `Modal.setAppElement(el)` to make this accessible');
}

function resetForTesting() {
  _element = document.body;
}

exports.toggle = toggle;
exports.setElement = setElement;
exports.show = show;
exports.hide = hide;
exports.resetForTesting = resetForTesting;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var findTabbable = __webpack_require__(159);
var modalElement = null;
var focusLaterElement = null;
var needToFocus = false;

function handleBlur(event) {
  needToFocus = true;
}

function handleFocus(event) {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation 
    // is that the document.body gets focus, and then we focus our element right 
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) return;
      var el = findTabbable(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

exports.markForFocusLater = function () {
  focusLaterElement = document.activeElement;
};

exports.returnFocus = function () {
  try {
    focusLaterElement.focus();
  } catch (e) {
    console.warn('You tried to return focus to ' + focusLaterElement + ' but it is not in the DOM anymore');
  }
  focusLaterElement = null;
};

exports.setupScopedFocus = function (element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener('blur', handleBlur, false);
    document.addEventListener('focus', handleFocus, true);
  } else {
    window.attachEvent('onBlur', handleBlur);
    document.attachEvent('onFocus', handleFocus);
  }
};

exports.teardownScopedFocus = function () {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener('blur', handleBlur);
    document.removeEventListener('focus', handleFocus);
  } else {
    window.detachEvent('onBlur', handleBlur);
    document.detachEvent('onFocus', handleFocus);
  }
};

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var findTabbable = __webpack_require__(159);

module.exports = function (node, event) {
  var tabbable = findTabbable(node);
  if (!tabbable.length) {
    event.preventDefault();
    return;
  }
  var finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
  var leavingFinalTabbable = finalTabbable === document.activeElement ||
  // handle immediate shift+tab after opening with mouse
  node === document.activeElement;
  if (!leavingFinalTabbable) return;
  event.preventDefault();
  var target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
  target.focus();
};

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(408);

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_Input__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_InputWithDefaultMetadata__ = __webpack_require__(415);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_1__modules_InputWithDefaultMetadata__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_libphonenumber_js__ = __webpack_require__(155);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "parse_phone_number", function() { return __WEBPACK_IMPORTED_MODULE_2_libphonenumber_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "parsePhoneNumber", function() { return __WEBPACK_IMPORTED_MODULE_2_libphonenumber_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "format_phone_number", function() { return __WEBPACK_IMPORTED_MODULE_2_libphonenumber_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatPhoneNumber", function() { return __WEBPACK_IMPORTED_MODULE_2_libphonenumber_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "is_valid_phone_number", function() { return __WEBPACK_IMPORTED_MODULE_2_libphonenumber_js__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isValidPhoneNumber", function() { return __WEBPACK_IMPORTED_MODULE_2_libphonenumber_js__["c"]; });






/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_libphonenumber_js_metadata_min_json__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_libphonenumber_js_metadata_min_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_libphonenumber_js_metadata_min_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Input__ = __webpack_require__(160);











var InputWithDefaultMetadata = function (_Component) {
	__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(InputWithDefaultMetadata, _Component);

	function InputWithDefaultMetadata() {
		__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InputWithDefaultMetadata);

		return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (InputWithDefaultMetadata.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(InputWithDefaultMetadata)).apply(this, arguments));
	}

	__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(InputWithDefaultMetadata, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_6_react__["default"].createElement(__WEBPACK_IMPORTED_MODULE_8__Input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
				ref: function ref(_ref) {
					return _this2.input = _ref;
				}
			}, this.props, {
				metadata: __WEBPACK_IMPORTED_MODULE_7_libphonenumber_js_metadata_min_json___default.a }));
		}
	}, {
		key: 'focus',
		value: function focus() {
			return this.input.focus();
		}
	}]);

	return InputWithDefaultMetadata;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (InputWithDefaultMetadata);
//# sourceMappingURL=InputWithDefaultMetadata.js.map

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = InternationalIcon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(5);


function InternationalIcon() {
	return __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
		"svg",
		{ version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink",
			viewBox: "0 0 356.926 356.926" },
		__WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
			"g",
			null,
			__WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
				"g",
				null,
				__WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement("path", { d: "M211.89,213.669c0-10.475-8.521-18.997-18.996-18.997c-0.401,0-0.799,0.017-1.193,0.041v2.406 c0.396-0.028,0.79-0.061,1.193-0.061c9.158,0,16.608,7.452,16.608,16.611s-7.45,16.61-16.608,16.61 c-0.269,0-0.53-0.027-0.795-0.041v0.897v1.509v4.723H186.2v3.182h13.388v-3.182h-5.104v-4.774 C204.218,231.781,211.89,223.607,211.89,213.669z" }),
				__WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
					"g",
					null,
					__WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement("polygon", { points: "260.072,79.408 260.398,82.045 256.447,82.882 255.913,88.517 260.677,88.517 266.998,87.913 270.251,84.021 266.788,82.678 264.883,80.488 262.024,75.858 260.677,69.329 255.286,70.409 253.799,72.721 253.799,75.312 256.378,77.084 " }),
					__WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement("polygon", { points: "255.495,81.569 255.773,78.037 252.637,76.683 248.233,77.706 244.945,82.94 244.945,86.344 248.768,86.344 " }),
					__WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement("path", { d: "M164.852,96.598l-0.976,2.498h-4.7v2.428h1.121c0,0,0.07,0.511,0.168,1.191l2.876-0.238l1.783-1.121l0.465-2.248 l2.335-0.204l0.912-1.888l-2.138-0.442L164.852,96.598z" }),
					__WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement("polygon", { points: "152.739,101.001 152.565,103.366 155.976,103.081 156.324,100.705 154.279,99.096 \t\t\t" }),
					__WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement("path", { d: "M356.868,176.633c-0.047-5.223-0.313-10.398-0.802-15.505c-1.662-17.01-5.717-33.311-11.828-48.589 c-0.441-1.127-0.859-2.283-1.336-3.41c-8.121-19.183-19.531-36.646-33.474-51.721c-0.906-0.987-1.835-1.952-2.765-2.916 c-2.649-2.736-5.333-5.415-8.156-7.971C266.788,17.631,224.642,0,178.463,0C131.896,0,89.447,17.957,57.635,47.271 c-7.413,6.832-14.221,14.303-20.408,22.285C13.919,99.717,0,137.49,0,178.463c0,98.398,80.059,178.463,178.463,178.463 c69.225,0,129.316-39.643,158.897-97.399c6.32-12.327,11.247-25.491,14.569-39.294c0.837-3.486,1.58-7.018,2.208-10.585 c1.801-10.137,2.788-20.56,2.788-31.196C356.902,177.859,356.868,177.249,356.868,176.633z M323.278,105.306l1.022-1.162 c1.359,2.637,2.649,5.304,3.846,8.028l-1.708-0.07l-3.172,0.436v-7.233H323.278z M297.484,74.156l0.023-7.971 c2.812,2.975,5.508,6.036,8.087,9.214l-3.207,4.781l-11.247-0.111l-0.696-2.341L297.484,74.156z M82.214,54.364v-0.302h3.567 l0.325-1.226h5.838v2.55l-1.691,2.236h-8.052v-3.259H82.214z M87.925,62.323c0,0,3.578-0.61,3.892-0.61c0.296,0,0,3.573,0,3.573 l-8.081,0.511l-1.534-1.847L87.925,62.323z M334.642,133.156h-13.06l-7.971-5.92l-8.365,0.808v5.112h-2.648l-2.848-2.033 l-14.512-3.671v-9.4l-18.38,1.423l-5.705,3.062h-7.285l-3.59-0.36l-8.854,4.926v9.254l-18.097,13.065l1.5,5.583h3.677 l-0.964,5.315l-2.58,0.953l-0.133,13.884l15.633,17.823h6.819l0.407-1.081h12.246l3.531-3.265h6.948l3.812,3.811l10.328,1.069 l-1.359,13.757l11.503,20.28l-6.064,11.572l0.406,5.438l4.775,4.752v13.095l6.251,8.412v10.897h5.391 c-30.046,36.913-75.823,60.534-127.026,60.534c-90.312,0-163.783-73.454-163.783-163.777c0-22.732,4.665-44.401,13.077-64.089 v-5.106l5.855-7.11c2.033-3.846,4.212-7.582,6.542-11.235l0.25,2.974l-6.791,8.261c-2.108,3.985-4.084,8.052-5.855,12.217v9.312 l6.791,3.276v12.955l6.535,11.136l5.316,0.808l0.68-3.817l-6.245-9.661l-1.237-9.388h3.677l1.557,9.673l9.051,13.193l-2.33,4.27 l5.734,8.795l14.291,3.532v-2.306l5.711,0.808l-0.534,4.078l4.484,0.825l6.948,1.888l9.8,11.171l12.507,0.941l1.237,10.207 l-8.58,5.984l-0.39,9.115l-1.237,5.588l12.386,15.5l0.947,5.32c0,0,4.49,1.209,5.048,1.209c0.535,0,10.062,7.227,10.062,7.227 v28.024l3.393,0.964l-2.294,12.92l5.71,7.634l-1.068,12.827l7.563,13.269l9.696,8.47l9.731,0.197l0.952-3.148l-7.163-6.029 l0.418-2.986l1.272-3.684l0.273-3.741l-4.839-0.14l-2.44-3.066l4.021-3.881l0.546-2.916l-4.496-1.29l0.261-2.719l6.402-0.976 l9.73-4.672l3.265-6.006l10.196-13.06l-2.312-10.213l3.131-5.438l9.399,0.278l6.327-5.02l2.051-19.693l7.04-8.877l1.237-5.704 l-6.39-2.045l-4.224-6.942l-14.419-0.145l-11.444-4.351l-0.534-8.162l-3.811-6.675l-10.335-0.145l-5.995-9.382l-5.298-2.585 l-0.273,2.858l-9.672,0.569l-3.532-4.926l-10.079-2.045l-8.302,9.603l-13.065-2.23l-0.953-14.727l-9.527-1.632l3.805-7.221 l-1.092-4.148l-12.531,8.371l-7.877-0.964l-2.817-6.158l1.737-6.355l4.339-8.005l9.998-5.072h19.322l-0.064,5.891l6.948,3.235 l-0.558-10.062l5.007-5.037l10.103-6.64l0.703-4.659l10.068-10.486l10.707-5.937l-0.941-0.773l7.256-6.826l2.655,0.703 l1.214,1.522l2.76-3.062l0.68-0.296l-3.021-0.43l-3.084-0.987v-2.963l1.632-1.33h3.579l1.655,0.726l1.418,2.858l1.737-0.267 v-0.244l0.5,0.163l5.02-0.772l0.714-2.463l2.852,0.726v2.667l-2.666,1.818h0.018l0.377,2.928l9.115,2.794c0,0,0,0.035,0.023,0.11 l2.079-0.18l0.146-3.939l-7.209-3.282l-0.396-1.894l5.972-2.033l0.273-5.722l-6.245-3.805l-0.412-9.667l-8.581,4.218h-3.143 l0.837-7.355l-11.688-2.748l-4.816,3.654v11.119l-8.673,2.754l-3.486,7.244l-3.758,0.604v-9.277l-8.162-1.133l-4.096-2.667 l-1.639-6.007l14.611-8.54l7.14-2.179l0.72,4.804l3.991-0.215l0.308-2.411l4.166-0.599l0.07-0.842l-1.784-0.738l-0.407-2.544 l5.118-0.43l3.091-3.213l0.18-0.238l0.035,0.012l0.941-0.976l10.753-1.354l4.746,4.032l-12.467,6.64l15.871,3.747l2.045-5.31 h6.948l2.44-4.625l-4.903-1.226v-5.856l-15.359-6.803l-10.62,1.226l-6.001,3.125l0.407,7.628l-6.257-0.953l-0.964-4.212 l6.007-5.449l-10.898-0.535l-3.125,0.953l-1.359,3.677l4.084,0.686l-0.813,4.084l-6.936,0.406l-1.092,2.725L118.987,52.4 c0,0-0.273-5.711-0.703-5.711c-0.389,0,7.901-0.145,7.901-0.145l5.995-5.85l-3.271-1.632l-4.339,4.223l-7.222-0.406l-4.403-6.019 h-9.254L94.03,44.07h8.848l0.796,2.597l-2.307,2.172l9.807,0.279l1.487,3.532l-11.032-0.407l-0.546-2.725l-6.925-1.499 l-3.689-2.033l-8.255,0.069c27.043-19.699,60.284-31.358,96.226-31.358c41.403,0,79.263,15.476,108.124,40.915l-1.929,3.474 l-7.564,2.962l-3.194,3.462l0.743,4.02l3.893,0.546l2.358,5.867l6.704-2.713l1.127,7.86h-2.045l-5.519-0.819l-6.111,1.022 l-5.926,8.377l-8.458,1.319l-1.221,7.25l3.579,0.842l-1.046,4.665l-8.412-1.69l-7.703,1.69l-1.639,4.293l1.325,9.01l4.531,2.115 l7.61-0.046l5.123-0.465l1.58-4.078l8.018-10.422l5.264,1.081l5.193-4.7l0.976,3.678l12.78,8.621l-1.557,2.108l-5.763-0.308 l2.23,3.137l3.556,0.79l4.159-1.737l-0.093-5.002l1.859-0.923l-1.487-1.575l-8.528-4.758l-2.254-6.314h7.099l2.243,2.248 l6.134,5.257l0.244,6.367l6.332,6.733l2.348-9.231l4.392-2.394l0.802,7.552l4.287,4.7l8.54-0.139 c1.661,4.247,3.148,8.563,4.427,12.978L334.642,133.156z M97.324,81.092l4.27-2.044l3.881,0.929l-1.324,5.211l-4.183,1.319 L97.324,81.092z M120.073,93.35v3.37h-9.783l-3.689-1.028l0.918-2.341l4.7-1.94h6.437v1.94H120.073z M124.582,98.05v3.259 l-2.463,1.58l-3.044,0.575c0,0,0-4.903,0-5.415H124.582z M121.822,96.72v-3.893l3.363,3.067L121.822,96.72z M123.355,104.568 v3.178l-2.347,2.347h-5.211l0.813-3.573l2.463-0.215l0.5-1.226L123.355,104.568z M110.39,98.05h5.408l-6.948,9.696l-2.852-1.534 l0.616-4.084L110.39,98.05z M132.529,103.464v3.166h-5.211l-1.417-2.062v-2.951h0.406L132.529,103.464z M127.748,99.096 l1.475-1.557l2.498,1.557l-1.999,1.656L127.748,99.096z M337.291,141.428l0.511-0.61c0.232,0.93,0.441,1.859,0.662,2.789 L337.291,141.428z" }),
					__WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement("path", { d: "M27.734,109.268v5.106c1.771-4.177,3.747-8.231,5.855-12.223L27.734,109.268z" })
				)
			)
		)
	);
}
//# sourceMappingURL=InternationalIcon.js.map

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = undefined;

var _react = __webpack_require__(5);

var _storeShape = __webpack_require__(161);

var _storeShape2 = _interopRequireDefault(_storeShape);

var _warning = __webpack_require__(162);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

var Provider = function (_Component) {
  _inherits(Provider, _Component);

  Provider.prototype.getChildContext = function getChildContext() {
    return { store: this.store };
  };

  function Provider(props, context) {
    _classCallCheck(this, Provider);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    _this.store = props.store;
    return _this;
  }

  Provider.prototype.render = function render() {
    return _react.Children.only(this.props.children);
  };

  return Provider;
}(_react.Component);

exports["default"] = Provider;


if (false) {
  Provider.prototype.componentWillReceiveProps = function (nextProps) {
    var store = this.store;
    var nextStore = nextProps.store;


    if (store !== nextStore) {
      warnAboutReceivingStore();
    }
  };
}

Provider.propTypes = {
  store: _storeShape2["default"].isRequired,
  children: _react.PropTypes.element.isRequired
};
Provider.childContextTypes = {
  store: _storeShape2["default"].isRequired
};

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports["default"] = connect;

var _react = __webpack_require__(5);

var _storeShape = __webpack_require__(161);

var _storeShape2 = _interopRequireDefault(_storeShape);

var _shallowEqual = __webpack_require__(419);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _wrapActionCreators = __webpack_require__(420);

var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);

var _warning = __webpack_require__(162);

var _warning2 = _interopRequireDefault(_warning);

var _isPlainObject = __webpack_require__(102);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _hoistNonReactStatics = __webpack_require__(370);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _invariant = __webpack_require__(149);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultMapStateToProps = function defaultMapStateToProps(state) {
  return {};
}; // eslint-disable-line no-unused-vars
var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
};
var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
  return _extends({}, parentProps, stateProps, dispatchProps);
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

var errorObject = { value: null };
function tryCatch(fn, ctx) {
  try {
    return fn.apply(ctx);
  } catch (e) {
    errorObject.value = e;
    return errorObject;
  }
}

// Helps track hot reloading.
var nextVersion = 0;

function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var shouldSubscribe = Boolean(mapStateToProps);
  var mapState = mapStateToProps || defaultMapStateToProps;

  var mapDispatch = void 0;
  if (typeof mapDispatchToProps === 'function') {
    mapDispatch = mapDispatchToProps;
  } else if (!mapDispatchToProps) {
    mapDispatch = defaultMapDispatchToProps;
  } else {
    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
  }

  var finalMergeProps = mergeProps || defaultMergeProps;
  var _options$pure = options.pure,
      pure = _options$pure === undefined ? true : _options$pure,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;

  // Helps track hot reloading.
  var version = nextVersion++;

  return function wrapWithConnect(WrappedComponent) {
    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';

    function checkStateShape(props, methodName) {
      if (!(0, _isPlainObject2["default"])(props)) {
        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
      }
    }

    function computeMergedProps(stateProps, dispatchProps, parentProps) {
      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
      if (false) {
        checkStateShape(mergedProps, 'mergeProps');
      }
      return mergedProps;
    }

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
      };

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.store = props.store || context.store;

        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));

        var storeState = _this.store.getState();
        _this.state = { storeState: storeState };
        _this.clearCache();
        return _this;
      }

      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
        if (!this.finalMapStateToProps) {
          return this.configureFinalMapState(store, props);
        }

        var state = store.getState();
        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);

        if (false) {
          checkStateShape(stateProps, 'mapStateToProps');
        }
        return stateProps;
      };

      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
        var mappedState = mapState(store.getState(), props);
        var isFactory = typeof mappedState === 'function';

        this.finalMapStateToProps = isFactory ? mappedState : mapState;
        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;

        if (isFactory) {
          return this.computeStateProps(store, props);
        }

        if (false) {
          checkStateShape(mappedState, 'mapStateToProps');
        }
        return mappedState;
      };

      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
        if (!this.finalMapDispatchToProps) {
          return this.configureFinalMapDispatch(store, props);
        }

        var dispatch = store.dispatch;

        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);

        if (false) {
          checkStateShape(dispatchProps, 'mapDispatchToProps');
        }
        return dispatchProps;
      };

      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
        var mappedDispatch = mapDispatch(store.dispatch, props);
        var isFactory = typeof mappedDispatch === 'function';

        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;

        if (isFactory) {
          return this.computeDispatchProps(store, props);
        }

        if (false) {
          checkStateShape(mappedDispatch, 'mapDispatchToProps');
        }
        return mappedDispatch;
      };

      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
        var nextStateProps = this.computeStateProps(this.store, this.props);
        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
          return false;
        }

        this.stateProps = nextStateProps;
        return true;
      };

      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
          return false;
        }

        this.dispatchProps = nextDispatchProps;
        return true;
      };

      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
          return false;
        }

        this.mergedProps = nextMergedProps;
        return true;
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return typeof this.unsubscribe === 'function';
      };

      Connect.prototype.trySubscribe = function trySubscribe() {
        if (shouldSubscribe && !this.unsubscribe) {
          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
          this.handleChange();
        }
      };

      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
        if (this.unsubscribe) {
          this.unsubscribe();
          this.unsubscribe = null;
        }
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        this.trySubscribe();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
          this.haveOwnPropsChanged = true;
        }
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        this.tryUnsubscribe();
        this.clearCache();
      };

      Connect.prototype.clearCache = function clearCache() {
        this.dispatchProps = null;
        this.stateProps = null;
        this.mergedProps = null;
        this.haveOwnPropsChanged = true;
        this.hasStoreStateChanged = true;
        this.haveStatePropsBeenPrecalculated = false;
        this.statePropsPrecalculationError = null;
        this.renderedElement = null;
        this.finalMapDispatchToProps = null;
        this.finalMapStateToProps = null;
      };

      Connect.prototype.handleChange = function handleChange() {
        if (!this.unsubscribe) {
          return;
        }

        var storeState = this.store.getState();
        var prevStoreState = this.state.storeState;
        if (pure && prevStoreState === storeState) {
          return;
        }

        if (pure && !this.doStatePropsDependOnOwnProps) {
          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
          if (!haveStatePropsChanged) {
            return;
          }
          if (haveStatePropsChanged === errorObject) {
            this.statePropsPrecalculationError = errorObject.value;
          }
          this.haveStatePropsBeenPrecalculated = true;
        }

        this.hasStoreStateChanged = true;
        this.setState({ storeState: storeState });
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');

        return this.refs.wrappedInstance;
      };

      Connect.prototype.render = function render() {
        var haveOwnPropsChanged = this.haveOwnPropsChanged,
            hasStoreStateChanged = this.hasStoreStateChanged,
            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
            statePropsPrecalculationError = this.statePropsPrecalculationError,
            renderedElement = this.renderedElement;


        this.haveOwnPropsChanged = false;
        this.hasStoreStateChanged = false;
        this.haveStatePropsBeenPrecalculated = false;
        this.statePropsPrecalculationError = null;

        if (statePropsPrecalculationError) {
          throw statePropsPrecalculationError;
        }

        var shouldUpdateStateProps = true;
        var shouldUpdateDispatchProps = true;
        if (pure && renderedElement) {
          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
        }

        var haveStatePropsChanged = false;
        var haveDispatchPropsChanged = false;
        if (haveStatePropsBeenPrecalculated) {
          haveStatePropsChanged = true;
        } else if (shouldUpdateStateProps) {
          haveStatePropsChanged = this.updateStatePropsIfNeeded();
        }
        if (shouldUpdateDispatchProps) {
          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
        }

        var haveMergedPropsChanged = true;
        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
        } else {
          haveMergedPropsChanged = false;
        }

        if (!haveMergedPropsChanged && renderedElement) {
          return renderedElement;
        }

        if (withRef) {
          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
            ref: 'wrappedInstance'
          }));
        } else {
          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
        }

        return this.renderedElement;
      };

      return Connect;
    }(_react.Component);

    Connect.displayName = connectDisplayName;
    Connect.WrappedComponent = WrappedComponent;
    Connect.contextTypes = {
      store: _storeShape2["default"]
    };
    Connect.propTypes = {
      store: _storeShape2["default"]
    };

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        if (this.version === version) {
          return;
        }

        // We are hot reloading!
        this.version = version;
        this.trySubscribe();
        this.clearCache();
      };
    }

    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
  };
}

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = shallowEqual;
function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var hasOwn = Object.prototype.hasOwnProperty;
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = wrapActionCreators;

var _redux = __webpack_require__(51);

function wrapActionCreators(actionCreators) {
  return function (dispatch) {
    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
  };
}

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(28);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(29);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(46);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(45);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(69);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(5);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _scrollIntoViewIfNeeded = __webpack_require__(432);

var _scrollIntoViewIfNeeded2 = _interopRequireDefault(_scrollIntoViewIfNeeded);

var _dom = __webpack_require__(422);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Possible enhancements:
//
//  * If the menu is close to a screen edge,
//    automatically reposition it so that it fits on the screen
//  * Maybe show menu immediately above the toggler
//    (like in Material design), not below it.
//
// https://material.google.com/components/menus.html

var Empty_value_option_value = '';

var value_prop_type = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]);

var Select = function (_PureComponent) {
	(0, _inherits3.default)(Select, _PureComponent);

	function Select(props) {
		(0, _classCallCheck3.default)(this, Select);

		// Shouldn't memory leak because
		// the set of options is assumed to be constant.
		var _this = (0, _possibleConstructorReturn3.default)(this, (Select.__proto__ || (0, _getPrototypeOf2.default)(Select)).call(this, props));

		_initialiseProps.call(_this);

		_this.options = {};

		var _this$props = _this.props,
		    value = _this$props.value,
		    autocomplete = _this$props.autocomplete,
		    options = _this$props.options,
		    children = _this$props.children,
		    menu = _this$props.menu,
		    toggler = _this$props.toggler,
		    onChange = _this$props.onChange;


		if (autocomplete) {
			if (!options) {
				throw new Error('"options" property is required for an "autocomplete" select');
			}

			_this.state.matching_options = _this.get_matching_options(options, value);
		}

		if (children && !menu) {
			_react2.default.Children.forEach(children, function (element) {
				if (!element.props.value) {
					throw new Error('You must specify "value" prop on each child of <Select/>');
				}

				if (!element.props.label) {
					throw new Error('You must specify "label" prop on each child of <Select/>');
				}
			});
		}

		if (menu && !toggler) {
			throw new Error('Supply a "toggler" component when enabling "menu" in <Select/>');
		}

		if (!menu && !onChange) {
			throw new Error('"onChange" property must be specified for a non-menu <Select/>');
		}
		return _this;
	}

	// Client side rendering, javascript is enabled


	(0, _createClass3.default)(Select, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _props = this.props,
			    fallback = _props.fallback,
			    nativeExpanded = _props.nativeExpanded;


			document.addEventListener('click', this.document_clicked);

			if (fallback) {
				this.setState({ javascript: true });
			}

			if (nativeExpanded) {
				this.resize_native_expanded_select();
				window.addEventListener('resize', this.resize_native_expanded_select);
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(previous_props, previous_state) {
			var _props2 = this.props,
			    nativeExpanded = _props2.nativeExpanded,
			    value = _props2.value;
			var _state = this.state,
			    expanded = _state.expanded,
			    height = _state.height;


			if (expanded !== previous_state.expanded) {
				if (expanded && this.should_animate()) {
					if (height === undefined) {
						this.calculate_height();
					}
				}
			}

			// If the `value` changed then resize the native expanded `<select/>`
			if (nativeExpanded && value !== previous_props.value) {
				this.resize_native_expanded_select();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			var nativeExpanded = this.props.nativeExpanded;


			document.removeEventListener('click', this.document_clicked);

			if (nativeExpanded) {
				window.removeEventListener('resize', this.resize_native_expanded_select);
			}

			if (this.toggle_timeout) {
				clearTimeout(this.toggle_timeout);
				this.toggle_timeout = undefined;
			}

			if (this.scroll_into_view_timeout) {
				clearTimeout(this.scroll_into_view_timeout);
				this.scroll_into_view_timeout = undefined;
			}

			if (this.restore_focus_on_collapse_timeout) {
				clearTimeout(this.restore_focus_on_collapse_timeout);
				this.restore_focus_on_collapse_timeout = undefined;
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props3 = this.props,
			    id = _props3.id,
			    upward = _props3.upward,
			    concise = _props3.concise,
			    compact = _props3.compact,
			    scroll = _props3.scroll,
			    children = _props3.children,
			    menu = _props3.menu,
			    toggler = _props3.toggler,
			    alignment = _props3.alignment,
			    autocomplete = _props3.autocomplete,
			    saveOnIcons = _props3.saveOnIcons,
			    fallback = _props3.fallback,
			    native = _props3.native,
			    nativeExpanded = _props3.nativeExpanded,
			    disabled = _props3.disabled,
			    required = _props3.required,
			    placeholder = _props3.placeholder,
			    label = _props3.label,
			    value = _props3.value,
			    error = _props3.error,
			    closeButton = _props3.closeButton,
			    closeAriaLabel = _props3.closeAriaLabel,
			    style = _props3.style,
			    className = _props3.className;
			var _state2 = this.state,
			    expanded = _state2.expanded,
			    list_height = _state2.list_height;


			var options = this.get_options();

			var list_style = void 0;

			// Makes the options list scrollable (only when not in `autocomplete` mode).
			if (this.is_scrollable() && this.state.list_height !== undefined) {
				list_style = { maxHeight: list_height + 'px' };
			}

			var overflow = scroll && options && this.overflown();

			var list_items = void 0;

			// If a list of options is supplied as an array of `{ value, label }`,
			// then transform those elements to <buttons/>
			if (options) {
				list_items = options.map(function (_ref, index) {
					var value = _ref.value,
					    label = _ref.label,
					    icon = _ref.icon;

					return _this2.render_list_item({ index: index, value: value, label: label, icon: !saveOnIcons && icon, overflow: overflow });
				});
			}
			// Else, if a list of options is supplied as a set of child React elements,
			// then render those elements.
			else {
					list_items = _react2.default.Children.map(children, function (element, index) {
						if (!element) {
							return;
						}

						return _this2.render_list_item({ index: index, element: element });
					});
				}

			var wrapper_style = { textAlign: alignment };

			var selected = this.get_selected_option();

			var show_options_list = !native && !nativeExpanded && list_items.length > 0;
			var show_label = label && (this.get_selected_option() || placeholder);

			var markup = _react2.default.createElement(
				'div',
				{
					ref: function ref(_ref3) {
						return _this2.select = _ref3;
					},
					onKeyDown: this.on_key_down_in_container,
					onBlur: this.on_blur,
					style: style ? (0, _extends3.default)({}, wrapper_style, style) : wrapper_style,
					className: (0, _classnames2.default)('rrui__select', {
						'rrui__rich': fallback,
						'rrui__select--menu': menu,
						'rrui__select--upward': upward,
						'rrui__select--expanded': expanded,
						'rrui__select--collapsed': !expanded,
						'rrui__select--disabled': disabled,
						'rrui__select--compact': compact || concise && !autocomplete
					}, className) },
				_react2.default.createElement(
					'div',
					{
						className: (0, _classnames2.default)({
							'rrui__input': !toggler
						}) },
					!menu && !native && this.render_selected_item(show_label),
					show_label && _react2.default.createElement(
						'label',
						{
							htmlFor: id,
							className: (0, _classnames2.default)('rrui__input-label', {
								'rrui__input-label--required': required && value_is_empty(value),
								'rrui__input-label--invalid': this.should_indicate_invalid()
							}) },
						label
					),
					menu && this.render_toggler(),
					show_options_list && _react2.default.createElement(
						'ul',
						{
							ref: function ref(_ref2) {
								return _this2.list = _ref2;
							},
							style: list_style,
							className: (0, _classnames2.default)('rrui__expandable', 'rrui__expandable--overlay', 'rrui__select__options', 'rrui__shadow', {
								'rrui__select__options--autocomplete': autocomplete,
								'rrui__select__options--menu': menu,
								'rrui__expandable--expanded': expanded,
								'rrui__select__options--expanded': expanded,
								'rrui__expandable--left-aligned': alignment === 'left',
								'rrui__expandable--right-aligned': alignment === 'right',
								'rrui__select__options--left-aligned': !children && alignment === 'left',
								'rrui__select__options--right-aligned': !children && alignment === 'right',
								// CSS selector performance optimization
								'rrui__select__options--upward': upward,
								'rrui__select__options--downward': !upward
							}) },
						list_items
					),
					show_options_list && expanded && closeButton && _react2.default.createElement(
						'button',
						{
							type: 'button',
							onClick: this.toggle,
							'aria-label': closeAriaLabel,
							className: (0, _classnames2.default)('rrui__select__close', {
								'rrui__select__close--autocomplete': autocomplete
							}) },
						closeButton
					),
					(native || fallback && !this.state.javascript) && this.render_static()
				),
				this.should_indicate_invalid() && _react2.default.createElement(
					'div',
					{ className: 'rrui__input-error' },
					error
				)
			);

			return markup;
		}
	}, {
		key: 'render_list_item',
		value: function render_list_item(_ref4) // , first, last
		{
			var _this3 = this;

			var index = _ref4.index,
			    element = _ref4.element,
			    value = _ref4.value,
			    label = _ref4.label,
			    icon = _ref4.icon,
			    overflow = _ref4.overflow;
			var _props4 = this.props,
			    disabled = _props4.disabled,
			    menu = _props4.menu,
			    scrollbarPadding = _props4.scrollbarPadding;
			var _state3 = this.state,
			    focused_option_value = _state3.focused_option_value,
			    expanded = _state3.expanded;

			// If a list of options is supplied as a set of child React elements,
			// then extract values from their props.

			if (element) {
				value = element.props.value;
			}

			var is_focused = !menu && value === focused_option_value;

			var item_style = void 0;

			// on overflow the vertical scrollbar will take up space
			// reducing padding-right and the only way to fix that
			// is to add additional padding-right
			//
			// a hack to restore padding-right taken up by a vertical scrollbar
			if (overflow && scrollbarPadding) {
				item_style = { marginRight: (0, _dom.get_scrollbar_width)() + 'px' };
			}

			var button = void 0;

			// If a list of options is supplied as a set of child React elements,
			// then enhance those elements with extra props.
			if (element) {
				var extra_props = {
					style: item_style ? (0, _extends3.default)({}, item_style, element.props.style) : element.props.style,
					className: (0, _classnames2.default)('rrui__select__option', {
						'rrui__select__option--focused': is_focused
					}, element.props.className)
				};

				var onClick = element.props.onClick;

				extra_props.onClick = function (event) {
					if (menu) {
						_this3.toggle();
					} else {
						_this3.item_clicked(value, event);
					}

					if (onClick) {
						onClick(event);
					}
				};

				button = _react2.default.cloneElement(element, extra_props);
			}
			// Else, if a list of options is supplied as an array of `{ value, label }`,
			// then transform those options to <buttons/>
			else {
					button = _react2.default.createElement(
						'button',
						{
							type: 'button',
							onClick: function onClick(event) {
								return _this3.item_clicked(value, event);
							},
							disabled: disabled,
							tabIndex: '-1',
							'aria-label': label,
							className: (0, _classnames2.default)('rrui__select__option', {
								'rrui__select__option--focused': is_focused,
								// CSS selector performance optimization
								'rrui__select__option--disabled': disabled
							}),
							style: item_style },
						icon && _react2.default.cloneElement(icon, { className: (0, _classnames2.default)(icon.props.className, 'rrui__select__option-icon') }),
						label
					);
				}

			var markup = _react2.default.createElement(
				'li',
				{
					key: get_option_key(value),
					ref: function ref(_ref5) {
						return _this3.options[get_option_key(value)] = _ref5;
					},
					className: (0, _classnames2.default)('rrui__expandable__content', 'rrui__select__options-list-item', {
						'rrui__select__separator-option': element && element.type === Select.Separator,
						'rrui__expandable__content--expanded': expanded,
						// CSS selector performance optimization
						'rrui__select__options-list-item--expanded': expanded
					}) },
				button
			);

			return markup;
		}

		// Renders the selected option
		// and possibly a transparent native `<select/>` above it
		// so that the native `<select/>` expands upon click
		// on the selected option
		// (in case of `nativeExpanded` setting).

	}, {
		key: 'render_selected_item',
		value: function render_selected_item(label_is_shown) {
			var _props5 = this.props,
			    nativeExpanded = _props5.nativeExpanded,
			    toggler = _props5.toggler;


			if (toggler) {
				return this.render_toggler();
			}

			var selected = this.render_selected_item_only(label_is_shown);

			if (nativeExpanded) {
				return _react2.default.createElement(
					'div',
					{ style: native_expanded_select_container_style },
					this.render_static(),
					selected
				);
			}

			return selected;
		}
	}, {
		key: 'render_selected_item_only',
		value: function render_selected_item_only(label_is_shown) {
			var _this4 = this;

			var _props6 = this.props,
			    children = _props6.children,
			    value = _props6.value,
			    placeholder = _props6.placeholder,
			    label = _props6.label,
			    disabled = _props6.disabled,
			    required = _props6.required,
			    autocomplete = _props6.autocomplete,
			    concise = _props6.concise,
			    nativeExpanded = _props6.nativeExpanded,
			    tabIndex = _props6.tabIndex,
			    onFocus = _props6.onFocus,
			    title = _props6.title,
			    ariaLabel = _props6.ariaLabel,
			    inputClassName = _props6.inputClassName;
			var _state4 = this.state,
			    expanded = _state4.expanded,
			    autocomplete_width = _state4.autocomplete_width,
			    autocomplete_input_value = _state4.autocomplete_input_value;


			var selected = this.get_selected_option();
			var selected_label = this.get_selected_option_label();

			var selected_text = selected ? selected_label : placeholder || label;

			var selected_style_classes = {
				'rrui__input-element': true
			};

			if (autocomplete && expanded) {
				// style = { ...style, width: autocomplete_width + 'px' }

				return _react2.default.createElement('input', {
					type: 'text',
					ref: function ref(_ref6) {
						return _this4.autocomplete = _ref6;
					},
					placeholder: selected_text,
					value: autocomplete_input_value,
					onChange: this.on_autocomplete_input_change,
					onKeyDown: this.on_key_down,
					onFocus: onFocus,
					tabIndex: tabIndex,
					title: title,
					className: (0, _classnames2.default)(selected_style_classes, 'rrui__input-field', 'rrui__select__autocomplete', inputClassName,
					// CSS selector performance optimization
					// (should it even be optimized).
					'rrui__input-field--disabled') });
			}

			var show_selected_as_an_icon = concise && selected && selected.icon;

			return _react2.default.createElement(
				'button',
				{
					ref: function ref(_ref7) {
						return _this4.selected = _ref7;
					},
					type: 'button',
					disabled: disabled,
					onClick: this.toggle,
					onKeyDown: this.on_key_down,
					onFocus: onFocus,
					tabIndex: nativeExpanded ? -1 : tabIndex,
					title: title,
					'aria-label': ariaLabel,
					className: (0, _classnames2.default)(selected_style_classes, 'rrui__select__button', {
						'rrui__select__button--empty': !selected_label,
						'rrui__select__button--invalid': this.should_indicate_invalid(),
						'rrui__input-element--invalid': this.should_indicate_invalid(),
						// CSS selector performance optimization
						// (should it even be optimized).
						'rrui__select__button--disabled': disabled
					}) },
				_react2.default.createElement(
					'div',
					{ className: 'rrui__select__selected-content' },
					_react2.default.createElement(
						'div',
						{
							className: (0, _classnames2.default)('rrui__select__selected-label', {
								'rrui__select__selected-label--required': !label_is_shown && required && value_is_empty(value)
							}) },
						show_selected_as_an_icon ? _react2.default.cloneElement(selected.icon, { title: selected_label }) : selected_text
					),
					_react2.default.createElement('div', {
						className: (0, _classnames2.default)('rrui__select__arrow', {
							// CSS selector performance optimization
							'rrui__select__arrow--expanded': expanded,
							'rrui__select__arrow--disabled': disabled
						}) })
				)
			);
		}
	}, {
		key: 'render_toggler',
		value: function render_toggler() {
			var _this5 = this;

			var toggler = this.props.toggler;


			return _react2.default.createElement(
				'div',
				{ className: 'rrui__select__toggler' },
				_react2.default.cloneElement(toggler, {
					ref: function ref(_ref8) {
						return _this5.selected = _ref8;
					},
					onClick: this.toggle,
					onKeyDown: this.on_key_down
				})
			);
		}

		// supports disabled javascript

	}, {
		key: 'render_static',
		value: function render_static() {
			var _this6 = this;

			var _props7 = this.props,
			    id = _props7.id,
			    name = _props7.name,
			    value = _props7.value,
			    label = _props7.label,
			    disabled = _props7.disabled,
			    options = _props7.options,
			    menu = _props7.menu,
			    toggler = _props7.toggler,
			    fallback = _props7.fallback,
			    native = _props7.native,
			    nativeExpanded = _props7.nativeExpanded,
			    tabIndex = _props7.tabIndex,
			    children = _props7.children;


			if (menu) {
				var _markup = _react2.default.createElement(
					'div',
					{
						className: (0, _classnames2.default)({
							'rrui__rich__fallback': fallback
						}) },
					toggler
				);

				return _markup;
			}

			var markup = _react2.default.createElement(
				'select',
				{
					ref: function ref(_ref9) {
						return _this6.native = _ref9;
					},
					id: id,
					name: name,
					value: value_is_empty(value) ? Empty_value_option_value : value,
					disabled: disabled,
					onChange: this.native_select_on_change,
					tabIndex: native || nativeExpanded ? tabIndex : undefined,
					className: (0, _classnames2.default)('rrui__input', 'rrui__select__native', {
						'rrui__select__native-expanded': nativeExpanded,
						'rrui__rich__fallback': fallback
					}) },
				options ? this.render_native_select_options(options, value_is_empty(value)) : _react2.default.Children.map(children, function (child) {
					if (!child) {
						return;
					}

					var markup = _react2.default.createElement(
						'option',
						{
							className: 'rrui__select__native-option',
							key: child.props.value,
							value: child.props.value },
						child.props.label
					);

					return markup;
				})
			);

			return markup;
		}
	}, {
		key: 'render_native_select_options',
		value: function render_native_select_options(options, empty_option_is_selected) {
			var placeholder = this.props.placeholder;


			var empty_option_present = false;

			var rendered_options = options.map(function (option) {
				var value = option.value,
				    label = option.label;


				if (value_is_empty(value)) {
					empty_option_present = true;
					value = Empty_value_option_value;
				}

				var markup = _react2.default.createElement(
					'option',
					{
						className: 'rrui__select__native-option',
						key: get_option_key(value),
						value: value },
					label
				);

				return markup;
			});

			if (empty_option_is_selected && !empty_option_present) {
				rendered_options.unshift(_react2.default.createElement(
					'option',
					{
						className: 'rrui__select__native-option',
						key: get_option_key(undefined),
						value: '' },
					placeholder
				));
			}

			return rendered_options;
		}

		// Whether should indicate that the input value is invalid

	}, {
		key: 'should_indicate_invalid',
		value: function should_indicate_invalid() {
			var _props8 = this.props,
			    indicateInvalid = _props8.indicateInvalid,
			    error = _props8.error;


			return indicateInvalid && error;
		}
	}, {
		key: 'get_selected_option',
		value: function get_selected_option() {
			var value = this.props.value;


			return this.get_option(value);
		}
	}, {
		key: 'get_option',
		value: function get_option(value) {
			var _props9 = this.props,
			    options = _props9.options,
			    children = _props9.children;


			if (options) {
				return options.filter(function (x) {
					return x.value === value;
				})[0];
			}

			var option = void 0;

			_react2.default.Children.forEach(children, function (child) {
				if (child.props.value === value) {
					option = child;
				}
			});

			return option;
		}
	}, {
		key: 'get_option_index',
		value: function get_option_index(option) {
			var _props10 = this.props,
			    options = _props10.options,
			    children = _props10.children;


			if (options) {
				return options.indexOf(option);
			}

			var option_index = void 0;

			_react2.default.Children.forEach(children, function (child, index) {
				if (child.props.value === option.value) {
					option_index = index;
				}
			});

			return option_index;
		}
	}, {
		key: 'get_selected_option_label',
		value: function get_selected_option_label() {
			var options = this.props.options;


			var selected = this.get_selected_option();

			if (!selected) {
				return;
			}

			if (options) {
				return selected.label;
			}

			return selected.props.label;
		}
	}, {
		key: 'overflown',
		value: function overflown() {
			var _props11 = this.props,
			    options = _props11.options,
			    maxItems = _props11.maxItems;


			return options.length > maxItems;
		}
	}, {
		key: 'scrollable_list_height',
		value: function scrollable_list_height() {
			var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state;
			var maxItems = this.props.maxItems;

			// (Adding vertical padding so that it shows these `maxItems` options fully)

			return (state.height - 2 * state.vertical_padding) * (maxItems / this.get_options().length) + state.vertical_padding;
		}
	}, {
		key: 'should_animate',
		value: function should_animate() {
			return true;

			// return this.props.options.length >= this.props.transition_item_count_min
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (this.autocomplete) {
				this.autocomplete.focus();
			} else {
				this.selected.focus();
			}
		}

		// Would have used `onBlur={...}` event handler here
		// with `if (container.contains(event.relatedTarget))` condition,
		// but it doesn't work in IE in React.
		// https://github.com/facebook/react/issues/3751
		//
		// Therefore, using the hacky `document.onClick` handlers
		// and this `onKeyDown` Tab handler
		// until `event.relatedTarget` support is consistent in React.
		//


		// This handler is a workaround for `redux-form`

	}, {
		key: 'get_options',
		value: function get_options() {
			var _props12 = this.props,
			    autocomplete = _props12.autocomplete,
			    autocompleteShowAll = _props12.autocompleteShowAll,
			    maxItems = _props12.maxItems,
			    options = _props12.options;
			var matching_options = this.state.matching_options;


			if (!autocomplete) {
				return options;
			}

			if (autocompleteShowAll) {
				return matching_options;
			}

			return matching_options.slice(0, maxItems);
		}

		// Get the previous option (relative to the currently focused option)

	}, {
		key: 'previous_focusable_option',
		value: function previous_focusable_option() {
			var options = this.get_options();
			var focused_option_value = this.state.focused_option_value;


			var i = 0;
			while (i < options.length) {
				if (options[i].value === focused_option_value) {
					if (i - 1 >= 0) {
						return options[i - 1];
					}
				}
				i++;
			}
		}

		// Get the next option (relative to the currently focused option)

	}, {
		key: 'next_focusable_option',
		value: function next_focusable_option() {
			var options = this.get_options();
			var focused_option_value = this.state.focused_option_value;


			var i = 0;
			while (i < options.length) {
				if (options[i].value === focused_option_value) {
					if (i + 1 < options.length) {
						return options[i + 1];
					}
				}
				i++;
			}
		}

		// Scrolls to an option having the value

	}, {
		key: 'scroll_to',
		value: function scroll_to(value) {
			var vertical_padding = this.state.vertical_padding;


			var option_element = _reactDom2.default.findDOMNode(this.options[get_option_key(value)]);
			var list = _reactDom2.default.findDOMNode(this.list);

			// If this option isn't even shown
			// (e.g. autocomplete)
			// then don't scroll to it because there's nothing to scroll to.
			if (!option_element) {
				return;
			}

			var offset_top = option_element.offsetTop;

			var is_first_option = list.firstChild === option_element;

			// If it's the first one - then scroll to list top
			if (is_first_option) {
				offset_top -= vertical_padding;
			}

			list.scrollTop = offset_top;
		}

		// Fully shows an option having the `value` (scrolls to it if neccessary)

	}, {
		key: 'show_option',
		value: function show_option(value, gravity) {
			var vertical_padding = this.state.vertical_padding;


			var option_element = _reactDom2.default.findDOMNode(this.options[get_option_key(value)]);
			var list = _reactDom2.default.findDOMNode(this.list);

			var is_first_option = list.firstChild === option_element;
			var is_last_option = list.lastChild === option_element;

			switch (gravity) {
				case 'top':
					var top_line = option_element.offsetTop;

					if (is_first_option) {
						top_line -= vertical_padding;
					}

					if (top_line < list.scrollTop) {
						list.scrollTop = top_line;
					}

					return;

				case 'bottom':
					var bottom_line = option_element.offsetTop + option_element.offsetHeight;

					if (is_last_option) {
						bottom_line += vertical_padding;
					}

					if (bottom_line > list.scrollTop + list.offsetHeight) {
						list.scrollTop = bottom_line - list.offsetHeight;
					}

					return;
			}
		}

		// Calculates height of the expanded item list

	}, {
		key: 'calculate_height',
		value: function calculate_height() {
			var options = this.props.options;


			var list_dom_node = _reactDom2.default.findDOMNode(this.list);
			var border = parseInt(window.getComputedStyle(list_dom_node).borderTopWidth);
			var height = list_dom_node.scrollHeight;

			var vertical_padding = parseInt(window.getComputedStyle(list_dom_node).paddingTop);

			// For things like "accordeon".
			//
			// const images = list_dom_node.querySelectorAll('img')
			//
			// if (images.length > 0)
			// {
			// 	return this.preload_images(list_dom_node, images)
			// }

			var state = { height: height, vertical_padding: vertical_padding, border: border };

			if (this.is_scrollable() && options && this.overflown()) {
				state.list_height = this.scrollable_list_height(state);
			}

			this.setState(state);
		}
	}, {
		key: 'is_scrollable',
		value: function is_scrollable() {
			var _props13 = this.props,
			    menu = _props13.menu,
			    autocomplete = _props13.autocomplete,
			    autocompleteShowAll = _props13.autocompleteShowAll,
			    scroll = _props13.scroll;


			return !menu && (autocomplete && autocompleteShowAll || !autocomplete) && scroll;
		}

		// This turned out not to work for `autocomplete`
		// because not all options are ever shown.
		// get_widest_label_width()
		// {
		// 	// <ul/> -> <li/> -> <button/>
		// 	const label = ReactDOM.findDOMNode(this.list).firstChild.firstChild
		//
		// 	const style = getComputedStyle(label)
		//
		// 	const width = parseFloat(style.width)
		// 	const side_padding = parseFloat(style.paddingLeft)
		//
		// 	return width - 2 * side_padding
		// }

	}, {
		key: 'get_matching_options',


		// // https://github.com/daviferreira/react-sanfona/blob/master/src/AccordionItem/index.jsx#L54
		// // Wait for images to load before calculating maxHeight
		// preload_images(node, images)
		// {
		// 	let images_loaded = 0
		//
		// 	const image_loaded = () =>
		// 	{
		// 		images_loaded++
		//
		// 		if (images_loaded === images.length)
		// 		{
		// 			this.setState
		// 			({
		// 				height: this.props.expanded ? node.scrollHeight : 0
		// 			})
		// 		}
		// 	}
		//
		// 	for (let i = 0; i < images.length; i += 1)
		// 	{
		// 		const image = new Image()
		// 		image.src = images[i].src
		// 		image.onload = image.onerror = image_loaded
		// 	}
		// }
		value: function get_matching_options(options, value) {
			// If the autocomplete value is `undefined` or empty
			if (!value) {
				return options;
			}

			value = value.toLowerCase();

			return options.filter(function (_ref10) {
				var label = _ref10.label,
				    verbose = _ref10.verbose;

				return (verbose || label).toLowerCase().indexOf(value) >= 0;
			});
		}
	}]);
	return Select;
}(_react.PureComponent);

Select.propTypes = {
	// A list of selectable options
	options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
		// Option value (may be `undefined`)
		value: value_prop_type,
		// Option label (may be `undefined`)
		label: _propTypes2.default.string,
		// Option icon
		icon: _propTypes2.default.node
	})),

	// HTML form input `name` attribute
	name: _propTypes2.default.string,

	// Label which is placed above the select
	label: _propTypes2.default.string,

	// Placeholder (like "Choose")
	placeholder: _propTypes2.default.string,

	// Whether to use native `<select/>`
	native: _propTypes2.default.bool.isRequired,

	// Whether to use native `<select/>` when expanded
	nativeExpanded: _propTypes2.default.bool.isRequired,

	// Show icon only for selected item,
	// and only if `concise` is `true`.
	saveOnIcons: _propTypes2.default.bool,

	// Disables this control
	disabled: _propTypes2.default.bool,

	// Set to `true` to mark the field as required
	required: _propTypes2.default.bool.isRequired,

	// Selected option value
	value: value_prop_type,

	// Is called when an option is selected
	onChange: _propTypes2.default.func,

	// Is called when the select is focused
	onFocus: _propTypes2.default.func,

	// Is called when the select is blurred.
	// This `onBlur` interceptor is a workaround for `redux-form`,
	// so that it gets the parsed `value` in its `onBlur` handler,
	// not the formatted text.
	onBlur: _propTypes2.default.func,

	// (exotic use case)
	// Falls back to a plain HTML input
	// when javascript is disabled (e.g. Tor)
	fallback: _propTypes2.default.bool.isRequired,

	// Component CSS class
	className: _propTypes2.default.string,

	// Autocomplete `<input/>` CSS class
	inputClassName: _propTypes2.default.string,

	// CSS style object
	style: _propTypes2.default.object,

	// If this flag is set to `true`,
	// and `icon` is specified for a selected option,
	// then the selected option will be displayed
	// as icon only, without the label.
	concise: _propTypes2.default.bool,

	// If this flag is set to `true`,
	// then it makes `<Select/>` not stretch itself
	// to 100% width by making it `inline-block`.
	// Is set to `true` when `concise` is `true`
	// because it makes sense.
	compact: _propTypes2.default.bool,

	// HTML `tabindex` attribute
	tabIndex: _propTypes2.default.number,

	// If set to `true`, autocompletion is available
	// upon expanding the options list.
	autocomplete: _propTypes2.default.bool,

	// If set to `true`, autocomple will show all
	// matching options instead of just `maxItems`.
	autocompleteShowAll: _propTypes2.default.bool,

	// Options list alignment ("left", "right")
	alignment: _propTypes2.default.oneOf(['left', 'right']),

	// If `menu` flag is set to `true`
	// then it's gonna be a dropdown menu
	// with `children` elements inside
	// and therefore `onChange` won't be called
	// on menu item click.
	menu: _propTypes2.default.bool,

	// If `menu` flag is set to `true`
	// then `toggler` is the dropdown menu button.
	toggler: _propTypes2.default.element,

	// If `scroll` is `false`, then options list
	// is not limited in height.
	// Is `true` by default (scrollable).
	scroll: _propTypes2.default.bool.isRequired,

	// If this flag is set to `true`,
	// then the dropdown expands itself upward.
	// (as opposed to the default downward)
	upward: _propTypes2.default.bool,

	// Maximum items fitting the options list height (scrollable).
	// In case of `autocomplete` that's the maximum number of matched items shown.
	// Is `6` by default.
	maxItems: _propTypes2.default.number.isRequired,

	// Is `true` by default (only when the list of options is scrollable)
	scrollbarPadding: _propTypes2.default.bool,

	focusUponSelection: _propTypes2.default.bool.isRequired,

	// When the `<Select/>` is expanded
	// the options list may not fit on the screen.
	// If `scrollIntoView` is `true` (which is the default)
	// then the browser will automatically scroll
	// so that the expanded options list fits on the screen.
	scrollIntoView: _propTypes2.default.bool.isRequired,

	// If `scrollIntoView` is `true` (which is the default)
	// then this is gonna be the delay after which it scrolls into view.
	expandAnimationDuration: _propTypes2.default.number.isRequired,

	onTabOut: _propTypes2.default.func,

	onToggle: _propTypes2.default.func,

	// `aria-label` for the `<Select/>`'s `<button/>`
	ariaLabel: _propTypes2.default.string.isRequired,

	// `aria-label` for the "Close" button
	// (which is an "x" visible in fullscreen mode).
	closeAriaLabel: _propTypes2.default.string.isRequired,

	// The "x" button that closes the `<Select/>`
	// in fullscreen mode on mobile devices.
	closeButton: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.oneOf([false])]).isRequired

	// transition_item_count_min : PropTypes.number,
	// transition_duration_min : PropTypes.number,
	// transition_duration_max : PropTypes.number
};
Select.defaultProps = {
	alignment: 'left',
	scroll: true,
	maxItems: 6,
	scrollbarPadding: true,
	focusUponSelection: true,
	fallback: false,
	native: false,
	nativeExpanded: false,
	scrollIntoView: true,
	expandAnimationDuration: 150,

	// Set to `true` to mark the field as required
	required: false,

	// `aria-label` for the `<Select/>`'s `<button/>`
	ariaLabel: 'Select country',

	// `aria-label` for the "Close" button
	// (which is an "x" visible in fullscreen mode).
	closeAriaLabel: 'Close',

	// The "x" button that closes the `<Select/>`
	// in fullscreen mode on mobile devices.
	closeButton: _react2.default.createElement(
		'svg',
		{ viewBox: '0 0 22 21', className: 'rrui__select__close-icon' },
		_react2.default.createElement(
			'g',
			{ stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', strokeLinecap: 'round' },
			_react2.default.createElement(
				'g',
				{ className: 'rrui__select__close-icon-path', transform: 'translate(-1367.000000, -40.000000)', strokeWidth: '1' },
				_react2.default.createElement(
					'g',
					{ transform: 'translate(1368.000000, 41.000000)' },
					_react2.default.createElement('path', { d: 'M0.807611845,0.307611845 L19.1923882,18.6923882' }),
					_react2.default.createElement('path', { d: 'M0.807611845,0.307611845 L19.1923882,18.6923882', transform: 'translate(10.000000, 9.500000) scale(-1, 1) translate(-10.000000, -9.500000) ' })
				)
			)
		)
	)

	// transition_item_count_min : 1,
	// transition_duration_min : 60, // milliseconds
	// transition_duration_max : 100 // milliseconds
};

var _initialiseProps = function _initialiseProps() {
	var _this7 = this;

	this.state = {
		// Is initialized during the first `componentDidUpdate()` call
		vertical_padding: 0
	};

	this.native_select_on_change = function (event) {
		var _props14 = _this7.props,
		    onChange = _props14.onChange,
		    previous_value = _props14.value;


		var value = event.target.value;

		// Convert back from an empty string to `undefined`
		if (value === Empty_value_option_value) {
			// `null` is not accounted for, use `undefined` instead.
			value = undefined;
		}

		// Call `onChange` only if `value` did actually change
		if (value !== previous_value) {
			onChange(value);
		}
	};

	this.resize_native_expanded_select = function () {
		// For some strange reason 1px on the right side of the `<select/>`
		// still falls through to the underlying selected option label.
		_reactDom2.default.findDOMNode(_this7.native).style.width = _reactDom2.default.findDOMNode(_this7.selected).offsetWidth + 1 + 'px';
	};

	this.toggle = function (event) {
		var toggle_options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		if (event) {
			// Don't navigate away when clicking links
			event.preventDefault();

			// Not discarding the click event because
			// other expanded selects may be listening to it.
			// // Discard the click event so that it won't reach `document` click listener
			// event.stopPropagation() // doesn't work
			// event.nativeEvent.stopImmediatePropagation()
		}

		var _props15 = _this7.props,
		    toggler = _props15.toggler,
		    disabled = _props15.disabled,
		    autocomplete = _props15.autocomplete,
		    options = _props15.options,
		    value = _props15.value,
		    focusUponSelection = _props15.focusUponSelection,
		    onToggle = _props15.onToggle,
		    nativeExpanded = _props15.nativeExpanded,
		    scrollIntoView = _props15.scrollIntoView,
		    expandAnimationDuration = _props15.expandAnimationDuration;


		if (nativeExpanded) {
			return;
		}

		if (disabled) {
			return;
		}

		if (_this7.toggle_timeout) {
			clearTimeout(_this7.toggle_timeout);
			_this7.toggle_timeout = undefined;
		}

		if (_this7.scroll_into_view_timeout) {
			clearTimeout(_this7.scroll_into_view_timeout);
			_this7.scroll_into_view_timeout = undefined;
		}

		var expanded = _this7.state.expanded;


		if (!expanded && autocomplete) {
			_this7.setState({
				// The input value can't be `undefined`
				// because in that case React would complain
				// about it being an "uncontrolled input"
				autocomplete_input_value: '',
				matching_options: options
			});

			// if (!this.state.autocomplete_width)
			// {
			// 	this.setState({ autocomplete_width: this.get_widest_label_width() })
			// }
		}

		// Deferring expanding the select upon click
		// because `document.onClick(event)` should fire first,
		// otherwise `event.target` in that handler will be detached
		// from the document and so `this.document_clicked()` handler will
		// immediately toggle the select back to collapsed state.
		_this7.toggle_timeout = setTimeout(function () {
			_this7.toggle_timeout = undefined;

			_this7.setState({
				expanded: !expanded
			}, function () {
				var is_now_expanded = _this7.state.expanded;

				if (!toggle_options.dont_focus_after_toggle) {
					// If it's autocomplete, then focus <input/> field
					// upon toggling the select component.
					if (autocomplete) {
						if (is_now_expanded) {
							// Focus the input after the select is expanded
							_this7.autocomplete.focus();
						} else if (focusUponSelection) {
							// Focus the toggler after the select is collapsed
							_this7.selected.focus();
						}
					} else {
						// For some reason Firefox loses focus
						// upon select expansion via a click,
						// so this extra `.focus()` works around that issue.
						_this7.selected.focus();
					}
				}

				_this7.scroll_into_view_timeout = setTimeout(function () {
					_this7.scroll_into_view_timeout = undefined;

					var is_still_expanded = _this7.state.expanded;

					if (is_still_expanded && _this7.list && scrollIntoView) {
						var element = _reactDom2.default.findDOMNode(_this7.list);

						// https://developer.mozilla.org/ru/docs/Web/API/Element/scrollIntoViewIfNeeded
						if (element.scrollIntoViewIfNeeded) {
							element.scrollIntoViewIfNeeded(false);
						} else {
							// https://github.com/stipsan/scroll-into-view-if-needed
							(0, _scrollIntoViewIfNeeded2.default)(element, false, { duration: 800 });
						}
					}
				}, expandAnimationDuration * 1.1);
			});

			if (!expanded && options) {
				// Focus either the selected option
				// or the first option in the list.

				var focused_option_value = value || options[0].value;

				_this7.setState({ focused_option_value: focused_option_value });

				// Scroll down to the focused option
				_this7.scroll_to(focused_option_value);
			}

			if (onToggle) {
				onToggle(!expanded);
			}

			if (toggle_options.callback) {
				toggle_options.callback();
			}
		}, 0);
	};

	this.item_clicked = function (value, event) {
		if (event) {
			event.preventDefault();
		}

		var _props16 = _this7.props,
		    onChange = _props16.onChange,
		    previous_value = _props16.value;


		_this7.toggle(undefined, {
			callback: function callback() {
				// Call `onChange` only if `value` did actually change
				if (value !== previous_value) {
					onChange(value);
				}
			}
		});
	};

	this.document_clicked = function (event) {
		var autocomplete = _reactDom2.default.findDOMNode(_this7.autocomplete);
		var selected_option = _reactDom2.default.findDOMNode(_this7.selected);
		var options_list = _reactDom2.default.findDOMNode(_this7.list);

		// Don't close the select if its expander button has been clicked,
		// or if autocomplete has been clicked,
		// or if an option was selected from the list.
		if (options_list && options_list.contains(event.target) || autocomplete && autocomplete.contains(event.target) || selected_option && selected_option.contains(event.target)) {
			return;
		}

		_this7.setState({ expanded: false });

		var onToggle = _this7.props.onToggle;


		if (onToggle) {
			onToggle(false);
		}
	};

	this.on_key_down_in_container = function (event) {
		if (event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) {
			return;
		}

		var expanded = _this7.state.expanded;


		switch (event.keyCode) {
			// Toggle on Tab out
			case 9:
				if (expanded) {
					_this7.toggle(undefined, { dont_focus_after_toggle: true });

					var onTabOut = _this7.props.onTabOut;


					if (onTabOut) {
						onTabOut(event);
					}
				}
				return;
		}
	};

	this.on_key_down = function (event) {
		if (event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) {
			return;
		}

		var _props17 = _this7.props,
		    options = _props17.options,
		    value = _props17.value,
		    autocomplete = _props17.autocomplete;
		var _state5 = _this7.state,
		    expanded = _state5.expanded,
		    focused_option_value = _state5.focused_option_value;

		// Maybe add support for `children` arrow navigation in future

		if (options) {
			switch (event.keyCode) {
				// Select the previous option (if present) on up arrow
				case 38:
					event.preventDefault();

					var previous = _this7.previous_focusable_option();

					if (previous) {
						_this7.show_option(previous.value, 'top');
						return _this7.setState({ focused_option_value: previous.value });
					}

					return;

				// Select the next option (if present) on down arrow
				case 40:
					event.preventDefault();

					var next = _this7.next_focusable_option();

					if (next) {
						_this7.show_option(next.value, 'bottom');
						return _this7.setState({ focused_option_value: next.value });
					}

					return;

				// Collapse on Escape
				//
				// Maybe add this kind of support for "Escape" key in some future:
				//  hiding the item list, cancelling current item selection process
				//  and restoring the selection present before the item list was toggled.
				//
				case 27:
					// Collapse the list if it's expanded
					if (_this7.state.expanded) {
						_this7.toggle();

						// Restore focus when the list is collapsed
						_this7.restore_focus_on_collapse_timeout = setTimeout(function () {
							_this7.restore_focus_on_collapse_timeout = undefined;

							_this7.selected.focus();
						}, 0);
					}

					return;

				// on Enter
				case 13:
					// Choose the focused item on Enter
					if (expanded) {
						event.preventDefault();

						// If an item is focused
						// (which may not be the case
						//  when autocomplete is matching no items)
						// (still for non-autocomplete select
						//  it is valid to have a default option)
						if (_this7.get_options() && _this7.get_options().length > 0) {
							// Choose the focused item
							_this7.item_clicked(focused_option_value);
						}
					}
					// Else it should have just submitted the form on Enter,
					// but it wouldn't because the select element activator is a <button/>
					// therefore hitting Enter while being focused on it just pushes that button.
					// So submit the enclosing form manually.
					else {
							if ((0, _dom.submit_parent_form)(_reactDom2.default.findDOMNode(_this7.select))) {
								event.preventDefault();
							}
						}

					return;

				// on Spacebar
				case 32:
					// Choose the focused item on Enter
					if (expanded) {
						// only if it it's an `options` select
						// and also if it's not an autocomplete
						if (_this7.get_options() && !autocomplete) {
							event.preventDefault();

							// `focused_option_value` could be non-existent
							// in case of `autocomplete`, but since
							// we're explicitly not handling autocomplete here
							// it is valid to select any options including the default ones.
							_this7.item_clicked(focused_option_value);
						}
					}
					// Otherwise, the spacebar keydown event on a `<button/>`
					// will trigger `onClick` and `.toggle()` will be called.

					return;
			}
		}
	};

	this.on_blur = function (event) {
		var _props18 = _this7.props,
		    onBlur = _props18.onBlur,
		    value = _props18.value;

		// If clicked on a select option then don't trigger "blur" event

		if (event.relatedTarget && event.currentTarget.contains(event.relatedTarget)) {
			return;
		}

		// This `onBlur` interceptor is a workaround for `redux-form`,
		// so that it gets the right (parsed, not the formatted one)
		// `event.target.value` in its `onBlur` handler.
		if (onBlur) {
			var _event = (0, _extends3.default)({}, event, {
				target: (0, _extends3.default)({}, event.target, {
					value: value
				})

				// For `redux-form` event detection.
				// https://github.com/erikras/redux-form/blob/v5/src/events/isEvent.js
			});_event.stopPropagation = event.stopPropagation;
			_event.preventDefault = event.preventDefault;

			onBlur(_event);
		}
	};

	this.on_autocomplete_input_change = function (event) {
		var options = _this7.props.options;

		var input = event.target.value;
		var matching_options = _this7.get_matching_options(options, input);

		_this7.setState({
			autocomplete_input_value: input,
			matching_options: matching_options,
			focused_option_value: matching_options.length > 0 ? matching_options[0].value : undefined
		});
	};
};

exports.default = Select;


Select.Separator = function (props) {
	return _react2.default.createElement('div', { className: 'rrui__select__separator' });
};

var native_expanded_select_container_style = {
	display: 'inline-block'

	// There can be an `undefined` value,
	// so just `{ value }` won't do here.
};function get_option_key(value) {
	return value_is_empty(value) ? '@@rrui/select/undefined' : value;
}

function value_is_empty(value) {
	return value === null || value === undefined;
}
//# sourceMappingURL=Select.js.map

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.submit_parent_form = submit_parent_form;
exports.get_scrollbar_width = get_scrollbar_width;
function submit_parent_form(node) {
	while (node.parentElement) {
		node = node.parentElement;
		if (node instanceof HTMLFormElement) {
			// Won't use `node.submit()` because it bypasses `onSubmit`.
			// Will click the submit button instead.
			var submit = node.querySelector('button[type=submit]');
			if (submit) {
				submit.click();
				return true;
			}
		}
	}
}

function get_scrollbar_width() {
	// // `window.innerWidth` has a bug:
	// // it's decreases as the page scale is increased.
	// // Therefore not using it.
	// // (Full width) - (Width minus scrollbar)
	// return document.body.clientWidth - window.innerWidth

	return 17;
}
//# sourceMappingURL=dom.js.map

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(79), __webpack_require__(28), __webpack_require__(29), __webpack_require__(46), __webpack_require__(45), __webpack_require__(5));
	else if(typeof define === 'function' && define.amd)
		define(["babel-runtime/helpers/typeof", "babel-runtime/helpers/classCallCheck", "babel-runtime/helpers/createClass", "babel-runtime/helpers/possibleConstructorReturn", "babel-runtime/helpers/inherits", "react"], factory);
	else if(typeof exports === 'object')
		exports["Webcam"] = factory(require("babel-runtime/helpers/typeof"), require("babel-runtime/helpers/classCallCheck"), require("babel-runtime/helpers/createClass"), require("babel-runtime/helpers/possibleConstructorReturn"), require("babel-runtime/helpers/inherits"), require("react"));
	else
		root["Webcam"] = factory(root["babel-runtime/helpers/typeof"], root["babel-runtime/helpers/classCallCheck"], root["babel-runtime/helpers/createClass"], root["babel-runtime/helpers/possibleConstructorReturn"], root["babel-runtime/helpers/inherits"], root["React"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_6__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(1);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(6);

var _react2 = _interopRequireDefault(_react);

var _video = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Deliberately ignoring the old api, due to very inconsistent behaviour
*/
var mediaDevices = navigator.mediaDevices;
var getUserMedia = mediaDevices && mediaDevices.getUserMedia ? mediaDevices.getUserMedia.bind(mediaDevices) : null;
var hasGetUserMedia = !!getUserMedia;

var DEBUG = false;
var debugConsole = function debugConsole() {
  var _console;

  if (DEBUG) (_console = console).log.apply(_console, arguments);
};

var permissionErrors = ['PermissionDeniedError', 'NotAllowedError', 'NotFoundError'];

var Webcam = function (_Component) {
  (0, _inherits3.default)(Webcam, _Component);

  function Webcam(props) {
    (0, _classCallCheck3.default)(this, Webcam);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Webcam.__proto__ || Object.getPrototypeOf(Webcam)).call(this, props));

    _this.state = {
      hasUserMedia: false,
      mirrored: false
    };


    if (!hasGetUserMedia) {
      var error = new Error('getUserMedia is not supported by this browser');
      _this.props.onFailure(error);
    }
    return _this;
  }

  (0, _createClass3.default)(Webcam, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      Webcam.mountedInstances.push(this);
      this.requestUserMedia();
    }
  }, {
    key: 'getConstraints',
    value: function getConstraints(width, height, facingMode, audio) {
      /*
      Safari 11 has a bug where if you specify both the height and width
      constraints you must chose a resolution supported by the web cam. If an
      unsupported resolution is used getUserMedia(constraints) will hit a
      OverconstrainedError complaining that width is an invalid constraint.
      This bug exists for ideal constraints as well as min and max.
       However if only a height is specified safari will correctly chose the
      nearest resolution supported by the web cam.
       Reference: https://developer.mozilla.org/en-US/docs/Web/API/Media_Streams_API/Constraints
      */

      // if `{facingMode: 'user'}` Firefox will still allow the user to choose which camera to use (Front camera will be the first option)
      var constraints = { video: { facingMode: facingMode }, audio: audio };

      if (width) {
        constraints.video.width = parseInt(width, 10) || width; // some devices need a Number type
      }

      if (height) {
        constraints.video.height = parseInt(height, 10) || height;
      }

      return constraints;
    }
  }, {
    key: 'requestUserMedia',
    value: function requestUserMedia() {
      if (!getUserMedia || !mediaDevices) return;
      var _props = this.props,
          width = _props.width,
          height = _props.height,
          facingMode = _props.facingMode,
          audio = _props.audio,
          fallbackWidth = _props.fallbackWidth,
          fallbackHeight = _props.fallbackHeight;


      var constraints = this.getConstraints(width, height, facingMode, audio);
      var fallbackConstraints = this.getConstraints(fallbackWidth, fallbackHeight, facingMode, audio);

      var logError = function logError(e) {
        return console.log('error', e, typeof e === 'undefined' ? 'undefined' : (0, _typeof3.default)(e));
      };

      var onSuccess = function onSuccess(stream) {
        Webcam.mountedInstances.forEach(function (instance) {
          return instance.handleUserMedia(stream);
        });
      };

      var hasTriedFallbackConstraints = void 0;
      var onError = function onError(e) {
        logError(e);
        var isPermissionError = permissionErrors.includes(e.name);
        if (isPermissionError || hasTriedFallbackConstraints) {
          Webcam.mountedInstances.forEach(function (instance) {
            return instance.handleError(e);
          });
        } else {
          hasTriedFallbackConstraints = true;
          getUserMedia(fallbackConstraints).then(onSuccess).catch(onError);
        }
      };
      getUserMedia(constraints).then(onSuccess).catch(onError);
    }
  }, {
    key: 'handleError',
    value: function handleError(error) {
      this.setState({
        hasUserMedia: false
      });
      this.props.onFailure(error);
    }
  }, {
    key: 'handleUserMedia',
    value: function handleUserMedia(stream) {
      this.stream = stream;
      var videoSettings = stream.getVideoTracks()[0].getSettings();
      debugConsole('video track settings', videoSettings);
      this.setState({
        hasUserMedia: true,
        mirrored: videoSettings.facingMode === 'user'
        /* #HACK desktop cameras seem to have `facingMode` undefined,
        therefore we are assuming all desktop cameras are user facing*/
        || !videoSettings.facingMode
      });

      this.props.onUserMedia();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var index = Webcam.mountedInstances.indexOf(this);
      Webcam.mountedInstances.splice(index, 1);

      if (Webcam.mountedInstances.length === 0 && this.state.hasUserMedia) {
        if (this.stream.getVideoTracks) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = this.stream.getVideoTracks()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var track = _step.value;

              track.stop();
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
        if (this.stream.getAudioTracks) {
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = this.stream.getAudioTracks()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var _track = _step2.value;

              _track.stop();
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      }
    }
  }, {
    key: 'getScreenshot',
    value: function getScreenshot() {
      var canvas = this.getCanvas();
      if (!canvas) return null;
      return canvas.toDataURL(this.props.screenshotFormat);
    }
  }, {
    key: 'getCanvas',
    value: function getCanvas() {
      if (!this.state.hasUserMedia || !this.video) return null;

      var video = this.video;

      if (!this.canvas) this.canvas = document.createElement('canvas');
      var canvas = this.canvas;


      if (!this.ctx) this.ctx = canvas.getContext('2d');
      var ctx = this.ctx;

      // This is set every time incase the video element has resized

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      debugConsole('drawn image to canvas: ' + canvas.width + 'x' + canvas.height);
      return canvas;
    }
  }, {
    key: 'startRecording',
    value: function startRecording() {
      this.mediaRecorder = (0, _video.createMediaRecorder)(this.stream);
      this.recordedBlobs = (0, _video.startRecording)(this.mediaRecorder);
    }
  }, {
    key: 'stopRecording',
    value: function stopRecording() {
      this.mediaRecorder.stop(this.recordedBlobs);
    }
  }, {
    key: 'getVideoBlob',
    value: function getVideoBlob() {
      var mimeType = this.mediaRecorder.mimeType;
      var type = mimeType.split(';')[0]; // mimeType (excluding the codec)
      return new Blob(this.recordedBlobs, { type: type });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement('video', {
        style: {
          // not necessary to add prefixes, since all browsers that support camera
          // support transform
          transform: this.state.mirrored ? 'scaleX(-1)' : ''
        },
        ref: function ref(el) {
          return _this2.video = el;
        },
        autoPlay: true,
        playsinline: true // necessary for iOS, see https://github.com/webrtc/samples/issues/929
        , srcObject: this.stream,
        muted: true // muted must be true for recording videos
        , className: this.props.className
      });
    }
  }]);
  return Webcam;
}(_react.Component);

Webcam.defaultProps = {
  audio: false,
  screenshotFormat: 'image/webp',
  onUserMedia: function onUserMedia() {},
  onFailure: function onFailure() {}
};
Webcam.mountedInstances = [];
exports.default = Webcam;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MediaRecorder = window.MediaRecorder;

var handleDataAvailable = function handleDataAvailable(event, recordedBlobs) {
  if (event.data && event.data.size > 0) {
    recordedBlobs.push(event.data);
  }
};

var handleStop = function handleStop(event) {
  console.log('Recorder stopped: ', event);
};

var videoOptions = function videoOptions() {
  var mimeTypes = ['video/webm;codecs=vp9', 'video/webm;codecs=vp8', 'video/webm'];
  var mimeType = '';
  for (var type in mimeTypes) {
    if (MediaRecorder.isTypeSupported(mimeTypes[type])) {
      mimeType = mimeTypes[type];
      break;
    } else {
      console.log(mimeTypes[type] + ' is not Supported');
    }
  }
  return mimeType ? { mimeType: mimeType } : { mimeType: '' };
};

var createMediaRecorder = exports.createMediaRecorder = function createMediaRecorder(stream) {
  var options = videoOptions();
  try {
    return new MediaRecorder(stream, options);
  } catch (e) {
    console.error('Exception while creating MediaRecorder: ' + e);
    return;
  }
};

var startRecording = exports.startRecording = function startRecording(mediaRecorder) {
  var recordedBlobs = [];
  mediaRecorder.onstop = handleStop;
  mediaRecorder.ondataavailable = function (e) {
    return handleDataAvailable(e, recordedBlobs);
  };
  mediaRecorder.start(10); // collect 10ms of data
  console.log('MediaRecorder started', mediaRecorder);
  return recordedBlobs;
};

/***/ })
/******/ ]);
});

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports["default"] = applyMiddleware;

var _compose = __webpack_require__(163);

var _compose2 = _interopRequireDefault(_compose);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, initialState, enhancer) {
      var store = createStore(reducer, initialState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = _compose2["default"].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = combineReducers;

var _createStore = __webpack_require__(164);

var _isPlainObject = __webpack_require__(102);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _warning = __webpack_require__(165);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'initialState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!(0, _isPlainObject2["default"])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key);
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerSanity(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];
    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var sanityError;
  try {
    assertReducerSanity(finalReducers);
  } catch (e) {
    sanityError = e;
  }

  return function combination() {
    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
    var action = arguments[1];

    if (sanityError) {
      throw sanityError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action);
      if (warningMessage) {
        (0, _warning2["default"])(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var i = 0; i < finalReducerKeys.length; i++) {
      var key = finalReducerKeys[i];
      var reducer = finalReducers[key];
      var previousStateForKey = state[key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(key, action);
        throw new Error(errorMessage);
      }
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createSelector = createSelector;
exports.createStructuredSelector = createStructuredSelector;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function defaultEqualityCheck(a, b) {
  return a === b;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length <= 1 || arguments[1] === undefined ? defaultEqualityCheck : arguments[1];

  var lastArgs = null;
  var lastResult = null;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (lastArgs !== null && lastArgs.length === args.length && args.every(function (value, index) {
      return equalityCheck(value, lastArgs[index]);
    })) {
      return lastResult;
    }
    lastArgs = args;
    lastResult = func.apply(undefined, args);
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len2 = arguments.length, memoizeOptions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    memoizeOptions[_key2 - 1] = arguments[_key2];
  }

  return function () {
    for (var _len3 = arguments.length, funcs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      funcs[_key3] = arguments[_key3];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      return resultFunc.apply(undefined, arguments);
    }].concat(memoizeOptions));

    var selector = function selector(state, props) {
      for (var _len4 = arguments.length, args = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        args[_key4 - 2] = arguments[_key4];
      }

      var params = dependencies.map(function (dependency) {
        return dependency.apply(undefined, [state, props].concat(args));
      });
      return memoizedResultFunc.apply(undefined, _toConsumableArray(params));
    };

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

function createSelector() {
  return createSelectorCreator(defaultMemoize).apply(undefined, arguments);
}

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length <= 1 || arguments[1] === undefined ? createSelector : arguments[1];

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len5 = arguments.length, values = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      values[_key5] = arguments[_key5];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 429 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
module.exports = function(src) {
	function log(error) {
		(typeof console !== "undefined")
		&& (console.error || console.log)("[Script Loader]", error);
	}

	// Check for IE =< 8
	function isIE() {
		return typeof attachEvent !== "undefined" && typeof addEventListener === "undefined";
	}

	try {
		if (typeof execScript !== "undefined" && isIE()) {
			execScript(src);
		} else if (typeof eval !== "undefined") {
			eval.call(null, src);
		} else {
			log("EvalError: No eval function available");
		}
	} catch (error) {
		log(error);
	}
}


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(429)(__webpack_require__(407))

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculate;
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var handleScroll = function (parent, _a) {
    var scrollLeft = _a.scrollLeft, scrollTop = _a.scrollTop;
    parent.scrollLeft = scrollLeft;
    parent.scrollTop = scrollTop;
};
function calculate(target, options) {
    if (!target || !(target instanceof HTMLElement))
        throw new Error('Element is required in scrollIntoViewIfNeeded');
    var config = __assign({ handleScroll: handleScroll }, options);
    var defaultOffset = { top: 0, right: 0, bottom: 0, left: 0 };
    config.offset = config.offset
        ? __assign({}, defaultOffset, config.offset) : defaultOffset;
    function withinBounds(value, min, max, extent) {
        if (config.centerIfNeeded === false ||
            (max <= value + extent && value <= min + extent)) {
            return Math.min(max, Math.max(min, value));
        }
        else {
            return (min + max) / 2;
        }
    }
    var offset = config.offset;
    var offsetTop = offset.top;
    var offsetLeft = offset.left;
    var offsetBottom = offset.bottom;
    var offsetRight = offset.right;
    function makeArea(left, top, width, height) {
        return {
            left: left + offsetLeft,
            top: top + offsetTop,
            width: width,
            height: height,
            right: left + offsetLeft + width + offsetRight,
            bottom: top + offsetTop + height + offsetBottom,
            translate: function (x, y) {
                return makeArea(x + left + offsetLeft, y + top + offsetTop, width, height);
            },
            relativeFromTo: function (lhs, rhs) {
                var newLeft = left + offsetLeft, newTop = top + offsetTop;
                lhs = lhs.offsetParent;
                rhs = rhs.offsetParent;
                if (lhs === rhs) {
                    return area;
                }
                for (; lhs; lhs = lhs.offsetParent) {
                    newLeft += lhs.offsetLeft + lhs.clientLeft;
                    newTop += lhs.offsetTop + lhs.clientTop;
                }
                for (; rhs; rhs = rhs.offsetParent) {
                    newLeft -= rhs.offsetLeft + rhs.clientLeft;
                    newTop -= rhs.offsetTop + rhs.clientTop;
                }
                return makeArea(newLeft, newTop, width, height);
            },
        };
    }
    var parent, area = makeArea(target.offsetLeft, target.offsetTop, target.offsetWidth, target.offsetHeight);
    while ((parent = target.parentNode) instanceof HTMLElement &&
        target !== config.boundary) {
        var clientLeft = parent.offsetLeft + parent.clientLeft;
        var clientTop = parent.offsetTop + parent.clientTop;
        // Make area relative to parent's client area.
        area = area
            .relativeFromTo(target, parent)
            .translate(-clientLeft, -clientTop);
        var scrollLeft = withinBounds(parent.scrollLeft, area.right - parent.clientWidth, area.left, parent.clientWidth);
        var scrollTop = withinBounds(parent.scrollTop, area.bottom - parent.clientHeight, area.top, parent.clientHeight);
        // Pass the new coordinates to the handleScroll callback
        config.handleScroll(parent, { scrollLeft: scrollLeft, scrollTop: scrollTop }, config);
        // Determine actual scroll amount by reading back scroll properties.
        area = area.translate(clientLeft - parent.scrollLeft, clientTop - parent.scrollTop);
        target = parent;
    }
}


/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = scrollIntoViewIfNeeded;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_amator__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_amator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_amator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calculate__ = __webpack_require__(431);
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var handleScroll = function (parent, _a, config) {
    var scrollLeft = _a.scrollLeft, scrollTop = _a.scrollTop;
    if (config.duration) {
        __WEBPACK_IMPORTED_MODULE_0_amator___default()(parent, {
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
        }, { duration: config.duration, easing: config.easing });
    }
    else {
        parent.scrollLeft = scrollLeft;
        parent.scrollTop = scrollTop;
    }
};
function isBoolean(options) {
    return typeof options === 'boolean';
}
function scrollIntoViewIfNeeded(target, options, animateOptions, finalElement, offsetOptions) {
    if (offsetOptions === void 0) { offsetOptions = {}; }
    if (!target || !(target instanceof HTMLElement))
        throw new Error('Element is required in scrollIntoViewIfNeeded');
    var config = { centerIfNeeded: false, handleScroll: handleScroll };
    if (isBoolean(options)) {
        config.centerIfNeeded = options;
    }
    else {
        config = __assign({}, config, options);
    }
    var defaultOffset = { top: 0, right: 0, bottom: 0, left: 0 };
    config.offset = config.offset
        ? __assign({}, defaultOffset, config.offset) : defaultOffset;
    if (animateOptions) {
        config.duration = animateOptions.duration;
        config.easing = animateOptions.easing;
    }
    if (finalElement) {
        config.boundary = finalElement;
    }
    if (offsetOptions.offsetTop) {
        config.offset.top = offsetOptions.offsetTop;
    }
    if (offsetOptions.offsetRight) {
        config.offset.right = offsetOptions.offsetRight;
    }
    if (offsetOptions.offsetBottom) {
        config.offset.bottom = offsetOptions.offsetBottom;
    }
    if (offsetOptions.offsetLeft) {
        config.offset.left = offsetOptions.offsetLeft;
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__calculate__["a" /* default */])(target, config);
}


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module dependencies.
 */

var parseuri = __webpack_require__(158);
var debug = __webpack_require__(22)('socket.io-client:url');

/**
 * Module exports.
 */

module.exports = url;

/**
 * URL parser.
 *
 * @param {String} url
 * @param {Object} An object meant to mimic window.location.
 *                 Defaults to window.location.
 * @api public
 */

function url (uri, loc) {
  var obj = uri;

  // default to window.location
  loc = loc || global.location;
  if (null == uri) uri = loc.protocol + '//' + loc.host;

  // relative path support
  if ('string' === typeof uri) {
    if ('/' === uri.charAt(0)) {
      if ('/' === uri.charAt(1)) {
        uri = loc.protocol + uri;
      } else {
        uri = loc.host + uri;
      }
    }

    if (!/^(https?|wss?):\/\//.test(uri)) {
      debug('protocol-less url %s', uri);
      if ('undefined' !== typeof loc) {
        uri = loc.protocol + '//' + uri;
      } else {
        uri = 'https://' + uri;
      }
    }

    // parse
    debug('parse %s', uri);
    obj = parseuri(uri);
  }

  // make sure we treat `localhost:80` and `localhost` equally
  if (!obj.port) {
    if (/^(http|ws)$/.test(obj.protocol)) {
      obj.port = '80';
    } else if (/^(http|ws)s$/.test(obj.protocol)) {
      obj.port = '443';
    }
  }

  obj.path = obj.path || '/';

  var ipv6 = obj.host.indexOf(':') !== -1;
  var host = ipv6 ? '[' + obj.host + ']' : obj.host;

  // define unique id
  obj.id = obj.protocol + '://' + host + ':' + obj.port;
  // define href
  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));

  return obj;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*global Blob,File*/

/**
 * Module requirements
 */

var isArray = __webpack_require__(151);
var isBuf = __webpack_require__(170);
var toString = Object.prototype.toString;
var withNativeBlob = typeof global.Blob === 'function' || toString.call(global.Blob) === '[object BlobConstructor]';
var withNativeFile = typeof global.File === 'function' || toString.call(global.File) === '[object FileConstructor]';

/**
 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
 * Anything with blobs or files should be fed through removeBlobs before coming
 * here.
 *
 * @param {Object} packet - socket.io event packet
 * @return {Object} with deconstructed packet and list of buffers
 * @api public
 */

exports.deconstructPacket = function(packet) {
  var buffers = [];
  var packetData = packet.data;
  var pack = packet;
  pack.data = _deconstructPacket(packetData, buffers);
  pack.attachments = buffers.length; // number of binary 'attachments'
  return {packet: pack, buffers: buffers};
};

function _deconstructPacket(data, buffers) {
  if (!data) return data;

  if (isBuf(data)) {
    var placeholder = { _placeholder: true, num: buffers.length };
    buffers.push(data);
    return placeholder;
  } else if (isArray(data)) {
    var newData = new Array(data.length);
    for (var i = 0; i < data.length; i++) {
      newData[i] = _deconstructPacket(data[i], buffers);
    }
    return newData;
  } else if (typeof data === 'object' && !(data instanceof Date)) {
    var newData = {};
    for (var key in data) {
      newData[key] = _deconstructPacket(data[key], buffers);
    }
    return newData;
  }
  return data;
}

/**
 * Reconstructs a binary packet from its placeholder packet and buffers
 *
 * @param {Object} packet - event packet with placeholders
 * @param {Array} buffers - binary buffers to put in placeholder positions
 * @return {Object} reconstructed packet
 * @api public
 */

exports.reconstructPacket = function(packet, buffers) {
  packet.data = _reconstructPacket(packet.data, buffers);
  packet.attachments = undefined; // no longer useful
  return packet;
};

function _reconstructPacket(data, buffers) {
  if (!data) return data;

  if (data && data._placeholder) {
    return buffers[data.num]; // appropriate buffer (should be natural order anyway)
  } else if (isArray(data)) {
    for (var i = 0; i < data.length; i++) {
      data[i] = _reconstructPacket(data[i], buffers);
    }
  } else if (typeof data === 'object') {
    for (var key in data) {
      data[key] = _reconstructPacket(data[key], buffers);
    }
  }

  return data;
}

/**
 * Asynchronously removes Blobs or Files from data via
 * FileReader's readAsArrayBuffer method. Used before encoding
 * data as msgpack. Calls callback with the blobless data.
 *
 * @param {Object} data
 * @param {Function} callback
 * @api private
 */

exports.removeBlobs = function(data, callback) {
  function _removeBlobs(obj, curKey, containingObject) {
    if (!obj) return obj;

    // convert any blob
    if ((withNativeBlob && obj instanceof Blob) ||
        (withNativeFile && obj instanceof File)) {
      pendingBlobs++;

      // async filereader
      var fileReader = new FileReader();
      fileReader.onload = function() { // this.result == arraybuffer
        if (containingObject) {
          containingObject[curKey] = this.result;
        }
        else {
          bloblessData = this.result;
        }

        // if nothing pending its callback time
        if(! --pendingBlobs) {
          callback(bloblessData);
        }
      };

      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
    } else if (isArray(obj)) { // handle array
      for (var i = 0; i < obj.length; i++) {
        _removeBlobs(obj[i], i, obj);
      }
    } else if (typeof obj === 'object' && !isBuf(obj)) { // and object
      for (var key in obj) {
        _removeBlobs(obj[key], key, obj);
      }
    }
  }

  var pendingBlobs = 0;
  var bloblessData = data;
  _removeBlobs(bloblessData);
  if (!pendingBlobs) {
    callback(bloblessData);
  }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(100);
var define = __webpack_require__(138);

var implementation = __webpack_require__(171);
var getPolyfill = __webpack_require__(172);
var shim = __webpack_require__(436);

var boundTrim = bind.call(Function.call, getPolyfill());

define(boundTrim, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = boundTrim;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(138);
var getPolyfill = __webpack_require__(172);

module.exports = function shimStringTrim() {
	var polyfill = getPolyfill();
	define(String.prototype, { trim: polyfill }, { trim: function () { return String.prototype.trim !== polyfill; } });
	return polyfill;
};


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(306);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(307);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(309);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(310);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(312);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(313);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(314);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(315);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(335);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(316);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(317);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(318);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(320);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(322);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(323);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(336);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(324);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(325);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(326);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(327);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(328);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(329);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(338);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(330);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(331);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(332);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(333);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!../../../../node_modules/less-loader/dist/cjs.js??ref--3-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(304);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../css-loader/index.js??ref--4-1!../postcss-loader/lib/index.js??ref--4-2!../less-loader/dist/cjs.js??ref--4-3!./rrui.css", function() {
			var newContent = require("!!../css-loader/index.js??ref--4-1!../postcss-loader/lib/index.js??ref--4-2!../less-loader/dist/cjs.js??ref--4-3!./rrui.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(305);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(2)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../css-loader/index.js??ref--4-1!../postcss-loader/lib/index.js??ref--4-2!../less-loader/dist/cjs.js??ref--4-3!./style.css", function() {
			var newContent = require("!!../css-loader/index.js??ref--4-1!../postcss-loader/lib/index.js??ref--4-2!../less-loader/dist/cjs.js??ref--4-3!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! npm.im/supports-webp */


var canvas = document.createElement('canvas');
canvas.width = canvas.height = 1;
var index = canvas.toDataURL && canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0;

module.exports = index;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(468);


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(469);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14), __webpack_require__(177)(module)))

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports = toArray

function toArray(list, index) {
    var array = []

    index = index || 0

    for (var i = index || 0; i < list.length; i++) {
        array[i - index] = list[i]
    }

    return array
}


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
Copyright (C) 2015-2017 Andrea Giammarchi - @WebReflection

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/


function URLSearchParams(query) {
  var
    index, key, value,
    pairs, i, length,
    dict = Object.create(null)
  ;
  this[secret] = dict;
  if (!query) return;
  if (typeof query === 'string') {
    if (query.charAt(0) === '?') {
      query = query.slice(1);
    }
    for (
      pairs = query.split('&'),
      i = 0,
      length = pairs.length; i < length; i++
    ) {
      value = pairs[i];
      index = value.indexOf('=');
      if (-1 < index) {
        appendTo(
          dict,
          decode(value.slice(0, index)),
          decode(value.slice(index + 1))
        );
      } else if (value.length){
        appendTo(
          dict,
          decode(value),
          ''
        );
      }
    }
  } else {
    if (isArray(query)) {
      for (
        i = 0,
        length = query.length; i < length; i++
      ) {
        value = query[i];
        appendTo(dict, value[0], value[1]);
      }
    } else {
      for (key in query) {
         appendTo(dict, key, query[key]);
      }
    }
  }
}

var
  isArray = Array.isArray,
  URLSearchParamsProto = URLSearchParams.prototype,
  find = /[!'\(\)~]|%20|%00/g,
  plus = /\+/g,
  replace = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  },
  replacer = function (match) {
    return replace[match];
  },
  secret = '__URLSearchParams__:' + Math.random()
;

function appendTo(dict, name, value) {
  if (name in dict) {
    dict[name].push('' + value);
  } else {
    dict[name] = isArray(value) ? value : ['' + value];
  }
}

function decode(str) {
  return decodeURIComponent(str.replace(plus, ' '));
}

function encode(str) {
  return encodeURIComponent(str).replace(find, replacer);
}

URLSearchParamsProto.append = function append(name, value) {
  appendTo(this[secret], name, value);
};

URLSearchParamsProto.delete = function del(name) {
  delete this[secret][name];
};

URLSearchParamsProto.get = function get(name) {
  var dict = this[secret];
  return name in dict ? dict[name][0] : null;
};

URLSearchParamsProto.getAll = function getAll(name) {
  var dict = this[secret];
  return name in dict ? dict[name].slice(0) : [];
};

URLSearchParamsProto.has = function has(name) {
  return name in this[secret];
};

URLSearchParamsProto.set = function set(name, value) {
  this[secret][name] = ['' + value];
};

URLSearchParamsProto.forEach = function forEach(callback, thisArg) {
  var dict = this[secret];
  Object.getOwnPropertyNames(dict).forEach(function(name) {
    dict[name].forEach(function(value) {
      callback.call(thisArg, value, name, this);
    }, this);
  }, this);
};

/*
URLSearchParamsProto.toBody = function() {
  return new Blob(
    [this.toString()],
    {type: 'application/x-www-form-urlencoded'}
  );
};
*/

URLSearchParamsProto.toJSON = function toJSON() {
  return {};
};

URLSearchParamsProto.toString = function toString() {
  var dict = this[secret], query = [], i, key, name, value;
  for (key in dict) {
    name = encode(key);
    for (
      i = 0,
      value = dict[key];
      i < value.length; i++
    ) {
      query.push(name + '=' + encode(value[i]));
    }
  }
  return query.join('&');
};

URLSearchParams = (module.exports = global.URLSearchParams || URLSearchParams);

(function (URLSearchParamsProto) {

  var iterable = (function () {
    try {
      return !!Symbol.iterator;
    } catch(error) {
      return false;
    }
  }());

  // mostly related to issue #24
  if (!('forEach' in URLSearchParamsProto)) {
    URLSearchParamsProto.forEach = function forEach(callback, thisArg) {
      var names = Object.create(null);
      this.toString()
          .replace(/=[\s\S]*?(?:&|$)/g, '=')
          .split('=')
          .forEach(function (name) {
            if (!name.length || name in names) return;
            (names[name] = this.getAll(name)).forEach(function(value) {
              callback.call(thisArg, value, name, this);
            }, this);
          }, this);
    };
  }

  if (!('keys' in URLSearchParamsProto)) {
    URLSearchParamsProto.keys = function keys() {
      var items = [];
      this.forEach(function(value, name) { items.push(name); });
      var iterator = {
        next: function() {
          var value = items.shift();
          return {done: value === undefined, value: value};
        }
      };

      if (iterable) {
        iterator[Symbol.iterator] = function() {
          return iterator;
        };
      }

      return iterator;
    };
  }

  if (!('values' in URLSearchParamsProto)) {
    URLSearchParamsProto.values = function values() {
      var items = [];
      this.forEach(function(value) { items.push(value); });
      var iterator = {
        next: function() {
          var value = items.shift();
          return {done: value === undefined, value: value};
        }
      };

      if (iterable) {
        iterator[Symbol.iterator] = function() {
          return iterator;
        };
      }

      return iterator;
    };
  }

  if (!('entries' in URLSearchParamsProto)) {
    URLSearchParamsProto.entries = function entries() {
      var items = [];
      this.forEach(function(value, name) { items.push([name, value]); });
      var iterator = {
        next: function() {
          var value = items.shift();
          return {done: value === undefined, value: value};
        }
      };

      if (iterable) {
        iterator[Symbol.iterator] = function() {
          return iterator;
        };
      }

      return iterator;
    };
  }

  if (iterable && !(Symbol.iterator in URLSearchParamsProto)) {
    URLSearchParamsProto[Symbol.iterator] = URLSearchParamsProto.entries;
  }

  if (!('sort' in URLSearchParamsProto)) {
    URLSearchParamsProto.sort = function sort() {
      var
        entries = this.entries(),
        entry = entries.next(),
        done = entry.done,
        keys = [],
        values = Object.create(null),
        i, key, value
      ;
      while (!done) {
        value = entry.value;
        key = value[0];
        keys.push(key);
        if (!(key in values)) {
          values[key] = [];
        }
        values[key].push(value[1]);
        entry = entries.next();
        done = entry.done;
      }
      // not the champion in efficiency
      // but these two bits just do the job
      keys.sort();
      for (i = 0; i < keys.length; i++) {
        this.delete(keys[i]);
      }
      for (i = 0; i < keys.length; i++) {
        key = keys[i];
        this.append(key, values[key].shift());
      }
    };
  }

}(URLSearchParams.prototype));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var valueEqual = function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
    return valueEqual(item, b[index]);
  });

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
};

exports.default = valueEqual;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(475)


/***/ }),
/* 474 */
/***/ (function(module, exports) {

;(function (global) {
    "use strict";

    var lastId = -1;

    // Visibility.js allow you to know, that your web page is in the background
    // tab and thus not visible to the user. This library is wrap under
    // Page Visibility API. It fix problems with different vendor prefixes and
    // add high-level useful functions.
    var self = {

        // Call callback only when page become to visible for user or
        // call it now if page is visible now or Page Visibility API
        // doesn’t supported.
        //
        // Return false if API isn’t supported, true if page is already visible
        // or listener ID (you can use it in `unbind` method) if page isn’t
        // visible now.
        //
        //   Visibility.onVisible(function () {
        //       startIntroAnimation();
        //   });
        onVisible: function (callback) {
            var support = self.isSupported();
            if ( !support || !self.hidden() ) {
                callback();
                return support;
            }

            var listener = self.change(function (e, state) {
                if ( !self.hidden() ) {
                    self.unbind(listener);
                    callback();
                }
            });
            return listener;
        },

        // Call callback when visibility will be changed. First argument for
        // callback will be original event object, second will be visibility
        // state name.
        //
        // Return listener ID to unbind listener by `unbind` method.
        //
        // If Page Visibility API doesn’t supported method will be return false
        // and callback never will be called.
        //
        //   Visibility.change(function(e, state) {
        //       Statistics.visibilityChange(state);
        //   });
        //
        // It is just proxy to `visibilitychange` event, but use vendor prefix.
        change: function (callback) {
            if ( !self.isSupported() ) {
                return false;
            }
            lastId += 1;
            var number = lastId;
            self._callbacks[number] = callback;
            self._listen();
            return number;
        },

        // Remove `change` listener by it ID.
        //
        //   var id = Visibility.change(function(e, state) {
        //       firstChangeCallback();
        //       Visibility.unbind(id);
        //   });
        unbind: function (id) {
            delete self._callbacks[id];
        },

        // Call `callback` in any state, expect “prerender”. If current state
        // is “prerender” it will wait until state will be changed.
        // If Page Visibility API doesn’t supported, it will call `callback`
        // immediately.
        //
        // Return false if API isn’t supported, true if page is already after
        // prerendering or listener ID (you can use it in `unbind` method)
        // if page is prerended now.
        //
        //   Visibility.afterPrerendering(function () {
        //       Statistics.countVisitor();
        //   });
        afterPrerendering: function (callback) {
            var support   = self.isSupported();
            var prerender = 'prerender';

            if ( !support || prerender != self.state() ) {
                callback();
                return support;
            }

            var listener = self.change(function (e, state) {
                if ( prerender != state ) {
                    self.unbind(listener);
                    callback();
                }
            });
            return listener;
        },

        // Return true if page now isn’t visible to user.
        //
        //   if ( !Visibility.hidden() ) {
        //       VideoPlayer.play();
        //   }
        //
        // It is just proxy to `document.hidden`, but use vendor prefix.
        hidden: function () {
            return !!(self._doc.hidden || self._doc.webkitHidden);
        },

        // Return visibility state: 'visible', 'hidden' or 'prerender'.
        //
        //   if ( 'prerender' == Visibility.state() ) {
        //       Statistics.pageIsPrerendering();
        //   }
        //
        // Don’t use `Visibility.state()` to detect, is page visible, because
        // visibility states can extend in next API versions.
        // Use more simpler and general `Visibility.hidden()` for this cases.
        //
        // It is just proxy to `document.visibilityState`, but use
        // vendor prefix.
        state: function () {
            return self._doc.visibilityState       ||
                   self._doc.webkitVisibilityState ||
                   'visible';
        },

        // Return true if browser support Page Visibility API.
        //
        //   if ( Visibility.isSupported() ) {
        //       Statistics.startTrackingVisibility();
        //       Visibility.change(function(e, state)) {
        //           Statistics.trackVisibility(state);
        //       });
        //   }
        isSupported: function () {
            return !!(self._doc.visibilityState ||
                      self._doc.webkitVisibilityState);
        },

        // Link to document object to change it in tests.
        _doc: document || {},

        // Callbacks from `change` method, that wait visibility changes.
        _callbacks: { },

        // Listener for `visibilitychange` event.
        _change: function(event) {
            var state = self.state();

            for ( var i in self._callbacks ) {
                self._callbacks[i].call(self._doc, event, state);
            }
        },

        // Set listener for `visibilitychange` event.
        _listen: function () {
            if ( self._init ) {
                return;
            }

            var event = 'visibilitychange';
            if ( self._doc.webkitVisibilityState ) {
                event = 'webkit' + event;
            }

            var listener = function () {
                self._change.apply(self, arguments);
            };
            if ( self._doc.addEventListener ) {
                self._doc.addEventListener(event, listener);
            } else {
                self._doc.attachEvent(event, listener);
            }
            self._init = true;
        }

    };

    if ( typeof(module) != 'undefined' && module.exports ) {
        module.exports = self;
    } else {
        global.Visibility = self;
    }

})(this);


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

;(function (window) {
    "use strict";

    var lastTimer = -1;

    var install = function (Visibility) {

        // Run callback every `interval` milliseconds if page is visible and
        // every `hiddenInterval` milliseconds if page is hidden.
        //
        //   Visibility.every(60 * 1000, 5 * 60 * 1000, function () {
        //       checkNewMails();
        //   });
        //
        // You can skip `hiddenInterval` and callback will be called only if
        // page is visible.
        //
        //   Visibility.every(1000, function () {
        //       updateCountdown();
        //   });
        //
        // It is analog of `setInterval(callback, interval)` but use visibility
        // state.
        //
        // It return timer ID, that you can use in `Visibility.stop(id)` to stop
        // timer (`clearInterval` analog).
        // Warning: timer ID is different from interval ID from `setInterval`,
        // so don’t use it in `clearInterval`.
        //
        // On change state from hidden to visible timers will be execute.
        Visibility.every = function (interval, hiddenInterval, callback) {
            Visibility._time();

            if ( !callback ) {
                callback = hiddenInterval;
                hiddenInterval = null;
            }

            lastTimer += 1;
            var number = lastTimer;

            Visibility._timers[number] = {
                visible:  interval,
                hidden:   hiddenInterval,
                callback: callback
            };
            Visibility._run(number, false);

            if ( Visibility.isSupported() ) {
                Visibility._listen();
            }
            return number;
        };

        // Stop timer from `every` method by it ID (`every` method return it).
        //
        //   slideshow = Visibility.every(5 * 1000, function () {
        //       changeSlide();
        //   });
        //   $('.stopSlideshow').click(function () {
        //       Visibility.stop(slideshow);
        //   });
        Visibility.stop = function(id) {
            if ( !Visibility._timers[id] ) {
                return false;
            }
            Visibility._stop(id);
            delete Visibility._timers[id];
            return true;
        };

        // Callbacks and intervals added by `every` method.
        Visibility._timers = { };

        // Initialize variables on page loading.
        Visibility._time = function () {
            if ( Visibility._timed ) {
                return;
            }
            Visibility._timed     = true;
            Visibility._wasHidden = Visibility.hidden();

            Visibility.change(function () {
                Visibility._stopRun();
                Visibility._wasHidden = Visibility.hidden();
            });
        };

        // Try to run timer from every method by it’s ID. It will be use
        // `interval` or `hiddenInterval` depending on visibility state.
        // If page is hidden and `hiddenInterval` is null,
        // it will not run timer.
        //
        // Argument `runNow` say, that timers must be execute now too.
        Visibility._run = function (id, runNow) {
            var interval,
                timer = Visibility._timers[id];

            if ( Visibility.hidden() ) {
                if ( null === timer.hidden ) {
                    return;
                }
                interval = timer.hidden;
            } else {
                interval = timer.visible;
            }

            var runner = function () {
                timer.last = new Date();
                timer.callback.call(window);
            }

            if ( runNow ) {
                var now  = new Date();
                var last = now - timer.last ;

                if ( interval > last ) {
                    timer.delay = setTimeout(function () {
                        timer.id = setInterval(runner, interval);
                        runner();
                    }, interval - last);
                } else {
                    timer.id = setInterval(runner, interval);
                    runner();
                }

            } else {
              timer.id = setInterval(runner, interval);
            }
        };

        // Stop timer from `every` method by it’s ID.
        Visibility._stop = function (id) {
            var timer = Visibility._timers[id];
            clearInterval(timer.id);
            clearTimeout(timer.delay);
            delete timer.id;
            delete timer.delay;
        };

        // Listener for `visibilitychange` event.
        Visibility._stopRun = function (event) {
            var isHidden  = Visibility.hidden(),
                wasHidden = Visibility._wasHidden;

            if ( (isHidden && !wasHidden) || (!isHidden && wasHidden) ) {
                for ( var i in Visibility._timers ) {
                    Visibility._stop(i);
                    Visibility._run(i, !isHidden);
                }
            }
        };

        return Visibility;
    }

    if ( typeof(module) != 'undefined' && module.exports ) {
        module.exports = install(__webpack_require__(474));
    } else {
        install(window.Visibility)
    }

})(window);


/***/ }),
/* 476 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 477 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
/******/ ]);
//# sourceMappingURL=index.js.map